
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dpjvp", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $9c2cbd94335cd4ac$export$6503ec6e8aabbaf; }, function (v) { return $9c2cbd94335cd4ac$export$6503ec6e8aabbaf = v; });
var $9c2cbd94335cd4ac$export$6503ec6e8aabbaf;
var $9c2cbd94335cd4ac$export$f7ad0328861e2f03;
"use strict";
var $9c2cbd94335cd4ac$var$mapping = new Map();
function $9c2cbd94335cd4ac$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9c2cbd94335cd4ac$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9c2cbd94335cd4ac$var$resolve(id) {
    var resolved = $9c2cbd94335cd4ac$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9c2cbd94335cd4ac$export$6503ec6e8aabbaf = $9c2cbd94335cd4ac$var$register;
$9c2cbd94335cd4ac$export$f7ad0328861e2f03 = $9c2cbd94335cd4ac$var$resolve;

});

parcelRegister("9w4Jx", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6edac62b517fe22a$export$ffb0004e005737fa; }, function (v) { return $6edac62b517fe22a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6edac62b517fe22a$export$34b9dba7ce09269b; }, function (v) { return $6edac62b517fe22a$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6edac62b517fe22a$export$25062201e9e25d76; }, function (v) { return $6edac62b517fe22a$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6edac62b517fe22a$export$ffb0004e005737fa;
var $6edac62b517fe22a$export$34b9dba7ce09269b;
var $6edac62b517fe22a$export$25062201e9e25d76;
'use strict';

var $3QbnI = parcelRequire("3QbnI");
var $6edac62b517fe22a$var$k = Symbol.for("react.element"), $6edac62b517fe22a$var$l = Symbol.for("react.fragment"), $6edac62b517fe22a$var$m = Object.prototype.hasOwnProperty, $6edac62b517fe22a$var$n = $3QbnI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $6edac62b517fe22a$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6edac62b517fe22a$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$6edac62b517fe22a$var$m.call(a, b) && !$6edac62b517fe22a$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $6edac62b517fe22a$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $6edac62b517fe22a$var$n.current
    };
}
$6edac62b517fe22a$export$ffb0004e005737fa = $6edac62b517fe22a$var$l;
$6edac62b517fe22a$export$34b9dba7ce09269b = $6edac62b517fe22a$var$q;
$6edac62b517fe22a$export$25062201e9e25d76 = $6edac62b517fe22a$var$q;

});
parcelRegister("3QbnI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("SYOhR"));

});
parcelRegister("SYOhR", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0a5436e054bab3e9$export$dca3b0875bd9a954; }, function (v) { return $0a5436e054bab3e9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0a5436e054bab3e9$export$16fa2f45be04daa8; }, function (v) { return $0a5436e054bab3e9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0a5436e054bab3e9$export$ffb0004e005737fa; }, function (v) { return $0a5436e054bab3e9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0a5436e054bab3e9$export$e2c29f18771995cb; }, function (v) { return $0a5436e054bab3e9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0a5436e054bab3e9$export$221d75b3f55bb0bd; }, function (v) { return $0a5436e054bab3e9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0a5436e054bab3e9$export$5f8d39834fd61797; }, function (v) { return $0a5436e054bab3e9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0a5436e054bab3e9$export$74bf444e3cd11ea5; }, function (v) { return $0a5436e054bab3e9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0a5436e054bab3e9$export$ae55be85d98224ed; }, function (v) { return $0a5436e054bab3e9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $0a5436e054bab3e9$export$3ba232387fd5d6dd; }, function (v) { return $0a5436e054bab3e9$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0a5436e054bab3e9$export$e530037191fcd5d7; }, function (v) { return $0a5436e054bab3e9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0a5436e054bab3e9$export$fd42f52fd3ae1109; }, function (v) { return $0a5436e054bab3e9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0a5436e054bab3e9$export$c8a8987d4410bf2d; }, function (v) { return $0a5436e054bab3e9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $0a5436e054bab3e9$export$d38cd72104c1f0e9; }, function (v) { return $0a5436e054bab3e9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $0a5436e054bab3e9$export$7d1e3a5e95ceca43; }, function (v) { return $0a5436e054bab3e9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0a5436e054bab3e9$export$257a8862b851cb5b; }, function (v) { return $0a5436e054bab3e9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0a5436e054bab3e9$export$a8257692ac88316c; }, function (v) { return $0a5436e054bab3e9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0a5436e054bab3e9$export$488013bae63b21da; }, function (v) { return $0a5436e054bab3e9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0a5436e054bab3e9$export$7c73462e0d25e514; }, function (v) { return $0a5436e054bab3e9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0a5436e054bab3e9$export$7568632d0d33d16d; }, function (v) { return $0a5436e054bab3e9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $0a5436e054bab3e9$export$88948ce120ea2619; }, function (v) { return $0a5436e054bab3e9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0a5436e054bab3e9$export$35808ee640e87ca7; }, function (v) { return $0a5436e054bab3e9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0a5436e054bab3e9$export$fae74005e78b1a27; }, function (v) { return $0a5436e054bab3e9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0a5436e054bab3e9$export$dc8fbce3eb94dc1e; }, function (v) { return $0a5436e054bab3e9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0a5436e054bab3e9$export$6a7bc4e911dc01cf; }, function (v) { return $0a5436e054bab3e9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0a5436e054bab3e9$export$6d9c69b0de29b591; }, function (v) { return $0a5436e054bab3e9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0a5436e054bab3e9$export$f680877a34711e37; }, function (v) { return $0a5436e054bab3e9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0a5436e054bab3e9$export$d5a552a76deda3c2; }, function (v) { return $0a5436e054bab3e9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0a5436e054bab3e9$export$aaabe4eda9ed9969; }, function (v) { return $0a5436e054bab3e9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0a5436e054bab3e9$export$e5c5a5f917a5871c; }, function (v) { return $0a5436e054bab3e9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0a5436e054bab3e9$export$1538c33de8887b59; }, function (v) { return $0a5436e054bab3e9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $0a5436e054bab3e9$export$13e3392192263954; }, function (v) { return $0a5436e054bab3e9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0a5436e054bab3e9$export$b8f5890fc79d6aca; }, function (v) { return $0a5436e054bab3e9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0a5436e054bab3e9$export$60241385465d0a34; }, function (v) { return $0a5436e054bab3e9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0a5436e054bab3e9$export$306c0aa65ff9ec16; }, function (v) { return $0a5436e054bab3e9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0a5436e054bab3e9$export$7b286972b8d8ccbf; }, function (v) { return $0a5436e054bab3e9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0a5436e054bab3e9$export$83d89fbfd8236492; }, function (v) { return $0a5436e054bab3e9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0a5436e054bab3e9$export$dca3b0875bd9a954;
var $0a5436e054bab3e9$export$16fa2f45be04daa8;
var $0a5436e054bab3e9$export$ffb0004e005737fa;
var $0a5436e054bab3e9$export$e2c29f18771995cb;
var $0a5436e054bab3e9$export$221d75b3f55bb0bd;
var $0a5436e054bab3e9$export$5f8d39834fd61797;
var $0a5436e054bab3e9$export$74bf444e3cd11ea5;
var $0a5436e054bab3e9$export$ae55be85d98224ed;
var $0a5436e054bab3e9$export$3ba232387fd5d6dd;
var $0a5436e054bab3e9$export$e530037191fcd5d7;
var $0a5436e054bab3e9$export$fd42f52fd3ae1109;
var $0a5436e054bab3e9$export$c8a8987d4410bf2d;
var $0a5436e054bab3e9$export$d38cd72104c1f0e9;
var $0a5436e054bab3e9$export$7d1e3a5e95ceca43;
var $0a5436e054bab3e9$export$257a8862b851cb5b;
var $0a5436e054bab3e9$export$a8257692ac88316c;
var $0a5436e054bab3e9$export$488013bae63b21da;
var $0a5436e054bab3e9$export$7c73462e0d25e514;
var $0a5436e054bab3e9$export$7568632d0d33d16d;
var $0a5436e054bab3e9$export$88948ce120ea2619;
var $0a5436e054bab3e9$export$35808ee640e87ca7;
var $0a5436e054bab3e9$export$fae74005e78b1a27;
var $0a5436e054bab3e9$export$dc8fbce3eb94dc1e;
var $0a5436e054bab3e9$export$6a7bc4e911dc01cf;
var $0a5436e054bab3e9$export$6d9c69b0de29b591;
var $0a5436e054bab3e9$export$f680877a34711e37;
var $0a5436e054bab3e9$export$d5a552a76deda3c2;
var $0a5436e054bab3e9$export$aaabe4eda9ed9969;
var $0a5436e054bab3e9$export$e5c5a5f917a5871c;
var $0a5436e054bab3e9$export$1538c33de8887b59;
var $0a5436e054bab3e9$export$13e3392192263954;
var $0a5436e054bab3e9$export$b8f5890fc79d6aca;
var $0a5436e054bab3e9$export$60241385465d0a34;
var $0a5436e054bab3e9$export$306c0aa65ff9ec16;
var $0a5436e054bab3e9$export$7b286972b8d8ccbf;
var $0a5436e054bab3e9$export$83d89fbfd8236492;
'use strict';
var $0a5436e054bab3e9$var$l = Symbol.for("react.element"), $0a5436e054bab3e9$var$n = Symbol.for("react.portal"), $0a5436e054bab3e9$var$p = Symbol.for("react.fragment"), $0a5436e054bab3e9$var$q = Symbol.for("react.strict_mode"), $0a5436e054bab3e9$var$r = Symbol.for("react.profiler"), $0a5436e054bab3e9$var$t = Symbol.for("react.provider"), $0a5436e054bab3e9$var$u = Symbol.for("react.context"), $0a5436e054bab3e9$var$v = Symbol.for("react.forward_ref"), $0a5436e054bab3e9$var$w = Symbol.for("react.suspense"), $0a5436e054bab3e9$var$x = Symbol.for("react.memo"), $0a5436e054bab3e9$var$y = Symbol.for("react.lazy"), $0a5436e054bab3e9$var$z = Symbol.iterator;
function $0a5436e054bab3e9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0a5436e054bab3e9$var$z && a[$0a5436e054bab3e9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0a5436e054bab3e9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0a5436e054bab3e9$var$C = Object.assign, $0a5436e054bab3e9$var$D = {};
function $0a5436e054bab3e9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0a5436e054bab3e9$var$D;
    this.updater = e || $0a5436e054bab3e9$var$B;
}
$0a5436e054bab3e9$var$E.prototype.isReactComponent = {};
$0a5436e054bab3e9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0a5436e054bab3e9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0a5436e054bab3e9$var$F() {}
$0a5436e054bab3e9$var$F.prototype = $0a5436e054bab3e9$var$E.prototype;
function $0a5436e054bab3e9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0a5436e054bab3e9$var$D;
    this.updater = e || $0a5436e054bab3e9$var$B;
}
var $0a5436e054bab3e9$var$H = $0a5436e054bab3e9$var$G.prototype = new $0a5436e054bab3e9$var$F;
$0a5436e054bab3e9$var$H.constructor = $0a5436e054bab3e9$var$G;
$0a5436e054bab3e9$var$C($0a5436e054bab3e9$var$H, $0a5436e054bab3e9$var$E.prototype);
$0a5436e054bab3e9$var$H.isPureReactComponent = !0;
var $0a5436e054bab3e9$var$I = Array.isArray, $0a5436e054bab3e9$var$J = Object.prototype.hasOwnProperty, $0a5436e054bab3e9$var$K = {
    current: null
}, $0a5436e054bab3e9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0a5436e054bab3e9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0a5436e054bab3e9$var$J.call(b, d) && !$0a5436e054bab3e9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0a5436e054bab3e9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0a5436e054bab3e9$var$K.current
    };
}
function $0a5436e054bab3e9$var$N(a, b) {
    return {
        $$typeof: $0a5436e054bab3e9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0a5436e054bab3e9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0a5436e054bab3e9$var$l;
}
function $0a5436e054bab3e9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0a5436e054bab3e9$var$P = /\/+/g;
function $0a5436e054bab3e9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0a5436e054bab3e9$var$escape("" + a.key) : b.toString(36);
}
function $0a5436e054bab3e9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0a5436e054bab3e9$var$l:
                case $0a5436e054bab3e9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0a5436e054bab3e9$var$Q(h, 0) : d, $0a5436e054bab3e9$var$I(c) ? (e = "", null != a && (e = a.replace($0a5436e054bab3e9$var$P, "$&/") + "/"), $0a5436e054bab3e9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0a5436e054bab3e9$var$O(c) && (c = $0a5436e054bab3e9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0a5436e054bab3e9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0a5436e054bab3e9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0a5436e054bab3e9$var$Q(k, g);
        h += $0a5436e054bab3e9$var$R(k, b, e, f, c);
    }
    else if (f = $0a5436e054bab3e9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0a5436e054bab3e9$var$Q(k, g++), h += $0a5436e054bab3e9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0a5436e054bab3e9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0a5436e054bab3e9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0a5436e054bab3e9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0a5436e054bab3e9$var$U = {
    current: null
}, $0a5436e054bab3e9$var$V = {
    transition: null
}, $0a5436e054bab3e9$var$W = {
    ReactCurrentDispatcher: $0a5436e054bab3e9$var$U,
    ReactCurrentBatchConfig: $0a5436e054bab3e9$var$V,
    ReactCurrentOwner: $0a5436e054bab3e9$var$K
};
function $0a5436e054bab3e9$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0a5436e054bab3e9$export$dca3b0875bd9a954 = {
    map: $0a5436e054bab3e9$var$S,
    forEach: function(a, b, e) {
        $0a5436e054bab3e9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0a5436e054bab3e9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0a5436e054bab3e9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0a5436e054bab3e9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0a5436e054bab3e9$export$16fa2f45be04daa8 = $0a5436e054bab3e9$var$E;
$0a5436e054bab3e9$export$ffb0004e005737fa = $0a5436e054bab3e9$var$p;
$0a5436e054bab3e9$export$e2c29f18771995cb = $0a5436e054bab3e9$var$r;
$0a5436e054bab3e9$export$221d75b3f55bb0bd = $0a5436e054bab3e9$var$G;
$0a5436e054bab3e9$export$5f8d39834fd61797 = $0a5436e054bab3e9$var$q;
$0a5436e054bab3e9$export$74bf444e3cd11ea5 = $0a5436e054bab3e9$var$w;
$0a5436e054bab3e9$export$ae55be85d98224ed = $0a5436e054bab3e9$var$W;
$0a5436e054bab3e9$export$3ba232387fd5d6dd = $0a5436e054bab3e9$var$X;
$0a5436e054bab3e9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0a5436e054bab3e9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0a5436e054bab3e9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0a5436e054bab3e9$var$J.call(b, f) && !$0a5436e054bab3e9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0a5436e054bab3e9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0a5436e054bab3e9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0a5436e054bab3e9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0a5436e054bab3e9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0a5436e054bab3e9$export$c8a8987d4410bf2d = $0a5436e054bab3e9$var$M;
$0a5436e054bab3e9$export$d38cd72104c1f0e9 = function(a) {
    var b = $0a5436e054bab3e9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0a5436e054bab3e9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0a5436e054bab3e9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0a5436e054bab3e9$var$v,
        render: a
    };
};
$0a5436e054bab3e9$export$a8257692ac88316c = $0a5436e054bab3e9$var$O;
$0a5436e054bab3e9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0a5436e054bab3e9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0a5436e054bab3e9$var$T
    };
};
$0a5436e054bab3e9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0a5436e054bab3e9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0a5436e054bab3e9$export$7568632d0d33d16d = function(a) {
    var b = $0a5436e054bab3e9$var$V.transition;
    $0a5436e054bab3e9$var$V.transition = {};
    try {
        a();
    } finally{
        $0a5436e054bab3e9$var$V.transition = b;
    }
};
$0a5436e054bab3e9$export$88948ce120ea2619 = $0a5436e054bab3e9$var$X;
$0a5436e054bab3e9$export$35808ee640e87ca7 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useCallback(a, b);
};
$0a5436e054bab3e9$export$fae74005e78b1a27 = function(a) {
    return $0a5436e054bab3e9$var$U.current.useContext(a);
};
$0a5436e054bab3e9$export$dc8fbce3eb94dc1e = function() {};
$0a5436e054bab3e9$export$6a7bc4e911dc01cf = function(a) {
    return $0a5436e054bab3e9$var$U.current.useDeferredValue(a);
};
$0a5436e054bab3e9$export$6d9c69b0de29b591 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useEffect(a, b);
};
$0a5436e054bab3e9$export$f680877a34711e37 = function() {
    return $0a5436e054bab3e9$var$U.current.useId();
};
$0a5436e054bab3e9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0a5436e054bab3e9$var$U.current.useImperativeHandle(a, b, e);
};
$0a5436e054bab3e9$export$aaabe4eda9ed9969 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useInsertionEffect(a, b);
};
$0a5436e054bab3e9$export$e5c5a5f917a5871c = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useLayoutEffect(a, b);
};
$0a5436e054bab3e9$export$1538c33de8887b59 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useMemo(a, b);
};
$0a5436e054bab3e9$export$13e3392192263954 = function(a, b, e) {
    return $0a5436e054bab3e9$var$U.current.useReducer(a, b, e);
};
$0a5436e054bab3e9$export$b8f5890fc79d6aca = function(a) {
    return $0a5436e054bab3e9$var$U.current.useRef(a);
};
$0a5436e054bab3e9$export$60241385465d0a34 = function(a) {
    return $0a5436e054bab3e9$var$U.current.useState(a);
};
$0a5436e054bab3e9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0a5436e054bab3e9$var$U.current.useSyncExternalStore(a, b, e);
};
$0a5436e054bab3e9$export$7b286972b8d8ccbf = function() {
    return $0a5436e054bab3e9$var$U.current.useTransition();
};
$0a5436e054bab3e9$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("chU0U", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8f2285b8ffe719da$export$ae55be85d98224ed; }, function (v) { return $8f2285b8ffe719da$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $8f2285b8ffe719da$export$d39a5bbd09211389; }, function (v) { return $8f2285b8ffe719da$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $8f2285b8ffe719da$export$882461b6382ed46c; }, function (v) { return $8f2285b8ffe719da$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $8f2285b8ffe719da$export$466bfc07425424d5; }, function (v) { return $8f2285b8ffe719da$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $8f2285b8ffe719da$export$cd75ccfd720a3cd4; }, function (v) { return $8f2285b8ffe719da$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $8f2285b8ffe719da$export$fa8d919ba61d84db; }, function (v) { return $8f2285b8ffe719da$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8f2285b8ffe719da$export$757ceba2d55c277e; }, function (v) { return $8f2285b8ffe719da$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $8f2285b8ffe719da$export$b3890eb0ae9dca99; }, function (v) { return $8f2285b8ffe719da$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $8f2285b8ffe719da$export$502457920280e6be; }, function (v) { return $8f2285b8ffe719da$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $8f2285b8ffe719da$export$c78a37762a8d58e1; }, function (v) { return $8f2285b8ffe719da$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $8f2285b8ffe719da$export$dc54d992c10e8a18; }, function (v) { return $8f2285b8ffe719da$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $8f2285b8ffe719da$export$83d89fbfd8236492; }, function (v) { return $8f2285b8ffe719da$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8f2285b8ffe719da$export$ae55be85d98224ed;
var $8f2285b8ffe719da$export$d39a5bbd09211389;
var $8f2285b8ffe719da$export$882461b6382ed46c;
var $8f2285b8ffe719da$export$466bfc07425424d5;
var $8f2285b8ffe719da$export$cd75ccfd720a3cd4;
var $8f2285b8ffe719da$export$fa8d919ba61d84db;
var $8f2285b8ffe719da$export$757ceba2d55c277e;
var $8f2285b8ffe719da$export$b3890eb0ae9dca99;
var $8f2285b8ffe719da$export$502457920280e6be;
var $8f2285b8ffe719da$export$c78a37762a8d58e1;
var $8f2285b8ffe719da$export$dc54d992c10e8a18;
var $8f2285b8ffe719da$export$83d89fbfd8236492;
'use strict';

var $3QbnI = parcelRequire("3QbnI");

var $e00l3 = parcelRequire("e00l3");
function $8f2285b8ffe719da$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8f2285b8ffe719da$var$da = new Set, $8f2285b8ffe719da$var$ea = {};
function $8f2285b8ffe719da$var$fa(a, b) {
    $8f2285b8ffe719da$var$ha(a, b);
    $8f2285b8ffe719da$var$ha(a + "Capture", b);
}
function $8f2285b8ffe719da$var$ha(a, b) {
    $8f2285b8ffe719da$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$8f2285b8ffe719da$var$da.add(b[a]);
}
var $8f2285b8ffe719da$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8f2285b8ffe719da$var$ja = Object.prototype.hasOwnProperty, $8f2285b8ffe719da$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $8f2285b8ffe719da$var$la = {}, $8f2285b8ffe719da$var$ma = {};
function $8f2285b8ffe719da$var$oa(a) {
    if ($8f2285b8ffe719da$var$ja.call($8f2285b8ffe719da$var$ma, a)) return !0;
    if ($8f2285b8ffe719da$var$ja.call($8f2285b8ffe719da$var$la, a)) return !1;
    if ($8f2285b8ffe719da$var$ka.test(a)) return $8f2285b8ffe719da$var$ma[a] = !0;
    $8f2285b8ffe719da$var$la[a] = !0;
    return !1;
}
function $8f2285b8ffe719da$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $8f2285b8ffe719da$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $8f2285b8ffe719da$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $8f2285b8ffe719da$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $8f2285b8ffe719da$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $8f2285b8ffe719da$var$ra = /[\-:]([a-z])/g;
function $8f2285b8ffe719da$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($8f2285b8ffe719da$var$ra, $8f2285b8ffe719da$var$sa);
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($8f2285b8ffe719da$var$ra, $8f2285b8ffe719da$var$sa);
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($8f2285b8ffe719da$var$ra, $8f2285b8ffe719da$var$sa);
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$8f2285b8ffe719da$var$z.xlinkHref = new $8f2285b8ffe719da$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $8f2285b8ffe719da$var$ta(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$z.hasOwnProperty(b) ? $8f2285b8ffe719da$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $8f2285b8ffe719da$var$qa(b, c, e, d) && (c = null), d || null === e ? $8f2285b8ffe719da$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $8f2285b8ffe719da$var$ua = $3QbnI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $8f2285b8ffe719da$var$va = Symbol.for("react.element"), $8f2285b8ffe719da$var$wa = Symbol.for("react.portal"), $8f2285b8ffe719da$var$ya = Symbol.for("react.fragment"), $8f2285b8ffe719da$var$za = Symbol.for("react.strict_mode"), $8f2285b8ffe719da$var$Aa = Symbol.for("react.profiler"), $8f2285b8ffe719da$var$Ba = Symbol.for("react.provider"), $8f2285b8ffe719da$var$Ca = Symbol.for("react.context"), $8f2285b8ffe719da$var$Da = Symbol.for("react.forward_ref"), $8f2285b8ffe719da$var$Ea = Symbol.for("react.suspense"), $8f2285b8ffe719da$var$Fa = Symbol.for("react.suspense_list"), $8f2285b8ffe719da$var$Ga = Symbol.for("react.memo"), $8f2285b8ffe719da$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $8f2285b8ffe719da$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $8f2285b8ffe719da$var$Ja = Symbol.iterator;
function $8f2285b8ffe719da$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8f2285b8ffe719da$var$Ja && a[$8f2285b8ffe719da$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8f2285b8ffe719da$var$A = Object.assign, $8f2285b8ffe719da$var$La;
function $8f2285b8ffe719da$var$Ma(a) {
    if (void 0 === $8f2285b8ffe719da$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $8f2285b8ffe719da$var$La = b && b[1] || "";
    }
    return "\n" + $8f2285b8ffe719da$var$La + a;
}
var $8f2285b8ffe719da$var$Na = !1;
function $8f2285b8ffe719da$var$Oa(a, b) {
    if (!a || $8f2285b8ffe719da$var$Na) return "";
    $8f2285b8ffe719da$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $8f2285b8ffe719da$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $8f2285b8ffe719da$var$Ma(a) : "";
}
function $8f2285b8ffe719da$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $8f2285b8ffe719da$var$Ma(a.type);
        case 16:
            return $8f2285b8ffe719da$var$Ma("Lazy");
        case 13:
            return $8f2285b8ffe719da$var$Ma("Suspense");
        case 19:
            return $8f2285b8ffe719da$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $8f2285b8ffe719da$var$Oa(a.type, !1), a;
        case 11:
            return a = $8f2285b8ffe719da$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $8f2285b8ffe719da$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $8f2285b8ffe719da$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $8f2285b8ffe719da$var$ya:
            return "Fragment";
        case $8f2285b8ffe719da$var$wa:
            return "Portal";
        case $8f2285b8ffe719da$var$Aa:
            return "Profiler";
        case $8f2285b8ffe719da$var$za:
            return "StrictMode";
        case $8f2285b8ffe719da$var$Ea:
            return "Suspense";
        case $8f2285b8ffe719da$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $8f2285b8ffe719da$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $8f2285b8ffe719da$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $8f2285b8ffe719da$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $8f2285b8ffe719da$var$Ga:
            return b = a.displayName || null, null !== b ? b : $8f2285b8ffe719da$var$Qa(a.type) || "Memo";
        case $8f2285b8ffe719da$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $8f2285b8ffe719da$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $8f2285b8ffe719da$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $8f2285b8ffe719da$var$Qa(b);
        case 8:
            return b === $8f2285b8ffe719da$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $8f2285b8ffe719da$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $8f2285b8ffe719da$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $8f2285b8ffe719da$var$Ua(a) {
    var b = $8f2285b8ffe719da$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $8f2285b8ffe719da$var$Va(a) {
    a._valueTracker || (a._valueTracker = $8f2285b8ffe719da$var$Ua(a));
}
function $8f2285b8ffe719da$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $8f2285b8ffe719da$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $8f2285b8ffe719da$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $8f2285b8ffe719da$var$Ya(a, b) {
    var c = b.checked;
    return $8f2285b8ffe719da$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $8f2285b8ffe719da$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $8f2285b8ffe719da$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $8f2285b8ffe719da$var$ab(a, b) {
    b = b.checked;
    null != b && $8f2285b8ffe719da$var$ta(a, "checked", b, !1);
}
function $8f2285b8ffe719da$var$bb(a, b) {
    $8f2285b8ffe719da$var$ab(a, b);
    var c = $8f2285b8ffe719da$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $8f2285b8ffe719da$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $8f2285b8ffe719da$var$cb(a, b.type, $8f2285b8ffe719da$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $8f2285b8ffe719da$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $8f2285b8ffe719da$var$cb(a, b, c) {
    if ("number" !== b || $8f2285b8ffe719da$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $8f2285b8ffe719da$var$eb = Array.isArray;
function $8f2285b8ffe719da$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $8f2285b8ffe719da$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $8f2285b8ffe719da$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($8f2285b8ffe719da$var$p(91));
    return $8f2285b8ffe719da$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $8f2285b8ffe719da$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($8f2285b8ffe719da$var$p(92));
            if ($8f2285b8ffe719da$var$eb(c)) {
                if (1 < c.length) throw Error($8f2285b8ffe719da$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $8f2285b8ffe719da$var$Sa(c)
    };
}
function $8f2285b8ffe719da$var$ib(a, b) {
    var c = $8f2285b8ffe719da$var$Sa(b.value), d = $8f2285b8ffe719da$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $8f2285b8ffe719da$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $8f2285b8ffe719da$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $8f2285b8ffe719da$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $8f2285b8ffe719da$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $8f2285b8ffe719da$var$mb, $8f2285b8ffe719da$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $8f2285b8ffe719da$var$mb = $8f2285b8ffe719da$var$mb || document.createElement("div");
        $8f2285b8ffe719da$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $8f2285b8ffe719da$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $8f2285b8ffe719da$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $8f2285b8ffe719da$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $8f2285b8ffe719da$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($8f2285b8ffe719da$var$pb).forEach(function(a) {
    $8f2285b8ffe719da$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $8f2285b8ffe719da$var$pb[b] = $8f2285b8ffe719da$var$pb[a];
    });
});
function $8f2285b8ffe719da$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $8f2285b8ffe719da$var$pb.hasOwnProperty(a) && $8f2285b8ffe719da$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $8f2285b8ffe719da$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $8f2285b8ffe719da$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $8f2285b8ffe719da$var$tb = $8f2285b8ffe719da$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $8f2285b8ffe719da$var$ub(a, b) {
    if (b) {
        if ($8f2285b8ffe719da$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($8f2285b8ffe719da$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($8f2285b8ffe719da$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($8f2285b8ffe719da$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($8f2285b8ffe719da$var$p(62));
    }
}
function $8f2285b8ffe719da$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8f2285b8ffe719da$var$wb = null;
function $8f2285b8ffe719da$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $8f2285b8ffe719da$var$yb = null, $8f2285b8ffe719da$var$zb = null, $8f2285b8ffe719da$var$Ab = null;
function $8f2285b8ffe719da$var$Bb(a) {
    if (a = $8f2285b8ffe719da$var$Cb(a)) {
        if ("function" !== typeof $8f2285b8ffe719da$var$yb) throw Error($8f2285b8ffe719da$var$p(280));
        var b = a.stateNode;
        b && (b = $8f2285b8ffe719da$var$Db(b), $8f2285b8ffe719da$var$yb(a.stateNode, a.type, b));
    }
}
function $8f2285b8ffe719da$var$Eb(a) {
    $8f2285b8ffe719da$var$zb ? $8f2285b8ffe719da$var$Ab ? $8f2285b8ffe719da$var$Ab.push(a) : $8f2285b8ffe719da$var$Ab = [
        a
    ] : $8f2285b8ffe719da$var$zb = a;
}
function $8f2285b8ffe719da$var$Fb() {
    if ($8f2285b8ffe719da$var$zb) {
        var a = $8f2285b8ffe719da$var$zb, b = $8f2285b8ffe719da$var$Ab;
        $8f2285b8ffe719da$var$Ab = $8f2285b8ffe719da$var$zb = null;
        $8f2285b8ffe719da$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$8f2285b8ffe719da$var$Bb(b[a]);
    }
}
function $8f2285b8ffe719da$var$Gb(a, b) {
    return a(b);
}
function $8f2285b8ffe719da$var$Hb() {}
var $8f2285b8ffe719da$var$Ib = !1;
function $8f2285b8ffe719da$var$Jb(a, b, c) {
    if ($8f2285b8ffe719da$var$Ib) return a(b, c);
    $8f2285b8ffe719da$var$Ib = !0;
    try {
        return $8f2285b8ffe719da$var$Gb(a, b, c);
    } finally{
        if ($8f2285b8ffe719da$var$Ib = !1, null !== $8f2285b8ffe719da$var$zb || null !== $8f2285b8ffe719da$var$Ab) $8f2285b8ffe719da$var$Hb(), $8f2285b8ffe719da$var$Fb();
    }
}
function $8f2285b8ffe719da$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $8f2285b8ffe719da$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($8f2285b8ffe719da$var$p(231, b, typeof c));
    return c;
}
var $8f2285b8ffe719da$var$Lb = !1;
if ($8f2285b8ffe719da$var$ia) try {
    var $8f2285b8ffe719da$var$Mb = {};
    Object.defineProperty($8f2285b8ffe719da$var$Mb, "passive", {
        get: function() {
            $8f2285b8ffe719da$var$Lb = !0;
        }
    });
    window.addEventListener("test", $8f2285b8ffe719da$var$Mb, $8f2285b8ffe719da$var$Mb);
    window.removeEventListener("test", $8f2285b8ffe719da$var$Mb, $8f2285b8ffe719da$var$Mb);
} catch (a) {
    $8f2285b8ffe719da$var$Lb = !1;
}
function $8f2285b8ffe719da$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $8f2285b8ffe719da$var$Ob = !1, $8f2285b8ffe719da$var$Pb = null, $8f2285b8ffe719da$var$Qb = !1, $8f2285b8ffe719da$var$Rb = null, $8f2285b8ffe719da$var$Sb = {
    onError: function(a) {
        $8f2285b8ffe719da$var$Ob = !0;
        $8f2285b8ffe719da$var$Pb = a;
    }
};
function $8f2285b8ffe719da$var$Tb(a, b, c, d, e, f, g, h, k) {
    $8f2285b8ffe719da$var$Ob = !1;
    $8f2285b8ffe719da$var$Pb = null;
    $8f2285b8ffe719da$var$Nb.apply($8f2285b8ffe719da$var$Sb, arguments);
}
function $8f2285b8ffe719da$var$Ub(a, b, c, d, e, f, g, h, k) {
    $8f2285b8ffe719da$var$Tb.apply(this, arguments);
    if ($8f2285b8ffe719da$var$Ob) {
        if ($8f2285b8ffe719da$var$Ob) {
            var l = $8f2285b8ffe719da$var$Pb;
            $8f2285b8ffe719da$var$Ob = !1;
            $8f2285b8ffe719da$var$Pb = null;
        } else throw Error($8f2285b8ffe719da$var$p(198));
        $8f2285b8ffe719da$var$Qb || ($8f2285b8ffe719da$var$Qb = !0, $8f2285b8ffe719da$var$Rb = l);
    }
}
function $8f2285b8ffe719da$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $8f2285b8ffe719da$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $8f2285b8ffe719da$var$Xb(a) {
    if ($8f2285b8ffe719da$var$Vb(a) !== a) throw Error($8f2285b8ffe719da$var$p(188));
}
function $8f2285b8ffe719da$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $8f2285b8ffe719da$var$Vb(a);
        if (null === b) throw Error($8f2285b8ffe719da$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $8f2285b8ffe719da$var$Xb(e), a;
                if (f === d) return $8f2285b8ffe719da$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($8f2285b8ffe719da$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($8f2285b8ffe719da$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($8f2285b8ffe719da$var$p(190));
    }
    if (3 !== c.tag) throw Error($8f2285b8ffe719da$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $8f2285b8ffe719da$var$Zb(a) {
    a = $8f2285b8ffe719da$var$Yb(a);
    return null !== a ? $8f2285b8ffe719da$var$$b(a) : null;
}
function $8f2285b8ffe719da$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $8f2285b8ffe719da$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $8f2285b8ffe719da$var$ac = $e00l3.unstable_scheduleCallback, $8f2285b8ffe719da$var$bc = $e00l3.unstable_cancelCallback, $8f2285b8ffe719da$var$cc = $e00l3.unstable_shouldYield, $8f2285b8ffe719da$var$dc = $e00l3.unstable_requestPaint, $8f2285b8ffe719da$var$B = $e00l3.unstable_now, $8f2285b8ffe719da$var$ec = $e00l3.unstable_getCurrentPriorityLevel, $8f2285b8ffe719da$var$fc = $e00l3.unstable_ImmediatePriority, $8f2285b8ffe719da$var$gc = $e00l3.unstable_UserBlockingPriority, $8f2285b8ffe719da$var$hc = $e00l3.unstable_NormalPriority, $8f2285b8ffe719da$var$ic = $e00l3.unstable_LowPriority, $8f2285b8ffe719da$var$jc = $e00l3.unstable_IdlePriority, $8f2285b8ffe719da$var$kc = null, $8f2285b8ffe719da$var$lc = null;
function $8f2285b8ffe719da$var$mc(a) {
    if ($8f2285b8ffe719da$var$lc && "function" === typeof $8f2285b8ffe719da$var$lc.onCommitFiberRoot) try {
        $8f2285b8ffe719da$var$lc.onCommitFiberRoot($8f2285b8ffe719da$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $8f2285b8ffe719da$var$oc = Math.clz32 ? Math.clz32 : $8f2285b8ffe719da$var$nc, $8f2285b8ffe719da$var$pc = Math.log, $8f2285b8ffe719da$var$qc = Math.LN2;
function $8f2285b8ffe719da$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($8f2285b8ffe719da$var$pc(a) / $8f2285b8ffe719da$var$qc | 0) | 0;
}
var $8f2285b8ffe719da$var$rc = 64, $8f2285b8ffe719da$var$sc = 4194304;
function $8f2285b8ffe719da$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $8f2285b8ffe719da$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $8f2285b8ffe719da$var$tc(h) : (f &= g, 0 !== f && (d = $8f2285b8ffe719da$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $8f2285b8ffe719da$var$tc(g) : 0 !== f && (d = $8f2285b8ffe719da$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $8f2285b8ffe719da$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $8f2285b8ffe719da$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8f2285b8ffe719da$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $8f2285b8ffe719da$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $8f2285b8ffe719da$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $8f2285b8ffe719da$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $8f2285b8ffe719da$var$yc() {
    var a = $8f2285b8ffe719da$var$rc;
    $8f2285b8ffe719da$var$rc <<= 1;
    0 === ($8f2285b8ffe719da$var$rc & 4194240) && ($8f2285b8ffe719da$var$rc = 64);
    return a;
}
function $8f2285b8ffe719da$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $8f2285b8ffe719da$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $8f2285b8ffe719da$var$oc(b);
    a[b] = c;
}
function $8f2285b8ffe719da$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $8f2285b8ffe719da$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $8f2285b8ffe719da$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $8f2285b8ffe719da$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $8f2285b8ffe719da$var$C = 0;
function $8f2285b8ffe719da$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $8f2285b8ffe719da$var$Ec, $8f2285b8ffe719da$var$Fc, $8f2285b8ffe719da$var$Gc, $8f2285b8ffe719da$var$Hc, $8f2285b8ffe719da$var$Ic, $8f2285b8ffe719da$var$Jc = !1, $8f2285b8ffe719da$var$Kc = [], $8f2285b8ffe719da$var$Lc = null, $8f2285b8ffe719da$var$Mc = null, $8f2285b8ffe719da$var$Nc = null, $8f2285b8ffe719da$var$Oc = new Map, $8f2285b8ffe719da$var$Pc = new Map, $8f2285b8ffe719da$var$Qc = [], $8f2285b8ffe719da$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $8f2285b8ffe719da$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $8f2285b8ffe719da$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $8f2285b8ffe719da$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $8f2285b8ffe719da$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $8f2285b8ffe719da$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8f2285b8ffe719da$var$Pc.delete(b.pointerId);
    }
}
function $8f2285b8ffe719da$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $8f2285b8ffe719da$var$Cb(b), null !== b && $8f2285b8ffe719da$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $8f2285b8ffe719da$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $8f2285b8ffe719da$var$Lc = $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $8f2285b8ffe719da$var$Mc = $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $8f2285b8ffe719da$var$Nc = $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $8f2285b8ffe719da$var$Oc.set(f, $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $8f2285b8ffe719da$var$Pc.set(f, $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $8f2285b8ffe719da$var$Vc(a) {
    var b = $8f2285b8ffe719da$var$Wc(a.target);
    if (null !== b) {
        var c = $8f2285b8ffe719da$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $8f2285b8ffe719da$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $8f2285b8ffe719da$var$Ic(a.priority, function() {
                        $8f2285b8ffe719da$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $8f2285b8ffe719da$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $8f2285b8ffe719da$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $8f2285b8ffe719da$var$wb = d;
            c.target.dispatchEvent(d);
            $8f2285b8ffe719da$var$wb = null;
        } else return b = $8f2285b8ffe719da$var$Cb(c), null !== b && $8f2285b8ffe719da$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $8f2285b8ffe719da$var$Zc(a, b, c) {
    $8f2285b8ffe719da$var$Xc(a) && c.delete(b);
}
function $8f2285b8ffe719da$var$$c() {
    $8f2285b8ffe719da$var$Jc = !1;
    null !== $8f2285b8ffe719da$var$Lc && $8f2285b8ffe719da$var$Xc($8f2285b8ffe719da$var$Lc) && ($8f2285b8ffe719da$var$Lc = null);
    null !== $8f2285b8ffe719da$var$Mc && $8f2285b8ffe719da$var$Xc($8f2285b8ffe719da$var$Mc) && ($8f2285b8ffe719da$var$Mc = null);
    null !== $8f2285b8ffe719da$var$Nc && $8f2285b8ffe719da$var$Xc($8f2285b8ffe719da$var$Nc) && ($8f2285b8ffe719da$var$Nc = null);
    $8f2285b8ffe719da$var$Oc.forEach($8f2285b8ffe719da$var$Zc);
    $8f2285b8ffe719da$var$Pc.forEach($8f2285b8ffe719da$var$Zc);
}
function $8f2285b8ffe719da$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $8f2285b8ffe719da$var$Jc || ($8f2285b8ffe719da$var$Jc = !0, $e00l3.unstable_scheduleCallback($e00l3.unstable_NormalPriority, $8f2285b8ffe719da$var$$c)));
}
function $8f2285b8ffe719da$var$bd(a) {
    function b(b) {
        return $8f2285b8ffe719da$var$ad(b, a);
    }
    if (0 < $8f2285b8ffe719da$var$Kc.length) {
        $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Kc[0], a);
        for(var c = 1; c < $8f2285b8ffe719da$var$Kc.length; c++){
            var d = $8f2285b8ffe719da$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $8f2285b8ffe719da$var$Lc && $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Lc, a);
    null !== $8f2285b8ffe719da$var$Mc && $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Mc, a);
    null !== $8f2285b8ffe719da$var$Nc && $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Nc, a);
    $8f2285b8ffe719da$var$Oc.forEach(b);
    $8f2285b8ffe719da$var$Pc.forEach(b);
    for(c = 0; c < $8f2285b8ffe719da$var$Qc.length; c++)d = $8f2285b8ffe719da$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $8f2285b8ffe719da$var$Qc.length && (c = $8f2285b8ffe719da$var$Qc[0], null === c.blockedOn);)$8f2285b8ffe719da$var$Vc(c), null === c.blockedOn && $8f2285b8ffe719da$var$Qc.shift();
}
var $8f2285b8ffe719da$var$cd = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig, $8f2285b8ffe719da$var$dd = !0;
function $8f2285b8ffe719da$var$ed(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$C, f = $8f2285b8ffe719da$var$cd.transition;
    $8f2285b8ffe719da$var$cd.transition = null;
    try {
        $8f2285b8ffe719da$var$C = 1, $8f2285b8ffe719da$var$fd(a, b, c, d);
    } finally{
        $8f2285b8ffe719da$var$C = e, $8f2285b8ffe719da$var$cd.transition = f;
    }
}
function $8f2285b8ffe719da$var$gd(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$C, f = $8f2285b8ffe719da$var$cd.transition;
    $8f2285b8ffe719da$var$cd.transition = null;
    try {
        $8f2285b8ffe719da$var$C = 4, $8f2285b8ffe719da$var$fd(a, b, c, d);
    } finally{
        $8f2285b8ffe719da$var$C = e, $8f2285b8ffe719da$var$cd.transition = f;
    }
}
function $8f2285b8ffe719da$var$fd(a, b, c, d) {
    if ($8f2285b8ffe719da$var$dd) {
        var e = $8f2285b8ffe719da$var$Yc(a, b, c, d);
        if (null === e) $8f2285b8ffe719da$var$hd(a, b, d, $8f2285b8ffe719da$var$id, c), $8f2285b8ffe719da$var$Sc(a, d);
        else if ($8f2285b8ffe719da$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($8f2285b8ffe719da$var$Sc(a, d), b & 4 && -1 < $8f2285b8ffe719da$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $8f2285b8ffe719da$var$Cb(e);
                null !== f && $8f2285b8ffe719da$var$Ec(f);
                f = $8f2285b8ffe719da$var$Yc(a, b, c, d);
                null === f && $8f2285b8ffe719da$var$hd(a, b, d, $8f2285b8ffe719da$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $8f2285b8ffe719da$var$hd(a, b, d, null, c);
    }
}
var $8f2285b8ffe719da$var$id = null;
function $8f2285b8ffe719da$var$Yc(a, b, c, d) {
    $8f2285b8ffe719da$var$id = null;
    a = $8f2285b8ffe719da$var$xb(d);
    a = $8f2285b8ffe719da$var$Wc(a);
    if (null !== a) {
        if (b = $8f2285b8ffe719da$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $8f2285b8ffe719da$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $8f2285b8ffe719da$var$id = a;
    return null;
}
function $8f2285b8ffe719da$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($8f2285b8ffe719da$var$ec()){
                case $8f2285b8ffe719da$var$fc:
                    return 1;
                case $8f2285b8ffe719da$var$gc:
                    return 4;
                case $8f2285b8ffe719da$var$hc:
                case $8f2285b8ffe719da$var$ic:
                    return 16;
                case $8f2285b8ffe719da$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $8f2285b8ffe719da$var$kd = null, $8f2285b8ffe719da$var$ld = null, $8f2285b8ffe719da$var$md = null;
function $8f2285b8ffe719da$var$nd() {
    if ($8f2285b8ffe719da$var$md) return $8f2285b8ffe719da$var$md;
    var a, b = $8f2285b8ffe719da$var$ld, c = b.length, d, e = "value" in $8f2285b8ffe719da$var$kd ? $8f2285b8ffe719da$var$kd.value : $8f2285b8ffe719da$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $8f2285b8ffe719da$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $8f2285b8ffe719da$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $8f2285b8ffe719da$var$pd() {
    return !0;
}
function $8f2285b8ffe719da$var$qd() {
    return !1;
}
function $8f2285b8ffe719da$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $8f2285b8ffe719da$var$pd : $8f2285b8ffe719da$var$qd;
        this.isPropagationStopped = $8f2285b8ffe719da$var$qd;
        return this;
    }
    $8f2285b8ffe719da$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $8f2285b8ffe719da$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $8f2285b8ffe719da$var$pd);
        },
        persist: function() {},
        isPersistent: $8f2285b8ffe719da$var$pd
    });
    return b;
}
var $8f2285b8ffe719da$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8f2285b8ffe719da$var$td = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$sd), $8f2285b8ffe719da$var$ud = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    view: 0,
    detail: 0
}), $8f2285b8ffe719da$var$vd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$ud), $8f2285b8ffe719da$var$wd, $8f2285b8ffe719da$var$xd, $8f2285b8ffe719da$var$yd, $8f2285b8ffe719da$var$Ad = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8f2285b8ffe719da$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $8f2285b8ffe719da$var$yd && ($8f2285b8ffe719da$var$yd && "mousemove" === a.type ? ($8f2285b8ffe719da$var$wd = a.screenX - $8f2285b8ffe719da$var$yd.screenX, $8f2285b8ffe719da$var$xd = a.screenY - $8f2285b8ffe719da$var$yd.screenY) : $8f2285b8ffe719da$var$xd = $8f2285b8ffe719da$var$wd = 0, $8f2285b8ffe719da$var$yd = a);
        return $8f2285b8ffe719da$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $8f2285b8ffe719da$var$xd;
    }
}), $8f2285b8ffe719da$var$Bd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Ad), $8f2285b8ffe719da$var$Cd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$Ad, {
    dataTransfer: 0
}), $8f2285b8ffe719da$var$Dd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Cd), $8f2285b8ffe719da$var$Ed = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    relatedTarget: 0
}), $8f2285b8ffe719da$var$Fd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Ed), $8f2285b8ffe719da$var$Gd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8f2285b8ffe719da$var$Hd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Gd), $8f2285b8ffe719da$var$Id = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $8f2285b8ffe719da$var$Jd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Id), $8f2285b8ffe719da$var$Kd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    data: 0
}), $8f2285b8ffe719da$var$Ld = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Kd), $8f2285b8ffe719da$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8f2285b8ffe719da$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8f2285b8ffe719da$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8f2285b8ffe719da$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $8f2285b8ffe719da$var$Od[a]) ? !!b[a] : !1;
}
function $8f2285b8ffe719da$var$zd() {
    return $8f2285b8ffe719da$var$Pd;
}
var $8f2285b8ffe719da$var$Qd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $8f2285b8ffe719da$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $8f2285b8ffe719da$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $8f2285b8ffe719da$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8f2285b8ffe719da$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $8f2285b8ffe719da$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $8f2285b8ffe719da$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $8f2285b8ffe719da$var$Rd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Qd), $8f2285b8ffe719da$var$Sd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8f2285b8ffe719da$var$Td = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Sd), $8f2285b8ffe719da$var$Ud = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8f2285b8ffe719da$var$zd
}), $8f2285b8ffe719da$var$Vd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Ud), $8f2285b8ffe719da$var$Wd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8f2285b8ffe719da$var$Xd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Wd), $8f2285b8ffe719da$var$Yd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8f2285b8ffe719da$var$Zd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Yd), $8f2285b8ffe719da$var$$d = [
    9,
    13,
    27,
    32
], $8f2285b8ffe719da$var$ae = $8f2285b8ffe719da$var$ia && "CompositionEvent" in window, $8f2285b8ffe719da$var$be = null;
$8f2285b8ffe719da$var$ia && "documentMode" in document && ($8f2285b8ffe719da$var$be = document.documentMode);
var $8f2285b8ffe719da$var$ce = $8f2285b8ffe719da$var$ia && "TextEvent" in window && !$8f2285b8ffe719da$var$be, $8f2285b8ffe719da$var$de = $8f2285b8ffe719da$var$ia && (!$8f2285b8ffe719da$var$ae || $8f2285b8ffe719da$var$be && 8 < $8f2285b8ffe719da$var$be && 11 >= $8f2285b8ffe719da$var$be), $8f2285b8ffe719da$var$ee = String.fromCharCode(32), $8f2285b8ffe719da$var$fe = !1;
function $8f2285b8ffe719da$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $8f2285b8ffe719da$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8f2285b8ffe719da$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $8f2285b8ffe719da$var$ie = !1;
function $8f2285b8ffe719da$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $8f2285b8ffe719da$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $8f2285b8ffe719da$var$fe = !0;
            return $8f2285b8ffe719da$var$ee;
        case "textInput":
            return a = b.data, a === $8f2285b8ffe719da$var$ee && $8f2285b8ffe719da$var$fe ? null : a;
        default:
            return null;
    }
}
function $8f2285b8ffe719da$var$ke(a, b) {
    if ($8f2285b8ffe719da$var$ie) return "compositionend" === a || !$8f2285b8ffe719da$var$ae && $8f2285b8ffe719da$var$ge(a, b) ? (a = $8f2285b8ffe719da$var$nd(), $8f2285b8ffe719da$var$md = $8f2285b8ffe719da$var$ld = $8f2285b8ffe719da$var$kd = null, $8f2285b8ffe719da$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $8f2285b8ffe719da$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $8f2285b8ffe719da$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8f2285b8ffe719da$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$8f2285b8ffe719da$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $8f2285b8ffe719da$var$ne(a, b, c, d) {
    $8f2285b8ffe719da$var$Eb(d);
    b = $8f2285b8ffe719da$var$oe(b, "onChange");
    0 < b.length && (c = new $8f2285b8ffe719da$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $8f2285b8ffe719da$var$pe = null, $8f2285b8ffe719da$var$qe = null;
function $8f2285b8ffe719da$var$re(a) {
    $8f2285b8ffe719da$var$se(a, 0);
}
function $8f2285b8ffe719da$var$te(a) {
    var b = $8f2285b8ffe719da$var$ue(a);
    if ($8f2285b8ffe719da$var$Wa(b)) return a;
}
function $8f2285b8ffe719da$var$ve(a, b) {
    if ("change" === a) return b;
}
var $8f2285b8ffe719da$var$we = !1;
if ($8f2285b8ffe719da$var$ia) {
    var $8f2285b8ffe719da$var$xe;
    if ($8f2285b8ffe719da$var$ia) {
        var $8f2285b8ffe719da$var$ye = "oninput" in document;
        if (!$8f2285b8ffe719da$var$ye) {
            var $8f2285b8ffe719da$var$ze = document.createElement("div");
            $8f2285b8ffe719da$var$ze.setAttribute("oninput", "return;");
            $8f2285b8ffe719da$var$ye = "function" === typeof $8f2285b8ffe719da$var$ze.oninput;
        }
        $8f2285b8ffe719da$var$xe = $8f2285b8ffe719da$var$ye;
    } else $8f2285b8ffe719da$var$xe = !1;
    $8f2285b8ffe719da$var$we = $8f2285b8ffe719da$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $8f2285b8ffe719da$var$Ae() {
    $8f2285b8ffe719da$var$pe && ($8f2285b8ffe719da$var$pe.detachEvent("onpropertychange", $8f2285b8ffe719da$var$Be), $8f2285b8ffe719da$var$qe = $8f2285b8ffe719da$var$pe = null);
}
function $8f2285b8ffe719da$var$Be(a) {
    if ("value" === a.propertyName && $8f2285b8ffe719da$var$te($8f2285b8ffe719da$var$qe)) {
        var b = [];
        $8f2285b8ffe719da$var$ne(b, $8f2285b8ffe719da$var$qe, a, $8f2285b8ffe719da$var$xb(a));
        $8f2285b8ffe719da$var$Jb($8f2285b8ffe719da$var$re, b);
    }
}
function $8f2285b8ffe719da$var$Ce(a, b, c) {
    "focusin" === a ? ($8f2285b8ffe719da$var$Ae(), $8f2285b8ffe719da$var$pe = b, $8f2285b8ffe719da$var$qe = c, $8f2285b8ffe719da$var$pe.attachEvent("onpropertychange", $8f2285b8ffe719da$var$Be)) : "focusout" === a && $8f2285b8ffe719da$var$Ae();
}
function $8f2285b8ffe719da$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $8f2285b8ffe719da$var$te($8f2285b8ffe719da$var$qe);
}
function $8f2285b8ffe719da$var$Ee(a, b) {
    if ("click" === a) return $8f2285b8ffe719da$var$te(b);
}
function $8f2285b8ffe719da$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $8f2285b8ffe719da$var$te(b);
}
function $8f2285b8ffe719da$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8f2285b8ffe719da$var$He = "function" === typeof Object.is ? Object.is : $8f2285b8ffe719da$var$Ge;
function $8f2285b8ffe719da$var$Ie(a, b) {
    if ($8f2285b8ffe719da$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$8f2285b8ffe719da$var$ja.call(b, e) || !$8f2285b8ffe719da$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $8f2285b8ffe719da$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $8f2285b8ffe719da$var$Ke(a, b) {
    var c = $8f2285b8ffe719da$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $8f2285b8ffe719da$var$Je(c);
    }
}
function $8f2285b8ffe719da$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $8f2285b8ffe719da$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $8f2285b8ffe719da$var$Me() {
    for(var a = window, b = $8f2285b8ffe719da$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $8f2285b8ffe719da$var$Xa(a.document);
    }
    return b;
}
function $8f2285b8ffe719da$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $8f2285b8ffe719da$var$Oe(a) {
    var b = $8f2285b8ffe719da$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $8f2285b8ffe719da$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $8f2285b8ffe719da$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $8f2285b8ffe719da$var$Ke(c, f);
                var g = $8f2285b8ffe719da$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $8f2285b8ffe719da$var$Pe = $8f2285b8ffe719da$var$ia && "documentMode" in document && 11 >= document.documentMode, $8f2285b8ffe719da$var$Qe = null, $8f2285b8ffe719da$var$Re = null, $8f2285b8ffe719da$var$Se = null, $8f2285b8ffe719da$var$Te = !1;
function $8f2285b8ffe719da$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $8f2285b8ffe719da$var$Te || null == $8f2285b8ffe719da$var$Qe || $8f2285b8ffe719da$var$Qe !== $8f2285b8ffe719da$var$Xa(d) || (d = $8f2285b8ffe719da$var$Qe, "selectionStart" in d && $8f2285b8ffe719da$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $8f2285b8ffe719da$var$Se && $8f2285b8ffe719da$var$Ie($8f2285b8ffe719da$var$Se, d) || ($8f2285b8ffe719da$var$Se = d, d = $8f2285b8ffe719da$var$oe($8f2285b8ffe719da$var$Re, "onSelect"), 0 < d.length && (b = new $8f2285b8ffe719da$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $8f2285b8ffe719da$var$Qe)));
}
function $8f2285b8ffe719da$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $8f2285b8ffe719da$var$We = {
    animationend: $8f2285b8ffe719da$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $8f2285b8ffe719da$var$Ve("Animation", "AnimationIteration"),
    animationstart: $8f2285b8ffe719da$var$Ve("Animation", "AnimationStart"),
    transitionend: $8f2285b8ffe719da$var$Ve("Transition", "TransitionEnd")
}, $8f2285b8ffe719da$var$Xe = {}, $8f2285b8ffe719da$var$Ye = {};
$8f2285b8ffe719da$var$ia && ($8f2285b8ffe719da$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $8f2285b8ffe719da$var$We.animationend.animation, delete $8f2285b8ffe719da$var$We.animationiteration.animation, delete $8f2285b8ffe719da$var$We.animationstart.animation), "TransitionEvent" in window || delete $8f2285b8ffe719da$var$We.transitionend.transition);
function $8f2285b8ffe719da$var$Ze(a) {
    if ($8f2285b8ffe719da$var$Xe[a]) return $8f2285b8ffe719da$var$Xe[a];
    if (!$8f2285b8ffe719da$var$We[a]) return a;
    var b = $8f2285b8ffe719da$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $8f2285b8ffe719da$var$Ye) return $8f2285b8ffe719da$var$Xe[a] = b[c];
    return a;
}
var $8f2285b8ffe719da$var$$e = $8f2285b8ffe719da$var$Ze("animationend"), $8f2285b8ffe719da$var$af = $8f2285b8ffe719da$var$Ze("animationiteration"), $8f2285b8ffe719da$var$bf = $8f2285b8ffe719da$var$Ze("animationstart"), $8f2285b8ffe719da$var$cf = $8f2285b8ffe719da$var$Ze("transitionend"), $8f2285b8ffe719da$var$df = new Map, $8f2285b8ffe719da$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $8f2285b8ffe719da$var$ff(a, b) {
    $8f2285b8ffe719da$var$df.set(a, b);
    $8f2285b8ffe719da$var$fa(b, [
        a
    ]);
}
for(var $8f2285b8ffe719da$var$gf = 0; $8f2285b8ffe719da$var$gf < $8f2285b8ffe719da$var$ef.length; $8f2285b8ffe719da$var$gf++){
    var $8f2285b8ffe719da$var$hf = $8f2285b8ffe719da$var$ef[$8f2285b8ffe719da$var$gf], $8f2285b8ffe719da$var$jf = $8f2285b8ffe719da$var$hf.toLowerCase(), $8f2285b8ffe719da$var$kf = $8f2285b8ffe719da$var$hf[0].toUpperCase() + $8f2285b8ffe719da$var$hf.slice(1);
    $8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$jf, "on" + $8f2285b8ffe719da$var$kf);
}
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$$e, "onAnimationEnd");
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$af, "onAnimationIteration");
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$bf, "onAnimationStart");
$8f2285b8ffe719da$var$ff("dblclick", "onDoubleClick");
$8f2285b8ffe719da$var$ff("focusin", "onFocus");
$8f2285b8ffe719da$var$ff("focusout", "onBlur");
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$cf, "onTransitionEnd");
$8f2285b8ffe719da$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8f2285b8ffe719da$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8f2285b8ffe719da$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8f2285b8ffe719da$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8f2285b8ffe719da$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8f2285b8ffe719da$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8f2285b8ffe719da$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8f2285b8ffe719da$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8f2285b8ffe719da$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8f2285b8ffe719da$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8f2285b8ffe719da$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8f2285b8ffe719da$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($8f2285b8ffe719da$var$lf));
function $8f2285b8ffe719da$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $8f2285b8ffe719da$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $8f2285b8ffe719da$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8f2285b8ffe719da$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8f2285b8ffe719da$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($8f2285b8ffe719da$var$Qb) throw a = $8f2285b8ffe719da$var$Rb, $8f2285b8ffe719da$var$Qb = !1, $8f2285b8ffe719da$var$Rb = null, a;
}
function $8f2285b8ffe719da$var$D(a, b) {
    var c = b[$8f2285b8ffe719da$var$of];
    void 0 === c && (c = b[$8f2285b8ffe719da$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($8f2285b8ffe719da$var$pf(b, a, 2, !1), c.add(d));
}
function $8f2285b8ffe719da$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $8f2285b8ffe719da$var$pf(c, a, d, b);
}
var $8f2285b8ffe719da$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $8f2285b8ffe719da$var$sf(a) {
    if (!a[$8f2285b8ffe719da$var$rf]) {
        a[$8f2285b8ffe719da$var$rf] = !0;
        $8f2285b8ffe719da$var$da.forEach(function(b) {
            "selectionchange" !== b && ($8f2285b8ffe719da$var$mf.has(b) || $8f2285b8ffe719da$var$qf(b, !1, a), $8f2285b8ffe719da$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$8f2285b8ffe719da$var$rf] || (b[$8f2285b8ffe719da$var$rf] = !0, $8f2285b8ffe719da$var$qf("selectionchange", !1, b));
    }
}
function $8f2285b8ffe719da$var$pf(a, b, c, d) {
    switch($8f2285b8ffe719da$var$jd(b)){
        case 1:
            var e = $8f2285b8ffe719da$var$ed;
            break;
        case 4:
            e = $8f2285b8ffe719da$var$gd;
            break;
        default:
            e = $8f2285b8ffe719da$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$8f2285b8ffe719da$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $8f2285b8ffe719da$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $8f2285b8ffe719da$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $8f2285b8ffe719da$var$Jb(function() {
        var d = f, e = $8f2285b8ffe719da$var$xb(c), g = [];
        a: {
            var h = $8f2285b8ffe719da$var$df.get(a);
            if (void 0 !== h) {
                var k = $8f2285b8ffe719da$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $8f2285b8ffe719da$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $8f2285b8ffe719da$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $8f2285b8ffe719da$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $8f2285b8ffe719da$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $8f2285b8ffe719da$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $8f2285b8ffe719da$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $8f2285b8ffe719da$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $8f2285b8ffe719da$var$Vd;
                        break;
                    case $8f2285b8ffe719da$var$$e:
                    case $8f2285b8ffe719da$var$af:
                    case $8f2285b8ffe719da$var$bf:
                        k = $8f2285b8ffe719da$var$Hd;
                        break;
                    case $8f2285b8ffe719da$var$cf:
                        k = $8f2285b8ffe719da$var$Xd;
                        break;
                    case "scroll":
                        k = $8f2285b8ffe719da$var$vd;
                        break;
                    case "wheel":
                        k = $8f2285b8ffe719da$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $8f2285b8ffe719da$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $8f2285b8ffe719da$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $8f2285b8ffe719da$var$Kb(w, x), null != F && t.push($8f2285b8ffe719da$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $8f2285b8ffe719da$var$wb && (n = c.relatedTarget || c.fromElement) && ($8f2285b8ffe719da$var$Wc(n) || n[$8f2285b8ffe719da$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $8f2285b8ffe719da$var$Wc(n) : null, null !== n && (J = $8f2285b8ffe719da$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $8f2285b8ffe719da$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $8f2285b8ffe719da$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $8f2285b8ffe719da$var$ue(k);
                        u = null == n ? h : $8f2285b8ffe719da$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $8f2285b8ffe719da$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $8f2285b8ffe719da$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $8f2285b8ffe719da$var$vf(F))u++;
                            for(; 0 < w - u;)t = $8f2285b8ffe719da$var$vf(t), w--;
                            for(; 0 < u - w;)x = $8f2285b8ffe719da$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $8f2285b8ffe719da$var$vf(t);
                                x = $8f2285b8ffe719da$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $8f2285b8ffe719da$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $8f2285b8ffe719da$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $8f2285b8ffe719da$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $8f2285b8ffe719da$var$ve;
                else if ($8f2285b8ffe719da$var$me(h)) {
                    if ($8f2285b8ffe719da$var$we) na = $8f2285b8ffe719da$var$Fe;
                    else {
                        na = $8f2285b8ffe719da$var$De;
                        var xa = $8f2285b8ffe719da$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $8f2285b8ffe719da$var$Ee);
                if (na && (na = na(a, d))) {
                    $8f2285b8ffe719da$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $8f2285b8ffe719da$var$cb(h, "number", h.value);
            }
            xa = d ? $8f2285b8ffe719da$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($8f2285b8ffe719da$var$me(xa) || "true" === xa.contentEditable) $8f2285b8ffe719da$var$Qe = xa, $8f2285b8ffe719da$var$Re = d, $8f2285b8ffe719da$var$Se = null;
                    break;
                case "focusout":
                    $8f2285b8ffe719da$var$Se = $8f2285b8ffe719da$var$Re = $8f2285b8ffe719da$var$Qe = null;
                    break;
                case "mousedown":
                    $8f2285b8ffe719da$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8f2285b8ffe719da$var$Te = !1;
                    $8f2285b8ffe719da$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($8f2285b8ffe719da$var$Pe) break;
                case "keydown":
                case "keyup":
                    $8f2285b8ffe719da$var$Ue(g, c, e);
            }
            var $a;
            if ($8f2285b8ffe719da$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $8f2285b8ffe719da$var$ie ? $8f2285b8ffe719da$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($8f2285b8ffe719da$var$de && "ko" !== c.locale && ($8f2285b8ffe719da$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $8f2285b8ffe719da$var$ie && ($a = $8f2285b8ffe719da$var$nd()) : ($8f2285b8ffe719da$var$kd = e, $8f2285b8ffe719da$var$ld = "value" in $8f2285b8ffe719da$var$kd ? $8f2285b8ffe719da$var$kd.value : $8f2285b8ffe719da$var$kd.textContent, $8f2285b8ffe719da$var$ie = !0)), xa = $8f2285b8ffe719da$var$oe(d, ba), 0 < xa.length && (ba = new $8f2285b8ffe719da$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $8f2285b8ffe719da$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $8f2285b8ffe719da$var$ce ? $8f2285b8ffe719da$var$je(a, c) : $8f2285b8ffe719da$var$ke(a, c)) d = $8f2285b8ffe719da$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $8f2285b8ffe719da$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $8f2285b8ffe719da$var$se(g, b);
    });
}
function $8f2285b8ffe719da$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $8f2285b8ffe719da$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $8f2285b8ffe719da$var$Kb(a, c), null != f && d.unshift($8f2285b8ffe719da$var$tf(a, f, e)), f = $8f2285b8ffe719da$var$Kb(a, b), null != f && d.push($8f2285b8ffe719da$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $8f2285b8ffe719da$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $8f2285b8ffe719da$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $8f2285b8ffe719da$var$Kb(c, f), null != k && g.unshift($8f2285b8ffe719da$var$tf(c, k, h))) : e || (k = $8f2285b8ffe719da$var$Kb(c, f), null != k && g.push($8f2285b8ffe719da$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $8f2285b8ffe719da$var$xf = /\r\n?/g, $8f2285b8ffe719da$var$yf = /\u0000|\uFFFD/g;
function $8f2285b8ffe719da$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($8f2285b8ffe719da$var$xf, "\n").replace($8f2285b8ffe719da$var$yf, "");
}
function $8f2285b8ffe719da$var$Af(a, b, c) {
    b = $8f2285b8ffe719da$var$zf(b);
    if ($8f2285b8ffe719da$var$zf(a) !== b && c) throw Error($8f2285b8ffe719da$var$p(425));
}
function $8f2285b8ffe719da$var$Bf() {}
var $8f2285b8ffe719da$var$Cf = null, $8f2285b8ffe719da$var$Df = null;
function $8f2285b8ffe719da$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $8f2285b8ffe719da$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $8f2285b8ffe719da$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $8f2285b8ffe719da$var$Hf = "function" === typeof Promise ? Promise : void 0, $8f2285b8ffe719da$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8f2285b8ffe719da$var$Hf ? function(a) {
    return $8f2285b8ffe719da$var$Hf.resolve(null).then(a).catch($8f2285b8ffe719da$var$If);
} : $8f2285b8ffe719da$var$Ff;
function $8f2285b8ffe719da$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $8f2285b8ffe719da$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $8f2285b8ffe719da$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $8f2285b8ffe719da$var$bd(b);
}
function $8f2285b8ffe719da$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $8f2285b8ffe719da$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $8f2285b8ffe719da$var$Nf = Math.random().toString(36).slice(2), $8f2285b8ffe719da$var$Of = "__reactFiber$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$Pf = "__reactProps$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$uf = "__reactContainer$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$of = "__reactEvents$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$Qf = "__reactListeners$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$Rf = "__reactHandles$" + $8f2285b8ffe719da$var$Nf;
function $8f2285b8ffe719da$var$Wc(a) {
    var b = a[$8f2285b8ffe719da$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$8f2285b8ffe719da$var$uf] || c[$8f2285b8ffe719da$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $8f2285b8ffe719da$var$Mf(a); null !== a;){
                if (c = a[$8f2285b8ffe719da$var$Of]) return c;
                a = $8f2285b8ffe719da$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $8f2285b8ffe719da$var$Cb(a) {
    a = a[$8f2285b8ffe719da$var$Of] || a[$8f2285b8ffe719da$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $8f2285b8ffe719da$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($8f2285b8ffe719da$var$p(33));
}
function $8f2285b8ffe719da$var$Db(a) {
    return a[$8f2285b8ffe719da$var$Pf] || null;
}
var $8f2285b8ffe719da$var$Sf = [], $8f2285b8ffe719da$var$Tf = -1;
function $8f2285b8ffe719da$var$Uf(a) {
    return {
        current: a
    };
}
function $8f2285b8ffe719da$var$E(a) {
    0 > $8f2285b8ffe719da$var$Tf || (a.current = $8f2285b8ffe719da$var$Sf[$8f2285b8ffe719da$var$Tf], $8f2285b8ffe719da$var$Sf[$8f2285b8ffe719da$var$Tf] = null, $8f2285b8ffe719da$var$Tf--);
}
function $8f2285b8ffe719da$var$G(a, b) {
    $8f2285b8ffe719da$var$Tf++;
    $8f2285b8ffe719da$var$Sf[$8f2285b8ffe719da$var$Tf] = a.current;
    a.current = b;
}
var $8f2285b8ffe719da$var$Vf = {}, $8f2285b8ffe719da$var$H = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$Vf), $8f2285b8ffe719da$var$Wf = $8f2285b8ffe719da$var$Uf(!1), $8f2285b8ffe719da$var$Xf = $8f2285b8ffe719da$var$Vf;
function $8f2285b8ffe719da$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $8f2285b8ffe719da$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $8f2285b8ffe719da$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $8f2285b8ffe719da$var$$f() {
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H);
}
function $8f2285b8ffe719da$var$ag(a, b, c) {
    if ($8f2285b8ffe719da$var$H.current !== $8f2285b8ffe719da$var$Vf) throw Error($8f2285b8ffe719da$var$p(168));
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$H, b);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wf, c);
}
function $8f2285b8ffe719da$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($8f2285b8ffe719da$var$p(108, $8f2285b8ffe719da$var$Ra(a) || "Unknown", e));
    return $8f2285b8ffe719da$var$A({}, c, d);
}
function $8f2285b8ffe719da$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $8f2285b8ffe719da$var$Vf;
    $8f2285b8ffe719da$var$Xf = $8f2285b8ffe719da$var$H.current;
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$H, a);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wf, $8f2285b8ffe719da$var$Wf.current);
    return !0;
}
function $8f2285b8ffe719da$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($8f2285b8ffe719da$var$p(169));
    c ? (a = $8f2285b8ffe719da$var$bg(a, b, $8f2285b8ffe719da$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H), $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$H, a)) : $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wf, c);
}
var $8f2285b8ffe719da$var$eg = null, $8f2285b8ffe719da$var$fg = !1, $8f2285b8ffe719da$var$gg = !1;
function $8f2285b8ffe719da$var$hg(a) {
    null === $8f2285b8ffe719da$var$eg ? $8f2285b8ffe719da$var$eg = [
        a
    ] : $8f2285b8ffe719da$var$eg.push(a);
}
function $8f2285b8ffe719da$var$ig(a) {
    $8f2285b8ffe719da$var$fg = !0;
    $8f2285b8ffe719da$var$hg(a);
}
function $8f2285b8ffe719da$var$jg() {
    if (!$8f2285b8ffe719da$var$gg && null !== $8f2285b8ffe719da$var$eg) {
        $8f2285b8ffe719da$var$gg = !0;
        var a = 0, b = $8f2285b8ffe719da$var$C;
        try {
            var c = $8f2285b8ffe719da$var$eg;
            for($8f2285b8ffe719da$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $8f2285b8ffe719da$var$eg = null;
            $8f2285b8ffe719da$var$fg = !1;
        } catch (e) {
            throw null !== $8f2285b8ffe719da$var$eg && ($8f2285b8ffe719da$var$eg = $8f2285b8ffe719da$var$eg.slice(a + 1)), $8f2285b8ffe719da$var$ac($8f2285b8ffe719da$var$fc, $8f2285b8ffe719da$var$jg), e;
        } finally{
            $8f2285b8ffe719da$var$C = b, $8f2285b8ffe719da$var$gg = !1;
        }
    }
    return null;
}
var $8f2285b8ffe719da$var$kg = [], $8f2285b8ffe719da$var$lg = 0, $8f2285b8ffe719da$var$mg = null, $8f2285b8ffe719da$var$ng = 0, $8f2285b8ffe719da$var$og = [], $8f2285b8ffe719da$var$pg = 0, $8f2285b8ffe719da$var$qg = null, $8f2285b8ffe719da$var$rg = 1, $8f2285b8ffe719da$var$sg = "";
function $8f2285b8ffe719da$var$tg(a, b) {
    $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg++] = $8f2285b8ffe719da$var$ng;
    $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg++] = $8f2285b8ffe719da$var$mg;
    $8f2285b8ffe719da$var$mg = a;
    $8f2285b8ffe719da$var$ng = b;
}
function $8f2285b8ffe719da$var$ug(a, b, c) {
    $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$rg;
    $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$sg;
    $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$qg;
    $8f2285b8ffe719da$var$qg = a;
    var d = $8f2285b8ffe719da$var$rg;
    a = $8f2285b8ffe719da$var$sg;
    var e = 32 - $8f2285b8ffe719da$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $8f2285b8ffe719da$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $8f2285b8ffe719da$var$rg = 1 << 32 - $8f2285b8ffe719da$var$oc(b) + e | c << e | d;
        $8f2285b8ffe719da$var$sg = f + a;
    } else $8f2285b8ffe719da$var$rg = 1 << f | c << e | d, $8f2285b8ffe719da$var$sg = a;
}
function $8f2285b8ffe719da$var$vg(a) {
    null !== a.return && ($8f2285b8ffe719da$var$tg(a, 1), $8f2285b8ffe719da$var$ug(a, 1, 0));
}
function $8f2285b8ffe719da$var$wg(a) {
    for(; a === $8f2285b8ffe719da$var$mg;)$8f2285b8ffe719da$var$mg = $8f2285b8ffe719da$var$kg[--$8f2285b8ffe719da$var$lg], $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg] = null, $8f2285b8ffe719da$var$ng = $8f2285b8ffe719da$var$kg[--$8f2285b8ffe719da$var$lg], $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg] = null;
    for(; a === $8f2285b8ffe719da$var$qg;)$8f2285b8ffe719da$var$qg = $8f2285b8ffe719da$var$og[--$8f2285b8ffe719da$var$pg], $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg] = null, $8f2285b8ffe719da$var$sg = $8f2285b8ffe719da$var$og[--$8f2285b8ffe719da$var$pg], $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg] = null, $8f2285b8ffe719da$var$rg = $8f2285b8ffe719da$var$og[--$8f2285b8ffe719da$var$pg], $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg] = null;
}
var $8f2285b8ffe719da$var$xg = null, $8f2285b8ffe719da$var$yg = null, $8f2285b8ffe719da$var$I = !1, $8f2285b8ffe719da$var$zg = null;
function $8f2285b8ffe719da$var$Ag(a, b) {
    var c = $8f2285b8ffe719da$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $8f2285b8ffe719da$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $8f2285b8ffe719da$var$xg = a, $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $8f2285b8ffe719da$var$xg = a, $8f2285b8ffe719da$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $8f2285b8ffe719da$var$qg ? {
                id: $8f2285b8ffe719da$var$rg,
                overflow: $8f2285b8ffe719da$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $8f2285b8ffe719da$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $8f2285b8ffe719da$var$xg = a, $8f2285b8ffe719da$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $8f2285b8ffe719da$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $8f2285b8ffe719da$var$Eg(a) {
    if ($8f2285b8ffe719da$var$I) {
        var b = $8f2285b8ffe719da$var$yg;
        if (b) {
            var c = b;
            if (!$8f2285b8ffe719da$var$Cg(a, b)) {
                if ($8f2285b8ffe719da$var$Dg(a)) throw Error($8f2285b8ffe719da$var$p(418));
                b = $8f2285b8ffe719da$var$Lf(c.nextSibling);
                var d = $8f2285b8ffe719da$var$xg;
                b && $8f2285b8ffe719da$var$Cg(a, b) ? $8f2285b8ffe719da$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $8f2285b8ffe719da$var$I = !1, $8f2285b8ffe719da$var$xg = a);
            }
        } else {
            if ($8f2285b8ffe719da$var$Dg(a)) throw Error($8f2285b8ffe719da$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $8f2285b8ffe719da$var$I = !1;
            $8f2285b8ffe719da$var$xg = a;
        }
    }
}
function $8f2285b8ffe719da$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $8f2285b8ffe719da$var$xg = a;
}
function $8f2285b8ffe719da$var$Gg(a) {
    if (a !== $8f2285b8ffe719da$var$xg) return !1;
    if (!$8f2285b8ffe719da$var$I) return $8f2285b8ffe719da$var$Fg(a), $8f2285b8ffe719da$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$8f2285b8ffe719da$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $8f2285b8ffe719da$var$yg)) {
        if ($8f2285b8ffe719da$var$Dg(a)) throw $8f2285b8ffe719da$var$Hg(), Error($8f2285b8ffe719da$var$p(418));
        for(; b;)$8f2285b8ffe719da$var$Ag(a, b), b = $8f2285b8ffe719da$var$Lf(b.nextSibling);
    }
    $8f2285b8ffe719da$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($8f2285b8ffe719da$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $8f2285b8ffe719da$var$yg = null;
        }
    } else $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$xg ? $8f2285b8ffe719da$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $8f2285b8ffe719da$var$Hg() {
    for(var a = $8f2285b8ffe719da$var$yg; a;)a = $8f2285b8ffe719da$var$Lf(a.nextSibling);
}
function $8f2285b8ffe719da$var$Ig() {
    $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$xg = null;
    $8f2285b8ffe719da$var$I = !1;
}
function $8f2285b8ffe719da$var$Jg(a) {
    null === $8f2285b8ffe719da$var$zg ? $8f2285b8ffe719da$var$zg = [
        a
    ] : $8f2285b8ffe719da$var$zg.push(a);
}
var $8f2285b8ffe719da$var$Kg = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig;
function $8f2285b8ffe719da$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($8f2285b8ffe719da$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($8f2285b8ffe719da$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($8f2285b8ffe719da$var$p(284));
        if (!c._owner) throw Error($8f2285b8ffe719da$var$p(290, a));
    }
    return a;
}
function $8f2285b8ffe719da$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($8f2285b8ffe719da$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $8f2285b8ffe719da$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $8f2285b8ffe719da$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $8f2285b8ffe719da$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $8f2285b8ffe719da$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $8f2285b8ffe719da$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $8f2285b8ffe719da$var$Ha && $8f2285b8ffe719da$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $8f2285b8ffe719da$var$Lg(a, b, c), d.return = a, d;
        d = $8f2285b8ffe719da$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $8f2285b8ffe719da$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $8f2285b8ffe719da$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $8f2285b8ffe719da$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $8f2285b8ffe719da$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    return c = $8f2285b8ffe719da$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $8f2285b8ffe719da$var$Lg(a, null, b), c.return = a, c;
                case $8f2285b8ffe719da$var$wa:
                    return b = $8f2285b8ffe719da$var$Sg(b, a.mode, c), b.return = a, b;
                case $8f2285b8ffe719da$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($8f2285b8ffe719da$var$eb(b) || $8f2285b8ffe719da$var$Ka(b)) return b = $8f2285b8ffe719da$var$Tg(b, a.mode, c, null), b.return = a, b;
            $8f2285b8ffe719da$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $8f2285b8ffe719da$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $8f2285b8ffe719da$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($8f2285b8ffe719da$var$eb(c) || $8f2285b8ffe719da$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $8f2285b8ffe719da$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $8f2285b8ffe719da$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $8f2285b8ffe719da$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($8f2285b8ffe719da$var$eb(d) || $8f2285b8ffe719da$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $8f2285b8ffe719da$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $8f2285b8ffe719da$var$Ka(h);
        if ("function" !== typeof l) throw Error($8f2285b8ffe719da$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($8f2285b8ffe719da$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $8f2285b8ffe719da$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $8f2285b8ffe719da$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $8f2285b8ffe719da$var$Ha && $8f2285b8ffe719da$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $8f2285b8ffe719da$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $8f2285b8ffe719da$var$ya ? (d = $8f2285b8ffe719da$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $8f2285b8ffe719da$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $8f2285b8ffe719da$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $8f2285b8ffe719da$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $8f2285b8ffe719da$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $8f2285b8ffe719da$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($8f2285b8ffe719da$var$eb(f)) return n(a, d, f, h);
            if ($8f2285b8ffe719da$var$Ka(f)) return t(a, d, f, h);
            $8f2285b8ffe719da$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $8f2285b8ffe719da$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $8f2285b8ffe719da$var$Ug = $8f2285b8ffe719da$var$Og(!0), $8f2285b8ffe719da$var$Vg = $8f2285b8ffe719da$var$Og(!1), $8f2285b8ffe719da$var$Wg = $8f2285b8ffe719da$var$Uf(null), $8f2285b8ffe719da$var$Xg = null, $8f2285b8ffe719da$var$Yg = null, $8f2285b8ffe719da$var$Zg = null;
function $8f2285b8ffe719da$var$$g() {
    $8f2285b8ffe719da$var$Zg = $8f2285b8ffe719da$var$Yg = $8f2285b8ffe719da$var$Xg = null;
}
function $8f2285b8ffe719da$var$ah(a) {
    var b = $8f2285b8ffe719da$var$Wg.current;
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wg);
    a._currentValue = b;
}
function $8f2285b8ffe719da$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $8f2285b8ffe719da$var$ch(a, b) {
    $8f2285b8ffe719da$var$Xg = a;
    $8f2285b8ffe719da$var$Zg = $8f2285b8ffe719da$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($8f2285b8ffe719da$var$dh = !0), a.firstContext = null);
}
function $8f2285b8ffe719da$var$eh(a) {
    var b = a._currentValue;
    if ($8f2285b8ffe719da$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $8f2285b8ffe719da$var$Yg) {
            if (null === $8f2285b8ffe719da$var$Xg) throw Error($8f2285b8ffe719da$var$p(308));
            $8f2285b8ffe719da$var$Yg = a;
            $8f2285b8ffe719da$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $8f2285b8ffe719da$var$Yg = $8f2285b8ffe719da$var$Yg.next = a;
    }
    return b;
}
var $8f2285b8ffe719da$var$fh = null;
function $8f2285b8ffe719da$var$gh(a) {
    null === $8f2285b8ffe719da$var$fh ? $8f2285b8ffe719da$var$fh = [
        a
    ] : $8f2285b8ffe719da$var$fh.push(a);
}
function $8f2285b8ffe719da$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $8f2285b8ffe719da$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $8f2285b8ffe719da$var$ih(a, d);
}
function $8f2285b8ffe719da$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $8f2285b8ffe719da$var$jh = !1;
function $8f2285b8ffe719da$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $8f2285b8ffe719da$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $8f2285b8ffe719da$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8f2285b8ffe719da$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($8f2285b8ffe719da$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $8f2285b8ffe719da$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $8f2285b8ffe719da$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $8f2285b8ffe719da$var$ih(a, c);
}
function $8f2285b8ffe719da$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8f2285b8ffe719da$var$Cc(a, c);
    }
}
function $8f2285b8ffe719da$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $8f2285b8ffe719da$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $8f2285b8ffe719da$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $8f2285b8ffe719da$var$A({}, q, r);
                            break a;
                        case 2:
                            $8f2285b8ffe719da$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $8f2285b8ffe719da$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $8f2285b8ffe719da$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($8f2285b8ffe719da$var$p(191, e));
            e.call(d);
        }
    }
}
var $8f2285b8ffe719da$var$th = {}, $8f2285b8ffe719da$var$uh = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$th), $8f2285b8ffe719da$var$vh = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$th), $8f2285b8ffe719da$var$wh = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$th);
function $8f2285b8ffe719da$var$xh(a) {
    if (a === $8f2285b8ffe719da$var$th) throw Error($8f2285b8ffe719da$var$p(174));
    return a;
}
function $8f2285b8ffe719da$var$yh(a, b) {
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$wh, b);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$vh, a);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$uh, $8f2285b8ffe719da$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $8f2285b8ffe719da$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $8f2285b8ffe719da$var$lb(b, a);
    }
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$uh);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$uh, b);
}
function $8f2285b8ffe719da$var$zh() {
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$uh);
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$vh);
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$wh);
}
function $8f2285b8ffe719da$var$Ah(a) {
    $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$wh.current);
    var b = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
    var c = $8f2285b8ffe719da$var$lb(b, a.type);
    b !== c && ($8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$vh, a), $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$uh, c));
}
function $8f2285b8ffe719da$var$Bh(a) {
    $8f2285b8ffe719da$var$vh.current === a && ($8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$uh), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$vh));
}
var $8f2285b8ffe719da$var$L = $8f2285b8ffe719da$var$Uf(0);
function $8f2285b8ffe719da$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $8f2285b8ffe719da$var$Dh = [];
function $8f2285b8ffe719da$var$Eh() {
    for(var a = 0; a < $8f2285b8ffe719da$var$Dh.length; a++)$8f2285b8ffe719da$var$Dh[a]._workInProgressVersionPrimary = null;
    $8f2285b8ffe719da$var$Dh.length = 0;
}
var $8f2285b8ffe719da$var$Fh = $8f2285b8ffe719da$var$ua.ReactCurrentDispatcher, $8f2285b8ffe719da$var$Gh = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig, $8f2285b8ffe719da$var$Hh = 0, $8f2285b8ffe719da$var$M = null, $8f2285b8ffe719da$var$N = null, $8f2285b8ffe719da$var$O = null, $8f2285b8ffe719da$var$Ih = !1, $8f2285b8ffe719da$var$Jh = !1, $8f2285b8ffe719da$var$Kh = 0, $8f2285b8ffe719da$var$Lh = 0;
function $8f2285b8ffe719da$var$P() {
    throw Error($8f2285b8ffe719da$var$p(321));
}
function $8f2285b8ffe719da$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$8f2285b8ffe719da$var$He(a[c], b[c])) return !1;
    return !0;
}
function $8f2285b8ffe719da$var$Nh(a, b, c, d, e, f) {
    $8f2285b8ffe719da$var$Hh = f;
    $8f2285b8ffe719da$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $8f2285b8ffe719da$var$Fh.current = null === a || null === a.memoizedState ? $8f2285b8ffe719da$var$Oh : $8f2285b8ffe719da$var$Ph;
    a = c(d, e);
    if ($8f2285b8ffe719da$var$Jh) {
        f = 0;
        do {
            $8f2285b8ffe719da$var$Jh = !1;
            $8f2285b8ffe719da$var$Kh = 0;
            if (25 <= f) throw Error($8f2285b8ffe719da$var$p(301));
            f += 1;
            $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$N = null;
            b.updateQueue = null;
            $8f2285b8ffe719da$var$Fh.current = $8f2285b8ffe719da$var$Qh;
            a = c(d, e);
        }while ($8f2285b8ffe719da$var$Jh);
    }
    $8f2285b8ffe719da$var$Fh.current = $8f2285b8ffe719da$var$Rh;
    b = null !== $8f2285b8ffe719da$var$N && null !== $8f2285b8ffe719da$var$N.next;
    $8f2285b8ffe719da$var$Hh = 0;
    $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$N = $8f2285b8ffe719da$var$M = null;
    $8f2285b8ffe719da$var$Ih = !1;
    if (b) throw Error($8f2285b8ffe719da$var$p(300));
    return a;
}
function $8f2285b8ffe719da$var$Sh() {
    var a = 0 !== $8f2285b8ffe719da$var$Kh;
    $8f2285b8ffe719da$var$Kh = 0;
    return a;
}
function $8f2285b8ffe719da$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8f2285b8ffe719da$var$O ? $8f2285b8ffe719da$var$M.memoizedState = $8f2285b8ffe719da$var$O = a : $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$O.next = a;
    return $8f2285b8ffe719da$var$O;
}
function $8f2285b8ffe719da$var$Uh() {
    if (null === $8f2285b8ffe719da$var$N) {
        var a = $8f2285b8ffe719da$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $8f2285b8ffe719da$var$N.next;
    var b = null === $8f2285b8ffe719da$var$O ? $8f2285b8ffe719da$var$M.memoizedState : $8f2285b8ffe719da$var$O.next;
    if (null !== b) $8f2285b8ffe719da$var$O = b, $8f2285b8ffe719da$var$N = a;
    else {
        if (null === a) throw Error($8f2285b8ffe719da$var$p(310));
        $8f2285b8ffe719da$var$N = a;
        a = {
            memoizedState: $8f2285b8ffe719da$var$N.memoizedState,
            baseState: $8f2285b8ffe719da$var$N.baseState,
            baseQueue: $8f2285b8ffe719da$var$N.baseQueue,
            queue: $8f2285b8ffe719da$var$N.queue,
            next: null
        };
        null === $8f2285b8ffe719da$var$O ? $8f2285b8ffe719da$var$M.memoizedState = $8f2285b8ffe719da$var$O = a : $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$O.next = a;
    }
    return $8f2285b8ffe719da$var$O;
}
function $8f2285b8ffe719da$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $8f2285b8ffe719da$var$Wh(a) {
    var b = $8f2285b8ffe719da$var$Uh(), c = b.queue;
    if (null === c) throw Error($8f2285b8ffe719da$var$p(311));
    c.lastRenderedReducer = a;
    var d = $8f2285b8ffe719da$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($8f2285b8ffe719da$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $8f2285b8ffe719da$var$M.lanes |= m;
                $8f2285b8ffe719da$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $8f2285b8ffe719da$var$He(d, b.memoizedState) || ($8f2285b8ffe719da$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $8f2285b8ffe719da$var$M.lanes |= f, $8f2285b8ffe719da$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $8f2285b8ffe719da$var$Xh(a) {
    var b = $8f2285b8ffe719da$var$Uh(), c = b.queue;
    if (null === c) throw Error($8f2285b8ffe719da$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $8f2285b8ffe719da$var$He(f, b.memoizedState) || ($8f2285b8ffe719da$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $8f2285b8ffe719da$var$Yh() {}
function $8f2285b8ffe719da$var$Zh(a, b) {
    var c = $8f2285b8ffe719da$var$M, d = $8f2285b8ffe719da$var$Uh(), e = b(), f = !$8f2285b8ffe719da$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $8f2285b8ffe719da$var$dh = !0);
    d = d.queue;
    $8f2285b8ffe719da$var$$h($8f2285b8ffe719da$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $8f2285b8ffe719da$var$O && $8f2285b8ffe719da$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $8f2285b8ffe719da$var$bi(9, $8f2285b8ffe719da$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $8f2285b8ffe719da$var$Q) throw Error($8f2285b8ffe719da$var$p(349));
        0 !== ($8f2285b8ffe719da$var$Hh & 30) || $8f2285b8ffe719da$var$di(c, b, e);
    }
    return e;
}
function $8f2285b8ffe719da$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $8f2285b8ffe719da$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8f2285b8ffe719da$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $8f2285b8ffe719da$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $8f2285b8ffe719da$var$ei(b) && $8f2285b8ffe719da$var$fi(a);
}
function $8f2285b8ffe719da$var$ai(a, b, c) {
    return c(function() {
        $8f2285b8ffe719da$var$ei(b) && $8f2285b8ffe719da$var$fi(a);
    });
}
function $8f2285b8ffe719da$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$8f2285b8ffe719da$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $8f2285b8ffe719da$var$fi(a) {
    var b = $8f2285b8ffe719da$var$ih(a, 1);
    null !== b && $8f2285b8ffe719da$var$gi(b, a, 1, -1);
}
function $8f2285b8ffe719da$var$hi(a) {
    var b = $8f2285b8ffe719da$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8f2285b8ffe719da$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $8f2285b8ffe719da$var$ii.bind(null, $8f2285b8ffe719da$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $8f2285b8ffe719da$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $8f2285b8ffe719da$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8f2285b8ffe719da$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $8f2285b8ffe719da$var$ji() {
    return $8f2285b8ffe719da$var$Uh().memoizedState;
}
function $8f2285b8ffe719da$var$ki(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$Th();
    $8f2285b8ffe719da$var$M.flags |= a;
    e.memoizedState = $8f2285b8ffe719da$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $8f2285b8ffe719da$var$li(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $8f2285b8ffe719da$var$N) {
        var g = $8f2285b8ffe719da$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $8f2285b8ffe719da$var$Mh(d, g.deps)) {
            e.memoizedState = $8f2285b8ffe719da$var$bi(b, c, f, d);
            return;
        }
    }
    $8f2285b8ffe719da$var$M.flags |= a;
    e.memoizedState = $8f2285b8ffe719da$var$bi(1 | b, c, f, d);
}
function $8f2285b8ffe719da$var$mi(a, b) {
    return $8f2285b8ffe719da$var$ki(8390656, 8, a, b);
}
function $8f2285b8ffe719da$var$$h(a, b) {
    return $8f2285b8ffe719da$var$li(2048, 8, a, b);
}
function $8f2285b8ffe719da$var$ni(a, b) {
    return $8f2285b8ffe719da$var$li(4, 2, a, b);
}
function $8f2285b8ffe719da$var$oi(a, b) {
    return $8f2285b8ffe719da$var$li(4, 4, a, b);
}
function $8f2285b8ffe719da$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $8f2285b8ffe719da$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $8f2285b8ffe719da$var$li(4, 4, $8f2285b8ffe719da$var$pi.bind(null, b, a), c);
}
function $8f2285b8ffe719da$var$ri() {}
function $8f2285b8ffe719da$var$si(a, b) {
    var c = $8f2285b8ffe719da$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8f2285b8ffe719da$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8f2285b8ffe719da$var$ti(a, b) {
    var c = $8f2285b8ffe719da$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8f2285b8ffe719da$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8f2285b8ffe719da$var$ui(a, b, c) {
    if (0 === ($8f2285b8ffe719da$var$Hh & 21)) return a.baseState && (a.baseState = !1, $8f2285b8ffe719da$var$dh = !0), a.memoizedState = c;
    $8f2285b8ffe719da$var$He(c, b) || (c = $8f2285b8ffe719da$var$yc(), $8f2285b8ffe719da$var$M.lanes |= c, $8f2285b8ffe719da$var$rh |= c, a.baseState = !0);
    return b;
}
function $8f2285b8ffe719da$var$vi(a, b) {
    var c = $8f2285b8ffe719da$var$C;
    $8f2285b8ffe719da$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $8f2285b8ffe719da$var$Gh.transition;
    $8f2285b8ffe719da$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $8f2285b8ffe719da$var$C = c, $8f2285b8ffe719da$var$Gh.transition = d;
    }
}
function $8f2285b8ffe719da$var$wi() {
    return $8f2285b8ffe719da$var$Uh().memoizedState;
}
function $8f2285b8ffe719da$var$xi(a, b, c) {
    var d = $8f2285b8ffe719da$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8f2285b8ffe719da$var$zi(a)) $8f2285b8ffe719da$var$Ai(b, c);
    else if (c = $8f2285b8ffe719da$var$hh(a, b, c, d), null !== c) {
        var e = $8f2285b8ffe719da$var$R();
        $8f2285b8ffe719da$var$gi(c, a, d, e);
        $8f2285b8ffe719da$var$Bi(c, b, d);
    }
}
function $8f2285b8ffe719da$var$ii(a, b, c) {
    var d = $8f2285b8ffe719da$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8f2285b8ffe719da$var$zi(a)) $8f2285b8ffe719da$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($8f2285b8ffe719da$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $8f2285b8ffe719da$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $8f2285b8ffe719da$var$hh(a, b, e, d);
        null !== c && (e = $8f2285b8ffe719da$var$R(), $8f2285b8ffe719da$var$gi(c, a, d, e), $8f2285b8ffe719da$var$Bi(c, b, d));
    }
}
function $8f2285b8ffe719da$var$zi(a) {
    var b = a.alternate;
    return a === $8f2285b8ffe719da$var$M || null !== b && b === $8f2285b8ffe719da$var$M;
}
function $8f2285b8ffe719da$var$Ai(a, b) {
    $8f2285b8ffe719da$var$Jh = $8f2285b8ffe719da$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $8f2285b8ffe719da$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8f2285b8ffe719da$var$Cc(a, c);
    }
}
var $8f2285b8ffe719da$var$Rh = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: $8f2285b8ffe719da$var$P,
    useContext: $8f2285b8ffe719da$var$P,
    useEffect: $8f2285b8ffe719da$var$P,
    useImperativeHandle: $8f2285b8ffe719da$var$P,
    useInsertionEffect: $8f2285b8ffe719da$var$P,
    useLayoutEffect: $8f2285b8ffe719da$var$P,
    useMemo: $8f2285b8ffe719da$var$P,
    useReducer: $8f2285b8ffe719da$var$P,
    useRef: $8f2285b8ffe719da$var$P,
    useState: $8f2285b8ffe719da$var$P,
    useDebugValue: $8f2285b8ffe719da$var$P,
    useDeferredValue: $8f2285b8ffe719da$var$P,
    useTransition: $8f2285b8ffe719da$var$P,
    useMutableSource: $8f2285b8ffe719da$var$P,
    useSyncExternalStore: $8f2285b8ffe719da$var$P,
    useId: $8f2285b8ffe719da$var$P,
    unstable_isNewReconciler: !1
}, $8f2285b8ffe719da$var$Oh = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: function(a, b) {
        $8f2285b8ffe719da$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $8f2285b8ffe719da$var$eh,
    useEffect: $8f2285b8ffe719da$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $8f2285b8ffe719da$var$ki(4194308, 4, $8f2285b8ffe719da$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $8f2285b8ffe719da$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $8f2285b8ffe719da$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $8f2285b8ffe719da$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $8f2285b8ffe719da$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $8f2285b8ffe719da$var$xi.bind(null, $8f2285b8ffe719da$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $8f2285b8ffe719da$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $8f2285b8ffe719da$var$hi,
    useDebugValue: $8f2285b8ffe719da$var$ri,
    useDeferredValue: function(a) {
        return $8f2285b8ffe719da$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $8f2285b8ffe719da$var$hi(!1), b = a[0];
        a = $8f2285b8ffe719da$var$vi.bind(null, a[1]);
        $8f2285b8ffe719da$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $8f2285b8ffe719da$var$M, e = $8f2285b8ffe719da$var$Th();
        if ($8f2285b8ffe719da$var$I) {
            if (void 0 === c) throw Error($8f2285b8ffe719da$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $8f2285b8ffe719da$var$Q) throw Error($8f2285b8ffe719da$var$p(349));
            0 !== ($8f2285b8ffe719da$var$Hh & 30) || $8f2285b8ffe719da$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $8f2285b8ffe719da$var$mi($8f2285b8ffe719da$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $8f2285b8ffe719da$var$bi(9, $8f2285b8ffe719da$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $8f2285b8ffe719da$var$Th(), b = $8f2285b8ffe719da$var$Q.identifierPrefix;
        if ($8f2285b8ffe719da$var$I) {
            var c = $8f2285b8ffe719da$var$sg;
            var d = $8f2285b8ffe719da$var$rg;
            c = (d & ~(1 << 32 - $8f2285b8ffe719da$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $8f2285b8ffe719da$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $8f2285b8ffe719da$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $8f2285b8ffe719da$var$Ph = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: $8f2285b8ffe719da$var$si,
    useContext: $8f2285b8ffe719da$var$eh,
    useEffect: $8f2285b8ffe719da$var$$h,
    useImperativeHandle: $8f2285b8ffe719da$var$qi,
    useInsertionEffect: $8f2285b8ffe719da$var$ni,
    useLayoutEffect: $8f2285b8ffe719da$var$oi,
    useMemo: $8f2285b8ffe719da$var$ti,
    useReducer: $8f2285b8ffe719da$var$Wh,
    useRef: $8f2285b8ffe719da$var$ji,
    useState: function() {
        return $8f2285b8ffe719da$var$Wh($8f2285b8ffe719da$var$Vh);
    },
    useDebugValue: $8f2285b8ffe719da$var$ri,
    useDeferredValue: function(a) {
        var b = $8f2285b8ffe719da$var$Uh();
        return $8f2285b8ffe719da$var$ui(b, $8f2285b8ffe719da$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8f2285b8ffe719da$var$Wh($8f2285b8ffe719da$var$Vh)[0], b = $8f2285b8ffe719da$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8f2285b8ffe719da$var$Yh,
    useSyncExternalStore: $8f2285b8ffe719da$var$Zh,
    useId: $8f2285b8ffe719da$var$wi,
    unstable_isNewReconciler: !1
}, $8f2285b8ffe719da$var$Qh = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: $8f2285b8ffe719da$var$si,
    useContext: $8f2285b8ffe719da$var$eh,
    useEffect: $8f2285b8ffe719da$var$$h,
    useImperativeHandle: $8f2285b8ffe719da$var$qi,
    useInsertionEffect: $8f2285b8ffe719da$var$ni,
    useLayoutEffect: $8f2285b8ffe719da$var$oi,
    useMemo: $8f2285b8ffe719da$var$ti,
    useReducer: $8f2285b8ffe719da$var$Xh,
    useRef: $8f2285b8ffe719da$var$ji,
    useState: function() {
        return $8f2285b8ffe719da$var$Xh($8f2285b8ffe719da$var$Vh);
    },
    useDebugValue: $8f2285b8ffe719da$var$ri,
    useDeferredValue: function(a) {
        var b = $8f2285b8ffe719da$var$Uh();
        return null === $8f2285b8ffe719da$var$N ? b.memoizedState = a : $8f2285b8ffe719da$var$ui(b, $8f2285b8ffe719da$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8f2285b8ffe719da$var$Xh($8f2285b8ffe719da$var$Vh)[0], b = $8f2285b8ffe719da$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8f2285b8ffe719da$var$Yh,
    useSyncExternalStore: $8f2285b8ffe719da$var$Zh,
    useId: $8f2285b8ffe719da$var$wi,
    unstable_isNewReconciler: !1
};
function $8f2285b8ffe719da$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $8f2285b8ffe719da$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $8f2285b8ffe719da$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8f2285b8ffe719da$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $8f2285b8ffe719da$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $8f2285b8ffe719da$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8f2285b8ffe719da$var$R(), e = $8f2285b8ffe719da$var$yi(a), f = $8f2285b8ffe719da$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8f2285b8ffe719da$var$nh(a, f, e);
        null !== b && ($8f2285b8ffe719da$var$gi(b, a, e, d), $8f2285b8ffe719da$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8f2285b8ffe719da$var$R(), e = $8f2285b8ffe719da$var$yi(a), f = $8f2285b8ffe719da$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8f2285b8ffe719da$var$nh(a, f, e);
        null !== b && ($8f2285b8ffe719da$var$gi(b, a, e, d), $8f2285b8ffe719da$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $8f2285b8ffe719da$var$R(), d = $8f2285b8ffe719da$var$yi(a), e = $8f2285b8ffe719da$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $8f2285b8ffe719da$var$nh(a, e, d);
        null !== b && ($8f2285b8ffe719da$var$gi(b, a, d, c), $8f2285b8ffe719da$var$oh(b, a, d));
    }
};
function $8f2285b8ffe719da$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$8f2285b8ffe719da$var$Ie(c, d) || !$8f2285b8ffe719da$var$Ie(e, f) : !0;
}
function $8f2285b8ffe719da$var$Gi(a, b, c) {
    var d = !1, e = $8f2285b8ffe719da$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $8f2285b8ffe719da$var$eh(f) : (e = $8f2285b8ffe719da$var$Zf(b) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $8f2285b8ffe719da$var$Yf(a, e) : $8f2285b8ffe719da$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $8f2285b8ffe719da$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $8f2285b8ffe719da$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $8f2285b8ffe719da$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $8f2285b8ffe719da$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $8f2285b8ffe719da$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $8f2285b8ffe719da$var$eh(f) : (f = $8f2285b8ffe719da$var$Zf(b) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, e.context = $8f2285b8ffe719da$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($8f2285b8ffe719da$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $8f2285b8ffe719da$var$Ei.enqueueReplaceState(e, e.state, null), $8f2285b8ffe719da$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $8f2285b8ffe719da$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $8f2285b8ffe719da$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $8f2285b8ffe719da$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $8f2285b8ffe719da$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $8f2285b8ffe719da$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $8f2285b8ffe719da$var$Ni(a, b, c) {
    c = $8f2285b8ffe719da$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $8f2285b8ffe719da$var$Oi || ($8f2285b8ffe719da$var$Oi = !0, $8f2285b8ffe719da$var$Pi = d);
        $8f2285b8ffe719da$var$Li(a, b);
    };
    return c;
}
function $8f2285b8ffe719da$var$Qi(a, b, c) {
    c = $8f2285b8ffe719da$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $8f2285b8ffe719da$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $8f2285b8ffe719da$var$Li(a, b);
        "function" !== typeof d && (null === $8f2285b8ffe719da$var$Ri ? $8f2285b8ffe719da$var$Ri = new Set([
            this
        ]) : $8f2285b8ffe719da$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $8f2285b8ffe719da$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $8f2285b8ffe719da$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $8f2285b8ffe719da$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $8f2285b8ffe719da$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $8f2285b8ffe719da$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $8f2285b8ffe719da$var$mh(-1, 1), b.tag = 2, $8f2285b8ffe719da$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $8f2285b8ffe719da$var$Wi = $8f2285b8ffe719da$var$ua.ReactCurrentOwner, $8f2285b8ffe719da$var$dh = !1;
function $8f2285b8ffe719da$var$Xi(a, b, c, d) {
    b.child = null === a ? $8f2285b8ffe719da$var$Vg(b, null, c, d) : $8f2285b8ffe719da$var$Ug(b, a.child, c, d);
}
function $8f2285b8ffe719da$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $8f2285b8ffe719da$var$ch(b, e);
    d = $8f2285b8ffe719da$var$Nh(a, b, c, d, f, e);
    c = $8f2285b8ffe719da$var$Sh();
    if (null !== a && !$8f2285b8ffe719da$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8f2285b8ffe719da$var$Zi(a, b, e);
    $8f2285b8ffe719da$var$I && c && $8f2285b8ffe719da$var$vg(b);
    b.flags |= 1;
    $8f2285b8ffe719da$var$Xi(a, b, d, e);
    return b.child;
}
function $8f2285b8ffe719da$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$8f2285b8ffe719da$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $8f2285b8ffe719da$var$bj(a, b, f, d, e);
        a = $8f2285b8ffe719da$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $8f2285b8ffe719da$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $8f2285b8ffe719da$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $8f2285b8ffe719da$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $8f2285b8ffe719da$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($8f2285b8ffe719da$var$Ie(f, d) && a.ref === b.ref) {
            if ($8f2285b8ffe719da$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($8f2285b8ffe719da$var$dh = !0);
            else return b.lanes = a.lanes, $8f2285b8ffe719da$var$Zi(a, b, e);
        }
    }
    return $8f2285b8ffe719da$var$cj(a, b, c, d, e);
}
function $8f2285b8ffe719da$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj), $8f2285b8ffe719da$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj), $8f2285b8ffe719da$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj);
            $8f2285b8ffe719da$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj), $8f2285b8ffe719da$var$fj |= d;
    $8f2285b8ffe719da$var$Xi(a, b, e, c);
    return b.child;
}
function $8f2285b8ffe719da$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $8f2285b8ffe719da$var$cj(a, b, c, d, e) {
    var f = $8f2285b8ffe719da$var$Zf(c) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current;
    f = $8f2285b8ffe719da$var$Yf(b, f);
    $8f2285b8ffe719da$var$ch(b, e);
    c = $8f2285b8ffe719da$var$Nh(a, b, c, d, f, e);
    d = $8f2285b8ffe719da$var$Sh();
    if (null !== a && !$8f2285b8ffe719da$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8f2285b8ffe719da$var$Zi(a, b, e);
    $8f2285b8ffe719da$var$I && d && $8f2285b8ffe719da$var$vg(b);
    b.flags |= 1;
    $8f2285b8ffe719da$var$Xi(a, b, c, e);
    return b.child;
}
function $8f2285b8ffe719da$var$hj(a, b, c, d, e) {
    if ($8f2285b8ffe719da$var$Zf(c)) {
        var f = !0;
        $8f2285b8ffe719da$var$cg(b);
    } else f = !1;
    $8f2285b8ffe719da$var$ch(b, e);
    if (null === b.stateNode) $8f2285b8ffe719da$var$ij(a, b), $8f2285b8ffe719da$var$Gi(b, c, d), $8f2285b8ffe719da$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $8f2285b8ffe719da$var$eh(l) : (l = $8f2285b8ffe719da$var$Zf(c) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, l = $8f2285b8ffe719da$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $8f2285b8ffe719da$var$Hi(b, g, d, l);
        $8f2285b8ffe719da$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $8f2285b8ffe719da$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $8f2285b8ffe719da$var$Wf.current || $8f2285b8ffe719da$var$jh ? ("function" === typeof m && ($8f2285b8ffe719da$var$Di(b, c, m, d), k = b.memoizedState), (h = $8f2285b8ffe719da$var$jh || $8f2285b8ffe719da$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $8f2285b8ffe719da$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $8f2285b8ffe719da$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $8f2285b8ffe719da$var$eh(k) : (k = $8f2285b8ffe719da$var$Zf(c) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, k = $8f2285b8ffe719da$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $8f2285b8ffe719da$var$Hi(b, g, d, k);
        $8f2285b8ffe719da$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $8f2285b8ffe719da$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $8f2285b8ffe719da$var$Wf.current || $8f2285b8ffe719da$var$jh ? ("function" === typeof y && ($8f2285b8ffe719da$var$Di(b, c, y, d), n = b.memoizedState), (l = $8f2285b8ffe719da$var$jh || $8f2285b8ffe719da$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $8f2285b8ffe719da$var$jj(a, b, c, d, f, e);
}
function $8f2285b8ffe719da$var$jj(a, b, c, d, e, f) {
    $8f2285b8ffe719da$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $8f2285b8ffe719da$var$dg(b, c, !1), $8f2285b8ffe719da$var$Zi(a, b, f);
    d = b.stateNode;
    $8f2285b8ffe719da$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $8f2285b8ffe719da$var$Ug(b, a.child, null, f), b.child = $8f2285b8ffe719da$var$Ug(b, null, h, f)) : $8f2285b8ffe719da$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $8f2285b8ffe719da$var$dg(b, c, !0);
    return b.child;
}
function $8f2285b8ffe719da$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $8f2285b8ffe719da$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $8f2285b8ffe719da$var$ag(a, b.context, !1);
    $8f2285b8ffe719da$var$yh(a, b.containerInfo);
}
function $8f2285b8ffe719da$var$lj(a, b, c, d, e) {
    $8f2285b8ffe719da$var$Ig();
    $8f2285b8ffe719da$var$Jg(e);
    b.flags |= 256;
    $8f2285b8ffe719da$var$Xi(a, b, c, d);
    return b.child;
}
var $8f2285b8ffe719da$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $8f2285b8ffe719da$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $8f2285b8ffe719da$var$oj(a, b, c) {
    var d = b.pendingProps, e = $8f2285b8ffe719da$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, e & 1);
    if (null === a) {
        $8f2285b8ffe719da$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $8f2285b8ffe719da$var$pj(g, d, 0, null), a = $8f2285b8ffe719da$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $8f2285b8ffe719da$var$nj(c), b.memoizedState = $8f2285b8ffe719da$var$mj, a) : $8f2285b8ffe719da$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $8f2285b8ffe719da$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $8f2285b8ffe719da$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $8f2285b8ffe719da$var$Pg(h, f) : (f = $8f2285b8ffe719da$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $8f2285b8ffe719da$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $8f2285b8ffe719da$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $8f2285b8ffe719da$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $8f2285b8ffe719da$var$qj(a, b) {
    b = $8f2285b8ffe719da$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $8f2285b8ffe719da$var$sj(a, b, c, d) {
    null !== d && $8f2285b8ffe719da$var$Jg(d);
    $8f2285b8ffe719da$var$Ug(b, a.child, null, c);
    a = $8f2285b8ffe719da$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $8f2285b8ffe719da$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $8f2285b8ffe719da$var$Ki(Error($8f2285b8ffe719da$var$p(422))), $8f2285b8ffe719da$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $8f2285b8ffe719da$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $8f2285b8ffe719da$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $8f2285b8ffe719da$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $8f2285b8ffe719da$var$nj(g);
        b.memoizedState = $8f2285b8ffe719da$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $8f2285b8ffe719da$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($8f2285b8ffe719da$var$p(419));
        d = $8f2285b8ffe719da$var$Ki(f, d, void 0);
        return $8f2285b8ffe719da$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($8f2285b8ffe719da$var$dh || h) {
        d = $8f2285b8ffe719da$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $8f2285b8ffe719da$var$ih(a, e), $8f2285b8ffe719da$var$gi(d, a, e, -1));
        }
        $8f2285b8ffe719da$var$tj();
        d = $8f2285b8ffe719da$var$Ki(Error($8f2285b8ffe719da$var$p(421)));
        return $8f2285b8ffe719da$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $8f2285b8ffe719da$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(e.nextSibling);
    $8f2285b8ffe719da$var$xg = b;
    $8f2285b8ffe719da$var$I = !0;
    $8f2285b8ffe719da$var$zg = null;
    null !== a && ($8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$rg, $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$sg, $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$qg, $8f2285b8ffe719da$var$rg = a.id, $8f2285b8ffe719da$var$sg = a.overflow, $8f2285b8ffe719da$var$qg = b);
    b = $8f2285b8ffe719da$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $8f2285b8ffe719da$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $8f2285b8ffe719da$var$bh(a.return, b, c);
}
function $8f2285b8ffe719da$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $8f2285b8ffe719da$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $8f2285b8ffe719da$var$Xi(a, b, d.children, c);
    d = $8f2285b8ffe719da$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $8f2285b8ffe719da$var$vj(a, c, b);
            else if (19 === a.tag) $8f2285b8ffe719da$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $8f2285b8ffe719da$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $8f2285b8ffe719da$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $8f2285b8ffe719da$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $8f2285b8ffe719da$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $8f2285b8ffe719da$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $8f2285b8ffe719da$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $8f2285b8ffe719da$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $8f2285b8ffe719da$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($8f2285b8ffe719da$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $8f2285b8ffe719da$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $8f2285b8ffe719da$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $8f2285b8ffe719da$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $8f2285b8ffe719da$var$kj(b);
            $8f2285b8ffe719da$var$Ig();
            break;
        case 5:
            $8f2285b8ffe719da$var$Ah(b);
            break;
        case 1:
            $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$cg(b);
            break;
        case 4:
            $8f2285b8ffe719da$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $8f2285b8ffe719da$var$oj(a, b, c);
                $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1);
                a = $8f2285b8ffe719da$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $8f2285b8ffe719da$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $8f2285b8ffe719da$var$dj(a, b, c);
    }
    return $8f2285b8ffe719da$var$Zi(a, b, c);
}
var $8f2285b8ffe719da$var$zj, $8f2285b8ffe719da$var$Aj, $8f2285b8ffe719da$var$Bj, $8f2285b8ffe719da$var$Cj;
$8f2285b8ffe719da$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$8f2285b8ffe719da$var$Aj = function() {};
$8f2285b8ffe719da$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $8f2285b8ffe719da$var$Ya(a, e);
                d = $8f2285b8ffe719da$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $8f2285b8ffe719da$var$A({}, e, {
                    value: void 0
                });
                d = $8f2285b8ffe719da$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $8f2285b8ffe719da$var$gb(a, e);
                d = $8f2285b8ffe719da$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $8f2285b8ffe719da$var$Bf);
        }
        $8f2285b8ffe719da$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($8f2285b8ffe719da$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($8f2285b8ffe719da$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $8f2285b8ffe719da$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$8f2285b8ffe719da$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $8f2285b8ffe719da$var$Dj(a, b) {
    if (!$8f2285b8ffe719da$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $8f2285b8ffe719da$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $8f2285b8ffe719da$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $8f2285b8ffe719da$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8f2285b8ffe719da$var$S(b), null;
        case 1:
            return $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$$f(), $8f2285b8ffe719da$var$S(b), null;
        case 3:
            d = b.stateNode;
            $8f2285b8ffe719da$var$zh();
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H);
            $8f2285b8ffe719da$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $8f2285b8ffe719da$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $8f2285b8ffe719da$var$zg && ($8f2285b8ffe719da$var$Fj($8f2285b8ffe719da$var$zg), $8f2285b8ffe719da$var$zg = null));
            $8f2285b8ffe719da$var$Aj(a, b);
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 5:
            $8f2285b8ffe719da$var$Bh(b);
            var e = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $8f2285b8ffe719da$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($8f2285b8ffe719da$var$p(166));
                    $8f2285b8ffe719da$var$S(b);
                    return null;
                }
                a = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
                if ($8f2285b8ffe719da$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$8f2285b8ffe719da$var$Of] = b;
                    d[$8f2285b8ffe719da$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $8f2285b8ffe719da$var$D("cancel", d);
                            $8f2285b8ffe719da$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $8f2285b8ffe719da$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $8f2285b8ffe719da$var$lf.length; e++)$8f2285b8ffe719da$var$D($8f2285b8ffe719da$var$lf[e], d);
                            break;
                        case "source":
                            $8f2285b8ffe719da$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $8f2285b8ffe719da$var$D("error", d);
                            $8f2285b8ffe719da$var$D("load", d);
                            break;
                        case "details":
                            $8f2285b8ffe719da$var$D("toggle", d);
                            break;
                        case "input":
                            $8f2285b8ffe719da$var$Za(d, f);
                            $8f2285b8ffe719da$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $8f2285b8ffe719da$var$D("invalid", d);
                            break;
                        case "textarea":
                            $8f2285b8ffe719da$var$hb(d, f), $8f2285b8ffe719da$var$D("invalid", d);
                    }
                    $8f2285b8ffe719da$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $8f2285b8ffe719da$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $8f2285b8ffe719da$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $8f2285b8ffe719da$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $8f2285b8ffe719da$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $8f2285b8ffe719da$var$Va(d);
                            $8f2285b8ffe719da$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $8f2285b8ffe719da$var$Va(d);
                            $8f2285b8ffe719da$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $8f2285b8ffe719da$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $8f2285b8ffe719da$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$8f2285b8ffe719da$var$Of] = b;
                    a[$8f2285b8ffe719da$var$Pf] = d;
                    $8f2285b8ffe719da$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $8f2285b8ffe719da$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $8f2285b8ffe719da$var$D("cancel", a);
                                $8f2285b8ffe719da$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $8f2285b8ffe719da$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $8f2285b8ffe719da$var$lf.length; e++)$8f2285b8ffe719da$var$D($8f2285b8ffe719da$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $8f2285b8ffe719da$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $8f2285b8ffe719da$var$D("error", a);
                                $8f2285b8ffe719da$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $8f2285b8ffe719da$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $8f2285b8ffe719da$var$Za(a, d);
                                e = $8f2285b8ffe719da$var$Ya(a, d);
                                $8f2285b8ffe719da$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $8f2285b8ffe719da$var$A({}, d, {
                                    value: void 0
                                });
                                $8f2285b8ffe719da$var$D("invalid", a);
                                break;
                            case "textarea":
                                $8f2285b8ffe719da$var$hb(a, d);
                                e = $8f2285b8ffe719da$var$gb(a, d);
                                $8f2285b8ffe719da$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $8f2285b8ffe719da$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $8f2285b8ffe719da$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $8f2285b8ffe719da$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $8f2285b8ffe719da$var$ob(a, k) : "number" === typeof k && $8f2285b8ffe719da$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($8f2285b8ffe719da$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $8f2285b8ffe719da$var$D("scroll", a) : null != k && $8f2285b8ffe719da$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $8f2285b8ffe719da$var$Va(a);
                                $8f2285b8ffe719da$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $8f2285b8ffe719da$var$Va(a);
                                $8f2285b8ffe719da$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $8f2285b8ffe719da$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $8f2285b8ffe719da$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $8f2285b8ffe719da$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $8f2285b8ffe719da$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $8f2285b8ffe719da$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($8f2285b8ffe719da$var$p(166));
                c = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$wh.current);
                $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
                if ($8f2285b8ffe719da$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$8f2285b8ffe719da$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $8f2285b8ffe719da$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $8f2285b8ffe719da$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $8f2285b8ffe719da$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$8f2285b8ffe719da$var$Of] = b, b.stateNode = d;
            }
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 13:
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($8f2285b8ffe719da$var$I && null !== $8f2285b8ffe719da$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $8f2285b8ffe719da$var$Hg(), $8f2285b8ffe719da$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $8f2285b8ffe719da$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($8f2285b8ffe719da$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($8f2285b8ffe719da$var$p(317));
                        f[$8f2285b8ffe719da$var$Of] = b;
                    } else $8f2285b8ffe719da$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $8f2285b8ffe719da$var$S(b);
                    f = !1;
                } else null !== $8f2285b8ffe719da$var$zg && ($8f2285b8ffe719da$var$Fj($8f2285b8ffe719da$var$zg), $8f2285b8ffe719da$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($8f2285b8ffe719da$var$L.current & 1) ? 0 === $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$T = 3) : $8f2285b8ffe719da$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 4:
            return $8f2285b8ffe719da$var$zh(), $8f2285b8ffe719da$var$Aj(a, b), null === a && $8f2285b8ffe719da$var$sf(b.stateNode.containerInfo), $8f2285b8ffe719da$var$S(b), null;
        case 10:
            return $8f2285b8ffe719da$var$ah(b.type._context), $8f2285b8ffe719da$var$S(b), null;
        case 17:
            return $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$$f(), $8f2285b8ffe719da$var$S(b), null;
        case 19:
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
            f = b.memoizedState;
            if (null === f) return $8f2285b8ffe719da$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $8f2285b8ffe719da$var$Dj(f, !1);
                else {
                    if (0 !== $8f2285b8ffe719da$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $8f2285b8ffe719da$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $8f2285b8ffe719da$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $8f2285b8ffe719da$var$B() > $8f2285b8ffe719da$var$Gj && (b.flags |= 128, d = !0, $8f2285b8ffe719da$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $8f2285b8ffe719da$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $8f2285b8ffe719da$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$8f2285b8ffe719da$var$I) return $8f2285b8ffe719da$var$S(b), null;
                    } else 2 * $8f2285b8ffe719da$var$B() - f.renderingStartTime > $8f2285b8ffe719da$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $8f2285b8ffe719da$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $8f2285b8ffe719da$var$B(), b.sibling = null, c = $8f2285b8ffe719da$var$L.current, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, d ? c & 1 | 2 : c & 1), b;
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 22:
        case 23:
            return $8f2285b8ffe719da$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($8f2285b8ffe719da$var$fj & 1073741824) && ($8f2285b8ffe719da$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $8f2285b8ffe719da$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($8f2285b8ffe719da$var$p(156, b.tag));
}
function $8f2285b8ffe719da$var$Ij(a, b) {
    $8f2285b8ffe719da$var$wg(b);
    switch(b.tag){
        case 1:
            return $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $8f2285b8ffe719da$var$zh(), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H), $8f2285b8ffe719da$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $8f2285b8ffe719da$var$Bh(b), null;
        case 13:
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($8f2285b8ffe719da$var$p(340));
                $8f2285b8ffe719da$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L), null;
        case 4:
            return $8f2285b8ffe719da$var$zh(), null;
        case 10:
            return $8f2285b8ffe719da$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $8f2285b8ffe719da$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $8f2285b8ffe719da$var$Jj = !1, $8f2285b8ffe719da$var$U = !1, $8f2285b8ffe719da$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $8f2285b8ffe719da$var$V = null;
function $8f2285b8ffe719da$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $8f2285b8ffe719da$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $8f2285b8ffe719da$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $8f2285b8ffe719da$var$W(a, b, d);
    }
}
var $8f2285b8ffe719da$var$Nj = !1;
function $8f2285b8ffe719da$var$Oj(a, b) {
    $8f2285b8ffe719da$var$Cf = $8f2285b8ffe719da$var$dd;
    a = $8f2285b8ffe719da$var$Me();
    if ($8f2285b8ffe719da$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $8f2285b8ffe719da$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $8f2285b8ffe719da$var$dd = !1;
    for($8f2285b8ffe719da$var$V = b; null !== $8f2285b8ffe719da$var$V;)if (b = $8f2285b8ffe719da$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $8f2285b8ffe719da$var$V = a;
    else for(; null !== $8f2285b8ffe719da$var$V;){
        b = $8f2285b8ffe719da$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $8f2285b8ffe719da$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($8f2285b8ffe719da$var$p(163));
            }
        } catch (F) {
            $8f2285b8ffe719da$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $8f2285b8ffe719da$var$V = a;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
    n = $8f2285b8ffe719da$var$Nj;
    $8f2285b8ffe719da$var$Nj = !1;
    return n;
}
function $8f2285b8ffe719da$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $8f2285b8ffe719da$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $8f2285b8ffe719da$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $8f2285b8ffe719da$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $8f2285b8ffe719da$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $8f2285b8ffe719da$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$8f2285b8ffe719da$var$Of], delete b[$8f2285b8ffe719da$var$Pf], delete b[$8f2285b8ffe719da$var$of], delete b[$8f2285b8ffe719da$var$Qf], delete b[$8f2285b8ffe719da$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $8f2285b8ffe719da$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $8f2285b8ffe719da$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $8f2285b8ffe719da$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $8f2285b8ffe719da$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $8f2285b8ffe719da$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($8f2285b8ffe719da$var$Vj(a, b, c), a = a.sibling; null !== a;)$8f2285b8ffe719da$var$Vj(a, b, c), a = a.sibling;
}
function $8f2285b8ffe719da$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($8f2285b8ffe719da$var$Wj(a, b, c), a = a.sibling; null !== a;)$8f2285b8ffe719da$var$Wj(a, b, c), a = a.sibling;
}
var $8f2285b8ffe719da$var$X = null, $8f2285b8ffe719da$var$Xj = !1;
function $8f2285b8ffe719da$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$8f2285b8ffe719da$var$Zj(a, b, c), c = c.sibling;
}
function $8f2285b8ffe719da$var$Zj(a, b, c) {
    if ($8f2285b8ffe719da$var$lc && "function" === typeof $8f2285b8ffe719da$var$lc.onCommitFiberUnmount) try {
        $8f2285b8ffe719da$var$lc.onCommitFiberUnmount($8f2285b8ffe719da$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $8f2285b8ffe719da$var$U || $8f2285b8ffe719da$var$Lj(c, b);
        case 6:
            var d = $8f2285b8ffe719da$var$X, e = $8f2285b8ffe719da$var$Xj;
            $8f2285b8ffe719da$var$X = null;
            $8f2285b8ffe719da$var$Yj(a, b, c);
            $8f2285b8ffe719da$var$X = d;
            $8f2285b8ffe719da$var$Xj = e;
            null !== $8f2285b8ffe719da$var$X && ($8f2285b8ffe719da$var$Xj ? (a = $8f2285b8ffe719da$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $8f2285b8ffe719da$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $8f2285b8ffe719da$var$X && ($8f2285b8ffe719da$var$Xj ? (a = $8f2285b8ffe719da$var$X, c = c.stateNode, 8 === a.nodeType ? $8f2285b8ffe719da$var$Kf(a.parentNode, c) : 1 === a.nodeType && $8f2285b8ffe719da$var$Kf(a, c), $8f2285b8ffe719da$var$bd(a)) : $8f2285b8ffe719da$var$Kf($8f2285b8ffe719da$var$X, c.stateNode));
            break;
        case 4:
            d = $8f2285b8ffe719da$var$X;
            e = $8f2285b8ffe719da$var$Xj;
            $8f2285b8ffe719da$var$X = c.stateNode.containerInfo;
            $8f2285b8ffe719da$var$Xj = !0;
            $8f2285b8ffe719da$var$Yj(a, b, c);
            $8f2285b8ffe719da$var$X = d;
            $8f2285b8ffe719da$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$8f2285b8ffe719da$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $8f2285b8ffe719da$var$Mj(c, b, g) : 0 !== (f & 4) && $8f2285b8ffe719da$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        case 1:
            if (!$8f2285b8ffe719da$var$U && ($8f2285b8ffe719da$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $8f2285b8ffe719da$var$W(c, b, h);
            }
            $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        case 21:
            $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($8f2285b8ffe719da$var$U = (d = $8f2285b8ffe719da$var$U) || null !== c.memoizedState, $8f2285b8ffe719da$var$Yj(a, b, c), $8f2285b8ffe719da$var$U = d) : $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        default:
            $8f2285b8ffe719da$var$Yj(a, b, c);
    }
}
function $8f2285b8ffe719da$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $8f2285b8ffe719da$var$Kj);
        b.forEach(function(b) {
            var d = $8f2285b8ffe719da$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $8f2285b8ffe719da$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $8f2285b8ffe719da$var$X = h.stateNode;
                        $8f2285b8ffe719da$var$Xj = !1;
                        break a;
                    case 3:
                        $8f2285b8ffe719da$var$X = h.stateNode.containerInfo;
                        $8f2285b8ffe719da$var$Xj = !0;
                        break a;
                    case 4:
                        $8f2285b8ffe719da$var$X = h.stateNode.containerInfo;
                        $8f2285b8ffe719da$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $8f2285b8ffe719da$var$X) throw Error($8f2285b8ffe719da$var$p(160));
            $8f2285b8ffe719da$var$Zj(f, g, e);
            $8f2285b8ffe719da$var$X = null;
            $8f2285b8ffe719da$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $8f2285b8ffe719da$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$8f2285b8ffe719da$var$dk(b, a), b = b.sibling;
}
function $8f2285b8ffe719da$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 4) {
                try {
                    $8f2285b8ffe719da$var$Pj(3, a, a.return), $8f2285b8ffe719da$var$Qj(3, a);
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
                try {
                    $8f2285b8ffe719da$var$Pj(5, a, a.return);
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            d & 512 && null !== c && $8f2285b8ffe719da$var$Lj(c, c.return);
            break;
        case 5:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            d & 512 && null !== c && $8f2285b8ffe719da$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $8f2285b8ffe719da$var$ob(e, "");
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $8f2285b8ffe719da$var$ab(e, f);
                    $8f2285b8ffe719da$var$vb(h, g);
                    var l = $8f2285b8ffe719da$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $8f2285b8ffe719da$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $8f2285b8ffe719da$var$nb(e, q) : "children" === m ? $8f2285b8ffe719da$var$ob(e, q) : $8f2285b8ffe719da$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $8f2285b8ffe719da$var$bb(e, f);
                            break;
                        case "textarea":
                            $8f2285b8ffe719da$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $8f2285b8ffe719da$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $8f2285b8ffe719da$var$fb(e, !!f.multiple, f.defaultValue, !0) : $8f2285b8ffe719da$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$8f2285b8ffe719da$var$Pf] = f;
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($8f2285b8ffe719da$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $8f2285b8ffe719da$var$bd(b.containerInfo);
            } catch (t) {
                $8f2285b8ffe719da$var$W(a, a.return, t);
            }
            break;
        case 4:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            break;
        case 13:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($8f2285b8ffe719da$var$fk = $8f2285b8ffe719da$var$B()));
            d & 4 && $8f2285b8ffe719da$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($8f2285b8ffe719da$var$U = (l = $8f2285b8ffe719da$var$U) || m, $8f2285b8ffe719da$var$ck(b, a), $8f2285b8ffe719da$var$U = l) : $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($8f2285b8ffe719da$var$V = a, m = a.child; null !== m;){
                    for(q = $8f2285b8ffe719da$var$V = m; null !== $8f2285b8ffe719da$var$V;){
                        r = $8f2285b8ffe719da$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $8f2285b8ffe719da$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $8f2285b8ffe719da$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $8f2285b8ffe719da$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $8f2285b8ffe719da$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $8f2285b8ffe719da$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $8f2285b8ffe719da$var$V = y) : $8f2285b8ffe719da$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $8f2285b8ffe719da$var$rb("display", g));
                            } catch (t) {
                                $8f2285b8ffe719da$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $8f2285b8ffe719da$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            d & 4 && $8f2285b8ffe719da$var$ak(a);
            break;
        case 21:
            break;
        default:
            $8f2285b8ffe719da$var$ck(b, a), $8f2285b8ffe719da$var$ek(a);
    }
}
function $8f2285b8ffe719da$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($8f2285b8ffe719da$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($8f2285b8ffe719da$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($8f2285b8ffe719da$var$ob(e, ""), d.flags &= -33);
                    var f = $8f2285b8ffe719da$var$Uj(a);
                    $8f2285b8ffe719da$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $8f2285b8ffe719da$var$Uj(a);
                    $8f2285b8ffe719da$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($8f2285b8ffe719da$var$p(161));
            }
        } catch (k) {
            $8f2285b8ffe719da$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $8f2285b8ffe719da$var$hk(a, b, c) {
    $8f2285b8ffe719da$var$V = a;
    $8f2285b8ffe719da$var$ik(a, b, c);
}
function $8f2285b8ffe719da$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $8f2285b8ffe719da$var$V;){
        var e = $8f2285b8ffe719da$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $8f2285b8ffe719da$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $8f2285b8ffe719da$var$U;
                h = $8f2285b8ffe719da$var$Jj;
                var l = $8f2285b8ffe719da$var$U;
                $8f2285b8ffe719da$var$Jj = g;
                if (($8f2285b8ffe719da$var$U = k) && !l) for($8f2285b8ffe719da$var$V = e; null !== $8f2285b8ffe719da$var$V;)g = $8f2285b8ffe719da$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $8f2285b8ffe719da$var$jk(e) : null !== k ? (k.return = g, $8f2285b8ffe719da$var$V = k) : $8f2285b8ffe719da$var$jk(e);
                for(; null !== f;)$8f2285b8ffe719da$var$V = f, $8f2285b8ffe719da$var$ik(f, b, c), f = f.sibling;
                $8f2285b8ffe719da$var$V = e;
                $8f2285b8ffe719da$var$Jj = h;
                $8f2285b8ffe719da$var$U = l;
            }
            $8f2285b8ffe719da$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $8f2285b8ffe719da$var$V = f) : $8f2285b8ffe719da$var$kk(a, b, c);
    }
}
function $8f2285b8ffe719da$var$kk(a) {
    for(; null !== $8f2285b8ffe719da$var$V;){
        var b = $8f2285b8ffe719da$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $8f2285b8ffe719da$var$U || $8f2285b8ffe719da$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$8f2285b8ffe719da$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $8f2285b8ffe719da$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $8f2285b8ffe719da$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $8f2285b8ffe719da$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $8f2285b8ffe719da$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($8f2285b8ffe719da$var$p(163));
                }
                $8f2285b8ffe719da$var$U || b.flags & 512 && $8f2285b8ffe719da$var$Rj(b);
            } catch (r) {
                $8f2285b8ffe719da$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $8f2285b8ffe719da$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8f2285b8ffe719da$var$V = c;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
}
function $8f2285b8ffe719da$var$gk(a) {
    for(; null !== $8f2285b8ffe719da$var$V;){
        var b = $8f2285b8ffe719da$var$V;
        if (b === a) {
            $8f2285b8ffe719da$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8f2285b8ffe719da$var$V = c;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
}
function $8f2285b8ffe719da$var$jk(a) {
    for(; null !== $8f2285b8ffe719da$var$V;){
        var b = $8f2285b8ffe719da$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $8f2285b8ffe719da$var$Qj(4, b);
                    } catch (k) {
                        $8f2285b8ffe719da$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $8f2285b8ffe719da$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $8f2285b8ffe719da$var$Rj(b);
                    } catch (k) {
                        $8f2285b8ffe719da$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $8f2285b8ffe719da$var$Rj(b);
                    } catch (k) {
                        $8f2285b8ffe719da$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $8f2285b8ffe719da$var$W(b, b.return, k);
        }
        if (b === a) {
            $8f2285b8ffe719da$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $8f2285b8ffe719da$var$V = h;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
}
var $8f2285b8ffe719da$var$lk = Math.ceil, $8f2285b8ffe719da$var$mk = $8f2285b8ffe719da$var$ua.ReactCurrentDispatcher, $8f2285b8ffe719da$var$nk = $8f2285b8ffe719da$var$ua.ReactCurrentOwner, $8f2285b8ffe719da$var$ok = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig, $8f2285b8ffe719da$var$K = 0, $8f2285b8ffe719da$var$Q = null, $8f2285b8ffe719da$var$Y = null, $8f2285b8ffe719da$var$Z = 0, $8f2285b8ffe719da$var$fj = 0, $8f2285b8ffe719da$var$ej = $8f2285b8ffe719da$var$Uf(0), $8f2285b8ffe719da$var$T = 0, $8f2285b8ffe719da$var$pk = null, $8f2285b8ffe719da$var$rh = 0, $8f2285b8ffe719da$var$qk = 0, $8f2285b8ffe719da$var$rk = 0, $8f2285b8ffe719da$var$sk = null, $8f2285b8ffe719da$var$tk = null, $8f2285b8ffe719da$var$fk = 0, $8f2285b8ffe719da$var$Gj = Infinity, $8f2285b8ffe719da$var$uk = null, $8f2285b8ffe719da$var$Oi = !1, $8f2285b8ffe719da$var$Pi = null, $8f2285b8ffe719da$var$Ri = null, $8f2285b8ffe719da$var$vk = !1, $8f2285b8ffe719da$var$wk = null, $8f2285b8ffe719da$var$xk = 0, $8f2285b8ffe719da$var$yk = 0, $8f2285b8ffe719da$var$zk = null, $8f2285b8ffe719da$var$Ak = -1, $8f2285b8ffe719da$var$Bk = 0;
function $8f2285b8ffe719da$var$R() {
    return 0 !== ($8f2285b8ffe719da$var$K & 6) ? $8f2285b8ffe719da$var$B() : -1 !== $8f2285b8ffe719da$var$Ak ? $8f2285b8ffe719da$var$Ak : $8f2285b8ffe719da$var$Ak = $8f2285b8ffe719da$var$B();
}
function $8f2285b8ffe719da$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($8f2285b8ffe719da$var$K & 2) && 0 !== $8f2285b8ffe719da$var$Z) return $8f2285b8ffe719da$var$Z & -$8f2285b8ffe719da$var$Z;
    if (null !== $8f2285b8ffe719da$var$Kg.transition) return 0 === $8f2285b8ffe719da$var$Bk && ($8f2285b8ffe719da$var$Bk = $8f2285b8ffe719da$var$yc()), $8f2285b8ffe719da$var$Bk;
    a = $8f2285b8ffe719da$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $8f2285b8ffe719da$var$jd(a.type);
    return a;
}
function $8f2285b8ffe719da$var$gi(a, b, c, d) {
    if (50 < $8f2285b8ffe719da$var$yk) throw $8f2285b8ffe719da$var$yk = 0, $8f2285b8ffe719da$var$zk = null, Error($8f2285b8ffe719da$var$p(185));
    $8f2285b8ffe719da$var$Ac(a, c, d);
    if (0 === ($8f2285b8ffe719da$var$K & 2) || a !== $8f2285b8ffe719da$var$Q) a === $8f2285b8ffe719da$var$Q && (0 === ($8f2285b8ffe719da$var$K & 2) && ($8f2285b8ffe719da$var$qk |= c), 4 === $8f2285b8ffe719da$var$T && $8f2285b8ffe719da$var$Ck(a, $8f2285b8ffe719da$var$Z)), $8f2285b8ffe719da$var$Dk(a, d), 1 === c && 0 === $8f2285b8ffe719da$var$K && 0 === (b.mode & 1) && ($8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$fg && $8f2285b8ffe719da$var$jg());
}
function $8f2285b8ffe719da$var$Dk(a, b) {
    var c = a.callbackNode;
    $8f2285b8ffe719da$var$wc(a, b);
    var d = $8f2285b8ffe719da$var$uc(a, a === $8f2285b8ffe719da$var$Q ? $8f2285b8ffe719da$var$Z : 0);
    if (0 === d) null !== c && $8f2285b8ffe719da$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $8f2285b8ffe719da$var$bc(c);
        if (1 === b) 0 === a.tag ? $8f2285b8ffe719da$var$ig($8f2285b8ffe719da$var$Ek.bind(null, a)) : $8f2285b8ffe719da$var$hg($8f2285b8ffe719da$var$Ek.bind(null, a)), $8f2285b8ffe719da$var$Jf(function() {
            0 === ($8f2285b8ffe719da$var$K & 6) && $8f2285b8ffe719da$var$jg();
        }), c = null;
        else {
            switch($8f2285b8ffe719da$var$Dc(d)){
                case 1:
                    c = $8f2285b8ffe719da$var$fc;
                    break;
                case 4:
                    c = $8f2285b8ffe719da$var$gc;
                    break;
                case 16:
                    c = $8f2285b8ffe719da$var$hc;
                    break;
                case 536870912:
                    c = $8f2285b8ffe719da$var$jc;
                    break;
                default:
                    c = $8f2285b8ffe719da$var$hc;
            }
            c = $8f2285b8ffe719da$var$Fk(c, $8f2285b8ffe719da$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $8f2285b8ffe719da$var$Gk(a, b) {
    $8f2285b8ffe719da$var$Ak = -1;
    $8f2285b8ffe719da$var$Bk = 0;
    if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(327));
    var c = a.callbackNode;
    if ($8f2285b8ffe719da$var$Hk() && a.callbackNode !== c) return null;
    var d = $8f2285b8ffe719da$var$uc(a, a === $8f2285b8ffe719da$var$Q ? $8f2285b8ffe719da$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $8f2285b8ffe719da$var$Ik(a, d);
    else {
        b = d;
        var e = $8f2285b8ffe719da$var$K;
        $8f2285b8ffe719da$var$K |= 2;
        var f = $8f2285b8ffe719da$var$Jk();
        if ($8f2285b8ffe719da$var$Q !== a || $8f2285b8ffe719da$var$Z !== b) $8f2285b8ffe719da$var$uk = null, $8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$Kk(a, b);
        for(;;)try {
            $8f2285b8ffe719da$var$Lk();
            break;
        } catch (h) {
            $8f2285b8ffe719da$var$Mk(a, h);
        }
        $8f2285b8ffe719da$var$$g();
        $8f2285b8ffe719da$var$mk.current = f;
        $8f2285b8ffe719da$var$K = e;
        null !== $8f2285b8ffe719da$var$Y ? b = 0 : ($8f2285b8ffe719da$var$Q = null, $8f2285b8ffe719da$var$Z = 0, b = $8f2285b8ffe719da$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $8f2285b8ffe719da$var$xc(a), 0 !== e && (d = e, b = $8f2285b8ffe719da$var$Nk(a, e)));
        if (1 === b) throw c = $8f2285b8ffe719da$var$pk, $8f2285b8ffe719da$var$Kk(a, 0), $8f2285b8ffe719da$var$Ck(a, d), $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), c;
        if (6 === b) $8f2285b8ffe719da$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$8f2285b8ffe719da$var$Ok(e) && (b = $8f2285b8ffe719da$var$Ik(a, d), 2 === b && (f = $8f2285b8ffe719da$var$xc(a), 0 !== f && (d = f, b = $8f2285b8ffe719da$var$Nk(a, f))), 1 === b)) throw c = $8f2285b8ffe719da$var$pk, $8f2285b8ffe719da$var$Kk(a, 0), $8f2285b8ffe719da$var$Ck(a, d), $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($8f2285b8ffe719da$var$p(345));
                case 2:
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                case 3:
                    $8f2285b8ffe719da$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $8f2285b8ffe719da$var$fk + 500 - $8f2285b8ffe719da$var$B(), 10 < b)) {
                        if (0 !== $8f2285b8ffe719da$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $8f2285b8ffe719da$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $8f2285b8ffe719da$var$Ff($8f2285b8ffe719da$var$Pk.bind(null, a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk), b);
                        break;
                    }
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                case 4:
                    $8f2285b8ffe719da$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $8f2285b8ffe719da$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $8f2285b8ffe719da$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $8f2285b8ffe719da$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $8f2285b8ffe719da$var$Ff($8f2285b8ffe719da$var$Pk.bind(null, a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk), d);
                        break;
                    }
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                case 5:
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                default:
                    throw Error($8f2285b8ffe719da$var$p(329));
            }
        }
    }
    $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B());
    return a.callbackNode === c ? $8f2285b8ffe719da$var$Gk.bind(null, a) : null;
}
function $8f2285b8ffe719da$var$Nk(a, b) {
    var c = $8f2285b8ffe719da$var$sk;
    a.current.memoizedState.isDehydrated && ($8f2285b8ffe719da$var$Kk(a, b).flags |= 256);
    a = $8f2285b8ffe719da$var$Ik(a, b);
    2 !== a && (b = $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$tk = c, null !== b && $8f2285b8ffe719da$var$Fj(b));
    return a;
}
function $8f2285b8ffe719da$var$Fj(a) {
    null === $8f2285b8ffe719da$var$tk ? $8f2285b8ffe719da$var$tk = a : $8f2285b8ffe719da$var$tk.push.apply($8f2285b8ffe719da$var$tk, a);
}
function $8f2285b8ffe719da$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$8f2285b8ffe719da$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $8f2285b8ffe719da$var$Ck(a, b) {
    b &= ~$8f2285b8ffe719da$var$rk;
    b &= ~$8f2285b8ffe719da$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $8f2285b8ffe719da$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $8f2285b8ffe719da$var$Ek(a) {
    if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(327));
    $8f2285b8ffe719da$var$Hk();
    var b = $8f2285b8ffe719da$var$uc(a, 0);
    if (0 === (b & 1)) return $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), null;
    var c = $8f2285b8ffe719da$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $8f2285b8ffe719da$var$xc(a);
        0 !== d && (b = d, c = $8f2285b8ffe719da$var$Nk(a, d));
    }
    if (1 === c) throw c = $8f2285b8ffe719da$var$pk, $8f2285b8ffe719da$var$Kk(a, 0), $8f2285b8ffe719da$var$Ck(a, b), $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), c;
    if (6 === c) throw Error($8f2285b8ffe719da$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
    $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B());
    return null;
}
function $8f2285b8ffe719da$var$Qk(a, b) {
    var c = $8f2285b8ffe719da$var$K;
    $8f2285b8ffe719da$var$K |= 1;
    try {
        return a(b);
    } finally{
        $8f2285b8ffe719da$var$K = c, 0 === $8f2285b8ffe719da$var$K && ($8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$fg && $8f2285b8ffe719da$var$jg());
    }
}
function $8f2285b8ffe719da$var$Rk(a) {
    null !== $8f2285b8ffe719da$var$wk && 0 === $8f2285b8ffe719da$var$wk.tag && 0 === ($8f2285b8ffe719da$var$K & 6) && $8f2285b8ffe719da$var$Hk();
    var b = $8f2285b8ffe719da$var$K;
    $8f2285b8ffe719da$var$K |= 1;
    var c = $8f2285b8ffe719da$var$ok.transition, d = $8f2285b8ffe719da$var$C;
    try {
        if ($8f2285b8ffe719da$var$ok.transition = null, $8f2285b8ffe719da$var$C = 1, a) return a();
    } finally{
        $8f2285b8ffe719da$var$C = d, $8f2285b8ffe719da$var$ok.transition = c, $8f2285b8ffe719da$var$K = b, 0 === ($8f2285b8ffe719da$var$K & 6) && $8f2285b8ffe719da$var$jg();
    }
}
function $8f2285b8ffe719da$var$Hj() {
    $8f2285b8ffe719da$var$fj = $8f2285b8ffe719da$var$ej.current;
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$ej);
}
function $8f2285b8ffe719da$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $8f2285b8ffe719da$var$Gf(c));
    if (null !== $8f2285b8ffe719da$var$Y) for(c = $8f2285b8ffe719da$var$Y.return; null !== c;){
        var d = c;
        $8f2285b8ffe719da$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $8f2285b8ffe719da$var$$f();
                break;
            case 3:
                $8f2285b8ffe719da$var$zh();
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H);
                $8f2285b8ffe719da$var$Eh();
                break;
            case 5:
                $8f2285b8ffe719da$var$Bh(d);
                break;
            case 4:
                $8f2285b8ffe719da$var$zh();
                break;
            case 13:
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
                break;
            case 19:
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
                break;
            case 10:
                $8f2285b8ffe719da$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $8f2285b8ffe719da$var$Hj();
        }
        c = c.return;
    }
    $8f2285b8ffe719da$var$Q = a;
    $8f2285b8ffe719da$var$Y = a = $8f2285b8ffe719da$var$Pg(a.current, null);
    $8f2285b8ffe719da$var$Z = $8f2285b8ffe719da$var$fj = b;
    $8f2285b8ffe719da$var$T = 0;
    $8f2285b8ffe719da$var$pk = null;
    $8f2285b8ffe719da$var$rk = $8f2285b8ffe719da$var$qk = $8f2285b8ffe719da$var$rh = 0;
    $8f2285b8ffe719da$var$tk = $8f2285b8ffe719da$var$sk = null;
    if (null !== $8f2285b8ffe719da$var$fh) {
        for(b = 0; b < $8f2285b8ffe719da$var$fh.length; b++)if (c = $8f2285b8ffe719da$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $8f2285b8ffe719da$var$fh = null;
    }
    return a;
}
function $8f2285b8ffe719da$var$Mk(a, b) {
    do {
        var c = $8f2285b8ffe719da$var$Y;
        try {
            $8f2285b8ffe719da$var$$g();
            $8f2285b8ffe719da$var$Fh.current = $8f2285b8ffe719da$var$Rh;
            if ($8f2285b8ffe719da$var$Ih) {
                for(var d = $8f2285b8ffe719da$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $8f2285b8ffe719da$var$Ih = !1;
            }
            $8f2285b8ffe719da$var$Hh = 0;
            $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$N = $8f2285b8ffe719da$var$M = null;
            $8f2285b8ffe719da$var$Jh = !1;
            $8f2285b8ffe719da$var$Kh = 0;
            $8f2285b8ffe719da$var$nk.current = null;
            if (null === c || null === c.return) {
                $8f2285b8ffe719da$var$T = 1;
                $8f2285b8ffe719da$var$pk = b;
                $8f2285b8ffe719da$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $8f2285b8ffe719da$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $8f2285b8ffe719da$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $8f2285b8ffe719da$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $8f2285b8ffe719da$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $8f2285b8ffe719da$var$Si(f, l, b);
                            $8f2285b8ffe719da$var$tj();
                            break a;
                        }
                        k = Error($8f2285b8ffe719da$var$p(426));
                    }
                } else if ($8f2285b8ffe719da$var$I && h.mode & 1) {
                    var J = $8f2285b8ffe719da$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $8f2285b8ffe719da$var$Vi(J, g, h, f, b);
                        $8f2285b8ffe719da$var$Jg($8f2285b8ffe719da$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $8f2285b8ffe719da$var$Ji(k, h);
                4 !== $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$T = 2);
                null === $8f2285b8ffe719da$var$sk ? $8f2285b8ffe719da$var$sk = [
                    f
                ] : $8f2285b8ffe719da$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $8f2285b8ffe719da$var$Ni(f, k, b);
                            $8f2285b8ffe719da$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $8f2285b8ffe719da$var$Ri || !$8f2285b8ffe719da$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $8f2285b8ffe719da$var$Qi(f, h, b);
                                $8f2285b8ffe719da$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $8f2285b8ffe719da$var$Sk(c);
        } catch (na) {
            b = na;
            $8f2285b8ffe719da$var$Y === c && null !== c && ($8f2285b8ffe719da$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $8f2285b8ffe719da$var$Jk() {
    var a = $8f2285b8ffe719da$var$mk.current;
    $8f2285b8ffe719da$var$mk.current = $8f2285b8ffe719da$var$Rh;
    return null === a ? $8f2285b8ffe719da$var$Rh : a;
}
function $8f2285b8ffe719da$var$tj() {
    if (0 === $8f2285b8ffe719da$var$T || 3 === $8f2285b8ffe719da$var$T || 2 === $8f2285b8ffe719da$var$T) $8f2285b8ffe719da$var$T = 4;
    null === $8f2285b8ffe719da$var$Q || 0 === ($8f2285b8ffe719da$var$rh & 268435455) && 0 === ($8f2285b8ffe719da$var$qk & 268435455) || $8f2285b8ffe719da$var$Ck($8f2285b8ffe719da$var$Q, $8f2285b8ffe719da$var$Z);
}
function $8f2285b8ffe719da$var$Ik(a, b) {
    var c = $8f2285b8ffe719da$var$K;
    $8f2285b8ffe719da$var$K |= 2;
    var d = $8f2285b8ffe719da$var$Jk();
    if ($8f2285b8ffe719da$var$Q !== a || $8f2285b8ffe719da$var$Z !== b) $8f2285b8ffe719da$var$uk = null, $8f2285b8ffe719da$var$Kk(a, b);
    for(;;)try {
        $8f2285b8ffe719da$var$Tk();
        break;
    } catch (e) {
        $8f2285b8ffe719da$var$Mk(a, e);
    }
    $8f2285b8ffe719da$var$$g();
    $8f2285b8ffe719da$var$K = c;
    $8f2285b8ffe719da$var$mk.current = d;
    if (null !== $8f2285b8ffe719da$var$Y) throw Error($8f2285b8ffe719da$var$p(261));
    $8f2285b8ffe719da$var$Q = null;
    $8f2285b8ffe719da$var$Z = 0;
    return $8f2285b8ffe719da$var$T;
}
function $8f2285b8ffe719da$var$Tk() {
    for(; null !== $8f2285b8ffe719da$var$Y;)$8f2285b8ffe719da$var$Uk($8f2285b8ffe719da$var$Y);
}
function $8f2285b8ffe719da$var$Lk() {
    for(; null !== $8f2285b8ffe719da$var$Y && !$8f2285b8ffe719da$var$cc();)$8f2285b8ffe719da$var$Uk($8f2285b8ffe719da$var$Y);
}
function $8f2285b8ffe719da$var$Uk(a) {
    var b = $8f2285b8ffe719da$var$Vk(a.alternate, a, $8f2285b8ffe719da$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $8f2285b8ffe719da$var$Sk(a) : $8f2285b8ffe719da$var$Y = b;
    $8f2285b8ffe719da$var$nk.current = null;
}
function $8f2285b8ffe719da$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $8f2285b8ffe719da$var$Ej(c, b, $8f2285b8ffe719da$var$fj), null !== c) {
                $8f2285b8ffe719da$var$Y = c;
                return;
            }
        } else {
            c = $8f2285b8ffe719da$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $8f2285b8ffe719da$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $8f2285b8ffe719da$var$T = 6;
                $8f2285b8ffe719da$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $8f2285b8ffe719da$var$Y = b;
            return;
        }
        $8f2285b8ffe719da$var$Y = b = a;
    }while (null !== b);
    0 === $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$T = 5);
}
function $8f2285b8ffe719da$var$Pk(a, b, c) {
    var d = $8f2285b8ffe719da$var$C, e = $8f2285b8ffe719da$var$ok.transition;
    try {
        $8f2285b8ffe719da$var$ok.transition = null, $8f2285b8ffe719da$var$C = 1, $8f2285b8ffe719da$var$Wk(a, b, c, d);
    } finally{
        $8f2285b8ffe719da$var$ok.transition = e, $8f2285b8ffe719da$var$C = d;
    }
    return null;
}
function $8f2285b8ffe719da$var$Wk(a, b, c, d) {
    do $8f2285b8ffe719da$var$Hk();
    while (null !== $8f2285b8ffe719da$var$wk);
    if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($8f2285b8ffe719da$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $8f2285b8ffe719da$var$Bc(a, f);
    a === $8f2285b8ffe719da$var$Q && ($8f2285b8ffe719da$var$Y = $8f2285b8ffe719da$var$Q = null, $8f2285b8ffe719da$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $8f2285b8ffe719da$var$vk || ($8f2285b8ffe719da$var$vk = !0, $8f2285b8ffe719da$var$Fk($8f2285b8ffe719da$var$hc, function() {
        $8f2285b8ffe719da$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $8f2285b8ffe719da$var$ok.transition;
        $8f2285b8ffe719da$var$ok.transition = null;
        var g = $8f2285b8ffe719da$var$C;
        $8f2285b8ffe719da$var$C = 1;
        var h = $8f2285b8ffe719da$var$K;
        $8f2285b8ffe719da$var$K |= 4;
        $8f2285b8ffe719da$var$nk.current = null;
        $8f2285b8ffe719da$var$Oj(a, c);
        $8f2285b8ffe719da$var$dk(c, a);
        $8f2285b8ffe719da$var$Oe($8f2285b8ffe719da$var$Df);
        $8f2285b8ffe719da$var$dd = !!$8f2285b8ffe719da$var$Cf;
        $8f2285b8ffe719da$var$Df = $8f2285b8ffe719da$var$Cf = null;
        a.current = c;
        $8f2285b8ffe719da$var$hk(c, a, e);
        $8f2285b8ffe719da$var$dc();
        $8f2285b8ffe719da$var$K = h;
        $8f2285b8ffe719da$var$C = g;
        $8f2285b8ffe719da$var$ok.transition = f;
    } else a.current = c;
    $8f2285b8ffe719da$var$vk && ($8f2285b8ffe719da$var$vk = !1, $8f2285b8ffe719da$var$wk = a, $8f2285b8ffe719da$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($8f2285b8ffe719da$var$Ri = null);
    $8f2285b8ffe719da$var$mc(c.stateNode, d);
    $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($8f2285b8ffe719da$var$Oi) throw $8f2285b8ffe719da$var$Oi = !1, a = $8f2285b8ffe719da$var$Pi, $8f2285b8ffe719da$var$Pi = null, a;
    0 !== ($8f2285b8ffe719da$var$xk & 1) && 0 !== a.tag && $8f2285b8ffe719da$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $8f2285b8ffe719da$var$zk ? $8f2285b8ffe719da$var$yk++ : ($8f2285b8ffe719da$var$yk = 0, $8f2285b8ffe719da$var$zk = a) : $8f2285b8ffe719da$var$yk = 0;
    $8f2285b8ffe719da$var$jg();
    return null;
}
function $8f2285b8ffe719da$var$Hk() {
    if (null !== $8f2285b8ffe719da$var$wk) {
        var a = $8f2285b8ffe719da$var$Dc($8f2285b8ffe719da$var$xk), b = $8f2285b8ffe719da$var$ok.transition, c = $8f2285b8ffe719da$var$C;
        try {
            $8f2285b8ffe719da$var$ok.transition = null;
            $8f2285b8ffe719da$var$C = 16 > a ? 16 : a;
            if (null === $8f2285b8ffe719da$var$wk) var d = !1;
            else {
                a = $8f2285b8ffe719da$var$wk;
                $8f2285b8ffe719da$var$wk = null;
                $8f2285b8ffe719da$var$xk = 0;
                if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(331));
                var e = $8f2285b8ffe719da$var$K;
                $8f2285b8ffe719da$var$K |= 4;
                for($8f2285b8ffe719da$var$V = a.current; null !== $8f2285b8ffe719da$var$V;){
                    var f = $8f2285b8ffe719da$var$V, g = f.child;
                    if (0 !== ($8f2285b8ffe719da$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($8f2285b8ffe719da$var$V = l; null !== $8f2285b8ffe719da$var$V;){
                                    var m = $8f2285b8ffe719da$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $8f2285b8ffe719da$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $8f2285b8ffe719da$var$V = q;
                                    else for(; null !== $8f2285b8ffe719da$var$V;){
                                        m = $8f2285b8ffe719da$var$V;
                                        var r = m.sibling, y = m.return;
                                        $8f2285b8ffe719da$var$Sj(m);
                                        if (m === l) {
                                            $8f2285b8ffe719da$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $8f2285b8ffe719da$var$V = r;
                                            break;
                                        }
                                        $8f2285b8ffe719da$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $8f2285b8ffe719da$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $8f2285b8ffe719da$var$V = g;
                    else b: for(; null !== $8f2285b8ffe719da$var$V;){
                        f = $8f2285b8ffe719da$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $8f2285b8ffe719da$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $8f2285b8ffe719da$var$V = x;
                            break b;
                        }
                        $8f2285b8ffe719da$var$V = f.return;
                    }
                }
                var w = a.current;
                for($8f2285b8ffe719da$var$V = w; null !== $8f2285b8ffe719da$var$V;){
                    g = $8f2285b8ffe719da$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $8f2285b8ffe719da$var$V = u;
                    else b: for(g = w; null !== $8f2285b8ffe719da$var$V;){
                        h = $8f2285b8ffe719da$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $8f2285b8ffe719da$var$Qj(9, h);
                            }
                        } catch (na) {
                            $8f2285b8ffe719da$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $8f2285b8ffe719da$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $8f2285b8ffe719da$var$V = F;
                            break b;
                        }
                        $8f2285b8ffe719da$var$V = h.return;
                    }
                }
                $8f2285b8ffe719da$var$K = e;
                $8f2285b8ffe719da$var$jg();
                if ($8f2285b8ffe719da$var$lc && "function" === typeof $8f2285b8ffe719da$var$lc.onPostCommitFiberRoot) try {
                    $8f2285b8ffe719da$var$lc.onPostCommitFiberRoot($8f2285b8ffe719da$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $8f2285b8ffe719da$var$C = c, $8f2285b8ffe719da$var$ok.transition = b;
        }
    }
    return !1;
}
function $8f2285b8ffe719da$var$Xk(a, b, c) {
    b = $8f2285b8ffe719da$var$Ji(c, b);
    b = $8f2285b8ffe719da$var$Ni(a, b, 1);
    a = $8f2285b8ffe719da$var$nh(a, b, 1);
    b = $8f2285b8ffe719da$var$R();
    null !== a && ($8f2285b8ffe719da$var$Ac(a, 1, b), $8f2285b8ffe719da$var$Dk(a, b));
}
function $8f2285b8ffe719da$var$W(a, b, c) {
    if (3 === a.tag) $8f2285b8ffe719da$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $8f2285b8ffe719da$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $8f2285b8ffe719da$var$Ri || !$8f2285b8ffe719da$var$Ri.has(d))) {
                a = $8f2285b8ffe719da$var$Ji(c, a);
                a = $8f2285b8ffe719da$var$Qi(b, a, 1);
                b = $8f2285b8ffe719da$var$nh(b, a, 1);
                a = $8f2285b8ffe719da$var$R();
                null !== b && ($8f2285b8ffe719da$var$Ac(b, 1, a), $8f2285b8ffe719da$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $8f2285b8ffe719da$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $8f2285b8ffe719da$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $8f2285b8ffe719da$var$Q === a && ($8f2285b8ffe719da$var$Z & c) === c && (4 === $8f2285b8ffe719da$var$T || 3 === $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$Z & 130023424) === $8f2285b8ffe719da$var$Z && 500 > $8f2285b8ffe719da$var$B() - $8f2285b8ffe719da$var$fk ? $8f2285b8ffe719da$var$Kk(a, 0) : $8f2285b8ffe719da$var$rk |= c);
    $8f2285b8ffe719da$var$Dk(a, b);
}
function $8f2285b8ffe719da$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $8f2285b8ffe719da$var$sc, $8f2285b8ffe719da$var$sc <<= 1, 0 === ($8f2285b8ffe719da$var$sc & 130023424) && ($8f2285b8ffe719da$var$sc = 4194304)));
    var c = $8f2285b8ffe719da$var$R();
    a = $8f2285b8ffe719da$var$ih(a, b);
    null !== a && ($8f2285b8ffe719da$var$Ac(a, b, c), $8f2285b8ffe719da$var$Dk(a, c));
}
function $8f2285b8ffe719da$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $8f2285b8ffe719da$var$Yk(a, c);
}
function $8f2285b8ffe719da$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($8f2285b8ffe719da$var$p(314));
    }
    null !== d && d.delete(b);
    $8f2285b8ffe719da$var$Yk(a, c);
}
var $8f2285b8ffe719da$var$Vk;
$8f2285b8ffe719da$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $8f2285b8ffe719da$var$Wf.current) $8f2285b8ffe719da$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $8f2285b8ffe719da$var$dh = !1, $8f2285b8ffe719da$var$yj(a, b, c);
            $8f2285b8ffe719da$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $8f2285b8ffe719da$var$dh = !1, $8f2285b8ffe719da$var$I && 0 !== (b.flags & 1048576) && $8f2285b8ffe719da$var$ug(b, $8f2285b8ffe719da$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $8f2285b8ffe719da$var$ij(a, b);
            a = b.pendingProps;
            var e = $8f2285b8ffe719da$var$Yf(b, $8f2285b8ffe719da$var$H.current);
            $8f2285b8ffe719da$var$ch(b, c);
            e = $8f2285b8ffe719da$var$Nh(null, b, d, a, e, c);
            var f = $8f2285b8ffe719da$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $8f2285b8ffe719da$var$Zf(d) ? (f = !0, $8f2285b8ffe719da$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $8f2285b8ffe719da$var$kh(b), e.updater = $8f2285b8ffe719da$var$Ei, b.stateNode = e, e._reactInternals = b, $8f2285b8ffe719da$var$Ii(b, d, a, c), b = $8f2285b8ffe719da$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $8f2285b8ffe719da$var$I && f && $8f2285b8ffe719da$var$vg(b), $8f2285b8ffe719da$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $8f2285b8ffe719da$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $8f2285b8ffe719da$var$Zk(d);
                a = $8f2285b8ffe719da$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $8f2285b8ffe719da$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $8f2285b8ffe719da$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $8f2285b8ffe719da$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $8f2285b8ffe719da$var$$i(null, b, d, $8f2285b8ffe719da$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($8f2285b8ffe719da$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $8f2285b8ffe719da$var$kj(b);
                if (null === a) throw Error($8f2285b8ffe719da$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $8f2285b8ffe719da$var$lh(a, b);
                $8f2285b8ffe719da$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $8f2285b8ffe719da$var$Ji(Error($8f2285b8ffe719da$var$p(423)), b);
                        b = $8f2285b8ffe719da$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $8f2285b8ffe719da$var$Ji(Error($8f2285b8ffe719da$var$p(424)), b);
                        b = $8f2285b8ffe719da$var$lj(a, b, d, c, e);
                        break a;
                    } else for($8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(b.stateNode.containerInfo.firstChild), $8f2285b8ffe719da$var$xg = b, $8f2285b8ffe719da$var$I = !0, $8f2285b8ffe719da$var$zg = null, c = $8f2285b8ffe719da$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $8f2285b8ffe719da$var$Ig();
                    if (d === e) {
                        b = $8f2285b8ffe719da$var$Zi(a, b, c);
                        break a;
                    }
                    $8f2285b8ffe719da$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $8f2285b8ffe719da$var$Ah(b), null === a && $8f2285b8ffe719da$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $8f2285b8ffe719da$var$Ef(d, e) ? g = null : null !== f && $8f2285b8ffe719da$var$Ef(d, f) && (b.flags |= 32), $8f2285b8ffe719da$var$gj(a, b), $8f2285b8ffe719da$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $8f2285b8ffe719da$var$Eg(b), null;
        case 13:
            return $8f2285b8ffe719da$var$oj(a, b, c);
        case 4:
            return $8f2285b8ffe719da$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $8f2285b8ffe719da$var$Ug(b, null, d, c) : $8f2285b8ffe719da$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$Yi(a, b, d, e, c);
        case 7:
            return $8f2285b8ffe719da$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $8f2285b8ffe719da$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $8f2285b8ffe719da$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($8f2285b8ffe719da$var$He(f.value, g)) {
                        if (f.children === e.children && !$8f2285b8ffe719da$var$Wf.current) {
                            b = $8f2285b8ffe719da$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $8f2285b8ffe719da$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $8f2285b8ffe719da$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($8f2285b8ffe719da$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $8f2285b8ffe719da$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $8f2285b8ffe719da$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $8f2285b8ffe719da$var$ch(b, c), e = $8f2285b8ffe719da$var$eh(e), d = d(e), b.flags |= 1, $8f2285b8ffe719da$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $8f2285b8ffe719da$var$Ci(d, b.pendingProps), e = $8f2285b8ffe719da$var$Ci(d.type, e), $8f2285b8ffe719da$var$$i(a, b, d, e, c);
        case 15:
            return $8f2285b8ffe719da$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$ij(a, b), b.tag = 1, $8f2285b8ffe719da$var$Zf(d) ? (a = !0, $8f2285b8ffe719da$var$cg(b)) : a = !1, $8f2285b8ffe719da$var$ch(b, c), $8f2285b8ffe719da$var$Gi(b, d, e), $8f2285b8ffe719da$var$Ii(b, d, e, c), $8f2285b8ffe719da$var$jj(null, b, d, !0, a, c);
        case 19:
            return $8f2285b8ffe719da$var$xj(a, b, c);
        case 22:
            return $8f2285b8ffe719da$var$dj(a, b, c);
    }
    throw Error($8f2285b8ffe719da$var$p(156, b.tag));
};
function $8f2285b8ffe719da$var$Fk(a, b) {
    return $8f2285b8ffe719da$var$ac(a, b);
}
function $8f2285b8ffe719da$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8f2285b8ffe719da$var$Bg(a, b, c, d) {
    return new $8f2285b8ffe719da$var$$k(a, b, c, d);
}
function $8f2285b8ffe719da$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $8f2285b8ffe719da$var$Zk(a) {
    if ("function" === typeof a) return $8f2285b8ffe719da$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $8f2285b8ffe719da$var$Da) return 11;
        if (a === $8f2285b8ffe719da$var$Ga) return 14;
    }
    return 2;
}
function $8f2285b8ffe719da$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $8f2285b8ffe719da$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $8f2285b8ffe719da$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $8f2285b8ffe719da$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $8f2285b8ffe719da$var$ya:
            return $8f2285b8ffe719da$var$Tg(c.children, e, f, b);
        case $8f2285b8ffe719da$var$za:
            g = 8;
            e |= 8;
            break;
        case $8f2285b8ffe719da$var$Aa:
            return a = $8f2285b8ffe719da$var$Bg(12, c, b, e | 2), a.elementType = $8f2285b8ffe719da$var$Aa, a.lanes = f, a;
        case $8f2285b8ffe719da$var$Ea:
            return a = $8f2285b8ffe719da$var$Bg(13, c, b, e), a.elementType = $8f2285b8ffe719da$var$Ea, a.lanes = f, a;
        case $8f2285b8ffe719da$var$Fa:
            return a = $8f2285b8ffe719da$var$Bg(19, c, b, e), a.elementType = $8f2285b8ffe719da$var$Fa, a.lanes = f, a;
        case $8f2285b8ffe719da$var$Ia:
            return $8f2285b8ffe719da$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $8f2285b8ffe719da$var$Ba:
                    g = 10;
                    break a;
                case $8f2285b8ffe719da$var$Ca:
                    g = 9;
                    break a;
                case $8f2285b8ffe719da$var$Da:
                    g = 11;
                    break a;
                case $8f2285b8ffe719da$var$Ga:
                    g = 14;
                    break a;
                case $8f2285b8ffe719da$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($8f2285b8ffe719da$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $8f2285b8ffe719da$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $8f2285b8ffe719da$var$Tg(a, b, c, d) {
    a = $8f2285b8ffe719da$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $8f2285b8ffe719da$var$pj(a, b, c, d) {
    a = $8f2285b8ffe719da$var$Bg(22, a, d, b);
    a.elementType = $8f2285b8ffe719da$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $8f2285b8ffe719da$var$Qg(a, b, c) {
    a = $8f2285b8ffe719da$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $8f2285b8ffe719da$var$Sg(a, b, c) {
    b = $8f2285b8ffe719da$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $8f2285b8ffe719da$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $8f2285b8ffe719da$var$zc(0);
    this.expirationTimes = $8f2285b8ffe719da$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8f2285b8ffe719da$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $8f2285b8ffe719da$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $8f2285b8ffe719da$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $8f2285b8ffe719da$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $8f2285b8ffe719da$var$kh(f);
    return a;
}
function $8f2285b8ffe719da$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8f2285b8ffe719da$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $8f2285b8ffe719da$var$dl(a) {
    if (!a) return $8f2285b8ffe719da$var$Vf;
    a = a._reactInternals;
    a: {
        if ($8f2285b8ffe719da$var$Vb(a) !== a || 1 !== a.tag) throw Error($8f2285b8ffe719da$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($8f2285b8ffe719da$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($8f2285b8ffe719da$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($8f2285b8ffe719da$var$Zf(c)) return $8f2285b8ffe719da$var$bg(a, c, b);
    }
    return b;
}
function $8f2285b8ffe719da$var$el(a, b, c, d, e, f, g, h, k) {
    a = $8f2285b8ffe719da$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $8f2285b8ffe719da$var$dl(null);
    c = a.current;
    d = $8f2285b8ffe719da$var$R();
    e = $8f2285b8ffe719da$var$yi(c);
    f = $8f2285b8ffe719da$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $8f2285b8ffe719da$var$nh(c, f, e);
    a.current.lanes = e;
    $8f2285b8ffe719da$var$Ac(a, e, d);
    $8f2285b8ffe719da$var$Dk(a, d);
    return a;
}
function $8f2285b8ffe719da$var$fl(a, b, c, d) {
    var e = b.current, f = $8f2285b8ffe719da$var$R(), g = $8f2285b8ffe719da$var$yi(e);
    c = $8f2285b8ffe719da$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $8f2285b8ffe719da$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $8f2285b8ffe719da$var$nh(e, b, g);
    null !== a && ($8f2285b8ffe719da$var$gi(a, e, g, f), $8f2285b8ffe719da$var$oh(a, e, g));
    return g;
}
function $8f2285b8ffe719da$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $8f2285b8ffe719da$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $8f2285b8ffe719da$var$il(a, b) {
    $8f2285b8ffe719da$var$hl(a, b);
    (a = a.alternate) && $8f2285b8ffe719da$var$hl(a, b);
}
function $8f2285b8ffe719da$var$jl() {
    return null;
}
var $8f2285b8ffe719da$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $8f2285b8ffe719da$var$ll(a) {
    this._internalRoot = a;
}
$8f2285b8ffe719da$var$ml.prototype.render = $8f2285b8ffe719da$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($8f2285b8ffe719da$var$p(409));
    $8f2285b8ffe719da$var$fl(a, b, null, null);
};
$8f2285b8ffe719da$var$ml.prototype.unmount = $8f2285b8ffe719da$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $8f2285b8ffe719da$var$Rk(function() {
            $8f2285b8ffe719da$var$fl(null, a, null, null);
        });
        b[$8f2285b8ffe719da$var$uf] = null;
    }
};
function $8f2285b8ffe719da$var$ml(a) {
    this._internalRoot = a;
}
$8f2285b8ffe719da$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $8f2285b8ffe719da$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $8f2285b8ffe719da$var$Qc.length && 0 !== b && b < $8f2285b8ffe719da$var$Qc[c].priority; c++);
        $8f2285b8ffe719da$var$Qc.splice(c, 0, a);
        0 === c && $8f2285b8ffe719da$var$Vc(a);
    }
};
function $8f2285b8ffe719da$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $8f2285b8ffe719da$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $8f2285b8ffe719da$var$pl() {}
function $8f2285b8ffe719da$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $8f2285b8ffe719da$var$gl(g);
                f.call(a);
            };
        }
        var g = $8f2285b8ffe719da$var$el(b, d, a, 0, null, !1, !1, "", $8f2285b8ffe719da$var$pl);
        a._reactRootContainer = g;
        a[$8f2285b8ffe719da$var$uf] = g.current;
        $8f2285b8ffe719da$var$sf(8 === a.nodeType ? a.parentNode : a);
        $8f2285b8ffe719da$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $8f2285b8ffe719da$var$gl(k);
            h.call(a);
        };
    }
    var k = $8f2285b8ffe719da$var$bl(a, 0, !1, null, null, !1, !1, "", $8f2285b8ffe719da$var$pl);
    a._reactRootContainer = k;
    a[$8f2285b8ffe719da$var$uf] = k.current;
    $8f2285b8ffe719da$var$sf(8 === a.nodeType ? a.parentNode : a);
    $8f2285b8ffe719da$var$Rk(function() {
        $8f2285b8ffe719da$var$fl(b, k, c, d);
    });
    return k;
}
function $8f2285b8ffe719da$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $8f2285b8ffe719da$var$gl(g);
                h.call(a);
            };
        }
        $8f2285b8ffe719da$var$fl(b, g, a, e);
    } else g = $8f2285b8ffe719da$var$ql(c, b, a, e, d);
    return $8f2285b8ffe719da$var$gl(g);
}
$8f2285b8ffe719da$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $8f2285b8ffe719da$var$tc(b.pendingLanes);
                0 !== c && ($8f2285b8ffe719da$var$Cc(b, c | 1), $8f2285b8ffe719da$var$Dk(b, $8f2285b8ffe719da$var$B()), 0 === ($8f2285b8ffe719da$var$K & 6) && ($8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$jg()));
            }
            break;
        case 13:
            $8f2285b8ffe719da$var$Rk(function() {
                var b = $8f2285b8ffe719da$var$ih(a, 1);
                if (null !== b) {
                    var c = $8f2285b8ffe719da$var$R();
                    $8f2285b8ffe719da$var$gi(b, a, 1, c);
                }
            }), $8f2285b8ffe719da$var$il(a, 1);
    }
};
$8f2285b8ffe719da$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $8f2285b8ffe719da$var$ih(a, 134217728);
        if (null !== b) {
            var c = $8f2285b8ffe719da$var$R();
            $8f2285b8ffe719da$var$gi(b, a, 134217728, c);
        }
        $8f2285b8ffe719da$var$il(a, 134217728);
    }
};
$8f2285b8ffe719da$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $8f2285b8ffe719da$var$yi(a), c = $8f2285b8ffe719da$var$ih(a, b);
        if (null !== c) {
            var d = $8f2285b8ffe719da$var$R();
            $8f2285b8ffe719da$var$gi(c, a, b, d);
        }
        $8f2285b8ffe719da$var$il(a, b);
    }
};
$8f2285b8ffe719da$var$Hc = function() {
    return $8f2285b8ffe719da$var$C;
};
$8f2285b8ffe719da$var$Ic = function(a, b) {
    var c = $8f2285b8ffe719da$var$C;
    try {
        return $8f2285b8ffe719da$var$C = a, b();
    } finally{
        $8f2285b8ffe719da$var$C = c;
    }
};
$8f2285b8ffe719da$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $8f2285b8ffe719da$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $8f2285b8ffe719da$var$Db(d);
                        if (!e) throw Error($8f2285b8ffe719da$var$p(90));
                        $8f2285b8ffe719da$var$Wa(d);
                        $8f2285b8ffe719da$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $8f2285b8ffe719da$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $8f2285b8ffe719da$var$fb(a, !!c.multiple, b, !1);
    }
};
$8f2285b8ffe719da$var$Gb = $8f2285b8ffe719da$var$Qk;
$8f2285b8ffe719da$var$Hb = $8f2285b8ffe719da$var$Rk;
var $8f2285b8ffe719da$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $8f2285b8ffe719da$var$Cb,
        $8f2285b8ffe719da$var$ue,
        $8f2285b8ffe719da$var$Db,
        $8f2285b8ffe719da$var$Eb,
        $8f2285b8ffe719da$var$Fb,
        $8f2285b8ffe719da$var$Qk
    ]
}, $8f2285b8ffe719da$var$tl = {
    findFiberByHostInstance: $8f2285b8ffe719da$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $8f2285b8ffe719da$var$ul = {
    bundleType: $8f2285b8ffe719da$var$tl.bundleType,
    version: $8f2285b8ffe719da$var$tl.version,
    rendererPackageName: $8f2285b8ffe719da$var$tl.rendererPackageName,
    rendererConfig: $8f2285b8ffe719da$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $8f2285b8ffe719da$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $8f2285b8ffe719da$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $8f2285b8ffe719da$var$tl.findFiberByHostInstance || $8f2285b8ffe719da$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8f2285b8ffe719da$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8f2285b8ffe719da$var$vl.isDisabled && $8f2285b8ffe719da$var$vl.supportsFiber) try {
        $8f2285b8ffe719da$var$kc = $8f2285b8ffe719da$var$vl.inject($8f2285b8ffe719da$var$ul), $8f2285b8ffe719da$var$lc = $8f2285b8ffe719da$var$vl;
    } catch (a) {}
}
$8f2285b8ffe719da$export$ae55be85d98224ed = $8f2285b8ffe719da$var$sl;
$8f2285b8ffe719da$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$8f2285b8ffe719da$var$nl(b)) throw Error($8f2285b8ffe719da$var$p(200));
    return $8f2285b8ffe719da$var$cl(a, b, null, c);
};
$8f2285b8ffe719da$export$882461b6382ed46c = function(a, b) {
    if (!$8f2285b8ffe719da$var$nl(a)) throw Error($8f2285b8ffe719da$var$p(299));
    var c = !1, d = "", e = $8f2285b8ffe719da$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $8f2285b8ffe719da$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$8f2285b8ffe719da$var$uf] = b.current;
    $8f2285b8ffe719da$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $8f2285b8ffe719da$var$ll(b);
};
$8f2285b8ffe719da$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($8f2285b8ffe719da$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($8f2285b8ffe719da$var$p(268, a));
    }
    a = $8f2285b8ffe719da$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$8f2285b8ffe719da$export$cd75ccfd720a3cd4 = function(a) {
    return $8f2285b8ffe719da$var$Rk(a);
};
$8f2285b8ffe719da$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$8f2285b8ffe719da$var$ol(b)) throw Error($8f2285b8ffe719da$var$p(200));
    return $8f2285b8ffe719da$var$rl(null, a, b, !0, c);
};
$8f2285b8ffe719da$export$757ceba2d55c277e = function(a, b, c) {
    if (!$8f2285b8ffe719da$var$nl(a)) throw Error($8f2285b8ffe719da$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $8f2285b8ffe719da$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $8f2285b8ffe719da$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$8f2285b8ffe719da$var$uf] = b.current;
    $8f2285b8ffe719da$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $8f2285b8ffe719da$var$ml(b);
};
$8f2285b8ffe719da$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$8f2285b8ffe719da$var$ol(b)) throw Error($8f2285b8ffe719da$var$p(200));
    return $8f2285b8ffe719da$var$rl(null, a, b, !1, c);
};
$8f2285b8ffe719da$export$502457920280e6be = function(a) {
    if (!$8f2285b8ffe719da$var$ol(a)) throw Error($8f2285b8ffe719da$var$p(40));
    return a._reactRootContainer ? ($8f2285b8ffe719da$var$Rk(function() {
        $8f2285b8ffe719da$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$8f2285b8ffe719da$var$uf] = null;
        });
    }), !0) : !1;
};
$8f2285b8ffe719da$export$c78a37762a8d58e1 = $8f2285b8ffe719da$var$Qk;
$8f2285b8ffe719da$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$8f2285b8ffe719da$var$ol(c)) throw Error($8f2285b8ffe719da$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($8f2285b8ffe719da$var$p(38));
    return $8f2285b8ffe719da$var$rl(a, b, c, !1, d);
};
$8f2285b8ffe719da$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("e00l3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gwwKq"));

});
parcelRegister("gwwKq", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c079098268807020$export$c4744153514ff05d; }, function (v) { return $c079098268807020$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c079098268807020$export$3e506c1ccc9cc1a7; }, function (v) { return $c079098268807020$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c079098268807020$export$e26fe2ed2fa76875; }, function (v) { return $c079098268807020$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c079098268807020$export$502329bbf4b505b1; }, function (v) { return $c079098268807020$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c079098268807020$export$6e3807111c4874c4; }, function (v) { return $c079098268807020$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c079098268807020$export$c27134553091fb3a; }, function (v) { return $c079098268807020$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c079098268807020$export$33ee1acdc04fd2a2; }, function (v) { return $c079098268807020$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c079098268807020$export$b00a404bbd5edef2; }, function (v) { return $c079098268807020$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $c079098268807020$export$8352ce38b91d0c62; }, function (v) { return $c079098268807020$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c079098268807020$export$d66a1c1c77bd778b; }, function (v) { return $c079098268807020$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c079098268807020$export$d3dfb8e4810cb555; }, function (v) { return $c079098268807020$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $c079098268807020$export$839f9183b0465a69; }, function (v) { return $c079098268807020$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c079098268807020$export$72fdf0e06517287b; }, function (v) { return $c079098268807020$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $c079098268807020$export$4b844e58a3e414b4; }, function (v) { return $c079098268807020$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c079098268807020$export$816d2913ae6b83b1; }, function (v) { return $c079098268807020$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c079098268807020$export$61bcfe829111a1d0; }, function (v) { return $c079098268807020$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c079098268807020$export$7ee8c9beb337bc3f; }, function (v) { return $c079098268807020$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c079098268807020$export$b5836b71941fa3ed; }, function (v) { return $c079098268807020$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c079098268807020$export$cf845f2c119da08a; }, function (v) { return $c079098268807020$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c079098268807020$export$c4744153514ff05d;
var $c079098268807020$export$3e506c1ccc9cc1a7;
var $c079098268807020$export$e26fe2ed2fa76875;
var $c079098268807020$export$502329bbf4b505b1;
var $c079098268807020$export$6e3807111c4874c4;
var $c079098268807020$export$c27134553091fb3a;
var $c079098268807020$export$33ee1acdc04fd2a2;
var $c079098268807020$export$b00a404bbd5edef2;
var $c079098268807020$export$8352ce38b91d0c62;
var $c079098268807020$export$d66a1c1c77bd778b;
var $c079098268807020$export$d3dfb8e4810cb555;
var $c079098268807020$export$839f9183b0465a69;
var $c079098268807020$export$72fdf0e06517287b;
var $c079098268807020$export$4b844e58a3e414b4;
var $c079098268807020$export$816d2913ae6b83b1;
var $c079098268807020$export$61bcfe829111a1d0;
var $c079098268807020$export$7ee8c9beb337bc3f;
var $c079098268807020$export$b5836b71941fa3ed;
var $c079098268807020$export$cf845f2c119da08a;
'use strict';
function $c079098268807020$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $c079098268807020$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $c079098268807020$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $c079098268807020$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $c079098268807020$var$g(C, c)) n < e && 0 > $c079098268807020$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $c079098268807020$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $c079098268807020$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c079098268807020$var$l = performance;
    $c079098268807020$export$c4744153514ff05d = function() {
        return $c079098268807020$var$l.now();
    };
} else {
    var $c079098268807020$var$p = Date, $c079098268807020$var$q = $c079098268807020$var$p.now();
    $c079098268807020$export$c4744153514ff05d = function() {
        return $c079098268807020$var$p.now() - $c079098268807020$var$q;
    };
}
var $c079098268807020$var$r = [], $c079098268807020$var$t = [], $c079098268807020$var$u = 1, $c079098268807020$var$v = null, $c079098268807020$var$y = 3, $c079098268807020$var$z = !1, $c079098268807020$var$A = !1, $c079098268807020$var$B = !1, $c079098268807020$var$D = "function" === typeof setTimeout ? setTimeout : null, $c079098268807020$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $c079098268807020$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $c079098268807020$var$G(a) {
    for(var b = $c079098268807020$var$h($c079098268807020$var$t); null !== b;){
        if (null === b.callback) $c079098268807020$var$k($c079098268807020$var$t);
        else if (b.startTime <= a) $c079098268807020$var$k($c079098268807020$var$t), b.sortIndex = b.expirationTime, $c079098268807020$var$f($c079098268807020$var$r, b);
        else break;
        b = $c079098268807020$var$h($c079098268807020$var$t);
    }
}
function $c079098268807020$var$H(a) {
    $c079098268807020$var$B = !1;
    $c079098268807020$var$G(a);
    if (!$c079098268807020$var$A) {
        if (null !== $c079098268807020$var$h($c079098268807020$var$r)) $c079098268807020$var$A = !0, $c079098268807020$var$I($c079098268807020$var$J);
        else {
            var b = $c079098268807020$var$h($c079098268807020$var$t);
            null !== b && $c079098268807020$var$K($c079098268807020$var$H, b.startTime - a);
        }
    }
}
function $c079098268807020$var$J(a, b) {
    $c079098268807020$var$A = !1;
    $c079098268807020$var$B && ($c079098268807020$var$B = !1, $c079098268807020$var$E($c079098268807020$var$L), $c079098268807020$var$L = -1);
    $c079098268807020$var$z = !0;
    var c = $c079098268807020$var$y;
    try {
        $c079098268807020$var$G(b);
        for($c079098268807020$var$v = $c079098268807020$var$h($c079098268807020$var$r); null !== $c079098268807020$var$v && (!($c079098268807020$var$v.expirationTime > b) || a && !$c079098268807020$var$M());){
            var d = $c079098268807020$var$v.callback;
            if ("function" === typeof d) {
                $c079098268807020$var$v.callback = null;
                $c079098268807020$var$y = $c079098268807020$var$v.priorityLevel;
                var e = d($c079098268807020$var$v.expirationTime <= b);
                b = $c079098268807020$export$c4744153514ff05d();
                "function" === typeof e ? $c079098268807020$var$v.callback = e : $c079098268807020$var$v === $c079098268807020$var$h($c079098268807020$var$r) && $c079098268807020$var$k($c079098268807020$var$r);
                $c079098268807020$var$G(b);
            } else $c079098268807020$var$k($c079098268807020$var$r);
            $c079098268807020$var$v = $c079098268807020$var$h($c079098268807020$var$r);
        }
        if (null !== $c079098268807020$var$v) var w = !0;
        else {
            var m = $c079098268807020$var$h($c079098268807020$var$t);
            null !== m && $c079098268807020$var$K($c079098268807020$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $c079098268807020$var$v = null, $c079098268807020$var$y = c, $c079098268807020$var$z = !1;
    }
}
var $c079098268807020$var$N = !1, $c079098268807020$var$O = null, $c079098268807020$var$L = -1, $c079098268807020$var$P = 5, $c079098268807020$var$Q = -1;
function $c079098268807020$var$M() {
    return $c079098268807020$export$c4744153514ff05d() - $c079098268807020$var$Q < $c079098268807020$var$P ? !1 : !0;
}
function $c079098268807020$var$R() {
    if (null !== $c079098268807020$var$O) {
        var a = $c079098268807020$export$c4744153514ff05d();
        $c079098268807020$var$Q = a;
        var b = !0;
        try {
            b = $c079098268807020$var$O(!0, a);
        } finally{
            b ? $c079098268807020$var$S() : ($c079098268807020$var$N = !1, $c079098268807020$var$O = null);
        }
    } else $c079098268807020$var$N = !1;
}
var $c079098268807020$var$S;
if ("function" === typeof $c079098268807020$var$F) $c079098268807020$var$S = function() {
    $c079098268807020$var$F($c079098268807020$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c079098268807020$var$T = new MessageChannel, $c079098268807020$var$U = $c079098268807020$var$T.port2;
    $c079098268807020$var$T.port1.onmessage = $c079098268807020$var$R;
    $c079098268807020$var$S = function() {
        $c079098268807020$var$U.postMessage(null);
    };
} else $c079098268807020$var$S = function() {
    $c079098268807020$var$D($c079098268807020$var$R, 0);
};
function $c079098268807020$var$I(a) {
    $c079098268807020$var$O = a;
    $c079098268807020$var$N || ($c079098268807020$var$N = !0, $c079098268807020$var$S());
}
function $c079098268807020$var$K(a, b) {
    $c079098268807020$var$L = $c079098268807020$var$D(function() {
        a($c079098268807020$export$c4744153514ff05d());
    }, b);
}
$c079098268807020$export$3e506c1ccc9cc1a7 = 5;
$c079098268807020$export$e26fe2ed2fa76875 = 1;
$c079098268807020$export$502329bbf4b505b1 = 4;
$c079098268807020$export$6e3807111c4874c4 = 3;
$c079098268807020$export$c27134553091fb3a = null;
$c079098268807020$export$33ee1acdc04fd2a2 = 2;
$c079098268807020$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$c079098268807020$export$8352ce38b91d0c62 = function() {
    $c079098268807020$var$A || $c079098268807020$var$z || ($c079098268807020$var$A = !0, $c079098268807020$var$I($c079098268807020$var$J));
};
$c079098268807020$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c079098268807020$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$c079098268807020$export$d3dfb8e4810cb555 = function() {
    return $c079098268807020$var$y;
};
$c079098268807020$export$839f9183b0465a69 = function() {
    return $c079098268807020$var$h($c079098268807020$var$r);
};
$c079098268807020$export$72fdf0e06517287b = function(a) {
    switch($c079098268807020$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $c079098268807020$var$y;
    }
    var c = $c079098268807020$var$y;
    $c079098268807020$var$y = b;
    try {
        return a();
    } finally{
        $c079098268807020$var$y = c;
    }
};
$c079098268807020$export$4b844e58a3e414b4 = function() {};
$c079098268807020$export$816d2913ae6b83b1 = function() {};
$c079098268807020$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $c079098268807020$var$y;
    $c079098268807020$var$y = a;
    try {
        return b();
    } finally{
        $c079098268807020$var$y = c;
    }
};
$c079098268807020$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $c079098268807020$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $c079098268807020$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $c079098268807020$var$f($c079098268807020$var$t, a), null === $c079098268807020$var$h($c079098268807020$var$r) && a === $c079098268807020$var$h($c079098268807020$var$t) && ($c079098268807020$var$B ? ($c079098268807020$var$E($c079098268807020$var$L), $c079098268807020$var$L = -1) : $c079098268807020$var$B = !0, $c079098268807020$var$K($c079098268807020$var$H, c - d))) : (a.sortIndex = e, $c079098268807020$var$f($c079098268807020$var$r, a), $c079098268807020$var$A || $c079098268807020$var$z || ($c079098268807020$var$A = !0, $c079098268807020$var$I($c079098268807020$var$J)));
    return a;
};
$c079098268807020$export$b5836b71941fa3ed = $c079098268807020$var$M;
$c079098268807020$export$cf845f2c119da08a = function(a) {
    var b = $c079098268807020$var$y;
    return function() {
        var c = $c079098268807020$var$y;
        $c079098268807020$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $c079098268807020$var$y = c;
        }
    };
};

});



parcelRegister("a5UKC", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $759664958dfcc4e1$export$2b8d127b894957b9; }, function (v) { return $759664958dfcc4e1$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $759664958dfcc4e1$export$cea3a54a6425200c; }, function (v) { return $759664958dfcc4e1$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $759664958dfcc4e1$export$a7c73072b1a182ae; }, function (v) { return $759664958dfcc4e1$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $759664958dfcc4e1$export$9f27bc3417b4524d; }, function (v) { return $759664958dfcc4e1$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $759664958dfcc4e1$export$db77ccec0bb4ccac; }, function (v) { return $759664958dfcc4e1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $759664958dfcc4e1$export$8392c0c9d3dcbd35; }, function (v) { return $759664958dfcc4e1$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $759664958dfcc4e1$export$ffb0004e005737fa; }, function (v) { return $759664958dfcc4e1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $759664958dfcc4e1$export$b624eff549462981; }, function (v) { return $759664958dfcc4e1$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $759664958dfcc4e1$export$7897aa7841a5380c; }, function (v) { return $759664958dfcc4e1$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $759664958dfcc4e1$export$602eac185826482c; }, function (v) { return $759664958dfcc4e1$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $759664958dfcc4e1$export$e2c29f18771995cb; }, function (v) { return $759664958dfcc4e1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $759664958dfcc4e1$export$5f8d39834fd61797; }, function (v) { return $759664958dfcc4e1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $759664958dfcc4e1$export$74bf444e3cd11ea5; }, function (v) { return $759664958dfcc4e1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $759664958dfcc4e1$export$92387174baf9b227; }, function (v) { return $759664958dfcc4e1$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $759664958dfcc4e1$export$ec112efeb987d9c6; }, function (v) { return $759664958dfcc4e1$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $759664958dfcc4e1$export$b706b080d889d2c9; }, function (v) { return $759664958dfcc4e1$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $759664958dfcc4e1$export$5be5a87408f70ddc; }, function (v) { return $759664958dfcc4e1$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $759664958dfcc4e1$export$45a5e7f76e0caa8d; }, function (v) { return $759664958dfcc4e1$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $759664958dfcc4e1$export$455c2e768291efa6; }, function (v) { return $759664958dfcc4e1$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $759664958dfcc4e1$export$9522e17588c12572; }, function (v) { return $759664958dfcc4e1$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $759664958dfcc4e1$export$2110ac352bb060b9; }, function (v) { return $759664958dfcc4e1$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $759664958dfcc4e1$export$56885ab8b9c456ab; }, function (v) { return $759664958dfcc4e1$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $759664958dfcc4e1$export$d927fcb6adf8f9de; }, function (v) { return $759664958dfcc4e1$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $759664958dfcc4e1$export$b82d16f27459e05a; }, function (v) { return $759664958dfcc4e1$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $759664958dfcc4e1$export$522c17b4f5e123e8; }, function (v) { return $759664958dfcc4e1$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $759664958dfcc4e1$export$1aabd8a0274ecfd6; }, function (v) { return $759664958dfcc4e1$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $759664958dfcc4e1$export$9b621391a187a31a; }, function (v) { return $759664958dfcc4e1$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $759664958dfcc4e1$export$f5bbd400c2f4426f; }, function (v) { return $759664958dfcc4e1$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $759664958dfcc4e1$export$2b8d127b894957b9;
var $759664958dfcc4e1$export$cea3a54a6425200c;
var $759664958dfcc4e1$export$a7c73072b1a182ae;
var $759664958dfcc4e1$export$9f27bc3417b4524d;
var $759664958dfcc4e1$export$db77ccec0bb4ccac;
var $759664958dfcc4e1$export$8392c0c9d3dcbd35;
var $759664958dfcc4e1$export$ffb0004e005737fa;
var $759664958dfcc4e1$export$b624eff549462981;
var $759664958dfcc4e1$export$7897aa7841a5380c;
var $759664958dfcc4e1$export$602eac185826482c;
var $759664958dfcc4e1$export$e2c29f18771995cb;
var $759664958dfcc4e1$export$5f8d39834fd61797;
var $759664958dfcc4e1$export$74bf444e3cd11ea5;
var $759664958dfcc4e1$export$92387174baf9b227;
var $759664958dfcc4e1$export$ec112efeb987d9c6;
var $759664958dfcc4e1$export$b706b080d889d2c9;
var $759664958dfcc4e1$export$5be5a87408f70ddc;
var $759664958dfcc4e1$export$45a5e7f76e0caa8d;
var $759664958dfcc4e1$export$455c2e768291efa6;
var $759664958dfcc4e1$export$9522e17588c12572;
var $759664958dfcc4e1$export$2110ac352bb060b9;
var $759664958dfcc4e1$export$56885ab8b9c456ab;
var $759664958dfcc4e1$export$d927fcb6adf8f9de;
var $759664958dfcc4e1$export$b82d16f27459e05a;
var $759664958dfcc4e1$export$522c17b4f5e123e8;
var $759664958dfcc4e1$export$1aabd8a0274ecfd6;
var $759664958dfcc4e1$export$9b621391a187a31a;
var $759664958dfcc4e1$export$f5bbd400c2f4426f;
'use strict';
var $759664958dfcc4e1$var$b = "function" === typeof Symbol && Symbol.for, $759664958dfcc4e1$var$c = $759664958dfcc4e1$var$b ? Symbol.for("react.element") : 60103, $759664958dfcc4e1$var$d = $759664958dfcc4e1$var$b ? Symbol.for("react.portal") : 60106, $759664958dfcc4e1$var$e = $759664958dfcc4e1$var$b ? Symbol.for("react.fragment") : 60107, $759664958dfcc4e1$var$f = $759664958dfcc4e1$var$b ? Symbol.for("react.strict_mode") : 60108, $759664958dfcc4e1$var$g = $759664958dfcc4e1$var$b ? Symbol.for("react.profiler") : 60114, $759664958dfcc4e1$var$h = $759664958dfcc4e1$var$b ? Symbol.for("react.provider") : 60109, $759664958dfcc4e1$var$k = $759664958dfcc4e1$var$b ? Symbol.for("react.context") : 60110, $759664958dfcc4e1$var$l = $759664958dfcc4e1$var$b ? Symbol.for("react.async_mode") : 60111, $759664958dfcc4e1$var$m = $759664958dfcc4e1$var$b ? Symbol.for("react.concurrent_mode") : 60111, $759664958dfcc4e1$var$n = $759664958dfcc4e1$var$b ? Symbol.for("react.forward_ref") : 60112, $759664958dfcc4e1$var$p = $759664958dfcc4e1$var$b ? Symbol.for("react.suspense") : 60113, $759664958dfcc4e1$var$q = $759664958dfcc4e1$var$b ? Symbol.for("react.suspense_list") : 60120, $759664958dfcc4e1$var$r = $759664958dfcc4e1$var$b ? Symbol.for("react.memo") : 60115, $759664958dfcc4e1$var$t = $759664958dfcc4e1$var$b ? Symbol.for("react.lazy") : 60116, $759664958dfcc4e1$var$v = $759664958dfcc4e1$var$b ? Symbol.for("react.block") : 60121, $759664958dfcc4e1$var$w = $759664958dfcc4e1$var$b ? Symbol.for("react.fundamental") : 60117, $759664958dfcc4e1$var$x = $759664958dfcc4e1$var$b ? Symbol.for("react.responder") : 60118, $759664958dfcc4e1$var$y = $759664958dfcc4e1$var$b ? Symbol.for("react.scope") : 60119;
function $759664958dfcc4e1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $759664958dfcc4e1$var$c:
                switch(a = a.type, a){
                    case $759664958dfcc4e1$var$l:
                    case $759664958dfcc4e1$var$m:
                    case $759664958dfcc4e1$var$e:
                    case $759664958dfcc4e1$var$g:
                    case $759664958dfcc4e1$var$f:
                    case $759664958dfcc4e1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $759664958dfcc4e1$var$k:
                            case $759664958dfcc4e1$var$n:
                            case $759664958dfcc4e1$var$t:
                            case $759664958dfcc4e1$var$r:
                            case $759664958dfcc4e1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $759664958dfcc4e1$var$d:
                return u;
        }
    }
}
function $759664958dfcc4e1$var$A(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$m;
}
$759664958dfcc4e1$export$2b8d127b894957b9 = $759664958dfcc4e1$var$l;
$759664958dfcc4e1$export$cea3a54a6425200c = $759664958dfcc4e1$var$m;
$759664958dfcc4e1$export$a7c73072b1a182ae = $759664958dfcc4e1$var$k;
$759664958dfcc4e1$export$9f27bc3417b4524d = $759664958dfcc4e1$var$h;
$759664958dfcc4e1$export$db77ccec0bb4ccac = $759664958dfcc4e1$var$c;
$759664958dfcc4e1$export$8392c0c9d3dcbd35 = $759664958dfcc4e1$var$n;
$759664958dfcc4e1$export$ffb0004e005737fa = $759664958dfcc4e1$var$e;
$759664958dfcc4e1$export$b624eff549462981 = $759664958dfcc4e1$var$t;
$759664958dfcc4e1$export$7897aa7841a5380c = $759664958dfcc4e1$var$r;
$759664958dfcc4e1$export$602eac185826482c = $759664958dfcc4e1$var$d;
$759664958dfcc4e1$export$e2c29f18771995cb = $759664958dfcc4e1$var$g;
$759664958dfcc4e1$export$5f8d39834fd61797 = $759664958dfcc4e1$var$f;
$759664958dfcc4e1$export$74bf444e3cd11ea5 = $759664958dfcc4e1$var$p;
$759664958dfcc4e1$export$92387174baf9b227 = function(a) {
    return $759664958dfcc4e1$var$A(a) || $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$l;
};
$759664958dfcc4e1$export$ec112efeb987d9c6 = $759664958dfcc4e1$var$A;
$759664958dfcc4e1$export$b706b080d889d2c9 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$k;
};
$759664958dfcc4e1$export$5be5a87408f70ddc = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$h;
};
$759664958dfcc4e1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $759664958dfcc4e1$var$c;
};
$759664958dfcc4e1$export$455c2e768291efa6 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$n;
};
$759664958dfcc4e1$export$9522e17588c12572 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$e;
};
$759664958dfcc4e1$export$2110ac352bb060b9 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$t;
};
$759664958dfcc4e1$export$56885ab8b9c456ab = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$r;
};
$759664958dfcc4e1$export$d927fcb6adf8f9de = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$d;
};
$759664958dfcc4e1$export$b82d16f27459e05a = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$g;
};
$759664958dfcc4e1$export$522c17b4f5e123e8 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$f;
};
$759664958dfcc4e1$export$1aabd8a0274ecfd6 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$p;
};
$759664958dfcc4e1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $759664958dfcc4e1$var$e || a === $759664958dfcc4e1$var$m || a === $759664958dfcc4e1$var$g || a === $759664958dfcc4e1$var$f || a === $759664958dfcc4e1$var$p || a === $759664958dfcc4e1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $759664958dfcc4e1$var$t || a.$$typeof === $759664958dfcc4e1$var$r || a.$$typeof === $759664958dfcc4e1$var$h || a.$$typeof === $759664958dfcc4e1$var$k || a.$$typeof === $759664958dfcc4e1$var$n || a.$$typeof === $759664958dfcc4e1$var$w || a.$$typeof === $759664958dfcc4e1$var$x || a.$$typeof === $759664958dfcc4e1$var$y || a.$$typeof === $759664958dfcc4e1$var$v);
};
$759664958dfcc4e1$export$f5bbd400c2f4426f = $759664958dfcc4e1$var$z;

});

parcelRegister("dQbr8", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $a13900bffe729056$export$a7c73072b1a182ae; }, function (v) { return $a13900bffe729056$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a13900bffe729056$export$9f27bc3417b4524d; }, function (v) { return $a13900bffe729056$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a13900bffe729056$export$db77ccec0bb4ccac; }, function (v) { return $a13900bffe729056$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a13900bffe729056$export$8392c0c9d3dcbd35; }, function (v) { return $a13900bffe729056$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a13900bffe729056$export$ffb0004e005737fa; }, function (v) { return $a13900bffe729056$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a13900bffe729056$export$b624eff549462981; }, function (v) { return $a13900bffe729056$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a13900bffe729056$export$7897aa7841a5380c; }, function (v) { return $a13900bffe729056$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a13900bffe729056$export$602eac185826482c; }, function (v) { return $a13900bffe729056$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a13900bffe729056$export$e2c29f18771995cb; }, function (v) { return $a13900bffe729056$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a13900bffe729056$export$5f8d39834fd61797; }, function (v) { return $a13900bffe729056$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a13900bffe729056$export$74bf444e3cd11ea5; }, function (v) { return $a13900bffe729056$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $a13900bffe729056$export$998bcd577473dd93; }, function (v) { return $a13900bffe729056$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a13900bffe729056$export$b706b080d889d2c9; }, function (v) { return $a13900bffe729056$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a13900bffe729056$export$5be5a87408f70ddc; }, function (v) { return $a13900bffe729056$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a13900bffe729056$export$45a5e7f76e0caa8d; }, function (v) { return $a13900bffe729056$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a13900bffe729056$export$455c2e768291efa6; }, function (v) { return $a13900bffe729056$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a13900bffe729056$export$9522e17588c12572; }, function (v) { return $a13900bffe729056$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a13900bffe729056$export$2110ac352bb060b9; }, function (v) { return $a13900bffe729056$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a13900bffe729056$export$56885ab8b9c456ab; }, function (v) { return $a13900bffe729056$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a13900bffe729056$export$d927fcb6adf8f9de; }, function (v) { return $a13900bffe729056$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a13900bffe729056$export$b82d16f27459e05a; }, function (v) { return $a13900bffe729056$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a13900bffe729056$export$522c17b4f5e123e8; }, function (v) { return $a13900bffe729056$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a13900bffe729056$export$1aabd8a0274ecfd6; }, function (v) { return $a13900bffe729056$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $a13900bffe729056$export$3d6c20d97e46b957; }, function (v) { return $a13900bffe729056$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a13900bffe729056$export$9b621391a187a31a; }, function (v) { return $a13900bffe729056$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a13900bffe729056$export$f5bbd400c2f4426f; }, function (v) { return $a13900bffe729056$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a13900bffe729056$export$a7c73072b1a182ae;
var $a13900bffe729056$export$9f27bc3417b4524d;
var $a13900bffe729056$export$db77ccec0bb4ccac;
var $a13900bffe729056$export$8392c0c9d3dcbd35;
var $a13900bffe729056$export$ffb0004e005737fa;
var $a13900bffe729056$export$b624eff549462981;
var $a13900bffe729056$export$7897aa7841a5380c;
var $a13900bffe729056$export$602eac185826482c;
var $a13900bffe729056$export$e2c29f18771995cb;
var $a13900bffe729056$export$5f8d39834fd61797;
var $a13900bffe729056$export$74bf444e3cd11ea5;
var $a13900bffe729056$export$998bcd577473dd93;
var $a13900bffe729056$export$b706b080d889d2c9;
var $a13900bffe729056$export$5be5a87408f70ddc;
var $a13900bffe729056$export$45a5e7f76e0caa8d;
var $a13900bffe729056$export$455c2e768291efa6;
var $a13900bffe729056$export$9522e17588c12572;
var $a13900bffe729056$export$2110ac352bb060b9;
var $a13900bffe729056$export$56885ab8b9c456ab;
var $a13900bffe729056$export$d927fcb6adf8f9de;
var $a13900bffe729056$export$b82d16f27459e05a;
var $a13900bffe729056$export$522c17b4f5e123e8;
var $a13900bffe729056$export$1aabd8a0274ecfd6;
var $a13900bffe729056$export$3d6c20d97e46b957;
var $a13900bffe729056$export$9b621391a187a31a;
var $a13900bffe729056$export$f5bbd400c2f4426f;
"use strict";
var $a13900bffe729056$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a13900bffe729056$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a13900bffe729056$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a13900bffe729056$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a13900bffe729056$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $a13900bffe729056$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a13900bffe729056$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a13900bffe729056$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a13900bffe729056$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a13900bffe729056$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $a13900bffe729056$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a13900bffe729056$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a13900bffe729056$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $a13900bffe729056$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $a13900bffe729056$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $a13900bffe729056$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $a13900bffe729056$var$REACT_FRAGMENT_TYPE:
                    case $a13900bffe729056$var$REACT_PROFILER_TYPE:
                    case $a13900bffe729056$var$REACT_STRICT_MODE_TYPE:
                    case $a13900bffe729056$var$REACT_SUSPENSE_TYPE:
                    case $a13900bffe729056$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $a13900bffe729056$var$REACT_CONTEXT_TYPE:
                            case $a13900bffe729056$var$REACT_FORWARD_REF_TYPE:
                            case $a13900bffe729056$var$REACT_LAZY_TYPE:
                            case $a13900bffe729056$var$REACT_MEMO_TYPE:
                                return object;
                            case $a13900bffe729056$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $a13900bffe729056$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$a13900bffe729056$export$a7c73072b1a182ae = $a13900bffe729056$var$REACT_CONSUMER_TYPE;
$a13900bffe729056$export$9f27bc3417b4524d = $a13900bffe729056$var$REACT_CONTEXT_TYPE;
$a13900bffe729056$export$db77ccec0bb4ccac = $a13900bffe729056$var$REACT_ELEMENT_TYPE;
$a13900bffe729056$export$8392c0c9d3dcbd35 = $a13900bffe729056$var$REACT_FORWARD_REF_TYPE;
$a13900bffe729056$export$ffb0004e005737fa = $a13900bffe729056$var$REACT_FRAGMENT_TYPE;
$a13900bffe729056$export$b624eff549462981 = $a13900bffe729056$var$REACT_LAZY_TYPE;
$a13900bffe729056$export$7897aa7841a5380c = $a13900bffe729056$var$REACT_MEMO_TYPE;
$a13900bffe729056$export$602eac185826482c = $a13900bffe729056$var$REACT_PORTAL_TYPE;
$a13900bffe729056$export$e2c29f18771995cb = $a13900bffe729056$var$REACT_PROFILER_TYPE;
$a13900bffe729056$export$5f8d39834fd61797 = $a13900bffe729056$var$REACT_STRICT_MODE_TYPE;
$a13900bffe729056$export$74bf444e3cd11ea5 = $a13900bffe729056$var$REACT_SUSPENSE_TYPE;
$a13900bffe729056$export$998bcd577473dd93 = $a13900bffe729056$var$REACT_SUSPENSE_LIST_TYPE;
$a13900bffe729056$export$b706b080d889d2c9 = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_CONSUMER_TYPE;
};
$a13900bffe729056$export$5be5a87408f70ddc = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_CONTEXT_TYPE;
};
$a13900bffe729056$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a13900bffe729056$var$REACT_ELEMENT_TYPE;
};
$a13900bffe729056$export$455c2e768291efa6 = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_FORWARD_REF_TYPE;
};
$a13900bffe729056$export$9522e17588c12572 = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_FRAGMENT_TYPE;
};
$a13900bffe729056$export$2110ac352bb060b9 = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_LAZY_TYPE;
};
$a13900bffe729056$export$56885ab8b9c456ab = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_MEMO_TYPE;
};
$a13900bffe729056$export$d927fcb6adf8f9de = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_PORTAL_TYPE;
};
$a13900bffe729056$export$b82d16f27459e05a = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_PROFILER_TYPE;
};
$a13900bffe729056$export$522c17b4f5e123e8 = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_STRICT_MODE_TYPE;
};
$a13900bffe729056$export$1aabd8a0274ecfd6 = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_SUSPENSE_TYPE;
};
$a13900bffe729056$export$3d6c20d97e46b957 = function(object) {
    return $a13900bffe729056$var$typeOf(object) === $a13900bffe729056$var$REACT_SUSPENSE_LIST_TYPE;
};
$a13900bffe729056$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $a13900bffe729056$var$REACT_FRAGMENT_TYPE || type === $a13900bffe729056$var$REACT_PROFILER_TYPE || type === $a13900bffe729056$var$REACT_STRICT_MODE_TYPE || type === $a13900bffe729056$var$REACT_SUSPENSE_TYPE || type === $a13900bffe729056$var$REACT_SUSPENSE_LIST_TYPE || type === $a13900bffe729056$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $a13900bffe729056$var$REACT_LAZY_TYPE || type.$$typeof === $a13900bffe729056$var$REACT_MEMO_TYPE || type.$$typeof === $a13900bffe729056$var$REACT_CONTEXT_TYPE || type.$$typeof === $a13900bffe729056$var$REACT_CONSUMER_TYPE || type.$$typeof === $a13900bffe729056$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $a13900bffe729056$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$a13900bffe729056$export$f5bbd400c2f4426f = $a13900bffe729056$var$typeOf;

});

parcelRegister("8Cb4O", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6gRMZ.default;
    }
});

var $6gRMZ = parcelRequire("6gRMZ");

});
parcelRegister("6gRMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $490df615e94e93bb$export$2e2bcd8739ae039; });

var $3QbnI = parcelRequire("3QbnI");

var $3cOgl = parcelRequire("3cOgl");

var $e1vzu = parcelRequire("e1vzu");
'use client';
function $490df615e94e93bb$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3cOgl.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $3cOgl.default).muiName;
    return /*#__PURE__*/ $3QbnI.memo(/*#__PURE__*/ $3QbnI.forwardRef(Component));
}

});
parcelRegister("3cOgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25597b2ea9c795bd$export$2e2bcd8739ae039; });

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $iCj5F = parcelRequire("iCj5F");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $iXYVf = parcelRequire("iXYVf");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $25597b2ea9c795bd$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $iCj5F.default)(color)}`,
            `fontSize${(0, $iCj5F.default)(fontSize)}`
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $iXYVf.getSvgIconUtilityClass), classes);
};
const $25597b2ea9c795bd$var$SvgIconRoot = (0, $2TGnx.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $iCj5F.default)(ownerState.color)}`],
            styles[`fontSize${(0, $iCj5F.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $25597b2ea9c795bd$var$SvgIcon = /*#__PURE__*/ $3QbnI.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $3QbnI.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $25597b2ea9c795bd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($25597b2ea9c795bd$var$SvgIconRoot, {
        as: component,
        className: (0, $eTLbi.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $e1vzu.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
if ($25597b2ea9c795bd$var$SvgIcon) $25597b2ea9c795bd$var$SvgIcon.muiName = 'SvgIcon';
var $25597b2ea9c795bd$export$2e2bcd8739ae039 = $25597b2ea9c795bd$var$SvgIcon;

});
parcelRegister("eTLbi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cb909bd25998edc$export$2e2bcd8739ae039; });
function $5cb909bd25998edc$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $5cb909bd25998edc$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $5cb909bd25998edc$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $5cb909bd25998edc$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5cb909bd25998edc$export$2e2bcd8739ae039 = $5cb909bd25998edc$export$4f5d2d50c9deca37;

});

parcelRegister("6q4c0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ac86c577bd84338$export$2e2bcd8739ae039; });
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $4ac86c577bd84338$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("iCj5F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8da95943d94ed3c$export$2e2bcd8739ae039; });

var $kJVS9 = parcelRequire("kJVS9");
var $d8da95943d94ed3c$export$2e2bcd8739ae039 = (0, $kJVS9.default);

});
parcelRegister("kJVS9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f194e6d9bb092d11$export$2e2bcd8739ae039; });

var $eClrZ = parcelRequire("eClrZ");
function $f194e6d9bb092d11$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $eClrZ.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("eClrZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa4540e3acd56645$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $aa4540e3acd56645$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});



parcelRegister("2TGnx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21c197525077e77f$export$2e2bcd8739ae039; });

var $2rj5K = parcelRequire("2rj5K");

var $cxyce = parcelRequire("cxyce");

var $9t00Y = parcelRequire("9t00Y");

var $ajKPH = parcelRequire("ajKPH");

'use client';
const $21c197525077e77f$var$styled = (0, $2rj5K.default)({
    themeId: (0, $9t00Y.default),
    defaultTheme: $cxyce.default,
    rootShouldForwardProp: $ajKPH.default
});
var $21c197525077e77f$export$2e2bcd8739ae039 = $21c197525077e77f$var$styled;

});
parcelRegister("2rj5K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c6ce997f56ffe21$export$2e2bcd8739ae039; });

var $c4XO5 = parcelRequire("c4XO5");

var $6s3yU = parcelRequire("6s3yU");

var $kJVS9 = parcelRequire("kJVS9");

var $eF4qW = parcelRequire("eF4qW");

var $aTv5Z = parcelRequire("aTv5Z");

var $hhWLk = parcelRequire("hhWLk");

var $5CT8V = parcelRequire("5CT8V");
const $1c6ce997f56ffe21$export$35e57303dbd8a66 = (0, $aTv5Z.default)();
function $1c6ce997f56ffe21$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $1c6ce997f56ffe21$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $1c6ce997f56ffe21$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $1c6ce997f56ffe21$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $1c6ce997f56ffe21$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$1c6ce997f56ffe21$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $1c6ce997f56ffe21$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $1c6ce997f56ffe21$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $1c6ce997f56ffe21$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $1c6ce997f56ffe21$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $1c6ce997f56ffe21$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $1c6ce997f56ffe21$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $1c6ce997f56ffe21$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $c4XO5.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $hhWLk.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $1c6ce997f56ffe21$var$defaultOverridesResolver($1c6ce997f56ffe21$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $1c6ce997f56ffe21$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($1c6ce997f56ffe21$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $c4XO5.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $1c6ce997f56ffe21$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === 'function' && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $1c6ce997f56ffe21$var$processStyle(props, style);
            };
            if ((0, $6s3yU.isPlainObject)(style)) {
                const serialized = (0, $5CT8V.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $1c6ce997f56ffe21$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $1c6ce997f56ffe21$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $1c6ce997f56ffe21$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $hhWLk.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $1c6ce997f56ffe21$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $kJVS9.default)(componentSlot || '')}`;
    return `Styled(${(0, $eF4qW.default)(tag)})`;
}
function $1c6ce997f56ffe21$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $1c6ce997f56ffe21$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $1c6ce997f56ffe21$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $1c6ce997f56ffe21$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("c4XO5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cb4402c020a1657$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $8cb4402c020a1657$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $8cb4402c020a1657$export$13a2d3ef13012b32; });
/**
 * @mui/styled-engine v6.2.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $dZn4h = parcelRequire("dZn4h");

var $NHV6R = parcelRequire("NHV6R");

var $fPIjG = parcelRequire("fPIjG");
var $54BtZ = parcelRequire("54BtZ");


var $3MMEU = parcelRequire("3MMEU");
function $8cb4402c020a1657$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $dZn4h.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $8cb4402c020a1657$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $8cb4402c020a1657$var$wrapper = [];
function $8cb4402c020a1657$export$13a2d3ef13012b32(styles) {
    $8cb4402c020a1657$var$wrapper[0] = styles;
    return (0, $NHV6R.serializeStyles)($8cb4402c020a1657$var$wrapper);
}

});
parcelRegister("dZn4h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2f2ddafee1fbfe8$export$2e2bcd8739ae039; });

var $8Ur3E = parcelRequire("8Ur3E");
parcelRequire("eEqN4");

parcelRequire("NHV6R");
parcelRequire("3KTx4");
parcelRequire("eV8kv");
parcelRequire("3QbnI");
parcelRequire("emYta");
var $a2f2ddafee1fbfe8$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $a2f2ddafee1fbfe8$export$2e2bcd8739ae039 = (0, $8Ur3E.default).bind(null);
$a2f2ddafee1fbfe8$var$tags.forEach(function(tagName) {
    $a2f2ddafee1fbfe8$export$2e2bcd8739ae039[tagName] = $a2f2ddafee1fbfe8$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("8Ur3E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67c88ad8b7fb2815$export$2e2bcd8739ae039; });

var $d0aSw = parcelRequire("d0aSw");
parcelRequire("fPIjG");
var $54BtZ = parcelRequire("54BtZ");

var $NHV6R = parcelRequire("NHV6R");

var $3KTx4 = parcelRequire("3KTx4");

var $eV8kv = parcelRequire("eV8kv");

var $3QbnI = parcelRequire("3QbnI");

var $emYta = parcelRequire("emYta");
var $67c88ad8b7fb2815$var$isBrowser = typeof document !== 'undefined';
var $67c88ad8b7fb2815$var$isDevelopment = false;
var $67c88ad8b7fb2815$var$testOmitPropsOnStringTag = (0, $emYta.default);
var $67c88ad8b7fb2815$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $67c88ad8b7fb2815$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $67c88ad8b7fb2815$var$testOmitPropsOnStringTag : $67c88ad8b7fb2815$var$testOmitPropsOnComponent;
};
var $67c88ad8b7fb2815$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $67c88ad8b7fb2815$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eV8kv.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $3KTx4.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eV8kv.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$67c88ad8b7fb2815$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $3QbnI.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $67c88ad8b7fb2815$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $67c88ad8b7fb2815$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $67c88ad8b7fb2815$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $54BtZ.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $3QbnI.useContext((0, $54BtZ.T));
            }
            if (typeof props.className === 'string') className = (0, $eV8kv.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $NHV6R.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $67c88ad8b7fb2815$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement($67c88ad8b7fb2815$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $3QbnI.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $67c88ad8b7fb2815$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $d0aSw.default)({}, options, nextOptions, {
                shouldForwardProp: $67c88ad8b7fb2815$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("d0aSw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9773b6a5491c527c$export$2e2bcd8739ae039; });
function $9773b6a5491c527c$export$2e2bcd8739ae039() {
    return $9773b6a5491c527c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9773b6a5491c527c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fPIjG", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $b86dfec4559889df$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $b86dfec4559889df$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $b86dfec4559889df$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("54BtZ")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("54BtZ")).w; });

var $54BtZ = parcelRequire("54BtZ");

var $3QbnI = parcelRequire("3QbnI");

var $eV8kv = parcelRequire("eV8kv");

var $3KTx4 = parcelRequire("3KTx4");

var $NHV6R = parcelRequire("NHV6R");
parcelRequire("eR9l4");
parcelRequire("eEqN4");
parcelRequire("a7GUy");

parcelRequire("8FL51");
var $b86dfec4559889df$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $54BtZ.h).call(props, 'css')) return $3QbnI.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $54BtZ.E);
    createElementArgArray[1] = (0, $54BtZ.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $3QbnI.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($b86dfec4559889df$export$c8a8987d4410bf2d || ($b86dfec4559889df$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b86dfec4559889df$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $54BtZ.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $NHV6R.serializeStyles)([
        styles
    ], undefined, $3QbnI.useContext((0, $54BtZ.T)));
    if (!(0, $54BtZ.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $3QbnI.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $3QbnI.useRef();
    (0, $3KTx4.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $3KTx4.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $eV8kv.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $b86dfec4559889df$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $NHV6R.serializeStyles)(args);
}
function $b86dfec4559889df$export$d25ddfdf17c3ad3e() {
    var insertable = $b86dfec4559889df$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $b86dfec4559889df$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $b86dfec4559889df$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $eV8kv.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b86dfec4559889df$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $3KTx4.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $eV8kv.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $54BtZ.i) && res !== undefined) rules += res;
        }
        if (!(0, $54BtZ.i)) return rules;
    });
    if (!(0, $54BtZ.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $3QbnI.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $b86dfec4559889df$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $54BtZ.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $54BtZ.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $NHV6R.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $eV8kv.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $54BtZ.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b86dfec4559889df$var$merge(cache.registered, css, $b86dfec4559889df$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $3QbnI.useContext((0, $54BtZ.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement($b86dfec4559889df$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("54BtZ", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $3b1a66c7ff4bee34$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $3b1a66c7ff4bee34$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $3b1a66c7ff4bee34$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $3b1a66c7ff4bee34$export$971d5caa766a69d7; });
$parcel$export(module.exports, "b", function () { return $3b1a66c7ff4bee34$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "h", function () { return $3b1a66c7ff4bee34$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $3b1a66c7ff4bee34$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $3b1a66c7ff4bee34$export$a9c23c6ac3fc3eca; });

var $3QbnI = parcelRequire("3QbnI");

var $eR9l4 = parcelRequire("eR9l4");

var $d0aSw = parcelRequire("d0aSw");

var $a7GUy = parcelRequire("a7GUy");

var $jOseu = parcelRequire("jOseu");

var $eV8kv = parcelRequire("eV8kv");

var $NHV6R = parcelRequire("NHV6R");

var $3KTx4 = parcelRequire("3KTx4");
var $3b1a66c7ff4bee34$export$407448d2b89b1813 = false;
var $3b1a66c7ff4bee34$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $3b1a66c7ff4bee34$var$EmotionCacheContext = /* #__PURE__ */ $3QbnI.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $eR9l4.default)({
    key: 'css'
}) : null);
var $3b1a66c7ff4bee34$export$e7094788287c5e9b = $3b1a66c7ff4bee34$var$EmotionCacheContext.Provider;
var $3b1a66c7ff4bee34$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $3QbnI.useContext)($3b1a66c7ff4bee34$var$EmotionCacheContext);
};
var $3b1a66c7ff4bee34$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $3QbnI.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $3QbnI.useContext)($3b1a66c7ff4bee34$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$3b1a66c7ff4bee34$export$23f2a1d2818174ef) $3b1a66c7ff4bee34$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $3QbnI.useContext)($3b1a66c7ff4bee34$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $eR9l4.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $3QbnI.createElement($3b1a66c7ff4bee34$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $3b1a66c7ff4bee34$export$971d5caa766a69d7 = /* #__PURE__ */ $3QbnI.createContext({});
var $3b1a66c7ff4bee34$export$3b14a55fb2447963 = function useTheme() {
    return $3QbnI.useContext($3b1a66c7ff4bee34$export$971d5caa766a69d7);
};
var $3b1a66c7ff4bee34$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $d0aSw.default)({}, outerTheme, theme);
};
var $3b1a66c7ff4bee34$var$createCacheWithTheme = /* #__PURE__ */ (0, $a7GUy.default)(function(outerTheme) {
    return (0, $a7GUy.default)(function(theme) {
        return $3b1a66c7ff4bee34$var$getTheme(outerTheme, theme);
    });
});
var $3b1a66c7ff4bee34$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $3QbnI.useContext($3b1a66c7ff4bee34$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $3b1a66c7ff4bee34$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $3QbnI.createElement($3b1a66c7ff4bee34$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $3b1a66c7ff4bee34$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $3QbnI.forwardRef(function render(props, ref) {
        var theme = $3QbnI.useContext($3b1a66c7ff4bee34$export$971d5caa766a69d7);
        return /*#__PURE__*/ $3QbnI.createElement(Component, (0, $d0aSw.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $jOseu.default)(WithTheme, Component);
}
var $3b1a66c7ff4bee34$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $3b1a66c7ff4bee34$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $3b1a66c7ff4bee34$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($3b1a66c7ff4bee34$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$3b1a66c7ff4bee34$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $3b1a66c7ff4bee34$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eV8kv.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $3KTx4.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eV8kv.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$3b1a66c7ff4bee34$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $3QbnI.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3b1a66c7ff4bee34$var$Emotion = /* #__PURE__ */ $3b1a66c7ff4bee34$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$3b1a66c7ff4bee34$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $eV8kv.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $NHV6R.serializeStyles)(registeredStyles, undefined, $3QbnI.useContext($3b1a66c7ff4bee34$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($3b1a66c7ff4bee34$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $3b1a66c7ff4bee34$var$typePropName && !$3b1a66c7ff4bee34$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement($3b1a66c7ff4bee34$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $3QbnI.createElement(WrappedComponent, newProps));
});
var $3b1a66c7ff4bee34$export$a9c23c6ac3fc3eca = $3b1a66c7ff4bee34$var$Emotion;

});
parcelRegister("eR9l4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad0d426da07bcd90$export$2e2bcd8739ae039; });

var $8z9qd = parcelRequire("8z9qd");

var $dttdf = parcelRequire("dttdf");

var $a7GUy = parcelRequire("a7GUy");

var $euCgl = parcelRequire("euCgl");
var $ad0d426da07bcd90$var$isBrowser = typeof document !== 'undefined';
var $ad0d426da07bcd90$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $dttdf.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $dttdf.token)(character)) break;
        (0, $dttdf.next)();
    }
    return (0, $dttdf.slice)(begin, (0, $dttdf.position));
};
var $ad0d426da07bcd90$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $dttdf.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $dttdf.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $ad0d426da07bcd90$var$identifierWithPointTracking((0, $dttdf.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $dttdf.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $dttdf.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $dttdf.from)(character);
    }
    while (character = (0, $dttdf.next)());
    return parsed;
};
var $ad0d426da07bcd90$var$getRules = function getRules(value, points) {
    return (0, $dttdf.dealloc)($ad0d426da07bcd90$var$toRules((0, $dttdf.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $ad0d426da07bcd90$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $ad0d426da07bcd90$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$ad0d426da07bcd90$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $ad0d426da07bcd90$var$fixedElements.set(element, true);
    var points = [];
    var rules = $ad0d426da07bcd90$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $ad0d426da07bcd90$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $ad0d426da07bcd90$var$prefix(value, length) {
    switch((0, $dttdf.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $dttdf.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $dttdf.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MOZ) + value + (0, $dttdf.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + value + value;
        // order
        case 6165:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.replace)(value, /(\w+).+(:[^]+)/, (0, $dttdf.WEBKIT) + 'box-$1$2' + (0, $dttdf.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + 'flex-item-' + (0, $dttdf.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + 'flex-line-pack' + (0, $dttdf.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $dttdf.WEBKIT) + 'box-' + (0, $dttdf.replace)(value, '-grow', '') + (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $dttdf.WEBKIT) + (0, $dttdf.replace)(value, /([^-])(transform)/g, '$1' + (0, $dttdf.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $dttdf.replace)((0, $dttdf.replace)((0, $dttdf.replace)(value, /(zoom-|grab)/, (0, $dttdf.WEBKIT) + '$1'), /(image-set)/, (0, $dttdf.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $dttdf.replace)(value, /(image-set\([^]*)/, (0, $dttdf.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $dttdf.replace)((0, $dttdf.replace)(value, /(.+:)(flex-)?(.*)/, (0, $dttdf.WEBKIT) + 'box-pack:$3' + (0, $dttdf.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $dttdf.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $dttdf.replace)(value, /(.+)-inline(.+)/, (0, $dttdf.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $dttdf.strlen)(value) - 1 - length > 6) switch((0, $dttdf.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $dttdf.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $dttdf.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $dttdf.WEBKIT) + '$2-$3' + '$1' + (0, $dttdf.MOZ) + ((0, $dttdf.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $dttdf.indexof)(value, 'stretch') ? $ad0d426da07bcd90$var$prefix((0, $dttdf.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $dttdf.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $dttdf.charat)(value, (0, $dttdf.strlen)(value) - 3 - (~(0, $dttdf.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $dttdf.replace)(value, ':', ':' + (0, $dttdf.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $dttdf.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $dttdf.WEBKIT) + ((0, $dttdf.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $dttdf.WEBKIT) + '$2$3' + '$1' + (0, $dttdf.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $dttdf.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + value + value;
    }
    return value;
}
var $ad0d426da07bcd90$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $dttdf.DECLARATION:
                element["return"] = $ad0d426da07bcd90$var$prefix(element.value, element.length);
                break;
            case 0, $dttdf.KEYFRAMES:
                return (0, $dttdf.serialize)([
                    (0, $dttdf.copy)(element, {
                        value: (0, $dttdf.replace)(element.value, '@', '@' + (0, $dttdf.WEBKIT))
                    })
                ], callback);
            case 0, $dttdf.RULESET:
                if (element.length) return (0, $dttdf.combine)(element.props, function(value) {
                    switch((0, $dttdf.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $dttdf.serialize)([
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(read-\w+)/, ':' + (0, $dttdf.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $dttdf.serialize)([
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(plac\w+)/, ':' + (0, $dttdf.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(plac\w+)/, ':' + (0, $dttdf.MOZ) + '$1')
                                    ]
                                }),
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(plac\w+)/, (0, $dttdf.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $ad0d426da07bcd90$var$getServerStylisCache = $ad0d426da07bcd90$var$isBrowser ? undefined : (0, $a7GUy.default)(function() {
    return (0, $euCgl.default)(function() {
        return {};
    });
});
var $ad0d426da07bcd90$var$defaultStylisPlugins = [
    $ad0d426da07bcd90$var$prefixer
];
var $ad0d426da07bcd90$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($ad0d426da07bcd90$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $ad0d426da07bcd90$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($ad0d426da07bcd90$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $ad0d426da07bcd90$var$compat,
        $ad0d426da07bcd90$var$removeLabel
    ];
    if (!$ad0d426da07bcd90$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $dttdf.stringify),
            (0, $dttdf.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $dttdf.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $dttdf.serialize)((0, $dttdf.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $dttdf.stringify)
        ];
        var _serializer = (0, $dttdf.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $dttdf.serialize)((0, $dttdf.compile)(styles), _serializer);
        };
        var serverStylisCache = $ad0d426da07bcd90$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $8z9qd.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("8z9qd", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $63c8e6969fd44d0d$export$9d753cd7ae895cce; });
var $63c8e6969fd44d0d$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $63c8e6969fd44d0d$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $63c8e6969fd44d0d$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $63c8e6969fd44d0d$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$63c8e6969fd44d0d$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($63c8e6969fd44d0d$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $63c8e6969fd44d0d$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("dttdf", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $045d360cdc2debe1$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $045d360cdc2debe1$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $045d360cdc2debe1$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $045d360cdc2debe1$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $045d360cdc2debe1$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $045d360cdc2debe1$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $045d360cdc2debe1$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $045d360cdc2debe1$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $045d360cdc2debe1$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $045d360cdc2debe1$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $045d360cdc2debe1$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $045d360cdc2debe1$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $045d360cdc2debe1$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $045d360cdc2debe1$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $045d360cdc2debe1$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $045d360cdc2debe1$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $045d360cdc2debe1$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $045d360cdc2debe1$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $045d360cdc2debe1$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $045d360cdc2debe1$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $045d360cdc2debe1$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $045d360cdc2debe1$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $045d360cdc2debe1$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $045d360cdc2debe1$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $045d360cdc2debe1$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $045d360cdc2debe1$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $045d360cdc2debe1$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $045d360cdc2debe1$export$38bcb760f1d4871c; });
var $045d360cdc2debe1$export$71ad59f2e432cfe8 = "-ms-";
var $045d360cdc2debe1$export$2c0f367103c8d01c = "-moz-";
var $045d360cdc2debe1$export$39dfd62a25e0fe93 = "-webkit-";
var $045d360cdc2debe1$export$a29989082612d0d9 = "comm";
var $045d360cdc2debe1$export$aa3a2e812ca8570d = "rule";
var $045d360cdc2debe1$export$527d108ccf083c2b = "decl";
var $045d360cdc2debe1$export$d3d35020fa5b54f0 = "@page";
var $045d360cdc2debe1$export$500415a86c544f73 = "@media";
var $045d360cdc2debe1$export$a763edbf796b780a = "@import";
var $045d360cdc2debe1$export$2790aeb8b4e5c826 = "@charset";
var $045d360cdc2debe1$export$1cc683e23b84b133 = "@viewport";
var $045d360cdc2debe1$export$9447a5efea57e862 = "@supports";
var $045d360cdc2debe1$export$ef011b4e114b1fba = "@document";
var $045d360cdc2debe1$export$6aad947bda0f3f46 = "@namespace";
var $045d360cdc2debe1$export$b44a8529a35fcb60 = "@keyframes";
var $045d360cdc2debe1$export$2c16de31893252e6 = "@font-face";
var $045d360cdc2debe1$export$3d846dd52e150c6f = "@counter-style";
var $045d360cdc2debe1$export$22314bfbb57653fe = "@font-feature-values";
var $045d360cdc2debe1$export$d773506282b3cfe6 = "@layer";
var $045d360cdc2debe1$export$2335f513bbd82c6d = Math.abs;
var $045d360cdc2debe1$export$6788812c4e6611e6 = String.fromCharCode;
var $045d360cdc2debe1$export$e6e34fd1f2686227 = Object.assign;
function $045d360cdc2debe1$export$d6af199866bfb566(e, r) {
    return $045d360cdc2debe1$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 0)) << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 1)) << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 2)) << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 3) : 0;
}
function $045d360cdc2debe1$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $045d360cdc2debe1$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $045d360cdc2debe1$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $045d360cdc2debe1$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $045d360cdc2debe1$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $045d360cdc2debe1$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $045d360cdc2debe1$export$36776f635604f274(e) {
    return e.length;
}
function $045d360cdc2debe1$export$f9084667e487ed46(e) {
    return e.length;
}
function $045d360cdc2debe1$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $045d360cdc2debe1$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $045d360cdc2debe1$export$53f1d5ea8de3d7c = 1;
var $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1;
var $045d360cdc2debe1$export$f24224f1c91d8156 = 0;
var $045d360cdc2debe1$export$5880b8b5730aff45 = 0;
var $045d360cdc2debe1$export$c0306caf338ac095 = 0;
var $045d360cdc2debe1$export$30a86d91af8ff6e6 = "";
function $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $045d360cdc2debe1$export$53f1d5ea8de3d7c,
        column: $045d360cdc2debe1$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $045d360cdc2debe1$export$784d13d8ee351f07(e, r) {
    return $045d360cdc2debe1$export$e6e34fd1f2686227($045d360cdc2debe1$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $045d360cdc2debe1$export$eba6f6f03b0a92e7() {
    return $045d360cdc2debe1$export$c0306caf338ac095;
}
function $045d360cdc2debe1$export$232faf9add678146() {
    $045d360cdc2debe1$export$c0306caf338ac095 = $045d360cdc2debe1$export$5880b8b5730aff45 > 0 ? $045d360cdc2debe1$export$a9db5e087081082d($045d360cdc2debe1$export$30a86d91af8ff6e6, --$045d360cdc2debe1$export$5880b8b5730aff45) : 0;
    if ($045d360cdc2debe1$export$4e0c71f277ca26b3--, $045d360cdc2debe1$export$c0306caf338ac095 === 10) $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1, $045d360cdc2debe1$export$53f1d5ea8de3d7c--;
    return $045d360cdc2debe1$export$c0306caf338ac095;
}
function $045d360cdc2debe1$export$48cfd1e771a65c4f() {
    $045d360cdc2debe1$export$c0306caf338ac095 = $045d360cdc2debe1$export$5880b8b5730aff45 < $045d360cdc2debe1$export$f24224f1c91d8156 ? $045d360cdc2debe1$export$a9db5e087081082d($045d360cdc2debe1$export$30a86d91af8ff6e6, $045d360cdc2debe1$export$5880b8b5730aff45++) : 0;
    if ($045d360cdc2debe1$export$4e0c71f277ca26b3++, $045d360cdc2debe1$export$c0306caf338ac095 === 10) $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1, $045d360cdc2debe1$export$53f1d5ea8de3d7c++;
    return $045d360cdc2debe1$export$c0306caf338ac095;
}
function $045d360cdc2debe1$export$4d3fb11e950abb9e() {
    return $045d360cdc2debe1$export$a9db5e087081082d($045d360cdc2debe1$export$30a86d91af8ff6e6, $045d360cdc2debe1$export$5880b8b5730aff45);
}
function $045d360cdc2debe1$export$e88cb2efb12ae807() {
    return $045d360cdc2debe1$export$5880b8b5730aff45;
}
function $045d360cdc2debe1$export$58adb3bec8346d0f(e, r) {
    return $045d360cdc2debe1$export$2f35ab04d2335697($045d360cdc2debe1$export$30a86d91af8ff6e6, e, r);
}
function $045d360cdc2debe1$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $045d360cdc2debe1$export$2de70f21292aac9e(e) {
    return $045d360cdc2debe1$export$53f1d5ea8de3d7c = $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1, $045d360cdc2debe1$export$f24224f1c91d8156 = $045d360cdc2debe1$export$36776f635604f274($045d360cdc2debe1$export$30a86d91af8ff6e6 = e), $045d360cdc2debe1$export$5880b8b5730aff45 = 0, [];
}
function $045d360cdc2debe1$export$45918ac1574455b1(e) {
    return $045d360cdc2debe1$export$30a86d91af8ff6e6 = "", e;
}
function $045d360cdc2debe1$export$410ac95b9ec204b8(e) {
    return $045d360cdc2debe1$export$87c2784dc9fc4ab($045d360cdc2debe1$export$58adb3bec8346d0f($045d360cdc2debe1$export$5880b8b5730aff45 - 1, $045d360cdc2debe1$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $045d360cdc2debe1$export$660b2ee2d4fb4eff(e) {
    return $045d360cdc2debe1$export$45918ac1574455b1($045d360cdc2debe1$export$5f8c09e3ae6f64e1($045d360cdc2debe1$export$2de70f21292aac9e(e)));
}
function $045d360cdc2debe1$export$7af1228ff777d175(e) {
    while($045d360cdc2debe1$export$c0306caf338ac095 = $045d360cdc2debe1$export$4d3fb11e950abb9e())if ($045d360cdc2debe1$export$c0306caf338ac095 < 33) $045d360cdc2debe1$export$48cfd1e771a65c4f();
    else break;
    return $045d360cdc2debe1$export$9e1725a4cfeada27(e) > 2 || $045d360cdc2debe1$export$9e1725a4cfeada27($045d360cdc2debe1$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $045d360cdc2debe1$export$5f8c09e3ae6f64e1(e) {
    while($045d360cdc2debe1$export$48cfd1e771a65c4f())switch($045d360cdc2debe1$export$9e1725a4cfeada27($045d360cdc2debe1$export$c0306caf338ac095)){
        case 0:
            $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$c2ab62c7bf24634($045d360cdc2debe1$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$410ac95b9ec204b8($045d360cdc2debe1$export$c0306caf338ac095), e);
            break;
        default:
            $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$6788812c4e6611e6($045d360cdc2debe1$export$c0306caf338ac095), e);
    }
    return e;
}
function $045d360cdc2debe1$export$955ba06d119e085e(e, r) {
    while(--r && $045d360cdc2debe1$export$48cfd1e771a65c4f())if ($045d360cdc2debe1$export$c0306caf338ac095 < 48 || $045d360cdc2debe1$export$c0306caf338ac095 > 102 || $045d360cdc2debe1$export$c0306caf338ac095 > 57 && $045d360cdc2debe1$export$c0306caf338ac095 < 65 || $045d360cdc2debe1$export$c0306caf338ac095 > 70 && $045d360cdc2debe1$export$c0306caf338ac095 < 97) break;
    return $045d360cdc2debe1$export$58adb3bec8346d0f(e, $045d360cdc2debe1$export$e88cb2efb12ae807() + (r < 6 && $045d360cdc2debe1$export$4d3fb11e950abb9e() == 32 && $045d360cdc2debe1$export$48cfd1e771a65c4f() == 32));
}
function $045d360cdc2debe1$export$c889f2fcc19dbf12(e) {
    while($045d360cdc2debe1$export$48cfd1e771a65c4f())switch($045d360cdc2debe1$export$c0306caf338ac095){
        case e:
            return $045d360cdc2debe1$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $045d360cdc2debe1$export$c889f2fcc19dbf12($045d360cdc2debe1$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $045d360cdc2debe1$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $045d360cdc2debe1$export$48cfd1e771a65c4f();
            break;
    }
    return $045d360cdc2debe1$export$5880b8b5730aff45;
}
function $045d360cdc2debe1$export$4254d4e2b3745c4c(e, r) {
    while($045d360cdc2debe1$export$48cfd1e771a65c4f())if (e + $045d360cdc2debe1$export$c0306caf338ac095 === 57) break;
    else if (e + $045d360cdc2debe1$export$c0306caf338ac095 === 84 && $045d360cdc2debe1$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $045d360cdc2debe1$export$58adb3bec8346d0f(r, $045d360cdc2debe1$export$5880b8b5730aff45 - 1) + "*" + $045d360cdc2debe1$export$6788812c4e6611e6(e === 47 ? e : $045d360cdc2debe1$export$48cfd1e771a65c4f());
}
function $045d360cdc2debe1$export$c2ab62c7bf24634(e) {
    while(!$045d360cdc2debe1$export$9e1725a4cfeada27($045d360cdc2debe1$export$4d3fb11e950abb9e()))$045d360cdc2debe1$export$48cfd1e771a65c4f();
    return $045d360cdc2debe1$export$58adb3bec8346d0f(e, $045d360cdc2debe1$export$5880b8b5730aff45);
}
function $045d360cdc2debe1$export$ef7acd7185315e22(e) {
    return $045d360cdc2debe1$export$45918ac1574455b1($045d360cdc2debe1$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $045d360cdc2debe1$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $045d360cdc2debe1$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $045d360cdc2debe1$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $045d360cdc2debe1$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($045d360cdc2debe1$export$f8e21b1e77979a08(j += $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $045d360cdc2debe1$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $045d360cdc2debe1$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $045d360cdc2debe1$export$955ba06d119e085e($045d360cdc2debe1$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($045d360cdc2debe1$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$4a34f930e789283c($045d360cdc2debe1$export$4254d4e2b3745c4c($045d360cdc2debe1$export$48cfd1e771a65c4f(), $045d360cdc2debe1$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $045d360cdc2debe1$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $045d360cdc2debe1$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $045d360cdc2debe1$export$36776f635604f274(j) - l) $045d360cdc2debe1$export$10d8903dec122b9d(p > 32 ? $045d360cdc2debe1$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $045d360cdc2debe1$export$f8483753829ec8f3($045d360cdc2debe1$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $045d360cdc2debe1$export$10d8903dec122b9d(y = $045d360cdc2debe1$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $045d360cdc2debe1$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $045d360cdc2debe1$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $045d360cdc2debe1$export$98e6a39c04603d36(e, y, y, n && $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $045d360cdc2debe1$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $045d360cdc2debe1$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $045d360cdc2debe1$export$232faf9add678146() == 125) continue;
            }
            switch(j += $045d360cdc2debe1$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($045d360cdc2debe1$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($045d360cdc2debe1$export$4d3fb11e950abb9e() === 45) j += $045d360cdc2debe1$export$410ac95b9ec204b8($045d360cdc2debe1$export$48cfd1e771a65c4f());
                    v = $045d360cdc2debe1$export$4d3fb11e950abb9e(), o = l = $045d360cdc2debe1$export$36776f635604f274(g = j += $045d360cdc2debe1$export$c2ab62c7bf24634($045d360cdc2debe1$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $045d360cdc2debe1$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $045d360cdc2debe1$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $045d360cdc2debe1$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $045d360cdc2debe1$export$2f35ab04d2335697(e, v + 1, v = $045d360cdc2debe1$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $045d360cdc2debe1$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $045d360cdc2debe1$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, s === 0 ? $045d360cdc2debe1$export$aa3a2e812ca8570d : i, f, o, l);
}
function $045d360cdc2debe1$export$4a34f930e789283c(e, r, a) {
    return $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, $045d360cdc2debe1$export$a29989082612d0d9, $045d360cdc2debe1$export$6788812c4e6611e6($045d360cdc2debe1$export$eba6f6f03b0a92e7()), $045d360cdc2debe1$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $045d360cdc2debe1$export$f8483753829ec8f3(e, r, a, n) {
    return $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, $045d360cdc2debe1$export$527d108ccf083c2b, $045d360cdc2debe1$export$2f35ab04d2335697(e, 0, n), $045d360cdc2debe1$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $045d360cdc2debe1$export$82e9f45cca5ba907(n, c, s) {
    switch($045d360cdc2debe1$export$d6af199866bfb566(n, c)){
        case 5103:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $045d360cdc2debe1$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$2c0f367103c8d01c + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($045d360cdc2debe1$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "box-$1$2" + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-item-" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$045d360cdc2debe1$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $045d360cdc2debe1$export$71ad59f2e432cfe8 + "grid-row-" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-line-pack" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + "box-" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-grow", "") + $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "box-pack:$3" + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$045d360cdc2debe1$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $045d360cdc2debe1$export$71ad59f2e432cfe8 + "grid-column-align" + $045d360cdc2debe1$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $045d360cdc2debe1$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$045d360cdc2debe1$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$045d360cdc2debe1$export$f8e21b1e77979a08(s, "span") ? $045d360cdc2debe1$export$4659b591c19bdf3d(s, /\d+/) : +$045d360cdc2debe1$export$4659b591c19bdf3d(s, /\d+/) - +$045d360cdc2debe1$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $045d360cdc2debe1$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($045d360cdc2debe1$export$36776f635604f274(n) - 1 - c > 6) switch($045d360cdc2debe1$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($045d360cdc2debe1$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $045d360cdc2debe1$export$2c0f367103c8d01c + ($045d360cdc2debe1$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$045d360cdc2debe1$export$f8e21b1e77979a08(n, "stretch") ? $045d360cdc2debe1$export$82e9f45cca5ba907($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $045d360cdc2debe1$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $045d360cdc2debe1$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($045d360cdc2debe1$export$a9db5e087081082d(n, c + 6) === 121) return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, ":", ":" + $045d360cdc2debe1$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($045d360cdc2debe1$export$a9db5e087081082d(n, $045d360cdc2debe1$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + ($045d360cdc2debe1$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, ":", ":" + $045d360cdc2debe1$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $045d360cdc2debe1$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $045d360cdc2debe1$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $045d360cdc2debe1$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $045d360cdc2debe1$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $045d360cdc2debe1$export$a763edbf796b780a:
        case $045d360cdc2debe1$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $045d360cdc2debe1$export$a29989082612d0d9:
            return "";
        case $045d360cdc2debe1$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $045d360cdc2debe1$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $045d360cdc2debe1$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $045d360cdc2debe1$export$36776f635604f274(a = $045d360cdc2debe1$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $045d360cdc2debe1$export$5a7767152ae0305f(e) {
    var r = $045d360cdc2debe1$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $045d360cdc2debe1$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $045d360cdc2debe1$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $045d360cdc2debe1$export$527d108ccf083c2b:
                n.return = $045d360cdc2debe1$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $045d360cdc2debe1$export$b44a8529a35fcb60:
                return $045d360cdc2debe1$export$dfdc1655ccc5b9cb([
                    $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                        value: $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $045d360cdc2debe1$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $045d360cdc2debe1$export$aa3a2e812ca8570d:
                if (n.length) return $045d360cdc2debe1$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($045d360cdc2debe1$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $045d360cdc2debe1$export$dfdc1655ccc5b9cb([
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $045d360cdc2debe1$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $045d360cdc2debe1$export$dfdc1655ccc5b9cb([
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $045d360cdc2debe1$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $045d360cdc2debe1$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $045d360cdc2debe1$export$76a88f7de6507443(e) {
    switch(e.type){
        case $045d360cdc2debe1$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $045d360cdc2debe1$export$1be1fc439b849fdf($045d360cdc2debe1$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($045d360cdc2debe1$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $045d360cdc2debe1$export$2f35ab04d2335697(r, 1, $045d360cdc2debe1$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $045d360cdc2debe1$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $045d360cdc2debe1$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $045d360cdc2debe1$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("a7GUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ebd8179b7036a0$export$2e2bcd8739ae039; });
var $75ebd8179b7036a0$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("euCgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8d18c2a60ba03d6$export$2e2bcd8739ae039; });
function $a8d18c2a60ba03d6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jOseu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c896405a255cbb$export$2e2bcd8739ae039; });

var $8FL51 = parcelRequire("8FL51");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $e6c896405a255cbb$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(targetComponent, sourceComponent);
};

});
parcelRegister("8FL51", function(module, exports) {
'use strict';

var $jy66G = parcelRequire("jy66G");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $6506ac27a174cdb1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $6506ac27a174cdb1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $6506ac27a174cdb1$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $6506ac27a174cdb1$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $6506ac27a174cdb1$var$TYPE_STATICS = {};
$6506ac27a174cdb1$var$TYPE_STATICS[$jy66G.ForwardRef] = $6506ac27a174cdb1$var$FORWARD_REF_STATICS;
$6506ac27a174cdb1$var$TYPE_STATICS[$jy66G.Memo] = $6506ac27a174cdb1$var$MEMO_STATICS;
function $6506ac27a174cdb1$var$getStatics(component) {
    // React v16.11 and below
    if ($jy66G.isMemo(component)) return $6506ac27a174cdb1$var$MEMO_STATICS;
     // React v16.12 and above
    return $6506ac27a174cdb1$var$TYPE_STATICS[component['$$typeof']] || $6506ac27a174cdb1$var$REACT_STATICS;
}
var $6506ac27a174cdb1$var$defineProperty = Object.defineProperty;
var $6506ac27a174cdb1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $6506ac27a174cdb1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6506ac27a174cdb1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6506ac27a174cdb1$var$getPrototypeOf = Object.getPrototypeOf;
var $6506ac27a174cdb1$var$objectPrototype = Object.prototype;
function $6506ac27a174cdb1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($6506ac27a174cdb1$var$objectPrototype) {
            var inheritedComponent = $6506ac27a174cdb1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $6506ac27a174cdb1$var$objectPrototype) $6506ac27a174cdb1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $6506ac27a174cdb1$var$getOwnPropertyNames(sourceComponent);
        if ($6506ac27a174cdb1$var$getOwnPropertySymbols) keys = keys.concat($6506ac27a174cdb1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $6506ac27a174cdb1$var$getStatics(targetComponent);
        var sourceStatics = $6506ac27a174cdb1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$6506ac27a174cdb1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $6506ac27a174cdb1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $6506ac27a174cdb1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $6506ac27a174cdb1$var$hoistNonReactStatics;

});
parcelRegister("jy66G", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a5UKC"));

});



parcelRegister("eV8kv", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $adccd9b04ce9e197$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $adccd9b04ce9e197$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $adccd9b04ce9e197$export$6f077d94b33a01aa; });
var $adccd9b04ce9e197$var$isBrowser = typeof document !== 'undefined';
function $adccd9b04ce9e197$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $adccd9b04ce9e197$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $adccd9b04ce9e197$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $adccd9b04ce9e197$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $adccd9b04ce9e197$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$adccd9b04ce9e197$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$adccd9b04ce9e197$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("NHV6R", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $0956a55703442836$export$6321afa313b251b5; });

var $4UriT = parcelRequire("4UriT");

var $irWrU = parcelRequire("irWrU");

var $euCgl = parcelRequire("euCgl");
var $0956a55703442836$var$isDevelopment = false;
var $0956a55703442836$var$hyphenateRegex = /[A-Z]|^ms/g;
var $0956a55703442836$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $0956a55703442836$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $0956a55703442836$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $0956a55703442836$var$processStyleName = /* #__PURE__ */ (0, $euCgl.default)(function(styleName) {
    return $0956a55703442836$var$isCustomProperty(styleName) ? styleName : styleName.replace($0956a55703442836$var$hyphenateRegex, '-$&').toLowerCase();
});
var $0956a55703442836$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($0956a55703442836$var$animationRegex, function(match, p1, p2) {
                $0956a55703442836$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $0956a55703442836$var$cursor
                };
                return p1;
            });
    }
    if ((0, $irWrU.default)[key] !== 1 && !$0956a55703442836$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $0956a55703442836$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $0956a55703442836$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $0956a55703442836$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $0956a55703442836$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $0956a55703442836$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $0956a55703442836$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $0956a55703442836$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $0956a55703442836$var$cursor;
                var result = interpolation(mergedProps);
                $0956a55703442836$var$cursor = previousCursor;
                return $0956a55703442836$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $0956a55703442836$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $0956a55703442836$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($0956a55703442836$var$isProcessableValue(asString)) string += $0956a55703442836$var$processStyleName(key) + ":" + $0956a55703442836$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $0956a55703442836$var$isDevelopment) throw new Error($0956a55703442836$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($0956a55703442836$var$isProcessableValue(value[_i])) string += $0956a55703442836$var$processStyleName(key) + ":" + $0956a55703442836$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $0956a55703442836$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $0956a55703442836$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $0956a55703442836$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $0956a55703442836$var$cursor;
function $0956a55703442836$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $0956a55703442836$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $0956a55703442836$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $0956a55703442836$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $0956a55703442836$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $0956a55703442836$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4UriT.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $0956a55703442836$var$cursor
    };
}

});
parcelRegister("4UriT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $393192585dd53dba$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $393192585dd53dba$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("irWrU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03775b331878e0ff$export$2e2bcd8739ae039; });
var $03775b331878e0ff$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("3KTx4", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $2bc0be89a5f256dc$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $2bc0be89a5f256dc$export$811a713a7276cb9d; });

var $3QbnI = parcelRequire("3QbnI");
var $2bc0be89a5f256dc$var$isBrowser = typeof document !== 'undefined';
var $2bc0be89a5f256dc$var$syncFallback = function syncFallback(create) {
    return create();
};
var $2bc0be89a5f256dc$var$useInsertionEffect = $3QbnI.useInsertionEffect ? $3QbnI.useInsertionEffect : false;
var $2bc0be89a5f256dc$export$db21c7ffa21794e7 = !$2bc0be89a5f256dc$var$isBrowser ? $2bc0be89a5f256dc$var$syncFallback : $2bc0be89a5f256dc$var$useInsertionEffect || $2bc0be89a5f256dc$var$syncFallback;
var $2bc0be89a5f256dc$export$811a713a7276cb9d = $2bc0be89a5f256dc$var$useInsertionEffect || $3QbnI.useLayoutEffect;

});


parcelRegister("eEqN4", function(module, exports) {
function $aaa99525bc8d9f58$var$_extends() {
    return module.exports = $aaa99525bc8d9f58$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $aaa99525bc8d9f58$var$_extends.apply(null, arguments);
}
module.exports = $aaa99525bc8d9f58$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("emYta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a76206b6927d3f7b$export$2e2bcd8739ae039; });

var $euCgl = parcelRequire("euCgl");
// eslint-disable-next-line no-undef
var $a76206b6927d3f7b$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a76206b6927d3f7b$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $euCgl.default)(function(prop) {
    return $a76206b6927d3f7b$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("3MMEU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c1b996e42426bab$export$2e2bcd8739ae039; });
parcelRequire("3QbnI");


var $fPIjG = parcelRequire("fPIjG");

var $e1vzu = parcelRequire("e1vzu");
'use client';
function $2c1b996e42426bab$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $2c1b996e42426bab$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($2c1b996e42426bab$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fPIjG.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("e1vzu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9w4Jx"));

});



parcelRegister("6s3yU", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $4b281ef8f8b24450$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $4b281ef8f8b24450$export$2e2bcd8739ae039; });

var $3QbnI = parcelRequire("3QbnI");
function $4b281ef8f8b24450$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $4b281ef8f8b24450$var$deepClone(source) {
    if (/*#__PURE__*/ $3QbnI.isValidElement(source) || !$4b281ef8f8b24450$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $4b281ef8f8b24450$var$deepClone(source[key]);
    });
    return output;
}
function $4b281ef8f8b24450$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($4b281ef8f8b24450$export$53b83ca8eaab0383(target) && $4b281ef8f8b24450$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $3QbnI.isValidElement(source[key])) output[key] = source[key];
        else if ($4b281ef8f8b24450$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $4b281ef8f8b24450$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $4b281ef8f8b24450$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $4b281ef8f8b24450$export$53b83ca8eaab0383(source[key]) ? $4b281ef8f8b24450$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("eF4qW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aac8556ecee8ebdb$export$2e2bcd8739ae039; });

var $4jVJX = parcelRequire("4jVJX");
function $aac8556ecee8ebdb$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $aac8556ecee8ebdb$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $aac8556ecee8ebdb$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $aac8556ecee8ebdb$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $aac8556ecee8ebdb$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jVJX.ForwardRef:
            return $aac8556ecee8ebdb$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jVJX.Memo:
            return $aac8556ecee8ebdb$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("4jVJX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dQbr8"));

});


parcelRegister("aTv5Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee729659d9d22c1$export$2e2bcd8739ae039; });

var $6s3yU = parcelRequire("6s3yU");

var $l6GzT = parcelRequire("l6GzT");

var $d2SaZ = parcelRequire("d2SaZ");

var $k4j85 = parcelRequire("k4j85");

var $k7uoa = parcelRequire("k7uoa");

var $hhWLk = parcelRequire("hhWLk");

var $bXE6K = parcelRequire("bXE6K");

var $8dV8p = parcelRequire("8dV8p");
function $7ee729659d9d22c1$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $l6GzT.default)(breakpointsInput);
    const spacing = (0, $k7uoa.default)(spacingInput);
    let muiTheme = (0, $6s3yU.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $k4j85.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $d2SaZ.default)(muiTheme);
    muiTheme.applyStyles = (0, $8dV8p.default);
    muiTheme = args.reduce((acc, argument)=>(0, $6s3yU.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $bXE6K.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $hhWLk.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $7ee729659d9d22c1$export$2e2bcd8739ae039 = $7ee729659d9d22c1$var$createTheme;

});
parcelRegister("l6GzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5db2f94c6e9b053$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $f5db2f94c6e9b053$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $f5db2f94c6e9b053$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $f5db2f94c6e9b053$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $f5db2f94c6e9b053$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("d2SaZ", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $97f57c90a7220d9a$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $97f57c90a7220d9a$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $97f57c90a7220d9a$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $97f57c90a7220d9a$export$2e2bcd8739ae039; });

function $97f57c90a7220d9a$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $97f57c90a7220d9a$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $97f57c90a7220d9a$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $97f57c90a7220d9a$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("k4j85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9c3051552342841$export$2e2bcd8739ae039; });
const $e9c3051552342841$var$shape = {
    borderRadius: 4
};
var $e9c3051552342841$export$2e2bcd8739ae039 = $e9c3051552342841$var$shape;

});

parcelRegister("k7uoa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea5c08ab349fc037$export$2e2bcd8739ae039; });

var $j3YoY = parcelRequire("j3YoY");
function $ea5c08ab349fc037$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $j3YoY.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("j3YoY", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $de0d26b2d0561e36$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $de0d26b2d0561e36$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $de0d26b2d0561e36$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $de0d26b2d0561e36$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $de0d26b2d0561e36$export$6f98e8eaf0be1996; });


var $jn7gE = parcelRequire("jn7gE");

var $aM01b = parcelRequire("aM01b");

var $a3Ldg = parcelRequire("a3Ldg");

var $lvJoA = parcelRequire("lvJoA");
const $de0d26b2d0561e36$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $de0d26b2d0561e36$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $de0d26b2d0561e36$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $de0d26b2d0561e36$var$getCssProperties = (0, $lvJoA.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($de0d26b2d0561e36$var$aliases[prop]) prop = $de0d26b2d0561e36$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $de0d26b2d0561e36$var$properties[a];
    const direction = $de0d26b2d0561e36$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $de0d26b2d0561e36$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $de0d26b2d0561e36$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $de0d26b2d0561e36$var$spacingKeys = [
    ...$de0d26b2d0561e36$export$aab52a0dde05ad8a,
    ...$de0d26b2d0561e36$export$f8397d44f03ab6ad
];
function $de0d26b2d0561e36$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $aM01b.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $de0d26b2d0561e36$export$1def6f833384e3d1(theme) {
    return $de0d26b2d0561e36$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $de0d26b2d0561e36$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $de0d26b2d0561e36$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $de0d26b2d0561e36$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $de0d26b2d0561e36$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $de0d26b2d0561e36$var$getCssProperties(prop);
    const styleFromPropValue = $de0d26b2d0561e36$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $jn7gE.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $de0d26b2d0561e36$var$style(props, keys) {
    const transformer = $de0d26b2d0561e36$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$de0d26b2d0561e36$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $a3Ldg.default), {});
}
function $de0d26b2d0561e36$export$7ede87f9b603dd3c(props) {
    return $de0d26b2d0561e36$var$style(props, $de0d26b2d0561e36$export$aab52a0dde05ad8a);
}
$de0d26b2d0561e36$export$7ede87f9b603dd3c.propTypes = {};
$de0d26b2d0561e36$export$7ede87f9b603dd3c.filterProps = $de0d26b2d0561e36$export$aab52a0dde05ad8a;
function $de0d26b2d0561e36$export$6f98e8eaf0be1996(props) {
    return $de0d26b2d0561e36$var$style(props, $de0d26b2d0561e36$export$f8397d44f03ab6ad);
}
$de0d26b2d0561e36$export$6f98e8eaf0be1996.propTypes = {};
$de0d26b2d0561e36$export$6f98e8eaf0be1996.filterProps = $de0d26b2d0561e36$export$f8397d44f03ab6ad;
function $de0d26b2d0561e36$var$spacing(props) {
    return $de0d26b2d0561e36$var$style(props, $de0d26b2d0561e36$var$spacingKeys);
}
$de0d26b2d0561e36$var$spacing.propTypes = {};
$de0d26b2d0561e36$var$spacing.filterProps = $de0d26b2d0561e36$var$spacingKeys;
var $de0d26b2d0561e36$export$2e2bcd8739ae039 = $de0d26b2d0561e36$var$spacing;

});
parcelRegister("jn7gE", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $e1a5cd7f53477ea4$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $e1a5cd7f53477ea4$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $e1a5cd7f53477ea4$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $e1a5cd7f53477ea4$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $e1a5cd7f53477ea4$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $e1a5cd7f53477ea4$export$980e6a259d807490; });


var $6s3yU = parcelRequire("6s3yU");

var $a3Ldg = parcelRequire("a3Ldg");

var $d2SaZ = parcelRequire("d2SaZ");
const $e1a5cd7f53477ea4$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $e1a5cd7f53477ea4$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$e1a5cd7f53477ea4$export$68c286be0e7e55b7[key]}px)`
};
const $e1a5cd7f53477ea4$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $e1a5cd7f53477ea4$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $e1a5cd7f53477ea4$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $e1a5cd7f53477ea4$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $e1a5cd7f53477ea4$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $d2SaZ.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $d2SaZ.getContainerQuery)(theme.containerQueries ? theme : $e1a5cd7f53477ea4$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $e1a5cd7f53477ea4$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $e1a5cd7f53477ea4$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $e1a5cd7f53477ea4$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $a3Ldg.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $e1a5cd7f53477ea4$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $e1a5cd7f53477ea4$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $e1a5cd7f53477ea4$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $e1a5cd7f53477ea4$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $6s3yU.default)(prev, next), {});
    return $e1a5cd7f53477ea4$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $e1a5cd7f53477ea4$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $e1a5cd7f53477ea4$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $e1a5cd7f53477ea4$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $e1a5cd7f53477ea4$export$2e2bcd8739ae039 = $e1a5cd7f53477ea4$var$breakpoints;

});
parcelRegister("a3Ldg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $752eceace3b6d6d6$export$2e2bcd8739ae039; });

var $6s3yU = parcelRequire("6s3yU");
function $752eceace3b6d6d6$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $6s3yU.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $752eceace3b6d6d6$export$2e2bcd8739ae039 = $752eceace3b6d6d6$var$merge;

});


parcelRegister("aM01b", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $7d7e66a63de98146$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $7d7e66a63de98146$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $7d7e66a63de98146$export$2e2bcd8739ae039; });

var $kJVS9 = parcelRequire("kJVS9");


var $jn7gE = parcelRequire("jn7gE");
function $7d7e66a63de98146$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $7d7e66a63de98146$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $7d7e66a63de98146$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $7d7e66a63de98146$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $7d7e66a63de98146$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $7d7e66a63de98146$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $7d7e66a63de98146$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $kJVS9.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $jn7gE.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $7d7e66a63de98146$export$2e2bcd8739ae039 = $7d7e66a63de98146$var$style;

});

parcelRegister("lvJoA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa8fb4d20c29bf3b$export$2e2bcd8739ae039; });
function $fa8fb4d20c29bf3b$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("hhWLk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9619b309473eea9$export$2e2bcd8739ae039; });

var $kJVS9 = parcelRequire("kJVS9");

var $a3Ldg = parcelRequire("a3Ldg");

var $aM01b = parcelRequire("aM01b");

var $jn7gE = parcelRequire("jn7gE");

var $d2SaZ = parcelRequire("d2SaZ");

var $bXE6K = parcelRequire("bXE6K");
function $c9619b309473eea9$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $c9619b309473eea9$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $c9619b309473eea9$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $aM01b.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $aM01b.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $aM01b.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $kJVS9.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $jn7gE.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $bXE6K.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $jn7gE.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $c9619b309473eea9$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $a3Ldg.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $jn7gE.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($c9619b309473eea9$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $a3Ldg.default)(css, breakpointsValues);
                        }
                    } else css = (0, $a3Ldg.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $d2SaZ.sortContainerQueries)(theme, (0, $jn7gE.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $c9619b309473eea9$var$styleFunctionSx = $c9619b309473eea9$export$7d53d8bf2911e013();
$c9619b309473eea9$var$styleFunctionSx.filterProps = [
    'sx'
];
var $c9619b309473eea9$export$2e2bcd8739ae039 = $c9619b309473eea9$var$styleFunctionSx;

});
parcelRegister("bXE6K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b5450f58f836ece$export$2e2bcd8739ae039; });

var $j3YoY = parcelRequire("j3YoY");

var $6GJR0 = parcelRequire("6GJR0");

var $7nD0j = parcelRequire("7nD0j");

var $gNQ3w = parcelRequire("gNQ3w");

var $3ibNG = parcelRequire("3ibNG");
const $8b5450f58f836ece$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $6GJR0.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $6GJR0.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $6GJR0.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $6GJR0.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $6GJR0.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $6GJR0.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $6GJR0.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $gNQ3w.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $gNQ3w.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $gNQ3w.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $j3YoY.padding)
    },
    pt: {
        style: (0, $j3YoY.padding)
    },
    pr: {
        style: (0, $j3YoY.padding)
    },
    pb: {
        style: (0, $j3YoY.padding)
    },
    pl: {
        style: (0, $j3YoY.padding)
    },
    px: {
        style: (0, $j3YoY.padding)
    },
    py: {
        style: (0, $j3YoY.padding)
    },
    padding: {
        style: (0, $j3YoY.padding)
    },
    paddingTop: {
        style: (0, $j3YoY.padding)
    },
    paddingRight: {
        style: (0, $j3YoY.padding)
    },
    paddingBottom: {
        style: (0, $j3YoY.padding)
    },
    paddingLeft: {
        style: (0, $j3YoY.padding)
    },
    paddingX: {
        style: (0, $j3YoY.padding)
    },
    paddingY: {
        style: (0, $j3YoY.padding)
    },
    paddingInline: {
        style: (0, $j3YoY.padding)
    },
    paddingInlineStart: {
        style: (0, $j3YoY.padding)
    },
    paddingInlineEnd: {
        style: (0, $j3YoY.padding)
    },
    paddingBlock: {
        style: (0, $j3YoY.padding)
    },
    paddingBlockStart: {
        style: (0, $j3YoY.padding)
    },
    paddingBlockEnd: {
        style: (0, $j3YoY.padding)
    },
    m: {
        style: (0, $j3YoY.margin)
    },
    mt: {
        style: (0, $j3YoY.margin)
    },
    mr: {
        style: (0, $j3YoY.margin)
    },
    mb: {
        style: (0, $j3YoY.margin)
    },
    ml: {
        style: (0, $j3YoY.margin)
    },
    mx: {
        style: (0, $j3YoY.margin)
    },
    my: {
        style: (0, $j3YoY.margin)
    },
    margin: {
        style: (0, $j3YoY.margin)
    },
    marginTop: {
        style: (0, $j3YoY.margin)
    },
    marginRight: {
        style: (0, $j3YoY.margin)
    },
    marginBottom: {
        style: (0, $j3YoY.margin)
    },
    marginLeft: {
        style: (0, $j3YoY.margin)
    },
    marginX: {
        style: (0, $j3YoY.margin)
    },
    marginY: {
        style: (0, $j3YoY.margin)
    },
    marginInline: {
        style: (0, $j3YoY.margin)
    },
    marginInlineStart: {
        style: (0, $j3YoY.margin)
    },
    marginInlineEnd: {
        style: (0, $j3YoY.margin)
    },
    marginBlock: {
        style: (0, $j3YoY.margin)
    },
    marginBlockStart: {
        style: (0, $j3YoY.margin)
    },
    marginBlockEnd: {
        style: (0, $j3YoY.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $7nD0j.gap)
    },
    rowGap: {
        style: (0, $7nD0j.rowGap)
    },
    columnGap: {
        style: (0, $7nD0j.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $3ibNG.sizingTransform)
    },
    maxWidth: {
        style: (0, $3ibNG.maxWidth)
    },
    minWidth: {
        transform: (0, $3ibNG.sizingTransform)
    },
    height: {
        transform: (0, $3ibNG.sizingTransform)
    },
    maxHeight: {
        transform: (0, $3ibNG.sizingTransform)
    },
    minHeight: {
        transform: (0, $3ibNG.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $8b5450f58f836ece$export$2e2bcd8739ae039 = $8b5450f58f836ece$var$defaultSxConfig;

});
parcelRegister("6GJR0", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $4dea3beff6493bbc$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $4dea3beff6493bbc$export$7a57f79000377ca2; });


var $aM01b = parcelRequire("aM01b");

var $iTLwB = parcelRequire("iTLwB");

var $j3YoY = parcelRequire("j3YoY");

var $jn7gE = parcelRequire("jn7gE");
function $4dea3beff6493bbc$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $4dea3beff6493bbc$var$createBorderStyle(prop, transform) {
    return (0, $aM01b.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $4dea3beff6493bbc$export$1edee58a52776cd9 = $4dea3beff6493bbc$var$createBorderStyle('border', $4dea3beff6493bbc$export$34e2febe53ae29cc);
const $4dea3beff6493bbc$export$f9a7b6bd24892946 = $4dea3beff6493bbc$var$createBorderStyle('borderTop', $4dea3beff6493bbc$export$34e2febe53ae29cc);
const $4dea3beff6493bbc$export$5abca33e6be905d2 = $4dea3beff6493bbc$var$createBorderStyle('borderRight', $4dea3beff6493bbc$export$34e2febe53ae29cc);
const $4dea3beff6493bbc$export$e2ce9f12a980a822 = $4dea3beff6493bbc$var$createBorderStyle('borderBottom', $4dea3beff6493bbc$export$34e2febe53ae29cc);
const $4dea3beff6493bbc$export$47658cca1a909427 = $4dea3beff6493bbc$var$createBorderStyle('borderLeft', $4dea3beff6493bbc$export$34e2febe53ae29cc);
const $4dea3beff6493bbc$export$e7fb0694ba2404fc = $4dea3beff6493bbc$var$createBorderStyle('borderColor');
const $4dea3beff6493bbc$export$126a92c968acdb85 = $4dea3beff6493bbc$var$createBorderStyle('borderTopColor');
const $4dea3beff6493bbc$export$85cc51cb8fbb8c0e = $4dea3beff6493bbc$var$createBorderStyle('borderRightColor');
const $4dea3beff6493bbc$export$340b0327727f6d1a = $4dea3beff6493bbc$var$createBorderStyle('borderBottomColor');
const $4dea3beff6493bbc$export$60beef91a985b4bf = $4dea3beff6493bbc$var$createBorderStyle('borderLeftColor');
const $4dea3beff6493bbc$export$f9258c55612cbed7 = $4dea3beff6493bbc$var$createBorderStyle('outline', $4dea3beff6493bbc$export$34e2febe53ae29cc);
const $4dea3beff6493bbc$export$621fe586efeb64b9 = $4dea3beff6493bbc$var$createBorderStyle('outlineColor');
const $4dea3beff6493bbc$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $j3YoY.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $j3YoY.getValue)(transformer, propValue)
            });
        return (0, $jn7gE.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$4dea3beff6493bbc$export$7a57f79000377ca2.propTypes = {};
$4dea3beff6493bbc$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $4dea3beff6493bbc$var$borders = (0, $iTLwB.default)($4dea3beff6493bbc$export$1edee58a52776cd9, $4dea3beff6493bbc$export$f9a7b6bd24892946, $4dea3beff6493bbc$export$5abca33e6be905d2, $4dea3beff6493bbc$export$e2ce9f12a980a822, $4dea3beff6493bbc$export$47658cca1a909427, $4dea3beff6493bbc$export$e7fb0694ba2404fc, $4dea3beff6493bbc$export$126a92c968acdb85, $4dea3beff6493bbc$export$85cc51cb8fbb8c0e, $4dea3beff6493bbc$export$340b0327727f6d1a, $4dea3beff6493bbc$export$60beef91a985b4bf, $4dea3beff6493bbc$export$7a57f79000377ca2, $4dea3beff6493bbc$export$f9258c55612cbed7, $4dea3beff6493bbc$export$621fe586efeb64b9);
var $4dea3beff6493bbc$export$2e2bcd8739ae039 = $4dea3beff6493bbc$var$borders;

});
parcelRegister("iTLwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc223a7864c0ab9c$export$2e2bcd8739ae039; });

var $a3Ldg = parcelRequire("a3Ldg");
function $dc223a7864c0ab9c$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $a3Ldg.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $dc223a7864c0ab9c$export$2e2bcd8739ae039 = $dc223a7864c0ab9c$var$compose;

});


parcelRegister("7nD0j", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $55f8efc7d9ed5093$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $55f8efc7d9ed5093$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $55f8efc7d9ed5093$export$8a833ffa5f5dbeda; });

var $aM01b = parcelRequire("aM01b");

var $iTLwB = parcelRequire("iTLwB");

var $j3YoY = parcelRequire("j3YoY");

var $jn7gE = parcelRequire("jn7gE");

const $55f8efc7d9ed5093$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $j3YoY.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $j3YoY.getValue)(transformer, propValue)
            });
        return (0, $jn7gE.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$55f8efc7d9ed5093$export$5df9adcb0db95e1e.propTypes = {};
$55f8efc7d9ed5093$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $55f8efc7d9ed5093$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $j3YoY.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $j3YoY.getValue)(transformer, propValue)
            });
        return (0, $jn7gE.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$55f8efc7d9ed5093$export$ec60d70ff941a580.propTypes = {};
$55f8efc7d9ed5093$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $55f8efc7d9ed5093$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $j3YoY.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $j3YoY.getValue)(transformer, propValue)
            });
        return (0, $jn7gE.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$55f8efc7d9ed5093$export$8a833ffa5f5dbeda.propTypes = {};
$55f8efc7d9ed5093$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $55f8efc7d9ed5093$export$baf44164ca3a34e8 = (0, $aM01b.default)({
    prop: 'gridColumn'
});
const $55f8efc7d9ed5093$export$8f7213a1cd01e832 = (0, $aM01b.default)({
    prop: 'gridRow'
});
const $55f8efc7d9ed5093$export$b0e0abbc49ba668 = (0, $aM01b.default)({
    prop: 'gridAutoFlow'
});
const $55f8efc7d9ed5093$export$bcd8b929d4b4142 = (0, $aM01b.default)({
    prop: 'gridAutoColumns'
});
const $55f8efc7d9ed5093$export$e5039a674e14c828 = (0, $aM01b.default)({
    prop: 'gridAutoRows'
});
const $55f8efc7d9ed5093$export$42bd9088661ffb03 = (0, $aM01b.default)({
    prop: 'gridTemplateColumns'
});
const $55f8efc7d9ed5093$export$920682ae05b999bc = (0, $aM01b.default)({
    prop: 'gridTemplateRows'
});
const $55f8efc7d9ed5093$export$1b88fbdd482fd33a = (0, $aM01b.default)({
    prop: 'gridTemplateAreas'
});
const $55f8efc7d9ed5093$export$bdb486e40d52d26f = (0, $aM01b.default)({
    prop: 'gridArea'
});
const $55f8efc7d9ed5093$var$grid = (0, $iTLwB.default)($55f8efc7d9ed5093$export$5df9adcb0db95e1e, $55f8efc7d9ed5093$export$ec60d70ff941a580, $55f8efc7d9ed5093$export$8a833ffa5f5dbeda, $55f8efc7d9ed5093$export$baf44164ca3a34e8, $55f8efc7d9ed5093$export$8f7213a1cd01e832, $55f8efc7d9ed5093$export$b0e0abbc49ba668, $55f8efc7d9ed5093$export$bcd8b929d4b4142, $55f8efc7d9ed5093$export$e5039a674e14c828, $55f8efc7d9ed5093$export$42bd9088661ffb03, $55f8efc7d9ed5093$export$920682ae05b999bc, $55f8efc7d9ed5093$export$1b88fbdd482fd33a, $55f8efc7d9ed5093$export$bdb486e40d52d26f);
var $55f8efc7d9ed5093$export$2e2bcd8739ae039 = $55f8efc7d9ed5093$var$grid;

});

parcelRegister("gNQ3w", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $c3b99a280544a199$export$dbaffd4420ea0ac6; });

var $aM01b = parcelRequire("aM01b");

var $iTLwB = parcelRequire("iTLwB");
function $c3b99a280544a199$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $c3b99a280544a199$export$35e9368ef982300f = (0, $aM01b.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $c3b99a280544a199$export$dbaffd4420ea0ac6
});
const $c3b99a280544a199$export$2506f56c10355b33 = (0, $aM01b.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $c3b99a280544a199$export$dbaffd4420ea0ac6
});
const $c3b99a280544a199$export$8c5a050822fd698c = (0, $aM01b.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $c3b99a280544a199$export$dbaffd4420ea0ac6
});
const $c3b99a280544a199$var$palette = (0, $iTLwB.default)($c3b99a280544a199$export$35e9368ef982300f, $c3b99a280544a199$export$2506f56c10355b33, $c3b99a280544a199$export$8c5a050822fd698c);
var $c3b99a280544a199$export$2e2bcd8739ae039 = $c3b99a280544a199$var$palette;

});

parcelRegister("3ibNG", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $265c34da1bf83288$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $265c34da1bf83288$export$488fda99655ff65a; });

var $aM01b = parcelRequire("aM01b");

var $iTLwB = parcelRequire("iTLwB");

var $jn7gE = parcelRequire("jn7gE");
function $265c34da1bf83288$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $265c34da1bf83288$export$7e3df82ee760448c = (0, $aM01b.default)({
    prop: 'width',
    transform: $265c34da1bf83288$export$8afece71750ec241
});
const $265c34da1bf83288$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $jn7gE.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $265c34da1bf83288$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $jn7gE.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$265c34da1bf83288$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $265c34da1bf83288$export$ee148fbbe8357dd2 = (0, $aM01b.default)({
    prop: 'minWidth',
    transform: $265c34da1bf83288$export$8afece71750ec241
});
const $265c34da1bf83288$export$ac607276a8fe9f0a = (0, $aM01b.default)({
    prop: 'height',
    transform: $265c34da1bf83288$export$8afece71750ec241
});
const $265c34da1bf83288$export$dc0d8bd0b94f8570 = (0, $aM01b.default)({
    prop: 'maxHeight',
    transform: $265c34da1bf83288$export$8afece71750ec241
});
const $265c34da1bf83288$export$a43cf604e12f3b17 = (0, $aM01b.default)({
    prop: 'minHeight',
    transform: $265c34da1bf83288$export$8afece71750ec241
});
const $265c34da1bf83288$export$ffed9f14fb65e276 = (0, $aM01b.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $265c34da1bf83288$export$8afece71750ec241
});
const $265c34da1bf83288$export$905076ed6620e671 = (0, $aM01b.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $265c34da1bf83288$export$8afece71750ec241
});
const $265c34da1bf83288$export$6ccc93f785106a58 = (0, $aM01b.default)({
    prop: 'boxSizing'
});
const $265c34da1bf83288$var$sizing = (0, $iTLwB.default)($265c34da1bf83288$export$7e3df82ee760448c, $265c34da1bf83288$export$488fda99655ff65a, $265c34da1bf83288$export$ee148fbbe8357dd2, $265c34da1bf83288$export$ac607276a8fe9f0a, $265c34da1bf83288$export$dc0d8bd0b94f8570, $265c34da1bf83288$export$a43cf604e12f3b17, $265c34da1bf83288$export$6ccc93f785106a58);
var $265c34da1bf83288$export$2e2bcd8739ae039 = $265c34da1bf83288$var$sizing;

});



parcelRegister("8dV8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fcbdb5c46ac029d$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $5fcbdb5c46ac029d$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("5CT8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $418b469a30f5cfb1$export$2e2bcd8739ae039; });

var $c4XO5 = parcelRequire("c4XO5");
function $418b469a30f5cfb1$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $c4XO5.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $c4XO5.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("cxyce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921317c9b5064d98$export$2e2bcd8739ae039; });

var $5HuF3 = parcelRequire("5HuF3");
'use client';
const $921317c9b5064d98$var$defaultTheme = (0, $5HuF3.default)();
var $921317c9b5064d98$export$2e2bcd8739ae039 = $921317c9b5064d98$var$defaultTheme;

});
parcelRegister("5HuF3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4268c090bb4533f1$export$2e2bcd8739ae039; });

var $9u39g = parcelRequire("9u39g");

var $7sISm = parcelRequire("7sISm");

var $lobh3 = parcelRequire("lobh3");
// eslint-disable-next-line consistent-return
function $4268c090bb4533f1$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $9u39g.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $4268c090bb4533f1$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $lobh3.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $lobh3.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $4268c090bb4533f1$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $4268c090bb4533f1$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $7sISm.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("9u39g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e795b977d5da8c0$export$2e2bcd8739ae039; });

var $eClrZ = parcelRequire("eClrZ");

var $6s3yU = parcelRequire("6s3yU");

var $aDUe6 = parcelRequire("aDUe6");

var $kH9It = parcelRequire("kH9It");

var $5V7zi = parcelRequire("5V7zi");

var $bJBXp = parcelRequire("bJBXp");

var $gBPUZ = parcelRequire("gBPUZ");

var $cRTfS = parcelRequire("cRTfS");

var $4MvxT = parcelRequire("4MvxT");

var $ggVZq = parcelRequire("ggVZq");

var $lBsKq = parcelRequire("lBsKq");
function $6e795b977d5da8c0$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $kH9It.default).white,
            default: (0, $kH9It.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $6e795b977d5da8c0$export$a43af521ac8c3202 = $6e795b977d5da8c0$var$getLight();
function $6e795b977d5da8c0$var$getDark() {
    return {
        text: {
            primary: (0, $kH9It.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $kH9It.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $6e795b977d5da8c0$export$55ce6f3a06c59543 = $6e795b977d5da8c0$var$getDark();
function $6e795b977d5da8c0$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $aDUe6.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $aDUe6.darken)(intent.main, tonalOffsetDark);
    }
}
function $6e795b977d5da8c0$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $4MvxT.default)[200],
        light: (0, $4MvxT.default)[50],
        dark: (0, $4MvxT.default)[400]
    };
    return {
        main: (0, $4MvxT.default)[700],
        light: (0, $4MvxT.default)[400],
        dark: (0, $4MvxT.default)[800]
    };
}
function $6e795b977d5da8c0$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bJBXp.default)[200],
        light: (0, $bJBXp.default)[50],
        dark: (0, $bJBXp.default)[400]
    };
    return {
        main: (0, $bJBXp.default)[500],
        light: (0, $bJBXp.default)[300],
        dark: (0, $bJBXp.default)[700]
    };
}
function $6e795b977d5da8c0$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gBPUZ.default)[500],
        light: (0, $gBPUZ.default)[300],
        dark: (0, $gBPUZ.default)[700]
    };
    return {
        main: (0, $gBPUZ.default)[700],
        light: (0, $gBPUZ.default)[400],
        dark: (0, $gBPUZ.default)[800]
    };
}
function $6e795b977d5da8c0$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ggVZq.default)[400],
        light: (0, $ggVZq.default)[300],
        dark: (0, $ggVZq.default)[700]
    };
    return {
        main: (0, $ggVZq.default)[700],
        light: (0, $ggVZq.default)[500],
        dark: (0, $ggVZq.default)[900]
    };
}
function $6e795b977d5da8c0$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $lBsKq.default)[400],
        light: (0, $lBsKq.default)[300],
        dark: (0, $lBsKq.default)[700]
    };
    return {
        main: (0, $lBsKq.default)[800],
        light: (0, $lBsKq.default)[500],
        dark: (0, $lBsKq.default)[900]
    };
}
function $6e795b977d5da8c0$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $cRTfS.default)[400],
        light: (0, $cRTfS.default)[300],
        dark: (0, $cRTfS.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $cRTfS.default)[500],
        dark: (0, $cRTfS.default)[900]
    };
}
function $6e795b977d5da8c0$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $6e795b977d5da8c0$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $6e795b977d5da8c0$var$getDefaultSecondary(mode);
    const error = palette.error || $6e795b977d5da8c0$var$getDefaultError(mode);
    const info = palette.info || $6e795b977d5da8c0$var$getDefaultInfo(mode);
    const success = palette.success || $6e795b977d5da8c0$var$getDefaultSuccess(mode);
    const warning = palette.warning || $6e795b977d5da8c0$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $aDUe6.getContrastRatio)(background, $6e795b977d5da8c0$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $6e795b977d5da8c0$export$55ce6f3a06c59543.text.primary : $6e795b977d5da8c0$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $eClrZ.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $eClrZ.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $6e795b977d5da8c0$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $6e795b977d5da8c0$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $6e795b977d5da8c0$var$getLight();
    else if (mode === 'dark') modeHydrated = $6e795b977d5da8c0$var$getDark();
    const paletteOutput = (0, $6s3yU.default)({
        // A collection of common colors.
        common: {
            ...(0, $kH9It.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $5V7zi.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("aDUe6", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", function () { return $7bf9294deb876731$export$427365fc3db6fc5e; });
$parcel$export(module.exports, "hslToRgb", function () { return $7bf9294deb876731$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getContrastRatio", function () { return $7bf9294deb876731$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $7bf9294deb876731$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "private_safeAlpha", function () { return $7bf9294deb876731$export$34109543fc7f43f8; });
$parcel$export(module.exports, "darken", function () { return $7bf9294deb876731$export$4b073707ff63303; });
$parcel$export(module.exports, "private_safeDarken", function () { return $7bf9294deb876731$export$eaaef2dca3e9e512; });
$parcel$export(module.exports, "lighten", function () { return $7bf9294deb876731$export$c0816ed86df316af; });
$parcel$export(module.exports, "private_safeLighten", function () { return $7bf9294deb876731$export$aeeda94ef1d01275; });
$parcel$export(module.exports, "private_safeEmphasize", function () { return $7bf9294deb876731$export$11bb74ba10c85505; });

var $eClrZ = parcelRequire("eClrZ");

var $7ZizZ = parcelRequire("7ZizZ");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7bf9294deb876731$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $7ZizZ.default)(value, min, max);
}
function $7bf9294deb876731$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $7bf9294deb876731$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $7bf9294deb876731$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7bf9294deb876731$export$677b39864803984e($7bf9294deb876731$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $eClrZ.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $eClrZ.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $7bf9294deb876731$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $7bf9294deb876731$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $7bf9294deb876731$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $7bf9294deb876731$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $7bf9294deb876731$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $7bf9294deb876731$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $7bf9294deb876731$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$7bf9294deb876731$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $7bf9294deb876731$export$29fb7152bd3f781a(color) {
    color = $7bf9294deb876731$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7bf9294deb876731$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $7bf9294deb876731$export$c852d90bf7403b62(color) {
    color = $7bf9294deb876731$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $7bf9294deb876731$export$677b39864803984e($7bf9294deb876731$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $7bf9294deb876731$export$d061e26956a60b0a(foreground, background) {
    const lumA = $7bf9294deb876731$export$c852d90bf7403b62(foreground);
    const lumB = $7bf9294deb876731$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $7bf9294deb876731$export$58f0f39f63f3cf42(color, value) {
    color = $7bf9294deb876731$export$677b39864803984e(color);
    value = $7bf9294deb876731$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $7bf9294deb876731$export$211a73f2b8c10ce4(color);
}
function $7bf9294deb876731$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $7bf9294deb876731$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $7bf9294deb876731$export$4b073707ff63303(color, coefficient) {
    color = $7bf9294deb876731$export$677b39864803984e(color);
    coefficient = $7bf9294deb876731$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7bf9294deb876731$export$211a73f2b8c10ce4(color);
}
function $7bf9294deb876731$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $7bf9294deb876731$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7bf9294deb876731$export$c0816ed86df316af(color, coefficient) {
    color = $7bf9294deb876731$export$677b39864803984e(color);
    coefficient = $7bf9294deb876731$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $7bf9294deb876731$export$211a73f2b8c10ce4(color);
}
function $7bf9294deb876731$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $7bf9294deb876731$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7bf9294deb876731$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $7bf9294deb876731$export$c852d90bf7403b62(color) > 0.5 ? $7bf9294deb876731$export$4b073707ff63303(color, coefficient) : $7bf9294deb876731$export$c0816ed86df316af(color, coefficient);
}
function $7bf9294deb876731$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $7bf9294deb876731$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7bf9294deb876731$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $7bf9294deb876731$export$677b39864803984e(background);
    const overlayColor = $7bf9294deb876731$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $7bf9294deb876731$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("7ZizZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0ca467e22ef875$export$2e2bcd8739ae039; });
function $5d0ca467e22ef875$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $5d0ca467e22ef875$export$2e2bcd8739ae039 = $5d0ca467e22ef875$var$clamp;

});


parcelRegister("kH9It", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f10f5c3f80a8a7f6$export$2e2bcd8739ae039; });
const $f10f5c3f80a8a7f6$var$common = {
    black: '#000',
    white: '#fff'
};
var $f10f5c3f80a8a7f6$export$2e2bcd8739ae039 = $f10f5c3f80a8a7f6$var$common;

});

parcelRegister("5V7zi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44f8258b79a5eeab$export$2e2bcd8739ae039; });
const $44f8258b79a5eeab$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $44f8258b79a5eeab$export$2e2bcd8739ae039 = $44f8258b79a5eeab$var$grey;

});

parcelRegister("bJBXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b1572b33b3efb0$export$2e2bcd8739ae039; });
const $88b1572b33b3efb0$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $88b1572b33b3efb0$export$2e2bcd8739ae039 = $88b1572b33b3efb0$var$purple;

});

parcelRegister("gBPUZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1785febe4f387c4$export$2e2bcd8739ae039; });
const $c1785febe4f387c4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $c1785febe4f387c4$export$2e2bcd8739ae039 = $c1785febe4f387c4$var$red;

});

parcelRegister("cRTfS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95e54bc1ef4edad4$export$2e2bcd8739ae039; });
const $95e54bc1ef4edad4$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $95e54bc1ef4edad4$export$2e2bcd8739ae039 = $95e54bc1ef4edad4$var$orange;

});

parcelRegister("4MvxT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37b41d702be45488$export$2e2bcd8739ae039; });
const $37b41d702be45488$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $37b41d702be45488$export$2e2bcd8739ae039 = $37b41d702be45488$var$blue;

});

parcelRegister("ggVZq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd8b1f7ef0d8b53b$export$2e2bcd8739ae039; });
const $bd8b1f7ef0d8b53b$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $bd8b1f7ef0d8b53b$export$2e2bcd8739ae039 = $bd8b1f7ef0d8b53b$var$lightBlue;

});

parcelRegister("lBsKq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fba35a61470ba6cb$export$2e2bcd8739ae039; });
const $fba35a61470ba6cb$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $fba35a61470ba6cb$export$2e2bcd8739ae039 = $fba35a61470ba6cb$var$green;

});


parcelRegister("7sISm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56edf555c6aa6815$export$2e2bcd8739ae039; });

var $eClrZ = parcelRequire("eClrZ");

var $6s3yU = parcelRequire("6s3yU");

var $k7uoa = parcelRequire("k7uoa");
var $1uzMX = parcelRequire("1uzMX");

var $j3YoY = parcelRequire("j3YoY");

var $6zV8D = parcelRequire("6zV8D");
var $6F23U = parcelRequire("6F23U");
var $97KtX = parcelRequire("97KtX");

var $hhWLk = parcelRequire("hhWLk");
var $bXE6K = parcelRequire("bXE6K");

var $aDUe6 = parcelRequire("aDUe6");

var $lobh3 = parcelRequire("lobh3");

var $4NllW = parcelRequire("4NllW");

var $dJbmY = parcelRequire("dJbmY");

var $3ucK7 = parcelRequire("3ucK7");

var $1fbQK = parcelRequire("1fbQK");
function $56edf555c6aa6815$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $56edf555c6aa6815$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $56edf555c6aa6815$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $aDUe6.hslToRgb)(color);
}
function $56edf555c6aa6815$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $aDUe6.private_safeColorChannel)($56edf555c6aa6815$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $56edf555c6aa6815$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $56edf555c6aa6815$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $56edf555c6aa6815$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $1uzMX.default)(cssVarPrefix);
function $56edf555c6aa6815$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $4NllW.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $lobh3.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $4NllW.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $4NllW.getOverlays)(mode)
    };
    return muiTheme;
}
function $56edf555c6aa6815$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $dJbmY.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $56edf555c6aa6815$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $eClrZ.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $56edf555c6aa6815$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $56edf555c6aa6815$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $56edf555c6aa6815$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $97KtX.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $56edf555c6aa6815$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $56edf555c6aa6815$var$setColor(palette.common, 'background', '#fff');
            $56edf555c6aa6815$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $56edf555c6aa6815$var$setColor(palette.common, 'background', '#000');
            $56edf555c6aa6815$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $56edf555c6aa6815$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorColor', (0, $aDUe6.private_safeDarken)(palette.error.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoColor', (0, $aDUe6.private_safeDarken)(palette.info.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successColor', (0, $aDUe6.private_safeDarken)(palette.success.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningColor', (0, $aDUe6.private_safeDarken)(palette.warning.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.error.main)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.info.main)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.success.main)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorStandardBg', (0, $aDUe6.private_safeLighten)(palette.error.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoStandardBg', (0, $aDUe6.private_safeLighten)(palette.info.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successStandardBg', (0, $aDUe6.private_safeLighten)(palette.success.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningStandardBg', (0, $aDUe6.private_safeLighten)(palette.warning.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $56edf555c6aa6815$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $56edf555c6aa6815$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $56edf555c6aa6815$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $56edf555c6aa6815$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $56edf555c6aa6815$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $56edf555c6aa6815$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $56edf555c6aa6815$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $56edf555c6aa6815$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $56edf555c6aa6815$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $56edf555c6aa6815$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'primaryBg', (0, $aDUe6.private_safeLighten)(palette.primary.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $aDUe6.private_safeLighten)(palette.secondary.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'errorBg', (0, $aDUe6.private_safeLighten)(palette.error.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'infoBg', (0, $aDUe6.private_safeLighten)(palette.info.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'successBg', (0, $aDUe6.private_safeLighten)(palette.success.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'warningBg', (0, $aDUe6.private_safeLighten)(palette.warning.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $56edf555c6aa6815$var$setColor(palette.Slider, 'primaryTrack', (0, $aDUe6.private_safeLighten)(palette.primary.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'secondaryTrack', (0, $aDUe6.private_safeLighten)(palette.secondary.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'errorTrack', (0, $aDUe6.private_safeLighten)(palette.error.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'infoTrack', (0, $aDUe6.private_safeLighten)(palette.info.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'successTrack', (0, $aDUe6.private_safeLighten)(palette.success.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'warningTrack', (0, $aDUe6.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $aDUe6.private_safeEmphasize)(palette.background.default, 0.8);
            $56edf555c6aa6815$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $56edf555c6aa6815$var$setColor(palette.SnackbarContent, 'color', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $56edf555c6aa6815$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $aDUe6.private_safeEmphasize)(palette.background.paper, 0.15));
            $56edf555c6aa6815$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $56edf555c6aa6815$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $aDUe6.private_safeLighten)(palette.primary.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $aDUe6.private_safeLighten)(palette.secondary.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'errorDisabledColor', (0, $aDUe6.private_safeLighten)(palette.error.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'infoDisabledColor', (0, $aDUe6.private_safeLighten)(palette.info.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'successDisabledColor', (0, $aDUe6.private_safeLighten)(palette.success.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'warningDisabledColor', (0, $aDUe6.private_safeLighten)(palette.warning.main, 0.62));
            $56edf555c6aa6815$var$setColor(palette.TableCell, 'border', (0, $aDUe6.private_safeLighten)((0, $aDUe6.private_safeAlpha)(palette.divider, 1), 0.88));
            $56edf555c6aa6815$var$setColor(palette.Tooltip, 'bg', (0, $aDUe6.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorColor', (0, $aDUe6.private_safeLighten)(palette.error.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoColor', (0, $aDUe6.private_safeLighten)(palette.info.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successColor', (0, $aDUe6.private_safeLighten)(palette.success.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningColor', (0, $aDUe6.private_safeLighten)(palette.warning.light, 0.6));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningFilledColor', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorStandardBg', (0, $aDUe6.private_safeDarken)(palette.error.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoStandardBg', (0, $aDUe6.private_safeDarken)(palette.info.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successStandardBg', (0, $aDUe6.private_safeDarken)(palette.success.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningStandardBg', (0, $aDUe6.private_safeDarken)(palette.warning.light, 0.9));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $56edf555c6aa6815$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $56edf555c6aa6815$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $56edf555c6aa6815$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $56edf555c6aa6815$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $56edf555c6aa6815$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $56edf555c6aa6815$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $56edf555c6aa6815$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $56edf555c6aa6815$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $56edf555c6aa6815$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $56edf555c6aa6815$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $56edf555c6aa6815$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $56edf555c6aa6815$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $56edf555c6aa6815$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'primaryBg', (0, $aDUe6.private_safeDarken)(palette.primary.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $aDUe6.private_safeDarken)(palette.secondary.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'errorBg', (0, $aDUe6.private_safeDarken)(palette.error.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'infoBg', (0, $aDUe6.private_safeDarken)(palette.info.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'successBg', (0, $aDUe6.private_safeDarken)(palette.success.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.LinearProgress, 'warningBg', (0, $aDUe6.private_safeDarken)(palette.warning.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $56edf555c6aa6815$var$setColor(palette.Slider, 'primaryTrack', (0, $aDUe6.private_safeDarken)(palette.primary.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'secondaryTrack', (0, $aDUe6.private_safeDarken)(palette.secondary.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'errorTrack', (0, $aDUe6.private_safeDarken)(palette.error.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'infoTrack', (0, $aDUe6.private_safeDarken)(palette.info.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'successTrack', (0, $aDUe6.private_safeDarken)(palette.success.main, 0.5));
            $56edf555c6aa6815$var$setColor(palette.Slider, 'warningTrack', (0, $aDUe6.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $aDUe6.private_safeEmphasize)(palette.background.default, 0.98);
            $56edf555c6aa6815$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $56edf555c6aa6815$var$setColor(palette.SnackbarContent, 'color', $56edf555c6aa6815$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $56edf555c6aa6815$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $aDUe6.private_safeEmphasize)(palette.background.paper, 0.15));
            $56edf555c6aa6815$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $56edf555c6aa6815$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $aDUe6.private_safeDarken)(palette.primary.main, 0.55));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $aDUe6.private_safeDarken)(palette.secondary.main, 0.55));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'errorDisabledColor', (0, $aDUe6.private_safeDarken)(palette.error.main, 0.55));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'infoDisabledColor', (0, $aDUe6.private_safeDarken)(palette.info.main, 0.55));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'successDisabledColor', (0, $aDUe6.private_safeDarken)(palette.success.main, 0.55));
            $56edf555c6aa6815$var$setColor(palette.Switch, 'warningDisabledColor', (0, $aDUe6.private_safeDarken)(palette.warning.main, 0.55));
            $56edf555c6aa6815$var$setColor(palette.TableCell, 'border', (0, $aDUe6.private_safeDarken)((0, $aDUe6.private_safeAlpha)(palette.divider, 1), 0.68));
            $56edf555c6aa6815$var$setColor(palette.Tooltip, 'bg', (0, $aDUe6.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $56edf555c6aa6815$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $56edf555c6aa6815$var$setColorChannel(palette.background, 'paper');
        $56edf555c6aa6815$var$setColorChannel(palette.common, 'background');
        $56edf555c6aa6815$var$setColorChannel(palette.common, 'onBackground');
        $56edf555c6aa6815$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $56edf555c6aa6815$var$setColor(palette[color], 'mainChannel', (0, $aDUe6.private_safeColorChannel)($56edf555c6aa6815$var$toRgb(colors.main)));
                if (colors.light) $56edf555c6aa6815$var$setColor(palette[color], 'lightChannel', (0, $aDUe6.private_safeColorChannel)($56edf555c6aa6815$var$toRgb(colors.light)));
                if (colors.dark) $56edf555c6aa6815$var$setColor(palette[color], 'darkChannel', (0, $aDUe6.private_safeColorChannel)($56edf555c6aa6815$var$toRgb(colors.dark)));
                if (colors.contrastText) $56edf555c6aa6815$var$setColor(palette[color], 'contrastTextChannel', (0, $aDUe6.private_safeColorChannel)($56edf555c6aa6815$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $56edf555c6aa6815$var$setColorChannel(palette[color], 'primary');
                    $56edf555c6aa6815$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $56edf555c6aa6815$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $56edf555c6aa6815$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $6s3yU.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $3ucK7.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $6F23U.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $k7uoa.default)(input.spacing, (0, $j3YoY.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $6zV8D.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $bXE6K.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $hhWLk.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $1fbQK.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("1uzMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11645aaddf780809$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $11645aaddf780809$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("6zV8D", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", function () { return $4ca2556ba4af0af5$export$858538ff6c0d421d; });
/* eslint-disable import/prefer-default-export */ function $4ca2556ba4af0af5$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("6F23U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d982be2cf5592d6$export$2e2bcd8739ae039; });

var $6s3yU = parcelRequire("6s3yU");

var $8M5bd = parcelRequire("8M5bd");
function $4d982be2cf5592d6$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $8M5bd.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $8M5bd.default)(scheme, parserConfig);
        themeVars = (0, $6s3yU.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $8M5bd.default)(defaultScheme, parserConfig);
        themeVars = (0, $6s3yU.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $6s3yU.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $4d982be2cf5592d6$export$2e2bcd8739ae039 = $4d982be2cf5592d6$var$prepareCssVars;

});
parcelRegister("8M5bd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6636d304eb0eff59$export$2e2bcd8739ae039; });
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $6636d304eb0eff59$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $6636d304eb0eff59$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $6636d304eb0eff59$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $6636d304eb0eff59$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $6636d304eb0eff59$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $6636d304eb0eff59$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $6636d304eb0eff59$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $6636d304eb0eff59$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("97KtX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a48d2ebcd56497e$export$2e2bcd8739ae039; });
function $6a48d2ebcd56497e$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("lobh3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f92495ab4226fafd$export$2e2bcd8739ae039; });

var $eClrZ = parcelRequire("eClrZ");

var $6s3yU = parcelRequire("6s3yU");

var $hhWLk = parcelRequire("hhWLk");
var $bXE6K = parcelRequire("bXE6K");

var $aTv5Z = parcelRequire("aTv5Z");


var $3BsNE = parcelRequire("3BsNE");

var $9u39g = parcelRequire("9u39g");

var $kh2J6 = parcelRequire("kh2J6");

var $9aGb4 = parcelRequire("9aGb4");

var $faUR4 = parcelRequire("faUR4");

var $hO7RK = parcelRequire("hO7RK");

var $1fbQK = parcelRequire("1fbQK");
function $f92495ab4226fafd$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars) throw new Error((0, $eClrZ.default)(20));
    const palette = (0, $9u39g.default)(paletteInput);
    const systemTheme = (0, $aTv5Z.default)(options);
    let muiTheme = (0, $6s3yU.default)(systemTheme, {
        mixins: (0, $3BsNE.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $9aGb4.default).slice(),
        typography: (0, $kh2J6.default)(palette, typographyInput),
        transitions: (0, $faUR4.default)(transitionsInput),
        zIndex: {
            ...(0, $hO7RK.default)
        }
    });
    muiTheme = (0, $6s3yU.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $6s3yU.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $bXE6K.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $hhWLk.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $1fbQK.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $f92495ab4226fafd$var$warnedOnce = false;
function $f92495ab4226fafd$export$c469355549431d9b(...args) {
    return $f92495ab4226fafd$var$createThemeNoVars(...args);
}
var $f92495ab4226fafd$export$2e2bcd8739ae039 = $f92495ab4226fafd$var$createThemeNoVars;

});
parcelRegister("3BsNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29fb2ade88ac4a5f$export$2e2bcd8739ae039; });
function $29fb2ade88ac4a5f$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("kh2J6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec2782949f176603$export$2e2bcd8739ae039; });

var $6s3yU = parcelRequire("6s3yU");
function $ec2782949f176603$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $ec2782949f176603$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $ec2782949f176603$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $ec2782949f176603$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $ec2782949f176603$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $ec2782949f176603$var$defaultFontFamily ? {
                letterSpacing: `${$ec2782949f176603$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $ec2782949f176603$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $ec2782949f176603$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $6s3yU.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("9aGb4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ad5c3cfbd71578a$export$2e2bcd8739ae039; });
const $6ad5c3cfbd71578a$var$shadowKeyUmbraOpacity = 0.2;
const $6ad5c3cfbd71578a$var$shadowKeyPenumbraOpacity = 0.14;
const $6ad5c3cfbd71578a$var$shadowAmbientShadowOpacity = 0.12;
function $6ad5c3cfbd71578a$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$6ad5c3cfbd71578a$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$6ad5c3cfbd71578a$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$6ad5c3cfbd71578a$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $6ad5c3cfbd71578a$var$shadows = [
    'none',
    $6ad5c3cfbd71578a$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $6ad5c3cfbd71578a$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $6ad5c3cfbd71578a$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $6ad5c3cfbd71578a$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $6ad5c3cfbd71578a$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $6ad5c3cfbd71578a$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $6ad5c3cfbd71578a$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $6ad5c3cfbd71578a$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $6ad5c3cfbd71578a$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $6ad5c3cfbd71578a$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $6ad5c3cfbd71578a$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $6ad5c3cfbd71578a$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $6ad5c3cfbd71578a$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $6ad5c3cfbd71578a$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $6ad5c3cfbd71578a$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $6ad5c3cfbd71578a$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $6ad5c3cfbd71578a$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $6ad5c3cfbd71578a$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $6ad5c3cfbd71578a$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $6ad5c3cfbd71578a$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $6ad5c3cfbd71578a$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $6ad5c3cfbd71578a$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $6ad5c3cfbd71578a$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $6ad5c3cfbd71578a$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $6ad5c3cfbd71578a$export$2e2bcd8739ae039 = $6ad5c3cfbd71578a$var$shadows;

});

parcelRegister("faUR4", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $b0c3e46951b75c75$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $b0c3e46951b75c75$export$2e2bcd8739ae039; });
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $b0c3e46951b75c75$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $b0c3e46951b75c75$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b0c3e46951b75c75$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b0c3e46951b75c75$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $b0c3e46951b75c75$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$b0c3e46951b75c75$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$b0c3e46951b75c75$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $b0c3e46951b75c75$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $b0c3e46951b75c75$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $b0c3e46951b75c75$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("hO7RK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf6d352b5c33b36a$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $cf6d352b5c33b36a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $cf6d352b5c33b36a$export$2e2bcd8739ae039 = $cf6d352b5c33b36a$var$zIndex;

});

parcelRegister("1fbQK", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", function () { return $0e806249931bb0e3$export$32c2afa5f91892aa; });
/* eslint-disable import/prefer-default-export */ 
var $6s3yU = parcelRequire("6s3yU");
function $0e806249931bb0e3$var$isSerializable(val) {
    return (0, $6s3yU.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $0e806249931bb0e3$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$0e806249931bb0e3$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $6s3yU.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("4NllW", function(module, exports) {

$parcel$export(module.exports, "getOpacity", function () { return $37dc4d451d7ac845$export$c85e0347fceb69ba; });
$parcel$export(module.exports, "getOverlays", function () { return $37dc4d451d7ac845$export$dd191566510330d3; });
$parcel$export(module.exports, "default", function () { return $37dc4d451d7ac845$export$2e2bcd8739ae039; });

var $9u39g = parcelRequire("9u39g");

var $Kxjv6 = parcelRequire("Kxjv6");
const $37dc4d451d7ac845$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $Kxjv6.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $37dc4d451d7ac845$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $37dc4d451d7ac845$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $37dc4d451d7ac845$var$defaultDarkOverlays : [];
}
function $37dc4d451d7ac845$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $9u39g.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$37dc4d451d7ac845$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $37dc4d451d7ac845$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("Kxjv6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08be235d602a5318$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $08be235d602a5318$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("dJbmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fe84c166972fbd3$export$2e2bcd8739ae039; });
function $9fe84c166972fbd3$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("3ucK7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $289e0ee192a03d20$export$2e2bcd8739ae039; });

var $lAkDo = parcelRequire("lAkDo");
var $289e0ee192a03d20$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $lAkDo.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("lAkDo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb6cf757d39f5aff$export$2e2bcd8739ae039; });
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $fb6cf757d39f5aff$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $fb6cf757d39f5aff$export$2e2bcd8739ae039 = $fb6cf757d39f5aff$var$excludeVariablesFromRoot;

});





parcelRegister("9t00Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e46d56b818df057$export$2e2bcd8739ae039; });
var $6e46d56b818df057$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("ajKPH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $783001c126eed7e3$export$2e2bcd8739ae039; });

var $97ZIb = parcelRequire("97ZIb");
const $783001c126eed7e3$var$rootShouldForwardProp = (prop)=>(0, $97ZIb.default)(prop) && prop !== 'classes';
var $783001c126eed7e3$export$2e2bcd8739ae039 = $783001c126eed7e3$var$rootShouldForwardProp;

});
parcelRegister("97ZIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a54a32b8ddf03e6$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $6a54a32b8ddf03e6$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $6a54a32b8ddf03e6$export$2e2bcd8739ae039 = $6a54a32b8ddf03e6$var$slotShouldForwardProp;

});



parcelRegister("gvYl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c05e58b5d7ef46e6$export$2e2bcd8739ae039; });

var $jpCPf = parcelRequire("jpCPf");
const $c05e58b5d7ef46e6$var$memoTheme = (0, $jpCPf.default);
var $c05e58b5d7ef46e6$export$2e2bcd8739ae039 = $c05e58b5d7ef46e6$var$memoTheme;

});
parcelRegister("jpCPf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e21e781745e3a148$export$2e2bcd8739ae039; });

var $5CT8V = parcelRequire("5CT8V");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $e21e781745e3a148$var$arg = {
    theme: undefined
};
function $e21e781745e3a148$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $e21e781745e3a148$var$arg.theme = props.theme;
            value = (0, $5CT8V.default)(styleFn($e21e781745e3a148$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("vqOnh", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $05e7b1919919f448$export$2440da353cedad43; });
parcelRequire("3QbnI");


var $5fiII = parcelRequire("5fiII");

var $e1vzu = parcelRequire("e1vzu");
'use client';
function $05e7b1919919f448$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $5fiII.default), {
        ...props
    });
}
var $05e7b1919919f448$export$2e2bcd8739ae039 = $05e7b1919919f448$var$DefaultPropsProvider;
function $05e7b1919919f448$export$2440da353cedad43(params) {
    return (0, $5fiII.useDefaultProps)(params);
}

});
parcelRegister("5fiII", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $3d1cdfef0fd199c9$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $3d1cdfef0fd199c9$export$2e2bcd8739ae039; });

var $3QbnI = parcelRequire("3QbnI");


var $dTxTI = parcelRequire("dTxTI");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $3d1cdfef0fd199c9$var$PropsContext = /*#__PURE__*/ $3QbnI.createContext(undefined);
function $3d1cdfef0fd199c9$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $e1vzu.jsx)($3d1cdfef0fd199c9$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $3d1cdfef0fd199c9$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $dTxTI.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $dTxTI.default)(config, props);
    return props;
}
function $3d1cdfef0fd199c9$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $3QbnI.useContext($3d1cdfef0fd199c9$var$PropsContext);
    return $3d1cdfef0fd199c9$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $3d1cdfef0fd199c9$export$2e2bcd8739ae039 = $3d1cdfef0fd199c9$var$DefaultPropsProvider;

});
parcelRegister("dTxTI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1dab4c2102f107e$export$2e2bcd8739ae039; });
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $a1dab4c2102f107e$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $a1dab4c2102f107e$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});



parcelRegister("iXYVf", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $dcecfe94697d7beb$export$c7c50641356bdfa5; });

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $dcecfe94697d7beb$export$c7c50641356bdfa5(slot) {
    return (0, $9uBH9.default)('MuiSvgIcon', slot);
}
const $dcecfe94697d7beb$var$svgIconClasses = (0, $6N1Oq.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $dcecfe94697d7beb$export$2e2bcd8739ae039 = $dcecfe94697d7beb$var$svgIconClasses;

});
parcelRegister("6N1Oq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f18b98f948aa8f3$export$2e2bcd8739ae039; });

var $9uBH9 = parcelRequire("9uBH9");
function $4f18b98f948aa8f3$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $9uBH9.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("9uBH9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e9427d478fa4882$export$2e2bcd8739ae039; });

var $gM6lN = parcelRequire("gM6lN");
const $6e9427d478fa4882$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $6e9427d478fa4882$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $6e9427d478fa4882$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $gM6lN.default).generate(componentName)}-${slot}`;
}
function $6e9427d478fa4882$export$34c0130b1f3e8ae3(slot) {
    return $6e9427d478fa4882$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("gM6lN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3660e20b42f93e7$export$2e2bcd8739ae039; });
const $c3660e20b42f93e7$var$defaultGenerator = (componentName)=>componentName;
const $c3660e20b42f93e7$var$createClassNameGenerator = ()=>{
    let generate = $c3660e20b42f93e7$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $c3660e20b42f93e7$var$defaultGenerator;
        }
    };
};
const $c3660e20b42f93e7$var$ClassNameGenerator = $c3660e20b42f93e7$var$createClassNameGenerator();
var $c3660e20b42f93e7$export$2e2bcd8739ae039 = $c3660e20b42f93e7$var$ClassNameGenerator;

});







parcelRegister("3Rwjo", function(module, exports) {

$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "Form", function () { return Form; });

var $80Td8 = parcelRequire("80Td8");

var $l5A6B = parcelRequire("l5A6B");

var $lMELy = parcelRequire("lMELy");

var $3QbnI = parcelRequire("3QbnI");

var $8xxO0 = parcelRequire("8xxO0");

var $3JyNw = parcelRequire("3JyNw");

var $gEJ4F = parcelRequire("gEJ4F");

var $lHNrF = parcelRequire("lHNrF");

var $8FL51 = parcelRequire("8FL51");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $3QbnI.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $3QbnI.useContext)(FormikContext);
    !!!formik && (0, $3JyNw.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $3QbnI.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $lHNrF.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $gEJ4F.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $lHNrF.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $gEJ4F.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $3QbnI.useRef)(props.initialValues);
    var initialErrors = (0, $3QbnI.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $3QbnI.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $3QbnI.useRef)(props.initialStatus);
    var isMounted = (0, $3QbnI.useRef)(false);
    var fieldRegistry = (0, $3QbnI.useRef)({});
    (0, $3QbnI.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $3QbnI.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $3QbnI.useRef)({
        values: (0, $lMELy.default)(props.initialValues),
        errors: (0, $lMELy.default)(props.initialErrors) || emptyErrors,
        touched: (0, $lMELy.default)(props.initialTouched) || emptyTouched,
        status: (0, $lMELy.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $3QbnI.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $3QbnI.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $3QbnI.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $3QbnI.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $3QbnI.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $3QbnI.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $80Td8.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $3QbnI.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $3QbnI.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $3QbnI.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $3QbnI.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $3QbnI.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $3QbnI.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $3QbnI.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $3QbnI.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $3QbnI.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $3QbnI.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $3QbnI.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $3QbnI.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $3QbnI.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $3QbnI.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $3QbnI.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $3QbnI.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $3QbnI.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $3QbnI.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $3QbnI.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $3QbnI.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $3QbnI.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $3QbnI.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $3QbnI.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $3QbnI.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $l5A6B.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $l5A6B.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $80Td8.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $80Td8.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $3QbnI.useLayoutEffect) : (0, $3QbnI.useEffect);
function useEventCallback(fn) {
    var ref = (0, $3QbnI.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $3QbnI.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $3QbnI.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $3JyNw.default)(false);
    var fieldHelpers = (0, $3QbnI.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $3QbnI.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $3QbnI.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $3QbnI.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $3QbnI.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $3QbnI.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $3QbnI.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $3QbnI.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $3QbnI.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $3QbnI.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $3QbnI.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $3QbnI.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $3JyNw.default)(false);
            return (0, $3QbnI.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $lMELy.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $3QbnI.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $3QbnI.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $3QbnI.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $3QbnI.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $3QbnI.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $3JyNw.default)(false);
        !!(component && render) && (0, $3JyNw.default)(false);
        !!(is && children && isFunction(children)) && (0, $3JyNw.default)(false);
        !!(component && children && isFunction(children)) && (0, $3JyNw.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $3JyNw.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $3QbnI.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $3QbnI.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $3QbnI.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $3QbnI.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $3QbnI.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("80Td8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d59268bb6326a3a$export$2e2bcd8739ae039; });
var $5d59268bb6326a3a$var$isMergeableObject = function isMergeableObject(value) {
    return $5d59268bb6326a3a$var$isNonNullObject(value) && !$5d59268bb6326a3a$var$isSpecial(value);
};
function $5d59268bb6326a3a$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $5d59268bb6326a3a$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $5d59268bb6326a3a$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $5d59268bb6326a3a$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $5d59268bb6326a3a$var$REACT_ELEMENT_TYPE = $5d59268bb6326a3a$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $5d59268bb6326a3a$var$isReactElement(value) {
    return value.$$typeof === $5d59268bb6326a3a$var$REACT_ELEMENT_TYPE;
}
function $5d59268bb6326a3a$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $5d59268bb6326a3a$var$deepmerge($5d59268bb6326a3a$var$emptyTarget(value), value, options) : value;
}
function $5d59268bb6326a3a$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $5d59268bb6326a3a$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $5d59268bb6326a3a$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $5d59268bb6326a3a$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $5d59268bb6326a3a$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $5d59268bb6326a3a$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $5d59268bb6326a3a$var$mergeObject(target, source, options);
}
$5d59268bb6326a3a$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $5d59268bb6326a3a$var$deepmerge(prev, next, options);
    }, {});
};
var $5d59268bb6326a3a$var$deepmerge_1 = $5d59268bb6326a3a$var$deepmerge;
var $5d59268bb6326a3a$export$2e2bcd8739ae039 = $5d59268bb6326a3a$var$deepmerge_1;

});

parcelRegister("l5A6B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a61267ac9c9829$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $FgAoP = parcelRequire("FgAoP");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $f5a61267ac9c9829$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $f5a61267ac9c9829$var$funcProto = Function.prototype, $f5a61267ac9c9829$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f5a61267ac9c9829$var$funcToString = $f5a61267ac9c9829$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f5a61267ac9c9829$var$hasOwnProperty = $f5a61267ac9c9829$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $f5a61267ac9c9829$var$objectCtorString = $f5a61267ac9c9829$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $f5a61267ac9c9829$var$isPlainObject(value) {
    if (!(0, $QTaGs.default)(value) || (0, $8ypmi.default)(value) != $f5a61267ac9c9829$var$objectTag) return false;
    var proto = (0, $FgAoP.default)(value);
    if (proto === null) return true;
    var Ctor = $f5a61267ac9c9829$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $f5a61267ac9c9829$var$funcToString.call(Ctor) == $f5a61267ac9c9829$var$objectCtorString;
}
var $f5a61267ac9c9829$export$2e2bcd8739ae039 = $f5a61267ac9c9829$var$isPlainObject;

});
parcelRegister("8ypmi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63a52b63e860451f$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");

var $lgbdJ = parcelRequire("lgbdJ");

var $5FaXM = parcelRequire("5FaXM");
/** `Object#toString` result references. */ var $63a52b63e860451f$var$nullTag = '[object Null]', $63a52b63e860451f$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $63a52b63e860451f$var$symToStringTag = (0, $iQXmk.default) ? (0, $iQXmk.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $63a52b63e860451f$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $63a52b63e860451f$var$undefinedTag : $63a52b63e860451f$var$nullTag;
    return $63a52b63e860451f$var$symToStringTag && $63a52b63e860451f$var$symToStringTag in Object(value) ? (0, $lgbdJ.default)(value) : (0, $5FaXM.default)(value);
}
var $63a52b63e860451f$export$2e2bcd8739ae039 = $63a52b63e860451f$var$baseGetTag;

});
parcelRegister("iQXmk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db9b20cc76d3f8d1$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Built-in value references. */ var $db9b20cc76d3f8d1$var$Symbol = (0, $65KY2.default).Symbol;
var $db9b20cc76d3f8d1$export$2e2bcd8739ae039 = $db9b20cc76d3f8d1$var$Symbol;

});
parcelRegister("65KY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f7a4759b73d162$export$2e2bcd8739ae039; });

var $h1ybm = parcelRequire("h1ybm");
/** Detect free variable `self`. */ var $46f7a4759b73d162$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $46f7a4759b73d162$var$root = (0, $h1ybm.default) || $46f7a4759b73d162$var$freeSelf || Function('return this')();
var $46f7a4759b73d162$export$2e2bcd8739ae039 = $46f7a4759b73d162$var$root;

});
parcelRegister("h1ybm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c64d0b90181ed9dd$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $c64d0b90181ed9dd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $c64d0b90181ed9dd$export$2e2bcd8739ae039 = $c64d0b90181ed9dd$var$freeGlobal;

});



parcelRegister("lgbdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7a3cbbfb80b5519$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");
/** Used for built-in method references. */ var $f7a3cbbfb80b5519$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7a3cbbfb80b5519$var$hasOwnProperty = $f7a3cbbfb80b5519$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f7a3cbbfb80b5519$var$nativeObjectToString = $f7a3cbbfb80b5519$var$objectProto.toString;
/** Built-in value references. */ var $f7a3cbbfb80b5519$var$symToStringTag = (0, $iQXmk.default) ? (0, $iQXmk.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f7a3cbbfb80b5519$var$getRawTag(value) {
    var isOwn = $f7a3cbbfb80b5519$var$hasOwnProperty.call(value, $f7a3cbbfb80b5519$var$symToStringTag), tag = value[$f7a3cbbfb80b5519$var$symToStringTag];
    try {
        value[$f7a3cbbfb80b5519$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f7a3cbbfb80b5519$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f7a3cbbfb80b5519$var$symToStringTag] = tag;
        else delete value[$f7a3cbbfb80b5519$var$symToStringTag];
    }
    return result;
}
var $f7a3cbbfb80b5519$export$2e2bcd8739ae039 = $f7a3cbbfb80b5519$var$getRawTag;

});

parcelRegister("5FaXM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41f94924c3cd05fa$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $41f94924c3cd05fa$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $41f94924c3cd05fa$var$nativeObjectToString = $41f94924c3cd05fa$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $41f94924c3cd05fa$var$objectToString(value) {
    return $41f94924c3cd05fa$var$nativeObjectToString.call(value);
}
var $41f94924c3cd05fa$export$2e2bcd8739ae039 = $41f94924c3cd05fa$var$objectToString;

});


parcelRegister("FgAoP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07c0b21a19a53df8$export$2e2bcd8739ae039; });

var $63r4t = parcelRequire("63r4t");
/** Built-in value references. */ var $07c0b21a19a53df8$var$getPrototype = (0, $63r4t.default)(Object.getPrototypeOf, Object);
var $07c0b21a19a53df8$export$2e2bcd8739ae039 = $07c0b21a19a53df8$var$getPrototype;

});
parcelRegister("63r4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468805a22d2bea69$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $468805a22d2bea69$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $468805a22d2bea69$export$2e2bcd8739ae039 = $468805a22d2bea69$var$overArg;

});


parcelRegister("QTaGs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09efa7518ff2ecd8$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $09efa7518ff2ecd8$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $09efa7518ff2ecd8$export$2e2bcd8739ae039 = $09efa7518ff2ecd8$var$isObjectLike;

});


parcelRegister("lMELy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdbdb3f7bd8930f0$export$2e2bcd8739ae039; });

var $jIw7K = parcelRequire("jIw7K");
/** Used to compose bitmasks for cloning. */ var $fdbdb3f7bd8930f0$var$CLONE_DEEP_FLAG = 1, $fdbdb3f7bd8930f0$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $fdbdb3f7bd8930f0$var$cloneDeep(value) {
    return (0, $jIw7K.default)(value, $fdbdb3f7bd8930f0$var$CLONE_DEEP_FLAG | $fdbdb3f7bd8930f0$var$CLONE_SYMBOLS_FLAG);
}
var $fdbdb3f7bd8930f0$export$2e2bcd8739ae039 = $fdbdb3f7bd8930f0$var$cloneDeep;

});
parcelRegister("jIw7K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5ab0b88c071b93d$export$2e2bcd8739ae039; });

var $30gur = parcelRequire("30gur");

var $i89nt = parcelRequire("i89nt");

var $hEH8C = parcelRequire("hEH8C");

var $lcedB = parcelRequire("lcedB");

var $4oQTa = parcelRequire("4oQTa");

var $hD9Sw = parcelRequire("hD9Sw");

var $cbaxU = parcelRequire("cbaxU");

var $g5knF = parcelRequire("g5knF");

var $gi8Nh = parcelRequire("gi8Nh");

var $6CWdP = parcelRequire("6CWdP");

var $05fLa = parcelRequire("05fLa");

var $bdaH3 = parcelRequire("bdaH3");

var $aJAyC = parcelRequire("aJAyC");

var $eMOhO = parcelRequire("eMOhO");

var $eeWvl = parcelRequire("eeWvl");

var $cvQ90 = parcelRequire("cvQ90");

var $lTJlI = parcelRequire("lTJlI");

var $9cm4a = parcelRequire("9cm4a");

var $6vN6O = parcelRequire("6vN6O");

var $kO458 = parcelRequire("kO458");

var $bCEuG = parcelRequire("bCEuG");

var $5QaB6 = parcelRequire("5QaB6");
/** Used to compose bitmasks for cloning. */ var $e5ab0b88c071b93d$var$CLONE_DEEP_FLAG = 1, $e5ab0b88c071b93d$var$CLONE_FLAT_FLAG = 2, $e5ab0b88c071b93d$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $e5ab0b88c071b93d$var$argsTag = '[object Arguments]', $e5ab0b88c071b93d$var$arrayTag = '[object Array]', $e5ab0b88c071b93d$var$boolTag = '[object Boolean]', $e5ab0b88c071b93d$var$dateTag = '[object Date]', $e5ab0b88c071b93d$var$errorTag = '[object Error]', $e5ab0b88c071b93d$var$funcTag = '[object Function]', $e5ab0b88c071b93d$var$genTag = '[object GeneratorFunction]', $e5ab0b88c071b93d$var$mapTag = '[object Map]', $e5ab0b88c071b93d$var$numberTag = '[object Number]', $e5ab0b88c071b93d$var$objectTag = '[object Object]', $e5ab0b88c071b93d$var$regexpTag = '[object RegExp]', $e5ab0b88c071b93d$var$setTag = '[object Set]', $e5ab0b88c071b93d$var$stringTag = '[object String]', $e5ab0b88c071b93d$var$symbolTag = '[object Symbol]', $e5ab0b88c071b93d$var$weakMapTag = '[object WeakMap]';
var $e5ab0b88c071b93d$var$arrayBufferTag = '[object ArrayBuffer]', $e5ab0b88c071b93d$var$dataViewTag = '[object DataView]', $e5ab0b88c071b93d$var$float32Tag = '[object Float32Array]', $e5ab0b88c071b93d$var$float64Tag = '[object Float64Array]', $e5ab0b88c071b93d$var$int8Tag = '[object Int8Array]', $e5ab0b88c071b93d$var$int16Tag = '[object Int16Array]', $e5ab0b88c071b93d$var$int32Tag = '[object Int32Array]', $e5ab0b88c071b93d$var$uint8Tag = '[object Uint8Array]', $e5ab0b88c071b93d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e5ab0b88c071b93d$var$uint16Tag = '[object Uint16Array]', $e5ab0b88c071b93d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $e5ab0b88c071b93d$var$cloneableTags = {};
$e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$argsTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$arrayTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$arrayBufferTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$dataViewTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$boolTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$dateTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$float32Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$float64Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$int8Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$int16Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$int32Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$mapTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$numberTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$objectTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$regexpTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$setTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$stringTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$symbolTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint8Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint8ClampedTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint16Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint32Tag] = true;
$e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$errorTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$funcTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $e5ab0b88c071b93d$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $e5ab0b88c071b93d$var$CLONE_DEEP_FLAG, isFlat = bitmask & $e5ab0b88c071b93d$var$CLONE_FLAT_FLAG, isFull = bitmask & $e5ab0b88c071b93d$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $6vN6O.default)(value)) return value;
    var isArr = (0, $cvQ90.default)(value);
    if (isArr) {
        result = (0, $aJAyC.default)(value);
        if (!isDeep) return (0, $cbaxU.default)(value, result);
    } else {
        var tag = (0, $bdaH3.default)(value), isFunc = tag == $e5ab0b88c071b93d$var$funcTag || tag == $e5ab0b88c071b93d$var$genTag;
        if ((0, $lTJlI.default)(value)) return (0, $hD9Sw.default)(value, isDeep);
        if (tag == $e5ab0b88c071b93d$var$objectTag || tag == $e5ab0b88c071b93d$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $eeWvl.default)(value);
            if (!isDeep) return isFlat ? (0, $gi8Nh.default)(value, (0, $4oQTa.default)(result, value)) : (0, $g5knF.default)(value, (0, $lcedB.default)(result, value));
        } else {
            if (!$e5ab0b88c071b93d$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $eMOhO.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $30gur.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $kO458.default)(value)) value.forEach(function(subValue) {
        result.add($e5ab0b88c071b93d$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $9cm4a.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $e5ab0b88c071b93d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $05fLa.default) : (0, $6CWdP.default) : isFlat ? (0, $5QaB6.default) : (0, $bCEuG.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $i89nt.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $hEH8C.default)(result, key, $e5ab0b88c071b93d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $e5ab0b88c071b93d$export$2e2bcd8739ae039 = $e5ab0b88c071b93d$var$baseClone;

});
parcelRegister("30gur", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22fe29c2a1ce14bf$export$2e2bcd8739ae039; });

var $1L7Vn = parcelRequire("1L7Vn");

var $kvs60 = parcelRequire("kvs60");

var $gwr4T = parcelRequire("gwr4T");

var $hBE2d = parcelRequire("hBE2d");

var $b3VB6 = parcelRequire("b3VB6");

var $kJtaZ = parcelRequire("kJtaZ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $22fe29c2a1ce14bf$var$Stack(entries) {
    var data = this.__data__ = new (0, $1L7Vn.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$22fe29c2a1ce14bf$var$Stack.prototype.clear = (0, $kvs60.default);
$22fe29c2a1ce14bf$var$Stack.prototype['delete'] = (0, $gwr4T.default);
$22fe29c2a1ce14bf$var$Stack.prototype.get = (0, $hBE2d.default);
$22fe29c2a1ce14bf$var$Stack.prototype.has = (0, $b3VB6.default);
$22fe29c2a1ce14bf$var$Stack.prototype.set = (0, $kJtaZ.default);
var $22fe29c2a1ce14bf$export$2e2bcd8739ae039 = $22fe29c2a1ce14bf$var$Stack;

});
parcelRegister("1L7Vn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $148053d706dae3be$export$2e2bcd8739ae039; });

var $d2x9T = parcelRequire("d2x9T");

var $arBmH = parcelRequire("arBmH");

var $hmWkL = parcelRequire("hmWkL");

var $dy3DT = parcelRequire("dy3DT");

var $8jgMB = parcelRequire("8jgMB");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $148053d706dae3be$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$148053d706dae3be$var$ListCache.prototype.clear = (0, $d2x9T.default);
$148053d706dae3be$var$ListCache.prototype['delete'] = (0, $arBmH.default);
$148053d706dae3be$var$ListCache.prototype.get = (0, $hmWkL.default);
$148053d706dae3be$var$ListCache.prototype.has = (0, $dy3DT.default);
$148053d706dae3be$var$ListCache.prototype.set = (0, $8jgMB.default);
var $148053d706dae3be$export$2e2bcd8739ae039 = $148053d706dae3be$var$ListCache;

});
parcelRegister("d2x9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97e52edc99c01de6$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $97e52edc99c01de6$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $97e52edc99c01de6$export$2e2bcd8739ae039 = $97e52edc99c01de6$var$listCacheClear;

});

parcelRegister("arBmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79a968ea83f562e0$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/** Used for built-in method references. */ var $79a968ea83f562e0$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $79a968ea83f562e0$var$splice = $79a968ea83f562e0$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $79a968ea83f562e0$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ewK8y.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $79a968ea83f562e0$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $79a968ea83f562e0$export$2e2bcd8739ae039 = $79a968ea83f562e0$var$listCacheDelete;

});
parcelRegister("ewK8y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a937d7aa975253b2$export$2e2bcd8739ae039; });

var $35xIW = parcelRequire("35xIW");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a937d7aa975253b2$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $35xIW.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $a937d7aa975253b2$export$2e2bcd8739ae039 = $a937d7aa975253b2$var$assocIndexOf;

});
parcelRegister("35xIW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fbff934cae5a70$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $23fbff934cae5a70$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $23fbff934cae5a70$export$2e2bcd8739ae039 = $23fbff934cae5a70$var$eq;

});



parcelRegister("hmWkL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca51bd9dd2622a2d$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ca51bd9dd2622a2d$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ewK8y.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $ca51bd9dd2622a2d$export$2e2bcd8739ae039 = $ca51bd9dd2622a2d$var$listCacheGet;

});

parcelRegister("dy3DT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dd146acabb673e8$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9dd146acabb673e8$var$listCacheHas(key) {
    return (0, $ewK8y.default)(this.__data__, key) > -1;
}
var $9dd146acabb673e8$export$2e2bcd8739ae039 = $9dd146acabb673e8$var$listCacheHas;

});

parcelRegister("8jgMB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60cd1dce32e03f61$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $60cd1dce32e03f61$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ewK8y.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $60cd1dce32e03f61$export$2e2bcd8739ae039 = $60cd1dce32e03f61$var$listCacheSet;

});


parcelRegister("kvs60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eedc7f2b4cad253b$export$2e2bcd8739ae039; });

var $1L7Vn = parcelRequire("1L7Vn");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $eedc7f2b4cad253b$var$stackClear() {
    this.__data__ = new (0, $1L7Vn.default);
    this.size = 0;
}
var $eedc7f2b4cad253b$export$2e2bcd8739ae039 = $eedc7f2b4cad253b$var$stackClear;

});

parcelRegister("gwr4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c074a3a094dc6d0c$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c074a3a094dc6d0c$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $c074a3a094dc6d0c$export$2e2bcd8739ae039 = $c074a3a094dc6d0c$var$stackDelete;

});

parcelRegister("hBE2d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd14f26d860e5f74$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cd14f26d860e5f74$var$stackGet(key) {
    return this.__data__.get(key);
}
var $cd14f26d860e5f74$export$2e2bcd8739ae039 = $cd14f26d860e5f74$var$stackGet;

});

parcelRegister("b3VB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80dca729546eb3d4$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $80dca729546eb3d4$var$stackHas(key) {
    return this.__data__.has(key);
}
var $80dca729546eb3d4$export$2e2bcd8739ae039 = $80dca729546eb3d4$var$stackHas;

});

parcelRegister("kJtaZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f17ea46ee6873b72$export$2e2bcd8739ae039; });

var $1L7Vn = parcelRequire("1L7Vn");

var $fnuNy = parcelRequire("fnuNy");

var $jitcP = parcelRequire("jitcP");
/** Used as the size to enable large array optimizations. */ var $f17ea46ee6873b72$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $f17ea46ee6873b72$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $1L7Vn.default)) {
        var pairs = data.__data__;
        if (!(0, $fnuNy.default) || pairs.length < $f17ea46ee6873b72$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $jitcP.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $f17ea46ee6873b72$export$2e2bcd8739ae039 = $f17ea46ee6873b72$var$stackSet;

});
parcelRegister("fnuNy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b320e4e562772a7d$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $b320e4e562772a7d$var$Map = (0, $97o2V.default)((0, $65KY2.default), 'Map');
var $b320e4e562772a7d$export$2e2bcd8739ae039 = $b320e4e562772a7d$var$Map;

});
parcelRegister("97o2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a376b8c868c04d4$export$2e2bcd8739ae039; });

var $jlIsA = parcelRequire("jlIsA");

var $bLvsx = parcelRequire("bLvsx");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6a376b8c868c04d4$var$getNative(object, key) {
    var value = (0, $bLvsx.default)(object, key);
    return (0, $jlIsA.default)(value) ? value : undefined;
}
var $6a376b8c868c04d4$export$2e2bcd8739ae039 = $6a376b8c868c04d4$var$getNative;

});
parcelRegister("jlIsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e16277573605e2c0$export$2e2bcd8739ae039; });

var $5OjsN = parcelRequire("5OjsN");

var $cSLZ6 = parcelRequire("cSLZ6");

var $6vN6O = parcelRequire("6vN6O");

var $jZH4M = parcelRequire("jZH4M");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e16277573605e2c0$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e16277573605e2c0$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $e16277573605e2c0$var$funcProto = Function.prototype, $e16277573605e2c0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e16277573605e2c0$var$funcToString = $e16277573605e2c0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e16277573605e2c0$var$hasOwnProperty = $e16277573605e2c0$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $e16277573605e2c0$var$reIsNative = RegExp('^' + $e16277573605e2c0$var$funcToString.call($e16277573605e2c0$var$hasOwnProperty).replace($e16277573605e2c0$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e16277573605e2c0$var$baseIsNative(value) {
    if (!(0, $6vN6O.default)(value) || (0, $cSLZ6.default)(value)) return false;
    var pattern = (0, $5OjsN.default)(value) ? $e16277573605e2c0$var$reIsNative : $e16277573605e2c0$var$reIsHostCtor;
    return pattern.test((0, $jZH4M.default)(value));
}
var $e16277573605e2c0$export$2e2bcd8739ae039 = $e16277573605e2c0$var$baseIsNative;

});
parcelRegister("5OjsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b0b84809e47192$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $6vN6O = parcelRequire("6vN6O");
/** `Object#toString` result references. */ var $43b0b84809e47192$var$asyncTag = '[object AsyncFunction]', $43b0b84809e47192$var$funcTag = '[object Function]', $43b0b84809e47192$var$genTag = '[object GeneratorFunction]', $43b0b84809e47192$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $43b0b84809e47192$var$isFunction(value) {
    if (!(0, $6vN6O.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $8ypmi.default)(value);
    return tag == $43b0b84809e47192$var$funcTag || tag == $43b0b84809e47192$var$genTag || tag == $43b0b84809e47192$var$asyncTag || tag == $43b0b84809e47192$var$proxyTag;
}
var $43b0b84809e47192$export$2e2bcd8739ae039 = $43b0b84809e47192$var$isFunction;

});
parcelRegister("6vN6O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bdbbb59fcac0bb9$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4bdbbb59fcac0bb9$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $4bdbbb59fcac0bb9$export$2e2bcd8739ae039 = $4bdbbb59fcac0bb9$var$isObject;

});


parcelRegister("cSLZ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $960fbfeca0df1e98$export$2e2bcd8739ae039; });

var $4Qwdl = parcelRequire("4Qwdl");
/** Used to detect methods masquerading as native. */ var $960fbfeca0df1e98$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $4Qwdl.default) && (0, $4Qwdl.default).keys && (0, $4Qwdl.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $960fbfeca0df1e98$var$isMasked(func) {
    return !!$960fbfeca0df1e98$var$maskSrcKey && $960fbfeca0df1e98$var$maskSrcKey in func;
}
var $960fbfeca0df1e98$export$2e2bcd8739ae039 = $960fbfeca0df1e98$var$isMasked;

});
parcelRegister("4Qwdl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $387501cfb4f5ac43$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Used to detect overreaching core-js shims. */ var $387501cfb4f5ac43$var$coreJsData = (0, $65KY2.default)['__core-js_shared__'];
var $387501cfb4f5ac43$export$2e2bcd8739ae039 = $387501cfb4f5ac43$var$coreJsData;

});


parcelRegister("jZH4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e520d4fbabdba0$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $e8e520d4fbabdba0$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e8e520d4fbabdba0$var$funcToString = $e8e520d4fbabdba0$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e8e520d4fbabdba0$var$toSource(func) {
    if (func != null) {
        try {
            return $e8e520d4fbabdba0$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $e8e520d4fbabdba0$export$2e2bcd8739ae039 = $e8e520d4fbabdba0$var$toSource;

});


parcelRegister("bLvsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $890c7ca478ff16a5$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $890c7ca478ff16a5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $890c7ca478ff16a5$export$2e2bcd8739ae039 = $890c7ca478ff16a5$var$getValue;

});



parcelRegister("jitcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0c65a6c1121d798$export$2e2bcd8739ae039; });

var $j2egd = parcelRequire("j2egd");

var $6BjDB = parcelRequire("6BjDB");

var $dcq99 = parcelRequire("dcq99");

var $lJWNS = parcelRequire("lJWNS");

var $dwmFA = parcelRequire("dwmFA");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e0c65a6c1121d798$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$e0c65a6c1121d798$var$MapCache.prototype.clear = (0, $j2egd.default);
$e0c65a6c1121d798$var$MapCache.prototype['delete'] = (0, $6BjDB.default);
$e0c65a6c1121d798$var$MapCache.prototype.get = (0, $dcq99.default);
$e0c65a6c1121d798$var$MapCache.prototype.has = (0, $lJWNS.default);
$e0c65a6c1121d798$var$MapCache.prototype.set = (0, $dwmFA.default);
var $e0c65a6c1121d798$export$2e2bcd8739ae039 = $e0c65a6c1121d798$var$MapCache;

});
parcelRegister("j2egd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb94410cedd2612$export$2e2bcd8739ae039; });

var $hgwaz = parcelRequire("hgwaz");

var $1L7Vn = parcelRequire("1L7Vn");

var $fnuNy = parcelRequire("fnuNy");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ddb94410cedd2612$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $hgwaz.default),
        'map': new ((0, $fnuNy.default) || (0, $1L7Vn.default)),
        'string': new (0, $hgwaz.default)
    };
}
var $ddb94410cedd2612$export$2e2bcd8739ae039 = $ddb94410cedd2612$var$mapCacheClear;

});
parcelRegister("hgwaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c91ce27793a3f4a7$export$2e2bcd8739ae039; });

var $4Tz9g = parcelRequire("4Tz9g");

var $17d5X = parcelRequire("17d5X");

var $kG6qk = parcelRequire("kG6qk");

var $vHhnq = parcelRequire("vHhnq");

var $bK942 = parcelRequire("bK942");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c91ce27793a3f4a7$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$c91ce27793a3f4a7$var$Hash.prototype.clear = (0, $4Tz9g.default);
$c91ce27793a3f4a7$var$Hash.prototype['delete'] = (0, $17d5X.default);
$c91ce27793a3f4a7$var$Hash.prototype.get = (0, $kG6qk.default);
$c91ce27793a3f4a7$var$Hash.prototype.has = (0, $vHhnq.default);
$c91ce27793a3f4a7$var$Hash.prototype.set = (0, $bK942.default);
var $c91ce27793a3f4a7$export$2e2bcd8739ae039 = $c91ce27793a3f4a7$var$Hash;

});
parcelRegister("4Tz9g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39079039e378aa63$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $39079039e378aa63$var$hashClear() {
    this.__data__ = (0, $1WnQP.default) ? (0, $1WnQP.default)(null) : {};
    this.size = 0;
}
var $39079039e378aa63$export$2e2bcd8739ae039 = $39079039e378aa63$var$hashClear;

});
parcelRegister("1WnQP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $169db58942102db8$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");
/* Built-in method references that are verified to be native. */ var $169db58942102db8$var$nativeCreate = (0, $97o2V.default)(Object, 'create');
var $169db58942102db8$export$2e2bcd8739ae039 = $169db58942102db8$var$nativeCreate;

});


parcelRegister("17d5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d009a4cf800ead6$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0d009a4cf800ead6$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $0d009a4cf800ead6$export$2e2bcd8739ae039 = $0d009a4cf800ead6$var$hashDelete;

});

parcelRegister("kG6qk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0dcb67fbe65ee1c$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/** Used to stand-in for `undefined` hash values. */ var $f0dcb67fbe65ee1c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $f0dcb67fbe65ee1c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0dcb67fbe65ee1c$var$hasOwnProperty = $f0dcb67fbe65ee1c$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f0dcb67fbe65ee1c$var$hashGet(key) {
    var data = this.__data__;
    if (0, $1WnQP.default) {
        var result = data[key];
        return result === $f0dcb67fbe65ee1c$var$HASH_UNDEFINED ? undefined : result;
    }
    return $f0dcb67fbe65ee1c$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $f0dcb67fbe65ee1c$export$2e2bcd8739ae039 = $f0dcb67fbe65ee1c$var$hashGet;

});

parcelRegister("vHhnq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f477b9fa072c51$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/** Used for built-in method references. */ var $05f477b9fa072c51$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $05f477b9fa072c51$var$hasOwnProperty = $05f477b9fa072c51$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $05f477b9fa072c51$var$hashHas(key) {
    var data = this.__data__;
    return (0, $1WnQP.default) ? data[key] !== undefined : $05f477b9fa072c51$var$hasOwnProperty.call(data, key);
}
var $05f477b9fa072c51$export$2e2bcd8739ae039 = $05f477b9fa072c51$var$hashHas;

});

parcelRegister("bK942", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88cb05871b91c14d$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/** Used to stand-in for `undefined` hash values. */ var $88cb05871b91c14d$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $88cb05871b91c14d$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $1WnQP.default) && value === undefined ? $88cb05871b91c14d$var$HASH_UNDEFINED : value;
    return this;
}
var $88cb05871b91c14d$export$2e2bcd8739ae039 = $88cb05871b91c14d$var$hashSet;

});



parcelRegister("6BjDB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce56e6ccf07c43c$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4ce56e6ccf07c43c$var$mapCacheDelete(key) {
    var result = (0, $j83NR.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $4ce56e6ccf07c43c$export$2e2bcd8739ae039 = $4ce56e6ccf07c43c$var$mapCacheDelete;

});
parcelRegister("j83NR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ded1b6e67eb9cd5e$export$2e2bcd8739ae039; });

var $fn6OQ = parcelRequire("fn6OQ");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ded1b6e67eb9cd5e$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $fn6OQ.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $ded1b6e67eb9cd5e$export$2e2bcd8739ae039 = $ded1b6e67eb9cd5e$var$getMapData;

});
parcelRegister("fn6OQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b30e4b19acaf09db$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b30e4b19acaf09db$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $b30e4b19acaf09db$export$2e2bcd8739ae039 = $b30e4b19acaf09db$var$isKeyable;

});



parcelRegister("dcq99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99c0ad843ce73a05$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $99c0ad843ce73a05$var$mapCacheGet(key) {
    return (0, $j83NR.default)(this, key).get(key);
}
var $99c0ad843ce73a05$export$2e2bcd8739ae039 = $99c0ad843ce73a05$var$mapCacheGet;

});

parcelRegister("lJWNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3b6a1c9c42a9be$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fd3b6a1c9c42a9be$var$mapCacheHas(key) {
    return (0, $j83NR.default)(this, key).has(key);
}
var $fd3b6a1c9c42a9be$export$2e2bcd8739ae039 = $fd3b6a1c9c42a9be$var$mapCacheHas;

});

parcelRegister("dwmFA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d7fd9419dffa8dc$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $9d7fd9419dffa8dc$var$mapCacheSet(key, value) {
    var data = (0, $j83NR.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $9d7fd9419dffa8dc$export$2e2bcd8739ae039 = $9d7fd9419dffa8dc$var$mapCacheSet;

});




parcelRegister("i89nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3303f8f23d7dec4$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d3303f8f23d7dec4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d3303f8f23d7dec4$export$2e2bcd8739ae039 = $d3303f8f23d7dec4$var$arrayEach;

});

parcelRegister("hEH8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cda7a26dc04cf3b8$export$2e2bcd8739ae039; });

var $kMRMD = parcelRequire("kMRMD");

var $35xIW = parcelRequire("35xIW");
/** Used for built-in method references. */ var $cda7a26dc04cf3b8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cda7a26dc04cf3b8$var$hasOwnProperty = $cda7a26dc04cf3b8$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $cda7a26dc04cf3b8$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($cda7a26dc04cf3b8$var$hasOwnProperty.call(object, key) && (0, $35xIW.default)(objValue, value)) || value === undefined && !(key in object)) (0, $kMRMD.default)(object, key, value);
}
var $cda7a26dc04cf3b8$export$2e2bcd8739ae039 = $cda7a26dc04cf3b8$var$assignValue;

});
parcelRegister("kMRMD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f22202a2476a3e43$export$2e2bcd8739ae039; });

var $hBQ41 = parcelRequire("hBQ41");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f22202a2476a3e43$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $hBQ41.default)) (0, $hBQ41.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $f22202a2476a3e43$export$2e2bcd8739ae039 = $f22202a2476a3e43$var$baseAssignValue;

});
parcelRegister("hBQ41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd1e4729ed176eb2$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");
var $cd1e4729ed176eb2$var$defineProperty = function() {
    try {
        var func = (0, $97o2V.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $cd1e4729ed176eb2$export$2e2bcd8739ae039 = $cd1e4729ed176eb2$var$defineProperty;

});



parcelRegister("lcedB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e5bf6a4098ca74$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $bCEuG = parcelRequire("bCEuG");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $f6e5bf6a4098ca74$var$baseAssign(object, source) {
    return object && (0, $Dfje1.default)(source, (0, $bCEuG.default)(source), object);
}
var $f6e5bf6a4098ca74$export$2e2bcd8739ae039 = $f6e5bf6a4098ca74$var$baseAssign;

});
parcelRegister("Dfje1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075f84b29e1e8a43$export$2e2bcd8739ae039; });

var $hEH8C = parcelRequire("hEH8C");

var $kMRMD = parcelRequire("kMRMD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $075f84b29e1e8a43$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $kMRMD.default)(object, key, newValue);
        else (0, $hEH8C.default)(object, key, newValue);
    }
    return object;
}
var $075f84b29e1e8a43$export$2e2bcd8739ae039 = $075f84b29e1e8a43$var$copyObject;

});

parcelRegister("bCEuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8762a7899474a5a1$export$2e2bcd8739ae039; });

var $lXa20 = parcelRequire("lXa20");

var $1DpxM = parcelRequire("1DpxM");

var $fvRYU = parcelRequire("fvRYU");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $8762a7899474a5a1$var$keys(object) {
    return (0, $fvRYU.default)(object) ? (0, $lXa20.default)(object) : (0, $1DpxM.default)(object);
}
var $8762a7899474a5a1$export$2e2bcd8739ae039 = $8762a7899474a5a1$var$keys;

});
parcelRegister("lXa20", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffb6e3ab89e890ad$export$2e2bcd8739ae039; });

var $c8nkI = parcelRequire("c8nkI");

var $ifZOn = parcelRequire("ifZOn");

var $cvQ90 = parcelRequire("cvQ90");

var $lTJlI = parcelRequire("lTJlI");

var $dNzbj = parcelRequire("dNzbj");

var $frOPg = parcelRequire("frOPg");
/** Used for built-in method references. */ var $ffb6e3ab89e890ad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ffb6e3ab89e890ad$var$hasOwnProperty = $ffb6e3ab89e890ad$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $ffb6e3ab89e890ad$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $cvQ90.default)(value), isArg = !isArr && (0, $ifZOn.default)(value), isBuff = !isArr && !isArg && (0, $lTJlI.default)(value), isType = !isArr && !isArg && !isBuff && (0, $frOPg.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $c8nkI.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $ffb6e3ab89e890ad$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $dNzbj.default)(key, length)))) result.push(key);
    return result;
}
var $ffb6e3ab89e890ad$export$2e2bcd8739ae039 = $ffb6e3ab89e890ad$var$arrayLikeKeys;

});
parcelRegister("c8nkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d5854ddc9992a89$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $8d5854ddc9992a89$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $8d5854ddc9992a89$export$2e2bcd8739ae039 = $8d5854ddc9992a89$var$baseTimes;

});

parcelRegister("ifZOn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a993307951c51d$export$2e2bcd8739ae039; });

var $eKgoA = parcelRequire("eKgoA");

var $QTaGs = parcelRequire("QTaGs");
/** Used for built-in method references. */ var $d4a993307951c51d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4a993307951c51d$var$hasOwnProperty = $d4a993307951c51d$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d4a993307951c51d$var$propertyIsEnumerable = $d4a993307951c51d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d4a993307951c51d$var$isArguments = (0, $eKgoA.default)(function() {
    return arguments;
}()) ? (0, $eKgoA.default) : function(value) {
    return (0, $QTaGs.default)(value) && $d4a993307951c51d$var$hasOwnProperty.call(value, 'callee') && !$d4a993307951c51d$var$propertyIsEnumerable.call(value, 'callee');
};
var $d4a993307951c51d$export$2e2bcd8739ae039 = $d4a993307951c51d$var$isArguments;

});
parcelRegister("eKgoA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc214687dd47254$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $abc214687dd47254$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $abc214687dd47254$var$baseIsArguments(value) {
    return (0, $QTaGs.default)(value) && (0, $8ypmi.default)(value) == $abc214687dd47254$var$argsTag;
}
var $abc214687dd47254$export$2e2bcd8739ae039 = $abc214687dd47254$var$baseIsArguments;

});


parcelRegister("cvQ90", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91c0d410801941b9$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $91c0d410801941b9$var$isArray = Array.isArray;
var $91c0d410801941b9$export$2e2bcd8739ae039 = $91c0d410801941b9$var$isArray;

});

parcelRegister("lTJlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff11e9736a78ec75$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");

var $kvkj9 = parcelRequire("kvkj9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $65KY2.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kvkj9.default);
var $ff11e9736a78ec75$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kvkj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eed674a4f8c075c0$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eed674a4f8c075c0$var$stubFalse() {
    return false;
}
var $eed674a4f8c075c0$export$2e2bcd8739ae039 = $eed674a4f8c075c0$var$stubFalse;

});


parcelRegister("dNzbj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0bb24454cd32991$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $a0bb24454cd32991$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a0bb24454cd32991$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a0bb24454cd32991$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a0bb24454cd32991$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a0bb24454cd32991$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $a0bb24454cd32991$export$2e2bcd8739ae039 = $a0bb24454cd32991$var$isIndex;

});

parcelRegister("frOPg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f0cd9b908e9acf$export$2e2bcd8739ae039; });

var $3uwJ4 = parcelRequire("3uwJ4");

var $gSwe7 = parcelRequire("gSwe7");

var $eihh9 = parcelRequire("eihh9");
/* Node.js helper references. */ var $b3f0cd9b908e9acf$var$nodeIsTypedArray = (0, $eihh9.default) && (0, $eihh9.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $b3f0cd9b908e9acf$var$isTypedArray = $b3f0cd9b908e9acf$var$nodeIsTypedArray ? (0, $gSwe7.default)($b3f0cd9b908e9acf$var$nodeIsTypedArray) : (0, $3uwJ4.default);
var $b3f0cd9b908e9acf$export$2e2bcd8739ae039 = $b3f0cd9b908e9acf$var$isTypedArray;

});
parcelRegister("3uwJ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ad8f27d88dc9a8$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $d0v4T = parcelRequire("d0v4T");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $28ad8f27d88dc9a8$var$argsTag = '[object Arguments]', $28ad8f27d88dc9a8$var$arrayTag = '[object Array]', $28ad8f27d88dc9a8$var$boolTag = '[object Boolean]', $28ad8f27d88dc9a8$var$dateTag = '[object Date]', $28ad8f27d88dc9a8$var$errorTag = '[object Error]', $28ad8f27d88dc9a8$var$funcTag = '[object Function]', $28ad8f27d88dc9a8$var$mapTag = '[object Map]', $28ad8f27d88dc9a8$var$numberTag = '[object Number]', $28ad8f27d88dc9a8$var$objectTag = '[object Object]', $28ad8f27d88dc9a8$var$regexpTag = '[object RegExp]', $28ad8f27d88dc9a8$var$setTag = '[object Set]', $28ad8f27d88dc9a8$var$stringTag = '[object String]', $28ad8f27d88dc9a8$var$weakMapTag = '[object WeakMap]';
var $28ad8f27d88dc9a8$var$arrayBufferTag = '[object ArrayBuffer]', $28ad8f27d88dc9a8$var$dataViewTag = '[object DataView]', $28ad8f27d88dc9a8$var$float32Tag = '[object Float32Array]', $28ad8f27d88dc9a8$var$float64Tag = '[object Float64Array]', $28ad8f27d88dc9a8$var$int8Tag = '[object Int8Array]', $28ad8f27d88dc9a8$var$int16Tag = '[object Int16Array]', $28ad8f27d88dc9a8$var$int32Tag = '[object Int32Array]', $28ad8f27d88dc9a8$var$uint8Tag = '[object Uint8Array]', $28ad8f27d88dc9a8$var$uint8ClampedTag = '[object Uint8ClampedArray]', $28ad8f27d88dc9a8$var$uint16Tag = '[object Uint16Array]', $28ad8f27d88dc9a8$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $28ad8f27d88dc9a8$var$typedArrayTags = {};
$28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$float32Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$float64Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$int8Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$int16Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$int32Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint8Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint8ClampedTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint16Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint32Tag] = true;
$28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$argsTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$arrayTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$arrayBufferTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$boolTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$dataViewTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$dateTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$errorTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$funcTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$mapTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$numberTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$objectTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$regexpTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$setTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$stringTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $28ad8f27d88dc9a8$var$baseIsTypedArray(value) {
    return (0, $QTaGs.default)(value) && (0, $d0v4T.default)(value.length) && !!$28ad8f27d88dc9a8$var$typedArrayTags[(0, $8ypmi.default)(value)];
}
var $28ad8f27d88dc9a8$export$2e2bcd8739ae039 = $28ad8f27d88dc9a8$var$baseIsTypedArray;

});
parcelRegister("d0v4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $978361e70025a850$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $978361e70025a850$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $978361e70025a850$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $978361e70025a850$var$MAX_SAFE_INTEGER;
}
var $978361e70025a850$export$2e2bcd8739ae039 = $978361e70025a850$var$isLength;

});


parcelRegister("gSwe7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c49ab00fcf3c802b$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c49ab00fcf3c802b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c49ab00fcf3c802b$export$2e2bcd8739ae039 = $c49ab00fcf3c802b$var$baseUnary;

});

parcelRegister("eihh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68025b785011fda$export$2e2bcd8739ae039; });

var $h1ybm = parcelRequire("h1ybm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $h1ybm.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $a68025b785011fda$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("1DpxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $130d3f6d5fcfb49d$export$2e2bcd8739ae039; });

var $i2xGO = parcelRequire("i2xGO");

var $48Rgc = parcelRequire("48Rgc");
/** Used for built-in method references. */ var $130d3f6d5fcfb49d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $130d3f6d5fcfb49d$var$hasOwnProperty = $130d3f6d5fcfb49d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $130d3f6d5fcfb49d$var$baseKeys(object) {
    if (!(0, $i2xGO.default)(object)) return (0, $48Rgc.default)(object);
    var result = [];
    for(var key in Object(object))if ($130d3f6d5fcfb49d$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $130d3f6d5fcfb49d$export$2e2bcd8739ae039 = $130d3f6d5fcfb49d$var$baseKeys;

});
parcelRegister("i2xGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2228bf424def2e3$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $d2228bf424def2e3$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $d2228bf424def2e3$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $d2228bf424def2e3$var$objectProto;
    return value === proto;
}
var $d2228bf424def2e3$export$2e2bcd8739ae039 = $d2228bf424def2e3$var$isPrototype;

});

parcelRegister("48Rgc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $304139292d97c286$export$2e2bcd8739ae039; });

var $63r4t = parcelRequire("63r4t");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $304139292d97c286$var$nativeKeys = (0, $63r4t.default)(Object.keys, Object);
var $304139292d97c286$export$2e2bcd8739ae039 = $304139292d97c286$var$nativeKeys;

});


parcelRegister("fvRYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4b39fd2c5d56ee0$export$2e2bcd8739ae039; });

var $5OjsN = parcelRequire("5OjsN");

var $d0v4T = parcelRequire("d0v4T");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $b4b39fd2c5d56ee0$var$isArrayLike(value) {
    return value != null && (0, $d0v4T.default)(value.length) && !(0, $5OjsN.default)(value);
}
var $b4b39fd2c5d56ee0$export$2e2bcd8739ae039 = $b4b39fd2c5d56ee0$var$isArrayLike;

});



parcelRegister("4oQTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33426debf32a14f9$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $5QaB6 = parcelRequire("5QaB6");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $33426debf32a14f9$var$baseAssignIn(object, source) {
    return object && (0, $Dfje1.default)(source, (0, $5QaB6.default)(source), object);
}
var $33426debf32a14f9$export$2e2bcd8739ae039 = $33426debf32a14f9$var$baseAssignIn;

});
parcelRegister("5QaB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440a078352bf8aef$export$2e2bcd8739ae039; });

var $lXa20 = parcelRequire("lXa20");

var $30s94 = parcelRequire("30s94");

var $fvRYU = parcelRequire("fvRYU");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $440a078352bf8aef$var$keysIn(object) {
    return (0, $fvRYU.default)(object) ? (0, $lXa20.default)(object, true) : (0, $30s94.default)(object);
}
var $440a078352bf8aef$export$2e2bcd8739ae039 = $440a078352bf8aef$var$keysIn;

});
parcelRegister("30s94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $230734409484894d$export$2e2bcd8739ae039; });

var $6vN6O = parcelRequire("6vN6O");

var $i2xGO = parcelRequire("i2xGO");

var $8HiE1 = parcelRequire("8HiE1");
/** Used for built-in method references. */ var $230734409484894d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $230734409484894d$var$hasOwnProperty = $230734409484894d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $230734409484894d$var$baseKeysIn(object) {
    if (!(0, $6vN6O.default)(object)) return (0, $8HiE1.default)(object);
    var isProto = (0, $i2xGO.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$230734409484894d$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $230734409484894d$export$2e2bcd8739ae039 = $230734409484894d$var$baseKeysIn;

});
parcelRegister("8HiE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6550cd4dba1e9966$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6550cd4dba1e9966$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $6550cd4dba1e9966$export$2e2bcd8739ae039 = $6550cd4dba1e9966$var$nativeKeysIn;

});




parcelRegister("hD9Sw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd5dbdcf361efd09$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $65KY2.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $cd5dbdcf361efd09$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("cbaxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ddeb14e1f96ad8d$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $8ddeb14e1f96ad8d$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $8ddeb14e1f96ad8d$export$2e2bcd8739ae039 = $8ddeb14e1f96ad8d$var$copyArray;

});

parcelRegister("g5knF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5cec2c62d3f705$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $ewGbf = parcelRequire("ewGbf");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $bb5cec2c62d3f705$var$copySymbols(source, object) {
    return (0, $Dfje1.default)(source, (0, $ewGbf.default)(source), object);
}
var $bb5cec2c62d3f705$export$2e2bcd8739ae039 = $bb5cec2c62d3f705$var$copySymbols;

});
parcelRegister("ewGbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a934c5fb1d6cb594$export$2e2bcd8739ae039; });

var $9U6p2 = parcelRequire("9U6p2");

var $jSInV = parcelRequire("jSInV");
/** Used for built-in method references. */ var $a934c5fb1d6cb594$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a934c5fb1d6cb594$var$propertyIsEnumerable = $a934c5fb1d6cb594$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a934c5fb1d6cb594$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a934c5fb1d6cb594$var$getSymbols = !$a934c5fb1d6cb594$var$nativeGetSymbols ? (0, $jSInV.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $9U6p2.default)($a934c5fb1d6cb594$var$nativeGetSymbols(object), function(symbol) {
        return $a934c5fb1d6cb594$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $a934c5fb1d6cb594$export$2e2bcd8739ae039 = $a934c5fb1d6cb594$var$getSymbols;

});
parcelRegister("9U6p2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735e4f7c31b4a331$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $735e4f7c31b4a331$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $735e4f7c31b4a331$export$2e2bcd8739ae039 = $735e4f7c31b4a331$var$arrayFilter;

});

parcelRegister("jSInV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7957d5ed38c1122$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e7957d5ed38c1122$var$stubArray() {
    return [];
}
var $e7957d5ed38c1122$export$2e2bcd8739ae039 = $e7957d5ed38c1122$var$stubArray;

});



parcelRegister("gi8Nh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc5261438d3c3d8$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $75AvF = parcelRequire("75AvF");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $bdc5261438d3c3d8$var$copySymbolsIn(source, object) {
    return (0, $Dfje1.default)(source, (0, $75AvF.default)(source), object);
}
var $bdc5261438d3c3d8$export$2e2bcd8739ae039 = $bdc5261438d3c3d8$var$copySymbolsIn;

});
parcelRegister("75AvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52955219533c6ca2$export$2e2bcd8739ae039; });

var $4zeHU = parcelRequire("4zeHU");

var $FgAoP = parcelRequire("FgAoP");

var $ewGbf = parcelRequire("ewGbf");

var $jSInV = parcelRequire("jSInV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $52955219533c6ca2$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $52955219533c6ca2$var$getSymbolsIn = !$52955219533c6ca2$var$nativeGetSymbols ? (0, $jSInV.default) : function(object) {
    var result = [];
    while(object){
        (0, $4zeHU.default)(result, (0, $ewGbf.default)(object));
        object = (0, $FgAoP.default)(object);
    }
    return result;
};
var $52955219533c6ca2$export$2e2bcd8739ae039 = $52955219533c6ca2$var$getSymbolsIn;

});
parcelRegister("4zeHU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3535d6d94cb04303$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3535d6d94cb04303$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $3535d6d94cb04303$export$2e2bcd8739ae039 = $3535d6d94cb04303$var$arrayPush;

});



parcelRegister("6CWdP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d337459fb5c1052$export$2e2bcd8739ae039; });

var $fnNfE = parcelRequire("fnNfE");

var $ewGbf = parcelRequire("ewGbf");

var $bCEuG = parcelRequire("bCEuG");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4d337459fb5c1052$var$getAllKeys(object) {
    return (0, $fnNfE.default)(object, (0, $bCEuG.default), (0, $ewGbf.default));
}
var $4d337459fb5c1052$export$2e2bcd8739ae039 = $4d337459fb5c1052$var$getAllKeys;

});
parcelRegister("fnNfE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b32f354f1e6224ec$export$2e2bcd8739ae039; });

var $4zeHU = parcelRequire("4zeHU");

var $cvQ90 = parcelRequire("cvQ90");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b32f354f1e6224ec$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $cvQ90.default)(object) ? result : (0, $4zeHU.default)(result, symbolsFunc(object));
}
var $b32f354f1e6224ec$export$2e2bcd8739ae039 = $b32f354f1e6224ec$var$baseGetAllKeys;

});


parcelRegister("05fLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00fcb14bfd3f213c$export$2e2bcd8739ae039; });

var $fnNfE = parcelRequire("fnNfE");

var $75AvF = parcelRequire("75AvF");

var $5QaB6 = parcelRequire("5QaB6");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $00fcb14bfd3f213c$var$getAllKeysIn(object) {
    return (0, $fnNfE.default)(object, (0, $5QaB6.default), (0, $75AvF.default));
}
var $00fcb14bfd3f213c$export$2e2bcd8739ae039 = $00fcb14bfd3f213c$var$getAllKeysIn;

});

parcelRegister("bdaH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8299341a43cd6d3e$export$2e2bcd8739ae039; });

var $e1rvy = parcelRequire("e1rvy");

var $fnuNy = parcelRequire("fnuNy");

var $OK9qR = parcelRequire("OK9qR");

var $iuRXK = parcelRequire("iuRXK");

var $dmGEQ = parcelRequire("dmGEQ");

var $8ypmi = parcelRequire("8ypmi");

var $jZH4M = parcelRequire("jZH4M");
/** `Object#toString` result references. */ var $8299341a43cd6d3e$var$mapTag = '[object Map]', $8299341a43cd6d3e$var$objectTag = '[object Object]', $8299341a43cd6d3e$var$promiseTag = '[object Promise]', $8299341a43cd6d3e$var$setTag = '[object Set]', $8299341a43cd6d3e$var$weakMapTag = '[object WeakMap]';
var $8299341a43cd6d3e$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $8299341a43cd6d3e$var$dataViewCtorString = (0, $jZH4M.default)((0, $e1rvy.default)), $8299341a43cd6d3e$var$mapCtorString = (0, $jZH4M.default)((0, $fnuNy.default)), $8299341a43cd6d3e$var$promiseCtorString = (0, $jZH4M.default)((0, $OK9qR.default)), $8299341a43cd6d3e$var$setCtorString = (0, $jZH4M.default)((0, $iuRXK.default)), $8299341a43cd6d3e$var$weakMapCtorString = (0, $jZH4M.default)((0, $dmGEQ.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $8299341a43cd6d3e$var$getTag = (0, $8ypmi.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $e1rvy.default) && $8299341a43cd6d3e$var$getTag(new (0, $e1rvy.default)(new ArrayBuffer(1))) != $8299341a43cd6d3e$var$dataViewTag || (0, $fnuNy.default) && $8299341a43cd6d3e$var$getTag(new (0, $fnuNy.default)) != $8299341a43cd6d3e$var$mapTag || (0, $OK9qR.default) && $8299341a43cd6d3e$var$getTag((0, $OK9qR.default).resolve()) != $8299341a43cd6d3e$var$promiseTag || (0, $iuRXK.default) && $8299341a43cd6d3e$var$getTag(new (0, $iuRXK.default)) != $8299341a43cd6d3e$var$setTag || (0, $dmGEQ.default) && $8299341a43cd6d3e$var$getTag(new (0, $dmGEQ.default)) != $8299341a43cd6d3e$var$weakMapTag) $8299341a43cd6d3e$var$getTag = function(value) {
    var result = (0, $8ypmi.default)(value), Ctor = result == $8299341a43cd6d3e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $jZH4M.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $8299341a43cd6d3e$var$dataViewCtorString:
            return $8299341a43cd6d3e$var$dataViewTag;
        case $8299341a43cd6d3e$var$mapCtorString:
            return $8299341a43cd6d3e$var$mapTag;
        case $8299341a43cd6d3e$var$promiseCtorString:
            return $8299341a43cd6d3e$var$promiseTag;
        case $8299341a43cd6d3e$var$setCtorString:
            return $8299341a43cd6d3e$var$setTag;
        case $8299341a43cd6d3e$var$weakMapCtorString:
            return $8299341a43cd6d3e$var$weakMapTag;
    }
    return result;
};
var $8299341a43cd6d3e$export$2e2bcd8739ae039 = $8299341a43cd6d3e$var$getTag;

});
parcelRegister("e1rvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3567f36c33d9e2d$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $a3567f36c33d9e2d$var$DataView = (0, $97o2V.default)((0, $65KY2.default), 'DataView');
var $a3567f36c33d9e2d$export$2e2bcd8739ae039 = $a3567f36c33d9e2d$var$DataView;

});

parcelRegister("OK9qR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09887847a84b5580$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $09887847a84b5580$var$Promise = (0, $97o2V.default)((0, $65KY2.default), 'Promise');
var $09887847a84b5580$export$2e2bcd8739ae039 = $09887847a84b5580$var$Promise;

});

parcelRegister("iuRXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d774e33558987876$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $d774e33558987876$var$Set = (0, $97o2V.default)((0, $65KY2.default), 'Set');
var $d774e33558987876$export$2e2bcd8739ae039 = $d774e33558987876$var$Set;

});

parcelRegister("dmGEQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0282d02f0d6f9c7e$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $0282d02f0d6f9c7e$var$WeakMap = (0, $97o2V.default)((0, $65KY2.default), 'WeakMap');
var $0282d02f0d6f9c7e$export$2e2bcd8739ae039 = $0282d02f0d6f9c7e$var$WeakMap;

});


parcelRegister("aJAyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d0a76e18a841f2d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $7d0a76e18a841f2d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0a76e18a841f2d$var$hasOwnProperty = $7d0a76e18a841f2d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7d0a76e18a841f2d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $7d0a76e18a841f2d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7d0a76e18a841f2d$export$2e2bcd8739ae039 = $7d0a76e18a841f2d$var$initCloneArray;

});

parcelRegister("eMOhO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac3c8e36b2de35e0$export$2e2bcd8739ae039; });

var $hSyFY = parcelRequire("hSyFY");

var $eowSB = parcelRequire("eowSB");

var $hEgyA = parcelRequire("hEgyA");

var $7JoCD = parcelRequire("7JoCD");

var $7RyYF = parcelRequire("7RyYF");
/** `Object#toString` result references. */ var $ac3c8e36b2de35e0$var$boolTag = '[object Boolean]', $ac3c8e36b2de35e0$var$dateTag = '[object Date]', $ac3c8e36b2de35e0$var$mapTag = '[object Map]', $ac3c8e36b2de35e0$var$numberTag = '[object Number]', $ac3c8e36b2de35e0$var$regexpTag = '[object RegExp]', $ac3c8e36b2de35e0$var$setTag = '[object Set]', $ac3c8e36b2de35e0$var$stringTag = '[object String]', $ac3c8e36b2de35e0$var$symbolTag = '[object Symbol]';
var $ac3c8e36b2de35e0$var$arrayBufferTag = '[object ArrayBuffer]', $ac3c8e36b2de35e0$var$dataViewTag = '[object DataView]', $ac3c8e36b2de35e0$var$float32Tag = '[object Float32Array]', $ac3c8e36b2de35e0$var$float64Tag = '[object Float64Array]', $ac3c8e36b2de35e0$var$int8Tag = '[object Int8Array]', $ac3c8e36b2de35e0$var$int16Tag = '[object Int16Array]', $ac3c8e36b2de35e0$var$int32Tag = '[object Int32Array]', $ac3c8e36b2de35e0$var$uint8Tag = '[object Uint8Array]', $ac3c8e36b2de35e0$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ac3c8e36b2de35e0$var$uint16Tag = '[object Uint16Array]', $ac3c8e36b2de35e0$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ac3c8e36b2de35e0$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ac3c8e36b2de35e0$var$arrayBufferTag:
            return (0, $hSyFY.default)(object);
        case $ac3c8e36b2de35e0$var$boolTag:
        case $ac3c8e36b2de35e0$var$dateTag:
            return new Ctor(+object);
        case $ac3c8e36b2de35e0$var$dataViewTag:
            return (0, $eowSB.default)(object, isDeep);
        case $ac3c8e36b2de35e0$var$float32Tag:
        case $ac3c8e36b2de35e0$var$float64Tag:
        case $ac3c8e36b2de35e0$var$int8Tag:
        case $ac3c8e36b2de35e0$var$int16Tag:
        case $ac3c8e36b2de35e0$var$int32Tag:
        case $ac3c8e36b2de35e0$var$uint8Tag:
        case $ac3c8e36b2de35e0$var$uint8ClampedTag:
        case $ac3c8e36b2de35e0$var$uint16Tag:
        case $ac3c8e36b2de35e0$var$uint32Tag:
            return (0, $7RyYF.default)(object, isDeep);
        case $ac3c8e36b2de35e0$var$mapTag:
            return new Ctor;
        case $ac3c8e36b2de35e0$var$numberTag:
        case $ac3c8e36b2de35e0$var$stringTag:
            return new Ctor(object);
        case $ac3c8e36b2de35e0$var$regexpTag:
            return (0, $hEgyA.default)(object);
        case $ac3c8e36b2de35e0$var$setTag:
            return new Ctor;
        case $ac3c8e36b2de35e0$var$symbolTag:
            return (0, $7JoCD.default)(object);
    }
}
var $ac3c8e36b2de35e0$export$2e2bcd8739ae039 = $ac3c8e36b2de35e0$var$initCloneByTag;

});
parcelRegister("hSyFY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d04260c33ae98149$export$2e2bcd8739ae039; });

var $jVSWw = parcelRequire("jVSWw");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $d04260c33ae98149$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $jVSWw.default)(result).set(new (0, $jVSWw.default)(arrayBuffer));
    return result;
}
var $d04260c33ae98149$export$2e2bcd8739ae039 = $d04260c33ae98149$var$cloneArrayBuffer;

});
parcelRegister("jVSWw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82df5b1e3d4b099$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Built-in value references. */ var $e82df5b1e3d4b099$var$Uint8Array = (0, $65KY2.default).Uint8Array;
var $e82df5b1e3d4b099$export$2e2bcd8739ae039 = $e82df5b1e3d4b099$var$Uint8Array;

});


parcelRegister("eowSB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7accfcc40fc8b6a$export$2e2bcd8739ae039; });

var $hSyFY = parcelRequire("hSyFY");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $a7accfcc40fc8b6a$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $hSyFY.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $a7accfcc40fc8b6a$export$2e2bcd8739ae039 = $a7accfcc40fc8b6a$var$cloneDataView;

});

parcelRegister("hEgyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd9303eda60c4c86$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $cd9303eda60c4c86$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $cd9303eda60c4c86$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $cd9303eda60c4c86$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $cd9303eda60c4c86$export$2e2bcd8739ae039 = $cd9303eda60c4c86$var$cloneRegExp;

});

parcelRegister("7JoCD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a0fd5cb61fe70d3$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");
/** Used to convert symbols to primitives and strings. */ var $5a0fd5cb61fe70d3$var$symbolProto = (0, $iQXmk.default) ? (0, $iQXmk.default).prototype : undefined, $5a0fd5cb61fe70d3$var$symbolValueOf = $5a0fd5cb61fe70d3$var$symbolProto ? $5a0fd5cb61fe70d3$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $5a0fd5cb61fe70d3$var$cloneSymbol(symbol) {
    return $5a0fd5cb61fe70d3$var$symbolValueOf ? Object($5a0fd5cb61fe70d3$var$symbolValueOf.call(symbol)) : {};
}
var $5a0fd5cb61fe70d3$export$2e2bcd8739ae039 = $5a0fd5cb61fe70d3$var$cloneSymbol;

});

parcelRegister("7RyYF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b989d76a094b295$export$2e2bcd8739ae039; });

var $hSyFY = parcelRequire("hSyFY");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $5b989d76a094b295$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $hSyFY.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $5b989d76a094b295$export$2e2bcd8739ae039 = $5b989d76a094b295$var$cloneTypedArray;

});


parcelRegister("eeWvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5dfc147ac5bfff3$export$2e2bcd8739ae039; });

var $fO4gT = parcelRequire("fO4gT");

var $FgAoP = parcelRequire("FgAoP");

var $i2xGO = parcelRequire("i2xGO");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $a5dfc147ac5bfff3$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $i2xGO.default)(object) ? (0, $fO4gT.default)((0, $FgAoP.default)(object)) : {};
}
var $a5dfc147ac5bfff3$export$2e2bcd8739ae039 = $a5dfc147ac5bfff3$var$initCloneObject;

});
parcelRegister("fO4gT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b81ed6c69e9fef27$export$2e2bcd8739ae039; });

var $6vN6O = parcelRequire("6vN6O");
/** Built-in value references. */ var $b81ed6c69e9fef27$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $b81ed6c69e9fef27$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $6vN6O.default)(proto)) return {};
        if ($b81ed6c69e9fef27$var$objectCreate) return $b81ed6c69e9fef27$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $b81ed6c69e9fef27$export$2e2bcd8739ae039 = $b81ed6c69e9fef27$var$baseCreate;

});


parcelRegister("9cm4a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b2659ef0ef28770$export$2e2bcd8739ae039; });

var $bTm70 = parcelRequire("bTm70");

var $gSwe7 = parcelRequire("gSwe7");

var $eihh9 = parcelRequire("eihh9");
/* Node.js helper references. */ var $6b2659ef0ef28770$var$nodeIsMap = (0, $eihh9.default) && (0, $eihh9.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $6b2659ef0ef28770$var$isMap = $6b2659ef0ef28770$var$nodeIsMap ? (0, $gSwe7.default)($6b2659ef0ef28770$var$nodeIsMap) : (0, $bTm70.default);
var $6b2659ef0ef28770$export$2e2bcd8739ae039 = $6b2659ef0ef28770$var$isMap;

});
parcelRegister("bTm70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a85fbc1b2d0f641$export$2e2bcd8739ae039; });

var $bdaH3 = parcelRequire("bdaH3");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $8a85fbc1b2d0f641$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $8a85fbc1b2d0f641$var$baseIsMap(value) {
    return (0, $QTaGs.default)(value) && (0, $bdaH3.default)(value) == $8a85fbc1b2d0f641$var$mapTag;
}
var $8a85fbc1b2d0f641$export$2e2bcd8739ae039 = $8a85fbc1b2d0f641$var$baseIsMap;

});


parcelRegister("kO458", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f25ba4bd6d1cdd4c$export$2e2bcd8739ae039; });

var $j5r63 = parcelRequire("j5r63");

var $gSwe7 = parcelRequire("gSwe7");

var $eihh9 = parcelRequire("eihh9");
/* Node.js helper references. */ var $f25ba4bd6d1cdd4c$var$nodeIsSet = (0, $eihh9.default) && (0, $eihh9.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $f25ba4bd6d1cdd4c$var$isSet = $f25ba4bd6d1cdd4c$var$nodeIsSet ? (0, $gSwe7.default)($f25ba4bd6d1cdd4c$var$nodeIsSet) : (0, $j5r63.default);
var $f25ba4bd6d1cdd4c$export$2e2bcd8739ae039 = $f25ba4bd6d1cdd4c$var$isSet;

});
parcelRegister("j5r63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de5380ccaae8ec54$export$2e2bcd8739ae039; });

var $bdaH3 = parcelRequire("bdaH3");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $de5380ccaae8ec54$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $de5380ccaae8ec54$var$baseIsSet(value) {
    return (0, $QTaGs.default)(value) && (0, $bdaH3.default)(value) == $de5380ccaae8ec54$var$setTag;
}
var $de5380ccaae8ec54$export$2e2bcd8739ae039 = $de5380ccaae8ec54$var$baseIsSet;

});




parcelRegister("8xxO0", function(module, exports) {
'use strict';
var $637ba0e11ea98061$var$isArray = Array.isArray;
var $637ba0e11ea98061$var$keyList = Object.keys;
var $637ba0e11ea98061$var$hasProp = Object.prototype.hasOwnProperty;
var $637ba0e11ea98061$var$hasElementType = typeof Element !== 'undefined';
function $637ba0e11ea98061$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $637ba0e11ea98061$var$isArray(a), arrB = $637ba0e11ea98061$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$637ba0e11ea98061$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $637ba0e11ea98061$var$keyList(a);
        length = keys.length;
        if (length !== $637ba0e11ea98061$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$637ba0e11ea98061$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($637ba0e11ea98061$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$637ba0e11ea98061$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $637ba0e11ea98061$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("3JyNw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b809129929fa9d8$export$2e2bcd8739ae039; });
var $2b809129929fa9d8$var$isProduction = true;
function $2b809129929fa9d8$var$warning(condition, message) {
    if (!$2b809129929fa9d8$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $2b809129929fa9d8$export$2e2bcd8739ae039 = $2b809129929fa9d8$var$warning;

});

parcelRegister("gEJ4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2035893aa4572bf$export$2e2bcd8739ae039; });

var $jIw7K = parcelRequire("jIw7K");
/** Used to compose bitmasks for cloning. */ var $c2035893aa4572bf$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $c2035893aa4572bf$var$clone(value) {
    return (0, $jIw7K.default)(value, $c2035893aa4572bf$var$CLONE_SYMBOLS_FLAG);
}
var $c2035893aa4572bf$export$2e2bcd8739ae039 = $c2035893aa4572bf$var$clone;

});

parcelRegister("lHNrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd3f7ee507255b4$export$2e2bcd8739ae039; });

var $cs7E8 = parcelRequire("cs7E8");

var $cbaxU = parcelRequire("cbaxU");

var $cvQ90 = parcelRequire("cvQ90");

var $3sgYV = parcelRequire("3sgYV");

var $ce37V = parcelRequire("ce37V");

var $afrUq = parcelRequire("afrUq");

var $aElJT = parcelRequire("aElJT");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $fcd3f7ee507255b4$var$toPath(value) {
    if ((0, $cvQ90.default)(value)) return (0, $cs7E8.default)(value, (0, $afrUq.default));
    return (0, $3sgYV.default)(value) ? [
        value
    ] : (0, $cbaxU.default)((0, $ce37V.default)((0, $aElJT.default)(value)));
}
var $fcd3f7ee507255b4$export$2e2bcd8739ae039 = $fcd3f7ee507255b4$var$toPath;

});
parcelRegister("cs7E8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $910e07f21d96dc9b$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $910e07f21d96dc9b$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $910e07f21d96dc9b$export$2e2bcd8739ae039 = $910e07f21d96dc9b$var$arrayMap;

});

parcelRegister("3sgYV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $284128cf79457634$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $284128cf79457634$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $284128cf79457634$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $QTaGs.default)(value) && (0, $8ypmi.default)(value) == $284128cf79457634$var$symbolTag;
}
var $284128cf79457634$export$2e2bcd8739ae039 = $284128cf79457634$var$isSymbol;

});

parcelRegister("ce37V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e6937bf5472b58a$export$2e2bcd8739ae039; });

var $f6RQn = parcelRequire("f6RQn");
/** Used to match property names within property paths. */ var $8e6937bf5472b58a$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8e6937bf5472b58a$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8e6937bf5472b58a$var$stringToPath = (0, $f6RQn.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($8e6937bf5472b58a$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8e6937bf5472b58a$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $8e6937bf5472b58a$export$2e2bcd8739ae039 = $8e6937bf5472b58a$var$stringToPath;

});
parcelRegister("f6RQn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0012ecce009d07d$export$2e2bcd8739ae039; });

var $5TWsc = parcelRequire("5TWsc");
/** Used as the maximum memoize cache size. */ var $b0012ecce009d07d$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b0012ecce009d07d$var$memoizeCapped(func) {
    var result = (0, $5TWsc.default)(func, function(key) {
        if (cache.size === $b0012ecce009d07d$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $b0012ecce009d07d$export$2e2bcd8739ae039 = $b0012ecce009d07d$var$memoizeCapped;

});
parcelRegister("5TWsc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44bf6e88affd91e5$export$2e2bcd8739ae039; });

var $jitcP = parcelRequire("jitcP");
/** Error message constants. */ var $44bf6e88affd91e5$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $44bf6e88affd91e5$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($44bf6e88affd91e5$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($44bf6e88affd91e5$var$memoize.Cache || (0, $jitcP.default));
    return memoized;
}
// Expose `MapCache`.
$44bf6e88affd91e5$var$memoize.Cache = (0, $jitcP.default);
var $44bf6e88affd91e5$export$2e2bcd8739ae039 = $44bf6e88affd91e5$var$memoize;

});



parcelRegister("afrUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7760f4479642e2ed$export$2e2bcd8739ae039; });

var $3sgYV = parcelRequire("3sgYV");
/** Used as references for various `Number` constants. */ var $7760f4479642e2ed$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $7760f4479642e2ed$var$toKey(value) {
    if (typeof value == 'string' || (0, $3sgYV.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$7760f4479642e2ed$var$INFINITY ? '-0' : result;
}
var $7760f4479642e2ed$export$2e2bcd8739ae039 = $7760f4479642e2ed$var$toKey;

});

parcelRegister("aElJT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c0e80c9a14886dc$export$2e2bcd8739ae039; });

var $cWZLF = parcelRequire("cWZLF");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $7c0e80c9a14886dc$var$toString(value) {
    return value == null ? '' : (0, $cWZLF.default)(value);
}
var $7c0e80c9a14886dc$export$2e2bcd8739ae039 = $7c0e80c9a14886dc$var$toString;

});
parcelRegister("cWZLF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96dad0a003234232$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");

var $cs7E8 = parcelRequire("cs7E8");

var $cvQ90 = parcelRequire("cvQ90");

var $3sgYV = parcelRequire("3sgYV");
/** Used as references for various `Number` constants. */ var $96dad0a003234232$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $96dad0a003234232$var$symbolProto = (0, $iQXmk.default) ? (0, $iQXmk.default).prototype : undefined, $96dad0a003234232$var$symbolToString = $96dad0a003234232$var$symbolProto ? $96dad0a003234232$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $96dad0a003234232$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $cvQ90.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $cs7E8.default)(value, $96dad0a003234232$var$baseToString) + '';
    if ((0, $3sgYV.default)(value)) return $96dad0a003234232$var$symbolToString ? $96dad0a003234232$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$96dad0a003234232$var$INFINITY ? '-0' : result;
}
var $96dad0a003234232$export$2e2bcd8739ae039 = $96dad0a003234232$var$baseToString;

});




parcelRegister("191I6", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $lvfvG = parcelRequire("lvfvG");

var $54X9E = parcelRequire("54X9E");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $lvfvG.isBrowserBundle)() && Object.prototype.toString.call(typeof $54X9E !== 'undefined' ? $54X9E : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("lvfvG", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $fa788630a413820d$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $fa788630a413820d$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $fa788630a413820d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $fa788630a413820d$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("54X9E", function(module, exports) {
// shim for using process in browser
var $3b2b36599051fe09$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3b2b36599051fe09$var$cachedSetTimeout;
var $3b2b36599051fe09$var$cachedClearTimeout;
function $3b2b36599051fe09$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3b2b36599051fe09$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3b2b36599051fe09$var$cachedSetTimeout = setTimeout;
        else $3b2b36599051fe09$var$cachedSetTimeout = $3b2b36599051fe09$var$defaultSetTimout;
    } catch (e) {
        $3b2b36599051fe09$var$cachedSetTimeout = $3b2b36599051fe09$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3b2b36599051fe09$var$cachedClearTimeout = clearTimeout;
        else $3b2b36599051fe09$var$cachedClearTimeout = $3b2b36599051fe09$var$defaultClearTimeout;
    } catch (e) {
        $3b2b36599051fe09$var$cachedClearTimeout = $3b2b36599051fe09$var$defaultClearTimeout;
    }
})();
function $3b2b36599051fe09$var$runTimeout(fun) {
    if ($3b2b36599051fe09$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3b2b36599051fe09$var$cachedSetTimeout === $3b2b36599051fe09$var$defaultSetTimout || !$3b2b36599051fe09$var$cachedSetTimeout) && setTimeout) {
        $3b2b36599051fe09$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3b2b36599051fe09$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3b2b36599051fe09$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3b2b36599051fe09$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3b2b36599051fe09$var$runClearTimeout(marker) {
    if ($3b2b36599051fe09$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3b2b36599051fe09$var$cachedClearTimeout === $3b2b36599051fe09$var$defaultClearTimeout || !$3b2b36599051fe09$var$cachedClearTimeout) && clearTimeout) {
        $3b2b36599051fe09$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3b2b36599051fe09$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3b2b36599051fe09$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3b2b36599051fe09$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3b2b36599051fe09$var$queue = [];
var $3b2b36599051fe09$var$draining = false;
var $3b2b36599051fe09$var$currentQueue;
var $3b2b36599051fe09$var$queueIndex = -1;
function $3b2b36599051fe09$var$cleanUpNextTick() {
    if (!$3b2b36599051fe09$var$draining || !$3b2b36599051fe09$var$currentQueue) return;
    $3b2b36599051fe09$var$draining = false;
    if ($3b2b36599051fe09$var$currentQueue.length) $3b2b36599051fe09$var$queue = $3b2b36599051fe09$var$currentQueue.concat($3b2b36599051fe09$var$queue);
    else $3b2b36599051fe09$var$queueIndex = -1;
    if ($3b2b36599051fe09$var$queue.length) $3b2b36599051fe09$var$drainQueue();
}
function $3b2b36599051fe09$var$drainQueue() {
    if ($3b2b36599051fe09$var$draining) return;
    var timeout = $3b2b36599051fe09$var$runTimeout($3b2b36599051fe09$var$cleanUpNextTick);
    $3b2b36599051fe09$var$draining = true;
    var len = $3b2b36599051fe09$var$queue.length;
    while(len){
        $3b2b36599051fe09$var$currentQueue = $3b2b36599051fe09$var$queue;
        $3b2b36599051fe09$var$queue = [];
        while(++$3b2b36599051fe09$var$queueIndex < len)if ($3b2b36599051fe09$var$currentQueue) $3b2b36599051fe09$var$currentQueue[$3b2b36599051fe09$var$queueIndex].run();
        $3b2b36599051fe09$var$queueIndex = -1;
        len = $3b2b36599051fe09$var$queue.length;
    }
    $3b2b36599051fe09$var$currentQueue = null;
    $3b2b36599051fe09$var$draining = false;
    $3b2b36599051fe09$var$runClearTimeout(timeout);
}
$3b2b36599051fe09$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3b2b36599051fe09$var$queue.push(new $3b2b36599051fe09$var$Item(fun, args));
    if ($3b2b36599051fe09$var$queue.length === 1 && !$3b2b36599051fe09$var$draining) $3b2b36599051fe09$var$runTimeout($3b2b36599051fe09$var$drainQueue);
};
// v8 likes predictible objects
function $3b2b36599051fe09$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3b2b36599051fe09$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3b2b36599051fe09$var$process.title = 'browser';
$3b2b36599051fe09$var$process.browser = true;
$3b2b36599051fe09$var$process.env = {};
$3b2b36599051fe09$var$process.argv = [];
$3b2b36599051fe09$var$process.version = ''; // empty string to avoid regexp issues
$3b2b36599051fe09$var$process.versions = {};
function $3b2b36599051fe09$var$noop() {}
$3b2b36599051fe09$var$process.on = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.addListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.once = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.off = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.removeListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.removeAllListeners = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.emit = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.prependListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.prependOnceListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.listeners = function(name) {
    return [];
};
$3b2b36599051fe09$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3b2b36599051fe09$var$process.cwd = function() {
    return '/';
};
$3b2b36599051fe09$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3b2b36599051fe09$var$process.umask = function() {
    return 0;
};

});


var $d4e0578bd4446b15$exports = {};

(parcelRequire("dpjvp")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"50iJS\",\"index.e553582d.js\",\"dLu1I\",\"finavia.7d992b13.png\"]"));


var $e1vzu = parcelRequire("e1vzu");
const $6c971ad20ffabfab$var$isString = (obj)=>typeof obj === 'string';
const $6c971ad20ffabfab$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $6c971ad20ffabfab$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $6c971ad20ffabfab$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $6c971ad20ffabfab$var$lastOfPathSeparatorRegExp = /###/g;
const $6c971ad20ffabfab$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($6c971ad20ffabfab$var$lastOfPathSeparatorRegExp, '.') : key;
const $6c971ad20ffabfab$var$canNotTraverseDeeper = (object)=>!object || $6c971ad20ffabfab$var$isString(object);
const $6c971ad20ffabfab$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$6c971ad20ffabfab$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($6c971ad20ffabfab$var$canNotTraverseDeeper(object)) return {};
        const key = $6c971ad20ffabfab$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($6c971ad20ffabfab$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $6c971ad20ffabfab$var$cleanKey(stack[stackIndex])
    };
};
const $6c971ad20ffabfab$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $6c971ad20ffabfab$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $6c971ad20ffabfab$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $6c971ad20ffabfab$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $6c971ad20ffabfab$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $6c971ad20ffabfab$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $6c971ad20ffabfab$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $6c971ad20ffabfab$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $6c971ad20ffabfab$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $6c971ad20ffabfab$var$getPath(data, key);
    if (value !== undefined) return value;
    return $6c971ad20ffabfab$var$getPath(defaultData, key);
};
const $6c971ad20ffabfab$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($6c971ad20ffabfab$var$isString(target[prop]) || target[prop] instanceof String || $6c971ad20ffabfab$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $6c971ad20ffabfab$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $6c971ad20ffabfab$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $6c971ad20ffabfab$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $6c971ad20ffabfab$var$escape = (data)=>{
    if ($6c971ad20ffabfab$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$6c971ad20ffabfab$var$_entityMap[s]);
    return data;
};
class $6c971ad20ffabfab$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $6c971ad20ffabfab$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $6c971ad20ffabfab$var$looksLikeObjectPathRegExpCache = new $6c971ad20ffabfab$var$RegExpCache(20);
const $6c971ad20ffabfab$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $6c971ad20ffabfab$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $6c971ad20ffabfab$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $6c971ad20ffabfab$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $6c971ad20ffabfab$var$getCleanedCode = (code)=>code && code.replace('_', '-');
const $6c971ad20ffabfab$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $6c971ad20ffabfab$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $6c971ad20ffabfab$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($6c971ad20ffabfab$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $6c971ad20ffabfab$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $6c971ad20ffabfab$var$Logger(this.logger, options);
    }
}
var $6c971ad20ffabfab$var$baseLogger = new $6c971ad20ffabfab$var$Logger();
class $6c971ad20ffabfab$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $6c971ad20ffabfab$var$ResourceStore extends $6c971ad20ffabfab$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($6c971ad20ffabfab$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $6c971ad20ffabfab$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$6c971ad20ffabfab$var$isString(key)) return result;
        return $6c971ad20ffabfab$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $6c971ad20ffabfab$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($6c971ad20ffabfab$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $6c971ad20ffabfab$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $6c971ad20ffabfab$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $6c971ad20ffabfab$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $6c971ad20ffabfab$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $6c971ad20ffabfab$var$checkedLoadedFor = {};
class $6c971ad20ffabfab$var$Translator extends $6c971ad20ffabfab$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $6c971ad20ffabfab$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $6c971ad20ffabfab$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$6c971ad20ffabfab$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $6c971ad20ffabfab$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $6c971ad20ffabfab$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !$6c971ad20ffabfab$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !($6c971ad20ffabfab$var$isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $6c971ad20ffabfab$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !$6c971ad20ffabfab$var$isString(options.count);
            const hasDefaultValue = $6c971ad20ffabfab$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $6c971ad20ffabfab$var$isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$6c971ad20ffabfab$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $6c971ad20ffabfab$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $6c971ad20ffabfab$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($6c971ad20ffabfab$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$6c971ad20ffabfab$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && ($6c971ad20ffabfab$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$6c971ad20ffabfab$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $6c971ad20ffabfab$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$6c971ad20ffabfab$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const $6c971ad20ffabfab$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $6c971ad20ffabfab$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $6c971ad20ffabfab$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $6c971ad20ffabfab$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $6c971ad20ffabfab$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($6c971ad20ffabfab$var$isString(code) && code.indexOf('-') > -1) {
            if (typeof Intl !== 'undefined' && typeof Intl.getCanonicalLocales !== 'undefined') try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $6c971ad20ffabfab$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $6c971ad20ffabfab$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $6c971ad20ffabfab$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($6c971ad20ffabfab$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($6c971ad20ffabfab$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($6c971ad20ffabfab$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $6c971ad20ffabfab$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $6c971ad20ffabfab$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $6c971ad20ffabfab$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $6c971ad20ffabfab$var$intlVersions = [
    'v4'
];
const $6c971ad20ffabfab$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $6c971ad20ffabfab$var$createRules = ()=>{
    const rules = {};
    $6c971ad20ffabfab$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $6c971ad20ffabfab$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $6c971ad20ffabfab$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $6c971ad20ffabfab$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $6c971ad20ffabfab$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $6c971ad20ffabfab$var$createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) {
            const cleanedCode = $6c971ad20ffabfab$var$getCleanedCode(code === 'dev' ? 'en' : code);
            const type = options.ordinal ? 'ordinal' : 'cardinal';
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            let rule;
            try {
                rule = new Intl.PluralRules(cleanedCode, {
                    type: type
                });
            } catch (err) {
                if (!code.match(/-|_/)) return;
                const lngPart = this.languageUtils.getLanguagePartFromCode(code);
                rule = this.getRule(lngPart, options);
            }
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$6c971ad20ffabfab$var$suffixesOrder[pluralCategory1] - $6c971ad20ffabfab$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$6c971ad20ffabfab$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const $6c971ad20ffabfab$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $6c971ad20ffabfab$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $6c971ad20ffabfab$var$isString(key)) {
        path = $6c971ad20ffabfab$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $6c971ad20ffabfab$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $6c971ad20ffabfab$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $6c971ad20ffabfab$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $6c971ad20ffabfab$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $6c971ad20ffabfab$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $6c971ad20ffabfab$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $6c971ad20ffabfab$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $6c971ad20ffabfab$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $6c971ad20ffabfab$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $6c971ad20ffabfab$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $6c971ad20ffabfab$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $6c971ad20ffabfab$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($6c971ad20ffabfab$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$6c971ad20ffabfab$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $6c971ad20ffabfab$var$regexSafe(this.escape(val)) : $6c971ad20ffabfab$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $6c971ad20ffabfab$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$6c971ad20ffabfab$var$isString(value) && !this.useRawValueToEscape) value = $6c971ad20ffabfab$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$6c971ad20ffabfab$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$6c971ad20ffabfab$var$isString(value)) return value;
            if (!$6c971ad20ffabfab$var$isString(value)) value = $6c971ad20ffabfab$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $6c971ad20ffabfab$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $6c971ad20ffabfab$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($6c971ad20ffabfab$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $6c971ad20ffabfab$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $6c971ad20ffabfab$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $6c971ad20ffabfab$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $6c971ad20ffabfab$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $6c971ad20ffabfab$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $6c971ad20ffabfab$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $6c971ad20ffabfab$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $6c971ad20ffabfab$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $6c971ad20ffabfab$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $6c971ad20ffabfab$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $6c971ad20ffabfab$var$Connector extends $6c971ad20ffabfab$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $6c971ad20ffabfab$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $6c971ad20ffabfab$var$pushPath(q.loaded, [
                lng
            ], ns);
            $6c971ad20ffabfab$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($6c971ad20ffabfab$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($6c971ad20ffabfab$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $6c971ad20ffabfab$var$get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($6c971ad20ffabfab$var$isString(args[1])) ret.defaultValue = args[1];
            if ($6c971ad20ffabfab$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $6c971ad20ffabfab$var$transformOptions = (options)=>{
    if ($6c971ad20ffabfab$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($6c971ad20ffabfab$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($6c971ad20ffabfab$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $6c971ad20ffabfab$var$noop = ()=>{};
const $6c971ad20ffabfab$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $6c971ad20ffabfab$var$I18n extends $6c971ad20ffabfab$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $6c971ad20ffabfab$var$transformOptions(options);
        this.services = {};
        this.logger = $6c971ad20ffabfab$var$baseLogger;
        this.modules = {
            external: []
        };
        $6c971ad20ffabfab$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if ($6c971ad20ffabfab$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $6c971ad20ffabfab$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$6c971ad20ffabfab$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $6c971ad20ffabfab$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $6c971ad20ffabfab$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $6c971ad20ffabfab$var$Formatter;
            const lu = new $6c971ad20ffabfab$var$LanguageUtil(this.options);
            this.store = new $6c971ad20ffabfab$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $6c971ad20ffabfab$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $6c971ad20ffabfab$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $6c971ad20ffabfab$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $6c971ad20ffabfab$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $6c971ad20ffabfab$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $6c971ad20ffabfab$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $6c971ad20ffabfab$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6c971ad20ffabfab$var$noop;
        let usedCallback = callback;
        const usedLng = $6c971ad20ffabfab$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $6c971ad20ffabfab$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $6c971ad20ffabfab$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $6c971ad20ffabfab$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $6c971ad20ffabfab$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $6c971ad20ffabfab$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($6c971ad20ffabfab$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $6c971ad20ffabfab$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($6c971ad20ffabfab$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $6c971ad20ffabfab$var$defer();
        if ($6c971ad20ffabfab$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $6c971ad20ffabfab$var$LanguageUtil($6c971ad20ffabfab$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $6c971ad20ffabfab$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6c971ad20ffabfab$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $6c971ad20ffabfab$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $6c971ad20ffabfab$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $6c971ad20ffabfab$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $6c971ad20ffabfab$export$2e2bcd8739ae039 = $6c971ad20ffabfab$var$I18n.createInstance();
$6c971ad20ffabfab$export$2e2bcd8739ae039.createInstance = $6c971ad20ffabfab$var$I18n.createInstance;
const $6c971ad20ffabfab$export$99152e8d49ca4e7d = $6c971ad20ffabfab$export$2e2bcd8739ae039.createInstance;
const $6c971ad20ffabfab$export$147ec2801e896265 = $6c971ad20ffabfab$export$2e2bcd8739ae039.dir;
const $6c971ad20ffabfab$export$2cd8252107eb640b = $6c971ad20ffabfab$export$2e2bcd8739ae039.init;
const $6c971ad20ffabfab$export$d3d08d944062d7e = $6c971ad20ffabfab$export$2e2bcd8739ae039.loadResources;
const $6c971ad20ffabfab$export$a5d9bf5d83fcab09 = $6c971ad20ffabfab$export$2e2bcd8739ae039.reloadResources;
const $6c971ad20ffabfab$export$1f96ae73734a86cc = $6c971ad20ffabfab$export$2e2bcd8739ae039.use;
const $6c971ad20ffabfab$export$61465194746e7fd2 = $6c971ad20ffabfab$export$2e2bcd8739ae039.changeLanguage;
const $6c971ad20ffabfab$export$f90d180fc7da3b3b = $6c971ad20ffabfab$export$2e2bcd8739ae039.getFixedT;
const $6c971ad20ffabfab$export$625550452a3fa3ec = $6c971ad20ffabfab$export$2e2bcd8739ae039.t;
const $6c971ad20ffabfab$export$f7e9f41ea797a17 = $6c971ad20ffabfab$export$2e2bcd8739ae039.exists;
const $6c971ad20ffabfab$export$2b4b218e406d2d00 = $6c971ad20ffabfab$export$2e2bcd8739ae039.setDefaultNamespace;
const $6c971ad20ffabfab$export$93d9ee97c1ad3f31 = $6c971ad20ffabfab$export$2e2bcd8739ae039.hasLoadedNamespace;
const $6c971ad20ffabfab$export$83be934b53fff43b = $6c971ad20ffabfab$export$2e2bcd8739ae039.loadNamespaces;
const $6c971ad20ffabfab$export$8cd7e7a54fa865bc = $6c971ad20ffabfab$export$2e2bcd8739ae039.loadLanguages;


function $c07a56ffd7c5a498$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $f153e69ae7eaec18$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f153e69ae7eaec18$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f153e69ae7eaec18$export$2e2bcd8739ae039(o);
}



function $442437ad1e247e6e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $f153e69ae7eaec18$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $f153e69ae7eaec18$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $f70fc3c85747748f$export$2e2bcd8739ae039(t) {
    var i = (0, $442437ad1e247e6e$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $f153e69ae7eaec18$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $1c50490f53a25b50$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $f70fc3c85747748f$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $1c50490f53a25b50$export$2e2bcd8739ae039(e, r, t) {
    return r && $1c50490f53a25b50$var$_defineProperties(e.prototype, r), t && $1c50490f53a25b50$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


var $2bcc403070ba62d9$var$arr = [];
var $2bcc403070ba62d9$var$each = $2bcc403070ba62d9$var$arr.forEach;
var $2bcc403070ba62d9$var$slice = $2bcc403070ba62d9$var$arr.slice;
function $2bcc403070ba62d9$var$defaults(obj) {
    $2bcc403070ba62d9$var$each.call($2bcc403070ba62d9$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $2bcc403070ba62d9$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $2bcc403070ba62d9$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$2bcc403070ba62d9$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$2bcc403070ba62d9$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var $2bcc403070ba62d9$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $2bcc403070ba62d9$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $2bcc403070ba62d9$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $2bcc403070ba62d9$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $2bcc403070ba62d9$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $2bcc403070ba62d9$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $2bcc403070ba62d9$var$hasLocalStorageSupport = null;
var $2bcc403070ba62d9$var$localStorageAvailable = function localStorageAvailable() {
    if ($2bcc403070ba62d9$var$hasLocalStorageSupport !== null) return $2bcc403070ba62d9$var$hasLocalStorageSupport;
    try {
        $2bcc403070ba62d9$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $2bcc403070ba62d9$var$hasLocalStorageSupport = false;
    }
    return $2bcc403070ba62d9$var$hasLocalStorageSupport;
};
var $2bcc403070ba62d9$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $2bcc403070ba62d9$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $2bcc403070ba62d9$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $2bcc403070ba62d9$var$hasSessionStorageSupport = null;
var $2bcc403070ba62d9$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($2bcc403070ba62d9$var$hasSessionStorageSupport !== null) return $2bcc403070ba62d9$var$hasSessionStorageSupport;
    try {
        $2bcc403070ba62d9$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $2bcc403070ba62d9$var$hasSessionStorageSupport = false;
    }
    return $2bcc403070ba62d9$var$hasSessionStorageSupport;
};
var $2bcc403070ba62d9$var$sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $2bcc403070ba62d9$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $2bcc403070ba62d9$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $2bcc403070ba62d9$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $2bcc403070ba62d9$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $2bcc403070ba62d9$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $2bcc403070ba62d9$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
var $2bcc403070ba62d9$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $2bcc403070ba62d9$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
var $2bcc403070ba62d9$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$2bcc403070ba62d9$var$canCookies) $2bcc403070ba62d9$var$order.splice(1, 1);
function $2bcc403070ba62d9$var$getDefaults() {
    return {
        order: $2bcc403070ba62d9$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $2bcc403070ba62d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $c07a56ffd7c5a498$export$2e2bcd8739ae039)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    return (0, $1c50490f53a25b50$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $2bcc403070ba62d9$var$defaults(options, this.options || {}, $2bcc403070ba62d9$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace('-', '_');
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($2bcc403070ba62d9$var$cookie$1);
                this.addDetector($2bcc403070ba62d9$var$querystring);
                this.addDetector($2bcc403070ba62d9$var$localStorage);
                this.addDetector($2bcc403070ba62d9$var$sessionStorage);
                this.addDetector($2bcc403070ba62d9$var$navigator$1);
                this.addDetector($2bcc403070ba62d9$var$htmlTag);
                this.addDetector($2bcc403070ba62d9$var$path);
                this.addDetector($2bcc403070ba62d9$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
                return this;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
}();
$2bcc403070ba62d9$export$2e2bcd8739ae039.type = 'languageDetector';



var $3QbnI = parcelRequire("3QbnI");

var $eEqN4 = parcelRequire("eEqN4");

var $3QbnI = parcelRequire("3QbnI");
var $de4b3f03ee106e77$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $de4b3f03ee106e77$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $d73cbeccb42e8979$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $d73cbeccb42e8979$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($de4b3f03ee106e77$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($d73cbeccb42e8979$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $d73cbeccb42e8979$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $d73cbeccb42e8979$var$i = /^\s*$/, $d73cbeccb42e8979$var$s = Object.create(null);
function $d73cbeccb42e8979$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($d73cbeccb42e8979$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $d73cbeccb42e8979$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $d73cbeccb42e8979$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($d73cbeccb42e8979$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $d73cbeccb42e8979$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $d73cbeccb42e8979$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $d73cbeccb42e8979$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $d73cbeccb42e8979$var$a("", t);
        }, "");
    }
};
var $d73cbeccb42e8979$export$2e2bcd8739ae039 = $d73cbeccb42e8979$var$c;


function $1eeddf45804ce9c9$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $1eeddf45804ce9c9$var$alreadyWarned = {};
function $1eeddf45804ce9c9$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $1eeddf45804ce9c9$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $1eeddf45804ce9c9$var$alreadyWarned[args[0]] = new Date();
    $1eeddf45804ce9c9$export$c106dd0671a0fc2d(...args);
}
const $1eeddf45804ce9c9$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
function $1eeddf45804ce9c9$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $1eeddf45804ce9c9$var$loadedClb(i18n, cb));
}
function $1eeddf45804ce9c9$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === 'string') ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $1eeddf45804ce9c9$var$loadedClb(i18n, cb));
}
function $1eeddf45804ce9c9$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $1eeddf45804ce9c9$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $1eeddf45804ce9c9$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $1eeddf45804ce9c9$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $1eeddf45804ce9c9$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


const $b9a5935daedb40f5$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $b9a5935daedb40f5$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $b9a5935daedb40f5$var$unescapeHtmlEntity = (m)=>$b9a5935daedb40f5$var$htmlEntities[m];
const $b9a5935daedb40f5$export$e8bacd2802a88316 = (text)=>text.replace($b9a5935daedb40f5$var$matchHtmlEntity, $b9a5935daedb40f5$var$unescapeHtmlEntity);


let $f4559ec9d899dea4$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $b9a5935daedb40f5$export$e8bacd2802a88316
};
function $f4559ec9d899dea4$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $f4559ec9d899dea4$var$defaultOptions = {
        ...$f4559ec9d899dea4$var$defaultOptions,
        ...options
    };
}
function $f4559ec9d899dea4$export$212bb2fc580a90a8() {
    return $f4559ec9d899dea4$var$defaultOptions;
}


let $6e51e8f68e30bc77$var$i18nInstance;
function $6e51e8f68e30bc77$export$a039134f2fc7e0(instance) {
    $6e51e8f68e30bc77$var$i18nInstance = instance;
}
function $6e51e8f68e30bc77$export$64af334f494c2f47() {
    return $6e51e8f68e30bc77$var$i18nInstance;
}


function $32392f81c628405b$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $32392f81c628405b$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $32392f81c628405b$var$getAsArray(children) : children;
}
function $32392f81c628405b$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every((child)=>(0, $3QbnI.isValidElement)(child));
}
function $32392f81c628405b$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $32392f81c628405b$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $32392f81c628405b$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $32392f81c628405b$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === 'string') stringNode += `${child}`;
        else if ((0, $3QbnI.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $32392f81c628405b$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $1eeddf45804ce9c9$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === 'object') {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $1eeddf45804ce9c9$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $1eeddf45804ce9c9$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $32392f81c628405b$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $32392f81c628405b$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === 'string') return;
            if ($32392f81c628405b$var$hasChildren(child)) getData($32392f81c628405b$var$getChildren(child));
            else if (typeof child === 'object' && !(0, $3QbnI.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $d73cbeccb42e8979$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $32392f81c628405b$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $32392f81c628405b$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $3QbnI.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $3QbnI.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($eEqN4)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $32392f81c628405b$var$getAsArray(reactNode);
        const astNodes = $32392f81c628405b$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $32392f81c628405b$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $3QbnI.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $32392f81c628405b$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === 'object' && child.dummy && !isElement;
                const isKnownComponent = typeof children === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($32392f81c628405b$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $3QbnI.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $3QbnI.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === 'object' && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $3QbnI.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $32392f81c628405b$var$getAsArray(children || []));
    return $32392f81c628405b$var$getChildren(result[0]);
}
function $32392f81c628405b$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $6e51e8f68e30bc77$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $1eeddf45804ce9c9$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $f4559ec9d899dea4$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $32392f81c628405b$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Fragment, null, comp);
        }
        components[c] = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(Componentized, null);
    });
    const content = $32392f81c628405b$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $3QbnI.createElement)(useAsParent, additionalProps, content) : content;
}



var $3QbnI = parcelRequire("3QbnI");




const $8534646853d1e278$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $f4559ec9d899dea4$export$2e2366488d12e20d)(instance.options.react);
        (0, $6e51e8f68e30bc77$export$a039134f2fc7e0)(instance);
    }
};


const $387e41e3fab13fe5$export$5603ab5ced17ce64 = (0, $3QbnI.createContext)();
class $387e41e3fab13fe5$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $387e41e3fab13fe5$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $387e41e3fab13fe5$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $387e41e3fab13fe5$export$704200e5d0b9e8f() {
    const i18n = (0, $6e51e8f68e30bc77$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $8786ef7f377b435f$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $3QbnI.useContext)((0, $387e41e3fab13fe5$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $6e51e8f68e30bc77$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $32392f81c628405b$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $3QbnI = parcelRequire("3QbnI");


const $2f9d9cd8e678cf7e$var$usePrevious = (value, ignore)=>{
    const ref = (0, $3QbnI.useRef)();
    (0, $3QbnI.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $2f9d9cd8e678cf7e$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $3QbnI.useContext)((0, $387e41e3fab13fe5$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $6e51e8f68e30bc77$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $387e41e3fab13fe5$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $1eeddf45804ce9c9$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $1eeddf45804ce9c9$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $f4559ec9d899dea4$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $1eeddf45804ce9c9$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $3QbnI.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $2f9d9cd8e678cf7e$var$usePrevious(joinedNS);
    const isMounted = (0, $3QbnI.useRef)(true);
    (0, $3QbnI.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $1eeddf45804ce9c9$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $1eeddf45804ce9c9$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $3QbnI.useRef)(true);
    (0, $3QbnI.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $1eeddf45804ce9c9$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $1eeddf45804ce9c9$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $3QbnI = parcelRequire("3QbnI");


function $2309a1fc8a579f85$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $2f9d9cd8e678cf7e$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $3QbnI.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $1eeddf45804ce9c9$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $3QbnI.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $3QbnI.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $f18ed5f971e0beab$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $2f9d9cd8e678cf7e$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $3QbnI = parcelRequire("3QbnI");

function $dda95c23dcc57180$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $3QbnI.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $3QbnI.createElement)((0, $387e41e3fab13fe5$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

function $159ac73cb15f35fe$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $3QbnI.useContext)((0, $387e41e3fab13fe5$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $6e51e8f68e30bc77$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $2eac22cf2205fbfc$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $159ac73cb15f35fe$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $3QbnI.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $387e41e3fab13fe5$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $1eeddf45804ce9c9$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $b816075049676d9c$export$324d90190a8b822a = ()=>'';
const $b816075049676d9c$export$2da9be4cfdb689b1 = ()=>'';
const $b816075049676d9c$export$98e628dec113755e = ()=>'';
const $b816075049676d9c$export$2e6c959c16ff56b8 = ()=>'';
const $b816075049676d9c$export$4e35d5c922a95490 = ()=>'';
const $b816075049676d9c$export$720a3b9db04b7a0f = ()=>'';


var $7132ad9939508af6$exports = {};
$7132ad9939508af6$exports = JSON.parse('{"facility.name":"Helsinki Airport drop-off area","facility.webpage.url":"https://www.finavia.fi/en","facility.customerService.url":"https://customerservice.finavia.fi/en/support/home","facility.privacyPolicy.url":"https://www.finavia.fi/fi/media/7837/download","facility.privacyPolicy.text":"Privacy policy","document.title":"Helsinki Airport drop-off","page.webPayment.paymentProvider.heading":"Payment Service Provider","page.webPayment.paymentProvider.information":"Paytrail Oyj is a collecting payment service provider and an authorized Payment Institution working in cooperation with Finnish banks and credit institutions. Paytrail Oyj will be shown as the recipient on your bank or credit card statement. Paytrail Oyj will forward the payment to the merchant. For complaints, please contact the website the payment was made to.","page.webPayment.paymentProvider.details1":"Paytrail Oyj, Business ID 2122839-7","page.webPayment.paymentProvider.details2":"Innova 2","page.webPayment.paymentProvider.details3":"Lutakonaukio 7","page.webPayment.paymentProvider.details4":"40100 Jyv\xe4skyl\xe4","page.webPayment.paymentProvider.url":"https://www.paytrail.com/en/consumer/information-about-paying","page.webPayment.stepFillLicensePlate.info.pay":"Pay for your visit within 48 hours","page.webPayment.stepFillLicensePlate.info.notPaid":"Did you visit Helsinki Airport\'s drop-off area and have not yet paid?","page.webPayment.stepFillLicensePlate.info.licensePlate":"Search for your visit details by entering your vehicle\'s registration number:","page.webPayment.stepFillLicensePlate.button.find":"Search for the vehicle","page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate":"Registration number","page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter":"Enter","page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate":"Enter a valid vehicle registration number.","page.webPayment.stepFillLicensePlate.formLicensePlate.info.format":"In the format ABC-123 or ABC123","page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents":"No unpaid visits were found for the registration number {licensePlate}.","page.webPayment.stepFillLicensePlate.alert.body.reason":"This can be due to various reasons.","page.webPayment.stepFillLicensePlate.alert.body.desc1":"Your visit to the drop-off area was free of charge","page.webPayment.stepFillLicensePlate.alert.body.desc2":"48 hours have passed since the visit and a bill or payment reminder has been sent by mail based on the registration number","page.webPayment.stepFillLicensePlate.alert.body.desc3":"You entered the wrong registration number","page.webPayment.stepFillLicensePlate.getInvoice.errorToast":"Error while fetching data. Please try again later.","page.webPayment.stepInvoice.info.invoice":"Your payments","page.webPayment.stepInvoice.info.invoiceDescription":"{count, plural, one {One unpaid visit was found with the registration number {licensePlate}.} other {{count} unpaid visits were found with the registration number {licensePlate}.}}","page.webPayment.stepInvoice.button.payParking":"Pay","page.webPayment.stepInvoice.button.payParking.loading":"Loading...","page.webPayment.stepInvoice.cardInvoice.parkingStarted":"Visit start time","page.webPayment.stepInvoice.cardInvoice.duration":"Duration","page.webPayment.stepInvoice.cardInvoice.parkingPrice":"Visit fee","page.webPayment.stepInvoice.cardInvoice.vatIncluded":"Incl. {vat}% VAT {vatPrice}","page.webPayment.stepInvoice.contactInformation.description":"Your email address is required for the receipt and the possible refund.","page.webPayment.stepInvoice.emailAddress":"Email address","page.webPayment.stepInvoice.form.email.errors.email":"Please enter a valid email address.","page.webPayment.stepInvoice.form.email.errors.required":"Email address is required.","page.webPayment.stepInvoice.error.initiatePayment":"Error while initiating payment. Please try again later.","page.webPayment.stepFinish.info.success":"Payment completed. Thank you!","page.webPayment.stepFinish.info.failure":"Payment failed.","page.webPayment.stepFinish.failureInfo":"The payment may have failed due to various reasons.","page.webPayment.stepFinish.failureInfoList.heading":"Possible reasons include","page.webPayment.stepFinish.failureInfoList.item1":"You cancelled the payment","page.webPayment.stepFinish.failureInfoList.item2":"Insufficient bank account balance","page.webPayment.stepFinish.failureInfoList.item3":"Credit limit on the credit card","page.webPayment.stepFinish.failureInfoList.item4":"Connection problem between the bank and the payment service","page.webPayment.stepFinish.failureInfoList.item5":"Online payment restrictions on the payment card","page.webPayment.stepFinish.failureInfoList.footer":"If necessary, please contact your bank.","page.webPayment.stepFinish.info.receipt":"Your receipt will be sent to {email}.","page.webPayment.stepFinish.button.newPayment":"Pay for another visit","page.webPayment.stepFinish.button.tryAgain":"Try again","page.webPayment.stepFinish.backToFacilitySiteButtonText":"Finavia.fi/en","page.webPayment.paymentRedirectReceiver.heading":"Processing payment...","page.webPayment.label.customerService.part1":"If you have any problems, please contact","page.webPayment.label.customerService.part2":"Finavia\'s customer service","page.webPayment.label.customerService.urlTitle":"Finavia\'s customer service","common.units.hours.short":"h","common.units.minutes.short":"min","common.units.seconds.short":"s","common.button.back":"Back","language":"Language","language.fi":"Suomeksi","language.en":"In English","language.sv":"P\xe5 svenska"}');


var $b93d046c1c5f0949$exports = {};
$b93d046c1c5f0949$exports = JSON.parse('{"facility.name":"Helsinki-Vantaan drop-off-alue","facility.webpage.url":"https://www.finavia.fi","facility.customerService.url":"https://customerservice.finavia.fi/fi/support/home","facility.privacyPolicy.url":"https://www.finavia.fi/fi/media/7837/download","facility.privacyPolicy.text":"Tietosuojaseloste","document.title":"Helsinki-Vantaa drop-off","page.webPayment.paymentProvider.heading":"Maksupalveluntarjoaja","page.webPayment.paymentProvider.information":"Maksunv\xe4lityspalvelun toteuttajana ja maksupalveluntarjoajana toimii Paytrail Oyj (2122839-7) yhteisty\xf6ss\xe4 suomalaisten pankkien ja luottolaitosten kanssa. Paytrail Oyj n\xe4kyy maksun saajana tiliotteella tai korttilaskulla ja v\xe4litt\xe4\xe4 maksun kauppiaalle. Paytrail Oyj:ll\xe4 on maksulaitoksen toimilupa. Reklamaatiotapauksissa pyyd\xe4mme ottamaan ensisijaisesti yhteytt\xe4 tuotteen toimittajaan.","page.webPayment.paymentProvider.details1":"Paytrail Oyj, y-tunnus: 2122839-7","page.webPayment.paymentProvider.details2":"Innova 2","page.webPayment.paymentProvider.details3":"Lutakonaukio 7","page.webPayment.paymentProvider.details4":"40100 Jyv\xe4skyl\xe4","page.webPayment.paymentProvider.url":"https://www.paytrail.com/kuluttaja/tietoa-maksamisesta","page.webPayment.stepFillLicensePlate.info.pay":"Maksa vierailu 48 tunnin sis\xe4ll\xe4","page.webPayment.stepFillLicensePlate.info.notPaid":"Vierailitko Helsinki-Vantaa drop-off-alueella etk\xe4 ole viel\xe4 maksanut vierailuasi?","page.webPayment.stepFillLicensePlate.info.licensePlate":"Hae vierailusi sy\xf6tt\xe4m\xe4ll\xe4 rekisteritunnuksesi:","page.webPayment.stepFillLicensePlate.button.find":"Hae ajoneuvo","page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate":"Rekisteritunnus","page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter":"Sy\xf6t\xe4","page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate":"Sy\xf6t\xe4 kelvollinen ajoneuvon rekisteritunnus.","page.webPayment.stepFillLicensePlate.formLicensePlate.info.format":"Muodossa ABC-123 tai ABC123","page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents":"Rekisteritunnukselle {licensePlate} ei l\xf6ytynyt maksamattomia vierailuja.","page.webPayment.stepFillLicensePlate.alert.body.reason":"T\xe4h\xe4n voi olla eri syit\xe4.","page.webPayment.stepFillLicensePlate.alert.body.desc1":"Vierailusi drop-off-alueella oli maksuton","page.webPayment.stepFillLicensePlate.alert.body.desc2":"Vierailusta on kulunut 48 tuntia ja siit\xe4 on l\xe4hetetty lasku tai maksumuistutus postitse rekisteritunnuksen perusteella","page.webPayment.stepFillLicensePlate.alert.body.desc3":"Sy\xf6tit lomakkeelle v\xe4\xe4r\xe4n rekisteritunnuksen","page.webPayment.stepFillLicensePlate.getInvoice.errorToast":"Virhe tietojen haussa. Kokeile my\xf6hemmin uudestaan.","page.webPayment.stepInvoice.info.invoice":"Maksamattomat vierailut","page.webPayment.stepInvoice.info.invoiceDescription":"{count, plural, one {Rekisteritunnuksella {licensePlate} l\xf6ytyi maksamaton vierailu.} other {Rekisteritunnuksella {licensePlate} l\xf6ytyi {count} maksamatonta vierailua.}}","page.webPayment.stepInvoice.button.payParking":"Maksa","page.webPayment.stepInvoice.button.payParking.loading":"Ladataan...","page.webPayment.stepInvoice.cardInvoice.parkingStarted":"Vierailu alkoi","page.webPayment.stepInvoice.cardInvoice.duration":"Kesto","page.webPayment.stepInvoice.cardInvoice.parkingPrice":"Vierailumaksu","page.webPayment.stepInvoice.cardInvoice.vatIncluded":"Sis. alv. {vat}% {vatPrice}","page.webPayment.stepInvoice.contactInformation.description":"S\xe4hk\xf6postiosoite vaaditaan kuittia ja mahdollista maksunpalautusta varten.","page.webPayment.stepInvoice.emailAddress":"S\xe4hk\xf6postiosoite","page.webPayment.stepInvoice.form.email.errors.email":"Sy\xf6t\xe4 kelvollinen s\xe4hk\xf6postiosoite.","page.webPayment.stepInvoice.form.email.errors.required":"S\xe4hk\xf6postiosoite vaaditaan.","page.webPayment.stepInvoice.error.initiatePayment":"Virhe maksun aloittamisessa. Yrit\xe4 hetken kuluttua uudelleen.","page.webPayment.stepFinish.info.success":"Maksu suoritettu, kiitos!","page.webPayment.stepFinish.info.failure":"Maksu ep\xe4onnistui.","page.webPayment.stepFinish.failureInfo":"Maksu voi ep\xe4onnistua monista eri syist\xe4.","page.webPayment.stepFinish.failureInfoList.heading":"Syit\xe4 voivat olla esimerkiksi","page.webPayment.stepFinish.failureInfoList.item1":"Peruutit maksamisen","page.webPayment.stepFinish.failureInfoList.item2":"Pankkitilin saldo ei riit\xe4","page.webPayment.stepFinish.failureInfoList.item3":"Luottokortin luottoraja","page.webPayment.stepFinish.failureInfoList.item4":"Yhteysongelma pankin ja maksupalvelun v\xe4lill\xe4","page.webPayment.stepFinish.failureInfoList.item5":"Maksukortin verkkomaksurajoitukset","page.webPayment.stepFinish.failureInfoList.footer":"Tarvittaessa ota yhteys pankkiisi.","page.webPayment.stepFinish.info.receipt":"Kuitti l\xe4hetet\xe4\xe4n s\xe4hk\xf6postiosoitteeseen {email}.","page.webPayment.stepFinish.button.newPayment":"Maksa toinen vierailu","page.webPayment.stepFinish.button.tryAgain":"Yrit\xe4 uudelleen","page.webPayment.stepFinish.backToFacilitySiteButtonText":"Finavia.fi","page.webPayment.paymentRedirectReceiver.heading":"Maksua k\xe4sitell\xe4\xe4n...","page.webPayment.label.customerService.part1":"Mahdollisissa ongelmatilanteissa ota yhteytt\xe4","page.webPayment.label.customerService.part2":"Finavian asiakaspalveluun","page.webPayment.label.customerService.urlTitle":"Finavian asiakaspalvelu","common.units.hours.short":"h","common.units.minutes.short":"min","common.units.seconds.short":"s","common.button.back":"Takaisin","language":"Kieli","language.fi":"Suomeksi","language.en":"In English","language.sv":"P\xe5 svenska"}');


var $19ca9a19d6a5d623$exports = {};
$19ca9a19d6a5d623$exports = JSON.parse('{"facility.name":"Helsingfors-Vanda flygplats drop-off-omr\xe5de","facility.webpage.url":"https://www.finavia.fi/sv","facility.customerService.url":"https://customerservice.finavia.fi/sv-SE/support/home","facility.privacyPolicy.url":"https://www.finavia.fi/fi/media/7837/download","facility.privacyPolicy.text":"Integritetspolicy","document.title":"Helsingfors-Vanda drop-off","page.webPayment.paymentProvider.heading":"Betaltja\u0308nstleveranto\u0308r","page.webPayment.paymentProvider.information":"Som betalningsfo\u0308rmedlingstja\u0308nst och betaltja\u0308nstleveranto\u0308r fungerar Paytrail Oyj (2122839-7) i samarbete med finska banker och kreditinstitut. Paytrail Oyj visas som mottagare av betalningen pa\u030A kontoutdraget eller kortfakturan och vidarebefordrar betalningen till handlaren. Paytrail Oyj har ett verksamhetstillsta\u030And fo\u0308r betalningsinstitut. Vid reklamationer ber vi dig fo\u0308rst kontakta produktens leveranto\u0308r.","page.webPayment.paymentProvider.details1":"Paytrail Oyj, FO-nummer: 2122839-7","page.webPayment.paymentProvider.details2":"Innova 2","page.webPayment.paymentProvider.details3":"Lutakonaukio 7","page.webPayment.paymentProvider.details4":"40100 Jyv\xe4skyl\xe4","page.webPayment.paymentProvider.url":"https://www.paytrail.com/kuluttaja/information-om-betalning","page.webPayment.stepFillLicensePlate.info.pay":"Betala f\xf6r ditt bes\xf6k inom 48 timmar","page.webPayment.stepFillLicensePlate.info.notPaid":"Har du bes\xf6kt Helsingfors-Vanda flygplats drop-off-omr\xe5de och inte betalat \xe4n?","page.webPayment.stepFillLicensePlate.info.licensePlate":"Ange ditt registreringsnummer f\xf6r att h\xe4mta information om ditt bes\xf6k:","page.webPayment.stepFillLicensePlate.button.find":"S\xf6k fordon","page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate":"Registreringsnumret","page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter":"Ange","page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate":"Ange ett giltigt registreringsnumret.","page.webPayment.stepFillLicensePlate.formLicensePlate.info.format":"i formen ABC-123 eller ABC123","page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents":"Inga obetalda bes\xf6k hittades f\xf6r registreringsnumret {licensePlate}.","page.webPayment.stepFillLicensePlate.alert.body.reason":"Detta kan bero p\xe5 olika orsaker.","page.webPayment.stepFillLicensePlate.alert.body.desc1":"Ditt bes\xf6k p\xe5 drop-off-omr\xe5det var kostnadsfritt","page.webPayment.stepFillLicensePlate.alert.body.desc2":"Det har g\xe5tt 48 timmar sedan bes\xf6ket och en faktura eller betalningsp\xe5minnelse har skickats per post baserat p\xe5 registreringsnumret","page.webPayment.stepFillLicensePlate.alert.body.desc3":"Du angav fel registreringsnumret","page.webPayment.stepFillLicensePlate.getInvoice.errorToast":"Ett fel uppstod vid h\xe4mtning av data. F\xf6rs\xf6k igen senare.","page.webPayment.stepInvoice.info.invoice":"Dina betalningar","page.webPayment.stepInvoice.info.invoiceDescription":"{count, plural, one {Ett obetalt bes\xf6k hittades med registreringsnumret {licensePlate}.} other {{count} obetalda bes\xf6k hittades med registreringsnumret {licensePlate}.}}","page.webPayment.stepInvoice.button.payParking":"Betala","page.webPayment.stepInvoice.button.payParking.loading":"Bearbetar...","page.webPayment.stepInvoice.cardInvoice.parkingStarted":"Bes\xf6ket b\xf6rjade","page.webPayment.stepInvoice.cardInvoice.duration":"L\xe4ngd","page.webPayment.stepInvoice.cardInvoice.parkingPrice":"Bes\xf6ksavgift","page.webPayment.stepInvoice.cardInvoice.vatIncluded":"Inkl. moms {vat}% {vatPrice}","page.webPayment.stepInvoice.contactInformation.description":"E-postadress kr\xe4vs f\xf6r kvitto och eventuell \xe5terbetalning.","page.webPayment.stepInvoice.emailAddress":"E-postadress","page.webPayment.stepInvoice.form.email.errors.email":"Ange en giltig e-postadress.","page.webPayment.stepInvoice.form.email.errors.required":"E-postadress kr\xe4vs.","page.webPayment.stepInvoice.error.initiatePayment":"Ett fel uppstod vid initiering av betalningen. F\xf6rs\xf6k igen senare.","page.webPayment.stepFinish.info.success":"Betalning gjord, tack!","page.webPayment.stepFinish.info.failure":"Betalningen misslyckades.","page.webPayment.stepFinish.failureInfo":"Betalningen kan ha misslyckats av olika anledningar.","page.webPayment.stepFinish.failureInfoList.heading":"M\xf6jliga orsaker inkluderar","page.webPayment.stepFinish.failureInfoList.item1":"Du avbr\xf6t betalningen","page.webPayment.stepFinish.failureInfoList.item2":"Otillr\xe4ckligt saldo p\xe5 bankkontot","page.webPayment.stepFinish.failureInfoList.item3":"Kreditkortets kreditgr\xe4ns","page.webPayment.stepFinish.failureInfoList.item4":"Anslutningsproblem mellan banken och betaltj\xe4nsten","page.webPayment.stepFinish.failureInfoList.item5":"Begr\xe4nsningar f\xf6r onlinebetalning p\xe5 betalkortet","page.webPayment.stepFinish.failureInfoList.footer":"Kontakta din bank vid behov.","page.webPayment.stepFinish.info.receipt":"Ditt kvitto kommer att skickas till {email}.","page.webPayment.stepFinish.button.newPayment":"Betala f\xf6r ett annat bes\xf6k","page.webPayment.stepFinish.button.tryAgain":"F\xf6rs\xf6k igen","page.webPayment.stepFinish.backToFacilitySiteButtonText":"Finavia.fi/sv","page.webPayment.paymentRedirectReceiver.heading":"Bearbetar betalning...","page.webPayment.label.customerService.part1":"Vid eventuella problem kontakta","page.webPayment.label.customerService.part2":"Finavias kundtj\xe4nst","page.webPayment.label.customerService.urlTitle":"Finavias kundtj\xe4nst","common.units.hours.short":"h","common.units.minutes.short":"min","common.units.seconds.short":"s","common.button.back":"Tillbaka","language":"Spr\xe5k","language.fi":"Suomeksi","language.en":"In English","language.sv":"P\xe5 svenska"}');


const $d30a5fdc49293dc0$export$bc99aaabaf7b70a7 = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($7132ad9939508af6$exports)))
    },
    fi: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($b93d046c1c5f0949$exports)))
    },
    sv: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($19ca9a19d6a5d623$exports)))
    }
};
const $d30a5fdc49293dc0$var$localizationResources = {
    resources: $d30a5fdc49293dc0$export$bc99aaabaf7b70a7,
    supportedLanguages: Object.getOwnPropertyNames($d30a5fdc49293dc0$export$bc99aaabaf7b70a7)
};
var $d30a5fdc49293dc0$export$2e2bcd8739ae039 = $d30a5fdc49293dc0$var$localizationResources;


(0, $6c971ad20ffabfab$export$2e2bcd8739ae039)// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use((0, $2bcc403070ba62d9$export$2e2bcd8739ae039))// pass the i18n instance to react-i18next.
.use((0, $8534646853d1e278$export$ae7e14d40d89f296))// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
    debug: true,
    supportedLngs: (0, $d30a5fdc49293dc0$export$2e2bcd8739ae039).supportedLanguages,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    resources: (0, $d30a5fdc49293dc0$export$2e2bcd8739ae039).resources
});
// update HTML document language now and whenever i18n language is changed
const $2e2f998e72251dab$var$updateDocumentLang = (lng)=>document.documentElement.setAttribute('lang', lng);
$2e2f998e72251dab$var$updateDocumentLang((0, $6c971ad20ffabfab$export$2e2bcd8739ae039).language);
(0, $6c971ad20ffabfab$export$2e2bcd8739ae039).on('languageChanged', $2e2f998e72251dab$var$updateDocumentLang);
var $2e2f998e72251dab$export$2e2bcd8739ae039 = (0, $6c971ad20ffabfab$export$2e2bcd8739ae039);




var $3QbnI = parcelRequire("3QbnI");
var $b44a20a3fc7684be$export$882461b6382ed46c;
var $b44a20a3fc7684be$export$757ceba2d55c277e;
'use strict';
var $70c58451959e30b3$exports = {};
'use strict';
function $70c58451959e30b3$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($70c58451959e30b3$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$70c58451959e30b3$var$checkDCE();

$70c58451959e30b3$exports = (parcelRequire("chU0U"));


var $b44a20a3fc7684be$var$i;
$b44a20a3fc7684be$export$882461b6382ed46c = $70c58451959e30b3$exports.createRoot;
$b44a20a3fc7684be$export$757ceba2d55c277e = $70c58451959e30b3$exports.hydrateRoot;



var $e1vzu = parcelRequire("e1vzu");



var $54BtZ = parcelRequire("54BtZ");

var $3QbnI = parcelRequire("3QbnI");

parcelRequire("3QbnI");

var $6s3yU = parcelRequire("6s3yU");

var $bXE6K = parcelRequire("bXE6K");
const $1a12cef9553d47e6$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $bXE6K.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $1a12cef9553d47e6$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $1a12cef9553d47e6$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $6s3yU.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}


parcelRequire("3QbnI");

var $aTv5Z = parcelRequire("aTv5Z");

var $3QbnI = parcelRequire("3QbnI");
parcelRequire("fPIjG");
var $54BtZ = parcelRequire("54BtZ");
'use client';
function $5b234c3a126f1137$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5b234c3a126f1137$var$useTheme(defaultTheme = null) {
    const contextTheme = $3QbnI.useContext((0, $54BtZ.T));
    return !contextTheme || $5b234c3a126f1137$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5b234c3a126f1137$export$2e2bcd8739ae039 = $5b234c3a126f1137$var$useTheme;


'use client';
const $6338ced0c7678953$export$35e57303dbd8a66 = (0, $aTv5Z.default)();
function $6338ced0c7678953$var$useTheme(defaultTheme = $6338ced0c7678953$export$35e57303dbd8a66) {
    return (0, $5b234c3a126f1137$export$2e2bcd8739ae039)(defaultTheme);
}
var $6338ced0c7678953$export$2e2bcd8739ae039 = $6338ced0c7678953$var$useTheme;



var $cxyce = parcelRequire("cxyce");

var $9t00Y = parcelRequire("9t00Y");
'use client';
function $6a808f4d6e083741$export$2e2bcd8739ae039() {
    const theme = (0, $6338ced0c7678953$export$2e2bcd8739ae039)((0, $cxyce.default));
    return theme[0, $9t00Y.default] || theme;
}


parcelRequire("3QbnI");

parcelRequire("3QbnI");


var $3MMEU = parcelRequire("3MMEU");


var $e1vzu = parcelRequire("e1vzu");
'use client';
function $7698ac916bdecb12$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $6338ced0c7678953$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3MMEU.default), {
        styles: globalStyles
    });
}
var $7698ac916bdecb12$export$2e2bcd8739ae039 = $7698ac916bdecb12$var$GlobalStyles;



var $cxyce = parcelRequire("cxyce");

var $9t00Y = parcelRequire("9t00Y");

var $e1vzu = parcelRequire("e1vzu");
'use client';
function $3131c44a70c48b35$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7698ac916bdecb12$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $cxyce.default),
        themeId: (0, $9t00Y.default)
    });
}
var $3131c44a70c48b35$export$2e2bcd8739ae039 = $3131c44a70c48b35$var$GlobalStyles;



var $e1vzu = parcelRequire("e1vzu");

var $fPIjG = parcelRequire("fPIjG");

var $2TGnx = parcelRequire("2TGnx");
function $9695b13a18ca320a$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $e1vzu.jsx)((0, $3131c44a70c48b35$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $9695b13a18ca320a$export$7e7f5719ff4debb1() {
    return 0, $1a12cef9553d47e6$export$2e2bcd8739ae039;
}



var $vqOnh = parcelRequire("vqOnh");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $43320114867ac2e8$var$isDynamicSupport = typeof (0, $9695b13a18ca320a$export$db53682eef82cc11)({}) === 'function';
const $43320114867ac2e8$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $43320114867ac2e8$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $43320114867ac2e8$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $43320114867ac2e8$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$43320114867ac2e8$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $43320114867ac2e8$var$SELECTOR = 'mui-ecs';
const $43320114867ac2e8$var$staticStyles = (theme)=>{
    const result = $43320114867ac2e8$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$43320114867ac2e8$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$43320114867ac2e8$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$43320114867ac2e8$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $43320114867ac2e8$var$GlobalStyles = (0, $9695b13a18ca320a$export$db53682eef82cc11)($43320114867ac2e8$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$43320114867ac2e8$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$43320114867ac2e8$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $43320114867ac2e8$var$CssBaseline(inProps) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            $43320114867ac2e8$var$isDynamicSupport && /*#__PURE__*/ (0, $e1vzu.jsx)($43320114867ac2e8$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$43320114867ac2e8$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
                className: $43320114867ac2e8$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $43320114867ac2e8$export$2e2bcd8739ae039 = $43320114867ac2e8$var$CssBaseline;



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $803f8bad65bbae62$var$extendStatics = function(d, b) {
    $803f8bad65bbae62$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $803f8bad65bbae62$var$extendStatics(d, b);
};
function $803f8bad65bbae62$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $803f8bad65bbae62$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $803f8bad65bbae62$export$18ce0697a983be9b = function() {
    $803f8bad65bbae62$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $803f8bad65bbae62$export$18ce0697a983be9b.apply(this, arguments);
};
function $803f8bad65bbae62$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $803f8bad65bbae62$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $803f8bad65bbae62$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $803f8bad65bbae62$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $803f8bad65bbae62$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $803f8bad65bbae62$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $803f8bad65bbae62$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $803f8bad65bbae62$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $803f8bad65bbae62$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $803f8bad65bbae62$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $803f8bad65bbae62$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $803f8bad65bbae62$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $803f8bad65bbae62$export$45d3717a4c69092e(o, m, p);
}
function $803f8bad65bbae62$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $803f8bad65bbae62$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $803f8bad65bbae62$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($803f8bad65bbae62$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $803f8bad65bbae62$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $803f8bad65bbae62$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $803f8bad65bbae62$export$10c90e4f7922046c(v) {
    return this instanceof $803f8bad65bbae62$export$10c90e4f7922046c ? (this.v = v, this) : new $803f8bad65bbae62$export$10c90e4f7922046c(v);
}
function $803f8bad65bbae62$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $803f8bad65bbae62$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $803f8bad65bbae62$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $803f8bad65bbae62$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $803f8bad65bbae62$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $803f8bad65bbae62$export$19a8beecd37a4c45 === "function" ? $803f8bad65bbae62$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $803f8bad65bbae62$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $803f8bad65bbae62$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $803f8bad65bbae62$var$ownKeys = function(o) {
    $803f8bad65bbae62$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $803f8bad65bbae62$var$ownKeys(o);
};
function $803f8bad65bbae62$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $803f8bad65bbae62$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $803f8bad65bbae62$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $803f8bad65bbae62$var$__setModuleDefault(result, mod);
    return result;
}
function $803f8bad65bbae62$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $803f8bad65bbae62$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $803f8bad65bbae62$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $803f8bad65bbae62$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $803f8bad65bbae62$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $803f8bad65bbae62$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $803f8bad65bbae62$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $803f8bad65bbae62$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $803f8bad65bbae62$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $803f8bad65bbae62$export$2e2bcd8739ae039 = {
    __extends: $803f8bad65bbae62$export$a8ba968b8961cb8a,
    __assign: $803f8bad65bbae62$export$18ce0697a983be9b,
    __rest: $803f8bad65bbae62$export$3c9a16f847548506,
    __decorate: $803f8bad65bbae62$export$29e00dfd3077644b,
    __param: $803f8bad65bbae62$export$d5ad3fd78186038f,
    __esDecorate: $803f8bad65bbae62$export$3a84e1ae4e97e9b0,
    __runInitializers: $803f8bad65bbae62$export$d831c04e792af3d,
    __propKey: $803f8bad65bbae62$export$6a2a36740a146cb8,
    __setFunctionName: $803f8bad65bbae62$export$d1a06452d3489bc7,
    __metadata: $803f8bad65bbae62$export$f1db080c865becb9,
    __awaiter: $803f8bad65bbae62$export$1050f835b63b671e,
    __generator: $803f8bad65bbae62$export$67ebef60e6f28a6,
    __createBinding: $803f8bad65bbae62$export$45d3717a4c69092e,
    __exportStar: $803f8bad65bbae62$export$f33643c0debef087,
    __values: $803f8bad65bbae62$export$19a8beecd37a4c45,
    __read: $803f8bad65bbae62$export$8d051b38c9118094,
    __spread: $803f8bad65bbae62$export$afc72e2116322959,
    __spreadArrays: $803f8bad65bbae62$export$6388937ca91ccae8,
    __spreadArray: $803f8bad65bbae62$export$1216008129fb82ed,
    __await: $803f8bad65bbae62$export$10c90e4f7922046c,
    __asyncGenerator: $803f8bad65bbae62$export$e427f37a30a4de9b,
    __asyncDelegator: $803f8bad65bbae62$export$bbd80228419bb833,
    __asyncValues: $803f8bad65bbae62$export$e3b29a3d6162315f,
    __makeTemplateObject: $803f8bad65bbae62$export$4fb47efe1390b86f,
    __importStar: $803f8bad65bbae62$export$c21735bcef00d192,
    __importDefault: $803f8bad65bbae62$export$da59b14a69baef04,
    __classPrivateFieldGet: $803f8bad65bbae62$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $803f8bad65bbae62$export$d40a35129aaff81f,
    __classPrivateFieldIn: $803f8bad65bbae62$export$81fdc39f203e4e04,
    __addDisposableResource: $803f8bad65bbae62$export$88ac25d8e944e405,
    __disposeResources: $803f8bad65bbae62$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $803f8bad65bbae62$export$889dfb5d17574b0b
};



var $3QbnI = parcelRequire("3QbnI");

//
// Main
//
function $f97fb4942b6bddae$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $f97fb4942b6bddae$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $f97fb4942b6bddae$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $f97fb4942b6bddae$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $f97fb4942b6bddae$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $f97fb4942b6bddae$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $f97fb4942b6bddae$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $f97fb4942b6bddae$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $f97fb4942b6bddae$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $f97fb4942b6bddae$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $f97fb4942b6bddae$var$monadic : $f97fb4942b6bddae$var$variadic;
    return $f97fb4942b6bddae$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $f97fb4942b6bddae$var$strategyVariadic(fn, options) {
    return $f97fb4942b6bddae$var$assemble(fn, this, $f97fb4942b6bddae$var$variadic, options.cache.create(), options.serializer);
}
function $f97fb4942b6bddae$var$strategyMonadic(fn, options) {
    return $f97fb4942b6bddae$var$assemble(fn, this, $f97fb4942b6bddae$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $f97fb4942b6bddae$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $f97fb4942b6bddae$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$f97fb4942b6bddae$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$f97fb4942b6bddae$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $f97fb4942b6bddae$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $f97fb4942b6bddae$var$ObjectWithoutPrototypeCache();
    }
};
var $f97fb4942b6bddae$export$c5491a8691a23b9e = {
    variadic: $f97fb4942b6bddae$var$strategyVariadic,
    monadic: $f97fb4942b6bddae$var$strategyMonadic
};


function $9652946c4050d8ce$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $9652946c4050d8ce$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $9652946c4050d8ce$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $9652946c4050d8ce$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $9652946c4050d8ce$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $9652946c4050d8ce$export$3fae2929ed23c202(map, pl, field) {
    return $9652946c4050d8ce$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $9652946c4050d8ce$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $9652946c4050d8ce$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $9652946c4050d8ce$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $9652946c4050d8ce$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $9652946c4050d8ce$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $9652946c4050d8ce$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $9652946c4050d8ce$export$a99e4aaac79eeead = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
});
var $9652946c4050d8ce$export$b479a1a2d8754359 = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
});
var $9652946c4050d8ce$export$569bb3095db8432e = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
});
var $9652946c4050d8ce$export$e124bc7d23dd0e5a = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
});
var $9652946c4050d8ce$export$a1209f8c6068edc3 = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
});



var $11ec5b0cbf2cbf2f$exports = {};

$parcel$defineInteropFlag($11ec5b0cbf2cbf2f$exports);
$parcel$export($11ec5b0cbf2cbf2f$exports, "ErrorCode", function () { return $4155f8205c990ad5$export$d4e71bc0b80dc0fb; });
$parcel$export($11ec5b0cbf2cbf2f$exports, "FormatError", function () { return $4155f8205c990ad5$export$7369836851cc1329; });
$parcel$export($11ec5b0cbf2cbf2f$exports, "isFormatXMLElementFn", function () { return $c1e6211c879bb1e5$export$df0c12a2d414a163; });

$parcel$export($11ec5b0cbf2cbf2f$exports, "IntlMessageFormat", function () { return $f3c6aa574affa4d1$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 


var $3bac08158faa47c7$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($3bac08158faa47c7$export$896afd8541959ee5 || ($3bac08158faa47c7$export$896afd8541959ee5 = {}));




var $bc39f8568750a8cb$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($bc39f8568750a8cb$export$b87f371cbc396fcf || ($bc39f8568750a8cb$export$b87f371cbc396fcf = {}));
var $bc39f8568750a8cb$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($bc39f8568750a8cb$export$906452485466fa53 || ($bc39f8568750a8cb$export$906452485466fa53 = {}));
function $bc39f8568750a8cb$export$cfa10c5697238752(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.literal;
}
function $bc39f8568750a8cb$export$4f55724281bdfaf9(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.argument;
}
function $bc39f8568750a8cb$export$e11187b219e191e1(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.number;
}
function $bc39f8568750a8cb$export$32d811605da75f40(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.date;
}
function $bc39f8568750a8cb$export$34ec46f596b1702f(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.time;
}
function $bc39f8568750a8cb$export$dcfe1c11d168b5a1(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.select;
}
function $bc39f8568750a8cb$export$6c796d116f0a4fbc(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.plural;
}
function $bc39f8568750a8cb$export$c0ece297bdd0c082(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.pound;
}
function $bc39f8568750a8cb$export$5c83de34745812b(el) {
    return el.type === $bc39f8568750a8cb$export$b87f371cbc396fcf.tag;
}
function $bc39f8568750a8cb$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $bc39f8568750a8cb$export$906452485466fa53.number);
}
function $bc39f8568750a8cb$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $bc39f8568750a8cb$export$906452485466fa53.dateTime);
}
function $bc39f8568750a8cb$export$f0ac572c1121c662(value) {
    return {
        type: $bc39f8568750a8cb$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $bc39f8568750a8cb$export$425e864b0ba114f1(value, style) {
    return {
        type: $bc39f8568750a8cb$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $2eb408ffe0156587$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $2eb408ffe0156587$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $a694fb5100e748a2$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $a694fb5100e748a2$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($a694fb5100e748a2$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



// @generated from regex-gen.ts
var $abd213a87eef1a0e$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $dee43d92e83707de$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $abd213a87eef1a0e$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $dee43d92e83707de$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $dee43d92e83707de$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $dee43d92e83707de$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $dee43d92e83707de$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $dee43d92e83707de$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $dee43d92e83707de$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($dee43d92e83707de$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $dee43d92e83707de$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $dee43d92e83707de$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$dee43d92e83707de$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $dee43d92e83707de$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $dee43d92e83707de$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $dee43d92e83707de$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $dee43d92e83707de$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, all), $dee43d92e83707de$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, all), $dee43d92e83707de$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($dee43d92e83707de$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($dee43d92e83707de$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($dee43d92e83707de$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($dee43d92e83707de$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, result), $dee43d92e83707de$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($dee43d92e83707de$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, result), $dee43d92e83707de$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $dee43d92e83707de$var$parseSign(token.stem);
        if (signOpts) result = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $dee43d92e83707de$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $8a9afd52b3dc6f7b$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $b8da3be4be0f0e34$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $b8da3be4be0f0e34$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $b8da3be4be0f0e34$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $8a9afd52b3dc6f7b$export$a8c9209db4084317)[regionTag || ''] || (0, $8a9afd52b3dc6f7b$export$a8c9209db4084317)[languageTag || ''] || (0, $8a9afd52b3dc6f7b$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $8a9afd52b3dc6f7b$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $7d1a3b67a7a55ede$var$_a;
var $7d1a3b67a7a55ede$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $2eb408ffe0156587$export$523451f94304dd6c).source, "*"));
var $7d1a3b67a7a55ede$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $2eb408ffe0156587$export$523451f94304dd6c).source, "*$"));
function $7d1a3b67a7a55ede$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $7d1a3b67a7a55ede$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $7d1a3b67a7a55ede$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $7d1a3b67a7a55ede$var$hasNativeFromEntries = !!Object.fromEntries;
var $7d1a3b67a7a55ede$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $7d1a3b67a7a55ede$var$hasTrimStart = !!String.prototype.trimStart;
var $7d1a3b67a7a55ede$var$hasTrimEnd = !!String.prototype.trimEnd;
var $7d1a3b67a7a55ede$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $7d1a3b67a7a55ede$var$isSafeInteger = $7d1a3b67a7a55ede$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $7d1a3b67a7a55ede$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $7d1a3b67a7a55ede$var$re = $7d1a3b67a7a55ede$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $7d1a3b67a7a55ede$var$REGEX_SUPPORTS_U_AND_Y = (($7d1a3b67a7a55ede$var$_a = $7d1a3b67a7a55ede$var$re.exec('a')) === null || $7d1a3b67a7a55ede$var$_a === void 0 ? void 0 : $7d1a3b67a7a55ede$var$_a[0]) === 'a';
} catch (_) {
    $7d1a3b67a7a55ede$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $7d1a3b67a7a55ede$var$startsWith = $7d1a3b67a7a55ede$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $7d1a3b67a7a55ede$var$fromCodePoint = $7d1a3b67a7a55ede$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $7d1a3b67a7a55ede$var$fromEntries = // native
$7d1a3b67a7a55ede$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $7d1a3b67a7a55ede$var$codePointAt = $7d1a3b67a7a55ede$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $7d1a3b67a7a55ede$var$trimStart = $7d1a3b67a7a55ede$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($7d1a3b67a7a55ede$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $7d1a3b67a7a55ede$var$trimEnd = $7d1a3b67a7a55ede$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($7d1a3b67a7a55ede$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $7d1a3b67a7a55ede$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $7d1a3b67a7a55ede$var$matchIdentifierAtIndex;
if ($7d1a3b67a7a55ede$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $7d1a3b67a7a55ede$var$IDENTIFIER_PREFIX_RE_1 = $7d1a3b67a7a55ede$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $7d1a3b67a7a55ede$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $7d1a3b67a7a55ede$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $7d1a3b67a7a55ede$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$7d1a3b67a7a55ede$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $7d1a3b67a7a55ede$var$codePointAt(s, index);
        if (c === undefined || $7d1a3b67a7a55ede$var$_isWhiteSpace(c) || $7d1a3b67a7a55ede$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $7d1a3b67a7a55ede$var$fromCodePoint.apply(void 0, match);
};
var $7d1a3b67a7a55ede$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).pound,
                    location: $7d1a3b67a7a55ede$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $7d1a3b67a7a55ede$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $7d1a3b67a7a55ede$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $7d1a3b67a7a55ede$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$7d1a3b67a7a55ede$var$_isAlpha(this.char())) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).INVALID_TAG, $7d1a3b67a7a55ede$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $7d1a3b67a7a55ede$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).INVALID_TAG, $7d1a3b67a7a55ede$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $7d1a3b67a7a55ede$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).UNCLOSED_TAG, $7d1a3b67a7a55ede$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).INVALID_TAG, $7d1a3b67a7a55ede$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $7d1a3b67a7a55ede$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $7d1a3b67a7a55ede$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$7d1a3b67a7a55ede$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $7d1a3b67a7a55ede$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $7d1a3b67a7a55ede$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EMPTY_ARGUMENT, $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).MALFORMED_ARGUMENT, $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).MALFORMED_ARGUMENT, $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $7d1a3b67a7a55ede$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $7d1a3b67a7a55ede$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $7d1a3b67a7a55ede$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $7d1a3b67a7a55ede$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $7d1a3b67a7a55ede$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $7d1a3b67a7a55ede$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $7d1a3b67a7a55ede$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $7d1a3b67a7a55ede$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $b8da3be4be0f0e34$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $bc39f8568750a8cb$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $a694fb5100e748a2$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).date : (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).date : (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $7d1a3b67a7a55ede$var$createLocation(typeEndPosition_1, (0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $7d1a3b67a7a55ede$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $3bac08158faa47c7$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $7d1a3b67a7a55ede$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $7d1a3b67a7a55ede$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $7d1a3b67a7a55ede$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $7d1a3b67a7a55ede$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $dee43d92e83707de$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $bc39f8568750a8cb$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $dee43d92e83707de$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $3bac08158faa47c7$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $7d1a3b67a7a55ede$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $3bac08158faa47c7$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $3bac08158faa47c7$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $7d1a3b67a7a55ede$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $7d1a3b67a7a55ede$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $3bac08158faa47c7$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $7d1a3b67a7a55ede$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $3bac08158faa47c7$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $7d1a3b67a7a55ede$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $7d1a3b67a7a55ede$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$7d1a3b67a7a55ede$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $7d1a3b67a7a55ede$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($7d1a3b67a7a55ede$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $7d1a3b67a7a55ede$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $7d1a3b67a7a55ede$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $7d1a3b67a7a55ede$var$_isAlphaOrSlash(codepoint) {
    return $7d1a3b67a7a55ede$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $7d1a3b67a7a55ede$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $7d1a3b67a7a55ede$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $7d1a3b67a7a55ede$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $5c613e4b32d2306e$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $bc39f8568750a8cb$export$dcfe1c11d168b5a1)(el) || (0, $bc39f8568750a8cb$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $5c613e4b32d2306e$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $bc39f8568750a8cb$export$e11187b219e191e1)(el) && (0, $bc39f8568750a8cb$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $bc39f8568750a8cb$export$32d811605da75f40)(el) || (0, $bc39f8568750a8cb$export$34ec46f596b1702f)(el)) && (0, $bc39f8568750a8cb$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $bc39f8568750a8cb$export$5c83de34745812b)(el)) $5c613e4b32d2306e$var$pruneLocation(el.children);
    });
}
function $5c613e4b32d2306e$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $803f8bad65bbae62$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $7d1a3b67a7a55ede$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $3bac08158faa47c7$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $5c613e4b32d2306e$var$pruneLocation(result.val);
    return result.val;
}
var $5c613e4b32d2306e$export$d3c1bfa0f7d806e9 = (0, $7d1a3b67a7a55ede$export$7acfa6ed01010e37);




var $4155f8205c990ad5$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($4155f8205c990ad5$export$d4e71bc0b80dc0fb || ($4155f8205c990ad5$export$d4e71bc0b80dc0fb = {}));
var $4155f8205c990ad5$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $4155f8205c990ad5$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $4155f8205c990ad5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($4155f8205c990ad5$export$7369836851cc1329);
var $4155f8205c990ad5$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $4155f8205c990ad5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($4155f8205c990ad5$export$7369836851cc1329);
var $4155f8205c990ad5$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $4155f8205c990ad5$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($4155f8205c990ad5$export$7369836851cc1329);


var $c1e6211c879bb1e5$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($c1e6211c879bb1e5$export$49694c2877b44c57 || ($c1e6211c879bb1e5$export$49694c2877b44c57 = {}));
function $c1e6211c879bb1e5$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $c1e6211c879bb1e5$export$49694c2877b44c57.literal || part.type !== $c1e6211c879bb1e5$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $c1e6211c879bb1e5$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $c1e6211c879bb1e5$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $bc39f8568750a8cb$export$cfa10c5697238752)(els[0])) return [
        {
            type: $c1e6211c879bb1e5$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $bc39f8568750a8cb$export$cfa10c5697238752)(el)) {
            result.push({
                type: $c1e6211c879bb1e5$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $bc39f8568750a8cb$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $c1e6211c879bb1e5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $4155f8205c990ad5$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $bc39f8568750a8cb$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $c1e6211c879bb1e5$export$49694c2877b44c57.literal : $c1e6211c879bb1e5$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $bc39f8568750a8cb$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $bc39f8568750a8cb$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $c1e6211c879bb1e5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $bc39f8568750a8cb$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $bc39f8568750a8cb$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $c1e6211c879bb1e5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $bc39f8568750a8cb$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $bc39f8568750a8cb$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $c1e6211c879bb1e5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $bc39f8568750a8cb$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$c1e6211c879bb1e5$export$df0c12a2d414a163(formatFn)) throw new (0, $4155f8205c990ad5$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $c1e6211c879bb1e5$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $c1e6211c879bb1e5$export$49694c2877b44c57.literal : $c1e6211c879bb1e5$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $bc39f8568750a8cb$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $4155f8205c990ad5$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c1e6211c879bb1e5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $bc39f8568750a8cb$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $4155f8205c990ad5$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $4155f8205c990ad5$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $4155f8205c990ad5$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c1e6211c879bb1e5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $c1e6211c879bb1e5$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $f3c6aa574affa4d1$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $f3c6aa574affa4d1$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $f3c6aa574affa4d1$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, defaultConfig));
}
function $f3c6aa574affa4d1$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $f3c6aa574affa4d1$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $f3c6aa574affa4d1$var$createFastMemoizeCache(cache.number),
            strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $f3c6aa574affa4d1$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $f3c6aa574affa4d1$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
        })
    };
}
var $f3c6aa574affa4d1$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $c1e6211c879bb1e5$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $c1e6211c879bb1e5$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $803f8bad65bbae62$export$3c9a16f847548506)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $f3c6aa574affa4d1$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $f3c6aa574affa4d1$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $5c613e4b32d2306e$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $11ec5b0cbf2cbf2f$export$2e2bcd8739ae039 = (0, $f3c6aa574affa4d1$export$d342343268debc40);




var $77f3caa7b3f1f5a1$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($77f3caa7b3f1f5a1$export$557d6acb76e8a244 || ($77f3caa7b3f1f5a1$export$557d6acb76e8a244 = {}));
var $77f3caa7b3f1f5a1$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $77f3caa7b3f1f5a1$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $77f3caa7b3f1f5a1$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($77f3caa7b3f1f5a1$export$c016d36112f6ddf8);
var $77f3caa7b3f1f5a1$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $77f3caa7b3f1f5a1$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($77f3caa7b3f1f5a1$export$c016d36112f6ddf8);
var $77f3caa7b3f1f5a1$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $77f3caa7b3f1f5a1$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($77f3caa7b3f1f5a1$export$c016d36112f6ddf8);
var $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $77f3caa7b3f1f5a1$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($77f3caa7b3f1f5a1$export$c016d36112f6ddf8);
var $77f3caa7b3f1f5a1$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($77f3caa7b3f1f5a1$export$e3b7eee1dbc44895);
var $77f3caa7b3f1f5a1$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $77f3caa7b3f1f5a1$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($77f3caa7b3f1f5a1$export$c016d36112f6ddf8);


function $b1dd18b1cc667557$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b1dd18b1cc667557$var$defaultErrorHandler = function(error) {};
var $b1dd18b1cc667557$var$defaultWarnHandler = function(warning) {};
var $b1dd18b1cc667557$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b1dd18b1cc667557$var$defaultErrorHandler,
    onWarn: $b1dd18b1cc667557$var$defaultWarnHandler
};
function $b1dd18b1cc667557$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b1dd18b1cc667557$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b1dd18b1cc667557$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b1dd18b1cc667557$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $b1dd18b1cc667557$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $b1dd18b1cc667557$var$createFastMemoizeCache(cache.number),
        strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $b1dd18b1cc667557$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $f3c6aa574affa4d1$export$d342343268debc40)(message, locales, overrideFormats, (0, $803f8bad65bbae62$export$18ce0697a983be9b)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b1dd18b1cc667557$var$createFastMemoizeCache(cache.message),
            strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $b1dd18b1cc667557$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $b1dd18b1cc667557$var$createFastMemoizeCache(cache.list),
            strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $f97fb4942b6bddae$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $b1dd18b1cc667557$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $f97fb4942b6bddae$export$c5491a8691a23b9e).variadic
        })
    };
}
function $b1dd18b1cc667557$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $77f3caa7b3f1f5a1$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $df74ec6c7358c66e$export$45c4bbf6e55bba1f(intl) {
    (0, $9652946c4050d8ce$export$f5708dca728d7177)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $df74ec6c7358c66e$export$b52f8d6fc0d47415 = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, (0, $b1dd18b1cc667557$export$b52f8d6fc0d47415)), {
    textComponent: $3QbnI.Fragment
});
function $df74ec6c7358c66e$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($3QbnI.Children.toArray(parts));
    };
}
function $df74ec6c7358c66e$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}




var $8FL51 = parcelRequire("8FL51");

var $3QbnI = parcelRequire("3QbnI");

function $d424b4c5f2093f25$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $d424b4c5f2093f25$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $3QbnI.createContext(null)) : $3QbnI.createContext(null);
var $d424b4c5f2093f25$var$IntlConsumer = $d424b4c5f2093f25$var$IntlContext.Consumer, $d424b4c5f2093f25$var$IntlProvider = $d424b4c5f2093f25$var$IntlContext.Provider;
var $d424b4c5f2093f25$export$2881499e37b75b9a = $d424b4c5f2093f25$var$IntlProvider;
var $d424b4c5f2093f25$export$841858b892ce1f4c = $d424b4c5f2093f25$var$IntlContext;
function $d424b4c5f2093f25$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $3QbnI.createElement($d424b4c5f2093f25$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $df74ec6c7358c66e$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $3QbnI.createElement(WrappedComponent, (0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($d424b4c5f2093f25$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(// @ts-expect-error
    $3QbnI.forwardRef(function(props, ref) {
        return $3QbnI.createElement(WithIntl, (0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(WithIntl, WrappedComponent);
}


function $e0606c1bc07ea566$export$2e2bcd8739ae039() {
    var intl = $3QbnI.useContext((0, $d424b4c5f2093f25$export$841858b892ce1f4c));
    (0, $df74ec6c7358c66e$export$45c4bbf6e55bba1f)(intl);
    return intl;
}



var $3QbnI = parcelRequire("3QbnI");

var $eTLbi = parcelRequire("eTLbi");
'use client';
const $d7fe6407b009814b$var$c = (e)=>"number" == typeof e && !isNaN(e), $d7fe6407b009814b$var$d = (e)=>"string" == typeof e, $d7fe6407b009814b$var$u = (e)=>"function" == typeof e, $d7fe6407b009814b$var$p = (e)=>$d7fe6407b009814b$var$d(e) || $d7fe6407b009814b$var$u(e) ? e : null, $d7fe6407b009814b$var$m = (e)=>(0, $3QbnI.isValidElement)(e) || $d7fe6407b009814b$var$d(e) || $d7fe6407b009814b$var$u(e) || $d7fe6407b009814b$var$c(e);
function $d7fe6407b009814b$export$184cca501f1aed7f(e, t, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = e;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(t, n);
        });
    });
}
function $d7fe6407b009814b$export$3ff7dc44d332d222(t) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = t;
    return function(t) {
        let { children: d, position: u, preventExitTransition: p, done: m, nodeRef: g, isIn: y, playToast: v } = t;
        const h = i ? `${a}--${u}` : a, T = i ? `${r}--${u}` : r, E = (0, $3QbnI.useRef)(0);
        return (0, $3QbnI.useLayoutEffect)(()=>{
            const e = g.current, t = h.split(" "), n = (o)=>{
                o.target === g.current && (v(), e.removeEventListener("animationend", n), e.removeEventListener("animationcancel", n), 0 === E.current && "animationcancel" !== o.type && e.classList.remove(...t));
            };
            e.classList.add(...t), e.addEventListener("animationend", n), e.addEventListener("animationcancel", n);
        }, []), (0, $3QbnI.useEffect)(()=>{
            const e = g.current, t = ()=>{
                e.removeEventListener("animationend", t), l ? $d7fe6407b009814b$export$184cca501f1aed7f(e, m, c) : m();
            };
            y || (p ? t() : (E.current = 1, e.className += ` ${T}`, e.addEventListener("animationend", t)));
        }, [
            y
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Fragment, null, d);
    };
}
function $d7fe6407b009814b$var$y(e, t) {
    return null != e ? {
        content: e.content,
        containerId: e.props.containerId,
        id: e.props.toastId,
        theme: e.props.theme,
        type: e.props.type,
        data: e.props.data || {},
        isLoading: e.props.isLoading,
        icon: e.props.icon,
        status: t
    } : {};
}
const $d7fe6407b009814b$var$v = new Map;
let $d7fe6407b009814b$var$h = [];
const $d7fe6407b009814b$var$T = new Set, $d7fe6407b009814b$var$E = (e)=>$d7fe6407b009814b$var$T.forEach((t)=>t(e)), $d7fe6407b009814b$var$b = ()=>$d7fe6407b009814b$var$v.size > 0;
function $d7fe6407b009814b$var$I(e, t) {
    var n;
    if (t) return !(null == (n = $d7fe6407b009814b$var$v.get(t)) || !n.isToastActive(e));
    let o = !1;
    return $d7fe6407b009814b$var$v.forEach((t)=>{
        t.isToastActive(e) && (o = !0);
    }), o;
}
function $d7fe6407b009814b$var$_(e, t) {
    $d7fe6407b009814b$var$m(e) && ($d7fe6407b009814b$var$b() || $d7fe6407b009814b$var$h.push({
        content: e,
        options: t
    }), $d7fe6407b009814b$var$v.forEach((n)=>{
        n.buildToast(e, t);
    }));
}
function $d7fe6407b009814b$var$C(e, t) {
    $d7fe6407b009814b$var$v.forEach((n)=>{
        null != t && null != t && t.containerId ? (null == t ? void 0 : t.containerId) === n.id && n.toggle(e, null == t ? void 0 : t.id) : n.toggle(e, null == t ? void 0 : t.id);
    });
}
function $d7fe6407b009814b$export$b262e13ca2dd2381(e) {
    const { subscribe: o, getSnapshot: s, setProps: i } = (0, $3QbnI.useRef)(function(e) {
        const n = e.containerId || 1;
        return {
            subscribe (o) {
                const s = function(e, n, o) {
                    let s = 1, r = 0, i = [], l = [], f = [], g = n;
                    const v = new Map, h = new Set, T = ()=>{
                        f = Array.from(v.values()), h.forEach((e)=>e());
                    }, E = (e)=>{
                        l = null == e ? [] : l.filter((t)=>t !== e), T();
                    }, b = (e)=>{
                        const { toastId: n, onOpen: s, updateId: a, children: r } = e.props, i = null == a;
                        e.staleId && v.delete(e.staleId), v.set(n, e), l = [
                            ...l,
                            e.props.toastId
                        ].filter((t)=>t !== e.staleId), T(), o($d7fe6407b009814b$var$y(e, i ? "added" : "updated")), i && $d7fe6407b009814b$var$u(s) && s((0, $3QbnI.isValidElement)(r) && r.props);
                    };
                    return {
                        id: e,
                        props: g,
                        observe: (e)=>(h.add(e), ()=>h.delete(e)),
                        toggle: (e, t)=>{
                            v.forEach((n)=>{
                                null != t && t !== n.props.toastId || $d7fe6407b009814b$var$u(n.toggle) && n.toggle(e);
                            });
                        },
                        removeToast: E,
                        toasts: v,
                        clearQueue: ()=>{
                            r -= i.length, i = [];
                        },
                        buildToast: (n, l)=>{
                            if (((t)=>{
                                let { containerId: n, toastId: o, updateId: s } = t;
                                const a = n ? n !== e : 1 !== e, r = v.has(o) && null == s;
                                return a || r;
                            })(l)) return;
                            const { toastId: f, updateId: h, data: I, staleId: _, delay: C } = l, L = ()=>{
                                E(f);
                            }, N = null == h;
                            N && r++;
                            const $ = {
                                ...g,
                                style: g.toastStyle,
                                key: s++,
                                ...Object.fromEntries(Object.entries(l).filter((e)=>{
                                    let [t, n] = e;
                                    return null != n;
                                })),
                                toastId: f,
                                updateId: h,
                                data: I,
                                closeToast: L,
                                isIn: !1,
                                className: $d7fe6407b009814b$var$p(l.className || g.toastClassName),
                                bodyClassName: $d7fe6407b009814b$var$p(l.bodyClassName || g.bodyClassName),
                                progressClassName: $d7fe6407b009814b$var$p(l.progressClassName || g.progressClassName),
                                autoClose: !l.isLoading && (w = l.autoClose, k = g.autoClose, !1 === w || $d7fe6407b009814b$var$c(w) && w > 0 ? w : k),
                                deleteToast () {
                                    const e = v.get(f), { onClose: n, children: s } = e.props;
                                    $d7fe6407b009814b$var$u(n) && n((0, $3QbnI.isValidElement)(s) && s.props), o($d7fe6407b009814b$var$y(e, "removed")), v.delete(f), r--, r < 0 && (r = 0), i.length > 0 ? b(i.shift()) : T();
                                }
                            };
                            var w, k;
                            $.closeButton = g.closeButton, !1 === l.closeButton || $d7fe6407b009814b$var$m(l.closeButton) ? $.closeButton = l.closeButton : !0 === l.closeButton && ($.closeButton = !$d7fe6407b009814b$var$m(g.closeButton) || g.closeButton);
                            let P = n;
                            (0, $3QbnI.isValidElement)(n) && !$d7fe6407b009814b$var$d(n.type) ? P = (0, $3QbnI.cloneElement)(n, {
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }) : $d7fe6407b009814b$var$u(n) && (P = n({
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }));
                            const M = {
                                content: P,
                                props: $,
                                staleId: _
                            };
                            g.limit && g.limit > 0 && r > g.limit && N ? i.push(M) : $d7fe6407b009814b$var$c(C) ? setTimeout(()=>{
                                b(M);
                            }, C) : b(M);
                        },
                        setProps (e) {
                            g = e;
                        },
                        setToggle: (e, t)=>{
                            v.get(e).toggle = t;
                        },
                        isToastActive: (e)=>l.some((t)=>t === e),
                        getSnapshot: ()=>f
                    };
                }(n, e, $d7fe6407b009814b$var$E);
                $d7fe6407b009814b$var$v.set(n, s);
                const r = s.observe(o);
                return $d7fe6407b009814b$var$h.forEach((e)=>$d7fe6407b009814b$var$_(e.content, e.options)), $d7fe6407b009814b$var$h = [], ()=>{
                    r(), $d7fe6407b009814b$var$v.delete(n);
                };
            },
            setProps (e) {
                var t;
                null == (t = $d7fe6407b009814b$var$v.get(n)) || t.setProps(e);
            },
            getSnapshot () {
                var e;
                return null == (e = $d7fe6407b009814b$var$v.get(n)) ? void 0 : e.getSnapshot();
            }
        };
    }(e)).current;
    i(e);
    const l = (0, $3QbnI.useSyncExternalStore)(o, s, s);
    return {
        getToastToRender: function(t) {
            if (!l) return [];
            const n = new Map;
            return e.newestOnTop && l.reverse(), l.forEach((e)=>{
                const { position: t } = e.props;
                n.has(t) || n.set(t, []), n.get(t).push(e);
            }), Array.from(n, (e)=>t(e[0], e[1]));
        },
        isToastActive: $d7fe6407b009814b$var$I,
        count: null == l ? void 0 : l.length
    };
}
function $d7fe6407b009814b$export$a407b657d3044108(e) {
    const [t, o] = (0, $3QbnI.useState)(!1), [a, r] = (0, $3QbnI.useState)(!1), l = (0, $3QbnI.useRef)(null), c = (0, $3QbnI.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: u, closeToast: p, onClick: m, closeOnClick: f } = e;
    var g, y;
    function h() {
        o(!0);
    }
    function T() {
        o(!1);
    }
    function E(n) {
        const o = l.current;
        c.canDrag && o && (c.didMove = !0, t && T(), c.delta = "x" === e.draggableDirection ? n.clientX - c.start : n.clientY - c.start, c.start !== n.clientX && (c.canCloseOnClick = !1), o.style.transform = `translate3d(${"x" === e.draggableDirection ? `${c.delta}px, var(--y)` : `0, calc(${c.delta}px + var(--y))`},0)`, o.style.opacity = "" + (1 - Math.abs(c.delta / c.removalDistance)));
    }
    function b() {
        document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", b);
        const t = l.current;
        if (c.canDrag && c.didMove && t) {
            if (c.canDrag = !1, Math.abs(c.delta) > c.removalDistance) return r(!0), e.closeToast(), void e.collapseAll();
            t.style.transition = "transform 0.2s, opacity 0.2s", t.style.removeProperty("transform"), t.style.removeProperty("opacity");
        }
    }
    null == (y = $d7fe6407b009814b$var$v.get((g = {
        id: e.toastId,
        containerId: e.containerId,
        fn: o
    }).containerId || 1)) || y.setToggle(g.id, g.fn), (0, $3QbnI.useEffect)(()=>{
        if (e.pauseOnFocusLoss) return document.hasFocus() || T(), window.addEventListener("focus", h), window.addEventListener("blur", T), ()=>{
            window.removeEventListener("focus", h), window.removeEventListener("blur", T);
        };
    }, [
        e.pauseOnFocusLoss
    ]);
    const I = {
        onPointerDown: function(t) {
            if (!0 === e.draggable || e.draggable === t.pointerType) {
                c.didMove = !1, document.addEventListener("pointermove", E), document.addEventListener("pointerup", b);
                const n = l.current;
                c.canCloseOnClick = !0, c.canDrag = !0, n.style.transition = "none", "x" === e.draggableDirection ? (c.start = t.clientX, c.removalDistance = n.offsetWidth * (e.draggablePercent / 100)) : (c.start = t.clientY, c.removalDistance = n.offsetHeight * (80 === e.draggablePercent ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
            }
        },
        onPointerUp: function(t) {
            const { top: n, bottom: o, left: s, right: a } = l.current.getBoundingClientRect();
            "touchend" !== t.nativeEvent.type && e.pauseOnHover && t.clientX >= s && t.clientX <= a && t.clientY >= n && t.clientY <= o ? T() : h();
        }
    };
    return d && u && (I.onMouseEnter = T, e.stacked || (I.onMouseLeave = h)), f && (I.onClick = (e)=>{
        m && m(e), c.canCloseOnClick && p();
    }), {
        playToast: h,
        pauseToast: T,
        isRunning: t,
        preventExitTransition: a,
        toastRef: l,
        eventHandlers: I
    };
}
function $d7fe6407b009814b$var$$(t) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: c, controlledProgress: d, progress: p, rtl: m, isIn: f, theme: g } = t;
    const y = r || d && 0 === p, v = {
        ...c,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    d && (v.transform = `scaleX(${p})`);
    const h = (0, $eTLbi.default)("Toastify__progress-bar", d ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $d7fe6407b009814b$var$u(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: h
    }) : (0, $eTLbi.default)(h, i), E = {
        [d && p >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: d && p < 1 ? null : ()=>{
            f && s();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${a}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
        role: "progressbar",
        "aria-hidden": y ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: v,
        ...E
    }));
}
let $d7fe6407b009814b$var$w = 1;
const $d7fe6407b009814b$var$k = ()=>"" + $d7fe6407b009814b$var$w++;
function $d7fe6407b009814b$var$P(e) {
    return e && ($d7fe6407b009814b$var$d(e.toastId) || $d7fe6407b009814b$var$c(e.toastId)) ? e.toastId : $d7fe6407b009814b$var$k();
}
function $d7fe6407b009814b$var$M(e, t) {
    return $d7fe6407b009814b$var$_(e, t), t.toastId;
}
function $d7fe6407b009814b$var$x(e, t) {
    return {
        ...t,
        type: t && t.type || e,
        toastId: $d7fe6407b009814b$var$P(t)
    };
}
function $d7fe6407b009814b$var$A(e) {
    return (t, n)=>$d7fe6407b009814b$var$M(t, $d7fe6407b009814b$var$x(e, n));
}
function $d7fe6407b009814b$export$b410431fab84fa58(e, t) {
    return $d7fe6407b009814b$var$M(e, $d7fe6407b009814b$var$x("default", t));
}
$d7fe6407b009814b$export$b410431fab84fa58.loading = (e, t)=>$d7fe6407b009814b$var$M(e, $d7fe6407b009814b$var$x("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...t
    })), $d7fe6407b009814b$export$b410431fab84fa58.promise = function(e, t, n) {
    let o, { pending: s, error: a, success: r } = t;
    s && (o = $d7fe6407b009814b$var$d(s) ? $d7fe6407b009814b$export$b410431fab84fa58.loading(s, n) : $d7fe6407b009814b$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (e, t, s)=>{
        if (null == t) return void $d7fe6407b009814b$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: e,
            ...i,
            ...n,
            data: s
        }, r = $d7fe6407b009814b$var$d(t) ? {
            render: t
        } : t;
        return o ? $d7fe6407b009814b$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $d7fe6407b009814b$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $d7fe6407b009814b$var$u(e) ? e() : e;
    return c.then((e)=>l("success", r, e)).catch((e)=>l("error", a, e)), c;
}, $d7fe6407b009814b$export$b410431fab84fa58.success = $d7fe6407b009814b$var$A("success"), $d7fe6407b009814b$export$b410431fab84fa58.info = $d7fe6407b009814b$var$A("info"), $d7fe6407b009814b$export$b410431fab84fa58.error = $d7fe6407b009814b$var$A("error"), $d7fe6407b009814b$export$b410431fab84fa58.warning = $d7fe6407b009814b$var$A("warning"), $d7fe6407b009814b$export$b410431fab84fa58.warn = $d7fe6407b009814b$export$b410431fab84fa58.warning, $d7fe6407b009814b$export$b410431fab84fa58.dark = (e, t)=>$d7fe6407b009814b$var$M(e, $d7fe6407b009814b$var$x("default", {
        theme: "dark",
        ...t
    })), $d7fe6407b009814b$export$b410431fab84fa58.dismiss = function(e) {
    !function(e) {
        var t;
        if ($d7fe6407b009814b$var$b()) {
            if (null == e || $d7fe6407b009814b$var$d(t = e) || $d7fe6407b009814b$var$c(t)) $d7fe6407b009814b$var$v.forEach((t)=>{
                t.removeToast(e);
            });
            else if (e && ("containerId" in e || "id" in e)) {
                const t = $d7fe6407b009814b$var$v.get(e.containerId);
                t ? t.removeToast(e.id) : $d7fe6407b009814b$var$v.forEach((t)=>{
                    t.removeToast(e.id);
                });
            }
        } else $d7fe6407b009814b$var$h = $d7fe6407b009814b$var$h.filter((t)=>null != e && t.options.toastId !== e);
    }(e);
}, $d7fe6407b009814b$export$b410431fab84fa58.clearWaitingQueue = function(e) {
    void 0 === e && (e = {}), $d7fe6407b009814b$var$v.forEach((t)=>{
        !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
    });
}, $d7fe6407b009814b$export$b410431fab84fa58.isActive = $d7fe6407b009814b$var$I, $d7fe6407b009814b$export$b410431fab84fa58.update = function(e, t) {
    void 0 === t && (t = {});
    const n = ((e, t)=>{
        var n;
        let { containerId: o } = t;
        return null == (n = $d7fe6407b009814b$var$v.get(o || 1)) ? void 0 : n.toasts.get(e);
    })(e, t);
    if (n) {
        const { props: o, content: s } = n, a = {
            delay: 100,
            ...o,
            ...t,
            toastId: t.toastId || e,
            updateId: $d7fe6407b009814b$var$k()
        };
        a.toastId !== e && (a.staleId = e);
        const r = a.render || s;
        delete a.render, $d7fe6407b009814b$var$M(r, a);
    }
}, $d7fe6407b009814b$export$b410431fab84fa58.done = (e)=>{
    $d7fe6407b009814b$export$b410431fab84fa58.update(e, {
        progress: 1
    });
}, $d7fe6407b009814b$export$b410431fab84fa58.onChange = function(e) {
    return $d7fe6407b009814b$var$T.add(e), ()=>{
        $d7fe6407b009814b$var$T.delete(e);
    };
}, $d7fe6407b009814b$export$b410431fab84fa58.play = (e)=>$d7fe6407b009814b$var$C(!0, e), $d7fe6407b009814b$export$b410431fab84fa58.pause = (e)=>$d7fe6407b009814b$var$C(!1, e);
const $d7fe6407b009814b$var$O = "undefined" != typeof window ? (0, $3QbnI.useLayoutEffect) : (0, $3QbnI.useEffect), $d7fe6407b009814b$var$D = (t)=>{
    let { theme: n, type: o, isLoading: s, ...a } = t;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...a
    });
}, $d7fe6407b009814b$export$4f13f83fd8bb1dac = {
    info: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d7fe6407b009814b$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d7fe6407b009814b$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d7fe6407b009814b$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d7fe6407b009814b$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
}, $d7fe6407b009814b$var$R = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i, playToast: c } = $d7fe6407b009814b$export$a407b657d3044108(n), { closeButton: d, children: p, autoClose: m, onClick: f, type: g, hideProgressBar: y, closeToast: v, transition: h, position: T, className: E, style: b, bodyClassName: I, bodyStyle: _, progressClassName: C, progressStyle: L, updateId: w, role: k, progress: P, rtl: M, toastId: x, deleteToast: A, isIn: B, isLoading: O, closeOnClick: D, theme: R } = n, S = (0, $eTLbi.default)("Toastify__toast", `Toastify__toast-theme--${R}`, `Toastify__toast--${g}`, {
        "Toastify__toast--rtl": M
    }, {
        "Toastify__toast--close-on-click": D
    }), H = $d7fe6407b009814b$var$u(E) ? E({
        rtl: M,
        position: T,
        type: g,
        defaultClassName: S
    }) : (0, $eTLbi.default)(S, E), F = function(e) {
        let { theme: n, type: o, isLoading: s, icon: r } = e, i = null;
        const l = {
            theme: n,
            type: o
        };
        return !1 === r || ($d7fe6407b009814b$var$u(r) ? i = r({
            ...l,
            isLoading: s
        }) : (0, $3QbnI.isValidElement)(r) ? i = (0, $3QbnI.cloneElement)(r, l) : s ? i = $d7fe6407b009814b$export$4f13f83fd8bb1dac.spinner() : ((e)=>e in $d7fe6407b009814b$export$4f13f83fd8bb1dac)(o) && (i = $d7fe6407b009814b$export$4f13f83fd8bb1dac[o](l))), i;
    }(n), X = !!P || !m, Y = {
        closeToast: v,
        type: g,
        theme: R
    };
    let q = null;
    return !1 === d || (q = $d7fe6407b009814b$var$u(d) ? d(Y) : (0, $3QbnI.isValidElement)(d) ? (0, $3QbnI.cloneElement)(d, Y) : function(t) {
        let { closeToast: n, theme: o, ariaLabel: s = "close" } = t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("button", {
            className: `Toastify__close-button Toastify__close-button--${o}`,
            type: "button",
            onClick: (e)=>{
                e.stopPropagation(), n(e);
            },
            "aria-label": s
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 14 16"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("path", {
            fillRule: "evenodd",
            d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
        })));
    }(Y)), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(h, {
        isIn: B,
        done: A,
        position: T,
        preventExitTransition: s,
        nodeRef: r,
        playToast: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
        id: x,
        onClick: f,
        "data-in": B,
        className: H,
        ...i,
        style: b,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
        ...B && {
            role: k
        },
        className: $d7fe6407b009814b$var$u(I) ? I({
            type: g
        }) : (0, $eTLbi.default)("Toastify__toast-body", I),
        style: _
    }, null != F && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
        className: (0, $eTLbi.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !O
        })
    }, F), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", null, p)), q, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d7fe6407b009814b$var$$, {
        ...w && !X ? {
            key: `pb-${w}`
        } : {},
        rtl: M,
        theme: R,
        delay: m,
        isRunning: o,
        isIn: B,
        closeToast: v,
        hide: y,
        type: g,
        style: L,
        className: C,
        controlledProgress: X,
        progress: P || 0
    })));
}, $d7fe6407b009814b$var$S = function(e, t) {
    return void 0 === t && (t = !1), {
        enter: `Toastify--animate Toastify__${e}-enter`,
        exit: `Toastify--animate Toastify__${e}-exit`,
        appendPosition: t
    };
}, $d7fe6407b009814b$export$d20e79fdc3899e95 = $d7fe6407b009814b$export$3ff7dc44d332d222($d7fe6407b009814b$var$S("bounce", !0)), $d7fe6407b009814b$export$d8dc01b5c85a37b9 = $d7fe6407b009814b$export$3ff7dc44d332d222($d7fe6407b009814b$var$S("slide", !0)), $d7fe6407b009814b$export$65cfd44a2050f99 = $d7fe6407b009814b$export$3ff7dc44d332d222($d7fe6407b009814b$var$S("zoom")), $d7fe6407b009814b$export$4d2fae537bd90431 = $d7fe6407b009814b$export$3ff7dc44d332d222($d7fe6407b009814b$var$S("flip")), $d7fe6407b009814b$var$q = {
    position: "top-right",
    transition: $d7fe6407b009814b$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
function $d7fe6407b009814b$export$f2815235e76a62b9(t) {
    let o = {
        ...$d7fe6407b009814b$var$q,
        ...t
    };
    const s = t.stacked, [a, r] = (0, $3QbnI.useState)(!0), c = (0, $3QbnI.useRef)(null), { getToastToRender: d, isToastActive: m, count: f } = $d7fe6407b009814b$export$b262e13ca2dd2381(o), { className: g, style: y, rtl: v, containerId: h } = o;
    function T(e) {
        const t = (0, $eTLbi.default)("Toastify__toast-container", `Toastify__toast-container--${e}`, {
            "Toastify__toast-container--rtl": v
        });
        return $d7fe6407b009814b$var$u(g) ? g({
            position: e,
            rtl: v,
            defaultClassName: t
        }) : (0, $eTLbi.default)(t, $d7fe6407b009814b$var$p(g));
    }
    function E() {
        s && (r(!0), $d7fe6407b009814b$export$b410431fab84fa58.play());
    }
    return $d7fe6407b009814b$var$O(()=>{
        if (s) {
            var e;
            const t = c.current.querySelectorAll('[data-in="true"]'), n = 12, s = null == (e = o.position) ? void 0 : e.includes("top");
            let r = 0, i = 0;
            Array.from(t).reverse().forEach((e, t)=>{
                const o = e;
                o.classList.add("Toastify__toast--stacked"), t > 0 && (o.dataset.collapsed = `${a}`), o.dataset.pos || (o.dataset.pos = s ? "top" : "bot");
                const l = r * (a ? .2 : 1) + (a ? 0 : n * t);
                o.style.setProperty("--y", `${s ? l : -1 * l}px`), o.style.setProperty("--g", `${n}`), o.style.setProperty("--s", "" + (1 - (a ? i : 0))), r += o.offsetHeight, i += .025;
            });
        }
    }, [
        a,
        f,
        s
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
        ref: c,
        className: "Toastify",
        id: h,
        onMouseEnter: ()=>{
            s && (r(!1), $d7fe6407b009814b$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E
    }, d((t, n)=>{
        const o = n.length ? {
            ...y
        } : {
            ...y,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("div", {
            className: T(t),
            style: o,
            key: `container-${t}`
        }, n.map((t)=>{
            let { content: n, props: o } = t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d7fe6407b009814b$var$R, {
                ...o,
                stacked: s,
                collapseAll: E,
                isIn: m(o.toastId, o.containerId),
                style: o.style,
                key: `toast-${o.key}`
            }, n);
        }));
    }));
}




var $e1vzu = parcelRequire("e1vzu");
/**
 * React Router DOM v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3QbnI = parcelRequire("3QbnI");

/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $98b25df047b2379b$var$_extends() {
    $98b25df047b2379b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $98b25df047b2379b$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $98b25df047b2379b$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($98b25df047b2379b$export$e19cd5f9376f8cee || ($98b25df047b2379b$export$e19cd5f9376f8cee = {}));
const $98b25df047b2379b$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $98b25df047b2379b$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $98b25df047b2379b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $98b25df047b2379b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $98b25df047b2379b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $98b25df047b2379b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $98b25df047b2379b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $98b25df047b2379b$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $98b25df047b2379b$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $98b25df047b2379b$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $98b25df047b2379b$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $98b25df047b2379b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $98b25df047b2379b$export$fe53371bee54353d(to);
    }
    return $98b25df047b2379b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $98b25df047b2379b$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $98b25df047b2379b$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $98b25df047b2379b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $98b25df047b2379b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $98b25df047b2379b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $98b25df047b2379b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $98b25df047b2379b$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $98b25df047b2379b$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $98b25df047b2379b$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $98b25df047b2379b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $98b25df047b2379b$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $98b25df047b2379b$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $98b25df047b2379b$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $98b25df047b2379b$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $98b25df047b2379b$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $98b25df047b2379b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $98b25df047b2379b$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $98b25df047b2379b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($98b25df047b2379b$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $98b25df047b2379b$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $98b25df047b2379b$export$e19cd5f9376f8cee.Push;
        let location = $98b25df047b2379b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $98b25df047b2379b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $98b25df047b2379b$export$e19cd5f9376f8cee.Replace;
        let location = $98b25df047b2379b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $98b25df047b2379b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $98b25df047b2379b$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $98b25df047b2379b$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($98b25df047b2379b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($98b25df047b2379b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $98b25df047b2379b$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($98b25df047b2379b$var$ResultType || ($98b25df047b2379b$var$ResultType = {}));
const $98b25df047b2379b$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $98b25df047b2379b$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $98b25df047b2379b$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $98b25df047b2379b$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $98b25df047b2379b$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($98b25df047b2379b$var$isIndexRoute(route)) {
            let indexRoute = $98b25df047b2379b$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $98b25df047b2379b$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $98b25df047b2379b$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $98b25df047b2379b$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $98b25df047b2379b$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $98b25df047b2379b$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $98b25df047b2379b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $98b25df047b2379b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $98b25df047b2379b$var$flattenRoutes(routes);
    $98b25df047b2379b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $98b25df047b2379b$export$30d21fd6d7295f52(pathname);
        matches = $98b25df047b2379b$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $98b25df047b2379b$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $98b25df047b2379b$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $98b25df047b2379b$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $98b25df047b2379b$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $98b25df047b2379b$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $98b25df047b2379b$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $98b25df047b2379b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $98b25df047b2379b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $98b25df047b2379b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $98b25df047b2379b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $98b25df047b2379b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $98b25df047b2379b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $98b25df047b2379b$var$paramRe = /^:[\w-]+$/;
const $98b25df047b2379b$var$dynamicSegmentValue = 3;
const $98b25df047b2379b$var$indexRouteValue = 2;
const $98b25df047b2379b$var$emptySegmentValue = 1;
const $98b25df047b2379b$var$staticSegmentValue = 10;
const $98b25df047b2379b$var$splatPenalty = -2;
const $98b25df047b2379b$var$isSplat = (s)=>s === "*";
function $98b25df047b2379b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($98b25df047b2379b$var$isSplat)) initialScore += $98b25df047b2379b$var$splatPenalty;
    if (index) initialScore += $98b25df047b2379b$var$indexRouteValue;
    return segments.filter((s)=>!$98b25df047b2379b$var$isSplat(s)).reduce((score, segment)=>score + ($98b25df047b2379b$var$paramRe.test(segment) ? $98b25df047b2379b$var$dynamicSegmentValue : segment === "" ? $98b25df047b2379b$var$emptySegmentValue : $98b25df047b2379b$var$staticSegmentValue), initialScore);
}
function $98b25df047b2379b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $98b25df047b2379b$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $98b25df047b2379b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $98b25df047b2379b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $98b25df047b2379b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $98b25df047b2379b$export$a5c6d149b50c1d86($98b25df047b2379b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $98b25df047b2379b$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $98b25df047b2379b$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $98b25df047b2379b$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $98b25df047b2379b$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $98b25df047b2379b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $98b25df047b2379b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $98b25df047b2379b$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $98b25df047b2379b$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $98b25df047b2379b$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $98b25df047b2379b$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $98b25df047b2379b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $98b25df047b2379b$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $98b25df047b2379b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $98b25df047b2379b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $98b25df047b2379b$var$normalizeSearch(search),
        hash: $98b25df047b2379b$var$normalizeHash(hash)
    };
}
function $98b25df047b2379b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $98b25df047b2379b$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $98b25df047b2379b$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $98b25df047b2379b$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $98b25df047b2379b$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $98b25df047b2379b$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $98b25df047b2379b$export$8ccf933b0513f8d0(toArg);
    else {
        to = $98b25df047b2379b$var$_extends({}, toArg);
        $98b25df047b2379b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $98b25df047b2379b$var$getInvalidPathError("?", "pathname", "search", to));
        $98b25df047b2379b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $98b25df047b2379b$var$getInvalidPathError("#", "pathname", "hash", to));
        $98b25df047b2379b$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $98b25df047b2379b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $98b25df047b2379b$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $98b25df047b2379b$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $98b25df047b2379b$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $98b25df047b2379b$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $98b25df047b2379b$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $98b25df047b2379b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $98b25df047b2379b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $98b25df047b2379b$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $98b25df047b2379b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $98b25df047b2379b$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $98b25df047b2379b$export$4051a07651545597(data, init) {
    return new $98b25df047b2379b$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $98b25df047b2379b$export$42a99a7a4bc0e76a extends Error {
}
class $98b25df047b2379b$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $98b25df047b2379b$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $98b25df047b2379b$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $98b25df047b2379b$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $98b25df047b2379b$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $98b25df047b2379b$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $98b25df047b2379b$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $98b25df047b2379b$var$unwrapTrackedPromise(value) {
    if (!$98b25df047b2379b$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $98b25df047b2379b$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $98b25df047b2379b$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $98b25df047b2379b$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $98b25df047b2379b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $98b25df047b2379b$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $98b25df047b2379b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $98b25df047b2379b$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $98b25df047b2379b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $98b25df047b2379b$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $98b25df047b2379b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $98b25df047b2379b$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $98b25df047b2379b$var$validMutationMethods = new Set($98b25df047b2379b$var$validMutationMethodsArr);
const $98b25df047b2379b$var$validRequestMethodsArr = [
    "get",
    ...$98b25df047b2379b$var$validMutationMethodsArr
];
const $98b25df047b2379b$var$validRequestMethods = new Set($98b25df047b2379b$var$validRequestMethodsArr);
const $98b25df047b2379b$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $98b25df047b2379b$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $98b25df047b2379b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $98b25df047b2379b$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $98b25df047b2379b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $98b25df047b2379b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $98b25df047b2379b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $98b25df047b2379b$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $98b25df047b2379b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $98b25df047b2379b$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $98b25df047b2379b$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $98b25df047b2379b$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $98b25df047b2379b$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $98b25df047b2379b$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $98b25df047b2379b$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $98b25df047b2379b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $98b25df047b2379b$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$98b25df047b2379b$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$98b25df047b2379b$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $98b25df047b2379b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $98b25df047b2379b$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $98b25df047b2379b$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $98b25df047b2379b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $98b25df047b2379b$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$98b25df047b2379b$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($98b25df047b2379b$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $98b25df047b2379b$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $98b25df047b2379b$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $98b25df047b2379b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $98b25df047b2379b$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $98b25df047b2379b$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $98b25df047b2379b$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $98b25df047b2379b$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $98b25df047b2379b$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $98b25df047b2379b$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($98b25df047b2379b$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $98b25df047b2379b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $98b25df047b2379b$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $98b25df047b2379b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $98b25df047b2379b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $98b25df047b2379b$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $98b25df047b2379b$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $98b25df047b2379b$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $98b25df047b2379b$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $98b25df047b2379b$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $98b25df047b2379b$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $98b25df047b2379b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $98b25df047b2379b$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $98b25df047b2379b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $98b25df047b2379b$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $98b25df047b2379b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $98b25df047b2379b$var$findNearestBoundary(matches).route.id,
            {
                type: $98b25df047b2379b$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $98b25df047b2379b$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($98b25df047b2379b$var$isErrorResult(result) && $98b25df047b2379b$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $98b25df047b2379b$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $98b25df047b2379b$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $98b25df047b2379b$var$_extends({
            matches: updatedMatches || matches
        }, $98b25df047b2379b$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $98b25df047b2379b$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $98b25df047b2379b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $98b25df047b2379b$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $98b25df047b2379b$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $98b25df047b2379b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $98b25df047b2379b$var$ResultType.error,
            error: $98b25df047b2379b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($98b25df047b2379b$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $98b25df047b2379b$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($98b25df047b2379b$var$isDeferredResult(result)) throw $98b25df047b2379b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($98b25df047b2379b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $98b25df047b2379b$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $98b25df047b2379b$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $98b25df047b2379b$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $98b25df047b2379b$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($98b25df047b2379b$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $98b25df047b2379b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $98b25df047b2379b$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $98b25df047b2379b$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $98b25df047b2379b$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $98b25df047b2379b$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $98b25df047b2379b$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $98b25df047b2379b$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $98b25df047b2379b$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $98b25df047b2379b$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $98b25df047b2379b$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$98b25df047b2379b$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $98b25df047b2379b$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $98b25df047b2379b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $98b25df047b2379b$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $98b25df047b2379b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $98b25df047b2379b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $98b25df047b2379b$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $98b25df047b2379b$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $98b25df047b2379b$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $98b25df047b2379b$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $98b25df047b2379b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $98b25df047b2379b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $98b25df047b2379b$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($98b25df047b2379b$var$isRedirectResult(actionResult) || $98b25df047b2379b$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $98b25df047b2379b$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($98b25df047b2379b$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $98b25df047b2379b$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $98b25df047b2379b$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($98b25df047b2379b$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($98b25df047b2379b$var$isDeferredResult(actionResult)) throw $98b25df047b2379b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $98b25df047b2379b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $98b25df047b2379b$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $98b25df047b2379b$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $98b25df047b2379b$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $98b25df047b2379b$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $98b25df047b2379b$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $98b25df047b2379b$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $98b25df047b2379b$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $98b25df047b2379b$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $98b25df047b2379b$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $98b25df047b2379b$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $98b25df047b2379b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $98b25df047b2379b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $98b25df047b2379b$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $98b25df047b2379b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $98b25df047b2379b$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($98b25df047b2379b$var$isDeferredResult(result)) result = await $98b25df047b2379b$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $98b25df047b2379b$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($98b25df047b2379b$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $98b25df047b2379b$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($98b25df047b2379b$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $98b25df047b2379b$export$3e9cee6b33872309(!$98b25df047b2379b$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $98b25df047b2379b$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $98b25df047b2379b$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $98b25df047b2379b$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $98b25df047b2379b$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($98b25df047b2379b$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $98b25df047b2379b$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $98b25df047b2379b$export$e19cd5f9376f8cee.Replace : $98b25df047b2379b$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $98b25df047b2379b$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($98b25df047b2379b$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $98b25df047b2379b$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $98b25df047b2379b$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $98b25df047b2379b$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $98b25df047b2379b$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $98b25df047b2379b$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($98b25df047b2379b$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $98b25df047b2379b$var$ResultType.redirect,
                response: $98b25df047b2379b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $98b25df047b2379b$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $98b25df047b2379b$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $98b25df047b2379b$var$ResultType.error,
                    error: $98b25df047b2379b$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $98b25df047b2379b$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $98b25df047b2379b$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $98b25df047b2379b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $98b25df047b2379b$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $98b25df047b2379b$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $98b25df047b2379b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $98b25df047b2379b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $98b25df047b2379b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $98b25df047b2379b$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $98b25df047b2379b$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $98b25df047b2379b$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $98b25df047b2379b$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $98b25df047b2379b$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $98b25df047b2379b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$98b25df047b2379b$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $98b25df047b2379b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $98b25df047b2379b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $98b25df047b2379b$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $98b25df047b2379b$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $98b25df047b2379b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $98b25df047b2379b$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $98b25df047b2379b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $98b25df047b2379b$export$4d0306f8f6a4585b = Symbol("deferred");
function $98b25df047b2379b$export$3336b097a6fbc59a(routes, opts) {
    $98b25df047b2379b$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $98b25df047b2379b$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $98b25df047b2379b$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $98b25df047b2379b$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $98b25df047b2379b$var$createLocation("", $98b25df047b2379b$export$fe53371bee54353d(url), null, "default");
        let matches = $98b25df047b2379b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$98b25df047b2379b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $98b25df047b2379b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $98b25df047b2379b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $98b25df047b2379b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $98b25df047b2379b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($98b25df047b2379b$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $98b25df047b2379b$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $98b25df047b2379b$var$createLocation("", $98b25df047b2379b$export$fe53371bee54353d(url), null, "default");
        let matches = $98b25df047b2379b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$98b25df047b2379b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $98b25df047b2379b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $98b25df047b2379b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $98b25df047b2379b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $98b25df047b2379b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $98b25df047b2379b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($98b25df047b2379b$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$98b25df047b2379b$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $98b25df047b2379b$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($98b25df047b2379b$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $98b25df047b2379b$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $98b25df047b2379b$var$isResponse(result) ? result : $98b25df047b2379b$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($98b25df047b2379b$var$isDataStrategyResult(e) && $98b25df047b2379b$var$isResponse(e.result)) {
                if (e.type === $98b25df047b2379b$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($98b25df047b2379b$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $98b25df047b2379b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $98b25df047b2379b$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $98b25df047b2379b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($98b25df047b2379b$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($98b25df047b2379b$var$isDeferredResult(result)) {
            let error = $98b25df047b2379b$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $98b25df047b2379b$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($98b25df047b2379b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($98b25df047b2379b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $98b25df047b2379b$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $98b25df047b2379b$var$_extends({}, context, {
                statusCode: $98b25df047b2379b$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $98b25df047b2379b$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $98b25df047b2379b$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $98b25df047b2379b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $98b25df047b2379b$var$isErrorResult(pendingActionResult[1]) ? $98b25df047b2379b$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $98b25df047b2379b$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $98b25df047b2379b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $98b25df047b2379b$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $98b25df047b2379b$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $98b25df047b2379b$var$callDataStrategyImpl(dataStrategy || $98b25df047b2379b$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($98b25df047b2379b$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $98b25df047b2379b$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($98b25df047b2379b$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $98b25df047b2379b$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $98b25df047b2379b$export$fec11da027c70692(routes, context, error) {
    let newContext = $98b25df047b2379b$var$_extends({}, context, {
        statusCode: $98b25df047b2379b$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $98b25df047b2379b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $98b25df047b2379b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $98b25df047b2379b$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $98b25df047b2379b$export$cae722b0cc860f13(to ? to : ".", $98b25df047b2379b$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $98b25df047b2379b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $98b25df047b2379b$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $98b25df047b2379b$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $98b25df047b2379b$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $98b25df047b2379b$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$98b25df047b2379b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$98b25df047b2379b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $98b25df047b2379b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $98b25df047b2379b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $98b25df047b2379b$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$98b25df047b2379b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$98b25df047b2379b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $98b25df047b2379b$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $98b25df047b2379b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $98b25df047b2379b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $98b25df047b2379b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $98b25df047b2379b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($98b25df047b2379b$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $98b25df047b2379b$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $98b25df047b2379b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $98b25df047b2379b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $98b25df047b2379b$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $98b25df047b2379b$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $98b25df047b2379b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $98b25df047b2379b$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $98b25df047b2379b$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $98b25df047b2379b$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $98b25df047b2379b$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($98b25df047b2379b$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $98b25df047b2379b$var$shouldRevalidateLoader(match, $98b25df047b2379b$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $98b25df047b2379b$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $98b25df047b2379b$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $98b25df047b2379b$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $98b25df047b2379b$var$shouldRevalidateLoader(fetcherMatch, $98b25df047b2379b$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $98b25df047b2379b$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $98b25df047b2379b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $98b25df047b2379b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $98b25df047b2379b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $98b25df047b2379b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $98b25df047b2379b$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$98b25df047b2379b$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $98b25df047b2379b$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $98b25df047b2379b$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$98b25df047b2379b$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $98b25df047b2379b$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $98b25df047b2379b$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $98b25df047b2379b$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$98b25df047b2379b$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $98b25df047b2379b$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $98b25df047b2379b$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $98b25df047b2379b$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $98b25df047b2379b$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $98b25df047b2379b$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $98b25df047b2379b$var$ResultType.data,
                result: undefined
            });
        };
        return $98b25df047b2379b$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $98b25df047b2379b$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $98b25df047b2379b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $98b25df047b2379b$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $98b25df047b2379b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $98b25df047b2379b$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $98b25df047b2379b$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $98b25df047b2379b$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($98b25df047b2379b$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $98b25df047b2379b$var$ResultType.error,
                error: e
            };
        }
        if (type === $98b25df047b2379b$var$ResultType.error) return {
            type: $98b25df047b2379b$var$ResultType.error,
            error: new $98b25df047b2379b$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $98b25df047b2379b$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $98b25df047b2379b$var$ResultType.error) {
        if ($98b25df047b2379b$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $98b25df047b2379b$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $98b25df047b2379b$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $98b25df047b2379b$var$ResultType.error,
            error: result,
            statusCode: $98b25df047b2379b$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($98b25df047b2379b$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $98b25df047b2379b$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($98b25df047b2379b$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $98b25df047b2379b$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $98b25df047b2379b$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $98b25df047b2379b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $98b25df047b2379b$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$98b25df047b2379b$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $98b25df047b2379b$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $98b25df047b2379b$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($98b25df047b2379b$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $98b25df047b2379b$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $98b25df047b2379b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($98b25df047b2379b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $98b25df047b2379b$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $98b25df047b2379b$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $98b25df047b2379b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $98b25df047b2379b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $98b25df047b2379b$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $98b25df047b2379b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $98b25df047b2379b$export$3e9cee6b33872309(!$98b25df047b2379b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($98b25df047b2379b$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $98b25df047b2379b$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $98b25df047b2379b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($98b25df047b2379b$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $98b25df047b2379b$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $98b25df047b2379b$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $98b25df047b2379b$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($98b25df047b2379b$var$isErrorResult(result)) {
            let boundaryMatch = $98b25df047b2379b$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $98b25df047b2379b$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($98b25df047b2379b$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $98b25df047b2379b$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($98b25df047b2379b$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $98b25df047b2379b$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $98b25df047b2379b$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $98b25df047b2379b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $98b25df047b2379b$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $98b25df047b2379b$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $98b25df047b2379b$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $98b25df047b2379b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $98b25df047b2379b$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $98b25df047b2379b$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $98b25df047b2379b$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $98b25df047b2379b$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($98b25df047b2379b$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $98b25df047b2379b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $98b25df047b2379b$export$8ccf933b0513f8d0(path) : path;
    return $98b25df047b2379b$export$fe53371bee54353d($98b25df047b2379b$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $98b25df047b2379b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $98b25df047b2379b$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $98b25df047b2379b$var$ResultType.data || result.type === $98b25df047b2379b$var$ResultType.error);
}
function $98b25df047b2379b$var$isRedirectDataStrategyResultResult(result) {
    return $98b25df047b2379b$var$isResponse(result.result) && $98b25df047b2379b$var$redirectStatusCodes.has(result.result.status);
}
function $98b25df047b2379b$var$isDeferredResult(result) {
    return result.type === $98b25df047b2379b$var$ResultType.deferred;
}
function $98b25df047b2379b$var$isErrorResult(result) {
    return result.type === $98b25df047b2379b$var$ResultType.error;
}
function $98b25df047b2379b$var$isRedirectResult(result) {
    return (result && result.type) === $98b25df047b2379b$var$ResultType.redirect;
}
function $98b25df047b2379b$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $98b25df047b2379b$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $98b25df047b2379b$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $98b25df047b2379b$var$isRedirectResponse(result) {
    if (!$98b25df047b2379b$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $98b25df047b2379b$var$isValidMethod(method) {
    return $98b25df047b2379b$var$validRequestMethods.has(method.toLowerCase());
}
function $98b25df047b2379b$var$isMutationMethod(method) {
    return $98b25df047b2379b$var$validMutationMethods.has(method.toLowerCase());
}
async function $98b25df047b2379b$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$98b25df047b2379b$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($98b25df047b2379b$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $98b25df047b2379b$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $98b25df047b2379b$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($98b25df047b2379b$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $98b25df047b2379b$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $98b25df047b2379b$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $98b25df047b2379b$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $98b25df047b2379b$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $98b25df047b2379b$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $98b25df047b2379b$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $98b25df047b2379b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $98b25df047b2379b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $98b25df047b2379b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $98b25df047b2379b$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $98b25df047b2379b$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $98b25df047b2379b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $98b25df047b2379b$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $98b25df047b2379b$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $98b25df047b2379b$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $98b25df047b2379b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $98b25df047b2379b$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $98b25df047b2379b$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($98b25df047b2379b$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $98b25df047b2379b$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($98b25df047b2379b$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $98b25df047b2379b$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3QbnI = parcelRequire("3QbnI");

function $720b4b44089c40ed$var$_extends() {
    $720b4b44089c40ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $720b4b44089c40ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $720b4b44089c40ed$export$3add0d5dce533e2e = /*#__PURE__*/ $3QbnI.createContext(null);
const $720b4b44089c40ed$export$145dfa71566a64dc = /*#__PURE__*/ $3QbnI.createContext(null);
const $720b4b44089c40ed$var$AwaitContext = /*#__PURE__*/ $3QbnI.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $720b4b44089c40ed$export$26749e8557646306 = /*#__PURE__*/ $3QbnI.createContext(null);
const $720b4b44089c40ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $3QbnI.createContext(null);
const $720b4b44089c40ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $3QbnI.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $720b4b44089c40ed$var$RouteErrorContext = /*#__PURE__*/ $3QbnI.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $720b4b44089c40ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$720b4b44089c40ed$export$9c954a9d03d32f4a() && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $3QbnI.useContext($720b4b44089c40ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $720b4b44089c40ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $98b25df047b2379b$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $720b4b44089c40ed$export$9c954a9d03d32f4a() {
    return $3QbnI.useContext($720b4b44089c40ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $720b4b44089c40ed$export$45d76561a5302f2b() {
    !$720b4b44089c40ed$export$9c954a9d03d32f4a() && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    return $3QbnI.useContext($720b4b44089c40ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $720b4b44089c40ed$export$1b3f31771c5d07c() {
    return $3QbnI.useContext($720b4b44089c40ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $720b4b44089c40ed$export$6c330e8992e8a295(pattern) {
    !$720b4b44089c40ed$export$9c954a9d03d32f4a() && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $720b4b44089c40ed$export$45d76561a5302f2b();
    return $3QbnI.useMemo(()=>(0, $98b25df047b2379b$export$81336c211d5ff295)(pattern, (0, $98b25df047b2379b$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $720b4b44089c40ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $720b4b44089c40ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $3QbnI.useContext($720b4b44089c40ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3QbnI.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $720b4b44089c40ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $720b4b44089c40ed$var$useNavigateStable() : $720b4b44089c40ed$var$useNavigateUnstable();
}
function $720b4b44089c40ed$var$useNavigateUnstable() {
    !$720b4b44089c40ed$export$9c954a9d03d32f4a() && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    let dataRouterContext = $3QbnI.useContext($720b4b44089c40ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $3QbnI.useContext($720b4b44089c40ed$export$26749e8557646306);
    let { matches: matches } = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $720b4b44089c40ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $98b25df047b2379b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $3QbnI.useRef(false);
    $720b4b44089c40ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3QbnI.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $98b25df047b2379b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $98b25df047b2379b$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $720b4b44089c40ed$var$OutletContext = /*#__PURE__*/ $3QbnI.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $720b4b44089c40ed$export$4138103a3ae699cc() {
    return $3QbnI.useContext($720b4b44089c40ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $720b4b44089c40ed$export$a3be3530d8e40d0b(context) {
    let outlet = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $720b4b44089c40ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $720b4b44089c40ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $3QbnI.useContext($720b4b44089c40ed$export$26749e8557646306);
    let { matches: matches } = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $720b4b44089c40ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $98b25df047b2379b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $3QbnI.useMemo(()=>(0, $98b25df047b2379b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $720b4b44089c40ed$export$5d3fca4a98652595(routes, locationArg) {
    return $720b4b44089c40ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $720b4b44089c40ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$720b4b44089c40ed$export$9c954a9d03d32f4a() && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $3QbnI.useContext($720b4b44089c40ed$export$26749e8557646306);
    let { matches: parentMatches } = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $720b4b44089c40ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $98b25df047b2379b$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $98b25df047b2379b$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $720b4b44089c40ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $98b25df047b2379b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $98b25df047b2379b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $720b4b44089c40ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $98b25df047b2379b$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $720b4b44089c40ed$var$DefaultErrorComponent() {
    let error = $720b4b44089c40ed$export$ed527bf60f6e05f2();
    let message = (0, $98b25df047b2379b$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $3QbnI.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $3QbnI.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $720b4b44089c40ed$var$defaultErrorElement = /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$DefaultErrorComponent, null);
class $720b4b44089c40ed$var$RenderErrorBoundary extends $3QbnI.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $720b4b44089c40ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $3QbnI.useContext($720b4b44089c40ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $720b4b44089c40ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $720b4b44089c40ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $720b4b44089c40ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $3QbnI.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $720b4b44089c40ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($720b4b44089c40ed$var$DataRouterHook || {});
var $720b4b44089c40ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($720b4b44089c40ed$var$DataRouterStateHook || {});
function $720b4b44089c40ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $720b4b44089c40ed$var$useDataRouterContext(hookName) {
    let ctx = $3QbnI.useContext($720b4b44089c40ed$export$3add0d5dce533e2e);
    !ctx && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $720b4b44089c40ed$var$useDataRouterState(hookName) {
    let state = $3QbnI.useContext($720b4b44089c40ed$export$145dfa71566a64dc);
    !state && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    return state;
}
function $720b4b44089c40ed$var$useRouteContext(hookName) {
    let route = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057);
    !route && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $720b4b44089c40ed$var$useCurrentRouteId(hookName) {
    let route = $720b4b44089c40ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $720b4b44089c40ed$export$5fc8298006ad9e58() {
    return $720b4b44089c40ed$var$useCurrentRouteId($720b4b44089c40ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $720b4b44089c40ed$export$d0fd4b7106de2769() {
    let state = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $720b4b44089c40ed$export$600dc272ed516c15() {
    let dataRouterContext = $720b4b44089c40ed$var$useDataRouterContext($720b4b44089c40ed$var$DataRouterHook.UseRevalidator);
    let state = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseRevalidator);
    return $3QbnI.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $720b4b44089c40ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseMatches);
    return $3QbnI.useMemo(()=>matches.map((m)=>(0, $98b25df047b2379b$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $720b4b44089c40ed$export$1448a5050d252c4d() {
    let state = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $720b4b44089c40ed$var$useCurrentRouteId($720b4b44089c40ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $720b4b44089c40ed$export$fd5d37484eab868d(routeId) {
    let state = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $720b4b44089c40ed$export$fdc00f3f26066d5e() {
    let state = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseActionData);
    let routeId = $720b4b44089c40ed$var$useCurrentRouteId($720b4b44089c40ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $720b4b44089c40ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $3QbnI.useContext($720b4b44089c40ed$var$RouteErrorContext);
    let state = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $720b4b44089c40ed$var$useCurrentRouteId($720b4b44089c40ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $720b4b44089c40ed$export$78a72ddb39bdd145() {
    let value = $3QbnI.useContext($720b4b44089c40ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $720b4b44089c40ed$export$17f53340677d5831() {
    let value = $3QbnI.useContext($720b4b44089c40ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $720b4b44089c40ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $720b4b44089c40ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $720b4b44089c40ed$var$useDataRouterContext($720b4b44089c40ed$var$DataRouterHook.UseBlocker);
    let state = $720b4b44089c40ed$var$useDataRouterState($720b4b44089c40ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $3QbnI.useState("");
    let blockerFunction = $3QbnI.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $720b4b44089c40ed$var$_extends({}, currentLocation, {
                pathname: (0, $98b25df047b2379b$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $720b4b44089c40ed$var$_extends({}, nextLocation, {
                pathname: (0, $98b25df047b2379b$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $3QbnI.useEffect(()=>{
        let key = String(++$720b4b44089c40ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $3QbnI.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $98b25df047b2379b$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $720b4b44089c40ed$var$useNavigateStable() {
    let { router: router } = $720b4b44089c40ed$var$useDataRouterContext($720b4b44089c40ed$var$DataRouterHook.UseNavigateStable);
    let id = $720b4b44089c40ed$var$useCurrentRouteId($720b4b44089c40ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $3QbnI.useRef(false);
    $720b4b44089c40ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3QbnI.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $720b4b44089c40ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $720b4b44089c40ed$var$alreadyWarned$1 = {};
function $720b4b44089c40ed$var$warningOnce(key, cond, message) {
    if (!cond && !$720b4b44089c40ed$var$alreadyWarned$1[key]) $720b4b44089c40ed$var$alreadyWarned$1[key] = true;
}
const $720b4b44089c40ed$var$alreadyWarned = {};
function $720b4b44089c40ed$var$warnOnce(key, message) {
    if (!$720b4b44089c40ed$var$alreadyWarned[message]) {
        $720b4b44089c40ed$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $720b4b44089c40ed$var$logDeprecation = (flag, msg, link)=>$720b4b44089c40ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $720b4b44089c40ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $720b4b44089c40ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $720b4b44089c40ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $720b4b44089c40ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $720b4b44089c40ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $720b4b44089c40ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $720b4b44089c40ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $720b4b44089c40ed$var$START_TRANSITION = "startTransition";
const $720b4b44089c40ed$var$startTransitionImpl = $3QbnI[$720b4b44089c40ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $720b4b44089c40ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3QbnI.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        if (v7_startTransition && $720b4b44089c40ed$var$startTransitionImpl) $720b4b44089c40ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3QbnI.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $3QbnI.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3QbnI.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3QbnI.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $3QbnI.useEffect(()=>$720b4b44089c40ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $720b4b44089c40ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $720b4b44089c40ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $720b4b44089c40ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $3QbnI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $98b25df047b2379b$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $720b4b44089c40ed$var$startTransitionImpl ? $720b4b44089c40ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3QbnI.useEffect(()=>$720b4b44089c40ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $720b4b44089c40ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$720b4b44089c40ed$export$9c954a9d03d32f4a() && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $3QbnI.useContext($720b4b44089c40ed$export$26749e8557646306);
    let { matches: matches } = $3QbnI.useContext($720b4b44089c40ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $720b4b44089c40ed$export$45d76561a5302f2b();
    let navigate = $720b4b44089c40ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $98b25df047b2379b$export$cae722b0cc860f13)(to, (0, $98b25df047b2379b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $3QbnI.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $720b4b44089c40ed$export$910ae8079b2c2852(props) {
    return $720b4b44089c40ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $720b4b44089c40ed$export$e7b0ac011bb776c6(_props) {
    (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $720b4b44089c40ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $98b25df047b2379b$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$720b4b44089c40ed$export$9c954a9d03d32f4a() && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $3QbnI.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $720b4b44089c40ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $98b25df047b2379b$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $3QbnI.useMemo(()=>{
        let trailingPathname = (0, $98b25df047b2379b$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $720b4b44089c40ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $720b4b44089c40ed$export$5d3fca4a98652595($720b4b44089c40ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $720b4b44089c40ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$ResolveAwait, null, children));
}
var $720b4b44089c40ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($720b4b44089c40ed$var$AwaitRenderStatus || {});
const $720b4b44089c40ed$var$neverSettledPromise = new Promise(()=>{});
class $720b4b44089c40ed$var$AwaitErrorBoundary extends $3QbnI.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $720b4b44089c40ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $720b4b44089c40ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $720b4b44089c40ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $720b4b44089c40ed$var$AwaitRenderStatus.error : "_data" in promise ? $720b4b44089c40ed$var$AwaitRenderStatus.success : $720b4b44089c40ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $720b4b44089c40ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $720b4b44089c40ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $98b25df047b2379b$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $720b4b44089c40ed$var$neverSettledPromise;
        if (status === $720b4b44089c40ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $720b4b44089c40ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $720b4b44089c40ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $3QbnI.createElement($720b4b44089c40ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $720b4b44089c40ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $720b4b44089c40ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $720b4b44089c40ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $3QbnI.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $3QbnI.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $3QbnI.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $720b4b44089c40ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $720b4b44089c40ed$export$e7b0ac011bb776c6) && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $720b4b44089c40ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $720b4b44089c40ed$export$daf73786167a7f72(matches) {
    return $720b4b44089c40ed$var$_renderMatches(matches);
}
function $720b4b44089c40ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $3QbnI.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $3QbnI.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $3QbnI.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $720b4b44089c40ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $98b25df047b2379b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $720b4b44089c40ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $98b25df047b2379b$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $720b4b44089c40ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $cd8cc81cff53fd72$var$_extends() {
    $cd8cc81cff53fd72$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd8cc81cff53fd72$var$_extends.apply(this, arguments);
}
function $cd8cc81cff53fd72$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $cd8cc81cff53fd72$var$defaultMethod = "get";
const $cd8cc81cff53fd72$var$defaultEncType = "application/x-www-form-urlencoded";
function $cd8cc81cff53fd72$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $cd8cc81cff53fd72$var$isButtonElement(object) {
    return $cd8cc81cff53fd72$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $cd8cc81cff53fd72$var$isFormElement(object) {
    return $cd8cc81cff53fd72$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $cd8cc81cff53fd72$var$isInputElement(object) {
    return $cd8cc81cff53fd72$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $cd8cc81cff53fd72$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $cd8cc81cff53fd72$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$cd8cc81cff53fd72$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $cd8cc81cff53fd72$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $cd8cc81cff53fd72$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $cd8cc81cff53fd72$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $cd8cc81cff53fd72$var$_formDataSupportsSubmitter = null;
function $cd8cc81cff53fd72$var$isFormDataSubmitterSupported() {
    if ($cd8cc81cff53fd72$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $cd8cc81cff53fd72$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $cd8cc81cff53fd72$var$_formDataSupportsSubmitter = true;
    }
    return $cd8cc81cff53fd72$var$_formDataSupportsSubmitter;
}
const $cd8cc81cff53fd72$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $cd8cc81cff53fd72$var$getFormEncType(encType) {
    if (encType != null && !$cd8cc81cff53fd72$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $cd8cc81cff53fd72$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($cd8cc81cff53fd72$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $98b25df047b2379b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $cd8cc81cff53fd72$var$defaultMethod;
        encType = $cd8cc81cff53fd72$var$getFormEncType(target.getAttribute("enctype")) || $cd8cc81cff53fd72$var$defaultEncType;
        formData = new FormData(target);
    } else if ($cd8cc81cff53fd72$var$isButtonElement(target) || $cd8cc81cff53fd72$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $98b25df047b2379b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $cd8cc81cff53fd72$var$defaultMethod;
        encType = $cd8cc81cff53fd72$var$getFormEncType(target.getAttribute("formenctype")) || $cd8cc81cff53fd72$var$getFormEncType(form.getAttribute("enctype")) || $cd8cc81cff53fd72$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$cd8cc81cff53fd72$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($cd8cc81cff53fd72$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $cd8cc81cff53fd72$var$defaultMethod;
        action = null;
        encType = $cd8cc81cff53fd72$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $cd8cc81cff53fd72$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $cd8cc81cff53fd72$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $cd8cc81cff53fd72$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $cd8cc81cff53fd72$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $cd8cc81cff53fd72$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $cd8cc81cff53fd72$export$1f3f55432a00e06d(routes, opts) {
    return (0, $98b25df047b2379b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $cd8cc81cff53fd72$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $98b25df047b2379b$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $cd8cc81cff53fd72$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $720b4b44089c40ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $cd8cc81cff53fd72$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $98b25df047b2379b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $cd8cc81cff53fd72$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $98b25df047b2379b$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $cd8cc81cff53fd72$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $720b4b44089c40ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $cd8cc81cff53fd72$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $cd8cc81cff53fd72$var$_extends({}, state, {
        errors: $cd8cc81cff53fd72$var$deserializeErrors(state.errors)
    });
    return state;
}
function $cd8cc81cff53fd72$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $98b25df047b2379b$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $cd8cc81cff53fd72$export$7ad602f0e94e62d1 = /*#__PURE__*/ $3QbnI.createContext({
    isTransitioning: false
});
const $cd8cc81cff53fd72$export$148fd98d095596d4 = /*#__PURE__*/ $3QbnI.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $cd8cc81cff53fd72$var$START_TRANSITION = "startTransition";
const $cd8cc81cff53fd72$var$startTransitionImpl = $3QbnI[$cd8cc81cff53fd72$var$START_TRANSITION];
const $cd8cc81cff53fd72$var$FLUSH_SYNC = "flushSync";
const $cd8cc81cff53fd72$var$flushSyncImpl = $70c58451959e30b3$exports[$cd8cc81cff53fd72$var$FLUSH_SYNC];
const $cd8cc81cff53fd72$var$USE_ID = "useId";
const $cd8cc81cff53fd72$var$useIdImpl = $3QbnI[$cd8cc81cff53fd72$var$USE_ID];
function $cd8cc81cff53fd72$var$startTransitionSafe(cb) {
    if ($cd8cc81cff53fd72$var$startTransitionImpl) $cd8cc81cff53fd72$var$startTransitionImpl(cb);
    else cb();
}
function $cd8cc81cff53fd72$var$flushSyncSafe(cb) {
    if ($cd8cc81cff53fd72$var$flushSyncImpl) $cd8cc81cff53fd72$var$flushSyncImpl(cb);
    else cb();
}
class $cd8cc81cff53fd72$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $cd8cc81cff53fd72$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3QbnI.useState(router.state);
    let [pendingState, setPendingState] = $3QbnI.useState();
    let [vtContext, setVtContext] = $3QbnI.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $3QbnI.useState();
    let [transition, setTransition] = $3QbnI.useState();
    let [interruption, setInterruption] = $3QbnI.useState();
    let fetcherData = $3QbnI.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $3QbnI.useCallback((cb)=>{
        if (v7_startTransition) $cd8cc81cff53fd72$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $3QbnI.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $cd8cc81cff53fd72$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $cd8cc81cff53fd72$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $cd8cc81cff53fd72$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $cd8cc81cff53fd72$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $cd8cc81cff53fd72$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3QbnI.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $3QbnI.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $cd8cc81cff53fd72$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $3QbnI.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $3QbnI.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $3QbnI.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $3QbnI.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3QbnI.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3QbnI.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $3QbnI.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $3QbnI.useEffect(()=>(0, $720b4b44089c40ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement((0, $720b4b44089c40ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3QbnI.createElement((0, $720b4b44089c40ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $3QbnI.createElement($cd8cc81cff53fd72$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $3QbnI.createElement($cd8cc81cff53fd72$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $3QbnI.createElement((0, $720b4b44089c40ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3QbnI.createElement($cd8cc81cff53fd72$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $cd8cc81cff53fd72$var$MemoizedDataRoutes = /*#__PURE__*/ $3QbnI.memo($cd8cc81cff53fd72$var$DataRoutes);
function $cd8cc81cff53fd72$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $720b4b44089c40ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $cd8cc81cff53fd72$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $3QbnI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $98b25df047b2379b$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $cd8cc81cff53fd72$var$startTransitionImpl ? $cd8cc81cff53fd72$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3QbnI.useEffect(()=>(0, $720b4b44089c40ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $3QbnI.createElement((0, $720b4b44089c40ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $cd8cc81cff53fd72$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $3QbnI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $98b25df047b2379b$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $cd8cc81cff53fd72$var$startTransitionImpl ? $cd8cc81cff53fd72$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3QbnI.useEffect(()=>(0, $720b4b44089c40ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $3QbnI.createElement((0, $720b4b44089c40ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $cd8cc81cff53fd72$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $cd8cc81cff53fd72$var$startTransitionImpl ? $cd8cc81cff53fd72$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3QbnI.useEffect(()=>(0, $720b4b44089c40ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $3QbnI.createElement((0, $720b4b44089c40ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $cd8cc81cff53fd72$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $cd8cc81cff53fd72$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $cd8cc81cff53fd72$export$a6c7ac8248d6e38a = /*#__PURE__*/ $3QbnI.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $cd8cc81cff53fd72$var$_objectWithoutPropertiesLoose(_ref7, $cd8cc81cff53fd72$var$_excluded);
    let { basename: basename } = $3QbnI.useContext((0, $720b4b44089c40ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $cd8cc81cff53fd72$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($cd8cc81cff53fd72$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $98b25df047b2379b$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $720b4b44089c40ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $cd8cc81cff53fd72$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $3QbnI.createElement("a", $cd8cc81cff53fd72$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $cd8cc81cff53fd72$export$b0d92dbee9b5b60d = /*#__PURE__*/ $3QbnI.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $cd8cc81cff53fd72$var$_objectWithoutPropertiesLoose(_ref8, $cd8cc81cff53fd72$var$_excluded2);
    let path = (0, $720b4b44089c40ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $720b4b44089c40ed$export$45d76561a5302f2b)();
    let routerState = $3QbnI.useContext((0, $720b4b44089c40ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $3QbnI.useContext((0, $720b4b44089c40ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cd8cc81cff53fd72$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $98b25df047b2379b$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $3QbnI.createElement($cd8cc81cff53fd72$export$a6c7ac8248d6e38a, $cd8cc81cff53fd72$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $cd8cc81cff53fd72$export$a7fed597f4b8afd8 = /*#__PURE__*/ $3QbnI.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $cd8cc81cff53fd72$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $cd8cc81cff53fd72$var$_objectWithoutPropertiesLoose(_ref9, $cd8cc81cff53fd72$var$_excluded3);
    let submit = $cd8cc81cff53fd72$export$47c85c6e3a081d3();
    let formAction = $cd8cc81cff53fd72$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $3QbnI.createElement("form", $cd8cc81cff53fd72$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $cd8cc81cff53fd72$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $cd8cc81cff53fd72$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $cd8cc81cff53fd72$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($cd8cc81cff53fd72$var$DataRouterHook || ($cd8cc81cff53fd72$var$DataRouterHook = {}));
var $cd8cc81cff53fd72$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($cd8cc81cff53fd72$var$DataRouterStateHook || ($cd8cc81cff53fd72$var$DataRouterStateHook = {}));
// Internal hooks
function $cd8cc81cff53fd72$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $cd8cc81cff53fd72$var$useDataRouterContext(hookName) {
    let ctx = $3QbnI.useContext((0, $720b4b44089c40ed$export$3add0d5dce533e2e));
    !ctx && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $cd8cc81cff53fd72$var$useDataRouterState(hookName) {
    let state = $3QbnI.useContext((0, $720b4b44089c40ed$export$145dfa71566a64dc));
    !state && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $cd8cc81cff53fd72$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $720b4b44089c40ed$export$9770f232ac06a008)();
    let location = (0, $720b4b44089c40ed$export$45d76561a5302f2b)();
    let path = (0, $720b4b44089c40ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $3QbnI.useCallback((event)=>{
        if ($cd8cc81cff53fd72$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $98b25df047b2379b$export$fe53371bee54353d)(location) === (0, $98b25df047b2379b$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $cd8cc81cff53fd72$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $3QbnI.useRef($cd8cc81cff53fd72$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $3QbnI.useRef(false);
    let location = (0, $720b4b44089c40ed$export$45d76561a5302f2b)();
    let searchParams = $3QbnI.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $cd8cc81cff53fd72$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $720b4b44089c40ed$export$9770f232ac06a008)();
    let setSearchParams = $3QbnI.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $cd8cc81cff53fd72$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $cd8cc81cff53fd72$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $cd8cc81cff53fd72$var$fetcherId = 0;
let $cd8cc81cff53fd72$var$getUniqueFetcherId = ()=>"__" + String(++$cd8cc81cff53fd72$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $cd8cc81cff53fd72$export$47c85c6e3a081d3() {
    let { router: router } = $cd8cc81cff53fd72$var$useDataRouterContext($cd8cc81cff53fd72$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $3QbnI.useContext((0, $720b4b44089c40ed$export$26749e8557646306));
    let currentRouteId = (0, $720b4b44089c40ed$export$5fc8298006ad9e58)();
    return $3QbnI.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $cd8cc81cff53fd72$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $cd8cc81cff53fd72$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $cd8cc81cff53fd72$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $cd8cc81cff53fd72$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $3QbnI.useContext((0, $720b4b44089c40ed$export$26749e8557646306));
    let routeContext = $3QbnI.useContext((0, $720b4b44089c40ed$export$9072aa6dd1f93057));
    !routeContext && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $cd8cc81cff53fd72$var$_extends({}, (0, $720b4b44089c40ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $720b4b44089c40ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $98b25df047b2379b$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $98b25df047b2379b$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $cd8cc81cff53fd72$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $cd8cc81cff53fd72$var$useDataRouterContext($cd8cc81cff53fd72$var$DataRouterHook.UseFetcher);
    let state = $cd8cc81cff53fd72$var$useDataRouterState($cd8cc81cff53fd72$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $3QbnI.useContext($cd8cc81cff53fd72$export$148fd98d095596d4);
    let route = $3QbnI.useContext((0, $720b4b44089c40ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    !route && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $cd8cc81cff53fd72$var$useIdImpl ? $cd8cc81cff53fd72$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $3QbnI.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($cd8cc81cff53fd72$var$getUniqueFetcherId());
    // Registration/cleanup
    $3QbnI.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $3QbnI.useCallback((href, opts)=>{
        !routeId && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $cd8cc81cff53fd72$export$47c85c6e3a081d3();
    let submit = $3QbnI.useCallback((target, opts)=>{
        submitImpl(target, $cd8cc81cff53fd72$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $3QbnI.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $3QbnI.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $3QbnI.createElement($cd8cc81cff53fd72$export$a7fed597f4b8afd8, $cd8cc81cff53fd72$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $98b25df047b2379b$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $3QbnI.useMemo(()=>$cd8cc81cff53fd72$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $cd8cc81cff53fd72$export$fa996778a3a31087() {
    let state = $cd8cc81cff53fd72$var$useDataRouterState($cd8cc81cff53fd72$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $cd8cc81cff53fd72$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $cd8cc81cff53fd72$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $cd8cc81cff53fd72$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $cd8cc81cff53fd72$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $cd8cc81cff53fd72$var$useDataRouterContext($cd8cc81cff53fd72$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $cd8cc81cff53fd72$var$useDataRouterState($cd8cc81cff53fd72$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $3QbnI.useContext((0, $720b4b44089c40ed$export$26749e8557646306));
    let location = (0, $720b4b44089c40ed$export$45d76561a5302f2b)();
    let matches = (0, $720b4b44089c40ed$export$2378eb7f5ff86053)();
    let navigation = (0, $720b4b44089c40ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $3QbnI.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $cd8cc81cff53fd72$var$usePageHide($3QbnI.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $cd8cc81cff53fd72$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $cd8cc81cff53fd72$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($cd8cc81cff53fd72$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3QbnI.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $cd8cc81cff53fd72$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $cd8cc81cff53fd72$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3QbnI.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($cd8cc81cff53fd72$var$_extends({}, location, {
                    pathname: (0, $98b25df047b2379b$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($cd8cc81cff53fd72$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3QbnI.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $cd8cc81cff53fd72$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $3QbnI.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $cd8cc81cff53fd72$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $3QbnI.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $cd8cc81cff53fd72$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $720b4b44089c40ed$export$b273b3273281a049)(when);
    $3QbnI.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $3QbnI.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $cd8cc81cff53fd72$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $3QbnI.useContext($cd8cc81cff53fd72$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $98b25df047b2379b$export$3e9cee6b33872309)(false);
    let { basename: basename } = $cd8cc81cff53fd72$var$useDataRouterContext($cd8cc81cff53fd72$var$DataRouterHook.useViewTransitionState);
    let path = (0, $720b4b44089c40ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $98b25df047b2379b$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $98b25df047b2379b$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $98b25df047b2379b$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $98b25df047b2379b$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");

var $eTLbi = parcelRequire("eTLbi");

var $c4XO5 = parcelRequire("c4XO5");

var $hhWLk = parcelRequire("hhWLk");


var $e1vzu = parcelRequire("e1vzu");
'use client';
function $402ae9b0c7346bef$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $c4XO5.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $hhWLk.default));
    const Box = /*#__PURE__*/ $3QbnI.forwardRef(function Box(inProps, ref) {
        const theme = (0, $6338ced0c7678953$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $1a12cef9553d47e6$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $e1vzu.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $eTLbi.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}




var $gM6lN = parcelRequire("gM6lN");

var $5HuF3 = parcelRequire("5HuF3");

var $9t00Y = parcelRequire("9t00Y");

var $6N1Oq = parcelRequire("6N1Oq");
const $f57c2d8679082ad5$var$boxClasses = (0, $6N1Oq.default)('MuiBox', [
    'root'
]);
var $f57c2d8679082ad5$export$2e2bcd8739ae039 = $f57c2d8679082ad5$var$boxClasses;


'use client';
const $f8b3278ab2e44253$var$defaultTheme = (0, $5HuF3.default)();
const $f8b3278ab2e44253$var$Box = (0, $402ae9b0c7346bef$export$2e2bcd8739ae039)({
    themeId: (0, $9t00Y.default),
    defaultTheme: $f8b3278ab2e44253$var$defaultTheme,
    defaultClassName: (0, $f57c2d8679082ad5$export$2e2bcd8739ae039).root,
    generateClassName: (0, $gM6lN.default).generate
});
var $f8b3278ab2e44253$export$2e2bcd8739ae039 = $f8b3278ab2e44253$var$Box;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $9uBH9 = parcelRequire("9uBH9");

var $6q4c0 = parcelRequire("6q4c0");

var $kJVS9 = parcelRequire("kJVS9");

var $dTxTI = parcelRequire("dTxTI");
function $d3ecc5ee5bf2e81f$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $dTxTI.default)(theme.components[name].defaultProps, props);
}



'use client';
function $2d05d0cee982a7a9$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $6338ced0c7678953$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $d3ecc5ee5bf2e81f$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}



var $2rj5K = parcelRequire("2rj5K");
const $0179a2a026d07f51$var$styled = (0, $2rj5K.default)();
var $0179a2a026d07f51$export$2e2bcd8739ae039 = $0179a2a026d07f51$var$styled;



var $aTv5Z = parcelRequire("aTv5Z");

var $e1vzu = parcelRequire("e1vzu");
const $b967536a2d1066a4$var$defaultTheme = (0, $aTv5Z.default)();
const $b967536a2d1066a4$var$defaultCreateStyledComponent = (0, $0179a2a026d07f51$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $kJVS9.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $b967536a2d1066a4$var$useThemePropsDefault = (inProps)=>(0, $2d05d0cee982a7a9$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $b967536a2d1066a4$var$defaultTheme
    });
const $b967536a2d1066a4$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $9uBH9.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $kJVS9.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $6q4c0.default)(slots, getContainerUtilityClass, classes);
};
function $b967536a2d1066a4$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $b967536a2d1066a4$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $b967536a2d1066a4$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $3QbnI.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $b967536a2d1066a4$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $e1vzu.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $eTLbi.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}



var $iCj5F = parcelRequire("iCj5F");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");
'use client';
const $36497735a3d4d2c6$var$Container = (0, $b967536a2d1066a4$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $2TGnx.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $iCj5F.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $vqOnh.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $36497735a3d4d2c6$export$2e2bcd8739ae039 = $36497735a3d4d2c6$var$Container;


var $2TGnx = parcelRequire("2TGnx");


var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $2172f9942b69d6fb$export$46f01d01378ec5a2(slot) {
    return (0, $9uBH9.default)('MuiDivider', slot);
}
const $2172f9942b69d6fb$var$dividerClasses = (0, $6N1Oq.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $2172f9942b69d6fb$export$2e2bcd8739ae039 = $2172f9942b69d6fb$var$dividerClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $939fbaf970c0d6e6$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $2172f9942b69d6fb$export$46f01d01378ec5a2), classes);
};
const $939fbaf970c0d6e6$var$DividerRoot = (0, $2TGnx.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $aDUe6.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $939fbaf970c0d6e6$var$DividerWrapper = (0, $2TGnx.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $939fbaf970c0d6e6$var$Divider = /*#__PURE__*/ $3QbnI.forwardRef(function Divider(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $939fbaf970c0d6e6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($939fbaf970c0d6e6$var$DividerRoot, {
        as: component,
        className: (0, $eTLbi.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $e1vzu.jsx)($939fbaf970c0d6e6$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($939fbaf970c0d6e6$var$Divider) $939fbaf970c0d6e6$var$Divider.muiSkipListHighlight = true;
var $939fbaf970c0d6e6$export$2e2bcd8739ae039 = $939fbaf970c0d6e6$var$Divider;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $a9d629b449fd42c4$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $a9d629b449fd42c4$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($a9d629b449fd42c4$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $a9d629b449fd42c4$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $a9d629b449fd42c4$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $iCj5F = parcelRequire("iCj5F");

var $3QbnI = parcelRequire("3QbnI");
function $87272f125c22ec3f$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $3QbnI.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}


var $5e162abd78b4747c$export$2e2bcd8739ae039 = (0, $87272f125c22ec3f$export$2e2bcd8739ae039);



var $3QbnI = parcelRequire("3QbnI");
/**
 * @ignore - internal component.
 */ const $8dad3b560ba18d35$var$FormControlContext = /*#__PURE__*/ $3QbnI.createContext(undefined);
var $8dad3b560ba18d35$export$2e2bcd8739ae039 = $8dad3b560ba18d35$var$FormControlContext;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $3bcb1b223cc0a9eb$export$149c8b8bab2289d1(slot) {
    return (0, $9uBH9.default)('MuiFormControl', slot);
}
const $3bcb1b223cc0a9eb$var$formControlClasses = (0, $6N1Oq.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $3bcb1b223cc0a9eb$export$2e2bcd8739ae039 = $3bcb1b223cc0a9eb$var$formControlClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $3b5eaf40d4a4ccf9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $iCj5F.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $3bcb1b223cc0a9eb$export$149c8b8bab2289d1), classes);
};
const $3b5eaf40d4a4ccf9$var$FormControlRoot = (0, $2TGnx.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $iCj5F.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $3b5eaf40d4a4ccf9$var$FormControl = /*#__PURE__*/ $3QbnI.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $3b5eaf40d4a4ccf9$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $3QbnI.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $3QbnI.Children.forEach(children, (child)=>{
            if (!(0, $5e162abd78b4747c$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $5e162abd78b4747c$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $a9d629b449fd42c4$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $3QbnI.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $3QbnI.Children.forEach(children, (child)=>{
            if (!(0, $5e162abd78b4747c$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $a9d629b449fd42c4$export$d652b828d7fdeff8)(child.props, true) || (0, $a9d629b449fd42c4$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $3QbnI.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $3QbnI.useRef(false);
    const childContext = $3QbnI.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $8dad3b560ba18d35$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)($3b5eaf40d4a4ccf9$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $eTLbi.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $3b5eaf40d4a4ccf9$export$2e2bcd8739ae039 = $3b5eaf40d4a4ccf9$var$FormControl;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $d2323f13691b1a28$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $d2323f13691b1a28$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$d2323f13691b1a28$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $d2323f13691b1a28$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $d2323f13691b1a28$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}



var $vqOnh = parcelRequire("vqOnh");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");



var $6q4c0 = parcelRequire("6q4c0");
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $e226b59a5013eedd$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}



var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $3QbnI = parcelRequire("3QbnI");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b9c84d8c7ebb3ea8$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $379786810d55b52d$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $3QbnI.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $b9c84d8c7ebb3ea8$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $4978b4fb9409dfeb$export$2e2bcd8739ae039 = (0, $379786810d55b52d$export$2e2bcd8739ae039);



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $8a62ee10fb4c50e9$var$useEnhancedEffect = typeof window !== 'undefined' ? $3QbnI.useLayoutEffect : $3QbnI.useEffect;
var $8a62ee10fb4c50e9$export$2e2bcd8739ae039 = $8a62ee10fb4c50e9$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0509c5f692f68ee8$var$useEventCallback(fn) {
    const ref = $3QbnI.useRef(fn);
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $3QbnI.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0509c5f692f68ee8$export$2e2bcd8739ae039 = $0509c5f692f68ee8$var$useEventCallback;


'use client';
var $19d3d0bd329f2e26$export$2e2bcd8739ae039 = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039);



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
'use client';
const $89000223d5884135$var$UNINITIALIZED = {};
function $89000223d5884135$export$2e2bcd8739ae039(init, initArg) {
    const ref = $3QbnI.useRef($89000223d5884135$var$UNINITIALIZED);
    if (ref.current === $89000223d5884135$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


'use client';
class $cf63729e00aac991$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $cf63729e00aac991$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $89000223d5884135$export$2e2bcd8739ae039)($cf63729e00aac991$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $3QbnI.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $3QbnI.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $cf63729e00aac991$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $cf63729e00aac991$export$2e2bcd8739ae039() {
    return $cf63729e00aac991$export$f5de0641c7db4154.use();
}
function $cf63729e00aac991$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $3QbnI = parcelRequire("3QbnI");

function $4236c3996bc2da77$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $d0aSw = parcelRequire("d0aSw");
function $809e40422b06111b$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $80aca5e8512256e7$export$2e2bcd8739ae039(t, e) {
    return $80aca5e8512256e7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $80aca5e8512256e7$export$2e2bcd8739ae039(t, e);
}


function $f4e3ee416edaaba3$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $80aca5e8512256e7$export$2e2bcd8739ae039)(t, o);
}




var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
var $621f76fda559e4bc$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createContext(null);



var $3QbnI = parcelRequire("3QbnI");
function $aa7c2160e690d250$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $3QbnI.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $3QbnI.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $aa7c2160e690d250$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $aa7c2160e690d250$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $aa7c2160e690d250$export$fa71e2345c31d7a2(props, onExited) {
    return $aa7c2160e690d250$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $3QbnI.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $aa7c2160e690d250$var$getProp(child, 'appear', props),
            enter: $aa7c2160e690d250$var$getProp(child, 'enter', props),
            exit: $aa7c2160e690d250$var$getProp(child, 'exit', props)
        });
    });
}
function $aa7c2160e690d250$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $aa7c2160e690d250$export$bbc8a025727ea824(nextProps.children);
    var children = $aa7c2160e690d250$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $3QbnI.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $3QbnI.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $3QbnI.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $aa7c2160e690d250$var$getProp(child, 'exit', nextProps),
            enter: $aa7c2160e690d250$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $3QbnI.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $3QbnI.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $3QbnI.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $aa7c2160e690d250$var$getProp(child, 'exit', nextProps),
            enter: $aa7c2160e690d250$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $3640e533ee002e2a$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $3640e533ee002e2a$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $3640e533ee002e2a$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $f4e3ee416edaaba3$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $809e40422b06111b$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $aa7c2160e690d250$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $aa7c2160e690d250$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $aa7c2160e690d250$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $d0aSw.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $3640e533ee002e2a$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $621f76fda559e4bc$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $621f76fda559e4bc$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Component);
$3640e533ee002e2a$var$TransitionGroup.propTypes = {};
$3640e533ee002e2a$var$TransitionGroup.defaultProps = $3640e533ee002e2a$var$defaultProps;
var $3640e533ee002e2a$export$2e2bcd8739ae039 = $3640e533ee002e2a$var$TransitionGroup;



var $eTLbi = parcelRequire("eTLbi");


var $3QbnI = parcelRequire("3QbnI");
'use client';
const $484d5183f376362c$var$EMPTY = [];
function $484d5183f376362c$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $3QbnI.useEffect(fn, $484d5183f376362c$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $37c3f9b73e33b963$export$786b4da70f00938b {
    static create() {
        return new $37c3f9b73e33b963$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $37c3f9b73e33b963$export$2e2bcd8739ae039() {
    const timeout = (0, $89000223d5884135$export$2e2bcd8739ae039)($37c3f9b73e33b963$export$786b4da70f00938b.create).current;
    (0, $484d5183f376362c$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}



var $fPIjG = parcelRequire("fPIjG");
var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $e1vzu = parcelRequire("e1vzu");
'use client';
function $89e42dc241b9751a$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $3QbnI.useState(false);
    const rippleClassName = (0, $eTLbi.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $eTLbi.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $3QbnI.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
            className: childClassName
        })
    });
}
var $89e42dc241b9751a$export$2e2bcd8739ae039 = $89e42dc241b9751a$var$Ripple;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $665334e45e5a3207$export$b464606f735ab902(slot) {
    return (0, $9uBH9.default)('MuiTouchRipple', slot);
}
const $665334e45e5a3207$var$touchRippleClasses = (0, $6N1Oq.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $665334e45e5a3207$export$2e2bcd8739ae039 = $665334e45e5a3207$var$touchRippleClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $bdb1cb79ebd182e1$var$DURATION = 550;
const $bdb1cb79ebd182e1$export$95d0c9356b2231a3 = 80;
const $bdb1cb79ebd182e1$var$enterKeyframe = (0, $fPIjG.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $bdb1cb79ebd182e1$var$exitKeyframe = (0, $fPIjG.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $bdb1cb79ebd182e1$var$pulsateKeyframe = (0, $fPIjG.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $bdb1cb79ebd182e1$export$f6b7418508c72c25 = (0, $2TGnx.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $bdb1cb79ebd182e1$export$676cfe7b12693c4b = (0, $2TGnx.default)((0, $89e42dc241b9751a$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $665334e45e5a3207$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$bdb1cb79ebd182e1$var$enterKeyframe};
    animation-duration: ${$bdb1cb79ebd182e1$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $665334e45e5a3207$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $665334e45e5a3207$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $665334e45e5a3207$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$bdb1cb79ebd182e1$var$exitKeyframe};
    animation-duration: ${$bdb1cb79ebd182e1$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $665334e45e5a3207$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$bdb1cb79ebd182e1$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $bdb1cb79ebd182e1$var$TouchRipple = /*#__PURE__*/ $3QbnI.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $3QbnI.useState([]);
    const nextKey = $3QbnI.useRef(0);
    const rippleCallback = $3QbnI.useRef(null);
    $3QbnI.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $3QbnI.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $37c3f9b73e33b963$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $3QbnI.useRef(null);
    const container = $3QbnI.useRef(null);
    const startCommit = $3QbnI.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $e1vzu.jsx)($bdb1cb79ebd182e1$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $eTLbi.default)(classes.ripple, (0, $665334e45e5a3207$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $eTLbi.default)(classes.rippleVisible, (0, $665334e45e5a3207$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $eTLbi.default)(classes.ripplePulsate, (0, $665334e45e5a3207$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $eTLbi.default)(classes.child, (0, $665334e45e5a3207$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $eTLbi.default)(classes.childLeaving, (0, $665334e45e5a3207$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $eTLbi.default)(classes.childPulsate, (0, $665334e45e5a3207$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $bdb1cb79ebd182e1$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $3QbnI.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($bdb1cb79ebd182e1$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $3QbnI.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $3QbnI.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $3QbnI.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($bdb1cb79ebd182e1$export$f6b7418508c72c25, {
        className: (0, $eTLbi.default)((0, $665334e45e5a3207$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3640e533ee002e2a$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $bdb1cb79ebd182e1$export$2e2bcd8739ae039 = $bdb1cb79ebd182e1$var$TouchRipple;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $a5fc08e51483d286$export$fccb0498dcd99783(slot) {
    return (0, $9uBH9.default)('MuiButtonBase', slot);
}
const $a5fc08e51483d286$var$buttonBaseClasses = (0, $6N1Oq.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $a5fc08e51483d286$export$2e2bcd8739ae039 = $a5fc08e51483d286$var$buttonBaseClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $0c5993b2b6821c5b$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $a5fc08e51483d286$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $0c5993b2b6821c5b$export$7ec0dcc5e3cdcd36 = (0, $2TGnx.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $a5fc08e51483d286$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $0c5993b2b6821c5b$var$ButtonBase = /*#__PURE__*/ $3QbnI.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $3QbnI.useRef(null);
    const ripple = (0, $cf63729e00aac991$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $3QbnI.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $3QbnI.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $3QbnI.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $0c5993b2b6821c5b$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $e226b59a5013eedd$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $19d3d0bd329f2e26$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $e226b59a5013eedd$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $19d3d0bd329f2e26$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $19d3d0bd329f2e26$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $0c5993b2b6821c5b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($0c5993b2b6821c5b$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bdb1cb79ebd182e1$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $0c5993b2b6821c5b$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $19d3d0bd329f2e26$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $0c5993b2b6821c5b$export$2e2bcd8739ae039 = $0c5993b2b6821c5b$var$ButtonBase;



var $iCj5F = parcelRequire("iCj5F");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $f08e5dbc5ce70f3a$export$5e8702d71474f093(slot) {
    return (0, $9uBH9.default)('MuiIconButton', slot);
}
const $f08e5dbc5ce70f3a$var$iconButtonClasses = (0, $6N1Oq.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $f08e5dbc5ce70f3a$export$2e2bcd8739ae039 = $f08e5dbc5ce70f3a$var$iconButtonClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $a987e9ba7ec70360$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $iCj5F.default)(color)}`,
            edge && `edge${(0, $iCj5F.default)(edge)}`,
            `size${(0, $iCj5F.default)(size)}`
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $f08e5dbc5ce70f3a$export$5e8702d71474f093), classes);
};
const $a987e9ba7ec70360$var$IconButtonRoot = (0, $2TGnx.default)((0, $0c5993b2b6821c5b$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $iCj5F.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $iCj5F.default)(ownerState.edge)}`],
            styles[`size${(0, $iCj5F.default)(ownerState.size)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $gvYl6.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $f08e5dbc5ce70f3a$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    })));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $a987e9ba7ec70360$var$IconButton = /*#__PURE__*/ $3QbnI.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', ...other } = props;
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    };
    const classes = $a987e9ba7ec70360$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($a987e9ba7ec70360$var$IconButtonRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children
    });
});
var $a987e9ba7ec70360$export$2e2bcd8739ae039 = $a987e9ba7ec70360$var$IconButton;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $3QbnI = parcelRequire("3QbnI");
'use client';
/**
 * @ignore - internal component.
 */ const $3fa9e52ed0665cfa$var$ListContext = /*#__PURE__*/ $3QbnI.createContext({});
var $3fa9e52ed0665cfa$export$2e2bcd8739ae039 = $3fa9e52ed0665cfa$var$ListContext;




'use client';
var $e5c931354b647203$export$2e2bcd8739ae039 = (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039);





var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $8bc1d622aa009c6a$export$81478e24460c57f2(slot) {
    return (0, $9uBH9.default)('MuiListItemIcon', slot);
}
const $8bc1d622aa009c6a$var$listItemIconClasses = (0, $6N1Oq.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $8bc1d622aa009c6a$export$2e2bcd8739ae039 = $8bc1d622aa009c6a$var$listItemIconClasses;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $9ec058eb019e7fdb$export$1061006a0db3aeb5(slot) {
    return (0, $9uBH9.default)('MuiListItemText', slot);
}
const $9ec058eb019e7fdb$var$listItemTextClasses = (0, $6N1Oq.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $9ec058eb019e7fdb$export$2e2bcd8739ae039 = $9ec058eb019e7fdb$var$listItemTextClasses;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $873b45c13480462b$export$515f8c67b5305377(slot) {
    return (0, $9uBH9.default)('MuiMenuItem', slot);
}
const $873b45c13480462b$var$menuItemClasses = (0, $6N1Oq.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $873b45c13480462b$export$2e2bcd8739ae039 = $873b45c13480462b$var$menuItemClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $a617846d6b4c8545$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $a617846d6b4c8545$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $873b45c13480462b$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $a617846d6b4c8545$var$MenuItemRoot = (0, $2TGnx.default)((0, $0c5993b2b6821c5b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $a617846d6b4c8545$export$4334bb34c76fef24
})((0, $gvYl6.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $873b45c13480462b$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aDUe6.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $873b45c13480462b$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aDUe6.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $873b45c13480462b$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aDUe6.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aDUe6.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $873b45c13480462b$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $873b45c13480462b$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $2172f9942b69d6fb$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $2172f9942b69d6fb$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $9ec058eb019e7fdb$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $9ec058eb019e7fdb$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $8bc1d622aa009c6a$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $8bc1d622aa009c6a$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $a617846d6b4c8545$var$MenuItem = /*#__PURE__*/ $3QbnI.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $3QbnI.useContext((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039));
    const childContext = $3QbnI.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $3QbnI.useRef(null);
    (0, $e5c931354b647203$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $a617846d6b4c8545$var$useUtilityClasses(props);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)($a617846d6b4c8545$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $eTLbi.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $eTLbi.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $a617846d6b4c8545$export$2e2bcd8739ae039 = $a617846d6b4c8545$var$MenuItem;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6s3yU = parcelRequire("6s3yU");

var $3QbnI = parcelRequire("3QbnI");
function $bca562fe1e155add$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($3QbnI.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}



var $eClrZ = parcelRequire("eClrZ");

var $3QbnI = parcelRequire("3QbnI");



var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $3QbnI = parcelRequire("3QbnI");
'use client';
let $259168cd063bb08e$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $259168cd063bb08e$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $3QbnI.useState(idOverride);
    const id = idOverride || defaultId;
    $3QbnI.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $259168cd063bb08e$var$globalId += 1;
            setDefaultId(`mui-${$259168cd063bb08e$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $259168cd063bb08e$var$safeReact = {
    ...$3QbnI
};
const $259168cd063bb08e$var$maybeReactUseId = $259168cd063bb08e$var$safeReact.useId;
function $259168cd063bb08e$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($259168cd063bb08e$var$maybeReactUseId !== undefined) {
        const reactId = $259168cd063bb08e$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $259168cd063bb08e$var$useGlobalId(idOverride);
}



function $364fe2bc6e6def98$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $f41f841251e5a65d$export$2e2bcd8739ae039 = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039);



var $iCj5F = parcelRequire("iCj5F");

var $3QbnI = parcelRequire("3QbnI");



var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");


var $3QbnI = parcelRequire("3QbnI");


var $e1vzu = parcelRequire("e1vzu");
const $d5e4f702f718a3e5$var$RtlContext = /*#__PURE__*/ $3QbnI.createContext();
function $d5e4f702f718a3e5$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $e1vzu.jsx)($d5e4f702f718a3e5$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $d5e4f702f718a3e5$export$b2dd014b6c321cb = ()=>{
    const value = $3QbnI.useContext($d5e4f702f718a3e5$var$RtlContext);
    return value ?? false;
};
var $d5e4f702f718a3e5$export$2e2bcd8739ae039 = $d5e4f702f718a3e5$var$RtlProvider;



/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $ccd98d6adeb086b1$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $ccd98d6adeb086b1$export$2e2bcd8739ae039 = $ccd98d6adeb086b1$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $efcd13002232f5f8$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $ccd98d6adeb086b1$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $efcd13002232f5f8$export$2e2bcd8739ae039 = $efcd13002232f5f8$var$appendOwnerState;



var $eTLbi = parcelRequire("eTLbi");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f3e8559e1708ae98$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $f3e8559e1708ae98$export$2e2bcd8739ae039 = $f3e8559e1708ae98$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $83f221f6f2c67e8e$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $83f221f6f2c67e8e$export$2e2bcd8739ae039 = $83f221f6f2c67e8e$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $e7af0febd6440bfa$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $eTLbi.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f3e8559e1708ae98$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $83f221f6f2c67e8e$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $83f221f6f2c67e8e$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $eTLbi.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $e7af0febd6440bfa$export$2e2bcd8739ae039 = $e7af0febd6440bfa$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $36bb804687c6ae15$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $36bb804687c6ae15$export$2e2bcd8739ae039 = $36bb804687c6ae15$var$resolveComponentProps;


'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $9a3742669d0259c9$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $36bb804687c6ae15$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $e7af0febd6440bfa$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $379786810d55b52d$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $efcd13002232f5f8$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $9a3742669d0259c9$export$2e2bcd8739ae039 = $9a3742669d0259c9$var$useSlotProps;



var $3QbnI = parcelRequire("3QbnI");




var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $007134a8a21fccc4$export$c6bd6795ed6e3203(slot) {
    return (0, $9uBH9.default)('MuiList', slot);
}
const $007134a8a21fccc4$var$listClasses = (0, $6N1Oq.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $007134a8a21fccc4$export$2e2bcd8739ae039 = $007134a8a21fccc4$var$listClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $bf4c6525c729e6fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $007134a8a21fccc4$export$c6bd6795ed6e3203), classes);
};
const $bf4c6525c729e6fe$var$ListRoot = (0, $2TGnx.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $bf4c6525c729e6fe$var$List = /*#__PURE__*/ $3QbnI.forwardRef(function List(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $3QbnI.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $bf4c6525c729e6fe$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $e1vzu.jsxs)($bf4c6525c729e6fe$var$ListRoot, {
            as: component,
            className: (0, $eTLbi.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $bf4c6525c729e6fe$export$2e2bcd8739ae039 = $bf4c6525c729e6fe$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $dc582ec3cd1bc541$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


var $722f5b1dde084cf7$export$2e2bcd8739ae039 = (0, $dc582ec3cd1bc541$export$2e2bcd8739ae039);





function $7b66579d2a58d2e2$export$2e2bcd8739ae039(node) {
    const doc = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $b28ea63c2ae297a4$export$2e2bcd8739ae039 = (0, $7b66579d2a58d2e2$export$2e2bcd8739ae039);



var $e1vzu = parcelRequire("e1vzu");
'use client';
function $bf6e0ea2c52aa623$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $bf6e0ea2c52aa623$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $bf6e0ea2c52aa623$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $bf6e0ea2c52aa623$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$bf6e0ea2c52aa623$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $bf6e0ea2c52aa623$var$MenuList = /*#__PURE__*/ $3QbnI.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $3QbnI.useRef(null);
    const textCriteriaRef = $3QbnI.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $e5c931354b647203$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $3QbnI.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $722f5b1dde084cf7$export$2e2bcd8739ae039)((0, $b28ea63c2ae297a4$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $f41f841251e5a65d$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $bf6e0ea2c52aa623$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $bf6e0ea2c52aa623$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $bf6e0ea2c52aa623$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $bf6e0ea2c52aa623$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $bf6e0ea2c52aa623$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $bf6e0ea2c52aa623$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $bf6e0ea2c52aa623$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $bf6e0ea2c52aa623$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $bf6e0ea2c52aa623$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $bf6e0ea2c52aa623$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $bf6e0ea2c52aa623$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $3QbnI.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $3QbnI.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $3QbnI.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $3QbnI.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $bf6e0ea2c52aa623$export$2e2bcd8739ae039 = $bf6e0ea2c52aa623$var$MenuList;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");





/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $d5877b474787d752$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $d5877b474787d752$export$2e2bcd8739ae039 = $d5877b474787d752$var$isHostComponent;



var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cc8593cbaa1b939$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $9ec20cee79d7bc2e$export$2e2bcd8739ae039 = (0, $7cc8593cbaa1b939$export$2e2bcd8739ae039);






var $3QbnI = parcelRequire("3QbnI");








var $3QbnI = parcelRequire("3QbnI");

var $a375b988a1398449$export$2e2bcd8739ae039 = {
    disabled: false
};




var $d30acf729f2ab9f0$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $310f30916c86eca9$export$bb38bb9a1161268 = 'unmounted';
var $310f30916c86eca9$export$84cbff306f539230 = 'exited';
var $310f30916c86eca9$export$df38205c966be359 = 'entering';
var $310f30916c86eca9$export$78e9e6e3e014d60a = 'entered';
var $310f30916c86eca9$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $310f30916c86eca9$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $f4e3ee416edaaba3$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $310f30916c86eca9$export$84cbff306f539230;
                _this.appearStatus = $310f30916c86eca9$export$df38205c966be359;
            } else initialStatus = $310f30916c86eca9$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $310f30916c86eca9$export$bb38bb9a1161268;
        else initialStatus = $310f30916c86eca9$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $310f30916c86eca9$export$bb38bb9a1161268) return {
            status: $310f30916c86eca9$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $310f30916c86eca9$export$df38205c966be359 && status !== $310f30916c86eca9$export$78e9e6e3e014d60a) nextStatus = $310f30916c86eca9$export$df38205c966be359;
            } else if (status === $310f30916c86eca9$export$df38205c966be359 || status === $310f30916c86eca9$export$78e9e6e3e014d60a) nextStatus = $310f30916c86eca9$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $310f30916c86eca9$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($70c58451959e30b3$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $d30acf729f2ab9f0$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $310f30916c86eca9$export$84cbff306f539230) this.setState({
            status: $310f30916c86eca9$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($70c58451959e30b3$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $a375b988a1398449$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $310f30916c86eca9$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $310f30916c86eca9$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $310f30916c86eca9$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($70c58451959e30b3$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $a375b988a1398449$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $310f30916c86eca9$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $310f30916c86eca9$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $310f30916c86eca9$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($70c58451959e30b3$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $310f30916c86eca9$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $621f76fda559e4bc$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Component);
$310f30916c86eca9$var$Transition.contextType = (0, $621f76fda559e4bc$export$2e2bcd8739ae039);
$310f30916c86eca9$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $310f30916c86eca9$var$noop() {}
$310f30916c86eca9$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $310f30916c86eca9$var$noop,
    onEntering: $310f30916c86eca9$var$noop,
    onEntered: $310f30916c86eca9$var$noop,
    onExit: $310f30916c86eca9$var$noop,
    onExiting: $310f30916c86eca9$var$noop,
    onExited: $310f30916c86eca9$var$noop
};
$310f30916c86eca9$var$Transition.UNMOUNTED = $310f30916c86eca9$export$bb38bb9a1161268;
$310f30916c86eca9$var$Transition.EXITED = $310f30916c86eca9$export$84cbff306f539230;
$310f30916c86eca9$var$Transition.ENTERING = $310f30916c86eca9$export$df38205c966be359;
$310f30916c86eca9$var$Transition.ENTERED = $310f30916c86eca9$export$78e9e6e3e014d60a;
$310f30916c86eca9$var$Transition.EXITING = $310f30916c86eca9$export$4aacc83d4d59139f;
var $310f30916c86eca9$export$2e2bcd8739ae039 = $310f30916c86eca9$var$Transition;



const $239bb4b3aee172ac$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $239bb4b3aee172ac$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




var $e1vzu = parcelRequire("e1vzu");
'use client';
function $d0716261e6e32602$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d0716261e6e32602$var$styles = {
    entering: {
        opacity: 1,
        transform: $d0716261e6e32602$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d0716261e6e32602$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d0716261e6e32602$var$Grow = /*#__PURE__*/ $3QbnI.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $310f30916c86eca9$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $37c3f9b73e33b963$export$2e2bcd8739ae039)();
    const autoTimeout = $3QbnI.useRef();
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const nodeRef = $3QbnI.useRef(null);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(nodeRef, (0, $bca562fe1e155add$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $239bb4b3aee172ac$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d0716261e6e32602$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d0716261e6e32602$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d0716261e6e32602$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d0716261e6e32602$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, childProps)=>{
            return /*#__PURE__*/ $3QbnI.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $d0716261e6e32602$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$d0716261e6e32602$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...childProps
            });
        }
    });
});
if ($d0716261e6e32602$var$Grow) $d0716261e6e32602$var$Grow.muiSupportAuto = true;
var $d0716261e6e32602$export$2e2bcd8739ae039 = $d0716261e6e32602$var$Grow;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");



var $6q4c0 = parcelRequire("6q4c0");

var $3QbnI = parcelRequire("3QbnI");



var $e1vzu = parcelRequire("e1vzu");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $460ee4c98546d2fa$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $460ee4c98546d2fa$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $460ee4c98546d2fa$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $460ee4c98546d2fa$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $460ee4c98546d2fa$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $460ee4c98546d2fa$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($460ee4c98546d2fa$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $460ee4c98546d2fa$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$460ee4c98546d2fa$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $460ee4c98546d2fa$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $460ee4c98546d2fa$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $460ee4c98546d2fa$var$defaultGetTabbable, isEnabled: isEnabled = $460ee4c98546d2fa$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $3QbnI.useRef(false);
    const sentinelStart = $3QbnI.useRef(null);
    const sentinelEnd = $3QbnI.useRef(null);
    const nodeToRestore = $3QbnI.useRef(null);
    const reactFocusEventTarget = $3QbnI.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $3QbnI.useRef(false);
    const rootRef = $3QbnI.useRef(null);
    const handleRef = (0, $379786810d55b52d$export$2e2bcd8739ae039)((0, $bca562fe1e155add$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $3QbnI.useRef(null);
    $3QbnI.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $3QbnI.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $3QbnI.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $3QbnI.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $460ee4c98546d2fa$export$2e2bcd8739ae039 = $460ee4c98546d2fa$var$FocusTrap;



var $3QbnI = parcelRequire("3QbnI");



'use client';
function $42d10c775b10147e$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $42d10c775b10147e$var$Portal = /*#__PURE__*/ $3QbnI.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $3QbnI.useState(null);
    const handleRef = (0, $379786810d55b52d$export$2e2bcd8739ae039)(/*#__PURE__*/ $3QbnI.isValidElement(children) ? (0, $bca562fe1e155add$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($42d10c775b10147e$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $b9c84d8c7ebb3ea8$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $b9c84d8c7ebb3ea8$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $3QbnI.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $3QbnI.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $70c58451959e30b3$exports.createPortal(children, mountNode) : mountNode;
});
var $42d10c775b10147e$export$2e2bcd8739ae039 = $42d10c775b10147e$var$Portal;



var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");




'use client';
function $bb288bdf2a03294b$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $36bb804687c6ae15$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $e7af0febd6440bfa$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $379786810d55b52d$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $efcd13002232f5f8$export$2e2bcd8739ae039)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && {
            as: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



var $3QbnI = parcelRequire("3QbnI");








var $e1vzu = parcelRequire("e1vzu");
'use client';
const $48f59d453896b6cd$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $48f59d453896b6cd$var$Fade = /*#__PURE__*/ $3QbnI.forwardRef(function Fade(props, ref) {
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $310f30916c86eca9$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $3QbnI.useRef(null);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(nodeRef, (0, $bca562fe1e155add$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $239bb4b3aee172ac$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, childProps)=>{
            return /*#__PURE__*/ $3QbnI.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$48f59d453896b6cd$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...childProps
            });
        }
    });
});
var $48f59d453896b6cd$export$2e2bcd8739ae039 = $48f59d453896b6cd$var$Fade;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $1d5e305646badc04$export$9927a91fd93152bd(slot) {
    return (0, $9uBH9.default)('MuiBackdrop', slot);
}
const $1d5e305646badc04$var$backdropClasses = (0, $6N1Oq.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $1d5e305646badc04$export$2e2bcd8739ae039 = $1d5e305646badc04$var$backdropClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $612130d157852fe1$var$removeOwnerState = (props)=>{
    const { ownerState: ownerState, ...rest } = props;
    return rest;
};
const $612130d157852fe1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $1d5e305646badc04$export$9927a91fd93152bd), classes);
};
const $612130d157852fe1$var$BackdropRoot = (0, $2TGnx.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $612130d157852fe1$var$Backdrop = /*#__PURE__*/ $3QbnI.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $612130d157852fe1$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('root', {
        elementType: $612130d157852fe1$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $48f59d453896b6cd$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const transitionPropsRemoved = $612130d157852fe1$var$removeOwnerState(transitionProps);
    return /*#__PURE__*/ (0, $e1vzu.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionPropsRemoved,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $612130d157852fe1$export$2e2bcd8739ae039 = $612130d157852fe1$var$Backdrop;



var $3QbnI = parcelRequire("3QbnI");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $e02e87e7b16fff5e$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $0a6aae8dd1c95685$var$isOverflowing(container) {
    const doc = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $7b66579d2a58d2e2$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $0a6aae8dd1c95685$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $0a6aae8dd1c95685$var$getPaddingRight(element) {
    return parseInt((0, $7b66579d2a58d2e2$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $0a6aae8dd1c95685$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $0a6aae8dd1c95685$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$0a6aae8dd1c95685$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $0a6aae8dd1c95685$export$e1bd0c6150f13d96(element, hide);
    });
}
function $0a6aae8dd1c95685$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $0a6aae8dd1c95685$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($0a6aae8dd1c95685$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $dc582ec3cd1bc541$export$2e2bcd8739ae039)((0, $7b66579d2a58d2e2$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$0a6aae8dd1c95685$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$0a6aae8dd1c95685$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $7b66579d2a58d2e2$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $0a6aae8dd1c95685$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $0a6aae8dd1c95685$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $0a6aae8dd1c95685$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $0a6aae8dd1c95685$var$getHiddenSiblings(container);
        $0a6aae8dd1c95685$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $0a6aae8dd1c95685$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $0a6aae8dd1c95685$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $0a6aae8dd1c95685$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $0a6aae8dd1c95685$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $0a6aae8dd1c95685$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $0a6aae8dd1c95685$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $0a6aae8dd1c95685$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $6c2a715c75119b5d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $6c2a715c75119b5d$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $6c2a715c75119b5d$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $6c2a715c75119b5d$var$manager = new (0, $0a6aae8dd1c95685$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $6c2a715c75119b5d$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $3QbnI.useRef({});
    const mountNodeRef = $3QbnI.useRef(null);
    const modalRef = $3QbnI.useRef(null);
    const handleRef = (0, $379786810d55b52d$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $3QbnI.useState(!open);
    const hasTransition = $6c2a715c75119b5d$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $6c2a715c75119b5d$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $6c2a715c75119b5d$var$getContainer(container) || getDoc().body;
        $6c2a715c75119b5d$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$6c2a715c75119b5d$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $0a6aae8dd1c95685$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $3QbnI.useCallback(()=>{
        $6c2a715c75119b5d$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $3QbnI.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $3QbnI.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f3e8559e1708ae98$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $e02e87e7b16fff5e$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $6c2a715c75119b5d$var$noop),
            onExited: (0, $e02e87e7b16fff5e$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $6c2a715c75119b5d$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $6c2a715c75119b5d$export$2e2bcd8739ae039 = $6c2a715c75119b5d$var$useModal;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $0848cbb6be0f27c8$export$67960e22b12a638d(slot) {
    return (0, $9uBH9.default)('MuiModal', slot);
}
const $0848cbb6be0f27c8$var$modalClasses = (0, $6N1Oq.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0848cbb6be0f27c8$export$2e2bcd8739ae039 = $0848cbb6be0f27c8$var$modalClasses;





var $e1vzu = parcelRequire("e1vzu");
'use client';
const $a331e411240678bd$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $0848cbb6be0f27c8$export$67960e22b12a638d), classes);
};
const $a331e411240678bd$var$ModalRoot = (0, $2TGnx.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $a331e411240678bd$var$ModalBackdrop = (0, $2TGnx.default)((0, $612130d157852fe1$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a331e411240678bd$var$Modal = /*#__PURE__*/ $3QbnI.forwardRef(function Modal(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a331e411240678bd$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $6c2a715c75119b5d$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $a331e411240678bd$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        ...other,
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('root', {
        elementType: $a331e411240678bd$var$ModalRoot,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $eTLbi.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('backdrop', {
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $eTLbi.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    const backdropRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(BackdropProps?.ref, backdropProps.ref);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $42d10c775b10147e$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $e1vzu.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $e1vzu.jsx)(BackdropSlot, {
                    ...backdropProps,
                    ref: backdropRef
                }) : null,
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $460ee4c98546d2fa$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $3QbnI.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $a331e411240678bd$export$2e2bcd8739ae039 = $a331e411240678bd$var$Modal;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");



var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $Kxjv6 = parcelRequire("Kxjv6");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $28b2d6668157aae8$export$29cdb466b9b6f20b(slot) {
    return (0, $9uBH9.default)('MuiPaper', slot);
}
const $28b2d6668157aae8$var$paperClasses = (0, $6N1Oq.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $28b2d6668157aae8$export$2e2bcd8739ae039 = $28b2d6668157aae8$var$paperClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $ef888684c47e6b36$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $28b2d6668157aae8$export$29cdb466b9b6f20b), classes);
};
const $ef888684c47e6b36$var$PaperRoot = (0, $2TGnx.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $ef888684c47e6b36$var$Paper = /*#__PURE__*/ $3QbnI.forwardRef(function Paper(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $ef888684c47e6b36$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($ef888684c47e6b36$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $eTLbi.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $aDUe6.alpha)('#fff', (0, $Kxjv6.default)(elevation))}, ${(0, $aDUe6.alpha)('#fff', (0, $Kxjv6.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $ef888684c47e6b36$export$2e2bcd8739ae039 = $ef888684c47e6b36$var$Paper;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $22e2f9307027539f$export$88f455dd56c95edb(slot) {
    return (0, $9uBH9.default)('MuiPopover', slot);
}
const $22e2f9307027539f$var$popoverClasses = (0, $6N1Oq.default)('MuiPopover', [
    'root',
    'paper'
]);
var $22e2f9307027539f$export$2e2bcd8739ae039 = $22e2f9307027539f$var$popoverClasses;




var $e1vzu = parcelRequire("e1vzu");
'use client';
function $cdb00c98373196ed$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $cdb00c98373196ed$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $cdb00c98373196ed$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $cdb00c98373196ed$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $cdb00c98373196ed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $22e2f9307027539f$export$88f455dd56c95edb), classes);
};
const $cdb00c98373196ed$export$bcce13685275fc99 = (0, $2TGnx.default)((0, $a331e411240678bd$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $cdb00c98373196ed$export$821346c38a2d9390 = (0, $2TGnx.default)((0, $ef888684c47e6b36$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $cdb00c98373196ed$var$Popover = /*#__PURE__*/ $3QbnI.forwardRef(function Popover(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $d0716261e6e32602$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, disableScrollLock: disableScrollLock = false, ...other } = props;
    const externalPaperSlotProps = slotProps?.paper ?? PaperPropsProp;
    const paperRef = $3QbnI.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $cdb00c98373196ed$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $3QbnI.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $cdb00c98373196ed$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $f41f841251e5a65d$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $cdb00c98373196ed$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $cdb00c98373196ed$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $3QbnI.useCallback((elemRect)=>{
        return {
            vertical: $cdb00c98373196ed$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $cdb00c98373196ed$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $3QbnI.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $cdb00c98373196ed$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $b28ea63c2ae297a4$export$2e2bcd8739ae039)($cdb00c98373196ed$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $cdb00c98373196ed$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $3QbnI.useState(open);
    const setPositioningStyles = $3QbnI.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $3QbnI.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $3QbnI.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $3QbnI.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $3QbnI.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $9ec20cee79d7bc2e$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $b28ea63c2ae297a4$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $f41f841251e5a65d$export$2e2bcd8739ae039)($cdb00c98373196ed$var$resolveAnchorEl(anchorEl)).body : undefined);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...slotProps,
            paper: externalPaperSlotProps
        }
    };
    const [PaperSlot, paperProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('paper', {
        elementType: $cdb00c98373196ed$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: elevation,
            className: (0, $eTLbi.default)(classes.paper, externalPaperSlotProps?.className),
            style: isPositioned ? externalPaperSlotProps.style : {
                ...externalPaperSlotProps.style,
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    const [RootSlot, { slotProps: rootSlotPropsProp, ...rootProps }] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('root', {
        elementType: $cdb00c98373196ed$export$bcce13685275fc99,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $eTLbi.default)(classes.root, className)
    });
    const handlePaperRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(paperRef, paperProps.ref);
    return /*#__PURE__*/ (0, $e1vzu.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $d5877b474787d752$export$2e2bcd8739ae039)(RootSlot) && {
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        ...other,
        ref: ref,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)(TransitionComponent, {
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration,
            ...TransitionProps,
            children: /*#__PURE__*/ (0, $e1vzu.jsx)(PaperSlot, {
                ...paperProps,
                ref: handlePaperRef,
                children: children
            })
        })
    });
});
var $cdb00c98373196ed$export$2e2bcd8739ae039 = $cdb00c98373196ed$var$Popover;



var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $bf400ad53f963868$export$2cf86a63a84fe23d(slot) {
    return (0, $9uBH9.default)('MuiMenu', slot);
}
const $bf400ad53f963868$var$menuClasses = (0, $6N1Oq.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $bf400ad53f963868$export$2e2bcd8739ae039 = $bf400ad53f963868$var$menuClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $e51996f3f7726802$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $e51996f3f7726802$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $e51996f3f7726802$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $bf400ad53f963868$export$2cf86a63a84fe23d), classes);
};
const $e51996f3f7726802$var$MenuRoot = (0, $2TGnx.default)((0, $cdb00c98373196ed$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $e51996f3f7726802$export$4f7c51a5920c9f33 = (0, $2TGnx.default)((0, $cdb00c98373196ed$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $e51996f3f7726802$var$MenuMenuList = (0, $2TGnx.default)((0, $bf6e0ea2c52aa623$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $e51996f3f7726802$var$Menu = /*#__PURE__*/ $3QbnI.forwardRef(function Menu(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $d5e4f702f718a3e5$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $e51996f3f7726802$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $3QbnI.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $3QbnI.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $3QbnI.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = slots.paper ?? $e51996f3f7726802$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = slotProps.paper ?? PaperProps;
    const rootSlotProps = (0, $9a3742669d0259c9$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $9a3742669d0259c9$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $e1vzu.jsx)($e51996f3f7726802$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $e51996f3f7726802$var$RTL_ORIGIN : $e51996f3f7726802$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: {
            onEntering: handleEntering,
            ...TransitionProps
        },
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)($e51996f3f7726802$var$MenuMenuList, {
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...MenuListProps,
            className: (0, $eTLbi.default)(classes.list, MenuListProps.className),
            children: children
        })
    });
});
var $e51996f3f7726802$export$2e2bcd8739ae039 = $e51996f3f7726802$var$Menu;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");

var $iCj5F = parcelRequire("iCj5F");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $c0f934ff7f73eedb$export$1ee13051fd9e2ab5(slot) {
    return (0, $9uBH9.default)('MuiNativeSelect', slot);
}
const $c0f934ff7f73eedb$var$nativeSelectClasses = (0, $6N1Oq.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $c0f934ff7f73eedb$export$2e2bcd8739ae039 = $c0f934ff7f73eedb$var$nativeSelectClasses;



var $2TGnx = parcelRequire("2TGnx");

var $ajKPH = parcelRequire("ajKPH");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $db34b39dba9f682b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $iCj5F.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $c0f934ff7f73eedb$export$1ee13051fd9e2ab5), classes);
};
const $db34b39dba9f682b$export$50b3545a8ccd87af = (0, $2TGnx.default)('select')(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $c0f934ff7f73eedb$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $db34b39dba9f682b$var$NativeSelectSelect = (0, $2TGnx.default)($db34b39dba9f682b$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $ajKPH.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $c0f934ff7f73eedb$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $db34b39dba9f682b$export$7dd4d92f143902e3 = (0, $2TGnx.default)('svg')(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $c0f934ff7f73eedb$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $db34b39dba9f682b$var$NativeSelectIcon = (0, $2TGnx.default)($db34b39dba9f682b$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iCj5F.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $db34b39dba9f682b$var$NativeSelectInput = /*#__PURE__*/ $3QbnI.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $db34b39dba9f682b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)($db34b39dba9f682b$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $eTLbi.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $e1vzu.jsx)($db34b39dba9f682b$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db34b39dba9f682b$export$2e2bcd8739ae039 = $db34b39dba9f682b$var$NativeSelectInput;




var $2TGnx = parcelRequire("2TGnx");

var $97ZIb = parcelRequire("97ZIb");


var $3QbnI = parcelRequire("3QbnI");
'use client';
function $b5a691d7d09c9d6d$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $3QbnI.useRef(controlled !== undefined);
    const [valueState, setValue] = $3QbnI.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $3QbnI.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $29c9d441247d5905$export$2e2bcd8739ae039 = (0, $b5a691d7d09c9d6d$export$2e2bcd8739ae039);



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $94f9f768c89b17cc$export$2c0c1ee5a3392e(slot) {
    return (0, $9uBH9.default)('MuiSelect', slot);
}
const $94f9f768c89b17cc$var$selectClasses = (0, $6N1Oq.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $94f9f768c89b17cc$export$2e2bcd8739ae039 = $94f9f768c89b17cc$var$selectClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
var $6648ce8dad022cc8$var$_span;
const $6648ce8dad022cc8$var$SelectSelect = (0, $2TGnx.default)((0, $db34b39dba9f682b$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $94f9f768c89b17cc$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $94f9f768c89b17cc$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $94f9f768c89b17cc$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $94f9f768c89b17cc$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $94f9f768c89b17cc$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $6648ce8dad022cc8$var$SelectIcon = (0, $2TGnx.default)((0, $db34b39dba9f682b$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iCj5F.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $6648ce8dad022cc8$var$SelectNativeInput = (0, $2TGnx.default)('input', {
    shouldForwardProp: (prop)=>(0, $97ZIb.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $6648ce8dad022cc8$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $6648ce8dad022cc8$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $6648ce8dad022cc8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $iCj5F.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $94f9f768c89b17cc$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $6648ce8dad022cc8$var$SelectInput = /*#__PURE__*/ $3QbnI.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $29c9d441247d5905$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $29c9d441247d5905$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $3QbnI.useRef(null);
    const displayRef = $3QbnI.useRef(null);
    const [displayNode, setDisplayNode] = $3QbnI.useState(null);
    const { current: isOpenControlled } = $3QbnI.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $3QbnI.useState();
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $3QbnI.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $3QbnI.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $3QbnI.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $3QbnI.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $3QbnI.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $f41f841251e5a65d$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $3QbnI.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $a9d629b449fd42c4$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $3QbnI.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $eClrZ.default)(2));
            selected = value.some((v)=>$6648ce8dad022cc8$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $6648ce8dad022cc8$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $3QbnI.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $6648ce8dad022cc8$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $259168cd063bb08e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)($6648ce8dad022cc8$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $eTLbi.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $6648ce8dad022cc8$var$isEmpty(display) ? $6648ce8dad022cc8$var$_span || ($6648ce8dad022cc8$var$_span = /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)($6648ce8dad022cc8$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)($6648ce8dad022cc8$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e51996f3f7726802$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                MenuListProps: {
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId,
                    ...MenuProps.MenuListProps
                },
                slotProps: {
                    ...MenuProps.slotProps,
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $6648ce8dad022cc8$export$2e2bcd8739ae039 = $6648ce8dad022cc8$var$SelectInput;


function $df517ddb991185ed$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $3QbnI = parcelRequire("3QbnI");

'use client';
function $1682aada1f3268bb$export$2e2bcd8739ae039() {
    return $3QbnI.useContext((0, $8dad3b560ba18d35$export$2e2bcd8739ae039));
}


parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $360af3e43b4c3b84$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $3QbnI = parcelRequire("3QbnI");


var $6q4c0 = parcelRequire("6q4c0");

var $6s3yU = parcelRequire("6s3yU");


var $eClrZ = parcelRequire("eClrZ");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");



var $6q4c0 = parcelRequire("6q4c0");

var $3QbnI = parcelRequire("3QbnI");



var $e1vzu = parcelRequire("e1vzu");
'use client';
function $bb832ee94c09b36a$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $bb832ee94c09b36a$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $bb832ee94c09b36a$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $bb832ee94c09b36a$var$TextareaAutosize = /*#__PURE__*/ $3QbnI.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $3QbnI.useRef(value != null);
    const inputRef = $3QbnI.useRef(null);
    const handleRef = (0, $379786810d55b52d$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const heightRef = $3QbnI.useRef(null);
    const shadowRef = $3QbnI.useRef(null);
    const calculateTextareaStyles = $3QbnI.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $7b66579d2a58d2e2$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $bb832ee94c09b36a$var$getStyleValue(computedStyle.paddingBottom) + $bb832ee94c09b36a$var$getStyleValue(computedStyle.paddingTop);
        const border = $bb832ee94c09b36a$var$getStyleValue(computedStyle.borderBottomWidth) + $bb832ee94c09b36a$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $3QbnI.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($bb832ee94c09b36a$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $7cc8593cbaa1b939$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $7b66579d2a58d2e2$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: {
                    ...$bb832ee94c09b36a$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $bb832ee94c09b36a$export$2e2bcd8739ae039 = $bb832ee94c09b36a$var$TextareaAutosize;







var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $iCj5F = parcelRequire("iCj5F");




var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $37dec2a412c69962$export$ef57d5c8ca2278f6(slot) {
    return (0, $9uBH9.default)('MuiInputBase', slot);
}
const $37dec2a412c69962$var$inputBaseClasses = (0, $6N1Oq.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $37dec2a412c69962$export$2e2bcd8739ae039 = $37dec2a412c69962$var$inputBaseClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
var $fdcb9aed07392de9$var$_InputGlobalStyles;
const $fdcb9aed07392de9$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $iCj5F.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $fdcb9aed07392de9$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $fdcb9aed07392de9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iCj5F.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $iCj5F.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $37dec2a412c69962$export$ef57d5c8ca2278f6), classes);
};
const $fdcb9aed07392de9$export$298a043133d72a38 = (0, $2TGnx.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $fdcb9aed07392de9$export$965edad20a84fa75
})((0, $gvYl6.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $fdcb9aed07392de9$export$ee10465db6ff6017 = (0, $2TGnx.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $fdcb9aed07392de9$export$cf507b112810e72d
})((0, $gvYl6.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $37dec2a412c69962$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $fdcb9aed07392de9$var$InputGlobalStyles = (0, $9695b13a18ca320a$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $fdcb9aed07392de9$var$InputBase = /*#__PURE__*/ $3QbnI.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $3QbnI.useRef(value != null);
    const inputRef = $3QbnI.useRef();
    const handleInputRefWarning = $3QbnI.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $3QbnI.useState(false);
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    const fcs = (0, $df517ddb991185ed$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $3QbnI.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $3QbnI.useCallback((obj)=>{
        if ((0, $a9d629b449fd42c4$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $e5c931354b647203$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $eClrZ.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $3QbnI.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $bb832ee94c09b36a$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $3QbnI.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $fdcb9aed07392de9$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $fdcb9aed07392de9$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $fdcb9aed07392de9$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $fdcb9aed07392de9$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($fdcb9aed07392de9$var$_InputGlobalStyles || ($fdcb9aed07392de9$var$_InputGlobalStyles = /*#__PURE__*/ (0, $e1vzu.jsx)($fdcb9aed07392de9$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $e1vzu.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $d5877b474787d752$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $eTLbi.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $8dad3b560ba18d35$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $d5877b474787d752$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $eTLbi.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $fdcb9aed07392de9$export$2e2bcd8739ae039 = $fdcb9aed07392de9$var$InputBase;



var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");

function $a36827ee2c43a1e3$export$cdb270390122322b(slot) {
    return (0, $9uBH9.default)('MuiInput', slot);
}
const $a36827ee2c43a1e3$var$inputClasses = {
    ...(0, $37dec2a412c69962$export$2e2bcd8739ae039),
    ...(0, $6N1Oq.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $a36827ee2c43a1e3$export$2e2bcd8739ae039 = $a36827ee2c43a1e3$var$inputClasses;




var $e1vzu = parcelRequire("e1vzu");
'use client';
const $b38e6a43f59357b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $a36827ee2c43a1e3$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $b38e6a43f59357b4$var$InputRoot = (0, $2TGnx.default)((0, $fdcb9aed07392de9$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $fdcb9aed07392de9$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).disabled}, .${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $b38e6a43f59357b4$var$InputInput = (0, $2TGnx.default)((0, $fdcb9aed07392de9$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $fdcb9aed07392de9$export$cf507b112810e72d)
})({});
const $b38e6a43f59357b4$var$Input = /*#__PURE__*/ $3QbnI.forwardRef(function Input(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $b38e6a43f59357b4$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $6s3yU.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $b38e6a43f59357b4$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $b38e6a43f59357b4$var$InputInput;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fdcb9aed07392de9$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
if ($b38e6a43f59357b4$var$Input) $b38e6a43f59357b4$var$Input.muiName = 'Input';
var $b38e6a43f59357b4$export$2e2bcd8739ae039 = $b38e6a43f59357b4$var$Input;




var $3QbnI = parcelRequire("3QbnI");

var $6s3yU = parcelRequire("6s3yU");



var $6q4c0 = parcelRequire("6q4c0");


var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");

function $88f969dc01a84852$export$3331e419f1a48437(slot) {
    return (0, $9uBH9.default)('MuiFilledInput', slot);
}
const $88f969dc01a84852$var$filledInputClasses = {
    ...(0, $37dec2a412c69962$export$2e2bcd8739ae039),
    ...(0, $6N1Oq.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $88f969dc01a84852$export$2e2bcd8739ae039 = $88f969dc01a84852$var$filledInputClasses;




var $iCj5F = parcelRequire("iCj5F");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $be355bed872f1a54$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $iCj5F.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $88f969dc01a84852$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $be355bed872f1a54$var$FilledInputRoot = (0, $2TGnx.default)((0, $fdcb9aed07392de9$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $fdcb9aed07392de9$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $88f969dc01a84852$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $88f969dc01a84852$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $88f969dc01a84852$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $88f969dc01a84852$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $88f969dc01a84852$export$2e2bcd8739ae039).disabled}, .${(0, $88f969dc01a84852$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $88f969dc01a84852$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $be355bed872f1a54$var$FilledInputInput = (0, $2TGnx.default)((0, $fdcb9aed07392de9$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $fdcb9aed07392de9$export$cf507b112810e72d)
})((0, $gvYl6.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $be355bed872f1a54$var$FilledInput = /*#__PURE__*/ $3QbnI.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $be355bed872f1a54$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $6s3yU.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $be355bed872f1a54$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $be355bed872f1a54$var$FilledInputInput;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fdcb9aed07392de9$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
if ($be355bed872f1a54$var$FilledInput) $be355bed872f1a54$var$FilledInput.muiName = 'Input';
var $be355bed872f1a54$export$2e2bcd8739ae039 = $be355bed872f1a54$var$FilledInput;



var $3QbnI = parcelRequire("3QbnI");



var $6q4c0 = parcelRequire("6q4c0");
parcelRequire("3QbnI");


var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $ef56b7158a816829$var$_span;
const $ef56b7158a816829$var$NotchedOutlineRoot = (0, $2TGnx.default)('fieldset', {
    shouldForwardProp: (0, $ajKPH.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $ef56b7158a816829$var$NotchedOutlineLegend = (0, $2TGnx.default)('legend', {
    shouldForwardProp: (0, $ajKPH.default)
})((0, $gvYl6.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $ef56b7158a816829$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)($ef56b7158a816829$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)($ef56b7158a816829$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
                children: label
            }) : $ef56b7158a816829$var$_span || ($ef56b7158a816829$var$_span = /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}





var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");

function $24943499ffaa9911$export$89922944c7227687(slot) {
    return (0, $9uBH9.default)('MuiOutlinedInput', slot);
}
const $24943499ffaa9911$var$outlinedInputClasses = {
    ...(0, $37dec2a412c69962$export$2e2bcd8739ae039),
    ...(0, $6N1Oq.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $24943499ffaa9911$export$2e2bcd8739ae039 = $24943499ffaa9911$var$outlinedInputClasses;




var $e1vzu = parcelRequire("e1vzu");
'use client';
const $3711d02228584efe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $24943499ffaa9911$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $3711d02228584efe$var$OutlinedInputRoot = (0, $2TGnx.default)((0, $fdcb9aed07392de9$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $fdcb9aed07392de9$export$965edad20a84fa75)
})((0, $gvYl6.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $24943499ffaa9911$export$2e2bcd8739ae039).focused} .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $24943499ffaa9911$export$2e2bcd8739ae039).focused} .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $24943499ffaa9911$export$2e2bcd8739ae039).error} .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $24943499ffaa9911$export$2e2bcd8739ae039).disabled} .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $3711d02228584efe$var$NotchedOutlineRoot = (0, $2TGnx.default)((0, $ef56b7158a816829$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $gvYl6.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $3711d02228584efe$var$OutlinedInputInput = (0, $2TGnx.default)((0, $fdcb9aed07392de9$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $fdcb9aed07392de9$export$cf507b112810e72d)
})((0, $gvYl6.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $3711d02228584efe$var$OutlinedInput = /*#__PURE__*/ $3QbnI.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $3711d02228584efe$var$useUtilityClasses(props);
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    const fcs = (0, $df517ddb991185ed$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $3711d02228584efe$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $3711d02228584efe$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fdcb9aed07392de9$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $e1vzu.jsx)($3711d02228584efe$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
if ($3711d02228584efe$var$OutlinedInput) $3711d02228584efe$var$OutlinedInput.muiName = 'Input';
var $3711d02228584efe$export$2e2bcd8739ae039 = $3711d02228584efe$var$OutlinedInput;



var $vqOnh = parcelRequire("vqOnh");


var $2TGnx = parcelRequire("2TGnx");

var $ajKPH = parcelRequire("ajKPH");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $e2e7f451596e3c31$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $e2e7f451596e3c31$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $e2e7f451596e3c31$var$StyledInput = (0, $2TGnx.default)((0, $b38e6a43f59357b4$export$2e2bcd8739ae039), $e2e7f451596e3c31$var$styledRootConfig)('');
const $e2e7f451596e3c31$var$StyledOutlinedInput = (0, $2TGnx.default)((0, $3711d02228584efe$export$2e2bcd8739ae039), $e2e7f451596e3c31$var$styledRootConfig)('');
const $e2e7f451596e3c31$var$StyledFilledInput = (0, $2TGnx.default)((0, $be355bed872f1a54$export$2e2bcd8739ae039), $e2e7f451596e3c31$var$styledRootConfig)('');
const $e2e7f451596e3c31$var$Select = /*#__PURE__*/ $3QbnI.forwardRef(function Select(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $360af3e43b4c3b84$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $db34b39dba9f682b$export$2e2bcd8739ae039) : (0, $6648ce8dad022cc8$export$2e2bcd8739ae039);
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    const fcs = (0, $df517ddb991185ed$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $e2e7f451596e3c31$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $e1vzu.jsx)($e2e7f451596e3c31$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $e1vzu.jsx)($e2e7f451596e3c31$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $e1vzu.jsx)($e2e7f451596e3c31$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(ref, (0, $bca562fe1e155add$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $e1vzu.jsx)($3QbnI.Fragment, {
        children: /*#__PURE__*/ $3QbnI.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $6s3yU.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $eTLbi.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$e2e7f451596e3c31$var$Select.muiName = 'Select';
var $e2e7f451596e3c31$export$2e2bcd8739ae039 = $e2e7f451596e3c31$var$Select;




var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6s3yU = parcelRequire("6s3yU");

var $9uBH9 = parcelRequire("9uBH9");

var $6q4c0 = parcelRequire("6q4c0");




var $aTv5Z = parcelRequire("aTv5Z");

var $jn7gE = parcelRequire("jn7gE");

var $j3YoY = parcelRequire("j3YoY");

var $e1vzu = parcelRequire("e1vzu");
const $fd9e8389f4e5f40f$var$defaultTheme = (0, $aTv5Z.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $fd9e8389f4e5f40f$var$defaultCreateStyledComponent = (0, $0179a2a026d07f51$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $fd9e8389f4e5f40f$var$useThemePropsDefault(props) {
    return (0, $2d05d0cee982a7a9$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $fd9e8389f4e5f40f$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $fd9e8389f4e5f40f$var$joinChildren(children, separator) {
    const childrenArray = $3QbnI.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $3QbnI.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $fd9e8389f4e5f40f$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $fd9e8389f4e5f40f$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $jn7gE.handleBreakpoints)({
            theme: theme
        }, (0, $jn7gE.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $j3YoY.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $jn7gE.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $jn7gE.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $j3YoY.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$fd9e8389f4e5f40f$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $j3YoY.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $6s3yU.default)(styles, (0, $jn7gE.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $jn7gE.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $fd9e8389f4e5f40f$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $fd9e8389f4e5f40f$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $fd9e8389f4e5f40f$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $6q4c0.default)(slots, (slot)=>(0, $9uBH9.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($fd9e8389f4e5f40f$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $3QbnI.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $1a12cef9553d47e6$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $e1vzu.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $eTLbi.default)(classes.root, className),
            ...other,
            children: divider ? $fd9e8389f4e5f40f$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}



var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");
'use client';
const $7961aabc05d182ef$var$Stack = (0, $fd9e8389f4e5f40f$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $2TGnx.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $vqOnh.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $7961aabc05d182ef$export$2e2bcd8739ae039 = $7961aabc05d182ef$var$Stack;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $iCj5F = parcelRequire("iCj5F");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $d5a6d5915630c5f7$export$24c1f8f60cbac79e(slot) {
    return (0, $9uBH9.default)('MuiTypography', slot);
}
const $d5a6d5915630c5f7$var$typographyClasses = (0, $6N1Oq.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $d5a6d5915630c5f7$export$2e2bcd8739ae039 = $d5a6d5915630c5f7$var$typographyClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $311a456630f5f039$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $311a456630f5f039$var$extendSxProp = (0, $9695b13a18ca320a$export$7e7f5719ff4debb1)();
const $311a456630f5f039$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $iCj5F.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $d5a6d5915630c5f7$export$24c1f8f60cbac79e), classes);
};
const $311a456630f5f039$export$140e2f5526d3cad8 = (0, $2TGnx.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $iCj5F.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $iCj5F.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $311a456630f5f039$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $311a456630f5f039$var$Typography = /*#__PURE__*/ $3QbnI.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$311a456630f5f039$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $311a456630f5f039$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $311a456630f5f039$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $311a456630f5f039$var$defaultVariantMapping[variant]) || 'span';
    const classes = $311a456630f5f039$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($311a456630f5f039$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $eTLbi.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $311a456630f5f039$export$2e2bcd8739ae039 = $311a456630f5f039$var$Typography;


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 

var $3QbnI = parcelRequire("3QbnI");


function $f34cae4af8bdbc33$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $803f8bad65bbae62$export$3c9a16f847548506)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $803f8bad65bbae62$export$3c9a16f847548506)(nextProps, [
        "values"
    ]);
    return (0, $df74ec6c7358c66e$export$d36bdfa510afb180)(nextValues, values) && (0, $df74ec6c7358c66e$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $f34cae4af8bdbc33$var$FormattedMessage(props) {
    var intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $3QbnI.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $3QbnI.createElement(Component, null, $3QbnI.Children.toArray(nodes));
    return $3QbnI.createElement($3QbnI.Fragment, null, nodes);
}
$f34cae4af8bdbc33$var$FormattedMessage.displayName = 'FormattedMessage';
var $f34cae4af8bdbc33$var$MemoizedFormattedMessage = $3QbnI.memo($f34cae4af8bdbc33$var$FormattedMessage, $f34cae4af8bdbc33$var$areEqual);
$f34cae4af8bdbc33$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $f34cae4af8bdbc33$export$2e2bcd8739ae039 = $f34cae4af8bdbc33$var$MemoizedFormattedMessage;


var $300085ebe0b047ad$exports = {};
"use strict";
"use client";
var $55ceebaba6abf8a9$exports = {};
function $55ceebaba6abf8a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$55ceebaba6abf8a9$exports = $55ceebaba6abf8a9$var$_interopRequireDefault, $55ceebaba6abf8a9$exports.__esModule = true, $55ceebaba6abf8a9$exports["default"] = $55ceebaba6abf8a9$exports;


var $300085ebe0b047ad$require$_interopRequireDefault = $55ceebaba6abf8a9$exports.default;
Object.defineProperty($300085ebe0b047ad$exports, "__esModule", {
    value: true
});
$300085ebe0b047ad$exports.default = void 0;

var $300085ebe0b047ad$var$_createSvgIcon = $300085ebe0b047ad$require$_interopRequireDefault((parcelRequire("8Cb4O")));

var $e1vzu = parcelRequire("e1vzu");
var $300085ebe0b047ad$var$_default = $300085ebe0b047ad$exports.default = (0, $300085ebe0b047ad$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1"
}), 'ArrowBackRounded');


var $25d5499ea2336b35$exports = {};
"use strict";
"use client";

var $25d5499ea2336b35$require$_interopRequireDefault = $55ceebaba6abf8a9$exports.default;
Object.defineProperty($25d5499ea2336b35$exports, "__esModule", {
    value: true
});
$25d5499ea2336b35$exports.default = void 0;

var $25d5499ea2336b35$var$_createSvgIcon = $25d5499ea2336b35$require$_interopRequireDefault((parcelRequire("8Cb4O")));

var $e1vzu = parcelRequire("e1vzu");
var $25d5499ea2336b35$var$_default = $25d5499ea2336b35$exports.default = (0, $25d5499ea2336b35$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');




var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");

var $fPIjG = parcelRequire("fPIjG");
var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $iCj5F = parcelRequire("iCj5F");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $226a33af747a023d$export$29cad1383b3f235d(slot) {
    return (0, $9uBH9.default)('MuiCircularProgress', slot);
}
const $226a33af747a023d$var$circularProgressClasses = (0, $6N1Oq.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $226a33af747a023d$export$2e2bcd8739ae039 = $226a33af747a023d$var$circularProgressClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $fccdfec3f47c0093$var$SIZE = 44;
const $fccdfec3f47c0093$var$circularRotateKeyframe = (0, $fPIjG.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $fccdfec3f47c0093$var$circularDashKeyframe = (0, $fPIjG.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $fccdfec3f47c0093$var$rotateAnimation = typeof $fccdfec3f47c0093$var$circularRotateKeyframe !== 'string' ? (0, $fPIjG.css)`
        animation: ${$fccdfec3f47c0093$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $fccdfec3f47c0093$var$dashAnimation = typeof $fccdfec3f47c0093$var$circularDashKeyframe !== 'string' ? (0, $fPIjG.css)`
        animation: ${$fccdfec3f47c0093$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $fccdfec3f47c0093$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $iCj5F.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $iCj5F.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $226a33af747a023d$export$29cad1383b3f235d), classes);
};
const $fccdfec3f47c0093$var$CircularProgressRoot = (0, $2TGnx.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $iCj5F.default)(ownerState.color)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $fccdfec3f47c0093$var$rotateAnimation || {
                    animation: `${$fccdfec3f47c0093$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $fccdfec3f47c0093$var$CircularProgressSVG = (0, $2TGnx.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $fccdfec3f47c0093$var$CircularProgressCircle = (0, $2TGnx.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $iCj5F.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $fccdfec3f47c0093$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$fccdfec3f47c0093$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $fccdfec3f47c0093$var$CircularProgress = /*#__PURE__*/ $3QbnI.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $fccdfec3f47c0093$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($fccdfec3f47c0093$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $e1vzu.jsx)($fccdfec3f47c0093$var$CircularProgressRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)($fccdfec3f47c0093$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$fccdfec3f47c0093$var$SIZE / 2} ${$fccdfec3f47c0093$var$SIZE / 2} ${$fccdfec3f47c0093$var$SIZE} ${$fccdfec3f47c0093$var$SIZE}`,
            children: /*#__PURE__*/ (0, $e1vzu.jsx)($fccdfec3f47c0093$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $fccdfec3f47c0093$var$SIZE,
                cy: $fccdfec3f47c0093$var$SIZE,
                r: ($fccdfec3f47c0093$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $fccdfec3f47c0093$export$2e2bcd8739ae039 = $fccdfec3f47c0093$var$CircularProgress;




var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $9uBH9 = parcelRequire("9uBH9");

var $6q4c0 = parcelRequire("6q4c0");





var $aTv5Z = parcelRequire("aTv5Z");
const $a14ce45279ad73ac$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $a14ce45279ad73ac$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $a14ce45279ad73ac$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $3959daaffab48a20$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $3959daaffab48a20$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $3959daaffab48a20$var$selfColumnsVar = '--Grid-columns';
const $3959daaffab48a20$var$parentColumnsVar = '--Grid-parent-columns';
const $3959daaffab48a20$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $a14ce45279ad73ac$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$3959daaffab48a20$var$parentColumnsVar}) - (var(${$3959daaffab48a20$var$parentColumnsVar}) - ${value}) * (var(${$3959daaffab48a20$var$getParentSpacingVar('column')}) / var(${$3959daaffab48a20$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $3959daaffab48a20$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $a14ce45279ad73ac$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$3959daaffab48a20$var$parentColumnsVar}) + var(${$3959daaffab48a20$var$getParentSpacingVar('column')}) * ${value} / var(${$3959daaffab48a20$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $3959daaffab48a20$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$3959daaffab48a20$var$selfColumnsVar]: 12
    };
    (0, $a14ce45279ad73ac$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$3959daaffab48a20$var$selfColumnsVar]: columns,
            '> *': {
                [$3959daaffab48a20$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $3959daaffab48a20$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $a14ce45279ad73ac$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$3959daaffab48a20$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$3959daaffab48a20$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $3959daaffab48a20$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $a14ce45279ad73ac$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$3959daaffab48a20$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$3959daaffab48a20$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $3959daaffab48a20$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $a14ce45279ad73ac$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $3959daaffab48a20$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$3959daaffab48a20$var$getSelfSpacingVar('row')}) var(${$3959daaffab48a20$var$getSelfSpacingVar('column')})`
        }
    };
};
const $3959daaffab48a20$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $3959daaffab48a20$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $3959daaffab48a20$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};



var $e1vzu = parcelRequire("e1vzu");
const $b7484669a16f822a$var$defaultTheme = (0, $aTv5Z.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $b7484669a16f822a$var$defaultCreateStyledComponent = (0, $0179a2a026d07f51$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $b7484669a16f822a$var$useThemePropsDefault(props) {
    return (0, $2d05d0cee982a7a9$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $b7484669a16f822a$var$defaultTheme
    });
}
function $b7484669a16f822a$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $b7484669a16f822a$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $b7484669a16f822a$var$useThemePropsDefault, useTheme: useTheme = (0, $6338ced0c7678953$export$2e2bcd8739ae039), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $3959daaffab48a20$export$a7c8efbe2b138a60)(direction),
                ...(0, $3959daaffab48a20$export$e2d1175061442d38)(size),
                ...container ? (0, $3959daaffab48a20$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $6q4c0.default)(slots, (slot)=>(0, $9uBH9.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $3959daaffab48a20$export$ccc4d4a4923f1b06), (0, $3959daaffab48a20$export$a89c28919b8e3bb5), (0, $3959daaffab48a20$export$68c4dad72dd49c74), (0, $3959daaffab48a20$export$84053369756c53db), (0, $3959daaffab48a20$export$2a0a3c01032b3f4), (0, $3959daaffab48a20$export$810b8c3ab5d46bf), (0, $3959daaffab48a20$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $3QbnI.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $1a12cef9553d47e6$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $e1vzu.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $eTLbi.default)(classes.root, className),
            ...other,
            children: $3QbnI.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $3QbnI.isValidElement(child) && (0, $87272f125c22ec3f$export$2e2bcd8739ae039)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $3QbnI.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}




var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

'use client';
/**
 *
 * Demos:
 *
 * - [Grid version 2](https://mui.com/material-ui/react-grid2/)
 *
 * API:
 *
 * - [Grid2 API](https://mui.com/material-ui/api/grid-2/)
 */ const $ad8e3f93e981b797$var$Grid2 = (0, $b7484669a16f822a$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $2TGnx.default)('div', {
        name: 'MuiGrid2',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid2',
    useThemeProps: (inProps)=>(0, $vqOnh.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid2'
        }),
    useTheme: $6a808f4d6e083741$export$2e2bcd8739ae039
});
var $ad8e3f93e981b797$export$2e2bcd8739ae039 = $ad8e3f93e981b797$var$Grid2;



var $3QbnI = parcelRequire("3QbnI");
// only allow these values for ENVIRONMENT, otherwise abort
const $87c980b245bbb7d9$var$allowedEnvironmentValues = [
    'test-automation',
    'development',
    'staging',
    'production'
];
// Determine 'test-automation' environment automatically if NODE_ENV is 'test'
const $87c980b245bbb7d9$var$testAutomation = undefined;
const $87c980b245bbb7d9$var$rawEnvironment = ("development" ?? $87c980b245bbb7d9$var$testAutomation)?.trim().toLowerCase();
if (!$87c980b245bbb7d9$var$rawEnvironment || !$87c980b245bbb7d9$var$allowedEnvironmentValues.includes($87c980b245bbb7d9$var$rawEnvironment || '')) throw new Error(`Invalid environment value: ${"development"}. Must be one of ${$87c980b245bbb7d9$var$allowedEnvironmentValues.join(', ')}`);
const $87c980b245bbb7d9$export$be46596bc6608f3b = $87c980b245bbb7d9$var$rawEnvironment;
const $87c980b245bbb7d9$export$616ba300510cadcb = 'http://localhost:56789/api/mofi-payments';
const $87c980b245bbb7d9$export$c3ee1e672e1e24e7 = $87c980b245bbb7d9$export$be46596bc6608f3b === 'test-automation' ? $87c980b245bbb7d9$export$616ba300510cadcb : "https://integration.pyzakointi.com/api/mofi-payments";
const $87c980b245bbb7d9$export$6faa4a850bc4d0ce = "https://4b695ea16abc16b8ce99d19140ad563a@o454086.ingest.us.sentry.io/4508649968369664";
const $87c980b245bbb7d9$export$d2c893bfac1da9a1 = "98a3ac74";
const $87c980b245bbb7d9$export$934e799b0e87def5 = parseFloat('0');
const $87c980b245bbb7d9$var$sentryTracePropagationTargets = undefined?.split(',').map((target)=>{
    return new RegExp(target.trim());
});
const $87c980b245bbb7d9$export$6229fa3b56a23727 = $87c980b245bbb7d9$var$sentryTracePropagationTargets;
const $87c980b245bbb7d9$export$d991ba28bdd15482 = parseFloat('0');
const $87c980b245bbb7d9$export$6d698ff2c1f4a0ca = parseFloat('0');
const $87c980b245bbb7d9$export$e987ec915f285263 = false;


'use strict';
function $360f3c3463da7332$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $54X9E = parcelRequire("54X9E");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $e14e746657dab732$var$toString } = Object.prototype;
const { getPrototypeOf: $e14e746657dab732$var$getPrototypeOf } = Object;
const $e14e746657dab732$var$kindOf = ((cache)=>(thing)=>{
        const str = $e14e746657dab732$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $e14e746657dab732$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$e14e746657dab732$var$kindOf(thing) === type;
};
const $e14e746657dab732$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $e14e746657dab732$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $e14e746657dab732$var$isUndefined = $e14e746657dab732$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $e14e746657dab732$var$isBuffer(val) {
    return val !== null && !$e14e746657dab732$var$isUndefined(val) && val.constructor !== null && !$e14e746657dab732$var$isUndefined(val.constructor) && $e14e746657dab732$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $e14e746657dab732$var$isArrayBuffer = $e14e746657dab732$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $e14e746657dab732$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $e14e746657dab732$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $e14e746657dab732$var$isString = $e14e746657dab732$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $e14e746657dab732$var$isFunction = $e14e746657dab732$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $e14e746657dab732$var$isNumber = $e14e746657dab732$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $e14e746657dab732$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $e14e746657dab732$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $e14e746657dab732$var$isPlainObject = (val)=>{
    if ($e14e746657dab732$var$kindOf(val) !== 'object') return false;
    const prototype = $e14e746657dab732$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $e14e746657dab732$var$isDate = $e14e746657dab732$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $e14e746657dab732$var$isFile = $e14e746657dab732$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $e14e746657dab732$var$isBlob = $e14e746657dab732$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $e14e746657dab732$var$isFileList = $e14e746657dab732$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $e14e746657dab732$var$isStream = (val)=>$e14e746657dab732$var$isObject(val) && $e14e746657dab732$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $e14e746657dab732$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $e14e746657dab732$var$isFunction(thing.append) && ((kind = $e14e746657dab732$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $e14e746657dab732$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $e14e746657dab732$var$isURLSearchParams = $e14e746657dab732$var$kindOfTest('URLSearchParams');
const [$e14e746657dab732$var$isReadableStream, $e14e746657dab732$var$isRequest, $e14e746657dab732$var$isResponse, $e14e746657dab732$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($e14e746657dab732$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $e14e746657dab732$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $e14e746657dab732$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($e14e746657dab732$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $e14e746657dab732$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $e14e746657dab732$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $e14e746657dab732$var$isContextDefined = (context)=>!$e14e746657dab732$var$isUndefined(context) && context !== $e14e746657dab732$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $e14e746657dab732$var$merge() {
    const { caseless: caseless } = $e14e746657dab732$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $e14e746657dab732$var$findKey(result, key) || key;
        if ($e14e746657dab732$var$isPlainObject(result[targetKey]) && $e14e746657dab732$var$isPlainObject(val)) result[targetKey] = $e14e746657dab732$var$merge(result[targetKey], val);
        else if ($e14e746657dab732$var$isPlainObject(val)) result[targetKey] = $e14e746657dab732$var$merge({}, val);
        else if ($e14e746657dab732$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $e14e746657dab732$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $e14e746657dab732$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $e14e746657dab732$var$forEach(b, (val, key)=>{
        if (thisArg && $e14e746657dab732$var$isFunction(val)) a[key] = (0, $360f3c3463da7332$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $e14e746657dab732$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $e14e746657dab732$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $e14e746657dab732$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $e14e746657dab732$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $e14e746657dab732$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $e14e746657dab732$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($e14e746657dab732$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$e14e746657dab732$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $e14e746657dab732$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $e14e746657dab732$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $e14e746657dab732$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $e14e746657dab732$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $e14e746657dab732$var$isHTMLForm = $e14e746657dab732$var$kindOfTest('HTMLFormElement');
const $e14e746657dab732$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $e14e746657dab732$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $e14e746657dab732$var$isRegExp = $e14e746657dab732$var$kindOfTest('RegExp');
const $e14e746657dab732$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $e14e746657dab732$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $e14e746657dab732$var$freezeMethods = (obj)=>{
    $e14e746657dab732$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($e14e746657dab732$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$e14e746657dab732$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $e14e746657dab732$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $e14e746657dab732$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $e14e746657dab732$var$noop = ()=>{};
const $e14e746657dab732$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $e14e746657dab732$var$ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const $e14e746657dab732$var$DIGIT = '0123456789';
const $e14e746657dab732$var$ALPHABET = {
    DIGIT: $e14e746657dab732$var$DIGIT,
    ALPHA: $e14e746657dab732$var$ALPHA,
    ALPHA_DIGIT: $e14e746657dab732$var$ALPHA + $e14e746657dab732$var$ALPHA.toUpperCase() + $e14e746657dab732$var$DIGIT
};
const $e14e746657dab732$var$generateString = (size = 16, alphabet = $e14e746657dab732$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $e14e746657dab732$var$isSpecCompliantForm(thing) {
    return !!(thing && $e14e746657dab732$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $e14e746657dab732$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($e14e746657dab732$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $e14e746657dab732$var$isArray(source) ? [] : {};
                $e14e746657dab732$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$e14e746657dab732$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $e14e746657dab732$var$isAsyncFn = $e14e746657dab732$var$kindOfTest('AsyncFunction');
const $e14e746657dab732$var$isThenable = (thing)=>thing && ($e14e746657dab732$var$isObject(thing) || $e14e746657dab732$var$isFunction(thing)) && $e14e746657dab732$var$isFunction(thing.then) && $e14e746657dab732$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $e14e746657dab732$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $e14e746657dab732$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $e14e746657dab732$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $e14e746657dab732$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $e14e746657dab732$var$isFunction($e14e746657dab732$var$_global.postMessage));
const $e14e746657dab732$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($e14e746657dab732$var$_global) : typeof $54X9E !== 'undefined' && $54X9E.nextTick || $e14e746657dab732$var$_setImmediate;
var // *********************
$e14e746657dab732$export$2e2bcd8739ae039 = {
    isArray: $e14e746657dab732$var$isArray,
    isArrayBuffer: $e14e746657dab732$var$isArrayBuffer,
    isBuffer: $e14e746657dab732$var$isBuffer,
    isFormData: $e14e746657dab732$var$isFormData,
    isArrayBufferView: $e14e746657dab732$var$isArrayBufferView,
    isString: $e14e746657dab732$var$isString,
    isNumber: $e14e746657dab732$var$isNumber,
    isBoolean: $e14e746657dab732$var$isBoolean,
    isObject: $e14e746657dab732$var$isObject,
    isPlainObject: $e14e746657dab732$var$isPlainObject,
    isReadableStream: $e14e746657dab732$var$isReadableStream,
    isRequest: $e14e746657dab732$var$isRequest,
    isResponse: $e14e746657dab732$var$isResponse,
    isHeaders: $e14e746657dab732$var$isHeaders,
    isUndefined: $e14e746657dab732$var$isUndefined,
    isDate: $e14e746657dab732$var$isDate,
    isFile: $e14e746657dab732$var$isFile,
    isBlob: $e14e746657dab732$var$isBlob,
    isRegExp: $e14e746657dab732$var$isRegExp,
    isFunction: $e14e746657dab732$var$isFunction,
    isStream: $e14e746657dab732$var$isStream,
    isURLSearchParams: $e14e746657dab732$var$isURLSearchParams,
    isTypedArray: $e14e746657dab732$var$isTypedArray,
    isFileList: $e14e746657dab732$var$isFileList,
    forEach: $e14e746657dab732$var$forEach,
    merge: $e14e746657dab732$var$merge,
    extend: $e14e746657dab732$var$extend,
    trim: $e14e746657dab732$var$trim,
    stripBOM: $e14e746657dab732$var$stripBOM,
    inherits: $e14e746657dab732$var$inherits,
    toFlatObject: $e14e746657dab732$var$toFlatObject,
    kindOf: $e14e746657dab732$var$kindOf,
    kindOfTest: $e14e746657dab732$var$kindOfTest,
    endsWith: $e14e746657dab732$var$endsWith,
    toArray: $e14e746657dab732$var$toArray,
    forEachEntry: $e14e746657dab732$var$forEachEntry,
    matchAll: $e14e746657dab732$var$matchAll,
    isHTMLForm: $e14e746657dab732$var$isHTMLForm,
    hasOwnProperty: $e14e746657dab732$var$hasOwnProperty,
    hasOwnProp: $e14e746657dab732$var$hasOwnProperty,
    reduceDescriptors: $e14e746657dab732$var$reduceDescriptors,
    freezeMethods: $e14e746657dab732$var$freezeMethods,
    toObjectSet: $e14e746657dab732$var$toObjectSet,
    toCamelCase: $e14e746657dab732$var$toCamelCase,
    noop: $e14e746657dab732$var$noop,
    toFiniteNumber: $e14e746657dab732$var$toFiniteNumber,
    findKey: $e14e746657dab732$var$findKey,
    global: $e14e746657dab732$var$_global,
    isContextDefined: $e14e746657dab732$var$isContextDefined,
    ALPHABET: $e14e746657dab732$var$ALPHABET,
    generateString: $e14e746657dab732$var$generateString,
    isSpecCompliantForm: $e14e746657dab732$var$isSpecCompliantForm,
    toJSONObject: $e14e746657dab732$var$toJSONObject,
    isAsyncFn: $e14e746657dab732$var$isAsyncFn,
    isThenable: $e14e746657dab732$var$isThenable,
    setImmediate: $e14e746657dab732$var$_setImmediate,
    asap: $e14e746657dab732$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $e7b34f3e9833a518$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $e14e746657dab732$export$2e2bcd8739ae039).inherits($e7b34f3e9833a518$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $e14e746657dab732$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $e7b34f3e9833a518$var$prototype = $e7b34f3e9833a518$var$AxiosError.prototype;
const $e7b34f3e9833a518$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $e7b34f3e9833a518$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($e7b34f3e9833a518$var$AxiosError, $e7b34f3e9833a518$var$descriptors);
Object.defineProperty($e7b34f3e9833a518$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$e7b34f3e9833a518$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($e7b34f3e9833a518$var$prototype);
    (0, $e14e746657dab732$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $e7b34f3e9833a518$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $e7b34f3e9833a518$export$2e2bcd8739ae039 = $e7b34f3e9833a518$var$AxiosError;


// eslint-disable-next-line strict
var $8ac03022097a5dd5$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $2f4093b97fdc053e$export$a143d493d941bafc;
var $2f4093b97fdc053e$export$e4cf37d7f6fb9e0a;
var $2f4093b97fdc053e$export$f99ded8fe4b79145;
var $2f4093b97fdc053e$export$599f31c3813fae4d;
'use strict';
var $c1110228c8ce65d7$export$a48f0734ac7c2329;
var $c1110228c8ce65d7$export$d622b2ad8d90c771;
var $c1110228c8ce65d7$export$6100ba28696e12de;
'use strict';
$c1110228c8ce65d7$export$a48f0734ac7c2329 = $c1110228c8ce65d7$var$byteLength;
$c1110228c8ce65d7$export$d622b2ad8d90c771 = $c1110228c8ce65d7$var$toByteArray;
$c1110228c8ce65d7$export$6100ba28696e12de = $c1110228c8ce65d7$var$fromByteArray;
var $c1110228c8ce65d7$var$lookup = [];
var $c1110228c8ce65d7$var$revLookup = [];
var $c1110228c8ce65d7$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $c1110228c8ce65d7$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $c1110228c8ce65d7$var$i = 0, $c1110228c8ce65d7$var$len = $c1110228c8ce65d7$var$code.length; $c1110228c8ce65d7$var$i < $c1110228c8ce65d7$var$len; ++$c1110228c8ce65d7$var$i){
    $c1110228c8ce65d7$var$lookup[$c1110228c8ce65d7$var$i] = $c1110228c8ce65d7$var$code[$c1110228c8ce65d7$var$i];
    $c1110228c8ce65d7$var$revLookup[$c1110228c8ce65d7$var$code.charCodeAt($c1110228c8ce65d7$var$i)] = $c1110228c8ce65d7$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c1110228c8ce65d7$var$revLookup['-'.charCodeAt(0)] = 62;
$c1110228c8ce65d7$var$revLookup['_'.charCodeAt(0)] = 63;
function $c1110228c8ce65d7$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c1110228c8ce65d7$var$byteLength(b64) {
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$toByteArray(b64) {
    var tmp;
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c1110228c8ce65d7$var$Arr($c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 18 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 2 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 10 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c1110228c8ce65d7$var$tripletToBase64(num) {
    return $c1110228c8ce65d7$var$lookup[num >> 18 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 12 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 6 & 0x3F] + $c1110228c8ce65d7$var$lookup[num & 0x3F];
}
function $c1110228c8ce65d7$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c1110228c8ce65d7$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $c1110228c8ce65d7$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c1110228c8ce65d7$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 2] + $c1110228c8ce65d7$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 10] + $c1110228c8ce65d7$var$lookup[tmp >> 4 & 0x3F] + $c1110228c8ce65d7$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $0b8359fe6fd9cd49$export$aafa59e2e03f2942;
var $0b8359fe6fd9cd49$export$68d8715fc104d294;
$0b8359fe6fd9cd49$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$0b8359fe6fd9cd49$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $2f4093b97fdc053e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$2f4093b97fdc053e$export$a143d493d941bafc = $2f4093b97fdc053e$var$Buffer;
$2f4093b97fdc053e$export$e4cf37d7f6fb9e0a = $2f4093b97fdc053e$var$SlowBuffer;
$2f4093b97fdc053e$export$f99ded8fe4b79145 = 50;
const $2f4093b97fdc053e$var$K_MAX_LENGTH = 0x7fffffff;
$2f4093b97fdc053e$export$599f31c3813fae4d = $2f4093b97fdc053e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $2f4093b97fdc053e$var$Buffer.TYPED_ARRAY_SUPPORT = $2f4093b97fdc053e$var$typedArraySupport();
if (!$2f4093b97fdc053e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $2f4093b97fdc053e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($2f4093b97fdc053e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$2f4093b97fdc053e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($2f4093b97fdc053e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$2f4093b97fdc053e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $2f4093b97fdc053e$var$createBuffer(length) {
    if (length > $2f4093b97fdc053e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $2f4093b97fdc053e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $2f4093b97fdc053e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $2f4093b97fdc053e$var$allocUnsafe(arg);
    }
    return $2f4093b97fdc053e$var$from(arg, encodingOrOffset, length);
}
$2f4093b97fdc053e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $2f4093b97fdc053e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $2f4093b97fdc053e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $2f4093b97fdc053e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($2f4093b97fdc053e$var$isInstance(value, ArrayBuffer) || value && $2f4093b97fdc053e$var$isInstance(value.buffer, ArrayBuffer)) return $2f4093b97fdc053e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($2f4093b97fdc053e$var$isInstance(value, SharedArrayBuffer) || value && $2f4093b97fdc053e$var$isInstance(value.buffer, SharedArrayBuffer))) return $2f4093b97fdc053e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $2f4093b97fdc053e$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $2f4093b97fdc053e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $2f4093b97fdc053e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $2f4093b97fdc053e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $2f4093b97fdc053e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($2f4093b97fdc053e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($2f4093b97fdc053e$var$Buffer, Uint8Array);
function $2f4093b97fdc053e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $2f4093b97fdc053e$var$alloc(size, fill, encoding) {
    $2f4093b97fdc053e$var$assertSize(size);
    if (size <= 0) return $2f4093b97fdc053e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $2f4093b97fdc053e$var$createBuffer(size).fill(fill, encoding) : $2f4093b97fdc053e$var$createBuffer(size).fill(fill);
    return $2f4093b97fdc053e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $2f4093b97fdc053e$var$Buffer.alloc = function(size, fill, encoding) {
    return $2f4093b97fdc053e$var$alloc(size, fill, encoding);
};
function $2f4093b97fdc053e$var$allocUnsafe(size) {
    $2f4093b97fdc053e$var$assertSize(size);
    return $2f4093b97fdc053e$var$createBuffer(size < 0 ? 0 : $2f4093b97fdc053e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $2f4093b97fdc053e$var$Buffer.allocUnsafe = function(size) {
    return $2f4093b97fdc053e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $2f4093b97fdc053e$var$Buffer.allocUnsafeSlow = function(size) {
    return $2f4093b97fdc053e$var$allocUnsafe(size);
};
function $2f4093b97fdc053e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$2f4093b97fdc053e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $2f4093b97fdc053e$var$byteLength(string, encoding) | 0;
    let buf = $2f4093b97fdc053e$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $2f4093b97fdc053e$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $2f4093b97fdc053e$var$checked(array.length) | 0;
    const buf = $2f4093b97fdc053e$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $2f4093b97fdc053e$var$fromArrayView(arrayView) {
    if ($2f4093b97fdc053e$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $2f4093b97fdc053e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $2f4093b97fdc053e$var$fromArrayLike(arrayView);
}
function $2f4093b97fdc053e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $2f4093b97fdc053e$var$Buffer.prototype);
    return buf;
}
function $2f4093b97fdc053e$var$fromObject(obj) {
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(obj)) {
        const len = $2f4093b97fdc053e$var$checked(obj.length) | 0;
        const buf = $2f4093b97fdc053e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $2f4093b97fdc053e$var$numberIsNaN(obj.length)) return $2f4093b97fdc053e$var$createBuffer(0);
        return $2f4093b97fdc053e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $2f4093b97fdc053e$var$fromArrayLike(obj.data);
}
function $2f4093b97fdc053e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $2f4093b97fdc053e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $2f4093b97fdc053e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $2f4093b97fdc053e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $2f4093b97fdc053e$var$Buffer.alloc(+length);
}
$2f4093b97fdc053e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $2f4093b97fdc053e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$2f4093b97fdc053e$var$Buffer.compare = function compare(a, b) {
    if ($2f4093b97fdc053e$var$isInstance(a, Uint8Array)) a = $2f4093b97fdc053e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($2f4093b97fdc053e$var$isInstance(b, Uint8Array)) b = $2f4093b97fdc053e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(a) || !$2f4093b97fdc053e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$2f4093b97fdc053e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$2f4093b97fdc053e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $2f4093b97fdc053e$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $2f4093b97fdc053e$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($2f4093b97fdc053e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) buf = $2f4093b97fdc053e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $2f4093b97fdc053e$var$byteLength(string, encoding) {
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $2f4093b97fdc053e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $2f4093b97fdc053e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $2f4093b97fdc053e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $2f4093b97fdc053e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$2f4093b97fdc053e$var$Buffer.byteLength = $2f4093b97fdc053e$var$byteLength;
function $2f4093b97fdc053e$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $2f4093b97fdc053e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $2f4093b97fdc053e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $2f4093b97fdc053e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $2f4093b97fdc053e$var$latin1Slice(this, start, end);
        case 'base64':
            return $2f4093b97fdc053e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2f4093b97fdc053e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$2f4093b97fdc053e$var$Buffer.prototype._isBuffer = true;
function $2f4093b97fdc053e$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$2f4093b97fdc053e$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$2f4093b97fdc053e$var$swap(this, i, i + 1);
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $2f4093b97fdc053e$var$swap(this, i, i + 3);
        $2f4093b97fdc053e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $2f4093b97fdc053e$var$swap(this, i, i + 7);
        $2f4093b97fdc053e$var$swap(this, i + 1, i + 6);
        $2f4093b97fdc053e$var$swap(this, i + 2, i + 5);
        $2f4093b97fdc053e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $2f4093b97fdc053e$var$utf8Slice(this, 0, length);
    return $2f4093b97fdc053e$var$slowToString.apply(this, arguments);
};
$2f4093b97fdc053e$var$Buffer.prototype.toLocaleString = $2f4093b97fdc053e$var$Buffer.prototype.toString;
$2f4093b97fdc053e$var$Buffer.prototype.equals = function equals(b) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $2f4093b97fdc053e$var$Buffer.compare(this, b) === 0;
};
$2f4093b97fdc053e$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $2f4093b97fdc053e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($2f4093b97fdc053e$var$customInspectSymbol) $2f4093b97fdc053e$var$Buffer.prototype[$2f4093b97fdc053e$var$customInspectSymbol] = $2f4093b97fdc053e$var$Buffer.prototype.inspect;
$2f4093b97fdc053e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($2f4093b97fdc053e$var$isInstance(target, Uint8Array)) target = $2f4093b97fdc053e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $2f4093b97fdc053e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($2f4093b97fdc053e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $2f4093b97fdc053e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $2f4093b97fdc053e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $2f4093b97fdc053e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $2f4093b97fdc053e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$2f4093b97fdc053e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$2f4093b97fdc053e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $2f4093b97fdc053e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$2f4093b97fdc053e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $2f4093b97fdc053e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $2f4093b97fdc053e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($2f4093b97fdc053e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $2f4093b97fdc053e$var$utf8Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $2f4093b97fdc053e$var$asciiWrite(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$asciiToBytes(string), buf, offset, length);
}
function $2f4093b97fdc053e$var$base64Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$base64ToBytes(string), buf, offset, length);
}
function $2f4093b97fdc053e$var$ucs2Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$2f4093b97fdc053e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $2f4093b97fdc053e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $2f4093b97fdc053e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $2f4093b97fdc053e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $2f4093b97fdc053e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2f4093b97fdc053e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$2f4093b97fdc053e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $2f4093b97fdc053e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $c1110228c8ce65d7$export$6100ba28696e12de(buf);
    else return $c1110228c8ce65d7$export$6100ba28696e12de(buf.slice(start, end));
}
function $2f4093b97fdc053e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $2f4093b97fdc053e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $2f4093b97fdc053e$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $2f4093b97fdc053e$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $2f4093b97fdc053e$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $2f4093b97fdc053e$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $2f4093b97fdc053e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $2f4093b97fdc053e$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$2f4093b97fdc053e$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $2f4093b97fdc053e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $2f4093b97fdc053e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$2f4093b97fdc053e$var$Buffer.prototype.readUintLE = $2f4093b97fdc053e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUintBE = $2f4093b97fdc053e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint8 = $2f4093b97fdc053e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint16LE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint16BE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint32LE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint32BE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$2f4093b97fdc053e$var$Buffer.prototype.readBigUInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$2f4093b97fdc053e$var$Buffer.prototype.readBigUInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$2f4093b97fdc053e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$2f4093b97fdc053e$var$Buffer.prototype.readBigInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$2f4093b97fdc053e$var$Buffer.prototype.readBigInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$2f4093b97fdc053e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$2f4093b97fdc053e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$2f4093b97fdc053e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 8, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$2f4093b97fdc053e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 8, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $2f4093b97fdc053e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$2f4093b97fdc053e$var$Buffer.prototype.writeUintLE = $2f4093b97fdc053e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUintBE = $2f4093b97fdc053e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint8 = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint16LE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint16BE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint32LE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint32BE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $2f4093b97fdc053e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $2f4093b97fdc053e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeBigUInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeBigUInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeBigInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeBigInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $2f4093b97fdc053e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $0b8359fe6fd9cd49$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeFloat(this, value, offset, true, noAssert);
};
$2f4093b97fdc053e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeFloat(this, value, offset, false, noAssert);
};
function $2f4093b97fdc053e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $0b8359fe6fd9cd49$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeDouble(this, value, offset, true, noAssert);
};
$2f4093b97fdc053e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$2f4093b97fdc053e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$2f4093b97fdc053e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$2f4093b97fdc053e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $2f4093b97fdc053e$var$Buffer.isBuffer(val) ? val : $2f4093b97fdc053e$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $2f4093b97fdc053e$var$errors = {};
function $2f4093b97fdc053e$var$E(sym, getMessage, Base) {
    $2f4093b97fdc053e$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$2f4093b97fdc053e$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$2f4093b97fdc053e$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$2f4093b97fdc053e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $2f4093b97fdc053e$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $2f4093b97fdc053e$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $2f4093b97fdc053e$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $2f4093b97fdc053e$var$checkBounds(buf, offset, byteLength) {
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $2f4093b97fdc053e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $2f4093b97fdc053e$var$checkBounds(buf, offset, byteLength);
}
function $2f4093b97fdc053e$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $2f4093b97fdc053e$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $2f4093b97fdc053e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $2f4093b97fdc053e$var$validateNumber(value, type);
        throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $2f4093b97fdc053e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $2f4093b97fdc053e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $2f4093b97fdc053e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($2f4093b97fdc053e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $2f4093b97fdc053e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $2f4093b97fdc053e$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $2f4093b97fdc053e$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $2f4093b97fdc053e$var$base64ToBytes(str) {
    return $c1110228c8ce65d7$export$d622b2ad8d90c771($2f4093b97fdc053e$var$base64clean(str));
}
function $2f4093b97fdc053e$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $2f4093b97fdc053e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $2f4093b97fdc053e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $2f4093b97fdc053e$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $2f4093b97fdc053e$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $2f4093b97fdc053e$var$BufferBigIntNotDefined : fn;
}
function $2f4093b97fdc053e$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $575a7a1b3c66953d$require$Buffer = $2f4093b97fdc053e$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $575a7a1b3c66953d$var$isVisitable(thing) {
    return (0, $e14e746657dab732$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $575a7a1b3c66953d$var$removeBrackets(key) {
    return (0, $e14e746657dab732$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $575a7a1b3c66953d$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $575a7a1b3c66953d$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $575a7a1b3c66953d$var$isFlatArray(arr) {
    return (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(arr) && !arr.some($575a7a1b3c66953d$var$isVisitable);
}
const $575a7a1b3c66953d$var$predicates = (0, $e14e746657dab732$export$2e2bcd8739ae039).toFlatObject((0, $e14e746657dab732$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $575a7a1b3c66953d$var$toFormData(obj, formData, options) {
    if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $8ac03022097a5dd5$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $e14e746657dab732$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $e14e746657dab732$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $e14e746657dab732$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $575a7a1b3c66953d$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(value) && $575a7a1b3c66953d$var$isFlatArray(value) || ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFileList(value) || (0, $e14e746657dab732$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $e14e746657dab732$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $575a7a1b3c66953d$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $575a7a1b3c66953d$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($575a7a1b3c66953d$var$isVisitable(value)) return true;
        formData.append($575a7a1b3c66953d$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($575a7a1b3c66953d$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $575a7a1b3c66953d$var$isVisitable
    });
    function build(value, path) {
        if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $e14e746657dab732$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $575a7a1b3c66953d$export$2e2bcd8739ae039 = $575a7a1b3c66953d$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $7776531f53e0c6c5$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $7776531f53e0c6c5$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $575a7a1b3c66953d$export$2e2bcd8739ae039)(params, this, options);
}
const $7776531f53e0c6c5$var$prototype = $7776531f53e0c6c5$var$AxiosURLSearchParams.prototype;
$7776531f53e0c6c5$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$7776531f53e0c6c5$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $7776531f53e0c6c5$var$encode);
    } : $7776531f53e0c6c5$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $7776531f53e0c6c5$export$2e2bcd8739ae039 = $7776531f53e0c6c5$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $980692a7e6ab2ca1$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $980692a7e6ab2ca1$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $980692a7e6ab2ca1$var$encode;
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $e14e746657dab732$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $7776531f53e0c6c5$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $7c3d1c9aa6253f01$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $7c3d1c9aa6253f01$export$2e2bcd8739ae039 = $7c3d1c9aa6253f01$var$InterceptorManager;





'use strict';
var $7a06460d2a543af8$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $581e7701d5b1b567$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $7776531f53e0c6c5$export$2e2bcd8739ae039);


'use strict';
var $01aa13adf104a672$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $c0cb1d1e091daf75$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $89cfe0aa23b1208c$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $581e7701d5b1b567$export$2e2bcd8739ae039,
        FormData: $01aa13adf104a672$export$2e2bcd8739ae039,
        Blob: $c0cb1d1e091daf75$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $b058f72f8a49e9e6$exports = {};

$parcel$export($b058f72f8a49e9e6$exports, "hasBrowserEnv", function () { return $b058f72f8a49e9e6$export$c4996c4b7b93b0bf; });
$parcel$export($b058f72f8a49e9e6$exports, "navigator", function () { return $b058f72f8a49e9e6$export$ec7c8efa7f5790ae; });
$parcel$export($b058f72f8a49e9e6$exports, "hasStandardBrowserEnv", function () { return $b058f72f8a49e9e6$export$c0bcc9250309d66; });
$parcel$export($b058f72f8a49e9e6$exports, "hasStandardBrowserWebWorkerEnv", function () { return $b058f72f8a49e9e6$export$c81692cf5af97dac; });
$parcel$export($b058f72f8a49e9e6$exports, "origin", function () { return $b058f72f8a49e9e6$export$f710a83a91838a36; });
const $b058f72f8a49e9e6$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $b058f72f8a49e9e6$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $b058f72f8a49e9e6$export$c0bcc9250309d66 = $b058f72f8a49e9e6$export$c4996c4b7b93b0bf && (!$b058f72f8a49e9e6$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($b058f72f8a49e9e6$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $b058f72f8a49e9e6$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $b058f72f8a49e9e6$export$f710a83a91838a36 = $b058f72f8a49e9e6$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $7fd3c69be80c5bd1$export$2e2bcd8739ae039 = {
    ...$b058f72f8a49e9e6$exports,
    ...(0, $89cfe0aa23b1208c$export$2e2bcd8739ae039)
};


'use strict';
function $edbbc65d5fa35a0c$export$2e2bcd8739ae039(data, options) {
    return (0, $575a7a1b3c66953d$export$2e2bcd8739ae039)(data, new (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).isNode && (0, $e14e746657dab732$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cfa05ce05f902dff$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $e14e746657dab732$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cfa05ce05f902dff$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cfa05ce05f902dff$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $e14e746657dab732$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cfa05ce05f902dff$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFormData(formData) && (0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $e14e746657dab732$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cfa05ce05f902dff$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cfa05ce05f902dff$export$2e2bcd8739ae039 = $cfa05ce05f902dff$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $c2e9062dc8ffa4ed$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $e14e746657dab732$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $c2e9062dc8ffa4ed$var$defaults = {
    transitional: (0, $7a06460d2a543af8$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $e14e746657dab732$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $e14e746657dab732$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $e14e746657dab732$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cfa05ce05f902dff$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isBuffer(data) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isStream(data) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isFile(data) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isBlob(data) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $edbbc65d5fa35a0c$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $e14e746657dab732$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $575a7a1b3c66953d$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $c2e9062dc8ffa4ed$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $c2e9062dc8ffa4ed$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isResponse(data) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $e14e746657dab732$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).from(e, (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $e14e746657dab732$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $c2e9062dc8ffa4ed$var$defaults.headers[method] = {};
});
var $c2e9062dc8ffa4ed$export$2e2bcd8739ae039 = $c2e9062dc8ffa4ed$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $a38ba91528f6b89b$var$ignoreDuplicateOf = (0, $e14e746657dab732$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $a38ba91528f6b89b$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $a38ba91528f6b89b$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $07f38f3cc343860f$var$$internals = Symbol('internals');
function $07f38f3cc343860f$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $07f38f3cc343860f$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(value) ? value.map($07f38f3cc343860f$var$normalizeValue) : String(value);
}
function $07f38f3cc343860f$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $07f38f3cc343860f$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $07f38f3cc343860f$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $07f38f3cc343860f$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $07f38f3cc343860f$var$buildAccessors(obj, header) {
    const accessorName = (0, $e14e746657dab732$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $07f38f3cc343860f$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $07f38f3cc343860f$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $e14e746657dab732$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $07f38f3cc343860f$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$07f38f3cc343860f$var$isValidHeaderName(header)) setHeaders((0, $a38ba91528f6b89b$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $07f38f3cc343860f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $e14e746657dab732$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $07f38f3cc343860f$var$parseTokens(value);
                if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $07f38f3cc343860f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $e14e746657dab732$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $07f38f3cc343860f$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $07f38f3cc343860f$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $e14e746657dab732$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $07f38f3cc343860f$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $07f38f3cc343860f$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $e14e746657dab732$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $07f38f3cc343860f$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $07f38f3cc343860f$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $07f38f3cc343860f$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$07f38f3cc343860f$var$$internals] = this[$07f38f3cc343860f$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $07f38f3cc343860f$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $07f38f3cc343860f$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$07f38f3cc343860f$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $e14e746657dab732$export$2e2bcd8739ae039).reduceDescriptors($07f38f3cc343860f$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $e14e746657dab732$export$2e2bcd8739ae039).freezeMethods($07f38f3cc343860f$var$AxiosHeaders);
var $07f38f3cc343860f$export$2e2bcd8739ae039 = $07f38f3cc343860f$var$AxiosHeaders;


'use strict';
function $204e554d53ef7a67$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $c2e9062dc8ffa4ed$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $71cbd2ea5d8ede34$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $c4355937ca423a58$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $e14e746657dab732$export$2e2bcd8739ae039).inherits($c4355937ca423a58$var$CanceledError, (0, $e7b34f3e9833a518$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $c4355937ca423a58$export$2e2bcd8739ae039 = $c4355937ca423a58$var$CanceledError;







'use strict';
function $927ba25680014314$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $2b8c43b021704d7e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $7d9c5ddf80160b8c$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $7d9c5ddf80160b8c$export$2e2bcd8739ae039 = $7d9c5ddf80160b8c$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $3e6ee64efc082924$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $3e6ee64efc082924$export$2e2bcd8739ae039 = $3e6ee64efc082924$var$throttle;



const $931a60ed9ea89a45$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $7d9c5ddf80160b8c$export$2e2bcd8739ae039)(50, 250);
    return (0, $3e6ee64efc082924$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $931a60ed9ea89a45$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $931a60ed9ea89a45$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $e14e746657dab732$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $ce34ef6c1ecca371$export$2e2bcd8739ae039 = (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).origin), (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $b18cf3b493bd6b5c$export$2e2bcd8739ae039 = (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $e14e746657dab732$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $e14e746657dab732$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $e14e746657dab732$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fafacd91a7830ad$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $ce5b162032bc0f2a$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $96a2fc02d299599f$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fafacd91a7830ad$export$2e2bcd8739ae039)(requestedURL)) return (0, $ce5b162032bc0f2a$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $7faca8401f8043c4$var$headersToObject = (thing)=>thing instanceof (0, $07f38f3cc343860f$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $7faca8401f8043c4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isPlainObject(target) && (0, $e14e746657dab732$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $e14e746657dab732$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $e14e746657dab732$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($7faca8401f8043c4$var$headersToObject(a), $7faca8401f8043c4$var$headersToObject(b), prop, true)
    };
    (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $23cfd0a9bbcc15ce$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $7faca8401f8043c4$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $980692a7e6ab2ca1$export$2e2bcd8739ae039)((0, $96a2fc02d299599f$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $ce34ef6c1ecca371$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $b18cf3b493bd6b5c$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $27316d2a1215f5e9$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $27316d2a1215f5e9$export$2e2bcd8739ae039 = $27316d2a1215f5e9$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $23cfd0a9bbcc15ce$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $927ba25680014314$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('Request aborted', (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('Network Error', (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $7a06460d2a543af8$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ETIMEDOUT : (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $931a60ed9ea89a45$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $931a60ed9ea89a45$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $c4355937ca423a58$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $2b8c43b021704d7e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $def561fd0e54a2f3$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $e7b34f3e9833a518$export$2e2bcd8739ae039) ? err : new (0, $c4355937ca423a58$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $e14e746657dab732$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $def561fd0e54a2f3$export$2e2bcd8739ae039 = $def561fd0e54a2f3$var$composeSignals;


const $26b8442aede94ce3$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $26b8442aede94ce3$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $26b8442aede94ce3$var$readStream(iterable))yield* $26b8442aede94ce3$export$71b051935044bd5d(chunk, chunkSize);
};
const $26b8442aede94ce3$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $26b8442aede94ce3$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $26b8442aede94ce3$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $ae90465a59e0e2d0$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $ae90465a59e0e2d0$var$isReadableStreamSupported = $ae90465a59e0e2d0$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $ae90465a59e0e2d0$var$encodeText = $ae90465a59e0e2d0$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $ae90465a59e0e2d0$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $ae90465a59e0e2d0$var$supportsRequestStream = $ae90465a59e0e2d0$var$isReadableStreamSupported && $ae90465a59e0e2d0$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $ae90465a59e0e2d0$var$DEFAULT_CHUNK_SIZE = 65536;
const $ae90465a59e0e2d0$var$supportsResponseStream = $ae90465a59e0e2d0$var$isReadableStreamSupported && $ae90465a59e0e2d0$var$test(()=>(0, $e14e746657dab732$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $ae90465a59e0e2d0$var$resolvers = {
    stream: $ae90465a59e0e2d0$var$supportsResponseStream && ((res)=>res.body)
};
$ae90465a59e0e2d0$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$ae90465a59e0e2d0$var$resolvers[type] && ($ae90465a59e0e2d0$var$resolvers[type] = (0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $ae90465a59e0e2d0$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $7fd3c69be80c5bd1$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $e14e746657dab732$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isString(body)) return (await $ae90465a59e0e2d0$var$encodeText(body)).byteLength;
};
const $ae90465a59e0e2d0$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $e14e746657dab732$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $ae90465a59e0e2d0$var$getBodyLength(body) : length;
};
var $ae90465a59e0e2d0$export$2e2bcd8739ae039 = $ae90465a59e0e2d0$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $23cfd0a9bbcc15ce$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $def561fd0e54a2f3$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $ae90465a59e0e2d0$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $ae90465a59e0e2d0$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $931a60ed9ea89a45$export$d9fadd12586c18d6)(requestContentLength, (0, $931a60ed9ea89a45$export$c1b28109d46c3592)((0, $931a60ed9ea89a45$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $26b8442aede94ce3$export$b0119225647bd83)(_request.body, $ae90465a59e0e2d0$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $e14e746657dab732$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $ae90465a59e0e2d0$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($ae90465a59e0e2d0$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $e14e746657dab732$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $931a60ed9ea89a45$export$d9fadd12586c18d6)(responseContentLength, (0, $931a60ed9ea89a45$export$c1b28109d46c3592)((0, $931a60ed9ea89a45$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $26b8442aede94ce3$export$b0119225647bd83)(response.body, $ae90465a59e0e2d0$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $ae90465a59e0e2d0$var$resolvers[(0, $e14e746657dab732$export$2e2bcd8739ae039).findKey($ae90465a59e0e2d0$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $927ba25680014314$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('Network Error', (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $3f386065f44b7283$var$knownAdapters = {
    http: (0, $8ac03022097a5dd5$export$2e2bcd8739ae039),
    xhr: (0, $27316d2a1215f5e9$export$2e2bcd8739ae039),
    fetch: (0, $ae90465a59e0e2d0$export$2e2bcd8739ae039)
};
(0, $e14e746657dab732$export$2e2bcd8739ae039).forEach($3f386065f44b7283$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $3f386065f44b7283$var$renderReason = (reason)=>`- ${reason}`;
const $3f386065f44b7283$var$isResolvedHandle = (adapter)=>(0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $3f386065f44b7283$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $e14e746657dab732$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$3f386065f44b7283$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $3f386065f44b7283$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($3f386065f44b7283$var$renderReason).join('\n') : ' ' + $3f386065f44b7283$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $3f386065f44b7283$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $e78dac5eea6144cd$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $c4355937ca423a58$export$2e2bcd8739ae039)(null, config);
}
function $e78dac5eea6144cd$export$2e2bcd8739ae039(config) {
    $e78dac5eea6144cd$var$throwIfCancellationRequested(config);
    config.headers = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $204e554d53ef7a67$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $3f386065f44b7283$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $c2e9062dc8ffa4ed$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $e78dac5eea6144cd$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $204e554d53ef7a67$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $71cbd2ea5d8ede34$export$2e2bcd8739ae039)(reason)) {
            $e78dac5eea6144cd$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $204e554d53ef7a67$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $1912db2f7a1ce0bd$export$a4ad2735b021c132 = "1.7.9";



'use strict';
const $6784c65ea4560a1f$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $6784c65ea4560a1f$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $6784c65ea4560a1f$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $6784c65ea4560a1f$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $1912db2f7a1ce0bd$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$6784c65ea4560a1f$var$deprecatedWarnings[opt]) {
            $6784c65ea4560a1f$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$6784c65ea4560a1f$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $6784c65ea4560a1f$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('options must be an object', (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $e7b34f3e9833a518$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $e7b34f3e9833a518$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $6784c65ea4560a1f$export$2e2bcd8739ae039 = {
    assertOptions: $6784c65ea4560a1f$var$assertOptions,
    validators: $6784c65ea4560a1f$var$validators
};



'use strict';
const $cba6217b6c946209$var$validators = (0, $6784c65ea4560a1f$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cba6217b6c946209$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $7c3d1c9aa6253f01$export$2e2bcd8739ae039)(),
            response: new (0, $7c3d1c9aa6253f01$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $7faca8401f8043c4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $6784c65ea4560a1f$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cba6217b6c946209$var$validators.transitional($cba6217b6c946209$var$validators.boolean),
            forcedJSONParsing: $cba6217b6c946209$var$validators.transitional($cba6217b6c946209$var$validators.boolean),
            clarifyTimeoutError: $cba6217b6c946209$var$validators.transitional($cba6217b6c946209$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $e14e746657dab732$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $6784c65ea4560a1f$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cba6217b6c946209$var$validators.function,
                serialize: $cba6217b6c946209$var$validators.function
            }, true);
        }
        (0, $6784c65ea4560a1f$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $cba6217b6c946209$var$validators.spelling('baseURL'),
            withXsrfToken: $cba6217b6c946209$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $e14e746657dab732$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $e14e746657dab732$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $07f38f3cc343860f$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $e78dac5eea6144cd$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $e78dac5eea6144cd$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $7faca8401f8043c4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $96a2fc02d299599f$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $980692a7e6ab2ca1$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $e14e746657dab732$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cba6217b6c946209$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $7faca8401f8043c4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $e14e746657dab732$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $7faca8401f8043c4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cba6217b6c946209$var$Axios.prototype[method] = generateHTTPMethod();
    $cba6217b6c946209$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cba6217b6c946209$export$2e2bcd8739ae039 = $cba6217b6c946209$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $40e598944e060b76$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $c4355937ca423a58$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $40e598944e060b76$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $40e598944e060b76$export$2e2bcd8739ae039 = $40e598944e060b76$var$CancelToken;






'use strict';
function $905d59867c7a98c4$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $174fd50527e8b66f$export$2e2bcd8739ae039(payload) {
    return (0, $e14e746657dab732$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $aec07c40fd51f24f$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($aec07c40fd51f24f$var$HttpStatusCode).forEach(([key, value])=>{
    $aec07c40fd51f24f$var$HttpStatusCode[value] = key;
});
var $aec07c40fd51f24f$export$2e2bcd8739ae039 = $aec07c40fd51f24f$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c70f1fd00fef8e80$var$createInstance(defaultConfig) {
    const context = new (0, $cba6217b6c946209$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $360f3c3463da7332$export$2e2bcd8739ae039)((0, $cba6217b6c946209$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $e14e746657dab732$export$2e2bcd8739ae039).extend(instance, (0, $cba6217b6c946209$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $e14e746657dab732$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c70f1fd00fef8e80$var$createInstance((0, $7faca8401f8043c4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c70f1fd00fef8e80$var$axios = $c70f1fd00fef8e80$var$createInstance((0, $c2e9062dc8ffa4ed$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c70f1fd00fef8e80$var$axios.Axios = (0, $cba6217b6c946209$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c70f1fd00fef8e80$var$axios.CanceledError = (0, $c4355937ca423a58$export$2e2bcd8739ae039);
$c70f1fd00fef8e80$var$axios.CancelToken = (0, $40e598944e060b76$export$2e2bcd8739ae039);
$c70f1fd00fef8e80$var$axios.isCancel = (0, $71cbd2ea5d8ede34$export$2e2bcd8739ae039);
$c70f1fd00fef8e80$var$axios.VERSION = (0, $1912db2f7a1ce0bd$export$a4ad2735b021c132);
$c70f1fd00fef8e80$var$axios.toFormData = (0, $575a7a1b3c66953d$export$2e2bcd8739ae039);
// Expose AxiosError class
$c70f1fd00fef8e80$var$axios.AxiosError = (0, $e7b34f3e9833a518$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c70f1fd00fef8e80$var$axios.Cancel = $c70f1fd00fef8e80$var$axios.CanceledError;
// Expose all/spread
$c70f1fd00fef8e80$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c70f1fd00fef8e80$var$axios.spread = (0, $905d59867c7a98c4$export$2e2bcd8739ae039);
// Expose isAxiosError
$c70f1fd00fef8e80$var$axios.isAxiosError = (0, $174fd50527e8b66f$export$2e2bcd8739ae039);
// Expose mergeConfig
$c70f1fd00fef8e80$var$axios.mergeConfig = (0, $7faca8401f8043c4$export$2e2bcd8739ae039);
$c70f1fd00fef8e80$var$axios.AxiosHeaders = (0, $07f38f3cc343860f$export$2e2bcd8739ae039);
$c70f1fd00fef8e80$var$axios.formToJSON = (thing)=>(0, $cfa05ce05f902dff$export$2e2bcd8739ae039)((0, $e14e746657dab732$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c70f1fd00fef8e80$var$axios.getAdapter = (0, $3f386065f44b7283$export$2e2bcd8739ae039).getAdapter;
$c70f1fd00fef8e80$var$axios.HttpStatusCode = (0, $aec07c40fd51f24f$export$2e2bcd8739ae039);
$c70f1fd00fef8e80$var$axios.default = $c70f1fd00fef8e80$var$axios;
var // this module should only have a default export
$c70f1fd00fef8e80$export$2e2bcd8739ae039 = $c70f1fd00fef8e80$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $825f481ca7ec0de3$export$1c00760e9e5a4e95, AxiosError: $825f481ca7ec0de3$export$c1fbed17c2f6a328, CanceledError: $825f481ca7ec0de3$export$1ab0c6b20d94fa14, isCancel: $825f481ca7ec0de3$export$3b22524397b493c6, CancelToken: $825f481ca7ec0de3$export$fd08e3cb425f0d61, VERSION: $825f481ca7ec0de3$export$a4ad2735b021c132, all: $825f481ca7ec0de3$export$84bf76cd7afc7469, Cancel: $825f481ca7ec0de3$export$848c9b7ead0df967, isAxiosError: $825f481ca7ec0de3$export$fbafdbe06a5b5a9a, spread: $825f481ca7ec0de3$export$3ae0fd4797ed47c8, toFormData: $825f481ca7ec0de3$export$10ae0d317ea97f8b, AxiosHeaders: $825f481ca7ec0de3$export$4e7d6ff0f3e6520, HttpStatusCode: $825f481ca7ec0de3$export$a972f69c851492b3, formToJSON: $825f481ca7ec0de3$export$86d7c59254d6a2c9, getAdapter: $825f481ca7ec0de3$export$17ddc20a97d669e2, mergeConfig: $825f481ca7ec0de3$export$7ec1ebcfa9d8bd6a } = (0, $c70f1fd00fef8e80$export$2e2bcd8739ae039);



let $0c6c769a0b0e21f2$var$accessToken = null;
let $0c6c769a0b0e21f2$var$failedQueue = [];
const $0c6c769a0b0e21f2$export$9bfe7023cfca0786 = (token)=>{
    $0c6c769a0b0e21f2$var$accessToken = token;
    if (token) $0c6c769a0b0e21f2$export$388e0302ca0d9a41.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    else delete $0c6c769a0b0e21f2$export$388e0302ca0d9a41.defaults.headers.common['Authorization'];
};
const $0c6c769a0b0e21f2$var$processQueue = (error)=>{
    $0c6c769a0b0e21f2$var$failedQueue.forEach((prom)=>{
        if (error) prom.reject(error);
        else prom.resolve();
    });
    $0c6c769a0b0e21f2$var$failedQueue = [];
};
const $0c6c769a0b0e21f2$export$388e0302ca0d9a41 = $0c6c769a0b0e21f2$var$createAxiosClient({
    options: {
        baseURL: (0, $87c980b245bbb7d9$export$c3ee1e672e1e24e7),
        timeout: 300000
    }
});
function $0c6c769a0b0e21f2$var$createAxiosClient({ options: options }) {
    const client = (0, $c70f1fd00fef8e80$export$2e2bcd8739ae039).create(options);
    client.interceptors.response.use((response)=>{
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, (error)=>{
        const originalRequest = error.config;
        // If error, process all the requests in the queue and logout the user.
        const handleError = (error)=>{
            $0c6c769a0b0e21f2$var$processQueue(error);
            // TODO: logout user?
            return Promise.reject(error);
        };
        /*
      // Refresh token conditions
      if (
        error.response?.status === 401 &&
        error.response.data.error === 'Token is not valid or has expired' &&
        originalRequest?._retry !== true
      ) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject })
          })
            .then(() => {
              return client(originalRequest)
            })
            .catch((err) => {
              return Promise.reject(err)
            })
        }
        isRefreshing = true
        originalRequest._retry = true

        LoginAPI.getAuthSession()
          .then((authSession) => {
            setJwtToken(authSession.tokens?.idToken?.toString() || '')
            processQueue(null)
            return client(originalRequest)
          }, handleError)
          .finally(() => {
            isRefreshing = false
          })
      }

      // Refresh token missing or expired => logout user...
      if (
        error.response?.status === 401 &&
        error.response.data.error === 'Token is not valid or has expired'
      ) {
        return handleError(error)
      }
      */ // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    });
    return client;
}


const $0e9294c15beacf0d$var$apiUrl = `${(0, $87c980b245bbb7d9$export$c3ee1e672e1e24e7)}/v1`;
const $0e9294c15beacf0d$var$getInvoices = (licensePlate)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$0e9294c15beacf0d$var$apiUrl}/invoices`, {
        params: {
            licensePlate: licensePlate
        }
    });
};
var $0e9294c15beacf0d$export$2e2bcd8739ae039 = {
    getInvoices: $0e9294c15beacf0d$var$getInvoices
};


var $c8a51a1a3cac62e6$export$9e355b279c43f205 = /*#__PURE__*/ function(PaymentSteps) {
    PaymentSteps["FILL_LICENSE_PLATE"] = "FILL_LICENSE_PLATE";
    PaymentSteps["FILL_LICENSE_PLATE_ERROR"] = "FILL_LICENSE_PLATE_ERROR";
    PaymentSteps["INVOICE"] = "INVOICE";
    PaymentSteps["INVOICE_ERROR"] = "INVOICE_ERROR";
    PaymentSteps["FINISH"] = "FINISH";
    PaymentSteps["FINISH_ERROR"] = "FINISH_ERROR";
    return PaymentSteps;
}({});


const $2732b3fe4895f686$export$e8c70a271f6ea3de = 'licensePlate';
const $2732b3fe4895f686$export$c02a0b32732a12b7 = 'paymentStep';
const $2732b3fe4895f686$export$e91329546f645e07 = 'userEmail';



var $e1vzu = parcelRequire("e1vzu");




var $d0aSw = parcelRequire("d0aSw");

var $3QbnI = parcelRequire("3QbnI");



var $iCj5F = parcelRequire("iCj5F");
'use client';
var $563f2fd432336b71$export$2e2bcd8739ae039 = (0, $259168cd063bb08e$export$2e2bcd8739ae039);


function $ea61120fd9474d83$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}



var $2TGnx = parcelRequire("2TGnx");

var $cxyce = parcelRequire("cxyce");

var $9t00Y = parcelRequire("9t00Y");
'use client';
function $4ecdb9b628b43462$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $2d05d0cee982a7a9$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $cxyce.default,
        themeId: (0, $9t00Y.default)
    });
}



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $dTxTI = parcelRequire("dTxTI");

var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");


var $iCj5F = parcelRequire("iCj5F");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $6ca980fc36632761$export$5a6f9035944c8119(slot) {
    return (0, $9uBH9.default)('MuiButton', slot);
}
const $6ca980fc36632761$var$buttonClasses = (0, $6N1Oq.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $6ca980fc36632761$export$2e2bcd8739ae039 = $6ca980fc36632761$var$buttonClasses;



var $3QbnI = parcelRequire("3QbnI");
/**
 * @ignore - internal component.
 */ const $997f1e9ac31d2763$var$ButtonGroupContext = /*#__PURE__*/ $3QbnI.createContext({});
var $997f1e9ac31d2763$export$2e2bcd8739ae039 = $997f1e9ac31d2763$var$ButtonGroupContext;



var $3QbnI = parcelRequire("3QbnI");
/**
 * @ignore - internal component.
 */ const $0d59f0ba03d26814$var$ButtonGroupButtonContext = /*#__PURE__*/ $3QbnI.createContext(undefined);
var $0d59f0ba03d26814$export$2e2bcd8739ae039 = $0d59f0ba03d26814$var$ButtonGroupButtonContext;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $eefbd326883d0eeb$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $iCj5F.default)(color)}`,
            `size${(0, $iCj5F.default)(size)}`,
            `${variant}Size${(0, $iCj5F.default)(size)}`,
            `color${(0, $iCj5F.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $iCj5F.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $iCj5F.default)(size)}`
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $6ca980fc36632761$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $eefbd326883d0eeb$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $eefbd326883d0eeb$var$ButtonRoot = (0, $2TGnx.default)((0, $0c5993b2b6821c5b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iCj5F.default)(ownerState.color)}`],
            styles[`size${(0, $iCj5F.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $iCj5F.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $6ca980fc36632761$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $6ca980fc36632761$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $6ca980fc36632761$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $6ca980fc36632761$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $aDUe6.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $6ca980fc36632761$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $6ca980fc36632761$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    };
}));
const $eefbd326883d0eeb$var$ButtonStartIcon = (0, $2TGnx.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $iCj5F.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inherit',
    marginRight: 8,
    marginLeft: -4,
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                marginLeft: -2
            }
        },
        ...$eefbd326883d0eeb$var$commonIconStyles
    ]
});
const $eefbd326883d0eeb$var$ButtonEndIcon = (0, $2TGnx.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $iCj5F.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inherit',
    marginRight: -4,
    marginLeft: 8,
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                marginRight: -2
            }
        },
        ...$eefbd326883d0eeb$var$commonIconStyles
    ]
});
const $eefbd326883d0eeb$var$Button = /*#__PURE__*/ $3QbnI.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $3QbnI.useContext((0, $997f1e9ac31d2763$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $3QbnI.useContext((0, $0d59f0ba03d26814$export$2e2bcd8739ae039));
    const resolvedProps = (0, $dTxTI.default)(contextProps, inProps);
    const props = (0, $vqOnh.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $eefbd326883d0eeb$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $e1vzu.jsx)($eefbd326883d0eeb$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $e1vzu.jsx)($eefbd326883d0eeb$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($eefbd326883d0eeb$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $eTLbi.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $eTLbi.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        ...other,
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    });
});
var $eefbd326883d0eeb$export$2e2bcd8739ae039 = $eefbd326883d0eeb$var$Button;





var $d0aSw = parcelRequire("d0aSw");
function $3d0595c7b2a5280c$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $d0aSw.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $d0aSw.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $d0aSw.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $3d0595c7b2a5280c$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}


const $7ab172c48c47f32f$var$defaultGenerator = (componentName)=>componentName;
const $7ab172c48c47f32f$var$createClassNameGenerator = ()=>{
    let generate = $7ab172c48c47f32f$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $7ab172c48c47f32f$var$defaultGenerator;
        }
    };
};
const $7ab172c48c47f32f$var$ClassNameGenerator = $7ab172c48c47f32f$var$createClassNameGenerator();
var $7ab172c48c47f32f$export$2e2bcd8739ae039 = $7ab172c48c47f32f$var$ClassNameGenerator;


const $c6e138298fcd1c98$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $c6e138298fcd1c98$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $c6e138298fcd1c98$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $7ab172c48c47f32f$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $c6e138298fcd1c98$export$34c0130b1f3e8ae3(slot) {
    return $c6e138298fcd1c98$export$9d6b9120de57c54[slot] !== undefined;
}



function $d66e35b7bf6ed776$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $c6e138298fcd1c98$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


function $694ebc46f554fb58$export$24fdd7c0683a4fed(slot) {
    return (0, $c6e138298fcd1c98$export$2e2bcd8739ae039)('MuiLoadingButton', slot);
}
const $694ebc46f554fb58$var$loadingButtonClasses = (0, $d66e35b7bf6ed776$export$2e2bcd8739ae039)('MuiLoadingButton', [
    'root',
    'loading',
    'loadingIndicator',
    'loadingIndicatorCenter',
    'loadingIndicatorStart',
    'loadingIndicatorEnd',
    'endIconLoadingEnd',
    'startIconLoadingStart'
]);
var $694ebc46f554fb58$export$2e2bcd8739ae039 = $694ebc46f554fb58$var$loadingButtonClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $ea0ef6f05b188718$var$_excluded = [
    "children",
    "disabled",
    "id",
    "loading",
    "loadingIndicator",
    "loadingPosition",
    "variant"
];
const $ea0ef6f05b188718$var$useUtilityClasses = (ownerState)=>{
    const { loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading'
        ],
        startIcon: [
            loading && `startIconLoading${(0, $iCj5F.default)(loadingPosition)}`
        ],
        endIcon: [
            loading && `endIconLoading${(0, $iCj5F.default)(loadingPosition)}`
        ],
        loadingIndicator: [
            'loadingIndicator',
            loading && `loadingIndicator${(0, $iCj5F.default)(loadingPosition)}`
        ]
    };
    const composedClasses = (0, $ea61120fd9474d83$export$2e2bcd8739ae039)(slots, (0, $694ebc46f554fb58$export$24fdd7c0683a4fed), classes);
    return (0, $d0aSw.default)({}, classes, composedClasses);
};
// TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const $ea0ef6f05b188718$var$rootShouldForwardProp = (prop)=>prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as' && prop !== 'classes';
const $ea0ef6f05b188718$var$LoadingButtonRoot = (0, $2TGnx.default)((0, $eefbd326883d0eeb$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>$ea0ef6f05b188718$var$rootShouldForwardProp(prop) || prop === 'classes',
    name: 'MuiLoadingButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            styles.root,
            styles.startIconLoadingStart && {
                [`& .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).startIconLoadingStart}`]: styles.startIconLoadingStart
            },
            styles.endIconLoadingEnd && {
                [`& .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).endIconLoadingEnd}`]: styles.endIconLoadingEnd
            }
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $d0aSw.default)({
        [`& .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0
        }
    }, ownerState.loadingPosition === 'center' && {
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        [`&.${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    }, ownerState.loadingPosition === 'start' && ownerState.fullWidth && {
        [`& .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginRight: -8
        }
    }, ownerState.loadingPosition === 'end' && ownerState.fullWidth && {
        [`& .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $694ebc46f554fb58$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginLeft: -8
        }
    }));
const $ea0ef6f05b188718$var$LoadingButtonLoadingIndicator = (0, $2TGnx.default)('span', {
    name: 'MuiLoadingButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.loadingIndicator,
            styles[`loadingIndicator${(0, $iCj5F.default)(ownerState.loadingPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $d0aSw.default)({
        position: 'absolute',
        visibility: 'visible',
        display: 'flex'
    }, ownerState.loadingPosition === 'start' && (ownerState.variant === 'outlined' || ownerState.variant === 'contained') && {
        left: ownerState.size === 'small' ? 10 : 14
    }, ownerState.loadingPosition === 'start' && ownerState.variant === 'text' && {
        left: 6
    }, ownerState.loadingPosition === 'center' && {
        left: '50%',
        transform: 'translate(-50%)',
        color: (theme.vars || theme).palette.action.disabled
    }, ownerState.loadingPosition === 'end' && (ownerState.variant === 'outlined' || ownerState.variant === 'contained') && {
        right: ownerState.size === 'small' ? 10 : 14
    }, ownerState.loadingPosition === 'end' && ownerState.variant === 'text' && {
        right: 6
    }, ownerState.loadingPosition === 'start' && ownerState.fullWidth && {
        position: 'relative',
        left: -10
    }, ownerState.loadingPosition === 'end' && ownerState.fullWidth && {
        position: 'relative',
        right: -10
    }));
const $ea0ef6f05b188718$var$LoadingButton = /*#__PURE__*/ $3QbnI.forwardRef(function LoadingButton(inProps, ref) {
    const contextProps = $3QbnI.useContext((0, $997f1e9ac31d2763$export$2e2bcd8739ae039));
    const resolvedProps = (0, $3d0595c7b2a5280c$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $4ecdb9b628b43462$export$2e2bcd8739ae039)({
        props: resolvedProps,
        name: 'MuiLoadingButton'
    });
    const { children: children, disabled: disabled = false, id: idProp, loading: loading = false, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', variant: variant = 'text' } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $ea0ef6f05b188718$var$_excluded);
    const id = (0, $563f2fd432336b71$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fccdfec3f47c0093$export$2e2bcd8739ae039), {
        "aria-labelledby": id,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $d0aSw.default)({}, props, {
        disabled: disabled,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        variant: variant
    });
    const classes = $ea0ef6f05b188718$var$useUtilityClasses(ownerState);
    const loadingButtonLoadingIndicator = loading ? /*#__PURE__*/ (0, $e1vzu.jsx)($ea0ef6f05b188718$var$LoadingButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState: ownerState,
        children: loadingIndicator
    }) : null;
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($ea0ef6f05b188718$var$LoadingButtonRoot, (0, $d0aSw.default)({
        disabled: disabled || loading,
        id: id,
        ref: ref
    }, other, {
        variant: variant,
        classes: classes,
        ownerState: ownerState,
        children: [
            ownerState.loadingPosition === 'end' ? children : loadingButtonLoadingIndicator,
            ownerState.loadingPosition === 'end' ? loadingButtonLoadingIndicator : children
        ]
    }));
});
var $ea0ef6f05b188718$export$2e2bcd8739ae039 = $ea0ef6f05b188718$var$LoadingButton;


parcelRequire("3QbnI");
const $234b0cbb679ba096$var$MoovyButton = (props)=>{
    const { mutation: mutation, query: query, startIcon: startIcon, showAsIconButton: showAsIconButton, ...rest } = props;
    const isLoading = props?.mutation?.isPending || props?.query?.isFetching || props?.query?.isLoading;
    const NormalButton = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ea0ef6f05b188718$export$2e2bcd8739ae039), {
            ...rest,
            disabled: isLoading || !!props.disabled,
            loading: isLoading,
            variant: props.variant || 'contained',
            children: props?.children
        });
    };
    const IconOnlyButton = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                visibility: rest.hidden ? 'hidden' : undefined
            },
            children: [
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
                    disabled: isLoading || !!props.disabled,
                    ...rest,
                    children: startIcon
                }),
                isLoading && /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fccdfec3f47c0093$export$2e2bcd8739ae039), {
                    size: 24,
                    style: {
                        position: 'absolute'
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: showAsIconButton ? /*#__PURE__*/ (0, $e1vzu.jsx)(IconOnlyButton, {}) : /*#__PURE__*/ (0, $e1vzu.jsx)(NormalButton, {})
    });
};
var $234b0cbb679ba096$export$2e2bcd8739ae039 = $234b0cbb679ba096$var$MoovyButton;



var $e1vzu = parcelRequire("e1vzu");



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");



var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $06aed526e7b1201f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $9ec058eb019e7fdb$export$1061006a0db3aeb5), classes);
};
const $06aed526e7b1201f$var$ListItemTextRoot = (0, $2TGnx.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9ec058eb019e7fdb$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $9ec058eb019e7fdb$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $d5a6d5915630c5f7$export$2e2bcd8739ae039).root}:where(& .${(0, $9ec058eb019e7fdb$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $d5a6d5915630c5f7$export$2e2bcd8739ae039).root}:where(& .${(0, $9ec058eb019e7fdb$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $06aed526e7b1201f$var$ListItemText = /*#__PURE__*/ $3QbnI.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $3QbnI.useContext((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $06aed526e7b1201f$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [PrimarySlot, primarySlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $311a456630f5f039$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $311a456630f5f039$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $311a456630f5f039$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $e1vzu.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $311a456630f5f039$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $e1vzu.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($06aed526e7b1201f$var$ListItemTextRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            primary,
            secondary
        ]
    });
});
var $06aed526e7b1201f$export$2e2bcd8739ae039 = $06aed526e7b1201f$var$ListItemText;



var $3QbnI = parcelRequire("3QbnI");

var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");



'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $6b20c813365ab96f$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $6b20c813365ab96f$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $6b20c813365ab96f$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $3QbnI.useRef(false);
    const nodeRef = $3QbnI.useRef(null);
    const activatedRef = $3QbnI.useRef(false);
    const syntheticEventRef = $3QbnI.useRef(false);
    $3QbnI.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $379786810d55b52d$export$2e2bcd8739ae039)((0, $bca562fe1e155add$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $6b20c813365ab96f$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $3QbnI.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $6b20c813365ab96f$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $3QbnI.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $6b20c813365ab96f$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $3QbnI.cloneElement(children, childrenProps);
}






var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

function $23bfc64a667b2c60$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b1841ec7f0414ab1$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b1841ec7f0414ab1$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b1841ec7f0414ab1$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $23c3944bcf8f5f72$export$8960430cfd85939f = Math.max;
var $23c3944bcf8f5f72$export$96ec731ed4dcb222 = Math.min;
var $23c3944bcf8f5f72$export$2077e0241d6afd3c = Math.round;



function $aae6093e2bdd30a0$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $54db2ca5841a6abd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $aae6093e2bdd30a0$export$2e2bcd8739ae039)());
}


function $552a36f424541fa4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(element) ? (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $54db2ca5841a6abd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $da1734441d1134fd$export$2e2bcd8739ae039(node) {
    var win = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $19dd3f2770c1e823$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $dd17bca7a54a00ab$export$2e2bcd8739ae039(node) {
    if (node === (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node) || !(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(node)) return (0, $da1734441d1134fd$export$2e2bcd8739ae039)(node);
    else return (0, $19dd3f2770c1e823$export$2e2bcd8739ae039)(node);
}


function $e98e23441bde3086$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $8bb9d7df3ba6a06e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $bcbbdb54536baeac$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $552a36f424541fa4$export$2e2bcd8739ae039)((0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element)).left + (0, $da1734441d1134fd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $5a21022d6f915cf0$export$2e2bcd8739ae039(element) {
    return (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $fd78ac594e4a6e37$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $762ab75df74183a5$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $762ab75df74183a5$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(offsetParent) && $762ab75df74183a5$var$isElementScaled(offsetParent);
    var documentElement = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e98e23441bde3086$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $fd78ac594e4a6e37$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $dd17bca7a54a00ab$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $bcbbdb54536baeac$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $643a8468b8f55590$export$2e2bcd8739ae039(element) {
    if ((0, $e98e23441bde3086$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b1841ec7f0414ab1$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $f66a20117ca5d60a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $e98e23441bde3086$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(node) && (0, $fd78ac594e4a6e37$export$2e2bcd8739ae039)(node)) return node;
    return $f66a20117ca5d60a$export$2e2bcd8739ae039((0, $643a8468b8f55590$export$2e2bcd8739ae039)(node));
}





function $1580d1f1bc5f0ff3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $f66a20117ca5d60a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $fd78ac594e4a6e37$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1580d1f1bc5f0ff3$export$2e2bcd8739ae039((0, $643a8468b8f55590$export$2e2bcd8739ae039)(target)));
}







function $e883e847abce7648$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $e98e23441bde3086$export$2e2bcd8739ae039)(element)) >= 0;
}




function $4200170a8fe0a087$var$getTrueOffsetParent(element) {
    if (!(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $4200170a8fe0a087$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $aae6093e2bdd30a0$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $aae6093e2bdd30a0$export$2e2bcd8739ae039)());
    if (isIE && (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $643a8468b8f55590$export$2e2bcd8739ae039)(element);
    if ((0, $b1841ec7f0414ab1$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $e98e23441bde3086$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $4200170a8fe0a087$export$2e2bcd8739ae039(element) {
    var window = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element);
    var offsetParent = $4200170a8fe0a087$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $e883e847abce7648$export$2e2bcd8739ae039)(offsetParent) && (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $4200170a8fe0a087$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $e98e23441bde3086$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $e98e23441bde3086$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $4200170a8fe0a087$var$getContainingBlock(element) || window;
}


var $c6657ed2bd4b5f0a$export$1e95b668f3b82d = 'top';
var $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb = 'bottom';
var $c6657ed2bd4b5f0a$export$79ffe56a765070d2 = 'right';
var $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4 = 'left';
var $c6657ed2bd4b5f0a$export$dfb5619354ba860 = 'auto';
var $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3 = [
    $c6657ed2bd4b5f0a$export$1e95b668f3b82d,
    $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb,
    $c6657ed2bd4b5f0a$export$79ffe56a765070d2,
    $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4
];
var $c6657ed2bd4b5f0a$export$b3571188c770cc5a = 'start';
var $c6657ed2bd4b5f0a$export$bd5df0f255a350f8 = 'end';
var $c6657ed2bd4b5f0a$export$390fd549c5303b4d = 'clippingParents';
var $c6657ed2bd4b5f0a$export$d7b7311ec04a3e8f = 'viewport';
var $c6657ed2bd4b5f0a$export$ae5ab1c730825774 = 'popper';
var $c6657ed2bd4b5f0a$export$ca50aac9f3ba507f = 'reference';
var $c6657ed2bd4b5f0a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $c6657ed2bd4b5f0a$export$b3571188c770cc5a,
        placement + "-" + $c6657ed2bd4b5f0a$export$bd5df0f255a350f8
    ]);
}, []);
var $c6657ed2bd4b5f0a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($c6657ed2bd4b5f0a$export$aec2ce47c367b8c3, [
    $c6657ed2bd4b5f0a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $c6657ed2bd4b5f0a$export$b3571188c770cc5a,
        placement + "-" + $c6657ed2bd4b5f0a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $c6657ed2bd4b5f0a$export$421679a7c3d56e = 'beforeRead';
var $c6657ed2bd4b5f0a$export$aafa59e2e03f2942 = 'read';
var $c6657ed2bd4b5f0a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $c6657ed2bd4b5f0a$export$c65e99957a05207c = 'beforeMain';
var $c6657ed2bd4b5f0a$export$f22da7240b7add18 = 'main';
var $c6657ed2bd4b5f0a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $c6657ed2bd4b5f0a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $c6657ed2bd4b5f0a$export$68d8715fc104d294 = 'write';
var $c6657ed2bd4b5f0a$export$70a6e5159acce2e6 = 'afterWrite';
var $c6657ed2bd4b5f0a$export$d087d3878fdf71d5 = [
    $c6657ed2bd4b5f0a$export$421679a7c3d56e,
    $c6657ed2bd4b5f0a$export$aafa59e2e03f2942,
    $c6657ed2bd4b5f0a$export$6964f6c886723980,
    $c6657ed2bd4b5f0a$export$c65e99957a05207c,
    $c6657ed2bd4b5f0a$export$f22da7240b7add18,
    $c6657ed2bd4b5f0a$export$bab79516f2d662fe,
    $c6657ed2bd4b5f0a$export$8d4d2d70e7d46032,
    $c6657ed2bd4b5f0a$export$68d8715fc104d294,
    $c6657ed2bd4b5f0a$export$70a6e5159acce2e6
];


function $46ba3bafee2163e3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $46ba3bafee2163e3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $46ba3bafee2163e3$var$order(modifiers); // order based on phase
    return (0, $c6657ed2bd4b5f0a$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9cd3e4a7a0d8020b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $4ae09abd06a8d91c$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $f7095fb200459102$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $f7095fb200459102$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $f7095fb200459102$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $f7095fb200459102$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $f7095fb200459102$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(reference) ? (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $46ba3bafee2163e3$export$2e2bcd8739ae039)((0, $4ae09abd06a8d91c$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$f7095fb200459102$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $762ab75df74183a5$export$2e2bcd8739ae039)(reference, (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9cd3e4a7a0d8020b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$f7095fb200459102$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $f7095fb200459102$export$8f7491d57c8f97a9 = /*#__PURE__*/ $f7095fb200459102$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $034398a97685f722$var$passive = {
    passive: true
};
function $034398a97685f722$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $034398a97685f722$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $034398a97685f722$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $034398a97685f722$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $034398a97685f722$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $034398a97685f722$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $034398a97685f722$var$effect,
    data: {}
};



function $61de13b434c26827$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $c6a018a4a1ef38e4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $2dab833bacc18f84$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $8c30663fe0bf4764$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $61de13b434c26827$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2dab833bacc18f84$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $c6657ed2bd4b5f0a$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $817cdc30d090b763$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $8c30663fe0bf4764$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $817cdc30d090b763$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $817cdc30d090b763$var$popperOffsets,
    data: {}
};










var $3f5d8947cd4685ee$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3f5d8947cd4685ee$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3f5d8947cd4685ee$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
    var sideY = (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(popper);
            if ((0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) || (placement === (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4) || placement === (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2)) && variation === (0, $c6657ed2bd4b5f0a$export$bd5df0f255a350f8)) {
            sideY = (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4) || (placement === (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) || placement === (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)) && variation === (0, $c6657ed2bd4b5f0a$export$bd5df0f255a350f8)) {
            sideX = (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3f5d8947cd4685ee$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3f5d8947cd4685ee$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $3f5d8947cd4685ee$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $61de13b434c26827$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3f5d8947cd4685ee$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3f5d8947cd4685ee$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3f5d8947cd4685ee$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $3f5d8947cd4685ee$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $a26367323d29f85c$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) || !(0, $e98e23441bde3086$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $a26367323d29f85c$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) || !(0, $e98e23441bde3086$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $a26367323d29f85c$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $a26367323d29f85c$var$applyStyles,
    effect: $a26367323d29f85c$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $f39a2db16c583784$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4),
        (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4),
        (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f39a2db16c583784$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $c6657ed2bd4b5f0a$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $f39a2db16c583784$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f39a2db16c583784$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f39a2db16c583784$var$offset
};


var $fc0120f6911cbc7d$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $fc0120f6911cbc7d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $fc0120f6911cbc7d$var$hash[matched];
    });
}



var $5acdbe1f7ef8ca86$var$hash = {
    start: 'end',
    end: 'start'
};
function $5acdbe1f7ef8ca86$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5acdbe1f7ef8ca86$var$hash[matched];
    });
}







function $0c209d99105e5baa$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element);
    var html = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $54db2ca5841a6abd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $bcbbdb54536baeac$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f3c5111ca93a319e$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $da1734441d1134fd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $bcbbdb54536baeac$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $4c605c525ca0edeb$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b1841ec7f0414ab1$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $c0bc3f890525ed3b$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $40338b76a3b0d8f0$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $40338b76a3b0d8f0$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $c6657ed2bd4b5f0a$export$d7b7311ec04a3e8f) ? (0, $c0bc3f890525ed3b$export$2e2bcd8739ae039)((0, $0c209d99105e5baa$export$2e2bcd8739ae039)(element, strategy)) : (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(clippingParent) ? $40338b76a3b0d8f0$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $c0bc3f890525ed3b$export$2e2bcd8739ae039)((0, $f3c5111ca93a319e$export$2e2bcd8739ae039)((0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $40338b76a3b0d8f0$var$getClippingParents(element) {
    var clippingParents = (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)((0, $643a8468b8f55590$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) ? (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4c605c525ca0edeb$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $e98e23441bde3086$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $40338b76a3b0d8f0$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $40338b76a3b0d8f0$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $40338b76a3b0d8f0$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $40338b76a3b0d8f0$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $2835d14c37255796$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $50b8f91f4d6175a0$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2835d14c37255796$export$2e2bcd8739ae039)(), paddingObject);
}


function $0985dc62839206c0$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $a7b0a9f6d274853f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $c6657ed2bd4b5f0a$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $c6657ed2bd4b5f0a$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $50b8f91f4d6175a0$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0985dc62839206c0$export$2e2bcd8739ae039)(padding, (0, $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) ? (0, $c6657ed2bd4b5f0a$export$ca50aac9f3ba507f) : (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $40338b76a3b0d8f0$export$2e2bcd8739ae039)((0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $8c30663fe0bf4764$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $c0bc3f890525ed3b$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2),
                (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
                (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $8cf189dfd52c74f8$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $c6657ed2bd4b5f0a$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $c6657ed2bd4b5f0a$export$368f9a87e87fa4e1) : (0, $c6657ed2bd4b5f0a$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $61de13b434c26827$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $80a537add0d1475a$var$getExpandedFallbackPlacements(placement) {
    if ((0, $61de13b434c26827$export$2e2bcd8739ae039)(placement) === (0, $c6657ed2bd4b5f0a$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5acdbe1f7ef8ca86$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5acdbe1f7ef8ca86$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $80a537add0d1475a$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $80a537add0d1475a$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $61de13b434c26827$export$2e2bcd8739ae039)(placement) === (0, $c6657ed2bd4b5f0a$export$dfb5619354ba860) ? (0, $8cf189dfd52c74f8$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement) === (0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a);
        var isVertical = [
            (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
            (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $80a537add0d1475a$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $80a537add0d1475a$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $00857c4adc5c4048$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $25e22eb95c43d6c5$export$f28d906d67a997f3(min, value, max) {
    return (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(min, (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(value, max));
}
function $25e22eb95c43d6c5$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $25e22eb95c43d6c5$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $59e0fe2f023eedbd$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2dab833bacc18f84$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $00857c4adc5c4048$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $2835d14c37255796$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(tether ? (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
            (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $25e22eb95c43d6c5$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $59e0fe2f023eedbd$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $59e0fe2f023eedbd$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $2aacc20cad9175ed$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $50b8f91f4d6175a0$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0985dc62839206c0$export$2e2bcd8739ae039)(padding, (0, $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3)));
};
function $2aacc20cad9175ed$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $2dab833bacc18f84$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4),
        (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $2aacc20cad9175ed$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $2aacc20cad9175ed$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4c605c525ca0edeb$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $2aacc20cad9175ed$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $2aacc20cad9175ed$var$arrow,
    effect: $2aacc20cad9175ed$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $5ac86404024ba63f$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $5ac86404024ba63f$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
        (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2),
        (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb),
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $5ac86404024ba63f$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $5ac86404024ba63f$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $5ac86404024ba63f$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $5ac86404024ba63f$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $5ac86404024ba63f$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $5ac86404024ba63f$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $5ac86404024ba63f$var$hide
};




var $160facd9e41a3641$export$d34966752335dd47 = [
    (0, $034398a97685f722$export$2e2bcd8739ae039),
    (0, $817cdc30d090b763$export$2e2bcd8739ae039),
    (0, $3f5d8947cd4685ee$export$2e2bcd8739ae039),
    (0, $a26367323d29f85c$export$2e2bcd8739ae039),
    (0, $f39a2db16c583784$export$2e2bcd8739ae039),
    (0, $80a537add0d1475a$export$2e2bcd8739ae039),
    (0, $59e0fe2f023eedbd$export$2e2bcd8739ae039),
    (0, $2aacc20cad9175ed$export$2e2bcd8739ae039),
    (0, $5ac86404024ba63f$export$2e2bcd8739ae039)
];
var $160facd9e41a3641$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $f7095fb200459102$export$ed5e13716264f202)({
    defaultModifiers: $160facd9e41a3641$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $6q4c0 = parcelRequire("6q4c0");



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $10a5c916b73615d7$export$1b69b6cd0fa638a1(slot) {
    return (0, $9uBH9.default)('MuiPopper', slot);
}
const $10a5c916b73615d7$var$popperClasses = (0, $6N1Oq.default)('MuiPopper', [
    'root'
]);
var $10a5c916b73615d7$export$2e2bcd8739ae039 = $10a5c916b73615d7$var$popperClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
function $5236551450d48d32$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5236551450d48d32$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5236551450d48d32$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5236551450d48d32$var$isVirtualElement(element) {
    return !$5236551450d48d32$var$isHTMLElement(element);
}
const $5236551450d48d32$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $10a5c916b73615d7$export$1b69b6cd0fa638a1), classes);
};
const $5236551450d48d32$var$defaultPopperOptions = {};
const $5236551450d48d32$var$PopperTooltip = /*#__PURE__*/ $3QbnI.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $3QbnI.useRef(null);
    const ownRef = (0, $379786810d55b52d$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $3QbnI.useRef(null);
    const handlePopperRef = (0, $379786810d55b52d$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $3QbnI.useRef(handlePopperRef);
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $3QbnI.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5236551450d48d32$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $3QbnI.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $3QbnI.useState($5236551450d48d32$var$resolveAnchorEl(anchorEl));
    $3QbnI.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $3QbnI.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5236551450d48d32$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $160facd9e41a3641$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5236551450d48d32$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $9a3742669d0259c9$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $e1vzu.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $5236551450d48d32$var$Popper = /*#__PURE__*/ $3QbnI.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5236551450d48d32$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $3QbnI.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5236551450d48d32$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5236551450d48d32$var$isHTMLElement(resolvedAnchorEl) ? (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $364fe2bc6e6def98$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $42d10c775b10147e$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)($5236551450d48d32$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $5236551450d48d32$export$2e2bcd8739ae039 = $5236551450d48d32$var$Popper;



var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $f758e2c428377d89$var$PopperRoot = (0, $2TGnx.default)((0, $5236551450d48d32$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $f758e2c428377d89$var$Popper = /*#__PURE__*/ $3QbnI.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $d5e4f702f718a3e5$export$b2dd014b6c321cb)();
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)($f758e2c428377d89$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $f758e2c428377d89$export$2e2bcd8739ae039 = $f758e2c428377d89$var$Popper;



var $3QbnI = parcelRequire("3QbnI");
const $41509f6a27074b22$var$MoovyCardMenu = ({ open: open, setOpen: setOpen, anchorRef: anchorRef, menuItems: menuItems })=>{
    const handleClose = (event, onMenuItemClick)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
        if (onMenuItemClick) {
            event.preventDefault();
            event.stopPropagation();
            onMenuItemClick();
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') setOpen(false);
    };
    const prevOpen = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useRef(open);
    (0, $3QbnI.useEffect)(()=>{
        if (prevOpen.current === true && open === false) anchorRef.current.focus();
        prevOpen.current = open;
    }, [
        open
    ]);
    const isMenu = menuItems && menuItems.length > 0;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f758e2c428377d89$export$2e2bcd8739ae039), {
        open: open,
        anchorEl: anchorRef.current,
        role: undefined,
        placement: "bottom-start",
        transition: true,
        disablePortal: true,
        style: {
            zIndex: 1
        },
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $d0716261e6e32602$export$2e2bcd8739ae039), {
                ...TransitionProps,
                style: {
                    transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ef888684c47e6b36$export$2e2bcd8739ae039), {
                    children: isMenu && /*#__PURE__*/ (0, $e1vzu.jsx)((0, $6b20c813365ab96f$export$58385c17fee43f89), {
                        onClickAway: handleClose,
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf6e0ea2c52aa623$export$2e2bcd8739ae039), {
                            autoFocusItem: open,
                            id: "composition-menu",
                            "aria-labelledby": "composition-button",
                            onKeyDown: handleListKeyDown,
                            children: menuItems.map((item, index)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $a617846d6b4c8545$export$2e2bcd8739ae039), {
                                    onClick: (event)=>handleClose(event, item.onClick),
                                    children: item.itemText
                                }, index))
                        })
                    })
                })
            })
    });
};
var $41509f6a27074b22$export$2e2bcd8739ae039 = $41509f6a27074b22$var$MoovyCardMenu;



var $852df2e16f47a650$exports = {};
"use strict";
"use client";

var $852df2e16f47a650$require$_interopRequireDefault = $55ceebaba6abf8a9$exports.default;
Object.defineProperty($852df2e16f47a650$exports, "__esModule", {
    value: true
});
$852df2e16f47a650$exports.default = void 0;

var $852df2e16f47a650$var$_createSvgIcon = $852df2e16f47a650$require$_interopRequireDefault((parcelRequire("8Cb4O")));

var $e1vzu = parcelRequire("e1vzu");
var $852df2e16f47a650$var$_default = $852df2e16f47a650$exports.default = (0, $852df2e16f47a650$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");
parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $d211cbb2d72b18cd$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $6092a4b2d6ad9962$export$ffd560f22c0ecf04(slot) {
    return (0, $9uBH9.default)('MuiAvatar', slot);
}
const $6092a4b2d6ad9962$var$avatarClasses = (0, $6N1Oq.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $6092a4b2d6ad9962$export$2e2bcd8739ae039 = $6092a4b2d6ad9962$var$avatarClasses;




var $e1vzu = parcelRequire("e1vzu");
'use client';
const $eb261bcdafe039ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $6092a4b2d6ad9962$export$ffd560f22c0ecf04), classes);
};
const $eb261bcdafe039ea$var$AvatarRoot = (0, $2TGnx.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: {
                    color: (theme.vars || theme).palette.background.default,
                    ...theme.vars ? {
                        backgroundColor: theme.vars.palette.Avatar.defaultBg
                    } : {
                        backgroundColor: theme.palette.grey[400],
                        ...theme.applyStyles('dark', {
                            backgroundColor: theme.palette.grey[600]
                        })
                    }
                }
            }
        ]
    })));
const $eb261bcdafe039ea$var$AvatarImg = (0, $2TGnx.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $eb261bcdafe039ea$var$AvatarFallback = (0, $2TGnx.default)((0, $d211cbb2d72b18cd$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $eb261bcdafe039ea$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $3QbnI.useState(false);
    $3QbnI.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $eb261bcdafe039ea$var$Avatar = /*#__PURE__*/ $3QbnI.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular', ...other } = props;
    let children = null;
    const ownerState = {
        ...props,
        component: component,
        variant: variant
    };
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $eb261bcdafe039ea$var$useLoaded({
        ...imgProps,
        ...typeof slotProps.img === 'function' ? slotProps.img(ownerState) : slotProps.img,
        src: src,
        srcSet: srcSet
    });
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    ownerState.colorDefault = !hasImgNotFailing;
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $eb261bcdafe039ea$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $eb261bcdafe039ea$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: {
                    ...imgProps,
                    ...slotProps.img
                }
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $e1vzu.jsx)(ImgSlot, {
        ...imgSlotProps
    });
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $e1vzu.jsx)($eb261bcdafe039ea$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $e1vzu.jsx)($eb261bcdafe039ea$var$AvatarRoot, {
        as: component,
        className: (0, $eTLbi.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children
    });
});
var $eb261bcdafe039ea$export$2e2bcd8739ae039 = $eb261bcdafe039ea$var$Avatar;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $c6bc3366df0ae324$export$f3b76d2cce458caa(slot) {
    return (0, $9uBH9.default)('MuiCard', slot);
}
const $c6bc3366df0ae324$var$cardClasses = (0, $6N1Oq.default)('MuiCard', [
    'root'
]);
var $c6bc3366df0ae324$export$2e2bcd8739ae039 = $c6bc3366df0ae324$var$cardClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $7ec9bf661e192db7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $c6bc3366df0ae324$export$f3b76d2cce458caa), classes);
};
const $7ec9bf661e192db7$var$CardRoot = (0, $2TGnx.default)((0, $ef888684c47e6b36$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: 'hidden'
});
const $7ec9bf661e192db7$var$Card = /*#__PURE__*/ $3QbnI.forwardRef(function Card(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $7ec9bf661e192db7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($7ec9bf661e192db7$var$CardRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $7ec9bf661e192db7$export$2e2bcd8739ae039 = $7ec9bf661e192db7$var$Card;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $4a5a0e88fbab2825$export$2a5c27c211442e3c(slot) {
    return (0, $9uBH9.default)('MuiCardActions', slot);
}
const $4a5a0e88fbab2825$var$cardActionsClasses = (0, $6N1Oq.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $4a5a0e88fbab2825$export$2e2bcd8739ae039 = $4a5a0e88fbab2825$var$cardActionsClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $fbfd9bad3edf9693$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $4a5a0e88fbab2825$export$2a5c27c211442e3c), classes);
};
const $fbfd9bad3edf9693$var$CardActionsRoot = (0, $2TGnx.default)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    variants: [
        {
            props: {
                disableSpacing: false
            },
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $fbfd9bad3edf9693$var$CardActions = /*#__PURE__*/ $3QbnI.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $fbfd9bad3edf9693$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($fbfd9bad3edf9693$var$CardActionsRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $fbfd9bad3edf9693$export$2e2bcd8739ae039 = $fbfd9bad3edf9693$var$CardActions;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $ca7a5d9a8fa887f0$export$964336739a8c7119(slot) {
    return (0, $9uBH9.default)('MuiCardContent', slot);
}
const $ca7a5d9a8fa887f0$var$cardContentClasses = (0, $6N1Oq.default)('MuiCardContent', [
    'root'
]);
var $ca7a5d9a8fa887f0$export$2e2bcd8739ae039 = $ca7a5d9a8fa887f0$var$cardContentClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $7344f96cc945ca6d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $ca7a5d9a8fa887f0$export$964336739a8c7119), classes);
};
const $7344f96cc945ca6d$var$CardContentRoot = (0, $2TGnx.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $7344f96cc945ca6d$var$CardContent = /*#__PURE__*/ $3QbnI.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $7344f96cc945ca6d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($7344f96cc945ca6d$var$CardContentRoot, {
        as: component,
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $7344f96cc945ca6d$export$2e2bcd8739ae039 = $7344f96cc945ca6d$var$CardContent;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");


var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $7a491fda310f4f86$export$f54c8b0d04b67946(slot) {
    return (0, $9uBH9.default)('MuiCardHeader', slot);
}
const $7a491fda310f4f86$var$cardHeaderClasses = (0, $6N1Oq.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $7a491fda310f4f86$export$2e2bcd8739ae039 = $7a491fda310f4f86$var$cardHeaderClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $0e900d4558c7429a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $7a491fda310f4f86$export$f54c8b0d04b67946), classes);
};
const $0e900d4558c7429a$var$CardHeaderRoot = (0, $2TGnx.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $7a491fda310f4f86$export$2e2bcd8739ae039).title}`]: styles.title
            },
            {
                [`& .${(0, $7a491fda310f4f86$export$2e2bcd8739ae039).subheader}`]: styles.subheader
            },
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $0e900d4558c7429a$var$CardHeaderAvatar = (0, $2TGnx.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $0e900d4558c7429a$var$CardHeaderAction = (0, $2TGnx.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $0e900d4558c7429a$var$CardHeaderContent = (0, $2TGnx.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    flex: '1 1 auto',
    [`.${(0, $d5a6d5915630c5f7$export$2e2bcd8739ae039).root}:where(& .${(0, $7a491fda310f4f86$export$2e2bcd8739ae039).title})`]: {
        display: 'block'
    },
    [`.${(0, $d5a6d5915630c5f7$export$2e2bcd8739ae039).root}:where(& .${(0, $7a491fda310f4f86$export$2e2bcd8739ae039).subheader})`]: {
        display: 'block'
    }
});
const $0e900d4558c7429a$var$CardHeader = /*#__PURE__*/ $3QbnI.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, className: className, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableTypography: disableTypography
    };
    const classes = $0e900d4558c7429a$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $311a456630f5f039$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
        variant: avatar ? 'body2' : 'h5',
        className: classes.title,
        component: "span",
        ...titleTypographyProps,
        children: title
    });
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $311a456630f5f039$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
        variant: avatar ? 'body2' : 'body1',
        className: classes.subheader,
        color: "textSecondary",
        component: "span",
        ...subheaderTypographyProps,
        children: subheader
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($0e900d4558c7429a$var$CardHeaderRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: [
            avatar && /*#__PURE__*/ (0, $e1vzu.jsx)($0e900d4558c7429a$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $e1vzu.jsxs)($0e900d4558c7429a$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $e1vzu.jsx)($0e900d4558c7429a$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    });
});
var $0e900d4558c7429a$export$2e2bcd8739ae039 = $0e900d4558c7429a$var$CardHeader;



var $3QbnI = parcelRequire("3QbnI");

var $eTLbi = parcelRequire("eTLbi");





var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $faUR4 = parcelRequire("faUR4");



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $5dcd66d3ea8d5187$export$5162da8f798e0959(slot) {
    return (0, $9uBH9.default)('MuiCollapse', slot);
}
const $5dcd66d3ea8d5187$var$collapseClasses = (0, $6N1Oq.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $5dcd66d3ea8d5187$export$2e2bcd8739ae039 = $5dcd66d3ea8d5187$var$collapseClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $37c185e70b4d3f43$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $5dcd66d3ea8d5187$export$5162da8f798e0959), classes);
};
const $37c185e70b4d3f43$var$CollapseRoot = (0, $2TGnx.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $37c185e70b4d3f43$var$CollapseWrapper = (0, $2TGnx.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $37c185e70b4d3f43$var$CollapseWrapperInner = (0, $2TGnx.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $37c185e70b4d3f43$var$Collapse = /*#__PURE__*/ $3QbnI.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $faUR4.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $310f30916c86eca9$export$2e2bcd8739ae039), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $37c185e70b4d3f43$var$useUtilityClasses(ownerState);
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const timer = (0, $37c3f9b73e33b963$export$2e2bcd8739ae039)();
    const wrapperRef = $3QbnI.useRef(null);
    const autoTransitionDuration = $3QbnI.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $3QbnI.useRef(null);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, childProps)=>/*#__PURE__*/ (0, $e1vzu.jsx)($37c185e70b4d3f43$var$CollapseRoot, {
                as: component,
                className: (0, $eTLbi.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ...childProps,
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: {
                    ...ownerState,
                    state: state
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)($37c185e70b4d3f43$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)($37c185e70b4d3f43$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($37c185e70b4d3f43$var$Collapse) $37c185e70b4d3f43$var$Collapse.muiSupportAuto = true;
var $37c185e70b4d3f43$export$2e2bcd8739ae039 = $37c185e70b4d3f43$var$Collapse;



var $5V7zi = parcelRequire("5V7zi");

var $2TGnx = parcelRequire("2TGnx");
function $ee9cb80b5c23ac97$export$16bf6fe03653420f(value, message = 'Reached unexpected case in exhaustive switch') {
    throw new Error(message);
}
const $ee9cb80b5c23ac97$export$8f98ff223296ded9 = (obj)=>{
    return obj && Object.keys(obj).some((key)=>obj[key] !== undefined);
};
const $ee9cb80b5c23ac97$export$7e4aa119212bc614 = (value)=>{
    return typeof value === 'number' && !isNaN(value);
};
const $ee9cb80b5c23ac97$export$cf6c09818bd7035a = (value)=>{
    return $ee9cb80b5c23ac97$export$7e4aa119212bc614(value) && isFinite(value);
};
const $ee9cb80b5c23ac97$export$6d1c4f83343cbd5d = (avatarName)=>{
    const trimmed = avatarName.trim();
    if (!trimmed) return '';
    const nameParts = trimmed.split(/[\s-]/);
    const firstInitial = nameParts[0]?.[0] || '';
    const secondInitial = nameParts[1]?.[0] || nameParts[0]?.[1] || '';
    return (firstInitial + secondInitial).toUpperCase();
};



var $e1vzu = parcelRequire("e1vzu");



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $aDUe6 = parcelRequire("aDUe6");


var $6q4c0 = parcelRequire("6q4c0");


var $iCj5F = parcelRequire("iCj5F");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $fdf186235c6365f1$export$d6efab9620b78fec(slot) {
    return (0, $9uBH9.default)('MuiLink', slot);
}
const $fdf186235c6365f1$var$linkClasses = (0, $6N1Oq.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $fdf186235c6365f1$export$2e2bcd8739ae039 = $fdf186235c6365f1$var$linkClasses;



var $aM01b = parcelRequire("aM01b");

var $aDUe6 = parcelRequire("aDUe6");
const $4bee252dda760898$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    const color = (0, $aM01b.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $aM01b.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $aDUe6.alpha)(color, 0.4);
};
var $4bee252dda760898$export$2e2bcd8739ae039 = $4bee252dda760898$var$getTextDecoration;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $365a8a584a6d2124$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $365a8a584a6d2124$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $iCj5F.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $fdf186235c6365f1$export$d6efab9620b78fec), classes);
};
const $365a8a584a6d2124$var$LinkRoot = (0, $2TGnx.default)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $iCj5F.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.4)` : (0, $aDUe6.alpha)(theme.palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $aDUe6.alpha)(theme.palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.secondaryChannel} / 0.4)` : (0, $aDUe6.alpha)(theme.palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $fdf186235c6365f1$export$2e2bcd8739ae039).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $365a8a584a6d2124$var$Link = /*#__PURE__*/ $3QbnI.forwardRef(function Link(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $3QbnI.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $e226b59a5013eedd$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $e226b59a5013eedd$export$2e2bcd8739ae039)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $365a8a584a6d2124$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($365a8a584a6d2124$var$LinkRoot, {
        color: color,
        className: (0, $eTLbi.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$365a8a584a6d2124$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$365a8a584a6d2124$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $4bee252dda760898$export$2e2bcd8739ae039)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $365a8a584a6d2124$export$2e2bcd8739ae039 = $365a8a584a6d2124$var$Link;



var $2TGnx = parcelRequire("2TGnx");
const $7c79f74a177f653a$var$StyledLinkButton = (0, $2TGnx.default)((0, $eefbd326883d0eeb$export$2e2bcd8739ae039))({
    textTransform: 'none',
    padding: 0,
    minWidth: 0,
    '&:hover': {
        backgroundColor: 'transparent'
    }
});
const $7c79f74a177f653a$var$SingleRightPointingAngleQuotationMark = ()=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: "\u203A"
    });
const $7c79f74a177f653a$var$SingleLeftPointingAngleQuotationMark = ()=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: "\u2039"
    });
const $7c79f74a177f653a$var$MoovyLink = ({ style: style, 'aria-label': ariaLabel, bold: bold, children: children, href: href, target: target = '_blank', onClick: onClick, showArrowForward: showArrowForward, showArrowBackward: showArrowBackward })=>{
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $365a8a584a6d2124$export$2e2bcd8739ae039), {
        href: href,
        onClick: onClick,
        target: target,
        fontWeight: bold ? 'bold' : 'normal',
        underline: "none",
        style: style,
        "aria-label": ariaLabel,
        children: [
            showArrowBackward && /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)($7c79f74a177f653a$var$SingleLeftPointingAngleQuotationMark, {}),
                    ' '
                ]
            }),
            children,
            showArrowForward && /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
                children: [
                    ' ',
                    /*#__PURE__*/ (0, $e1vzu.jsx)($7c79f74a177f653a$var$SingleRightPointingAngleQuotationMark, {})
                ]
            })
        ]
    });
};
const $7c79f74a177f653a$var$MoovyLinkButton = ({ style: style, 'aria-label': ariaLabel, loading: loading, red: red, disabled: disabled, bold: bold, onClick: onClick, children: children, href: href })=>{
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)($7c79f74a177f653a$var$StyledLinkButton, {
                "aria-label": ariaLabel,
                style: style,
                onClick: (event)=>{
                    if (onClick) {
                        if (disabled || loading) event.preventDefault();
                        else onClick(event);
                    }
                },
                color: red ? 'error' : undefined,
                href: href,
                children: bold && /*#__PURE__*/ (0, $e1vzu.jsx)("b", {
                    children: children
                }) || children
            }),
            loading && /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fccdfec3f47c0093$export$2e2bcd8739ae039), {
                size: "mini"
            })
        ]
    });
};
var $7c79f74a177f653a$export$2e2bcd8739ae039 = {
    Link: $7c79f74a177f653a$var$MoovyLink,
    LinkButton: $7c79f74a177f653a$var$MoovyLinkButton
};


const $048939e8d048fac8$var$ExpandMore = (0, $2TGnx.default)((props)=>{
    const { expand: expand, ...other } = props;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
        ...other
    });
})(({ theme: theme, expand: expand })=>({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        })
    }));
const $048939e8d048fac8$var$MoovyCard = (props)=>{
    const [expanded, setExpanded] = (0, $3QbnI.useState)(false);
    const [open, setOpen] = (0, $3QbnI.useState)(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useRef(null);
    const handleToggle = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setOpen((prevOpen)=>!prevOpen);
    };
    const prevOpen = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useRef(open);
    (0, $3QbnI.useEffect)(()=>{
        if (prevOpen.current === true && open === false) anchorRef.current.focus();
        prevOpen.current = open;
    }, [
        open
    ]);
    const handleExpandClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setExpanded(!expanded);
    };
    const expandList = props.cardExpandContentList;
    const avatarName = props.avatarName || (typeof props.cardTitle === 'string' ? props.cardTitle : '');
    const shortAvatarName = (0, $ee9cb80b5c23ac97$export$6d1c4f83343cbd5d)(avatarName);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $7ec9bf661e192db7$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 200
        },
        onClick: (event)=>props.onCardClicked && props.onCardClicked(event),
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $0e900d4558c7429a$export$2e2bcd8739ae039), {
                avatar: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $eb261bcdafe039ea$export$2e2bcd8739ae039), {
                    sx: {
                        bgcolor: (0, $5V7zi.default)[500]
                    },
                    "aria-label": avatarName,
                    children: shortAvatarName
                }),
                action: props.cardMenuActions ? /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
                    "aria-label": "settings",
                    ref: anchorRef,
                    "aria-controls": open ? 'composition-menu' : undefined,
                    "aria-expanded": open ? 'true' : undefined,
                    "aria-haspopup": "true",
                    onClick: handleToggle,
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($852df2e16f47a650$exports))), {})
                }) : undefined,
                title: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039).LinkButton, {
                    style: {
                        textAlign: 'left'
                    },
                    children: props.cardTitle
                }),
                subheader: props.cardSecondaryTitle
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7344f96cc945ca6d$export$2e2bcd8739ae039), {
                style: {
                    paddingBottom: props.cardContentList.length > 0 || expandList ? 12 : 0,
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                    style: {
                        paddingBottom: 0,
                        paddingTop: 0
                    },
                    children: props.cardContentList.map((item, index)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                            secondary: item,
                            style: {
                                wordBreak: 'break-all'
                            }
                        }, index))
                })
            }),
            expandList && /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fbfd9bad3edf9693$export$2e2bcd8739ae039), {
                        disableSpacing: true,
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)($048939e8d048fac8$var$ExpandMore, {
                            expand: expanded,
                            onClick: handleExpandClick,
                            "aria-expanded": expanded,
                            "aria-label": "show more",
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($25d5499ea2336b35$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $37c185e70b4d3f43$export$2e2bcd8739ae039), {
                        in: expanded,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7344f96cc945ca6d$export$2e2bcd8739ae039), {
                            style: {
                                paddingBottom: 0,
                                paddingTop: 0
                            },
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                                children: expandList.map((item, index)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                                        secondary: item,
                                        style: {
                                            wordBreak: 'break-all'
                                        }
                                    }, index))
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $41509f6a27074b22$export$2e2bcd8739ae039), {
                open: open,
                setOpen: setOpen,
                anchorRef: anchorRef,
                menuItems: props.cardMenuActions
            })
        ]
    }, props.key);
};
var $048939e8d048fac8$export$2e2bcd8739ae039 = $048939e8d048fac8$var$MoovyCard;



var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");


var $iCj5F = parcelRequire("iCj5F");




var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $632d2994d80a4521$export$2177af0aa15c34c2(slot) {
    return (0, $9uBH9.default)('MuiDialog', slot);
}
const $632d2994d80a4521$var$dialogClasses = (0, $6N1Oq.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $632d2994d80a4521$export$2e2bcd8739ae039 = $632d2994d80a4521$var$dialogClasses;



var $3QbnI = parcelRequire("3QbnI");
const $e5d5d89600f808da$var$DialogContext = /*#__PURE__*/ $3QbnI.createContext({});
var $e5d5d89600f808da$export$2e2bcd8739ae039 = $e5d5d89600f808da$var$DialogContext;




var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $af6d338c6c0b385f$var$DialogBackdrop = (0, $2TGnx.default)((0, $612130d157852fe1$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $af6d338c6c0b385f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $iCj5F.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $iCj5F.default)(scroll)}`,
            `paperWidth${(0, $iCj5F.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $632d2994d80a4521$export$2177af0aa15c34c2), classes);
};
const $af6d338c6c0b385f$var$DialogRoot = (0, $2TGnx.default)((0, $a331e411240678bd$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $af6d338c6c0b385f$var$DialogContainer = (0, $2TGnx.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $iCj5F.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $af6d338c6c0b385f$var$DialogPaper = (0, $2TGnx.default)((0, $ef888684c47e6b36$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $iCj5F.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $iCj5F.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $632d2994d80a4521$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $632d2994d80a4521$export$2e2bcd8739ae039).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $632d2994d80a4521$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $af6d338c6c0b385f$var$Dialog = /*#__PURE__*/ $3QbnI.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $ef888684c47e6b36$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $48f59d453896b6cd$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $af6d338c6c0b385f$var$useUtilityClasses(ownerState);
    const backdropClick = $3QbnI.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $259168cd063bb08e$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $3QbnI.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($af6d338c6c0b385f$var$DialogRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $af6d338c6c0b385f$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...BackdropProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)(TransitionComponent, {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation",
            ...TransitionProps,
            children: /*#__PURE__*/ (0, $e1vzu.jsx)($af6d338c6c0b385f$var$DialogContainer, {
                className: (0, $eTLbi.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $e1vzu.jsx)($af6d338c6c0b385f$var$DialogPaper, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...PaperProps,
                    className: (0, $eTLbi.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e5d5d89600f808da$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $af6d338c6c0b385f$export$2e2bcd8739ae039 = $af6d338c6c0b385f$var$Dialog;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $68236a08d7a6c032$export$5e57a444791c63be(slot) {
    return (0, $9uBH9.default)('MuiDialogActions', slot);
}
const $68236a08d7a6c032$var$dialogActionsClasses = (0, $6N1Oq.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $68236a08d7a6c032$export$2e2bcd8739ae039 = $68236a08d7a6c032$var$dialogActionsClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $7f49c2570bf95eb0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $68236a08d7a6c032$export$5e57a444791c63be), classes);
};
const $7f49c2570bf95eb0$var$DialogActionsRoot = (0, $2TGnx.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $7f49c2570bf95eb0$var$DialogActions = /*#__PURE__*/ $3QbnI.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $7f49c2570bf95eb0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($7f49c2570bf95eb0$var$DialogActionsRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $7f49c2570bf95eb0$export$2e2bcd8739ae039 = $7f49c2570bf95eb0$var$DialogActions;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $01313512aa0332ab$export$61b0ee1f05fb344e(slot) {
    return (0, $9uBH9.default)('MuiDialogContent', slot);
}
const $01313512aa0332ab$var$dialogContentClasses = (0, $6N1Oq.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $01313512aa0332ab$export$2e2bcd8739ae039 = $01313512aa0332ab$var$dialogContentClasses;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $fe761c5f51293a79$export$f5d2ec7e4c47e088(slot) {
    return (0, $9uBH9.default)('MuiDialogTitle', slot);
}
const $fe761c5f51293a79$var$dialogTitleClasses = (0, $6N1Oq.default)('MuiDialogTitle', [
    'root'
]);
var $fe761c5f51293a79$export$2e2bcd8739ae039 = $fe761c5f51293a79$var$dialogTitleClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $2add2b85eb79af1a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $01313512aa0332ab$export$61b0ee1f05fb344e), classes);
};
const $2add2b85eb79af1a$var$DialogContentRoot = (0, $2TGnx.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $fe761c5f51293a79$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $2add2b85eb79af1a$var$DialogContent = /*#__PURE__*/ $3QbnI.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $2add2b85eb79af1a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($2add2b85eb79af1a$var$DialogContentRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $2add2b85eb79af1a$export$2e2bcd8739ae039 = $2add2b85eb79af1a$var$DialogContent;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");


var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $37a20f5307851084$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $fe761c5f51293a79$export$f5d2ec7e4c47e088), classes);
};
const $37a20f5307851084$var$DialogTitleRoot = (0, $2TGnx.default)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $37a20f5307851084$var$DialogTitle = /*#__PURE__*/ $3QbnI.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $37a20f5307851084$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $3QbnI.useContext((0, $e5d5d89600f808da$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $e1vzu.jsx)($37a20f5307851084$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $37a20f5307851084$export$2e2bcd8739ae039 = $37a20f5307851084$var$DialogTitle;


var $3QbnI = parcelRequire("3QbnI");



'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $95897aa2643a2194$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $3QbnI.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $8a62ee10fb4c50e9$export$2e2bcd8739ae039)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $95897aa2643a2194$var$safeReact = {
    ...$3QbnI
};
const $95897aa2643a2194$var$maybeReactUseSyncExternalStore = $95897aa2643a2194$var$safeReact.useSyncExternalStore;
function $95897aa2643a2194$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $3QbnI.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $3QbnI.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $3QbnI.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $95897aa2643a2194$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $95897aa2643a2194$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $5b234c3a126f1137$export$2e2bcd8739ae039)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $d3ecc5ee5bf2e81f$export$2e2bcd8739ae039)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        const useMediaQueryImplementation = $95897aa2643a2194$var$maybeReactUseSyncExternalStore !== undefined ? $95897aa2643a2194$var$useMediaQueryNew : $95897aa2643a2194$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $95897aa2643a2194$var$useMediaQuery = $95897aa2643a2194$export$96d7927a982220b5();
var $95897aa2643a2194$export$2e2bcd8739ae039 = $95897aa2643a2194$var$useMediaQuery;



var $9t00Y = parcelRequire("9t00Y");
const $658e8a054972a949$var$useMediaQuery = (0, $95897aa2643a2194$export$96d7927a982220b5)({
    themeId: (0, $9t00Y.default)
});
var $658e8a054972a949$export$2e2bcd8739ae039 = $658e8a054972a949$var$useMediaQuery;



var $f384c639fc15d1ff$exports = {};
"use strict";
"use client";

var $f384c639fc15d1ff$require$_interopRequireDefault = $55ceebaba6abf8a9$exports.default;
Object.defineProperty($f384c639fc15d1ff$exports, "__esModule", {
    value: true
});
$f384c639fc15d1ff$exports.default = void 0;

var $f384c639fc15d1ff$var$_createSvgIcon = $f384c639fc15d1ff$require$_interopRequireDefault((parcelRequire("8Cb4O")));

var $e1vzu = parcelRequire("e1vzu");
var $f384c639fc15d1ff$var$_default = $f384c639fc15d1ff$exports.default = (0, $f384c639fc15d1ff$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
}), 'CloseRounded');



(function(MoovyPalette) {
    MoovyPalette.primaryMain = '#0098d8';
    MoovyPalette.secondaryMain = '#555555';
    MoovyPalette.errorMain = '#ff4848';
    MoovyPalette.warningMain = '#E0732C';
    MoovyPalette.infoMain = MoovyPalette.primaryMain;
    MoovyPalette.successMain = '#0BCD61';
    MoovyPalette.commonBlue = '#555';
    MoovyPalette.commonBlack = '#555';
    MoovyPalette.commonWhite = 'white';
    MoovyPalette.commonRed = '#ff4848';
    MoovyPalette.colorMainBackground = '#FAFAFA';
    MoovyPalette.colorTableHeader = '#efefef';
    MoovyPalette.colorMenuUnderline = MoovyPalette.commonWhite;
    MoovyPalette.progressBlockContentColor = 'white';
    MoovyPalette.colorMenuBackgroundGradient = 'linear-gradient(135deg, #08cbef 0%, #0098d8 99.43%);';
})($53be88aa100c8649$export$f86ab2f69f02b2d9 || ($53be88aa100c8649$export$f86ab2f69f02b2d9 = {}));
(function(MoovyStyle) {
    MoovyStyle.fontFamily = 'Fira Sans, sans-serif';
    MoovyStyle.htmlFontSize = 16;
    MoovyStyle.fontSizeMobile = 16;
    MoovyStyle.fontSizeDesktop = 18;
    MoovyStyle.menuFontSize = '17px';
    MoovyStyle.menuFontWeight = 500;
    MoovyStyle.buttonFontWeight = 700;
    MoovyStyle.tableHeadFontWeight = 700;
    MoovyStyle.elementSpacingMobile = 4;
    MoovyStyle.elementSpacingDesktop = 8;
    MoovyStyle.rowSpacing = {
        xs: MoovyStyle.elementSpacingMobile,
        sm: MoovyStyle.elementSpacingDesktop
    };
})($53be88aa100c8649$export$6039b89271c3de71 || ($53be88aa100c8649$export$6039b89271c3de71 = {}));
var $53be88aa100c8649$export$f86ab2f69f02b2d9, $53be88aa100c8649$export$6039b89271c3de71;


const $625d026951ac286d$var$MoovyDialog = (props)=>{
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const fullScreen = (0, $658e8a054972a949$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const { open: open, mutation: mutation, errorTitleKey: errorTitleKey, children: children, modalTitle: modalTitle, submitButtonContent: submitButtonContent, formReference: formReference, leftSideButtons: leftSideButtons, deleteButtonContent: deleteButtonContent, contentPadding: contentPadding, hideCancelButton: hideCancelButton, onCancel: onCancel, onSubmit: onSubmit, onDelete: onDelete, ...other } = props;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $af6d338c6c0b385f$export$2e2bcd8739ae039), {
            open: open,
            onSubmit: onSubmit,
            fullScreen: fullScreen,
            onClose: onCancel,
            sx: fullScreen ? undefined : {
                '& .MuiDialog-paper': {
                    // Minimum width of all Moovy dialogs is set here
                    minWidth: '350px'
                }
            },
            ...other,
            children: [
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $37a20f5307851084$export$2e2bcd8739ae039), {
                    sx: {
                        pr: 7
                    },
                    children: modalTitle
                }),
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    sx: {
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        color: (theme)=>theme.palette.grey[500]
                    },
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f384c639fc15d1ff$exports))), {})
                }),
                /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $2add2b85eb79af1a$export$2e2bcd8739ae039), {
                    dividers: true,
                    sx: {
                        padding: contentPadding,
                        position: 'relative'
                    },
                    children: [
                        mutation && /*#__PURE__*/ (0, $e1vzu.jsx)("div", {
                            style: {
                                marginBottom: mutation?.error ? '1rem' : undefined
                            },
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                                mutation: mutation,
                                errorTitleKey: errorTitleKey || 'common.actions.error'
                            })
                        }),
                        children,
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
                            sx: {
                                opacity: 0.5
                            },
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $612130d157852fe1$export$2e2bcd8739ae039), {
                                sx: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorMainBackground,
                                    zIndex: 1
                                },
                                open: mutation?.isPending || false,
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fccdfec3f47c0093$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7f49c2570bf95eb0$export$2e2bcd8739ae039), {
                    sx: {
                        padding: 2
                    },
                    children: /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: leftSideButtons || deleteButtonContent ? 'space-between' : 'right',
                            width: '100%'
                        },
                        children: [
                            [
                                ...leftSideButtons?.map((item)=>item) || [],
                                props.deleteButtonContent && /*#__PURE__*/ (0, $e1vzu.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                    color: 'error',
                                    onClick: props.onDelete,
                                    type: "submit",
                                    formAction: "delete",
                                    form: formReference,
                                    children: props.deleteButtonContent
                                }) || null
                            ],
                            /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    gap: 1
                                },
                                children: [
                                    !hideCancelButton && /*#__PURE__*/ (0, $e1vzu.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            onCancel();
                                        },
                                        variant: "text",
                                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                            id: "common.buttons.cancel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                        type: "submit",
                                        form: formReference,
                                        mutation: mutation,
                                        onClick: onSubmit,
                                        children: submitButtonContent
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $625d026951ac286d$export$2e2bcd8739ae039 = $625d026951ac286d$var$MoovyDialog;



var $e1vzu = parcelRequire("e1vzu");




const $03bdcb6e7b9b2179$var$MoovyDialogConfirmation = (props)=>{
    const { open: open, header: header, content: content, lang: lang, onCancel: onCancel, onConfirm: onConfirm } = props;
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const resetView = ()=>{
        props.mutation?.reset();
    };
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $af6d338c6c0b385f$export$2e2bcd8739ae039), {
        open: open,
        onClose: ()=>{
            resetView();
            onCancel();
        },
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $37a20f5307851084$export$2e2bcd8739ae039), {
                sx: {
                    pr: 7
                },
                children: header
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
                onClick: props.onCancel,
                sx: {
                    position: 'absolute',
                    right: 10,
                    top: 10,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f384c639fc15d1ff$exports))), {})
            }),
            /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $2add2b85eb79af1a$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                        mutation: props.mutation,
                        errorTitleKey: lang.error
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)("div", {
                        style: {
                            padding: '5px'
                        },
                        children: content
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $7f49c2570bf95eb0$export$2e2bcd8739ae039), {
                sx: {
                    padding: 2
                },
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            resetView();
                            onCancel();
                        },
                        variant: "text",
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                            id: "common.buttons.cancel"
                        })
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                        disabled: props.mutation?.isPending || props.disableSubmit,
                        mutation: props.mutation,
                        onClick: ()=>{
                            onConfirm();
                        },
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                            id: lang.confirmButton
                        })
                    })
                ]
            })
        ]
    });
};
var $03bdcb6e7b9b2179$export$2e2bcd8739ae039 = $03bdcb6e7b9b2179$var$MoovyDialogConfirmation;



var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");



var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
'use client';
const $aad3a51b3c4b40fc$var$usePreviousProps = (value)=>{
    const ref = $3QbnI.useRef({});
    $3QbnI.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $aad3a51b3c4b40fc$export$2e2bcd8739ae039 = $aad3a51b3c4b40fc$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $63d6f3470f1dd372$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $63d6f3470f1dd372$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $63d6f3470f1dd372$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $63d6f3470f1dd372$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $63d6f3470f1dd372$var$defaultFilterOptions = $63d6f3470f1dd372$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $63d6f3470f1dd372$var$pageSize = 5;
const $63d6f3470f1dd372$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $63d6f3470f1dd372$var$MULTIPLE_DEFAULT_VALUE = [];
function $63d6f3470f1dd372$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $63d6f3470f1dd372$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $63d6f3470f1dd372$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $63d6f3470f1dd372$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $259168cd063bb08e$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $3QbnI.useRef(false);
    const firstFocus = $3QbnI.useRef(true);
    const inputRef = $3QbnI.useRef(null);
    const listboxRef = $3QbnI.useRef(null);
    const [anchorEl, setAnchorEl] = $3QbnI.useState(null);
    const [focusedTag, setFocusedTag] = $3QbnI.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $3QbnI.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $b5a691d7d09c9d6d$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $b5a691d7d09c9d6d$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $3QbnI.useState(false);
    const resetInputValue = $3QbnI.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $b5a691d7d09c9d6d$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $3QbnI.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $aad3a51b3c4b40fc$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $3QbnI.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $3QbnI.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $3QbnI.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $0509c5f692f68ee8$export$2e2bcd8739ae039)((node)=>{
        (0, $b9c84d8c7ebb3ea8$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $3QbnI.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $3QbnI.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$63d6f3470f1dd372$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $63d6f3470f1dd372$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null,
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleTagDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $63d6f3470f1dd372$export$2e2bcd8739ae039 = $63d6f3470f1dd372$var$useAutocomplete;




var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $iCj5F = parcelRequire("iCj5F");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $103a642330345529$export$6816d4fc0981ec7(slot) {
    return (0, $9uBH9.default)('MuiListSubheader', slot);
}
const $103a642330345529$var$listSubheaderClasses = (0, $6N1Oq.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $103a642330345529$export$2e2bcd8739ae039 = $103a642330345529$var$listSubheaderClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $498ab56a438ec3e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $iCj5F.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $103a642330345529$export$6816d4fc0981ec7), classes);
};
const $498ab56a438ec3e7$var$ListSubheaderRoot = (0, $2TGnx.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $iCj5F.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $498ab56a438ec3e7$var$ListSubheader = /*#__PURE__*/ $3QbnI.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $498ab56a438ec3e7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($498ab56a438ec3e7$var$ListSubheaderRoot, {
        as: component,
        className: (0, $eTLbi.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($498ab56a438ec3e7$var$ListSubheader) $498ab56a438ec3e7$var$ListSubheader.muiSkipListHighlight = true;
var $498ab56a438ec3e7$export$2e2bcd8739ae039 = $498ab56a438ec3e7$var$ListSubheader;





var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");
parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $bca55d20a2bbcbc4$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $iCj5F = parcelRequire("iCj5F");


var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $0f5a22c6938574ba$export$31444911e4ee6fdd(slot) {
    return (0, $9uBH9.default)('MuiChip', slot);
}
const $0f5a22c6938574ba$var$chipClasses = (0, $6N1Oq.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $0f5a22c6938574ba$export$2e2bcd8739ae039 = $0f5a22c6938574ba$var$chipClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $7eddcf63d3e4685f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $iCj5F.default)(size)}`,
            `color${(0, $iCj5F.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $iCj5F.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $iCj5F.default)(color)}`,
            `${variant}${(0, $iCj5F.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $iCj5F.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $iCj5F.default)(size)}`,
            `avatarColor${(0, $iCj5F.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $iCj5F.default)(size)}`,
            `iconColor${(0, $iCj5F.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $iCj5F.default)(size)}`,
            `deleteIconColor${(0, $iCj5F.default)(color)}`,
            `deleteIcon${(0, $iCj5F.default)(variant)}Color${(0, $iCj5F.default)(color)}`
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $0f5a22c6938574ba$export$31444911e4ee6fdd), classes);
};
const $7eddcf63d3e4685f$var$ChipRoot = (0, $2TGnx.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $iCj5F.default)(size)}`]
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $iCj5F.default)(color)}`]
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $iCj5F.default)(size)}`]
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $iCj5F.default)(iconColor)}`]
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $iCj5F.default)(size)}`]
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $iCj5F.default)(color)}`]
            },
            {
                [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $iCj5F.default)(variant)}Color${(0, $iCj5F.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $iCj5F.default)(size)}`],
            styles[`color${(0, $iCj5F.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $iCj5F.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $iCj5F.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $iCj5F.default)(color)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $aDUe6.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $aDUe6.alpha)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, $aDUe6.alpha)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aDUe6.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aDUe6.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aDUe6.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $aDUe6.alpha)(theme.palette[color].main, 0.7)}`,
                        [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $aDUe6.alpha)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${(0, $0f5a22c6938574ba$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $aDUe6.alpha)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $7eddcf63d3e4685f$var$ChipLabel = (0, $2TGnx.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $iCj5F.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $7eddcf63d3e4685f$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $7eddcf63d3e4685f$var$Chip = /*#__PURE__*/ $3QbnI.forwardRef(function Chip(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    ...other } = props;
    const chipRef = $3QbnI.useRef(null);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $7eddcf63d3e4685f$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $7eddcf63d3e4685f$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $0c5993b2b6821c5b$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $3QbnI.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $7eddcf63d3e4685f$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $0c5993b2b6821c5b$export$2e2bcd8739ae039) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $3QbnI.isValidElement(deleteIconProp) ? /*#__PURE__*/ $3QbnI.cloneElement(deleteIconProp, {
        className: (0, $eTLbi.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bca55d20a2bbcbc4$export$2e2bcd8739ae039), {
        className: (0, $eTLbi.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $3QbnI.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $3QbnI.cloneElement(avatarProp, {
        className: (0, $eTLbi.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $3QbnI.isValidElement(iconProp)) icon = /*#__PURE__*/ $3QbnI.cloneElement(iconProp, {
        className: (0, $eTLbi.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($7eddcf63d3e4685f$var$ChipRoot, {
        as: component,
        className: (0, $eTLbi.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState,
        ...moreProps,
        ...other,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $e1vzu.jsx)($7eddcf63d3e4685f$var$ChipLabel, {
                className: (0, $eTLbi.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $7eddcf63d3e4685f$export$2e2bcd8739ae039 = $7eddcf63d3e4685f$var$Chip;






parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $4d445f9c17e454df$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');




var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $f416f31a33d78eb7$export$8ee01529667e66d9(slot) {
    return (0, $9uBH9.default)('MuiAutocomplete', slot);
}
const $f416f31a33d78eb7$var$autocompleteClasses = (0, $6N1Oq.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $f416f31a33d78eb7$export$2e2bcd8739ae039 = $f416f31a33d78eb7$var$autocompleteClasses;



var $iCj5F = parcelRequire("iCj5F");


var $e1vzu = parcelRequire("e1vzu");
'use client';
var $d9265ded7fdc0b26$var$_ClearIcon, $d9265ded7fdc0b26$var$_ArrowDropDownIcon;
const $d9265ded7fdc0b26$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $iCj5F.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $f416f31a33d78eb7$export$8ee01529667e66d9), classes);
};
const $d9265ded7fdc0b26$var$AutocompleteRoot = (0, $2TGnx.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $iCj5F.default)(size)}`]
            },
            {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).focused} .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).root}.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $a36827ee2c43a1e3$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $24943499ffaa9911$export$2e2bcd8739ae039).root}.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $88f969dc01a84852$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $88f969dc01a84852$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $88f969dc01a84852$export$2e2bcd8739ae039).root}.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $88f969dc01a84852$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $37dec2a412c69962$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $88f969dc01a84852$export$2e2bcd8739ae039).root}.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $88f969dc01a84852$export$2e2bcd8739ae039).root}.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).hiddenLabel}.${(0, $37dec2a412c69962$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $d9265ded7fdc0b26$var$AutocompleteEndAdornment = (0, $2TGnx.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $d9265ded7fdc0b26$var$AutocompleteClearIndicator = (0, $2TGnx.default)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $d9265ded7fdc0b26$var$AutocompletePopupIndicator = (0, $2TGnx.default)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $d9265ded7fdc0b26$var$AutocompletePopper = (0, $2TGnx.default)((0, $f758e2c428377d89$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $d9265ded7fdc0b26$var$AutocompletePaper = (0, $2TGnx.default)((0, $ef888684c47e6b36$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})((0, $gvYl6.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $d9265ded7fdc0b26$var$AutocompleteLoading = (0, $2TGnx.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})((0, $gvYl6.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $d9265ded7fdc0b26$var$AutocompleteNoOptions = (0, $2TGnx.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})((0, $gvYl6.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $d9265ded7fdc0b26$var$AutocompleteListbox = (0, $2TGnx.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})((0, $gvYl6.default)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aDUe6.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aDUe6.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aDUe6.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    })));
const $d9265ded7fdc0b26$var$AutocompleteGroupLabel = (0, $2TGnx.default)((0, $498ab56a438ec3e7$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})((0, $gvYl6.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $d9265ded7fdc0b26$var$AutocompleteGroupUl = (0, $2TGnx.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $f416f31a33d78eb7$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $d9265ded7fdc0b26$var$Autocomplete = /*#__PURE__*/ $3QbnI.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $d9265ded7fdc0b26$var$_ClearIcon || ($d9265ded7fdc0b26$var$_ClearIcon = /*#__PURE__*/ (0, $e1vzu.jsx)((0, $4d445f9c17e454df$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $d9265ded7fdc0b26$var$_ArrowDropDownIcon || ($d9265ded7fdc0b26$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $e1vzu.jsx)((0, $360af3e43b4c3b84$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $63d6f3470f1dd372$export$2e2bcd8739ae039)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $d9265ded7fdc0b26$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('listbox', {
        elementType: $d9265ded7fdc0b26$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('paper', {
        elementType: (0, $ef888684c47e6b36$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('popper', {
        elementType: (0, $f758e2c428377d89$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>({
                className: classes.tag,
                disabled: disabled,
                ...getTagProps(params)
            });
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const { key: key, ...customTagProps } = getCustomizedTagProps({
                index: index
            });
            return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7eddcf63d3e4685f$export$2e2bcd8739ae039), {
                label: getOptionLabel(option),
                size: size,
                ...customTagProps,
                ...externalForwardedProps.slotProps.chip
            }, key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $e1vzu.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $e1vzu.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $e1vzu.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    const renderAutocompletePopperChildren = (children)=>/*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompletePopper, {
            as: PopperSlot,
            ...popperProps,
            children: /*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompletePaper, {
                as: PaperSlot,
                ...paperProps,
                children: children
            })
        });
    let autocompletePopper = null;
    if (groupedOptions.length > 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ // TODO v7: remove `as` prop and move ListboxComponentProp to externalForwardedProps or remove ListboxComponentProp entirely
    // https://github.com/mui/material-ui/pull/43994#issuecomment-2401945800
    (0, $e1vzu.jsx)(ListboxSlot, {
        as: ListboxComponentProp,
        ...listboxProps,
        children: groupedOptions.map((option, index)=>{
            if (groupBy) return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
            });
            return renderListOption(option, index);
        })
    }));
    else if (loading && groupedOptions.length === 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompleteLoading, {
        className: classes.loading,
        ownerState: ownerState,
        children: loadingText
    }));
    else if (groupedOptions.length === 0 && !freeSolo && !loading) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompleteNoOptions, {
        className: classes.noOptions,
        ownerState: ownerState,
        role: "presentation",
        onMouseDown: (event)=>{
            // Prevent input blur when interacting with the "no options" content
            event.preventDefault();
        },
        children: noOptionsText
    }));
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $eTLbi.default)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $e1vzu.jsxs)($d9265ded7fdc0b26$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $eTLbi.default)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $e1vzu.jsx)($d9265ded7fdc0b26$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $eTLbi.default)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? autocompletePopper : null
        ]
    });
});
var $d9265ded7fdc0b26$export$2e2bcd8739ae039 = $d9265ded7fdc0b26$var$Autocomplete;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");


var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");


var $iCj5F = parcelRequire("iCj5F");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $3b36adf9495c9977$export$717666c39ec07e12(slot) {
    return (0, $9uBH9.default)('MuiFormControlLabel', slot);
}
const $3b36adf9495c9977$var$formControlLabelClasses = (0, $6N1Oq.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $3b36adf9495c9977$export$2e2bcd8739ae039 = $3b36adf9495c9977$var$formControlLabelClasses;





var $e1vzu = parcelRequire("e1vzu");
'use client';
const $21383229114adc00$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $iCj5F.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $3b36adf9495c9977$export$717666c39ec07e12), classes);
};
const $21383229114adc00$export$1b479270917a5676 = (0, $2TGnx.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3b36adf9495c9977$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $iCj5F.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $3b36adf9495c9977$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $3b36adf9495c9977$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $3b36adf9495c9977$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $21383229114adc00$var$AsteriskComponent = (0, $2TGnx.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $gvYl6.default)(({ theme: theme })=>({
        [`&.${(0, $3b36adf9495c9977$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $21383229114adc00$var$FormControlLabel = /*#__PURE__*/ $3QbnI.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $df517ddb991185ed$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $21383229114adc00$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $311a456630f5f039$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $311a456630f5f039$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $e1vzu.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $eTLbi.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($21383229114adc00$export$1b479270917a5676, {
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $3QbnI.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $e1vzu.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $e1vzu.jsxs)($21383229114adc00$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $21383229114adc00$export$2e2bcd8739ae039 = $21383229114adc00$var$FormControlLabel;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");



var $iCj5F = parcelRequire("iCj5F");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $54f43334c0f4f48f$export$f7d501e40371cd17(slot) {
    return (0, $9uBH9.default)('MuiFormLabel', slot);
}
const $54f43334c0f4f48f$var$formLabelClasses = (0, $6N1Oq.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $54f43334c0f4f48f$export$2e2bcd8739ae039 = $54f43334c0f4f48f$var$formLabelClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $247a133eca226b8b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iCj5F.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $54f43334c0f4f48f$export$f7d501e40371cd17), classes);
};
const $247a133eca226b8b$export$aa5bc7f8a4705b27 = (0, $2TGnx.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $54f43334c0f4f48f$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $54f43334c0f4f48f$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $54f43334c0f4f48f$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $247a133eca226b8b$var$AsteriskComponent = (0, $2TGnx.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $gvYl6.default)(({ theme: theme })=>({
        [`&.${(0, $54f43334c0f4f48f$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $247a133eca226b8b$var$FormLabel = /*#__PURE__*/ $3QbnI.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    const fcs = (0, $df517ddb991185ed$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $247a133eca226b8b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($247a133eca226b8b$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $eTLbi.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $e1vzu.jsxs)($247a133eca226b8b$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $247a133eca226b8b$export$2e2bcd8739ae039 = $247a133eca226b8b$var$FormLabel;


var $3QbnI = parcelRequire("3QbnI");


var $6q4c0 = parcelRequire("6q4c0");

var $eTLbi = parcelRequire("eTLbi");




var $iCj5F = parcelRequire("iCj5F");

var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $2b10f037579f3e0c$export$c1c4b4545ad2ea5f(slot) {
    return (0, $9uBH9.default)('MuiInputLabel', slot);
}
const $2b10f037579f3e0c$var$inputLabelClasses = (0, $6N1Oq.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $2b10f037579f3e0c$export$2e2bcd8739ae039 = $2b10f037579f3e0c$var$inputLabelClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $b814543cccc0a34d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $iCj5F.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $2b10f037579f3e0c$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $b814543cccc0a34d$var$InputLabelRoot = (0, $2TGnx.default)((0, $247a133eca226b8b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $54f43334c0f4f48f$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $b814543cccc0a34d$var$InputLabel = /*#__PURE__*/ $3QbnI.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $df517ddb991185ed$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $b814543cccc0a34d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($b814543cccc0a34d$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $eTLbi.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $b814543cccc0a34d$export$2e2bcd8739ae039 = $b814543cccc0a34d$var$InputLabel;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");

var $iCj5F = parcelRequire("iCj5F");

var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");




var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $48c7684d2b744c26$export$baa0faa0c7ad8085(slot) {
    return (0, $9uBH9.default)('PrivateSwitchBase', slot);
}
const $48c7684d2b744c26$var$switchBaseClasses = (0, $6N1Oq.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $48c7684d2b744c26$export$2e2bcd8739ae039 = $48c7684d2b744c26$var$switchBaseClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $67f64900a90c1c09$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $iCj5F.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $48c7684d2b744c26$export$baa0faa0c7ad8085), classes);
};
const $67f64900a90c1c09$var$SwitchBaseRoot = (0, $2TGnx.default)((0, $0c5993b2b6821c5b$export$2e2bcd8739ae039))({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $67f64900a90c1c09$var$SwitchBaseInput = (0, $2TGnx.default)('input', {
    shouldForwardProp: (0, $ajKPH.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $67f64900a90c1c09$var$SwitchBase = /*#__PURE__*/ $3QbnI.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, ...other } = props;
    const [checked, setCheckedState] = (0, $29c9d441247d5905$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $67f64900a90c1c09$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($67f64900a90c1c09$var$SwitchBaseRoot, {
        component: "span",
        className: (0, $eTLbi.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)($67f64900a90c1c09$var$SwitchBaseInput, {
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type,
                ...type === 'checkbox' && value === undefined ? {} : {
                    value: value
                },
                ...inputProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $67f64900a90c1c09$export$2e2bcd8739ae039 = $67f64900a90c1c09$var$SwitchBase;


parcelRequire("3QbnI");

parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $4b271110feedde42$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $19ccef84094ffec4$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $aec216519250edcb$var$RadioButtonIconRoot = (0, $2TGnx.default)('span', {
    shouldForwardProp: (0, $ajKPH.default)
})({
    position: 'relative',
    display: 'flex'
});
const $aec216519250edcb$var$RadioButtonIconBackground = (0, $2TGnx.default)((0, $4b271110feedde42$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $aec216519250edcb$var$RadioButtonIconDot = (0, $2TGnx.default)((0, $19ccef84094ffec4$export$2e2bcd8739ae039))((0, $gvYl6.default)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $aec216519250edcb$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($aec216519250edcb$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)($aec216519250edcb$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)($aec216519250edcb$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $aec216519250edcb$export$2e2bcd8739ae039 = $aec216519250edcb$var$RadioButtonIcon;



var $iCj5F = parcelRequire("iCj5F");

var $20da468d40b7167e$export$2e2bcd8739ae039 = (0, $e02e87e7b16fff5e$export$2e2bcd8739ae039);




var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
/**
 * @ignore - internal component.
 */ const $313bbbe74a490b8d$var$RadioGroupContext = /*#__PURE__*/ $3QbnI.createContext(undefined);
var $313bbbe74a490b8d$export$2e2bcd8739ae039 = $313bbbe74a490b8d$var$RadioGroupContext;


'use client';
function $7e36f5ec4714736b$export$2e2bcd8739ae039() {
    return $3QbnI.useContext((0, $313bbbe74a490b8d$export$2e2bcd8739ae039));
}



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $25a524c43dbdd407$export$192f7b2363c77155(slot) {
    return (0, $9uBH9.default)('MuiRadio', slot);
}
const $25a524c43dbdd407$var$radioClasses = (0, $6N1Oq.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $25a524c43dbdd407$export$2e2bcd8739ae039 = $25a524c43dbdd407$var$radioClasses;



var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $77c195cd3d6ab4ed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iCj5F.default)(color)}`,
            size !== 'medium' && `size${(0, $iCj5F.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $6q4c0.default)(slots, (0, $25a524c43dbdd407$export$192f7b2363c77155), classes)
    };
};
const $77c195cd3d6ab4ed$var$RadioRoot = (0, $2TGnx.default)((0, $67f64900a90c1c09$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $iCj5F.default)(ownerState.size)}`],
            styles[`color${(0, $iCj5F.default)(ownerState.color)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $25a524c43dbdd407$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $25a524c43dbdd407$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $77c195cd3d6ab4ed$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $77c195cd3d6ab4ed$var$defaultCheckedIcon = /*#__PURE__*/ (0, $e1vzu.jsx)((0, $aec216519250edcb$export$2e2bcd8739ae039), {
    checked: true
});
const $77c195cd3d6ab4ed$var$defaultIcon = /*#__PURE__*/ (0, $e1vzu.jsx)((0, $aec216519250edcb$export$2e2bcd8739ae039), {});
const $77c195cd3d6ab4ed$var$Radio = /*#__PURE__*/ $3QbnI.forwardRef(function Radio(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $77c195cd3d6ab4ed$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $77c195cd3d6ab4ed$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, ...other } = props;
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $77c195cd3d6ab4ed$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $7e36f5ec4714736b$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $20da468d40b7167e$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $77c195cd3d6ab4ed$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $e1vzu.jsx)($77c195cd3d6ab4ed$var$RadioRoot, {
        type: "radio",
        icon: /*#__PURE__*/ $3QbnI.cloneElement(icon, {
            fontSize: $77c195cd3d6ab4ed$var$defaultIcon.props.fontSize ?? size
        }),
        checkedIcon: /*#__PURE__*/ $3QbnI.cloneElement(checkedIcon, {
            fontSize: $77c195cd3d6ab4ed$var$defaultCheckedIcon.props.fontSize ?? size
        }),
        disabled: disabled,
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $eTLbi.default)(classes.root, className),
        ...other
    });
});
var $77c195cd3d6ab4ed$export$2e2bcd8739ae039 = $77c195cd3d6ab4ed$var$Radio;


var $2TGnx = parcelRequire("2TGnx");
var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");


var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $iCj5F = parcelRequire("iCj5F");



var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $7cff95e3805e2063$export$39f6debbec19b3ba(slot) {
    return (0, $9uBH9.default)('MuiSwitch', slot);
}
const $7cff95e3805e2063$var$switchClasses = (0, $6N1Oq.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $7cff95e3805e2063$export$2e2bcd8739ae039 = $7cff95e3805e2063$var$switchClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $95059175bf29d720$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $iCj5F.default)(edge)}`,
            `size${(0, $iCj5F.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $iCj5F.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $7cff95e3805e2063$export$39f6debbec19b3ba), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $95059175bf29d720$var$SwitchRoot = (0, $2TGnx.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $iCj5F.default)(ownerState.edge)}`],
            styles[`size${(0, $iCj5F.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $95059175bf29d720$var$SwitchSwitchBase = (0, $2TGnx.default)((0, $67f64900a90c1c09$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $iCj5F.default)(ownerState.color)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).checked} + .${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).disabled} + .${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $gvYl6.default)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aDUe6.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $aDUe6.lighten)(theme.palette[color].main, 0.62) : (0, $aDUe6.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).checked} + .${(0, $7cff95e3805e2063$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $95059175bf29d720$var$SwitchTrack = (0, $2TGnx.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $gvYl6.default)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $95059175bf29d720$var$SwitchThumb = (0, $2TGnx.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})((0, $gvYl6.default)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $95059175bf29d720$var$Switch = /*#__PURE__*/ $3QbnI.forwardRef(function Switch(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $95059175bf29d720$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $e1vzu.jsx)($95059175bf29d720$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($95059175bf29d720$var$SwitchRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)($95059175bf29d720$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                }
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)($95059175bf29d720$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $95059175bf29d720$export$2e2bcd8739ae039 = $95059175bf29d720$var$Switch;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");



var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");






var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");



var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $iCj5F = parcelRequire("iCj5F");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $f129e906f559b48d$export$a394fa61b1d583a9(slot) {
    return (0, $9uBH9.default)('MuiFormHelperText', slot);
}
const $f129e906f559b48d$var$formHelperTextClasses = (0, $6N1Oq.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $f129e906f559b48d$export$2e2bcd8739ae039 = $f129e906f559b48d$var$formHelperTextClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
var $a652a3061dc69153$var$_span;
const $a652a3061dc69153$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $iCj5F.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $f129e906f559b48d$export$a394fa61b1d583a9), classes);
};
const $a652a3061dc69153$var$FormHelperTextRoot = (0, $2TGnx.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $iCj5F.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $f129e906f559b48d$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $f129e906f559b48d$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $a652a3061dc69153$var$FormHelperText = /*#__PURE__*/ $3QbnI.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $1682aada1f3268bb$export$2e2bcd8739ae039)();
    const fcs = (0, $df517ddb991185ed$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $a652a3061dc69153$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($a652a3061dc69153$var$FormHelperTextRoot, {
        as: component,
        className: (0, $eTLbi.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $a652a3061dc69153$var$_span || ($a652a3061dc69153$var$_span = /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $a652a3061dc69153$export$2e2bcd8739ae039 = $a652a3061dc69153$var$FormHelperText;




var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $8b57eef4f55a8d3b$export$c1bdcbaf0596aeda(slot) {
    return (0, $9uBH9.default)('MuiTextField', slot);
}
const $8b57eef4f55a8d3b$var$textFieldClasses = (0, $6N1Oq.default)('MuiTextField', [
    'root'
]);
var $8b57eef4f55a8d3b$export$2e2bcd8739ae039 = $8b57eef4f55a8d3b$var$textFieldClasses;




var $e1vzu = parcelRequire("e1vzu");
'use client';
const $59688cf1d5b98722$var$variantComponent = {
    standard: (0, $b38e6a43f59357b4$export$2e2bcd8739ae039),
    filled: (0, $be355bed872f1a54$export$2e2bcd8739ae039),
    outlined: (0, $3711d02228584efe$export$2e2bcd8739ae039)
};
const $59688cf1d5b98722$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $8b57eef4f55a8d3b$export$c1bdcbaf0596aeda), classes);
};
const $59688cf1d5b98722$var$TextFieldRoot = (0, $2TGnx.default)((0, $3b5eaf40d4a4ccf9$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $59688cf1d5b98722$var$TextField = /*#__PURE__*/ $3QbnI.forwardRef(function TextField(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $59688cf1d5b98722$var$useUtilityClasses(ownerState);
    const id = (0, $259168cd063bb08e$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $59688cf1d5b98722$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [InputSlot, inputProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $b814543cccc0a34d$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $a652a3061dc69153$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('select', {
        elementType: (0, $e2e7f451596e3c31$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $e1vzu.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($59688cf1d5b98722$var$TextFieldRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState,
        ...other,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $e1vzu.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $e1vzu.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $e1vzu.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $59688cf1d5b98722$export$2e2bcd8739ae039 = $59688cf1d5b98722$var$TextField;


var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");



var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");




var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");

var $iCj5F = parcelRequire("iCj5F");








var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $a94978a8418d2a68$export$837848f5f6cee923(slot) {
    return (0, $9uBH9.default)('MuiTooltip', slot);
}
const $a94978a8418d2a68$var$tooltipClasses = (0, $6N1Oq.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $a94978a8418d2a68$export$2e2bcd8739ae039 = $a94978a8418d2a68$var$tooltipClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
function $485baf1c29ab983f$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $485baf1c29ab983f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $iCj5F.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $a94978a8418d2a68$export$837848f5f6cee923), classes);
};
const $485baf1c29ab983f$var$TooltipPopper = (0, $2TGnx.default)((0, $f758e2c428377d89$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $485baf1c29ab983f$var$TooltipTooltip = (0, $2TGnx.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $iCj5F.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $aDUe6.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$485baf1c29ab983f$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $a94978a8418d2a68$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $485baf1c29ab983f$var$TooltipArrow = (0, $2TGnx.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})((0, $gvYl6.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $aDUe6.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $485baf1c29ab983f$var$hystersisOpen = false;
const $485baf1c29ab983f$var$hystersisTimer = new (0, $37c3f9b73e33b963$export$786b4da70f00938b)();
let $485baf1c29ab983f$var$cursorPosition = {
    x: 0,
    y: 0
};
function $485baf1c29ab983f$export$b9ee5a7ace0541f8() {
    $485baf1c29ab983f$var$hystersisOpen = false;
    $485baf1c29ab983f$var$hystersisTimer.clear();
}
function $485baf1c29ab983f$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $485baf1c29ab983f$var$Tooltip = /*#__PURE__*/ $3QbnI.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $3QbnI.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $e1vzu.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const isRtl = (0, $d5e4f702f718a3e5$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $3QbnI.useState();
    const [arrowRef, setArrowRef] = $3QbnI.useState(null);
    const ignoreNonTouchEvents = $3QbnI.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $37c3f9b73e33b963$export$2e2bcd8739ae039)();
    const enterTimer = (0, $37c3f9b73e33b963$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $37c3f9b73e33b963$export$2e2bcd8739ae039)();
    const touchTimer = (0, $37c3f9b73e33b963$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $29c9d441247d5905$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $563f2fd432336b71$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $3QbnI.useRef();
    const stopTouchInteraction = (0, $19d3d0bd329f2e26$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $3QbnI.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $485baf1c29ab983f$var$hystersisTimer.clear();
        $485baf1c29ab983f$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $19d3d0bd329f2e26$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $485baf1c29ab983f$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $485baf1c29ab983f$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $485baf1c29ab983f$var$hystersisOpen && enterNextDelay) enterTimer.start($485baf1c29ab983f$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $3QbnI.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $e226b59a5013eedd$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $e226b59a5013eedd$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $3QbnI.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)((0, $bca562fe1e155add$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $3QbnI.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $485baf1c29ab983f$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $eTLbi.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $485baf1c29ab983f$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $485baf1c29ab983f$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $485baf1c29ab983f$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $485baf1c29ab983f$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $3QbnI.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $485baf1c29ab983f$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('popper', {
        elementType: $485baf1c29ab983f$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $eTLbi.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $d0716261e6e32602$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('tooltip', {
        elementType: $485baf1c29ab983f$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('arrow', {
        elementType: $485baf1c29ab983f$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($3QbnI.Fragment, {
        children: [
            /*#__PURE__*/ $3QbnI.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $e1vzu.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $f758e2c428377d89$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $485baf1c29ab983f$var$cursorPosition.y,
                            left: $485baf1c29ab983f$var$cursorPosition.x,
                            right: $485baf1c29ab983f$var$cursorPosition.x,
                            bottom: $485baf1c29ab983f$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $e1vzu.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $e1vzu.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $e1vzu.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $485baf1c29ab983f$export$2e2bcd8739ae039 = $485baf1c29ab983f$var$Tooltip;



var $3QbnI = parcelRequire("3QbnI");
var $c301cdf1a7ab3ff0$exports = {};
"use strict";
"use client";

var $c301cdf1a7ab3ff0$require$_interopRequireDefault = $55ceebaba6abf8a9$exports.default;
Object.defineProperty($c301cdf1a7ab3ff0$exports, "__esModule", {
    value: true
});
$c301cdf1a7ab3ff0$exports.default = void 0;

var $c301cdf1a7ab3ff0$var$_createSvgIcon = $c301cdf1a7ab3ff0$require$_interopRequireDefault((parcelRequire("8Cb4O")));

var $e1vzu = parcelRequire("e1vzu");
var $c301cdf1a7ab3ff0$var$_default = $c301cdf1a7ab3ff0$exports.default = (0, $c301cdf1a7ab3ff0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1-8h-2V7h2z"
}), 'InfoRounded');


// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $11a8279e63afc787$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "3|4(?:2[09]|7[01])|6[1-9]",
                        "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[25-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $dea17e9ecaa879c8$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $11a8279e63afc787$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $c701811a9019e75c$var$objectConstructor = {}.constructor;
function $c701811a9019e75c$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $c701811a9019e75c$var$objectConstructor;
}


function $641f9afb5e20c2d5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $641f9afb5e20c2d5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $641f9afb5e20c2d5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $641f9afb5e20c2d5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $641f9afb5e20c2d5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $641f9afb5e20c2d5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $641f9afb5e20c2d5$var$_slicedToArray(arr, i) {
    return $641f9afb5e20c2d5$var$_arrayWithHoles(arr) || $641f9afb5e20c2d5$var$_iterableToArrayLimit(arr, i) || $641f9afb5e20c2d5$var$_unsupportedIterableToArray(arr, i) || $641f9afb5e20c2d5$var$_nonIterableRest();
}
function $641f9afb5e20c2d5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $641f9afb5e20c2d5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $641f9afb5e20c2d5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $641f9afb5e20c2d5$var$_arrayLikeToArray(o, minLen);
}
function $641f9afb5e20c2d5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $641f9afb5e20c2d5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $641f9afb5e20c2d5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $641f9afb5e20c2d5$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $641f9afb5e20c2d5$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $641f9afb5e20c2d5$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $c701811a9019e75c$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $1f6da0abd03007e2$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $1f6da0abd03007e2$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $1f6da0abd03007e2$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $1f6da0abd03007e2$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $1f6da0abd03007e2$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $1f6da0abd03007e2$var$SLASHES = "\uFF0F/";
var $1f6da0abd03007e2$var$DOTS = "\uFF0E.";
var $1f6da0abd03007e2$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $1f6da0abd03007e2$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $1f6da0abd03007e2$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $1f6da0abd03007e2$export$7f01587e28f9194 = "".concat($1f6da0abd03007e2$var$DASHES).concat($1f6da0abd03007e2$var$SLASHES).concat($1f6da0abd03007e2$var$DOTS).concat($1f6da0abd03007e2$export$20542845033f576e).concat($1f6da0abd03007e2$var$BRACKETS).concat($1f6da0abd03007e2$var$TILDES);
var $1f6da0abd03007e2$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $264d3f29a12458fe$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $264d3f29a12458fe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $264d3f29a12458fe$var$_typeof(obj);
}
function $264d3f29a12458fe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $264d3f29a12458fe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $264d3f29a12458fe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $264d3f29a12458fe$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $264d3f29a12458fe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $264d3f29a12458fe$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $264d3f29a12458fe$var$_setPrototypeOf(subClass, superClass);
}
function $264d3f29a12458fe$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $264d3f29a12458fe$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $264d3f29a12458fe$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $264d3f29a12458fe$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $264d3f29a12458fe$var$_possibleConstructorReturn(this, result);
    };
}
function $264d3f29a12458fe$var$_possibleConstructorReturn(self, call) {
    if (call && ($264d3f29a12458fe$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $264d3f29a12458fe$var$_assertThisInitialized(self);
}
function $264d3f29a12458fe$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $264d3f29a12458fe$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $264d3f29a12458fe$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$264d3f29a12458fe$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $264d3f29a12458fe$var$_construct(Class, arguments, $264d3f29a12458fe$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $264d3f29a12458fe$var$_setPrototypeOf(Wrapper, Class);
    };
    return $264d3f29a12458fe$var$_wrapNativeSuper(Class);
}
function $264d3f29a12458fe$var$_construct(Parent, args, Class) {
    if ($264d3f29a12458fe$var$_isNativeReflectConstruct()) $264d3f29a12458fe$var$_construct = Reflect.construct;
    else $264d3f29a12458fe$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $264d3f29a12458fe$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $264d3f29a12458fe$var$_construct.apply(null, arguments);
}
function $264d3f29a12458fe$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $264d3f29a12458fe$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $264d3f29a12458fe$var$_setPrototypeOf(o, p) {
    $264d3f29a12458fe$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $264d3f29a12458fe$var$_setPrototypeOf(o, p);
}
function $264d3f29a12458fe$var$_getPrototypeOf(o) {
    $264d3f29a12458fe$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $264d3f29a12458fe$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $264d3f29a12458fe$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $264d3f29a12458fe$var$_inherits(ParseError, _Error);
    var _super = $264d3f29a12458fe$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $264d3f29a12458fe$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($264d3f29a12458fe$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $264d3f29a12458fe$var$_createClass(ParseError);
}(/*#__PURE__*/ $264d3f29a12458fe$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $ed7a87917baecc0f$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $f913d58a5537f3b4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f913d58a5537f3b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f913d58a5537f3b4$var$_typeof(obj);
}
function $f913d58a5537f3b4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f913d58a5537f3b4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f913d58a5537f3b4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f913d58a5537f3b4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f913d58a5537f3b4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $f913d58a5537f3b4$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $f913d58a5537f3b4$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $f913d58a5537f3b4$var$V4 = '1.7.35';
var $f913d58a5537f3b4$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $f913d58a5537f3b4$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $f913d58a5537f3b4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $f913d58a5537f3b4$var$_classCallCheck(this, Metadata);
        $f913d58a5537f3b4$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $f913d58a5537f3b4$var$setVersion.call(this, metadata);
    }
    $f913d58a5537f3b4$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $f913d58a5537f3b4$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $f913d58a5537f3b4$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $f913d58a5537f3b4$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $f913d58a5537f3b4$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $f913d58a5537f3b4$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $f913d58a5537f3b4$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $f913d58a5537f3b4$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $f913d58a5537f3b4$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $f913d58a5537f3b4$var$getType(this.types(), _type2)) return new $f913d58a5537f3b4$var$Type($f913d58a5537f3b4$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $f913d58a5537f3b4$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $f913d58a5537f3b4$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $f913d58a5537f3b4$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $f913d58a5537f3b4$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $f913d58a5537f3b4$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$f913d58a5537f3b4$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $f913d58a5537f3b4$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $f913d58a5537f3b4$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $f913d58a5537f3b4$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $f913d58a5537f3b4$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $f913d58a5537f3b4$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $f913d58a5537f3b4$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $c701811a9019e75c$export$2e2bcd8739ae039)(metadata) || !(0, $c701811a9019e75c$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $c701811a9019e75c$export$2e2bcd8739ae039)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $f913d58a5537f3b4$var$typeOf(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $f913d58a5537f3b4$var$typeOf = function typeOf(_) {
    return $f913d58a5537f3b4$var$_typeof(_);
};
function $f913d58a5537f3b4$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $f913d58a5537f3b4$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $f913d58a5537f3b4$var$DEFAULT_EXT_PREFIX;
}
function $f913d58a5537f3b4$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $f913d58a5537f3b4$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $f913d58a5537f3b4$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $f913d58a5537f3b4$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $ed7a87917baecc0f$export$2e2bcd8739ae039)(version, $f913d58a5537f3b4$var$V3) === -1) this.v2 = true;
        else if ((0, $ed7a87917baecc0f$export$2e2bcd8739ae039)(version, $f913d58a5537f3b4$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $5df7de86976d4f1c$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $5df7de86976d4f1c$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $1f6da0abd03007e2$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $5df7de86976d4f1c$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $5df7de86976d4f1c$var$RFC3966_EXTN_PREFIX + $5df7de86976d4f1c$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $5df7de86976d4f1c$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $5df7de86976d4f1c$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $5df7de86976d4f1c$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $5df7de86976d4f1c$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $5df7de86976d4f1c$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $7acfe648d8749cff$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + ']{' + (0, $1f6da0abd03007e2$export$cd8355bcbe13154) + '}'; //
var $7acfe648d8749cff$export$a77dd7471651eee = '[' + (0, $1f6da0abd03007e2$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $1f6da0abd03007e2$export$7f01587e28f9194) + ']*' + '[' + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $1f6da0abd03007e2$export$7f01587e28f9194) + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $7acfe648d8749cff$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $1f6da0abd03007e2$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $1f6da0abd03007e2$export$7f01587e28f9194) + ']*' + '[' + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $7acfe648d8749cff$export$a2d12a04749c087d = $7acfe648d8749cff$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $5df7de86976d4f1c$export$2e2bcd8739ae039)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $7acfe648d8749cff$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $7acfe648d8749cff$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $7acfe648d8749cff$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $7acfe648d8749cff$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $1f6da0abd03007e2$export$cd8355bcbe13154) && $7acfe648d8749cff$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $7acfe648d8749cff$export$4c3f76c95c05197c(number) {
    return $7acfe648d8749cff$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $ef155a8ef828dbe0$var$EXTN_PATTERN = new RegExp('(?:' + (0, $5df7de86976d4f1c$export$2e2bcd8739ae039)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $ef155a8ef828dbe0$export$2e2bcd8739ae039(number) {
    var start = number.search($ef155a8ef828dbe0$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($ef155a8ef828dbe0$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $572248de93a65ad1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $572248de93a65ad1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $572248de93a65ad1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $572248de93a65ad1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $572248de93a65ad1$var$_arrayLikeToArray(o, minLen);
}
function $572248de93a65ad1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $572248de93a65ad1$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $572248de93a65ad1$export$1d16fddea1437169(character) {
    return $572248de93a65ad1$export$2848f3d68c08fe69[character];
}
function $572248de93a65ad1$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $572248de93a65ad1$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $572248de93a65ad1$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $4d290360587ee23d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4d290360587ee23d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4d290360587ee23d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4d290360587ee23d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4d290360587ee23d$var$_arrayLikeToArray(o, minLen);
}
function $4d290360587ee23d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4d290360587ee23d$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $4d290360587ee23d$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $4d290360587ee23d$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $4d290360587ee23d$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === 'function') emitEvent('end');
            return;
        }
        return '+';
    } // Allow digits.
    return (0, $572248de93a65ad1$export$1d16fddea1437169)(character);
}




function $d8d3d2e9e1fe61fb$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d8d3d2e9e1fe61fb$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d8d3d2e9e1fe61fb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d8d3d2e9e1fe61fb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d8d3d2e9e1fe61fb$var$_arrayLikeToArray(o, minLen);
}
function $d8d3d2e9e1fe61fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d8d3d2e9e1fe61fb$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $d8d3d2e9e1fe61fb$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $cd6cd25d92d39dbd$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $cd6cd25d92d39dbd$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $cd6cd25d92d39dbd$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $cd6cd25d92d39dbd$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $d8d3d2e9e1fe61fb$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $258c7defc40cccf2$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $258c7defc40cccf2$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $258c7defc40cccf2$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $cd6cd25d92d39dbd$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $6e9a7eceef69d686$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}




function $bcc9b750e03e6692$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $bcc9b750e03e6692$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bcc9b750e03e6692$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bcc9b750e03e6692$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bcc9b750e03e6692$var$_arrayLikeToArray(o, minLen);
}
function $bcc9b750e03e6692$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $bcc9b750e03e6692$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $bcc9b750e03e6692$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($bcc9b750e03e6692$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($bcc9b750e03e6692$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $bcc9b750e03e6692$var$_createForOfIteratorHelperLoose($bcc9b750e03e6692$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($bcc9b750e03e6692$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $bcc9b750e03e6692$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $3c865225cd21eb95$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $bcc9b750e03e6692$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $671a9607cb5df080$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $671a9607cb5df080$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $671a9607cb5df080$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $9d43fd003150baac$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $1f6da0abd03007e2$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $d207dd079e44f226$export$4f32ad1c51a7a6be = /(\$\d)/;
function $d207dd079e44f226$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($d207dd079e44f226$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $9d43fd003150baac$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $55ecf26f32a39979$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $55ecf26f32a39979$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($55ecf26f32a39979$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $32c9810aea0f2a24$var$_slicedToArray(arr, i) {
    return $32c9810aea0f2a24$var$_arrayWithHoles(arr) || $32c9810aea0f2a24$var$_iterableToArrayLimit(arr, i) || $32c9810aea0f2a24$var$_unsupportedIterableToArray(arr, i) || $32c9810aea0f2a24$var$_nonIterableRest();
}
function $32c9810aea0f2a24$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $32c9810aea0f2a24$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $32c9810aea0f2a24$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $32c9810aea0f2a24$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $32c9810aea0f2a24$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $32c9810aea0f2a24$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $32c9810aea0f2a24$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $32c9810aea0f2a24$var$_arrayLikeToArray(o, minLen);
}
function $32c9810aea0f2a24$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $32c9810aea0f2a24$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $32c9810aea0f2a24$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $32c9810aea0f2a24$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $7acfe648d8749cff$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $32c9810aea0f2a24$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}


function $cb64a509409234ae$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $cb64a509409234ae$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cb64a509409234ae$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cb64a509409234ae$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cb64a509409234ae$var$_arrayLikeToArray(o, minLen);
}
function $cb64a509409234ae$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cb64a509409234ae$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cb64a509409234ae$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cb64a509409234ae$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cb64a509409234ae$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cb64a509409234ae$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cb64a509409234ae$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cb64a509409234ae$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $cb64a509409234ae$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $cb64a509409234ae$var$_objectSpread($cb64a509409234ae$var$_objectSpread({}, $cb64a509409234ae$var$DEFAULT_OPTIONS), options);
    else options = $cb64a509409234ae$var$DEFAULT_OPTIONS;
    metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $cb64a509409234ae$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $cb64a509409234ae$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $cb64a509409234ae$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $cb64a509409234ae$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $32c9810aea0f2a24$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $cb64a509409234ae$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $cb64a509409234ae$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $cb64a509409234ae$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $cb64a509409234ae$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $d207dd079e44f226$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $cb64a509409234ae$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $cb64a509409234ae$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $cb64a509409234ae$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $cb64a509409234ae$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $f913d58a5537f3b4$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $cb64a509409234ae$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $55ecf26f32a39979$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($cb64a509409234ae$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}


function $8df4389ddd63a375$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8df4389ddd63a375$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8df4389ddd63a375$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8df4389ddd63a375$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8df4389ddd63a375$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8df4389ddd63a375$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8df4389ddd63a375$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8df4389ddd63a375$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8df4389ddd63a375$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8df4389ddd63a375$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8df4389ddd63a375$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $8df4389ddd63a375$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $8df4389ddd63a375$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $8df4389ddd63a375$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError('`country` or `countryCallingCode` not passed');
        if (!nationalNumber) throw new TypeError('`nationalNumber` not passed');
        if (!metadata) throw new TypeError('`metadata` not passed');
        var _getCountryAndCountry = $8df4389ddd63a375$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $8df4389ddd63a375$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $671a9607cb5df080$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $258c7defc40cccf2$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $3c865225cd21eb95$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $bcc9b750e03e6692$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $cb64a509409234ae$export$2e2bcd8739ae039)(this, _format, options ? $8df4389ddd63a375$var$_objectSpread($8df4389ddd63a375$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $8df4389ddd63a375$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $8df4389ddd63a375$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($8df4389ddd63a375$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($8df4389ddd63a375$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $1779e41cae43c4cd$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + '])');
function $1779e41cae43c4cd$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($1779e41cae43c4cd$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $3f1e73ad9db3b38a$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $de3add233090b7da$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $3f1e73ad9db3b38a$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$de3add233090b7da$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$de3add233090b7da$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $de3add233090b7da$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $de3add233090b7da$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $cd6cd25d92d39dbd$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $130fc108415d8cf0$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $f913d58a5537f3b4$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $de3add233090b7da$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $de3add233090b7da$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $cd6cd25d92d39dbd$export$2e2bcd8739ae039)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $0e3ac0c835119796$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $1779e41cae43c4cd$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $130fc108415d8cf0$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $1f6da0abd03007e2$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $afefb3ba473f43e0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $afefb3ba473f43e0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $afefb3ba473f43e0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $afefb3ba473f43e0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $afefb3ba473f43e0$var$_arrayLikeToArray(o, minLen);
}
function $afefb3ba473f43e0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $afefb3ba473f43e0$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $afefb3ba473f43e0$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $bcc9b750e03e6692$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $44714837438d4a73$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $44714837438d4a73$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($44714837438d4a73$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $afefb3ba473f43e0$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $d0525e05499aff0c$export$1ddc7eed78155f68 = '+';
var $d0525e05499aff0c$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $d0525e05499aff0c$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + ']' + '|' + $d0525e05499aff0c$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $d0525e05499aff0c$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $d0525e05499aff0c$export$1ddc7eed78155f68 + $d0525e05499aff0c$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + ']' + $d0525e05499aff0c$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $d0525e05499aff0c$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($d0525e05499aff0c$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $d0525e05499aff0c$var$ALPHANUM_ = (0, $1f6da0abd03007e2$export$852d1d4a47329634);
var $d0525e05499aff0c$var$RFC3966_DOMAINLABEL_ = '[' + $d0525e05499aff0c$var$ALPHANUM_ + ']+((\\-)*[' + $d0525e05499aff0c$var$ALPHANUM_ + '])*';
var $d0525e05499aff0c$var$VALID_ALPHA_ = 'a-zA-Z';
var $d0525e05499aff0c$var$RFC3966_TOPLABEL_ = '[' + $d0525e05499aff0c$var$VALID_ALPHA_ + ']+((\\-)*[' + $d0525e05499aff0c$var$ALPHANUM_ + '])*';
var $d0525e05499aff0c$var$RFC3966_DOMAINNAME_ = '^(' + $d0525e05499aff0c$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $d0525e05499aff0c$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $d0525e05499aff0c$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($d0525e05499aff0c$var$RFC3966_DOMAINNAME_, 'g');
var $d0525e05499aff0c$export$70d485ce3f6de783 = 'tel:';
var $d0525e05499aff0c$export$f6d5879d582c3a27 = ';phone-context=';
var $d0525e05499aff0c$export$9e356e12edb00a81 = ';isub=';
function $d0525e05499aff0c$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($d0525e05499aff0c$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $d0525e05499aff0c$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $d0525e05499aff0c$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $d0525e05499aff0c$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $d0525e05499aff0c$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $7832a67f2ee8e838$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $d0525e05499aff0c$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $d0525e05499aff0c$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $d0525e05499aff0c$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $d0525e05499aff0c$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $d0525e05499aff0c$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $d0525e05499aff0c$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $d0525e05499aff0c$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $bebe83e4a4176762$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $bebe83e4a4176762$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $1f6da0abd03007e2$export$207c99ccf3902df8) + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $bebe83e4a4176762$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $1f6da0abd03007e2$export$852d1d4a47329634) + '#' + ']+$');
var $bebe83e4a4176762$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $bebe83e4a4176762$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $f913d58a5537f3b4$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $bebe83e4a4176762$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $bebe83e4a4176762$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $1f6da0abd03007e2$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $1f6da0abd03007e2$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $8df4389ddd63a375$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $6e9a7eceef69d686$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $bebe83e4a4176762$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $258c7defc40cccf2$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $bebe83e4a4176762$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $bebe83e4a4176762$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $264d3f29a12458fe$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($bebe83e4a4176762$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($bebe83e4a4176762$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $bebe83e4a4176762$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $7832a67f2ee8e838$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $bebe83e4a4176762$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $7acfe648d8749cff$export$2e2bcd8739ae039)(number)) {
        if ((0, $7acfe648d8749cff$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $ef155a8ef828dbe0$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $bebe83e4a4176762$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $bebe83e4a4176762$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $0e3ac0c835119796$export$2e2bcd8739ae039)((0, $4d290360587ee23d$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($bebe83e4a4176762$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $f913d58a5537f3b4$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $de3add233090b7da$export$2e2bcd8739ae039)((0, $4d290360587ee23d$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $44714837438d4a73$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $6f726c2165d95f98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f726c2165d95f98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6f726c2165d95f98$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6f726c2165d95f98$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6f726c2165d95f98$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6f726c2165d95f98$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6f726c2165d95f98$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $bebe83e4a4176762$export$2e2bcd8739ae039)(text, $6f726c2165d95f98$var$_objectSpread($6f726c2165d95f98$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $0302c63a578f00e3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0302c63a578f00e3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0302c63a578f00e3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0302c63a578f00e3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0302c63a578f00e3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0302c63a578f00e3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0302c63a578f00e3$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $f913d58a5537f3b4$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $0302c63a578f00e3$var$_objectSpread($0302c63a578f00e3$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $6f726c2165d95f98$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $264d3f29a12458fe$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $71876cabd1362d8a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $71876cabd1362d8a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $71876cabd1362d8a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $71876cabd1362d8a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $71876cabd1362d8a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $71876cabd1362d8a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71876cabd1362d8a$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $641f9afb5e20c2d5$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $71876cabd1362d8a$var$_objectSpread($71876cabd1362d8a$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $0302c63a578f00e3$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}


function $e2fb645bbb5a2ef2$export$992e2df24bec72ba() {
    return (0, $dea17e9ecaa879c8$export$2e2bcd8739ae039)((0, $71876cabd1362d8a$export$2e2bcd8739ae039), arguments);
}


(function(MoovyFormRestrictions) {
    MoovyFormRestrictions.INPUT_MAX_CHARS = 255;
})($066f7ec5b64309d3$export$85ea93c7f196b8c3 || ($066f7ec5b64309d3$export$85ea93c7f196b8c3 = {}));
const $066f7ec5b64309d3$export$992e2df24bec72ba = (phoneNumber)=>{
    if (!phoneNumber) return false;
    return (0, $e2fb645bbb5a2ef2$export$992e2df24bec72ba)(phoneNumber);
};
const $066f7ec5b64309d3$export$dddb845077defee2 = (licensePlateNumber)=>{
    const pattern = /^[A-ZÅÄÖa-zåäö0-9\\s-]{2,10}$/;
    return !!licensePlateNumber && pattern.test(licensePlateNumber);
};
var $066f7ec5b64309d3$export$85ea93c7f196b8c3;


const $b8b9780b21c9795b$var$FormContainer = (props)=>{
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3b5eaf40d4a4ccf9$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            mb: 1,
            mt: 1,
            gap: 2,
            children: props.children
        })
    });
};
const $b8b9780b21c9795b$var$StyledTextField = (0, $2TGnx.default)((0, $59688cf1d5b98722$export$2e2bcd8739ae039))(({ error: error, theme: theme })=>({
        color: error ? theme.palette.error.main : 'inherit'
    }));
const $b8b9780b21c9795b$var$FormTextField = ({ errorText: errorText, ...textFieldProps })=>{
    let inputProps = undefined;
    if (textFieldProps?.inputProps) inputProps = textFieldProps.inputProps?.maxLength ? textFieldProps.inputProps : {
        ...textFieldProps.inputProps,
        maxLength: (0, $066f7ec5b64309d3$export$85ea93c7f196b8c3).INPUT_MAX_CHARS
    };
    else inputProps = {
        maxLength: (0, $066f7ec5b64309d3$export$85ea93c7f196b8c3).INPUT_MAX_CHARS
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)($b8b9780b21c9795b$var$StyledTextField, {
        ...textFieldProps,
        inputProps: inputProps,
        helperText: errorText ? errorText : '',
        sx: {
            flex: 1
        }
    });
};
const $b8b9780b21c9795b$var$FormAutoCompleteTextField = (props)=>{
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $d9265ded7fdc0b26$export$2e2bcd8739ae039), {
        ...props
    });
};
const $b8b9780b21c9795b$var$FormRadio = (props)=>{
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $21383229114adc00$export$2e2bcd8739ae039), {
        ...props,
        control: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $77c195cd3d6ab4ed$export$2e2bcd8739ae039), {})
    });
};
const $b8b9780b21c9795b$var$FormLabel = (props)=>{
    const [tooltipOpen, setTooltipOpen] = (0, $3QbnI.useState)(false);
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $247a133eca226b8b$export$2e2bcd8739ae039), {
        ...props,
        children: props.info ? /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $e1vzu.jsx)("div", {
                    children: props.children
                }),
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $485baf1c29ab983f$export$2e2bcd8739ae039), {
                    title: props.info,
                    open: tooltipOpen,
                    onClose: ()=>setTooltipOpen(false),
                    onClick: ()=>setTooltipOpen(true),
                    placement: "top",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
                        onMouseEnter: ()=>setTooltipOpen(true),
                        onMouseLeave: ()=>setTooltipOpen(false),
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c301cdf1a7ab3ff0$exports))), {})
                    })
                })
            ]
        }) : props.children
    });
};
const $b8b9780b21c9795b$var$FormSwitch = (props)=>{
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $21383229114adc00$export$2e2bcd8739ae039), {
        label: props.label,
        control: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $95059175bf29d720$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
const $b8b9780b21c9795b$var$FormBoxRow = (props)=>{
    const { children: children, gap: gap, flexDirection: flexDirection } = props;
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
        display: "flex",
        gap: gap ? gap : 2,
        flex: 1,
        flexDirection: flexDirection ? {
            xs: 'column',
            md: 'row'
        } : undefined,
        children: children
    });
};
const $b8b9780b21c9795b$var$FormSelect = (props)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $3b5eaf40d4a4ccf9$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $b814543cccc0a34d$export$2e2bcd8739ae039), {
                id: rest.labelId,
                children: rest.label
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e2e7f451596e3c31$export$2e2bcd8739ae039), {
                ...rest,
                children: children
            })
        ]
    });
};
const $b8b9780b21c9795b$var$FormTitle = (props)=>/*#__PURE__*/ (0, $e1vzu.jsx)($b8b9780b21c9795b$var$FormBoxRow, {
        children: /*#__PURE__*/ (0, $e1vzu.jsx)("h4", {
            style: {
                margin: 0
            },
            children: props.title
        })
    });
var $b8b9780b21c9795b$export$2e2bcd8739ae039 = {
    FormAutoCompleteTextField: $b8b9780b21c9795b$var$FormAutoCompleteTextField,
    FormTextField: $b8b9780b21c9795b$var$FormTextField,
    FormContainer: $b8b9780b21c9795b$var$FormContainer,
    FormRadio: $b8b9780b21c9795b$var$FormRadio,
    FormSwitch: $b8b9780b21c9795b$var$FormSwitch,
    FormLabel: $b8b9780b21c9795b$var$FormLabel,
    FormBoxRow: $b8b9780b21c9795b$var$FormBoxRow,
    FormSelect: $b8b9780b21c9795b$var$FormSelect,
    FormTitle: $b8b9780b21c9795b$var$FormTitle
};




var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $aDUe6 = parcelRequire("aDUe6");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");


var $iCj5F = parcelRequire("iCj5F");



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $29acb4c570761f89$export$69aecd24bc2cf7e3(slot) {
    return (0, $9uBH9.default)('MuiAlert', slot);
}
const $29acb4c570761f89$var$alertClasses = (0, $6N1Oq.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $29acb4c570761f89$export$2e2bcd8739ae039 = $29acb4c570761f89$var$alertClasses;



parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $6986833c0594e896$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $b2847195c7d86434$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $a9cfdf263fa6454e$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("3QbnI");

var $6gRMZ = parcelRequire("6gRMZ");

var $e1vzu = parcelRequire("e1vzu");
'use client';
var $9b3c4cdf7d75b0bb$export$2e2bcd8739ae039 = (0, $6gRMZ.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');




var $e1vzu = parcelRequire("e1vzu");
'use client';
const $da123deb82412e15$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iCj5F.default)(color || severity)}`,
            `${variant}${(0, $iCj5F.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $29acb4c570761f89$export$69aecd24bc2cf7e3), classes);
};
const $da123deb82412e15$var$AlertRoot = (0, $2TGnx.default)((0, $ef888684c47e6b36$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iCj5F.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $aDUe6.darken) : (0, $aDUe6.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $aDUe6.lighten) : (0, $aDUe6.darken);
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $29acb4c570761f89$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $29acb4c570761f89$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $da123deb82412e15$var$AlertIcon = (0, $2TGnx.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $da123deb82412e15$var$AlertMessage = (0, $2TGnx.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $da123deb82412e15$var$AlertAction = (0, $2TGnx.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $da123deb82412e15$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $6986833c0594e896$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $b2847195c7d86434$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a9cfdf263fa6454e$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $9b3c4cdf7d75b0bb$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $da123deb82412e15$var$Alert = /*#__PURE__*/ $3QbnI.forwardRef(function Alert(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $da123deb82412e15$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $da123deb82412e15$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $a987e9ba7ec70360$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $bb288bdf2a03294b$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $4d445f9c17e454df$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $e1vzu.jsxs)($da123deb82412e15$var$AlertRoot, {
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $eTLbi.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $e1vzu.jsx)($da123deb82412e15$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $da123deb82412e15$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $e1vzu.jsx)($da123deb82412e15$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $e1vzu.jsx)($da123deb82412e15$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $e1vzu.jsx)($da123deb82412e15$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $e1vzu.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $da123deb82412e15$export$2e2bcd8739ae039 = $da123deb82412e15$var$Alert;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $d4a736300a6cd583$export$5269a5bce2c2f987(slot) {
    return (0, $9uBH9.default)('MuiAlertTitle', slot);
}
const $d4a736300a6cd583$var$alertTitleClasses = (0, $6N1Oq.default)('MuiAlertTitle', [
    'root'
]);
var $d4a736300a6cd583$export$2e2bcd8739ae039 = $d4a736300a6cd583$var$alertTitleClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $9783166253fe9251$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $d4a736300a6cd583$export$5269a5bce2c2f987), classes);
};
const $9783166253fe9251$var$AlertTitleRoot = (0, $2TGnx.default)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
    name: 'MuiAlertTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $gvYl6.default)(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
}));
const $9783166253fe9251$var$AlertTitle = /*#__PURE__*/ $3QbnI.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $9783166253fe9251$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($9783166253fe9251$var$AlertTitleRoot, {
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $eTLbi.default)(classes.root, className),
        ...other
    });
});
var $9783166253fe9251$export$2e2bcd8739ae039 = $9783166253fe9251$var$AlertTitle;



var $3QbnI = parcelRequire("3QbnI");

const $09ef42aa6aba452d$var$getValidationErrors = (intl, validationErrors)=>{
    return validationErrors?.map((item)=>{
        return intl.formatMessage({
            id: `validation.code.${item.code}`,
            defaultMessage: intl.formatMessage({
                id: 'validation.code.generic'
            })
        }, {
            field: intl.formatMessage({
                id: `validation.field.${item.field}`,
                defaultMessage: item.field
            })
        });
    });
};
const $09ef42aa6aba452d$export$414e01788cec8720 = (intl, error)=>{
    if (error.response?.data?.validationErrors && error.response.data.validationErrors.length > 0) return $09ef42aa6aba452d$var$getValidationErrors(intl, error.response.data.validationErrors);
    return null;
};
const $09ef42aa6aba452d$export$b2aeb2d3d984ebee = (intl, error)=>{
    if (error.response?.data?.code) return intl.formatMessage({
        id: `api.error.code.${error.response?.data?.code}`,
        defaultMessage: intl.formatMessage({
            id: 'api.error.code.generic'
        })
    });
    return null;
};
const $09ef42aa6aba452d$var$MoovyMutationError = ({ mutation: mutation, query: query, errorTitleKey: errorTitleKey, errorBodyKey: errorBodyKey })=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    const MoovyAlert = ({ title: title, children: children })=>{
        const isChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).isValidElement(children);
        const RenderOnlyTitle = ()=>{
            return /*#__PURE__*/ (0, $e1vzu.jsx)("b", {
                children: title
            });
        };
        const RenderOnlyDescription = ()=>{
            return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
                children: children
            });
        };
        const RenderAll = ()=>{
            return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $9783166253fe9251$export$2e2bcd8739ae039), {
                        children: title
                    }),
                    children
                ]
            });
        };
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $da123deb82412e15$export$2e2bcd8739ae039), {
            severity: "error",
            children: title && isChildren ? /*#__PURE__*/ (0, $e1vzu.jsx)(RenderAll, {}) : title ? /*#__PURE__*/ (0, $e1vzu.jsx)(RenderOnlyTitle, {}) : /*#__PURE__*/ (0, $e1vzu.jsx)(RenderOnlyDescription, {})
        });
    };
    const localizedErrorText = ({ mutation: mutation, query: query, errorBodyKey: errorBodyKey, errorTitleKey: errorTitleKey })=>{
        if (!mutation?.isError && !query?.isError) return '';
        const error = mutation?.error || query?.error;
        const localizedValidationErrors = $09ef42aa6aba452d$export$414e01788cec8720(intl, error);
        const localizedError = $09ef42aa6aba452d$export$b2aeb2d3d984ebee(intl, error);
        const localizedTitle = errorTitleKey && intl.formatMessage({
            id: errorTitleKey
        });
        if (localizedValidationErrors) return /*#__PURE__*/ (0, $e1vzu.jsx)(MoovyAlert, {
            title: localizedTitle,
            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
                children: localizedValidationErrors.map((item, index)=>/*#__PURE__*/ (0, $e1vzu.jsx)("li", {
                        children: item
                    }, index))
            })
        });
        else if (localizedError) return /*#__PURE__*/ (0, $e1vzu.jsx)(MoovyAlert, {
            title: localizedError
        });
        else return /*#__PURE__*/ (0, $e1vzu.jsx)(MoovyAlert, {
            title: localizedTitle,
            children: errorBodyKey ? intl.formatMessage({
                id: errorBodyKey
            }) : null
        });
    };
    return localizedErrorText({
        mutation: mutation,
        query: query,
        errorBodyKey: errorBodyKey,
        errorTitleKey: errorTitleKey
    });
};
var $09ef42aa6aba452d$export$2e2bcd8739ae039 = $09ef42aa6aba452d$var$MoovyMutationError;



var $e1vzu = parcelRequire("e1vzu");


const $4453c76d9a9c1264$var$MoovyProgress = (props)=>{
    const style = props.sx || {
        display: 'flex',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
        sx: style,
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fccdfec3f47c0093$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
var $4453c76d9a9c1264$export$2e2bcd8739ae039 = $4453c76d9a9c1264$var$MoovyProgress;



var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");


var $iCj5F = parcelRequire("iCj5F");

var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $70bc6f286fa62d01$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $9uBH9.default)('MuiFab', slot);
}
const $70bc6f286fa62d01$var$fabClasses = (0, $6N1Oq.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $70bc6f286fa62d01$export$2e2bcd8739ae039 = $70bc6f286fa62d01$var$fabClasses;



var $ajKPH = parcelRequire("ajKPH");

var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");


var $vqOnh = parcelRequire("vqOnh");

var $e1vzu = parcelRequire("e1vzu");
'use client';
const $ddc033381f4b5702$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $iCj5F.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $6q4c0.default)(slots, (0, $70bc6f286fa62d01$export$e2cfa0ca4bce1fc2), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $ddc033381f4b5702$var$FabRoot = (0, $2TGnx.default)((0, $0c5993b2b6821c5b$export$2e2bcd8739ae039), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $ajKPH.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $iCj5F.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $iCj5F.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $gvYl6.default)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $70bc6f286fa62d01$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $gvYl6.default)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $d2323f13691b1a28$export$2e2bcd8739ae039)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $gvYl6.default)(({ theme: theme })=>({
        [`&.${(0, $70bc6f286fa62d01$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $ddc033381f4b5702$var$Fab = /*#__PURE__*/ $3QbnI.forwardRef(function Fab(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $ddc033381f4b5702$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($ddc033381f4b5702$var$FabRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $eTLbi.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: classes,
        children: children
    });
});
var $ddc033381f4b5702$export$2e2bcd8739ae039 = $ddc033381f4b5702$var$Fab;



var $3QbnI = parcelRequire("3QbnI");








var $e1vzu = parcelRequire("e1vzu");
'use client';
const $8a53a777ee07baf2$var$styles = {
    entering: {
        transform: 'none'
    },
    entered: {
        transform: 'none'
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8a53a777ee07baf2$var$Zoom = /*#__PURE__*/ $3QbnI.forwardRef(function Zoom(props, ref) {
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $310f30916c86eca9$export$2e2bcd8739ae039), ...other } = props;
    const nodeRef = $3QbnI.useRef(null);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(nodeRef, (0, $bca562fe1e155add$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $239bb4b3aee172ac$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $239bb4b3aee172ac$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, childProps)=>{
            return /*#__PURE__*/ $3QbnI.cloneElement(children, {
                style: {
                    transform: 'scale(0)',
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$8a53a777ee07baf2$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...childProps
            });
        }
    });
});
var $8a53a777ee07baf2$export$2e2bcd8739ae039 = $8a53a777ee07baf2$var$Zoom;



var $3QbnI = parcelRequire("3QbnI");
var $68de497c81418273$exports = {};
"use strict";
"use client";

var $68de497c81418273$require$_interopRequireDefault = $55ceebaba6abf8a9$exports.default;
Object.defineProperty($68de497c81418273$exports, "__esModule", {
    value: true
});
$68de497c81418273$exports.default = void 0;

var $68de497c81418273$var$_createSvgIcon = $68de497c81418273$require$_interopRequireDefault((parcelRequire("8Cb4O")));

var $e1vzu = parcelRequire("e1vzu");
var $68de497c81418273$var$_default = $68de497c81418273$exports.default = (0, $68de497c81418273$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e1vzu.jsx)("path", {
    d: "M8.12 14.71 12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L12.7 8.71a.996.996 0 0 0-1.41 0L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.38 1.03.39 1.42 0"
}), 'KeyboardArrowUpRounded');


const $5f4a92248a848f80$var$MoovyScrollToTop = ({})=>{
    const [showScroll, setshowScroll] = (0, $3QbnI.useState)(false);
    const [scrollY, setScrollY] = (0, $3QbnI.useState)(0);
    (0, $3QbnI.useEffect)(()=>{
        const handleScroll = ()=>{
            const innerHeight = window.innerHeight || 0;
            const y = window.scrollY;
            // Show the button only if user is scrolling down.
            setshowScroll(scrollY < y && y > innerHeight / 2);
            setScrollY(y);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        scrollY
    ]);
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $8a53a777ee07baf2$export$2e2bcd8739ae039), {
            in: showScroll,
            timeout: {
                enter: 500,
                exit: 500
            },
            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ddc033381f4b5702$export$2e2bcd8739ae039), {
                size: "small",
                style: {
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    backgroundColor: 'transparent'
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68de497c81418273$exports))), {
                    onClick: scrollToTop
                })
            })
        })
    });
};
var $5f4a92248a848f80$export$2e2bcd8739ae039 = $5f4a92248a848f80$var$MoovyScrollToTop;



var $e1vzu = parcelRequire("e1vzu");



const $fd8cba9627e69a57$export$76ce5bcdf3530075 = (cents)=>Number.parseFloat((cents / 100).toFixed(2));
const $fd8cba9627e69a57$export$dc061432631a11cf = (eur)=>Math.round(eur * 100);
const $fd8cba9627e69a57$export$7fef4f5078e2ef4a = (parameters)=>{
    return (0, $ee9cb80b5c23ac97$export$cf6c09818bd7035a)(parameters.cents) ? parameters.intl.formatNumber($fd8cba9627e69a57$export$76ce5bcdf3530075(parameters.cents), {
        style: 'currency',
        currency: 'EUR'
    }) : null;
};
const $fd8cba9627e69a57$var$PrettyCurrency = (props)=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
        children: $fd8cba9627e69a57$export$7fef4f5078e2ef4a({
            intl: intl,
            cents: props.cents
        })
    });
};
var $fd8cba9627e69a57$export$2e2bcd8739ae039 = $fd8cba9627e69a57$var$PrettyCurrency;





var $3QbnI = parcelRequire("3QbnI");

var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");

const $6772a177ad7746fa$var$defaultLocale = (0, $2e2f998e72251dab$export$2e2bcd8739ae039).language.split('-')[0];
const $6772a177ad7746fa$export$cc1a71568d63a601 = /*#__PURE__*/ (0, $3QbnI.createContext)({
    locale: $6772a177ad7746fa$var$defaultLocale,
    setLocale: ()=>{}
});
const $6772a177ad7746fa$export$d07e18ad7fac0edc = ({ children: children })=>{
    const [locale, setLocaleState] = (0, $3QbnI.useState)($6772a177ad7746fa$var$defaultLocale);
    const setLocale = (newLocale)=>{
        setLocaleState(newLocale);
        (0, $2e2f998e72251dab$export$2e2bcd8739ae039).changeLanguage(newLocale);
    };
    const value = {
        locale: locale,
        setLocale: setLocale
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)($6772a177ad7746fa$export$cc1a71568d63a601.Provider, {
        value: value,
        children: children
    });
};


const $2baeba59fba86da4$var$useLocale = ()=>{
    return (0, $3QbnI.useContext)((0, $6772a177ad7746fa$export$cc1a71568d63a601));
};
var $2baeba59fba86da4$export$2e2bcd8739ae039 = $2baeba59fba86da4$var$useLocale;



var $3QbnI = parcelRequire("3QbnI");

var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");


const $d9e1f0b1f58d3102$var$paymentSteps = Object.values((0, $c8a51a1a3cac62e6$export$9e355b279c43f205));
const $d9e1f0b1f58d3102$var$loadStepFromSessionStorage = ()=>{
    const stepFromSessionStorage = sessionStorage.getItem((0, $2732b3fe4895f686$export$c02a0b32732a12b7));
    if ($d9e1f0b1f58d3102$var$paymentSteps.includes(stepFromSessionStorage)) return stepFromSessionStorage;
    else return (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE;
};
const $d9e1f0b1f58d3102$var$saveStepToSessionStorage = (step)=>{
    sessionStorage.setItem((0, $2732b3fe4895f686$export$c02a0b32732a12b7), step);
};
const $d9e1f0b1f58d3102$var$defaultStep = $d9e1f0b1f58d3102$var$loadStepFromSessionStorage();
const $d9e1f0b1f58d3102$export$4dbef2dcc6f6d556 = /*#__PURE__*/ (0, $3QbnI.createContext)([
    $d9e1f0b1f58d3102$var$defaultStep,
    ()=>{}
]);
const $d9e1f0b1f58d3102$export$747289a838051b01 = ({ children: children })=>{
    const [step, setStepState] = (0, $3QbnI.useState)($d9e1f0b1f58d3102$var$defaultStep);
    const setStep = (newStep)=>{
        setStepState(newStep);
        $d9e1f0b1f58d3102$var$saveStepToSessionStorage(newStep);
    };
    const value = [
        step,
        setStep
    ];
    return /*#__PURE__*/ (0, $e1vzu.jsx)($d9e1f0b1f58d3102$export$4dbef2dcc6f6d556.Provider, {
        value: value,
        children: children
    });
};


const $19b60b7d89217ab4$var$usePaymentStep = ()=>{
    return (0, $3QbnI.useContext)((0, $d9e1f0b1f58d3102$export$4dbef2dcc6f6d556));
};
var $19b60b7d89217ab4$export$2e2bcd8739ae039 = $19b60b7d89217ab4$var$usePaymentStep;



var $2227b20de94aaa0a$exports = {};
$2227b20de94aaa0a$exports = new URL("finavia.7d992b13.png", import.meta.url).toString();




(function(MoovyToast) {
    MoovyToast.showToast = (message, type = 'success')=>{
        switch(type){
            case 'success':
                (0, $d7fe6407b009814b$export$b410431fab84fa58).success(message);
                break;
            case 'error':
                (0, $d7fe6407b009814b$export$b410431fab84fa58).error(message);
                break;
        }
    };
})($eaea2ba9b50fd31e$export$266cbe012f0ab791 || ($eaea2ba9b50fd31e$export$266cbe012f0ab791 = {}));
var $eaea2ba9b50fd31e$export$266cbe012f0ab791;



var $e1vzu = parcelRequire("e1vzu");





const $3d09673614435234$var$PaymentProviderInformation = ()=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
        container: true,
        marginTop: 8,
        rowGap: 4,
        size: {
            xs: 12,
            sm: 6
        },
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                width: "100%",
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $939fbaf970c0d6e6$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                variant: "h6",
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.paymentProvider.heading"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                variant: "body2",
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.paymentProvider.information"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                variant: "body2",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                        id: "page.webPayment.paymentProvider.details1"
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)("br", {}),
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                        id: "page.webPayment.paymentProvider.details2"
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)("br", {}),
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                        id: "page.webPayment.paymentProvider.details3"
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)("br", {}),
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                        id: "page.webPayment.paymentProvider.details4"
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                variant: "body2",
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039).Link, {
                    target: "_blank",
                    href: intl.formatMessage({
                        id: 'page.webPayment.paymentProvider.url'
                    }),
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                        id: "page.webPayment.paymentProvider.url"
                    })
                })
            })
        ]
    });
};
var $3d09673614435234$export$2e2bcd8739ae039 = $3d09673614435234$var$PaymentProviderInformation;



var $e1vzu = parcelRequire("e1vzu");


var $e1vzu = parcelRequire("e1vzu");
var $fb520d4af766a619$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $fb520d4af766a619$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$fb520d4af766a619$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$fb520d4af766a619$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$fb520d4af766a619$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $fb520d4af766a619$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $fb520d4af766a619$var$DIGIT_REGEX = /^\d+$/, $fb520d4af766a619$var$LEAD_DIGIT_REGEX = /^\d/, $fb520d4af766a619$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $fb520d4af766a619$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $fb520d4af766a619$var$MAX_CACHE_SIZE = 512;
var $fb520d4af766a619$var$pathCache = new $fb520d4af766a619$var$Cache($fb520d4af766a619$var$MAX_CACHE_SIZE), $fb520d4af766a619$var$setCache = new $fb520d4af766a619$var$Cache($fb520d4af766a619$var$MAX_CACHE_SIZE), $fb520d4af766a619$var$getCache = new $fb520d4af766a619$var$Cache($fb520d4af766a619$var$MAX_CACHE_SIZE);
var $fb520d4af766a619$var$config;
$fb520d4af766a619$exports = {
    Cache: $fb520d4af766a619$var$Cache,
    split: $fb520d4af766a619$var$split,
    normalizePath: $fb520d4af766a619$var$normalizePath,
    setter: function(path) {
        var parts = $fb520d4af766a619$var$normalizePath(path);
        return $fb520d4af766a619$var$setCache.get(path) || $fb520d4af766a619$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $fb520d4af766a619$var$normalizePath(path);
        return $fb520d4af766a619$var$getCache.get(path) || $fb520d4af766a619$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($fb520d4af766a619$var$isQuoted(part) || $fb520d4af766a619$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $fb520d4af766a619$var$forEach(Array.isArray(path) ? path : $fb520d4af766a619$var$split(path), cb, thisArg);
    }
};
function $fb520d4af766a619$var$normalizePath(path) {
    return $fb520d4af766a619$var$pathCache.get(path) || $fb520d4af766a619$var$pathCache.set(path, $fb520d4af766a619$var$split(path).map(function(part) {
        return part.replace($fb520d4af766a619$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $fb520d4af766a619$var$split(path) {
    return path.match($fb520d4af766a619$var$SPLIT_REGEX) || [
        ''
    ];
}
function $fb520d4af766a619$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($fb520d4af766a619$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $fb520d4af766a619$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $fb520d4af766a619$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $fb520d4af766a619$var$hasLeadingNumber(part) {
    return part.match($fb520d4af766a619$var$LEAD_DIGIT_REGEX) && !part.match($fb520d4af766a619$var$DIGIT_REGEX);
}
function $fb520d4af766a619$var$hasSpecialChars(part) {
    return $fb520d4af766a619$var$SPEC_CHAR_REGEX.test(part);
}
function $fb520d4af766a619$var$shouldBeQuoted(part) {
    return !$fb520d4af766a619$var$isQuoted(part) && ($fb520d4af766a619$var$hasLeadingNumber(part) || $fb520d4af766a619$var$hasSpecialChars(part));
}


var $6dec5c6aac957a20$exports = {};
const $6dec5c6aac957a20$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $6dec5c6aac957a20$var$words = (str)=>str.match($6dec5c6aac957a20$var$reWords) || [];
const $6dec5c6aac957a20$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $6dec5c6aac957a20$var$join = (str, d)=>$6dec5c6aac957a20$var$words(str).join(d).toLowerCase();
const $6dec5c6aac957a20$var$camelCase = (str)=>$6dec5c6aac957a20$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $6dec5c6aac957a20$var$pascalCase = (str)=>$6dec5c6aac957a20$var$upperFirst($6dec5c6aac957a20$var$camelCase(str));
const $6dec5c6aac957a20$var$snakeCase = (str)=>$6dec5c6aac957a20$var$join(str, '_');
const $6dec5c6aac957a20$var$kebabCase = (str)=>$6dec5c6aac957a20$var$join(str, '-');
const $6dec5c6aac957a20$var$sentenceCase = (str)=>$6dec5c6aac957a20$var$upperFirst($6dec5c6aac957a20$var$join(str, ' '));
const $6dec5c6aac957a20$var$titleCase = (str)=>$6dec5c6aac957a20$var$words(str).map($6dec5c6aac957a20$var$upperFirst).join(' ');
$6dec5c6aac957a20$exports = {
    words: $6dec5c6aac957a20$var$words,
    upperFirst: $6dec5c6aac957a20$var$upperFirst,
    camelCase: $6dec5c6aac957a20$var$camelCase,
    pascalCase: $6dec5c6aac957a20$var$pascalCase,
    snakeCase: $6dec5c6aac957a20$var$snakeCase,
    kebabCase: $6dec5c6aac957a20$var$kebabCase,
    sentenceCase: $6dec5c6aac957a20$var$sentenceCase,
    titleCase: $6dec5c6aac957a20$var$titleCase
};


var $3f37d9e86483661e$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $3f37d9e86483661e$exports = function(edges) {
    return $3f37d9e86483661e$var$toposort($3f37d9e86483661e$var$uniqueNodes(edges), edges);
};
$3f37d9e86483661e$exports.array = $3f37d9e86483661e$var$toposort;
function $3f37d9e86483661e$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $3f37d9e86483661e$var$makeOutgoingEdges(edges), nodesHash = $3f37d9e86483661e$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $3f37d9e86483661e$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $3f37d9e86483661e$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $3f37d9e86483661e$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $13652c29f5b631d1$var$toString = Object.prototype.toString;
const $13652c29f5b631d1$var$errorToString = Error.prototype.toString;
const $13652c29f5b631d1$var$regExpToString = RegExp.prototype.toString;
const $13652c29f5b631d1$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $13652c29f5b631d1$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $13652c29f5b631d1$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $13652c29f5b631d1$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $13652c29f5b631d1$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $13652c29f5b631d1$var$symbolToString.call(val).replace($13652c29f5b631d1$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $13652c29f5b631d1$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $13652c29f5b631d1$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $13652c29f5b631d1$var$regExpToString.call(val);
    return null;
}
function $13652c29f5b631d1$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $13652c29f5b631d1$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $13652c29f5b631d1$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $13652c29f5b631d1$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $13652c29f5b631d1$var$_Symbol$toStringTag, $13652c29f5b631d1$var$_Symbol$hasInstance, $13652c29f5b631d1$var$_Symbol$toStringTag2;
let $13652c29f5b631d1$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$13652c29f5b631d1$var$_Symbol$toStringTag = Symbol.toStringTag;
class $13652c29f5b631d1$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$13652c29f5b631d1$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $13652c29f5b631d1$var$toArray(errorOrErrors).forEach((err)=>{
            if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$13652c29f5b631d1$var$_Symbol$hasInstance = Symbol.hasInstance;
$13652c29f5b631d1$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $13652c29f5b631d1$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($13652c29f5b631d1$var$strReg, (_, key)=>$13652c29f5b631d1$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $13652c29f5b631d1$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$13652c29f5b631d1$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $13652c29f5b631d1$export$2191b9da168c6cf0);
    }
    static [$13652c29f5b631d1$var$_Symbol$hasInstance](inst) {
        return $13652c29f5b631d1$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $13652c29f5b631d1$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$13652c29f5b631d1$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$13652c29f5b631d1$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$13652c29f5b631d1$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $13652c29f5b631d1$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $13652c29f5b631d1$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $13652c29f5b631d1$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $13652c29f5b631d1$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $13652c29f5b631d1$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $13652c29f5b631d1$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $13652c29f5b631d1$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$13652c29f5b631d1$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$13652c29f5b631d1$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $13652c29f5b631d1$export$2191b9da168c6cf0.formatError($13652c29f5b631d1$var$mixed.notType, params);
    }
};
var $13652c29f5b631d1$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $13652c29f5b631d1$var$mixed,
    string: $13652c29f5b631d1$var$string,
    number: $13652c29f5b631d1$var$number,
    date: $13652c29f5b631d1$var$date,
    object: $13652c29f5b631d1$var$object,
    array: $13652c29f5b631d1$var$array,
    boolean: $13652c29f5b631d1$var$boolean,
    tuple: $13652c29f5b631d1$var$tuple
});
const $13652c29f5b631d1$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $13652c29f5b631d1$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $13652c29f5b631d1$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$13652c29f5b631d1$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $13652c29f5b631d1$var$prefixes = {
    context: '$',
    value: '.'
};
function $13652c29f5b631d1$export$eff4d24c3ff7876e(key, options) {
    return new $13652c29f5b631d1$var$Reference(key, options);
}
class $13652c29f5b631d1$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $13652c29f5b631d1$var$prefixes.context;
        this.isValue = this.key[0] === $13652c29f5b631d1$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $13652c29f5b631d1$var$prefixes.context : this.isValue ? $13652c29f5b631d1$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $fb520d4af766a619$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$13652c29f5b631d1$var$Reference.prototype.__isYupRef = true;
const $13652c29f5b631d1$var$isAbsent = (value)=>value == null;
function $13652c29f5b631d1$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $13652c29f5b631d1$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $13652c29f5b631d1$export$2191b9da168c6cf0($13652c29f5b631d1$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $13652c29f5b631d1$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $13652c29f5b631d1$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $fb520d4af766a619$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $13652c29f5b631d1$export$cfedb76369cc7782(obj, path, value, context) {
    return $13652c29f5b631d1$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $13652c29f5b631d1$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($13652c29f5b631d1$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $13652c29f5b631d1$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $13652c29f5b631d1$var$clone(src, seen = new Map()) {
    if ($13652c29f5b631d1$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $13652c29f5b631d1$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $13652c29f5b631d1$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($13652c29f5b631d1$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $13652c29f5b631d1$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $13652c29f5b631d1$var$ReferenceSet();
        this._blacklist = new $13652c29f5b631d1$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($13652c29f5b631d1$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $13652c29f5b631d1$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $13652c29f5b631d1$var$isAbsent(result)) return result;
            let formattedValue = $13652c29f5b631d1$export$5790025c6e6c2ba6(value);
            let formattedResult = $13652c29f5b631d1$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $13652c29f5b631d1$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $13652c29f5b631d1$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $13652c29f5b631d1$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $13652c29f5b631d1$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $13652c29f5b631d1$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $13652c29f5b631d1$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $13652c29f5b631d1$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $13652c29f5b631d1$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $13652c29f5b631d1$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $13652c29f5b631d1$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $13652c29f5b631d1$var$toArray(keys).map((key)=>new $13652c29f5b631d1$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $13652c29f5b631d1$var$Condition(deps, options) : $13652c29f5b631d1$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $13652c29f5b631d1$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $13652c29f5b631d1$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $13652c29f5b631d1$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $13652c29f5b631d1$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $13652c29f5b631d1$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$13652c29f5b631d1$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$13652c29f5b631d1$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $13652c29f5b631d1$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$13652c29f5b631d1$export$19342e026b58ebb7.prototype[alias] = $13652c29f5b631d1$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$13652c29f5b631d1$export$19342e026b58ebb7.prototype[alias] = $13652c29f5b631d1$export$19342e026b58ebb7.prototype.notOneOf;
const $13652c29f5b631d1$var$returnsTrue = ()=>true;
function $13652c29f5b631d1$export$9b30b6294c1449a8(spec) {
    return new $13652c29f5b631d1$export$1e88358c94ddec71(spec);
}
class $13652c29f5b631d1$export$1e88358c94ddec71 extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $13652c29f5b631d1$var$returnsTrue
        }, spec));
    }
}
$13652c29f5b631d1$export$9b30b6294c1449a8.prototype = $13652c29f5b631d1$export$1e88358c94ddec71.prototype;
function $13652c29f5b631d1$export$87b259aa03e3d267() {
    return new $13652c29f5b631d1$export$c7980688f11e1f49();
}
class $13652c29f5b631d1$export$c7980688f11e1f49 extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $13652c29f5b631d1$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $13652c29f5b631d1$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $13652c29f5b631d1$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $13652c29f5b631d1$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$13652c29f5b631d1$export$87b259aa03e3d267.prototype = $13652c29f5b631d1$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $13652c29f5b631d1$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $13652c29f5b631d1$var$parseIsoDate(date) {
    const struct = $13652c29f5b631d1$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $13652c29f5b631d1$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $13652c29f5b631d1$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $13652c29f5b631d1$var$toNumber(regexResult[1]),
        month: $13652c29f5b631d1$var$toNumber(regexResult[2], 1) - 1,
        day: $13652c29f5b631d1$var$toNumber(regexResult[3], 1),
        hour: $13652c29f5b631d1$var$toNumber(regexResult[4]),
        minute: $13652c29f5b631d1$var$toNumber(regexResult[5]),
        second: $13652c29f5b631d1$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $13652c29f5b631d1$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $13652c29f5b631d1$var$toNumber(regexResult[10]),
        minuteOffset: $13652c29f5b631d1$var$toNumber(regexResult[11])
    };
}
function $13652c29f5b631d1$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $13652c29f5b631d1$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $13652c29f5b631d1$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $13652c29f5b631d1$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $13652c29f5b631d1$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $13652c29f5b631d1$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $13652c29f5b631d1$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $13652c29f5b631d1$var$rIsoDateTime = new RegExp(`${$13652c29f5b631d1$var$yearMonthDay}T${$13652c29f5b631d1$var$hourMinuteSecond}(\\.\\d+)?${$13652c29f5b631d1$var$zOrOffset}$`);
let $13652c29f5b631d1$var$isTrimmed = (value)=>$13652c29f5b631d1$var$isAbsent(value) || value === value.trim();
let $13652c29f5b631d1$var$objStringTag = ({}).toString();
function $13652c29f5b631d1$export$22b082955e083ec3() {
    return new $13652c29f5b631d1$export$49bf8b2ede5138eb();
}
class $13652c29f5b631d1$export$49bf8b2ede5138eb extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $13652c29f5b631d1$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $13652c29f5b631d1$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $13652c29f5b631d1$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $13652c29f5b631d1$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $13652c29f5b631d1$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $13652c29f5b631d1$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $13652c29f5b631d1$var$string.email) {
        return this.matches($13652c29f5b631d1$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $13652c29f5b631d1$var$string.url) {
        return this.matches($13652c29f5b631d1$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $13652c29f5b631d1$var$string.uuid) {
        return this.matches($13652c29f5b631d1$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($13652c29f5b631d1$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $13652c29f5b631d1$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $13652c29f5b631d1$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $13652c29f5b631d1$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $13652c29f5b631d1$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $13652c29f5b631d1$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $13652c29f5b631d1$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $13652c29f5b631d1$var$isTrimmed
        });
    }
    lowercase(message = $13652c29f5b631d1$var$string.lowercase) {
        return this.transform((value)=>!$13652c29f5b631d1$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$13652c29f5b631d1$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $13652c29f5b631d1$var$string.uppercase) {
        return this.transform((value)=>!$13652c29f5b631d1$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$13652c29f5b631d1$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$13652c29f5b631d1$export$22b082955e083ec3.prototype = $13652c29f5b631d1$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $13652c29f5b631d1$var$isNaN$1 = (value)=>value != +value;
function $13652c29f5b631d1$export$98e628dec113755e() {
    return new $13652c29f5b631d1$export$f192ec5e9228ab19();
}
class $13652c29f5b631d1$export$f192ec5e9228ab19 extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$13652c29f5b631d1$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $13652c29f5b631d1$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $13652c29f5b631d1$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $13652c29f5b631d1$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $13652c29f5b631d1$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $13652c29f5b631d1$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $13652c29f5b631d1$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $13652c29f5b631d1$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$13652c29f5b631d1$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$13652c29f5b631d1$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$13652c29f5b631d1$export$98e628dec113755e.prototype = $13652c29f5b631d1$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $13652c29f5b631d1$var$invalidDate = new Date('');
let $13652c29f5b631d1$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $13652c29f5b631d1$export$324d90190a8b822a() {
    return new $13652c29f5b631d1$export$18ec3cc5a157503f();
}
class $13652c29f5b631d1$export$18ec3cc5a157503f extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $13652c29f5b631d1$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $13652c29f5b631d1$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $13652c29f5b631d1$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$13652c29f5b631d1$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $13652c29f5b631d1$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $13652c29f5b631d1$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$13652c29f5b631d1$export$18ec3cc5a157503f.INVALID_DATE = $13652c29f5b631d1$var$invalidDate;
$13652c29f5b631d1$export$324d90190a8b822a.prototype = $13652c29f5b631d1$export$18ec3cc5a157503f.prototype;
$13652c29f5b631d1$export$324d90190a8b822a.INVALID_DATE = $13652c29f5b631d1$var$invalidDate;
// @ts-expect-error
function $13652c29f5b631d1$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $fb520d4af766a619$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($13652c29f5b631d1$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($13652c29f5b631d1$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3f37d9e86483661e$exports))).array(Array.from(nodes), edges).reverse();
}
function $13652c29f5b631d1$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $13652c29f5b631d1$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $13652c29f5b631d1$var$findIndex(keys, a) - $13652c29f5b631d1$var$findIndex(keys, b);
    };
}
const $13652c29f5b631d1$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $13652c29f5b631d1$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $13652c29f5b631d1$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $13652c29f5b631d1$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($13652c29f5b631d1$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $13652c29f5b631d1$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $fb520d4af766a619$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $fb520d4af766a619$exports.getter)((0, $fb520d4af766a619$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $13652c29f5b631d1$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $13652c29f5b631d1$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $13652c29f5b631d1$var$defaultSort = $13652c29f5b631d1$var$sortByKeyOrder([]);
function $13652c29f5b631d1$export$be5493f9613cbbe(spec) {
    return new $13652c29f5b631d1$export$18b4fc70ec7eccf8(spec);
}
class $13652c29f5b631d1$export$18b4fc70ec7eccf8 extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $13652c29f5b631d1$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $13652c29f5b631d1$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $13652c29f5b631d1$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$13652c29f5b631d1$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $13652c29f5b631d1$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $13652c29f5b631d1$var$sortFields(shape, excludedEdges);
        next._sortErrors = $13652c29f5b631d1$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $13652c29f5b631d1$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $fb520d4af766a619$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($13652c29f5b631d1$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($13652c29f5b631d1$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $13652c29f5b631d1$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $13652c29f5b631d1$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $13652c29f5b631d1$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $13652c29f5b631d1$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $13652c29f5b631d1$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $6dec5c6aac957a20$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $6dec5c6aac957a20$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $6dec5c6aac957a20$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$13652c29f5b631d1$export$be5493f9613cbbe.prototype = $13652c29f5b631d1$export$18b4fc70ec7eccf8.prototype;
function $13652c29f5b631d1$export$2f23118c22fb2630(type) {
    return new $13652c29f5b631d1$export$4347112b8447a7d(type);
}
class $13652c29f5b631d1$export$4347112b8447a7d extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($13652c29f5b631d1$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$13652c29f5b631d1$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $13652c29f5b631d1$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $13652c29f5b631d1$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $13652c29f5b631d1$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $13652c29f5b631d1$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$13652c29f5b631d1$export$2f23118c22fb2630.prototype = $13652c29f5b631d1$export$4347112b8447a7d.prototype;
// @ts-ignore
function $13652c29f5b631d1$export$65e3907585753458(schemas) {
    return new $13652c29f5b631d1$export$411c3b3687e8ecc8(schemas);
}
class $13652c29f5b631d1$export$411c3b3687e8ecc8 extends $13652c29f5b631d1$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($13652c29f5b631d1$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$13652c29f5b631d1$export$65e3907585753458.prototype = $13652c29f5b631d1$export$411c3b3687e8ecc8.prototype;
function $13652c29f5b631d1$export$488013bae63b21da(builder) {
    return new $13652c29f5b631d1$export$71117d144d3091c9(builder);
}
function $13652c29f5b631d1$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $13652c29f5b631d1$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$13652c29f5b631d1$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $13652c29f5b631d1$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $13652c29f5b631d1$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $13652c29f5b631d1$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($13652c29f5b631d1$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $13652c29f5b631d1$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $13652c29f5b631d1$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $13652c29f5b631d1$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$13652c29f5b631d1$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}




var $3Rwjo = parcelRequire("3Rwjo");

var $3QbnI = parcelRequire("3QbnI");

// Naming format: [component]_[description]_[element-type]
const $5cb825bac5cf2334$var$STEP_LICENSE_PLATE_LPN_INPUT = 'step-license-plate-lpn-input';
const $5cb825bac5cf2334$var$STEP_LICENSE_PLATE_SEARCH_BUTTON = 'step-license-plate-search-button';
const $5cb825bac5cf2334$var$STEP_LICENSE_PLATE_NO_INVOICES_INFORMATION = 'step-license-plate-no-invoices-information';
const $5cb825bac5cf2334$var$STEP_INVOICE_INVOICE_CONTAINER = 'step-invoice-invoice-container';
var $5cb825bac5cf2334$export$2e2bcd8739ae039 = {
    STEP_LICENSE_PLATE_LPN_INPUT: $5cb825bac5cf2334$var$STEP_LICENSE_PLATE_LPN_INPUT,
    STEP_LICENSE_PLATE_SEARCH_BUTTON: $5cb825bac5cf2334$var$STEP_LICENSE_PLATE_SEARCH_BUTTON,
    STEP_LICENSE_PLATE_NO_INVOICES_INFORMATION: $5cb825bac5cf2334$var$STEP_LICENSE_PLATE_NO_INVOICES_INFORMATION,
    STEP_INVOICE_INVOICE_CONTAINER: $5cb825bac5cf2334$var$STEP_INVOICE_INVOICE_CONTAINER
};




const $169a04a4f28c5fb1$var$FormLicensePlate = (props)=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $3QbnI.useState)(false);
    const defaultValues = {
        licensePlate: props.licensePlate
    };
    const validationSchema = ()=>{
        return $13652c29f5b631d1$export$be5493f9613cbbe().shape({
            licensePlate: $13652c29f5b631d1$export$22b082955e083ec3().trim().test('licensePlate', intl.formatMessage({
                id: 'page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate'
            }), (licensePlate)=>(0, $066f7ec5b64309d3$export$dddb845077defee2)(licensePlate))
        });
    };
    const onSubmitFormValues = (values)=>{
        const { licensePlate: licensePlate } = values;
        props.onSubmit({
            licensePlate: licensePlate.trim()
        });
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3Rwjo.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: validationSchema(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $e1vzu.jsx)("form", {
                    onSubmit: (event)=>{
                        event.preventDefault();
                        handleSubmit();
                    },
                    id: props.formReference,
                    style: {
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "licensePlate",
                                "data-testid": (0, $5cb825bac5cf2334$export$2e2bcd8739ae039).STEP_LICENSE_PLATE_LPN_INPUT,
                                value: values.licensePlate,
                                autoFocus: true,
                                label: intl.formatMessage({
                                    id: 'page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter'
                                }),
                                placeholder: intl.formatMessage({
                                    id: 'page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate'
                                }),
                                InputLabelProps: {
                                    shrink: true
                                },
                                onChange: handleChange,
                                error: !!errors.licensePlate,
                                errorText: errors.licensePlate
                            }),
                            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                                variant: "body2",
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                    id: "page.webPayment.stepFillLicensePlate.formLicensePlate.info.format"
                                })
                            })
                        ]
                    })
                })
        })
    });
};
var $169a04a4f28c5fb1$export$2e2bcd8739ae039 = $169a04a4f28c5fb1$var$FormLicensePlate;









var $e1vzu = parcelRequire("e1vzu");




var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");




var $2TGnx = parcelRequire("2TGnx");

var $gvYl6 = parcelRequire("gvYl6");

var $vqOnh = parcelRequire("vqOnh");




var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $c448846818ee5f7c$export$5682c366c0c669d9(slot) {
    return (0, $9uBH9.default)('MuiListItem', slot);
}
const $c448846818ee5f7c$var$listItemClasses = (0, $6N1Oq.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $c448846818ee5f7c$export$2e2bcd8739ae039 = $c448846818ee5f7c$var$listItemClasses;



var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $670f9716f575057e$export$c09531d8563c67a5(slot) {
    return (0, $9uBH9.default)('MuiListItemButton', slot);
}
const $670f9716f575057e$var$listItemButtonClasses = (0, $6N1Oq.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $670f9716f575057e$export$2e2bcd8739ae039 = $670f9716f575057e$var$listItemButtonClasses;



var $3QbnI = parcelRequire("3QbnI");


var $eTLbi = parcelRequire("eTLbi");

var $6q4c0 = parcelRequire("6q4c0");

var $2TGnx = parcelRequire("2TGnx");

var $vqOnh = parcelRequire("vqOnh");


var $6N1Oq = parcelRequire("6N1Oq");

var $9uBH9 = parcelRequire("9uBH9");
function $6b7c31ebfef9a03b$export$ccdb26aeba48a86e(slot) {
    return (0, $9uBH9.default)('MuiListItemSecondaryAction', slot);
}
const $6b7c31ebfef9a03b$var$listItemSecondaryActionClasses = (0, $6N1Oq.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $6b7c31ebfef9a03b$export$2e2bcd8739ae039 = $6b7c31ebfef9a03b$var$listItemSecondaryActionClasses;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $58c88d1e17dd342f$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $6b7c31ebfef9a03b$export$ccdb26aeba48a86e), classes);
};
const $58c88d1e17dd342f$var$ListItemSecondaryActionRoot = (0, $2TGnx.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $58c88d1e17dd342f$var$ListItemSecondaryAction = /*#__PURE__*/ $3QbnI.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $3QbnI.useContext((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $58c88d1e17dd342f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e1vzu.jsx)($58c88d1e17dd342f$var$ListItemSecondaryActionRoot, {
        className: (0, $eTLbi.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$58c88d1e17dd342f$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $58c88d1e17dd342f$export$2e2bcd8739ae039 = $58c88d1e17dd342f$var$ListItemSecondaryAction;



var $e1vzu = parcelRequire("e1vzu");
'use client';
const $d92c467eb64a79d5$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $d92c467eb64a79d5$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $6q4c0.default)(slots, (0, $c448846818ee5f7c$export$5682c366c0c669d9), classes);
};
const $d92c467eb64a79d5$export$aed538f7519abe89 = (0, $2TGnx.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $d92c467eb64a79d5$export$4334bb34c76fef24
})((0, $gvYl6.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $670f9716f575057e$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $d92c467eb64a79d5$var$ListItemContainer = (0, $2TGnx.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $d92c467eb64a79d5$var$ListItem = /*#__PURE__*/ $3QbnI.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $vqOnh.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $3QbnI.useContext((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039));
    const childContext = $3QbnI.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $3QbnI.useRef(null);
    const children = $3QbnI.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $5e162abd78b4747c$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $d92c467eb64a79d5$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4978b4fb9409dfeb$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $d92c467eb64a79d5$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $eTLbi.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $e1vzu.jsxs)($d92c467eb64a79d5$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $eTLbi.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $d5877b474787d752$export$2e2bcd8739ae039)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3fa9e52ed0665cfa$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $e1vzu.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $d5877b474787d752$export$2e2bcd8739ae039)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $e1vzu.jsx)((0, $58c88d1e17dd342f$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $d92c467eb64a79d5$export$2e2bcd8739ae039 = $d92c467eb64a79d5$var$ListItem;




const $d43dc7f92ddce118$var$AlertNoPayment = ({ licensePlate: licensePlate })=>{
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $da123deb82412e15$export$2e2bcd8739ae039), {
        severity: "info",
        sx: {
            textAlign: 'left'
        },
        "data-testid": (0, $5cb825bac5cf2334$export$2e2bcd8739ae039).STEP_LICENSE_PLATE_NO_INVOICES_INFORMATION,
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $9783166253fe9251$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents",
                    values: {
                        licensePlate: licensePlate
                    }
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                id: "page.webPayment.stepFillLicensePlate.alert.body.reason"
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: 2,
                    listStyleType: 'disc'
                },
                children: [
                    1,
                    2,
                    3
                ].map((i)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $d92c467eb64a79d5$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'list-item'
                        },
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                            id: `page.webPayment.stepFillLicensePlate.alert.body.desc${i}`
                        })
                    }, `noUnpaidParkingEventsDescriptionItem-${i}`))
            })
        ]
    });
};
var $d43dc7f92ddce118$export$2e2bcd8739ae039 = $d43dc7f92ddce118$var$AlertNoPayment;


const $e1cbeb8d7e2751bc$var$StepFillLicensePlate = ({ formReference: formReference, licensePlate: licensePlate, isButtonDisabled: isButtonDisabled, onSubmitLicensePlate: onSubmitLicensePlate })=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    const [paymentStep] = (0, $19b60b7d89217ab4$export$2e2bcd8739ae039)();
    const GridAlertNoPayment = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
            container: true,
            size: {
                xs: 12,
                sm: 6
            },
            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                style: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: 20
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $d43dc7f92ddce118$export$2e2bcd8739ae039), {
                    licensePlate: licensePlate
                })
            })
        });
    };
    const GridSearchVehicle = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
            container: true,
            size: {
                xs: 12
            },
            direction: 'column',
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            rowSpacing: (0, $53be88aa100c8649$export$6039b89271c3de71).rowSpacing,
            children: /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                size: {
                    xs: 12,
                    sm: 6
                },
                container: true,
                style: {
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                rowSpacing: (0, $53be88aa100c8649$export$6039b89271c3de71).rowSpacing,
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $169a04a4f28c5fb1$export$2e2bcd8739ae039), {
                        formReference: formReference,
                        licensePlate: licensePlate,
                        onSubmit: onSubmitLicensePlate
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                        "aria-label": intl.formatMessage({
                            id: 'page.webPayment.stepFillLicensePlate.button.find'
                        }),
                        type: "submit",
                        form: formReference,
                        fullWidth: true,
                        color: "secondary",
                        style: {
                            height: '56px'
                        },
                        disabled: isButtonDisabled,
                        "data-testid": (0, $5cb825bac5cf2334$export$2e2bcd8739ae039).STEP_LICENSE_PLATE_SEARCH_BUTTON,
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                            id: "page.webPayment.stepFillLicensePlate.button.find"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
        size: 12,
        container: true,
        marginTop: (0, $53be88aa100c8649$export$6039b89271c3de71).elementSpacingMobile * 2,
        rowSpacing: (0, $53be88aa100c8649$export$6039b89271c3de71).rowSpacing,
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFillLicensePlate.info.pay"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFillLicensePlate.info.notPaid"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFillLicensePlate.info.licensePlate"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)(GridSearchVehicle, {}),
            paymentStep === 'FILL_LICENSE_PLATE_ERROR' && /*#__PURE__*/ (0, $e1vzu.jsx)(GridAlertNoPayment, {})
        ]
    });
};
var $e1cbeb8d7e2751bc$export$2e2bcd8739ae039 = $e1cbeb8d7e2751bc$var$StepFillLicensePlate;



var $e1vzu = parcelRequire("e1vzu");




var $e1vzu = parcelRequire("e1vzu");











const $6fb3e844d51d5d8a$var$Failure = ()=>{
    const [_currentPaymentStep, setCurrentPaymentStep] = (0, $19b60b7d89217ab4$export$2e2bcd8739ae039)();
    const theme = (0, $6a808f4d6e083741$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFinish.info.failure"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
                alignItems: "left",
                justifyContent: "left",
                margin: 2,
                textAlign: "left",
                children: /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $da123deb82412e15$export$2e2bcd8739ae039), {
                    severity: "error",
                    children: [
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $9783166253fe9251$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                id: "page.webPayment.stepFinish.failureInfo"
                            })
                        }),
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                            sx: {
                                paddingLeft: 2,
                                listStyleType: 'disc',
                                ...theme.typography.body1
                            },
                            children: [
                                1,
                                2,
                                3,
                                4,
                                5
                            ].map((n)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $d92c467eb64a79d5$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'list-item'
                                    },
                                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                        id: `page.webPayment.stepFinish.failureInfoList.item${n}`
                                    })
                                }, `failure-info-list-item-${n}`))
                        }),
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                id: "page.webPayment.stepFinish.failureInfoList.footer"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039).Link, {
                onClick: (event)=>{
                    event.preventDefault();
                    setCurrentPaymentStep((0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE);
                },
                bold: true,
                href: "#",
                showArrowBackward: true,
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFinish.button.tryAgain"
                })
            })
        ]
    });
};
var $6fb3e844d51d5d8a$export$2e2bcd8739ae039 = $6fb3e844d51d5d8a$var$Failure;



var $e1vzu = parcelRequire("e1vzu");






var $3QbnI = parcelRequire("3QbnI");

var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");

const $e8dd76247e9dc202$var$loadUserEmailFromSessionStorage = ()=>{
    return sessionStorage.getItem((0, $2732b3fe4895f686$export$e91329546f645e07)) ?? '';
};
const $e8dd76247e9dc202$var$saveuserEmailToSessionStorage = (userEmail)=>{
    sessionStorage.setItem((0, $2732b3fe4895f686$export$e91329546f645e07), userEmail);
};
const $e8dd76247e9dc202$export$1b9f047e14a01430 = /*#__PURE__*/ (0, $3QbnI.createContext)([
    '',
    (_)=>{}
]);
const $e8dd76247e9dc202$export$fdea2815ccb497e = ({ children: children })=>{
    const [userEmail, setUserEmail] = (0, $3QbnI.useState)($e8dd76247e9dc202$var$loadUserEmailFromSessionStorage());
    const setUserEmailStateAndSessionStorage = (newEmail)=>{
        $e8dd76247e9dc202$var$saveuserEmailToSessionStorage(newEmail);
        setUserEmail(newEmail);
    };
    const value = [
        userEmail,
        setUserEmailStateAndSessionStorage
    ];
    return /*#__PURE__*/ (0, $e1vzu.jsx)($e8dd76247e9dc202$export$1b9f047e14a01430.Provider, {
        value: value,
        children: children
    });
};


const $264779fcdde7e2fb$var$useUserEmail = ()=>{
    return (0, $3QbnI.useContext)((0, $e8dd76247e9dc202$export$1b9f047e14a01430));
};
var $264779fcdde7e2fb$export$2e2bcd8739ae039 = $264779fcdde7e2fb$var$useUserEmail;


const $5ea92f8c43dc7631$var$Success = ()=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    const [_currentPaymentStep, setCurrentPaymentStep] = (0, $19b60b7d89217ab4$export$2e2bcd8739ae039)();
    const [userEmail] = (0, $264779fcdde7e2fb$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFinish.info.success"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFinish.info.receipt",
                    values: {
                        email: userEmail
                    }
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039).Link, {
                onClick: (event)=>{
                    event.preventDefault();
                    setCurrentPaymentStep((0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE);
                },
                bold: true,
                href: "#",
                showArrowForward: true,
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFinish.button.newPayment"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039).Link, {
                href: intl.formatMessage({
                    id: 'facility.webpage.url'
                }),
                bold: true,
                showArrowForward: true,
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.stepFinish.backToFacilitySiteButtonText"
                })
            })
        ]
    });
};
var $5ea92f8c43dc7631$export$2e2bcd8739ae039 = $5ea92f8c43dc7631$var$Success;


const $b9e346de39611d09$var$StepFinish = ()=>{
    const [currentPaymentStep, _setCurrentPaymentStep] = (0, $19b60b7d89217ab4$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7961aabc05d182ef$export$2e2bcd8739ae039), {
            spacing: (0, $53be88aa100c8649$export$6039b89271c3de71).rowSpacing,
            direction: "column",
            alignItems: "center",
            marginTop: (0, $53be88aa100c8649$export$6039b89271c3de71).rowSpacing,
            children: currentPaymentStep === 'FINISH' ? /*#__PURE__*/ (0, $e1vzu.jsx)((0, $5ea92f8c43dc7631$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $e1vzu.jsx)((0, $6fb3e844d51d5d8a$export$2e2bcd8739ae039), {})
        })
    });
};
var $b9e346de39611d09$export$2e2bcd8739ae039 = $b9e346de39611d09$var$StepFinish;



var $e1vzu = parcelRequire("e1vzu");




var $3QbnI = parcelRequire("3QbnI");

// src/notifyManager.ts
function $b80c5091a3f57d21$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $b80c5091a3f57d21$export$520687f44db6e1ab = $b80c5091a3f57d21$export$316a8efd03cd1458();


// src/utils.ts
var $83dd1d9d9eb46358$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $83dd1d9d9eb46358$export$8793edee2d425525() {}
function $83dd1d9d9eb46358$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $83dd1d9d9eb46358$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $83dd1d9d9eb46358$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $83dd1d9d9eb46358$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $83dd1d9d9eb46358$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $83dd1d9d9eb46358$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $83dd1d9d9eb46358$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$83dd1d9d9eb46358$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $83dd1d9d9eb46358$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($83dd1d9d9eb46358$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $83dd1d9d9eb46358$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$83dd1d9d9eb46358$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $83dd1d9d9eb46358$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $83dd1d9d9eb46358$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $83dd1d9d9eb46358$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$83dd1d9d9eb46358$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $83dd1d9d9eb46358$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$83dd1d9d9eb46358$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $83dd1d9d9eb46358$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $83dd1d9d9eb46358$export$7a8558113332b71e(a) && $83dd1d9d9eb46358$export$7a8558113332b71e(b);
    if (array || $83dd1d9d9eb46358$export$53b83ca8eaab0383(a) && $83dd1d9d9eb46358$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $83dd1d9d9eb46358$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $83dd1d9d9eb46358$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $83dd1d9d9eb46358$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $83dd1d9d9eb46358$export$53b83ca8eaab0383(o) {
    if (!$83dd1d9d9eb46358$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$83dd1d9d9eb46358$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $83dd1d9d9eb46358$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $83dd1d9d9eb46358$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $83dd1d9d9eb46358$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $83dd1d9d9eb46358$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $83dd1d9d9eb46358$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $83dd1d9d9eb46358$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $83dd1d9d9eb46358$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $83dd1d9d9eb46358$export$1aa5a89531b7670d = Symbol();
function $83dd1d9d9eb46358$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $83dd1d9d9eb46358$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}



var $3QbnI = parcelRequire("3QbnI");

var $e1vzu = parcelRequire("e1vzu");
"use client";
var $f6e0a971d72905b7$export$da112d31b0149f31 = $3QbnI.createContext(void 0);
var $f6e0a971d72905b7$export$22e77b9572c4fded = (queryClient)=>{
    const client = $3QbnI.useContext($f6e0a971d72905b7$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $f6e0a971d72905b7$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $3QbnI.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $e1vzu.jsx)($f6e0a971d72905b7$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


"use client";
function $522ec8f0f7be08eb$export$32cc39cf62abf4fc(filters, queryClient) {
    const client = (0, $f6e0a971d72905b7$export$22e77b9572c4fded)(queryClient);
    return $522ec8f0f7be08eb$export$29ea95f3fea1dc1c({
        filters: {
            ...filters,
            status: "pending"
        }
    }, client).length;
}
function $522ec8f0f7be08eb$var$getResult(mutationCache, options) {
    return mutationCache.findAll(options.filters).map((mutation)=>options.select ? options.select(mutation) : mutation.state);
}
function $522ec8f0f7be08eb$export$29ea95f3fea1dc1c(options = {}, queryClient) {
    const mutationCache = (0, $f6e0a971d72905b7$export$22e77b9572c4fded)(queryClient).getMutationCache();
    const optionsRef = $3QbnI.useRef(options);
    const result = $3QbnI.useRef(null);
    if (!result.current) result.current = $522ec8f0f7be08eb$var$getResult(mutationCache, options);
    $3QbnI.useEffect(()=>{
        optionsRef.current = options;
    });
    return $3QbnI.useSyncExternalStore($3QbnI.useCallback((onStoreChange)=>mutationCache.subscribe(()=>{
            const nextResult = (0, $83dd1d9d9eb46358$export$77a71fc411098696)(result.current, $522ec8f0f7be08eb$var$getResult(mutationCache, optionsRef.current));
            if (result.current !== nextResult) {
                result.current = nextResult;
                (0, $b80c5091a3f57d21$export$520687f44db6e1ab).schedule(onStoreChange);
            }
        }), [
        mutationCache
    ]), ()=>result.current, ()=>result.current);
}


var $3QbnI = parcelRequire("3QbnI");
var $338be774a3ed77e3$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $338be774a3ed77e3$export$18a094aefa070634 = (obj, member, getter)=>{
    $338be774a3ed77e3$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $338be774a3ed77e3$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $338be774a3ed77e3$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $338be774a3ed77e3$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $338be774a3ed77e3$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $338be774a3ed77e3$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $338be774a3ed77e3$export$18a094aefa070634(obj, member, getter);
        }
    });
var $338be774a3ed77e3$export$fa92d15b718fce20 = (obj, member, method)=>{
    $338be774a3ed77e3$var$__accessCheck(obj, member, "access private method");
    return method;
};






var $5582451878673406$var$_gcTimeout;
var $5582451878673406$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5582451878673406$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $83dd1d9d9eb46358$export$e539f754e934e270)(this.gcTime)) (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5582451878673406$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $83dd1d9d9eb46358$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5582451878673406$var$_gcTimeout)) {
            clearTimeout((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5582451878673406$var$_gcTimeout));
            (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5582451878673406$var$_gcTimeout, void 0);
        }
    }
};
$5582451878673406$var$_gcTimeout = new WeakMap();





// src/subscribable.ts
var $bdb903fb62af5313$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $07e860d07ad11d97$var$_focused, $07e860d07ad11d97$var$_cleanup, $07e860d07ad11d97$var$_setup;
var $07e860d07ad11d97$export$86f1af424b2ca4de = class extends (0, $bdb903fb62af5313$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $07e860d07ad11d97$var$_focused, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $07e860d07ad11d97$var$_cleanup, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $07e860d07ad11d97$var$_setup, void 0);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $07e860d07ad11d97$var$_setup, (onFocus)=>{
            if (!(0, $83dd1d9d9eb46358$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $07e860d07ad11d97$var$_cleanup)) this.setEventListener((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $07e860d07ad11d97$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $07e860d07ad11d97$var$_cleanup)) == null || _a.call(this);
            (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $07e860d07ad11d97$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $07e860d07ad11d97$var$_setup, setup);
        (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $07e860d07ad11d97$var$_cleanup)) == null || _a.call(this);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $07e860d07ad11d97$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $07e860d07ad11d97$var$_focused) !== focused;
        if (changed) {
            (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $07e860d07ad11d97$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $07e860d07ad11d97$var$_focused) === "boolean") return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $07e860d07ad11d97$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$07e860d07ad11d97$var$_focused = new WeakMap();
$07e860d07ad11d97$var$_cleanup = new WeakMap();
$07e860d07ad11d97$var$_setup = new WeakMap();
var $07e860d07ad11d97$export$6bf54661be5b02cf = new $07e860d07ad11d97$export$86f1af424b2ca4de();





var $74b8cab575ff81f7$var$_online, $74b8cab575ff81f7$var$_cleanup, $74b8cab575ff81f7$var$_setup;
var $74b8cab575ff81f7$export$58774fb55d5ff7fc = class extends (0, $bdb903fb62af5313$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $74b8cab575ff81f7$var$_online, true);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $74b8cab575ff81f7$var$_cleanup, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $74b8cab575ff81f7$var$_setup, void 0);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $74b8cab575ff81f7$var$_setup, (onOnline)=>{
            if (!(0, $83dd1d9d9eb46358$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $74b8cab575ff81f7$var$_cleanup)) this.setEventListener((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $74b8cab575ff81f7$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $74b8cab575ff81f7$var$_cleanup)) == null || _a.call(this);
            (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $74b8cab575ff81f7$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $74b8cab575ff81f7$var$_setup, setup);
        (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $74b8cab575ff81f7$var$_cleanup)) == null || _a.call(this);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $74b8cab575ff81f7$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $74b8cab575ff81f7$var$_online) !== online;
        if (changed) {
            (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $74b8cab575ff81f7$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $74b8cab575ff81f7$var$_online);
    }
};
$74b8cab575ff81f7$var$_online = new WeakMap();
$74b8cab575ff81f7$var$_cleanup = new WeakMap();
$74b8cab575ff81f7$var$_setup = new WeakMap();
var $74b8cab575ff81f7$export$b113e788b2dd3fdc = new $74b8cab575ff81f7$export$58774fb55d5ff7fc();



// src/thenable.ts
function $e4fd2aef407060bb$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}



function $5f29fcf8f44eb575$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $5f29fcf8f44eb575$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $74b8cab575ff81f7$export$b113e788b2dd3fdc).isOnline() : true;
}
var $5f29fcf8f44eb575$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $5f29fcf8f44eb575$export$986cc6445c1d323(value) {
    return value instanceof $5f29fcf8f44eb575$export$a8430ed4188f35a9;
}
function $5f29fcf8f44eb575$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $e4fd2aef407060bb$export$d54630db02a12b72)();
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $5f29fcf8f44eb575$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $07e860d07ad11d97$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $74b8cab575ff81f7$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$5f29fcf8f44eb575$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $83dd1d9d9eb46358$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $5f29fcf8f44eb575$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $83dd1d9d9eb46358$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


var $ba51cfc10291f93f$var$_observers, $ba51cfc10291f93f$var$_mutationCache, $ba51cfc10291f93f$var$_retryer, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn;
var $ba51cfc10291f93f$export$17b8b19c814bcf56 = class extends (0, $5582451878673406$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $ba51cfc10291f93f$var$_dispatch);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $ba51cfc10291f93f$var$_observers, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $ba51cfc10291f93f$var$_mutationCache, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $ba51cfc10291f93f$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $ba51cfc10291f93f$var$_mutationCache, config.mutationCache);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $ba51cfc10291f93f$var$_observers, []);
        this.state = config.state || $ba51cfc10291f93f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_observers).includes(observer)) {
            (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $ba51cfc10291f93f$var$_observers, (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $ba51cfc10291f93f$var$_retryer, (0, $5f29fcf8f44eb575$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_retryer).canStart();
        try {
            if (!restored) {
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_retryer).start();
            await ((_f = (_e = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $ba51cfc10291f93f$var$_dispatch, $ba51cfc10291f93f$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).runNext(this);
        }
    }
};
$ba51cfc10291f93f$var$_observers = new WeakMap();
$ba51cfc10291f93f$var$_mutationCache = new WeakMap();
$ba51cfc10291f93f$var$_retryer = new WeakMap();
$ba51cfc10291f93f$var$_dispatch = new WeakSet();
$ba51cfc10291f93f$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $ba51cfc10291f93f$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $ba51cfc10291f93f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}





var $841801f25515435e$var$_client, $841801f25515435e$var$_currentResult, $841801f25515435e$var$_currentMutation, $841801f25515435e$var$_mutateOptions, $841801f25515435e$var$_updateResult, $841801f25515435e$var$updateResult_fn, $841801f25515435e$var$_notify, $841801f25515435e$var$notify_fn;
var $841801f25515435e$export$d3c1860ee66f291a = class extends (0, $bdb903fb62af5313$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $841801f25515435e$var$_updateResult);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $841801f25515435e$var$_notify);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $841801f25515435e$var$_client, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $841801f25515435e$var$_currentResult, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $841801f25515435e$var$_currentMutation, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $841801f25515435e$var$_mutateOptions, void 0);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $841801f25515435e$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $841801f25515435e$var$_updateResult, $841801f25515435e$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_client).defaultMutationOptions(options);
        if (!(0, $83dd1d9d9eb46358$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $83dd1d9d9eb46358$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $83dd1d9d9eb46358$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $841801f25515435e$var$_updateResult, $841801f25515435e$var$updateResult_fn).call(this);
        (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $841801f25515435e$var$_notify, $841801f25515435e$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $841801f25515435e$var$_currentMutation, void 0);
        (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $841801f25515435e$var$_updateResult, $841801f25515435e$var$updateResult_fn).call(this);
        (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $841801f25515435e$var$_notify, $841801f25515435e$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $841801f25515435e$var$_mutateOptions, options);
        (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $841801f25515435e$var$_currentMutation, (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_client).getMutationCache().build((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_client), this.options));
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation).addObserver(this);
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation).execute(variables);
    }
};
$841801f25515435e$var$_client = new WeakMap();
$841801f25515435e$var$_currentResult = new WeakMap();
$841801f25515435e$var$_currentMutation = new WeakMap();
$841801f25515435e$var$_mutateOptions = new WeakMap();
$841801f25515435e$var$_updateResult = new WeakSet();
$841801f25515435e$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $ba51cfc10291f93f$export$a1659b54bac3252a)();
    (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $841801f25515435e$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$841801f25515435e$var$_notify = new WeakSet();
$841801f25515435e$var$notify_fn = function(action) {
    (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentResult).variables;
            const context = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $841801f25515435e$var$_currentResult));
        });
    });
};



// src/utils.ts
function $432a7748b12b324a$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $432a7748b12b324a$export$8793edee2d425525() {}


"use client";
function $61d107a8eeadcf94$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $f6e0a971d72905b7$export$22e77b9572c4fded)(queryClient);
    const [observer] = $3QbnI.useState(()=>new (0, $841801f25515435e$export$d3c1860ee66f291a)(client, options));
    $3QbnI.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $3QbnI.useSyncExternalStore($3QbnI.useCallback((onStoreChange)=>observer.subscribe((0, $b80c5091a3f57d21$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $3QbnI.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $432a7748b12b324a$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $432a7748b12b324a$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



var $3QbnI = parcelRequire("3QbnI");


const $ef4c197593d1f0e8$var$apiUrl = `${(0, $87c980b245bbb7d9$export$c3ee1e672e1e24e7)}/v1`;
const $ef4c197593d1f0e8$var$createPaymentSession = (request)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${$ef4c197593d1f0e8$var$apiUrl}/pay`, request);
};
var $ef4c197593d1f0e8$export$2e2bcd8739ae039 = {
    createPaymentSession: $ef4c197593d1f0e8$var$createPaymentSession
};







var $e1vzu = parcelRequire("e1vzu");


var $4911b75302454952$exports = {};
'use strict';
Object.defineProperty($4911b75302454952$exports, '__esModule', {
    value: true
});
function $4911b75302454952$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4911b75302454952$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4911b75302454952$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4911b75302454952$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4911b75302454952$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4911b75302454952$var$_extends() {
    $4911b75302454952$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4911b75302454952$var$_extends.apply(this, arguments);
}
function $4911b75302454952$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $4911b75302454952$var$_setPrototypeOf(subClass, superClass);
}
function $4911b75302454952$var$_getPrototypeOf(o) {
    $4911b75302454952$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4911b75302454952$var$_getPrototypeOf(o);
}
function $4911b75302454952$var$_setPrototypeOf(o, p) {
    $4911b75302454952$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4911b75302454952$var$_setPrototypeOf(o, p);
}
function $4911b75302454952$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4911b75302454952$var$_construct(Parent, args, Class) {
    if ($4911b75302454952$var$_isNativeReflectConstruct()) $4911b75302454952$var$_construct = Reflect.construct.bind();
    else $4911b75302454952$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $4911b75302454952$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $4911b75302454952$var$_construct.apply(null, arguments);
}
function $4911b75302454952$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $4911b75302454952$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $4911b75302454952$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$4911b75302454952$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $4911b75302454952$var$_construct(Class, arguments, $4911b75302454952$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $4911b75302454952$var$_setPrototypeOf(Wrapper, Class);
    };
    return $4911b75302454952$var$_wrapNativeSuper(Class);
}
function $4911b75302454952$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4911b75302454952$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4911b75302454952$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4911b75302454952$var$_arrayLikeToArray(o, minLen);
}
function $4911b75302454952$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4911b75302454952$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4911b75302454952$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4911b75302454952$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4911b75302454952$var$_toPropertyKey(arg) {
    var key = $4911b75302454952$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $4911b75302454952$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $4911b75302454952$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $4911b75302454952$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $4911b75302454952$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $4911b75302454952$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($4911b75302454952$var$LuxonError);
/**
 * @private
 */ var $4911b75302454952$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $4911b75302454952$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($4911b75302454952$var$LuxonError);
/**
 * @private
 */ var $4911b75302454952$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $4911b75302454952$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($4911b75302454952$var$LuxonError);
/**
 * @private
 */ var $4911b75302454952$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $4911b75302454952$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($4911b75302454952$var$LuxonError);
/**
 * @private
 */ var $4911b75302454952$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $4911b75302454952$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($4911b75302454952$var$LuxonError);
/**
 * @private
 */ var $4911b75302454952$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $4911b75302454952$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($4911b75302454952$var$LuxonError);
/**
 * @private
 */ var $4911b75302454952$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $4911b75302454952$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($4911b75302454952$var$LuxonError);
/**
 * @private
 */ var $4911b75302454952$var$n = "numeric", $4911b75302454952$var$s = "short", $4911b75302454952$var$l = "long";
var $4911b75302454952$var$DATE_SHORT = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$n,
    day: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATE_MED = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$s,
    day: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATE_MED_WITH_WEEKDAY = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$s,
    day: $4911b75302454952$var$n,
    weekday: $4911b75302454952$var$s
};
var $4911b75302454952$var$DATE_FULL = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$l,
    day: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATE_HUGE = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$l,
    day: $4911b75302454952$var$n,
    weekday: $4911b75302454952$var$l
};
var $4911b75302454952$var$TIME_SIMPLE = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n
};
var $4911b75302454952$var$TIME_WITH_SECONDS = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n
};
var $4911b75302454952$var$TIME_WITH_SHORT_OFFSET = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n,
    timeZoneName: $4911b75302454952$var$s
};
var $4911b75302454952$var$TIME_WITH_LONG_OFFSET = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n,
    timeZoneName: $4911b75302454952$var$l
};
var $4911b75302454952$var$TIME_24_SIMPLE = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    hourCycle: "h23"
};
var $4911b75302454952$var$TIME_24_WITH_SECONDS = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n,
    hourCycle: "h23"
};
var $4911b75302454952$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n,
    hourCycle: "h23",
    timeZoneName: $4911b75302454952$var$s
};
var $4911b75302454952$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n,
    hourCycle: "h23",
    timeZoneName: $4911b75302454952$var$l
};
var $4911b75302454952$var$DATETIME_SHORT = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$n,
    day: $4911b75302454952$var$n,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$n,
    day: $4911b75302454952$var$n,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATETIME_MED = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$s,
    day: $4911b75302454952$var$n,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATETIME_MED_WITH_SECONDS = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$s,
    day: $4911b75302454952$var$n,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$s,
    day: $4911b75302454952$var$n,
    weekday: $4911b75302454952$var$s,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n
};
var $4911b75302454952$var$DATETIME_FULL = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$l,
    day: $4911b75302454952$var$n,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    timeZoneName: $4911b75302454952$var$s
};
var $4911b75302454952$var$DATETIME_FULL_WITH_SECONDS = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$l,
    day: $4911b75302454952$var$n,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n,
    timeZoneName: $4911b75302454952$var$s
};
var $4911b75302454952$var$DATETIME_HUGE = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$l,
    day: $4911b75302454952$var$n,
    weekday: $4911b75302454952$var$l,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    timeZoneName: $4911b75302454952$var$l
};
var $4911b75302454952$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $4911b75302454952$var$n,
    month: $4911b75302454952$var$l,
    day: $4911b75302454952$var$n,
    weekday: $4911b75302454952$var$l,
    hour: $4911b75302454952$var$n,
    minute: $4911b75302454952$var$n,
    second: $4911b75302454952$var$n,
    timeZoneName: $4911b75302454952$var$l
};
/**
 * @interface
 */ var $4911b75302454952$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $4911b75302454952$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $4911b75302454952$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $4911b75302454952$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $4911b75302454952$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $4911b75302454952$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $4911b75302454952$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $4911b75302454952$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $4911b75302454952$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $4911b75302454952$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $4911b75302454952$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $4911b75302454952$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $4911b75302454952$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $4911b75302454952$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $4911b75302454952$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $4911b75302454952$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($4911b75302454952$var$singleton$1 === null) $4911b75302454952$var$singleton$1 = new SystemZone();
                return $4911b75302454952$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($4911b75302454952$var$Zone);
var $4911b75302454952$var$dtfCache = {};
function $4911b75302454952$var$makeDTF(zone) {
    if (!$4911b75302454952$var$dtfCache[zone]) $4911b75302454952$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $4911b75302454952$var$dtfCache[zone];
}
var $4911b75302454952$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $4911b75302454952$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $4911b75302454952$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $4911b75302454952$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$4911b75302454952$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $4911b75302454952$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $4911b75302454952$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $4911b75302454952$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$4911b75302454952$var$ianaZoneCache[name]) $4911b75302454952$var$ianaZoneCache[name] = new IANAZone(name);
        return $4911b75302454952$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $4911b75302454952$var$ianaZoneCache = {};
        $4911b75302454952$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $4911b75302454952$var$parseZoneInfo(ts, format, locale, this.name);
    } /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $4911b75302454952$var$formatOffset(this.offset(ts), format);
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $4911b75302454952$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $4911b75302454952$var$partsOffset(dtf, date) : $4911b75302454952$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $4911b75302454952$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ ;
    $4911b75302454952$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($4911b75302454952$var$Zone);
var $4911b75302454952$var$_excluded = [
    "base"
], $4911b75302454952$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $4911b75302454952$var$intlLFCache = {};
function $4911b75302454952$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $4911b75302454952$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $4911b75302454952$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $4911b75302454952$var$intlDTCache = {};
function $4911b75302454952$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $4911b75302454952$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $4911b75302454952$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $4911b75302454952$var$intlNumCache = {};
function $4911b75302454952$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $4911b75302454952$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $4911b75302454952$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $4911b75302454952$var$intlRelCache = {};
function $4911b75302454952$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $4911b75302454952$var$_objectWithoutPropertiesLoose(_opts, $4911b75302454952$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $4911b75302454952$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $4911b75302454952$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $4911b75302454952$var$sysLocaleCache = null;
function $4911b75302454952$var$systemLocale() {
    if ($4911b75302454952$var$sysLocaleCache) return $4911b75302454952$var$sysLocaleCache;
    else {
        $4911b75302454952$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $4911b75302454952$var$sysLocaleCache;
    }
}
var $4911b75302454952$var$weekInfoCache = {};
function $4911b75302454952$var$getCachedWeekInfo(locString) {
    var data = $4911b75302454952$var$weekInfoCache[locString];
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        $4911b75302454952$var$weekInfoCache[locString] = data;
    }
    return data;
}
function $4911b75302454952$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $4911b75302454952$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $4911b75302454952$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $4911b75302454952$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $4911b75302454952$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $4911b75302454952$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $4911b75302454952$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $4911b75302454952$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $4911b75302454952$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $4911b75302454952$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $4911b75302454952$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $4911b75302454952$var$_objectWithoutPropertiesLoose(opts, $4911b75302454952$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $4911b75302454952$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $4911b75302454952$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $4911b75302454952$var$roundTo(i, 3);
            return $4911b75302454952$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $4911b75302454952$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $4911b75302454952$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $4911b75302454952$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $4911b75302454952$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $4911b75302454952$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $4911b75302454952$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $4911b75302454952$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $4911b75302454952$var$hasRelative()) this.rtf = $4911b75302454952$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $4911b75302454952$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $4911b75302454952$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $4911b75302454952$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $4911b75302454952$var$Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $4911b75302454952$var$systemLocale());
        var numberingSystemR = numberingSystem || $4911b75302454952$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $4911b75302454952$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $4911b75302454952$var$validateWeekSettings(weekSettings) || $4911b75302454952$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $4911b75302454952$var$sysLocaleCache = null;
        $4911b75302454952$var$intlDTCache = {};
        $4911b75302454952$var$intlNumCache = {};
        $4911b75302454952$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $4911b75302454952$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $4911b75302454952$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $4911b75302454952$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($4911b75302454952$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($4911b75302454952$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $4911b75302454952$var$listStuff(this, length, $4911b75302454952$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $4911b75302454952$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $4911b75302454952$var$listStuff(this, length, $4911b75302454952$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $4911b75302454952$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $4911b75302454952$var$listStuff(this, undefined, function() {
            return $4911b75302454952$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $4911b75302454952$var$DateTime.utc(2016, 11, 13, 9),
                    $4911b75302454952$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $4911b75302454952$var$listStuff(this, length, $4911b75302454952$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $4911b75302454952$var$DateTime.utc(-40, 1, 1),
                $4911b75302454952$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $4911b75302454952$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $4911b75302454952$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $4911b75302454952$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $4911b75302454952$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$4911b75302454952$var$hasLocaleWeekInfo()) return $4911b75302454952$var$fallbackWeekSettings;
        else return $4911b75302454952$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    $4911b75302454952$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $4911b75302454952$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $4911b75302454952$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $4911b75302454952$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $4911b75302454952$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($4911b75302454952$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    } /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $4911b75302454952$var$formatOffset(this.fixed, format);
    } /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ ;
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    } /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ ;
    $4911b75302454952$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $4911b75302454952$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $4911b75302454952$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($4911b75302454952$var$singleton === null) $4911b75302454952$var$singleton = new FixedOffsetZone(0);
                return $4911b75302454952$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($4911b75302454952$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $4911b75302454952$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $4911b75302454952$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $4911b75302454952$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($4911b75302454952$var$Zone);
/**
 * @private
 */ function $4911b75302454952$var$normalizeZone(input, defaultZone) {
    if ($4911b75302454952$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $4911b75302454952$var$Zone) return input;
    else if ($4911b75302454952$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $4911b75302454952$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $4911b75302454952$var$FixedOffsetZone.utcInstance;
        else return $4911b75302454952$var$FixedOffsetZone.parseSpecifier(lowered) || $4911b75302454952$var$IANAZone.create(input);
    } else if ($4911b75302454952$var$isNumber(input)) return $4911b75302454952$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $4911b75302454952$var$InvalidZone(input);
}
var $4911b75302454952$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $4911b75302454952$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $4911b75302454952$var$hanidecChars = $4911b75302454952$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $4911b75302454952$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($4911b75302454952$var$numberingSystems.hanidec) !== -1) value += $4911b75302454952$var$hanidecChars.indexOf(str[i]);
            else for(var key in $4911b75302454952$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $4911b75302454952$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var $4911b75302454952$var$digitRegexCache = {};
function $4911b75302454952$var$resetDigitRegexCache() {
    $4911b75302454952$var$digitRegexCache = {};
}
function $4911b75302454952$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    if (!$4911b75302454952$var$digitRegexCache[ns]) $4911b75302454952$var$digitRegexCache[ns] = {};
    if (!$4911b75302454952$var$digitRegexCache[ns][append]) $4911b75302454952$var$digitRegexCache[ns][append] = new RegExp("" + $4911b75302454952$var$numberingSystems[ns] + append);
    return $4911b75302454952$var$digitRegexCache[ns][append];
}
var $4911b75302454952$var$now = function now() {
    return Date.now();
}, $4911b75302454952$var$defaultZone = "system", $4911b75302454952$var$defaultLocale = null, $4911b75302454952$var$defaultNumberingSystem = null, $4911b75302454952$var$defaultOutputCalendar = null, $4911b75302454952$var$twoDigitCutoffYear = 60, $4911b75302454952$var$throwOnInvalid, $4911b75302454952$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $4911b75302454952$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $4911b75302454952$var$Locale.resetCache();
        $4911b75302454952$var$IANAZone.resetCache();
        $4911b75302454952$var$DateTime.resetCache();
        $4911b75302454952$var$resetDigitRegexCache();
    };
    $4911b75302454952$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $4911b75302454952$var$now;
            },
            set: function set(n) {
                $4911b75302454952$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $4911b75302454952$var$normalizeZone($4911b75302454952$var$defaultZone, $4911b75302454952$var$SystemZone.instance);
            },
            set: function set(zone) {
                $4911b75302454952$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $4911b75302454952$var$defaultLocale;
            },
            set: function set(locale) {
                $4911b75302454952$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $4911b75302454952$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $4911b75302454952$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $4911b75302454952$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $4911b75302454952$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $4911b75302454952$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $4911b75302454952$var$defaultWeekSettings = $4911b75302454952$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $4911b75302454952$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $4911b75302454952$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $4911b75302454952$var$throwOnInvalid;
            },
            set: function set(t) {
                $4911b75302454952$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $4911b75302454952$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $4911b75302454952$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $4911b75302454952$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $4911b75302454952$var$unitOutOfRange(unit, value) {
    return new $4911b75302454952$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $4911b75302454952$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $4911b75302454952$var$computeOrdinal(year, month, day) {
    return day + ($4911b75302454952$var$isLeapYear(year) ? $4911b75302454952$var$leapLadder : $4911b75302454952$var$nonLeapLadder)[month - 1];
}
function $4911b75302454952$var$uncomputeOrdinal(year, ordinal) {
    var table = $4911b75302454952$var$isLeapYear(year) ? $4911b75302454952$var$leapLadder : $4911b75302454952$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $4911b75302454952$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $4911b75302454952$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $4911b75302454952$var$computeOrdinal(year, month, day), weekday = $4911b75302454952$var$isoWeekdayToLocal($4911b75302454952$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $4911b75302454952$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $4911b75302454952$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $4911b75302454952$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $4911b75302454952$var$timeObject(gregObj));
}
function $4911b75302454952$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $4911b75302454952$var$isoWeekdayToLocal($4911b75302454952$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $4911b75302454952$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $4911b75302454952$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $4911b75302454952$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $4911b75302454952$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $4911b75302454952$var$_extends({
        year: year,
        month: month,
        day: day
    }, $4911b75302454952$var$timeObject(weekData));
}
function $4911b75302454952$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $4911b75302454952$var$computeOrdinal(year, month, day);
    return $4911b75302454952$var$_extends({
        year: year,
        ordinal: ordinal
    }, $4911b75302454952$var$timeObject(gregData));
}
function $4911b75302454952$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $4911b75302454952$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $4911b75302454952$var$_extends({
        year: year,
        month: month,
        day: day
    }, $4911b75302454952$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $4911b75302454952$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$4911b75302454952$var$isUndefined(obj.localWeekday) || !$4911b75302454952$var$isUndefined(obj.localWeekNumber) || !$4911b75302454952$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$4911b75302454952$var$isUndefined(obj.weekday) || !$4911b75302454952$var$isUndefined(obj.weekNumber) || !$4911b75302454952$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $4911b75302454952$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$4911b75302454952$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$4911b75302454952$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$4911b75302454952$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $4911b75302454952$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $4911b75302454952$var$isInteger(obj.weekYear), validWeek = $4911b75302454952$var$integerBetween(obj.weekNumber, 1, $4911b75302454952$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $4911b75302454952$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $4911b75302454952$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $4911b75302454952$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $4911b75302454952$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $4911b75302454952$var$hasInvalidOrdinalData(obj) {
    var validYear = $4911b75302454952$var$isInteger(obj.year), validOrdinal = $4911b75302454952$var$integerBetween(obj.ordinal, 1, $4911b75302454952$var$daysInYear(obj.year));
    if (!validYear) return $4911b75302454952$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $4911b75302454952$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $4911b75302454952$var$hasInvalidGregorianData(obj) {
    var validYear = $4911b75302454952$var$isInteger(obj.year), validMonth = $4911b75302454952$var$integerBetween(obj.month, 1, 12), validDay = $4911b75302454952$var$integerBetween(obj.day, 1, $4911b75302454952$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $4911b75302454952$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $4911b75302454952$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $4911b75302454952$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $4911b75302454952$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $4911b75302454952$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $4911b75302454952$var$integerBetween(minute, 0, 59), validSecond = $4911b75302454952$var$integerBetween(second, 0, 59), validMillisecond = $4911b75302454952$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $4911b75302454952$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $4911b75302454952$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $4911b75302454952$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $4911b75302454952$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $4911b75302454952$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $4911b75302454952$var$isNumber(o) {
    return typeof o === "number";
}
function $4911b75302454952$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $4911b75302454952$var$isString(o) {
    return typeof o === "string";
}
function $4911b75302454952$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $4911b75302454952$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $4911b75302454952$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $4911b75302454952$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $4911b75302454952$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $4911b75302454952$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $4911b75302454952$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $4911b75302454952$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $4911b75302454952$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$4911b75302454952$var$integerBetween(settings.firstDay, 1, 7) || !$4911b75302454952$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$4911b75302454952$var$integerBetween(v, 1, 7);
        })) throw new $4911b75302454952$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $4911b75302454952$var$integerBetween(thing, bottom, top) {
    return $4911b75302454952$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $4911b75302454952$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $4911b75302454952$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $4911b75302454952$var$parseInteger(string) {
    if ($4911b75302454952$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $4911b75302454952$var$parseFloating(string) {
    if ($4911b75302454952$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $4911b75302454952$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($4911b75302454952$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $4911b75302454952$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $4911b75302454952$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $4911b75302454952$var$daysInYear(year) {
    return $4911b75302454952$var$isLeapYear(year) ? 366 : 365;
}
function $4911b75302454952$var$daysInMonth(year, month) {
    var modMonth = $4911b75302454952$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $4911b75302454952$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $4911b75302454952$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $4911b75302454952$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $4911b75302454952$var$isoWeekdayToLocal($4911b75302454952$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $4911b75302454952$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $4911b75302454952$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $4911b75302454952$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($4911b75302454952$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $4911b75302454952$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $4911b75302454952$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $4911b75302454952$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $4911b75302454952$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $4911b75302454952$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $4911b75302454952$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $4911b75302454952$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $4911b75302454952$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($4911b75302454952$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $4911b75302454952$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $4911b75302454952$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $4911b75302454952$var$padStart(hours, 2) + ":" + $4911b75302454952$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $4911b75302454952$var$padStart(hours, 2) + $4911b75302454952$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $4911b75302454952$var$timeObject(obj) {
    return $4911b75302454952$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $4911b75302454952$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $4911b75302454952$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $4911b75302454952$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $4911b75302454952$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($4911b75302454952$var$monthsNarrow);
        case "short":
            return [].concat($4911b75302454952$var$monthsShort);
        case "long":
            return [].concat($4911b75302454952$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $4911b75302454952$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $4911b75302454952$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $4911b75302454952$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $4911b75302454952$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($4911b75302454952$var$weekdaysNarrow);
        case "short":
            return [].concat($4911b75302454952$var$weekdaysShort);
        case "long":
            return [].concat($4911b75302454952$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $4911b75302454952$var$meridiems = [
    "AM",
    "PM"
];
var $4911b75302454952$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $4911b75302454952$var$erasShort = [
    "BC",
    "AD"
];
var $4911b75302454952$var$erasNarrow = [
    "B",
    "A"
];
function $4911b75302454952$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($4911b75302454952$var$erasNarrow);
        case "short":
            return [].concat($4911b75302454952$var$erasShort);
        case "long":
            return [].concat($4911b75302454952$var$erasLong);
        default:
            return null;
    }
}
function $4911b75302454952$var$meridiemForDateTime(dt) {
    return $4911b75302454952$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $4911b75302454952$var$weekdayForDateTime(dt, length) {
    return $4911b75302454952$var$weekdays(length)[dt.weekday - 1];
}
function $4911b75302454952$var$monthForDateTime(dt, length) {
    return $4911b75302454952$var$months(length)[dt.month - 1];
}
function $4911b75302454952$var$eraForDateTime(dt, length) {
    return $4911b75302454952$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $4911b75302454952$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $4911b75302454952$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $4911b75302454952$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $4911b75302454952$var$_macroTokenToFormatOpts = {
    D: $4911b75302454952$var$DATE_SHORT,
    DD: $4911b75302454952$var$DATE_MED,
    DDD: $4911b75302454952$var$DATE_FULL,
    DDDD: $4911b75302454952$var$DATE_HUGE,
    t: $4911b75302454952$var$TIME_SIMPLE,
    tt: $4911b75302454952$var$TIME_WITH_SECONDS,
    ttt: $4911b75302454952$var$TIME_WITH_SHORT_OFFSET,
    tttt: $4911b75302454952$var$TIME_WITH_LONG_OFFSET,
    T: $4911b75302454952$var$TIME_24_SIMPLE,
    TT: $4911b75302454952$var$TIME_24_WITH_SECONDS,
    TTT: $4911b75302454952$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $4911b75302454952$var$TIME_24_WITH_LONG_OFFSET,
    f: $4911b75302454952$var$DATETIME_SHORT,
    ff: $4911b75302454952$var$DATETIME_MED,
    fff: $4911b75302454952$var$DATETIME_FULL,
    ffff: $4911b75302454952$var$DATETIME_HUGE,
    F: $4911b75302454952$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $4911b75302454952$var$DATETIME_MED_WITH_SECONDS,
    FFF: $4911b75302454952$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $4911b75302454952$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $4911b75302454952$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $4911b75302454952$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $4911b75302454952$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $4911b75302454952$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $4911b75302454952$var$padStart(n, p);
        var opts = $4911b75302454952$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $4911b75302454952$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $4911b75302454952$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $4911b75302454952$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $4911b75302454952$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $4911b75302454952$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $4911b75302454952$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $4911b75302454952$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $4911b75302454952$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $4911b75302454952$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $4911b75302454952$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $4911b75302454952$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $4911b75302454952$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $4911b75302454952$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $4911b75302454952$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $4911b75302454952$var$isoExtendedZone = "(?:" + $4911b75302454952$var$offsetRegex.source + "?(?:\\[(" + $4911b75302454952$var$ianaRegex.source + ")\\])?)?";
var $4911b75302454952$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $4911b75302454952$var$isoTimeRegex = RegExp("" + $4911b75302454952$var$isoTimeBaseRegex.source + $4911b75302454952$var$isoExtendedZone);
var $4911b75302454952$var$isoTimeExtensionRegex = RegExp("(?:T" + $4911b75302454952$var$isoTimeRegex.source + ")?");
var $4911b75302454952$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $4911b75302454952$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $4911b75302454952$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $4911b75302454952$var$extractISOWeekData = $4911b75302454952$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $4911b75302454952$var$extractISOOrdinalData = $4911b75302454952$var$simpleParse("year", "ordinal");
var $4911b75302454952$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $4911b75302454952$var$sqlTimeRegex = RegExp($4911b75302454952$var$isoTimeBaseRegex.source + " ?(?:" + $4911b75302454952$var$offsetRegex.source + "|(" + $4911b75302454952$var$ianaRegex.source + "))?");
var $4911b75302454952$var$sqlTimeExtensionRegex = RegExp("(?: " + $4911b75302454952$var$sqlTimeRegex.source + ")?");
function $4911b75302454952$var$int(match, pos, fallback) {
    var m = match[pos];
    return $4911b75302454952$var$isUndefined(m) ? fallback : $4911b75302454952$var$parseInteger(m);
}
function $4911b75302454952$var$extractISOYmd(match, cursor) {
    var item = {
        year: $4911b75302454952$var$int(match, cursor),
        month: $4911b75302454952$var$int(match, cursor + 1, 1),
        day: $4911b75302454952$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $4911b75302454952$var$extractISOTime(match, cursor) {
    var item = {
        hours: $4911b75302454952$var$int(match, cursor, 0),
        minutes: $4911b75302454952$var$int(match, cursor + 1, 0),
        seconds: $4911b75302454952$var$int(match, cursor + 2, 0),
        milliseconds: $4911b75302454952$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $4911b75302454952$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $4911b75302454952$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $4911b75302454952$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $4911b75302454952$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $4911b75302454952$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $4911b75302454952$var$isoTimeOnly = RegExp("^T?" + $4911b75302454952$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $4911b75302454952$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $4911b75302454952$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($4911b75302454952$var$parseFloating(yearStr)),
            months: maybeNegate($4911b75302454952$var$parseFloating(monthStr)),
            weeks: maybeNegate($4911b75302454952$var$parseFloating(weekStr)),
            days: maybeNegate($4911b75302454952$var$parseFloating(dayStr)),
            hours: maybeNegate($4911b75302454952$var$parseFloating(hourStr)),
            minutes: maybeNegate($4911b75302454952$var$parseFloating(minuteStr)),
            seconds: maybeNegate($4911b75302454952$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($4911b75302454952$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $4911b75302454952$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $4911b75302454952$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $4911b75302454952$var$untruncateYear($4911b75302454952$var$parseInteger(yearStr)) : $4911b75302454952$var$parseInteger(yearStr),
        month: $4911b75302454952$var$monthsShort.indexOf(monthStr) + 1,
        day: $4911b75302454952$var$parseInteger(dayStr),
        hour: $4911b75302454952$var$parseInteger(hourStr),
        minute: $4911b75302454952$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $4911b75302454952$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $4911b75302454952$var$weekdaysLong.indexOf(weekdayStr) + 1 : $4911b75302454952$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $4911b75302454952$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $4911b75302454952$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $4911b75302454952$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $4911b75302454952$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $4911b75302454952$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $4911b75302454952$var$FixedOffsetZone(offset)
    ];
}
function $4911b75302454952$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $4911b75302454952$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $4911b75302454952$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $4911b75302454952$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $4911b75302454952$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $4911b75302454952$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $4911b75302454952$var$FixedOffsetZone.utcInstance
    ];
}
function $4911b75302454952$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $4911b75302454952$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $4911b75302454952$var$FixedOffsetZone.utcInstance
    ];
}
var $4911b75302454952$var$isoYmdWithTimeExtensionRegex = $4911b75302454952$var$combineRegexes($4911b75302454952$var$isoYmdRegex, $4911b75302454952$var$isoTimeExtensionRegex);
var $4911b75302454952$var$isoWeekWithTimeExtensionRegex = $4911b75302454952$var$combineRegexes($4911b75302454952$var$isoWeekRegex, $4911b75302454952$var$isoTimeExtensionRegex);
var $4911b75302454952$var$isoOrdinalWithTimeExtensionRegex = $4911b75302454952$var$combineRegexes($4911b75302454952$var$isoOrdinalRegex, $4911b75302454952$var$isoTimeExtensionRegex);
var $4911b75302454952$var$isoTimeCombinedRegex = $4911b75302454952$var$combineRegexes($4911b75302454952$var$isoTimeRegex);
var $4911b75302454952$var$extractISOYmdTimeAndOffset = $4911b75302454952$var$combineExtractors($4911b75302454952$var$extractISOYmd, $4911b75302454952$var$extractISOTime, $4911b75302454952$var$extractISOOffset, $4911b75302454952$var$extractIANAZone);
var $4911b75302454952$var$extractISOWeekTimeAndOffset = $4911b75302454952$var$combineExtractors($4911b75302454952$var$extractISOWeekData, $4911b75302454952$var$extractISOTime, $4911b75302454952$var$extractISOOffset, $4911b75302454952$var$extractIANAZone);
var $4911b75302454952$var$extractISOOrdinalDateAndTime = $4911b75302454952$var$combineExtractors($4911b75302454952$var$extractISOOrdinalData, $4911b75302454952$var$extractISOTime, $4911b75302454952$var$extractISOOffset, $4911b75302454952$var$extractIANAZone);
var $4911b75302454952$var$extractISOTimeAndOffset = $4911b75302454952$var$combineExtractors($4911b75302454952$var$extractISOTime, $4911b75302454952$var$extractISOOffset, $4911b75302454952$var$extractIANAZone);
/*
 * @private
 */ function $4911b75302454952$var$parseISODate(s) {
    return $4911b75302454952$var$parse(s, [
        $4911b75302454952$var$isoYmdWithTimeExtensionRegex,
        $4911b75302454952$var$extractISOYmdTimeAndOffset
    ], [
        $4911b75302454952$var$isoWeekWithTimeExtensionRegex,
        $4911b75302454952$var$extractISOWeekTimeAndOffset
    ], [
        $4911b75302454952$var$isoOrdinalWithTimeExtensionRegex,
        $4911b75302454952$var$extractISOOrdinalDateAndTime
    ], [
        $4911b75302454952$var$isoTimeCombinedRegex,
        $4911b75302454952$var$extractISOTimeAndOffset
    ]);
}
function $4911b75302454952$var$parseRFC2822Date(s) {
    return $4911b75302454952$var$parse($4911b75302454952$var$preprocessRFC2822(s), [
        $4911b75302454952$var$rfc2822,
        $4911b75302454952$var$extractRFC2822
    ]);
}
function $4911b75302454952$var$parseHTTPDate(s) {
    return $4911b75302454952$var$parse(s, [
        $4911b75302454952$var$rfc1123,
        $4911b75302454952$var$extractRFC1123Or850
    ], [
        $4911b75302454952$var$rfc850,
        $4911b75302454952$var$extractRFC1123Or850
    ], [
        $4911b75302454952$var$ascii,
        $4911b75302454952$var$extractASCII
    ]);
}
function $4911b75302454952$var$parseISODuration(s) {
    return $4911b75302454952$var$parse(s, [
        $4911b75302454952$var$isoDuration,
        $4911b75302454952$var$extractISODuration
    ]);
}
var $4911b75302454952$var$extractISOTimeOnly = $4911b75302454952$var$combineExtractors($4911b75302454952$var$extractISOTime);
function $4911b75302454952$var$parseISOTimeOnly(s) {
    return $4911b75302454952$var$parse(s, [
        $4911b75302454952$var$isoTimeOnly,
        $4911b75302454952$var$extractISOTimeOnly
    ]);
}
var $4911b75302454952$var$sqlYmdWithTimeExtensionRegex = $4911b75302454952$var$combineRegexes($4911b75302454952$var$sqlYmdRegex, $4911b75302454952$var$sqlTimeExtensionRegex);
var $4911b75302454952$var$sqlTimeCombinedRegex = $4911b75302454952$var$combineRegexes($4911b75302454952$var$sqlTimeRegex);
var $4911b75302454952$var$extractISOTimeOffsetAndIANAZone = $4911b75302454952$var$combineExtractors($4911b75302454952$var$extractISOTime, $4911b75302454952$var$extractISOOffset, $4911b75302454952$var$extractIANAZone);
function $4911b75302454952$var$parseSQL(s) {
    return $4911b75302454952$var$parse(s, [
        $4911b75302454952$var$sqlYmdWithTimeExtensionRegex,
        $4911b75302454952$var$extractISOYmdTimeAndOffset
    ], [
        $4911b75302454952$var$sqlTimeCombinedRegex,
        $4911b75302454952$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $4911b75302454952$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $4911b75302454952$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $4911b75302454952$var$casualMatrix = $4911b75302454952$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $4911b75302454952$var$lowOrderMatrix), $4911b75302454952$var$daysInYearAccurate = 365.2425, $4911b75302454952$var$daysInMonthAccurate = 30.436875, $4911b75302454952$var$accurateMatrix = $4911b75302454952$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $4911b75302454952$var$daysInYearAccurate / 7,
        days: $4911b75302454952$var$daysInYearAccurate,
        hours: $4911b75302454952$var$daysInYearAccurate * 24,
        minutes: $4911b75302454952$var$daysInYearAccurate * 1440,
        seconds: $4911b75302454952$var$daysInYearAccurate * 86400,
        milliseconds: $4911b75302454952$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $4911b75302454952$var$daysInYearAccurate / 28,
        days: $4911b75302454952$var$daysInYearAccurate / 4,
        hours: $4911b75302454952$var$daysInYearAccurate * 24 / 4,
        minutes: $4911b75302454952$var$daysInYearAccurate * 1440 / 4,
        seconds: $4911b75302454952$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $4911b75302454952$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $4911b75302454952$var$daysInMonthAccurate / 7,
        days: $4911b75302454952$var$daysInMonthAccurate,
        hours: $4911b75302454952$var$daysInMonthAccurate * 24,
        minutes: $4911b75302454952$var$daysInMonthAccurate * 1440,
        seconds: $4911b75302454952$var$daysInMonthAccurate * 86400,
        milliseconds: $4911b75302454952$var$daysInMonthAccurate * 86400000
    }
}, $4911b75302454952$var$lowOrderMatrix);
// units ordered by size
var $4911b75302454952$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $4911b75302454952$var$reverseUnits = $4911b75302454952$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $4911b75302454952$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $4911b75302454952$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $4911b75302454952$var$Duration(conf);
}
function $4911b75302454952$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $4911b75302454952$var$_createForOfIteratorHelperLoose($4911b75302454952$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $4911b75302454952$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $4911b75302454952$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $4911b75302454952$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$4911b75302454952$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $4911b75302454952$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$4911b75302454952$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $4911b75302454952$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $4911b75302454952$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $4911b75302454952$var$accurateMatrix : $4911b75302454952$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $4911b75302454952$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $4911b75302454952$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $4911b75302454952$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $4911b75302454952$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($4911b75302454952$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $4911b75302454952$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $4911b75302454952$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $4911b75302454952$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $4911b75302454952$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $4911b75302454952$var$Invalid ? reason : new $4911b75302454952$var$Invalid(reason, explanation);
        if ($4911b75302454952$var$Settings.throwOnInvalid) throw new $4911b75302454952$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $4911b75302454952$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $4911b75302454952$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $4911b75302454952$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $4911b75302454952$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $4911b75302454952$var$INVALID$2;
        var l = $4911b75302454952$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($4911b75302454952$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($4911b75302454952$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($4911b75302454952$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $4911b75302454952$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $4911b75302454952$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $4911b75302454952$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $4911b75302454952$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $4911b75302454952$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $4911b75302454952$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($4911b75302454952$var$hasOwnProperty(dur.values, k) || $4911b75302454952$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $4911b75302454952$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $4911b75302454952$var$asNumber(fn(this.values[k], k));
        }
        return $4911b75302454952$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $4911b75302454952$var$_extends({}, this.values, $4911b75302454952$var$normalizeObject(values, Duration.normalizeUnit));
        return $4911b75302454952$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $4911b75302454952$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $4911b75302454952$var$normalizeValues(this.matrix, vals);
        return $4911b75302454952$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $4911b75302454952$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $4911b75302454952$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $4911b75302454952$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($4911b75302454952$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($4911b75302454952$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $4911b75302454952$var$normalizeValues(this.matrix, built);
        return $4911b75302454952$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $4911b75302454952$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $4911b75302454952$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $4911b75302454952$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $4911b75302454952$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $4911b75302454952$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $4911b75302454952$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $4911b75302454952$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $4911b75302454952$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $4911b75302454952$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $4911b75302454952$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $4911b75302454952$var$Invalid ? reason : new $4911b75302454952$var$Invalid(reason, explanation);
        if ($4911b75302454952$var$Settings.throwOnInvalid) throw new $4911b75302454952$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $4911b75302454952$var$friendlyDateTime(start), builtEnd = $4911b75302454952$var$friendlyDateTime(end);
        var validateError = $4911b75302454952$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $4911b75302454952$var$Duration.fromDurationLike(duration), dt = $4911b75302454952$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $4911b75302454952$var$Duration.fromDurationLike(duration), dt = $4911b75302454952$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $4911b75302454952$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $4911b75302454952$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $4911b75302454952$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $4911b75302454952$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ ;
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($4911b75302454952$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $4911b75302454952$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $4911b75302454952$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $4911b75302454952$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $4911b75302454952$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $4911b75302454952$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $4911b75302454952$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $4911b75302454952$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $4911b75302454952$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $4911b75302454952$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $4911b75302454952$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $4911b75302454952$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $4911b75302454952$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $4911b75302454952$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $4911b75302454952$var$Settings.defaultZone;
        var proto = $4911b75302454952$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $4911b75302454952$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $4911b75302454952$var$normalizeZone(input, $4911b75302454952$var$Settings.defaultZone);
    } /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ ;
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $4911b75302454952$var$Locale.create(locale)).getStartOfWeek();
    } /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ ;
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $4911b75302454952$var$Locale.create(locale)).getMinDaysInFirstWeek();
    } /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ ;
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $4911b75302454952$var$Locale.create(locale)).getWeekendDays().slice();
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $4911b75302454952$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $4911b75302454952$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $4911b75302454952$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $4911b75302454952$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $4911b75302454952$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $4911b75302454952$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $4911b75302454952$var$hasRelative(),
            localeWeek: $4911b75302454952$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $4911b75302454952$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($4911b75302454952$var$Duration.fromMillis(ms).as("days"));
}
function $4911b75302454952$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $4911b75302454952$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $4911b75302454952$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $4911b75302454952$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $4911b75302454952$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $4911b75302454952$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $4911b75302454952$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $4911b75302454952$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $4911b75302454952$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($4911b75302454952$var$parseDigits(s));
        }
    };
}
var $4911b75302454952$var$NBSP = String.fromCharCode(160);
var $4911b75302454952$var$spaceOrNBSP = "[ " + $4911b75302454952$var$NBSP + "]";
var $4911b75302454952$var$spaceOrNBSPRegExp = new RegExp($4911b75302454952$var$spaceOrNBSP, "g");
function $4911b75302454952$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($4911b75302454952$var$spaceOrNBSPRegExp, $4911b75302454952$var$spaceOrNBSP);
}
function $4911b75302454952$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($4911b75302454952$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $4911b75302454952$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($4911b75302454952$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $4911b75302454952$var$stripInsensitivities(s) === $4911b75302454952$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $4911b75302454952$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $4911b75302454952$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $4911b75302454952$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $4911b75302454952$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $4911b75302454952$var$unitForToken(token, loc) {
    var one = $4911b75302454952$var$digitRegex(loc), two = $4911b75302454952$var$digitRegex(loc, "{2}"), three = $4911b75302454952$var$digitRegex(loc, "{3}"), four = $4911b75302454952$var$digitRegex(loc, "{4}"), six = $4911b75302454952$var$digitRegex(loc, "{6}"), oneOrTwo = $4911b75302454952$var$digitRegex(loc, "{1,2}"), oneToThree = $4911b75302454952$var$digitRegex(loc, "{1,3}"), oneToSix = $4911b75302454952$var$digitRegex(loc, "{1,6}"), oneToNine = $4911b75302454952$var$digitRegex(loc, "{1,9}"), twoToFour = $4911b75302454952$var$digitRegex(loc, "{2,4}"), fourToSix = $4911b75302454952$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($4911b75302454952$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $4911b75302454952$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $4911b75302454952$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $4911b75302454952$var$intUnit(oneToSix);
            case "yy":
                return $4911b75302454952$var$intUnit(twoToFour, $4911b75302454952$var$untruncateYear);
            case "yyyy":
                return $4911b75302454952$var$intUnit(four);
            case "yyyyy":
                return $4911b75302454952$var$intUnit(fourToSix);
            case "yyyyyy":
                return $4911b75302454952$var$intUnit(six);
            // months
            case "M":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "MM":
                return $4911b75302454952$var$intUnit(two);
            case "MMM":
                return $4911b75302454952$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $4911b75302454952$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "LL":
                return $4911b75302454952$var$intUnit(two);
            case "LLL":
                return $4911b75302454952$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $4911b75302454952$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "dd":
                return $4911b75302454952$var$intUnit(two);
            // ordinals
            case "o":
                return $4911b75302454952$var$intUnit(oneToThree);
            case "ooo":
                return $4911b75302454952$var$intUnit(three);
            // time
            case "HH":
                return $4911b75302454952$var$intUnit(two);
            case "H":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "hh":
                return $4911b75302454952$var$intUnit(two);
            case "h":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "mm":
                return $4911b75302454952$var$intUnit(two);
            case "m":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "q":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "qq":
                return $4911b75302454952$var$intUnit(two);
            case "s":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "ss":
                return $4911b75302454952$var$intUnit(two);
            case "S":
                return $4911b75302454952$var$intUnit(oneToThree);
            case "SSS":
                return $4911b75302454952$var$intUnit(three);
            case "u":
                return $4911b75302454952$var$simple(oneToNine);
            case "uu":
                return $4911b75302454952$var$simple(oneOrTwo);
            case "uuu":
                return $4911b75302454952$var$intUnit(one);
            // meridiem
            case "a":
                return $4911b75302454952$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $4911b75302454952$var$intUnit(four);
            case "kk":
                return $4911b75302454952$var$intUnit(twoToFour, $4911b75302454952$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $4911b75302454952$var$intUnit(oneOrTwo);
            case "WW":
                return $4911b75302454952$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $4911b75302454952$var$intUnit(one);
            case "EEE":
                return $4911b75302454952$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $4911b75302454952$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $4911b75302454952$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $4911b75302454952$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $4911b75302454952$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $4911b75302454952$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $4911b75302454952$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $4911b75302454952$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $4911b75302454952$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $4911b75302454952$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $4911b75302454952$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $4911b75302454952$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $4911b75302454952$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $4911b75302454952$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($4911b75302454952$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $4911b75302454952$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$4911b75302454952$var$isUndefined(matches.z)) zone = $4911b75302454952$var$IANAZone.create(matches.z);
    if (!$4911b75302454952$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $4911b75302454952$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$4911b75302454952$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$4911b75302454952$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$4911b75302454952$var$isUndefined(matches.u)) matches.S = $4911b75302454952$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $4911b75302454952$var$dummyDateTimeCache = null;
function $4911b75302454952$var$getDummyDateTime() {
    if (!$4911b75302454952$var$dummyDateTimeCache) $4911b75302454952$var$dummyDateTimeCache = $4911b75302454952$var$DateTime.fromMillis(1555555555555);
    return $4911b75302454952$var$dummyDateTimeCache;
}
function $4911b75302454952$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $4911b75302454952$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $4911b75302454952$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $4911b75302454952$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $4911b75302454952$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var $4911b75302454952$var$TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = $4911b75302454952$var$expandMacroTokens($4911b75302454952$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return $4911b75302454952$var$unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = $4911b75302454952$var$buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = $4911b75302454952$var$match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $4911b75302454952$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if ($4911b75302454952$var$hasOwnProperty(matches, "a") && $4911b75302454952$var$hasOwnProperty(matches, "H")) throw new $4911b75302454952$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    $4911b75302454952$var$_createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function $4911b75302454952$var$explainFromTokens(locale, input, format) {
    var parser = new $4911b75302454952$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $4911b75302454952$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $4911b75302454952$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $4911b75302454952$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $4911b75302454952$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($4911b75302454952$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $4911b75302454952$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $4911b75302454952$var$INVALID = "Invalid DateTime";
var $4911b75302454952$var$MAX_DATE = 8.64e15;
function $4911b75302454952$var$unsupportedZone(zone) {
    return new $4911b75302454952$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $4911b75302454952$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $4911b75302454952$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $4911b75302454952$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $4911b75302454952$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $4911b75302454952$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $4911b75302454952$var$DateTime($4911b75302454952$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $4911b75302454952$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $4911b75302454952$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $4911b75302454952$var$objToTS(obj, offset, zone) {
    return $4911b75302454952$var$fixOffset($4911b75302454952$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $4911b75302454952$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $4911b75302454952$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $4911b75302454952$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $4911b75302454952$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $4911b75302454952$var$objToLocalTS(c);
    var _fixOffset = $4911b75302454952$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $4911b75302454952$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $4911b75302454952$var$DateTime.fromObject(parsed, $4911b75302454952$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $4911b75302454952$var$DateTime.invalid(new $4911b75302454952$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $4911b75302454952$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $4911b75302454952$var$Formatter.create($4911b75302454952$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $4911b75302454952$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $4911b75302454952$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $4911b75302454952$var$padStart(o.c.month);
        c += "-";
        c += $4911b75302454952$var$padStart(o.c.day);
    } else {
        c += $4911b75302454952$var$padStart(o.c.month);
        c += $4911b75302454952$var$padStart(o.c.day);
    }
    return c;
}
function $4911b75302454952$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $4911b75302454952$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $4911b75302454952$var$padStart(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $4911b75302454952$var$padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += $4911b75302454952$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $4911b75302454952$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $4911b75302454952$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $4911b75302454952$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $4911b75302454952$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $4911b75302454952$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $4911b75302454952$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $4911b75302454952$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $4911b75302454952$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $4911b75302454952$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $4911b75302454952$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $4911b75302454952$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $4911b75302454952$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $4911b75302454952$var$InvalidUnitError(unit);
    return normalized;
}
function $4911b75302454952$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $4911b75302454952$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
function $4911b75302454952$var$guessOffsetForZone(zone) {
    if (!$4911b75302454952$var$zoneOffsetGuessCache[zone]) {
        if ($4911b75302454952$var$zoneOffsetTs === undefined) $4911b75302454952$var$zoneOffsetTs = $4911b75302454952$var$Settings.now();
        $4911b75302454952$var$zoneOffsetGuessCache[zone] = zone.offset($4911b75302454952$var$zoneOffsetTs);
    }
    return $4911b75302454952$var$zoneOffsetGuessCache[zone];
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $4911b75302454952$var$quickDT(obj, opts) {
    var zone = $4911b75302454952$var$normalizeZone(opts.zone, $4911b75302454952$var$Settings.defaultZone);
    if (!zone.isValid) return $4911b75302454952$var$DateTime.invalid($4911b75302454952$var$unsupportedZone(zone));
    var loc = $4911b75302454952$var$Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!$4911b75302454952$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $4911b75302454952$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($4911b75302454952$var$isUndefined(obj[u])) obj[u] = $4911b75302454952$var$defaultUnitValues[u];
        }
        var invalid = $4911b75302454952$var$hasInvalidGregorianData(obj) || $4911b75302454952$var$hasInvalidTimeData(obj);
        if (invalid) return $4911b75302454952$var$DateTime.invalid(invalid);
        var offsetProvis = $4911b75302454952$var$guessOffsetForZone(zone);
        var _objToTS = $4911b75302454952$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = $4911b75302454952$var$Settings.now();
    return new $4911b75302454952$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $4911b75302454952$var$diffRelative(start, end, opts) {
    var round = $4911b75302454952$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $4911b75302454952$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $4911b75302454952$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $4911b75302454952$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var $4911b75302454952$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var $4911b75302454952$var$zoneOffsetGuessCache = {};
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $4911b75302454952$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $4911b75302454952$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $4911b75302454952$var$Invalid("invalid input") : null) || (!zone.isValid ? $4911b75302454952$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $4911b75302454952$var$isUndefined(config.ts) ? $4911b75302454952$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = $4911b75302454952$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $4911b75302454952$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $4911b75302454952$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $4911b75302454952$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $4911b75302454952$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $4911b75302454952$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $4911b75302454952$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $4911b75302454952$var$FixedOffsetZone.utcInstance;
        return $4911b75302454952$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $4911b75302454952$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $4911b75302454952$var$normalizeZone(options.zone, $4911b75302454952$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($4911b75302454952$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $4911b75302454952$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$4911b75302454952$var$isNumber(milliseconds)) throw new $4911b75302454952$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$4911b75302454952$var$MAX_DATE || milliseconds > $4911b75302454952$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $4911b75302454952$var$normalizeZone(options.zone, $4911b75302454952$var$Settings.defaultZone),
            loc: $4911b75302454952$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$4911b75302454952$var$isNumber(seconds)) throw new $4911b75302454952$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $4911b75302454952$var$normalizeZone(options.zone, $4911b75302454952$var$Settings.defaultZone),
            loc: $4911b75302454952$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $4911b75302454952$var$normalizeZone(opts.zone, $4911b75302454952$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($4911b75302454952$var$unsupportedZone(zoneToUse));
        var loc = $4911b75302454952$var$Locale.fromObject(opts);
        var normalized = $4911b75302454952$var$normalizeObject(obj, $4911b75302454952$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $4911b75302454952$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $4911b75302454952$var$Settings.now(), offsetProvis = !$4911b75302454952$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$4911b75302454952$var$isUndefined(normalized.ordinal), containsGregorYear = !$4911b75302454952$var$isUndefined(normalized.year), containsGregorMD = !$4911b75302454952$var$isUndefined(normalized.month) || !$4911b75302454952$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $4911b75302454952$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $4911b75302454952$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $4911b75302454952$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $4911b75302454952$var$orderedWeekUnits;
            defaultValues = $4911b75302454952$var$defaultWeekUnitValues;
            objNow = $4911b75302454952$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $4911b75302454952$var$orderedOrdinalUnits;
            defaultValues = $4911b75302454952$var$defaultOrdinalUnitValues;
            objNow = $4911b75302454952$var$gregorianToOrdinal(objNow);
        } else {
            units = $4911b75302454952$var$orderedUnits;
            defaultValues = $4911b75302454952$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $4911b75302454952$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$4911b75302454952$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $4911b75302454952$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $4911b75302454952$var$hasInvalidOrdinalData(normalized) : $4911b75302454952$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $4911b75302454952$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $4911b75302454952$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $4911b75302454952$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $4911b75302454952$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $4911b75302454952$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $4911b75302454952$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $4911b75302454952$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $4911b75302454952$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $4911b75302454952$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $4911b75302454952$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($4911b75302454952$var$isUndefined(text) || $4911b75302454952$var$isUndefined(fmt)) throw new $4911b75302454952$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $4911b75302454952$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $4911b75302454952$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $4911b75302454952$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $4911b75302454952$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $4911b75302454952$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $4911b75302454952$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $4911b75302454952$var$Invalid ? reason : new $4911b75302454952$var$Invalid(reason, explanation);
        if ($4911b75302454952$var$Settings.throwOnInvalid) throw new $4911b75302454952$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $4911b75302454952$var$formatOptsToTokens(formatOpts, $4911b75302454952$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $4911b75302454952$var$expandMacroTokens($4911b75302454952$var$Formatter.parseFormat(fmt), $4911b75302454952$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        $4911b75302454952$var$zoneOffsetTs = undefined;
        $4911b75302454952$var$zoneOffsetGuessCache = {};
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $4911b75302454952$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $4911b75302454952$var$tsToObj(ts1, o1);
        var c2 = $4911b75302454952$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $4911b75302454952$var$clone(this, {
                ts: ts1
            }),
            $4911b75302454952$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $4911b75302454952$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($4911b75302454952$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($4911b75302454952$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $4911b75302454952$var$normalizeZone(zone, $4911b75302454952$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($4911b75302454952$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $4911b75302454952$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $4911b75302454952$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $4911b75302454952$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $4911b75302454952$var$normalizeObject(values, $4911b75302454952$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $4911b75302454952$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$4911b75302454952$var$isUndefined(normalized.weekYear) || !$4911b75302454952$var$isUndefined(normalized.weekNumber) || !$4911b75302454952$var$isUndefined(normalized.weekday), containsOrdinal = !$4911b75302454952$var$isUndefined(normalized.ordinal), containsGregorYear = !$4911b75302454952$var$isUndefined(normalized.year), containsGregorMD = !$4911b75302454952$var$isUndefined(normalized.month) || !$4911b75302454952$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $4911b75302454952$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $4911b75302454952$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $4911b75302454952$var$weekToGregorian($4911b75302454952$var$_extends({}, $4911b75302454952$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$4911b75302454952$var$isUndefined(normalized.ordinal)) mixed = $4911b75302454952$var$ordinalToGregorian($4911b75302454952$var$_extends({}, $4911b75302454952$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $4911b75302454952$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($4911b75302454952$var$isUndefined(normalized.day)) mixed.day = Math.min($4911b75302454952$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $4911b75302454952$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $4911b75302454952$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $4911b75302454952$var$Duration.fromDurationLike(duration);
        return $4911b75302454952$var$clone(this, $4911b75302454952$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $4911b75302454952$var$Duration.fromDurationLike(duration).negate();
        return $4911b75302454952$var$clone(this, $4911b75302454952$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $4911b75302454952$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $4911b75302454952$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $4911b75302454952$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $4911b75302454952$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $4911b75302454952$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $4911b75302454952$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $4911b75302454952$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $4911b75302454952$var$_toISODate(this, ext);
        c += "T";
        c += $4911b75302454952$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        return $4911b75302454952$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $4911b75302454952$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $4911b75302454952$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $4911b75302454952$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $4911b75302454952$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $4911b75302454952$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $4911b75302454952$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $4911b75302454952$var$INVALID;
    } /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $4911b75302454952$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $4911b75302454952$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $4911b75302454952$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $4911b75302454952$var$maybeArray(unit).map($4911b75302454952$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $4911b75302454952$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $4911b75302454952$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $4911b75302454952$var$diffRelative(base, this.plus(padding), $4911b75302454952$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $4911b75302454952$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $4911b75302454952$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $4911b75302454952$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $4911b75302454952$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $4911b75302454952$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $4911b75302454952$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $4911b75302454952$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $4911b75302454952$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ ;
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = $4911b75302454952$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $4911b75302454952$var$TokenParser(localeToUse, fmt);
    } /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ ;
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if ($4911b75302454952$var$isUndefined(text) || $4911b75302454952$var$isUndefined(formatParser)) throw new $4911b75302454952$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = $4911b75302454952$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $4911b75302454952$var$InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return $4911b75302454952$var$parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $4911b75302454952$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $4911b75302454952$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $4911b75302454952$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $4911b75302454952$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $4911b75302454952$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $4911b75302454952$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $4911b75302454952$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $4911b75302454952$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $4911b75302454952$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $4911b75302454952$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $4911b75302454952$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $4911b75302454952$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $4911b75302454952$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $4911b75302454952$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $4911b75302454952$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $4911b75302454952$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $4911b75302454952$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $4911b75302454952$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $4911b75302454952$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $4911b75302454952$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $4911b75302454952$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $4911b75302454952$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $4911b75302454952$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $4911b75302454952$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $4911b75302454952$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $4911b75302454952$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $4911b75302454952$var$friendlyDateTime(dateTimeish) {
    if ($4911b75302454952$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $4911b75302454952$var$isNumber(dateTimeish.valueOf())) return $4911b75302454952$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $4911b75302454952$var$DateTime.fromObject(dateTimeish);
    else throw new $4911b75302454952$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $4911b75302454952$var$VERSION = "3.5.0";
$4911b75302454952$exports.DateTime = $4911b75302454952$var$DateTime;
$4911b75302454952$exports.Duration = $4911b75302454952$var$Duration;
$4911b75302454952$exports.FixedOffsetZone = $4911b75302454952$var$FixedOffsetZone;
$4911b75302454952$exports.IANAZone = $4911b75302454952$var$IANAZone;
$4911b75302454952$exports.Info = $4911b75302454952$var$Info;
$4911b75302454952$exports.Interval = $4911b75302454952$var$Interval;
$4911b75302454952$exports.InvalidZone = $4911b75302454952$var$InvalidZone;
$4911b75302454952$exports.Settings = $4911b75302454952$var$Settings;
$4911b75302454952$exports.SystemZone = $4911b75302454952$var$SystemZone;
$4911b75302454952$exports.VERSION = $4911b75302454952$var$VERSION;
$4911b75302454952$exports.Zone = $4911b75302454952$var$Zone;


(function(BackendDatetime) {
    BackendDatetime.nowToUTC = ()=>{
        return BackendDatetime.toUTC((0, $4911b75302454952$exports.DateTime).local());
    };
    BackendDatetime.toUTC = (datetime)=>{
        if (!datetime.isValid) {
            console.error('Invalid datetime was given. ', datetime);
            return '';
        }
        return datetime.toUTC().toISO() || '';
    };
    BackendDatetime.fromUTC = (utcDatetime, locale)=>{
        return (0, $4911b75302454952$exports.DateTime).fromISO(utcDatetime || '').setLocale(locale);
    };
})($4ea31e1953a3d675$export$6ef9dbcccbc4ed7d || ($4ea31e1953a3d675$export$6ef9dbcccbc4ed7d = {}));
(function(UIDatetime) {
    UIDatetime.toString = (datetime)=>{
        return datetime.toLocaleString((0, $4911b75302454952$exports.DateTime).DATETIME_SHORT);
    };
})($4ea31e1953a3d675$export$59110d836eb073ac || ($4ea31e1953a3d675$export$59110d836eb073ac = {}));
(function(UIDate) {
    UIDate.toString = (datetime)=>{
        return datetime.toLocaleString((0, $4911b75302454952$exports.DateTime).DATE_SHORT);
    };
    UIDate.toCustomString = (datetime, format = 'yyyyMMdd')=>{
        return datetime.toFormat(format);
    };
})($4ea31e1953a3d675$export$6c3b6c09c58d6bc3 || ($4ea31e1953a3d675$export$6c3b6c09c58d6bc3 = {}));
const $4ea31e1953a3d675$export$b450afd4bcd34baf = (intl, isoTimestamp)=>{
    if (!isoTimestamp) return '';
    const dateStr = intl.formatDate(isoTimestamp);
    const timeStr = intl.formatTime(isoTimestamp, {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    });
    return `${dateStr} ${timeStr}`;
};
const $4ea31e1953a3d675$export$3c155241990d019 = (intl, duration)=>{
    if (!duration && duration !== 0) return '';
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor(duration / 60) % 60;
    const seconds = duration % 60;
    const hourUnit = intl.formatMessage({
        id: 'common.units.hours.short'
    });
    const minuteUnit = intl.formatMessage({
        id: 'common.units.minutes.short'
    });
    const secondUnit = intl.formatMessage({
        id: 'common.units.seconds.short'
    });
    const nbsp = '\u00A0';
    if (hours === 0 && minutes === 0) return `${seconds}${nbsp}${secondUnit}`;
    if (hours === 0) return `${minutes}${nbsp}${minuteUnit} ${seconds}${nbsp}${secondUnit}`;
    return `${hours}${nbsp}${hourUnit} ${minutes}${nbsp}${minuteUnit} ${seconds}${nbsp}${secondUnit}`;
};
var $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d, $4ea31e1953a3d675$export$59110d836eb073ac, $4ea31e1953a3d675$export$6c3b6c09c58d6bc3;




var $e1vzu = parcelRequire("e1vzu");


var $3Rwjo = parcelRequire("3Rwjo");

var $3QbnI = parcelRequire("3QbnI");




const $6862e75f9cff4874$var$InvoiceForm = (props)=>{
    const [userEmail, setUserEmail] = (0, $264779fcdde7e2fb$export$2e2bcd8739ae039)();
    const [inputValue, setInputValue] = (0, $3QbnI.useState)(userEmail);
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    const validationSchema = $13652c29f5b631d1$export$be5493f9613cbbe({
        email: $13652c29f5b631d1$export$22b082955e083ec3().email(intl.formatMessage({
            id: 'page.webPayment.stepInvoice.form.email.errors.email'
        })).required(intl.formatMessage({
            id: 'page.webPayment.stepInvoice.form.email.errors.required'
        }))
    });
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3Rwjo.Formik), {
        initialValues: {
            email: userEmail
        },
        onSubmit: (values, { setSubmitting: setSubmitting })=>{
            setUserEmail(inputValue);
            props.onSubmit(values.email);
        },
        validationSchema: validationSchema,
        children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $3Rwjo.Form), {
                onSubmit: handleSubmit,
                style: {
                    width: '100%',
                    padding: '0 1rem'
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "email",
                            label: intl.formatMessage({
                                id: 'page.webPayment.stepInvoice.emailAddress'
                            }),
                            value: values.email,
                            error: !!errors.email,
                            errorText: errors.email,
                            onChange: (event)=>{
                                setInputValue(event.target.value);
                                handleChange(event);
                            }
                        }),
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                            align: "left",
                            variant: "body2",
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                id: "page.webPayment.stepInvoice.contactInformation.description"
                            })
                        }),
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                            disabled: props.isButtonDisabled,
                            type: "submit",
                            "aria-label": intl.formatMessage({
                                id: 'page.webPayment.stepInvoice.button.payParking'
                            }),
                            fullWidth: true,
                            color: "secondary",
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                id: `page.webPayment.stepInvoice.button.payParking${props.isButtonDisabled ? '.loading' : ''}`
                            })
                        })
                    ]
                })
            })
    });
};
var $6862e75f9cff4874$export$2e2bcd8739ae039 = $6862e75f9cff4874$var$InvoiceForm;


const $dbefda6c971e7ae5$var$CardInvoice = ({ invoiceNumber: invoiceNumber, locationName: locationName, startTimeISO: startTimeISO, duration: duration, price: price, vat: vat, vatPrice: vatPrice, isButtonDisabled: isButtonDisabled, onInvoiceClick: onInvoiceClick })=>{
    const TitleValue = ({ title: title, value: value })=>{
        return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
            children: [
                title,
                ': ',
                /*#__PURE__*/ (0, $e1vzu.jsx)("b", {
                    children: value
                })
            ]
        });
    };
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $7ec9bf661e192db7$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 200
        },
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $7344f96cc945ca6d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                            style: {
                                wordBreak: 'break-all'
                            },
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                                variant: "h5",
                                textAlign: "left",
                                children: locationName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                        style: {
                            paddingBottom: 0,
                            paddingTop: 0,
                            textAlign: 'left'
                        },
                        children: [
                            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                                style: {
                                    wordBreak: 'break-all'
                                },
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)(TitleValue, {
                                    title: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                        id: "page.webPayment.stepInvoice.cardInvoice.parkingStarted"
                                    }),
                                    value: (0, $4ea31e1953a3d675$export$b450afd4bcd34baf)(intl, startTimeISO)
                                })
                            }),
                            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                                style: {
                                    wordBreak: 'break-all'
                                },
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)(TitleValue, {
                                    title: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                        id: "page.webPayment.stepInvoice.cardInvoice.duration"
                                    }),
                                    value: (0, $4ea31e1953a3d675$export$3c155241990d019)(intl, duration)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsx)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                            style: {
                                wordBreak: 'break-all'
                            },
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $939fbaf970c0d6e6$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $bf4c6525c729e6fe$export$2e2bcd8739ae039), {
                        style: {
                            paddingBottom: 0,
                            paddingTop: 0,
                            textAlign: 'left'
                        },
                        children: [
                            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                                style: {
                                    wordBreak: 'break-all'
                                },
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)(TitleValue, {
                                    title: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                        id: "page.webPayment.stepInvoice.cardInvoice.parkingPrice"
                                    }),
                                    value: (0, $fd8cba9627e69a57$export$7fef4f5078e2ef4a)({
                                        intl: intl,
                                        cents: price
                                    }) || ''
                                })
                            }),
                            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $06aed526e7b1201f$export$2e2bcd8739ae039), {
                                style: {
                                    wordBreak: 'break-all'
                                },
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontStyle: 'italic'
                                    },
                                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                        id: "page.webPayment.stepInvoice.cardInvoice.vatIncluded",
                                        values: {
                                            vat: intl.formatNumber(vat),
                                            vatPrice: (0, $fd8cba9627e69a57$export$7fef4f5078e2ef4a)({
                                                intl: intl,
                                                cents: vatPrice
                                            })
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fbfd9bad3edf9693$export$2e2bcd8739ae039), {
                style: {
                    paddingBottom: 10
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $6862e75f9cff4874$export$2e2bcd8739ae039), {
                    onSubmit: onInvoiceClick,
                    isButtonDisabled: isButtonDisabled
                })
            })
        ]
    }, invoiceNumber);
};
var $dbefda6c971e7ae5$export$2e2bcd8739ae039 = $dbefda6c971e7ae5$var$CardInvoice;


const $de400b3a8e56e4f5$var$initiatePaymentMutationKey = [
    'initiatePayment'
];
const $de400b3a8e56e4f5$var$StepInvoice = ({ licensePlate: licensePlate, invoices: invoices })=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    const [isRedirecting, setIsRedirecting] = (0, $3QbnI.useState)(false);
    const { locale: locale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    const [email] = (0, $264779fcdde7e2fb$export$2e2bcd8739ae039)();
    const queryInitiatePayment = (0, $61d107a8eeadcf94$export$609860bf8b0084c)({
        mutationKey: $de400b3a8e56e4f5$var$initiatePaymentMutationKey,
        mutationFn: (request)=>(0, $ef4c197593d1f0e8$export$2e2bcd8739ae039).createPaymentSession(request),
        onError: (_error)=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(intl.formatMessage({
                id: 'page.webPayment.stepInvoice.error.initiatePayment'
            }), 'error');
        },
        onSuccess: (response)=>{
            if (response.data.href) {
                setIsRedirecting(true);
                window.location.href = response.data.href;
            }
        }
    });
    const isInitiatePaymentMutating = (0, $522ec8f0f7be08eb$export$32cc39cf62abf4fc)({
        mutationKey: $de400b3a8e56e4f5$var$initiatePaymentMutationKey
    });
    const GridInvoice = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
            container: true,
            sx: {
                flexGrow: 1,
                justifyContent: 'center'
            },
            spacing: 2,
            "data-testid": (0, $5cb825bac5cf2334$export$2e2bcd8739ae039).STEP_INVOICE_INVOICE_CONTAINER,
            children: invoices.map((item)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                    size: {
                        sm: 12,
                        md: 6
                    },
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $dbefda6c971e7ae5$export$2e2bcd8739ae039), {
                        invoiceNumber: item.invoiceNumber,
                        locationName: intl.formatMessage({
                            id: 'facility.name'
                        }),
                        startTimeISO: item.startTimeISO,
                        duration: item.duration,
                        price: item.price,
                        vat: item.vat,
                        vatPrice: item.vatPrice,
                        isButtonDisabled: !!(isRedirecting || isInitiatePaymentMutating),
                        onInvoiceClick: (userEmail)=>{
                            const languages = [
                                'FI',
                                'EN',
                                'SV'
                            ];
                            queryInitiatePayment.mutate({
                                language: languages.find((lang)=>lang === locale.toUpperCase()) ?? 'EN',
                                invoiceNumber: item.invoiceNumber,
                                email: userEmail
                            });
                        }
                    }, `invoiceCard-${item.invoiceNumber}`)
                }, `invoiceContainer-${item.invoiceNumber}`))
        });
    };
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                size: 12,
                style: {
                    padding: 50
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                    variant: "h3",
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                        id: "page.webPayment.stepInvoice.info.invoice"
                    })
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                size: 12,
                style: {
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingBottom: 20
                },
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                        id: "page.webPayment.stepInvoice.info.invoiceDescription",
                        values: {
                            count: invoices.length,
                            licensePlate: licensePlate
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)(GridInvoice, {})
        ]
    });
};
var $de400b3a8e56e4f5$export$2e2bcd8739ae039 = $de400b3a8e56e4f5$var$StepInvoice;


const $d72c9f17ad7fd436$var$WebPayment = ()=>{
    const FORM_REFERENCE = 'formWebPayment';
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    const { locale: locale, setLocale: setLocale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    const [filledLicensePlate, setFilledLicensePlate] = (0, $3QbnI.useState)(sessionStorage.getItem((0, $2732b3fe4895f686$export$e8c70a271f6ea3de)) ?? '');
    const [invoices, setInvoices] = (0, $3QbnI.useState)([]);
    (0, $3QbnI.useEffect)(()=>{
        sessionStorage.setItem((0, $2732b3fe4895f686$export$e8c70a271f6ea3de), filledLicensePlate);
    }, [
        filledLicensePlate
    ]);
    const [currentPaymentStep, setCurrentPaymentStep] = (0, $19b60b7d89217ab4$export$2e2bcd8739ae039)();
    const [isPageReady, setIsPageReady] = (0, $3QbnI.useState)(false);
    const [isButtonDisabled, setIsButtonDisabled] = (0, $3QbnI.useState)(false);
    const locOptions = (0, $d30a5fdc49293dc0$export$2e2bcd8739ae039).supportedLanguages.map((key)=>{
        return {
            key: key,
            text: intl.formatMessage({
                id: `language.${key}`
            })
        };
    });
    const fetchInvoices = async (licensePlate)=>{
        setIsButtonDisabled(true);
        try {
            const invoicesQuery = await (0, $0e9294c15beacf0d$export$2e2bcd8739ae039).getInvoices(licensePlate);
            setFilledLicensePlate(invoicesQuery.data.data?.licensePlate ?? licensePlate);
            if ((invoicesQuery.data.data?.invoices ?? []).length > 0) {
                setInvoices(invoicesQuery.data.data?.invoices ?? []);
                setCurrentPaymentStep((0, $c8a51a1a3cac62e6$export$9e355b279c43f205).INVOICE);
            } else {
                setInvoices([]);
                setCurrentPaymentStep((0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE_ERROR);
            }
        } catch (error) {
            setInvoices([]);
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(intl.formatMessage({
                id: 'page.webPayment.stepFillLicensePlate.getInvoice.errorToast'
            }), 'error');
            setCurrentPaymentStep((0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE);
        } finally{
            setIsButtonDisabled(false);
            setIsPageReady(true);
        }
    };
    // Fetch invoices on first render if we are in invoice step
    (0, $3QbnI.useEffect)(()=>{
        if ([
            (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).INVOICE,
            (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).INVOICE_ERROR
        ].includes(currentPaymentStep)) fetchInvoices(filledLicensePlate);
        else setIsPageReady(true);
    }, []);
    const onSubmitLicensePlate = (values)=>{
        // Reset possible error state
        setCurrentPaymentStep((0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE);
        setFilledLicensePlate(values.licensePlate);
        fetchInvoices(values.licensePlate);
    };
    const GridLanguage = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
            container: true,
            size: 12,
            style: {
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                    size: 6,
                    style: {
                        alignItems: 'left',
                        justifyContent: 'flex-start',
                        textAlign: 'left'
                    },
                    children: currentPaymentStep !== 'FILL_LICENSE_PLATE' && [
                        (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).INVOICE,
                        (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).INVOICE_ERROR
                    ].includes(currentPaymentStep) && /*#__PURE__*/ (0, $e1vzu.jsx)((0, $a987e9ba7ec70360$export$2e2bcd8739ae039), {
                        "aria-label": intl.formatMessage({
                            id: 'common.button.back'
                        }),
                        onClick: ()=>setCurrentPaymentStep((0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE),
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($300085ebe0b047ad$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                    size: 6,
                    style: {
                        alignItems: 'right',
                        justifyContent: 'flex-end',
                        textAlign: 'right'
                    },
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3b5eaf40d4a4ccf9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e2e7f451596e3c31$export$2e2bcd8739ae039), {
                            name: "language",
                            "aria-label": intl.formatMessage({
                                id: 'language'
                            }),
                            labelId: "select-language",
                            value: locale,
                            sx: {
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none'
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    border: 'none'
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    border: 'none'
                                },
                                color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).primaryMain
                            },
                            IconComponent: (props)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($25d5499ea2336b35$exports))), {
                                    ...props,
                                    style: {
                                        color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).primaryMain
                                    }
                                }),
                            children: locOptions.map((item)=>/*#__PURE__*/ (0, $e1vzu.jsx)((0, $a617846d6b4c8545$export$2e2bcd8739ae039), {
                                    "aria-label": item.text,
                                    value: item.key,
                                    onClick: ()=>{
                                        setLocale(item.key);
                                    },
                                    disabled: item.key === locale,
                                    children: item.text
                                }, item.key))
                        })
                    })
                })
            ]
        });
    };
    const GridLogo = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
            size: 12,
            sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: {
                    xs: (0, $53be88aa100c8649$export$6039b89271c3de71).elementSpacingMobile * 2,
                    sm: (0, $53be88aa100c8649$export$6039b89271c3de71).elementSpacingDesktop * 2
                }
            },
            children: /*#__PURE__*/ (0, $e1vzu.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2227b20de94aaa0a$exports)))
            })
        });
    };
    const GridCustomerService = ()=>{
        return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $e1vzu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
                    size: 12,
                    sx: {
                        marginTop: {
                            xs: (0, $53be88aa100c8649$export$6039b89271c3de71).elementSpacingMobile,
                            sm: (0, $53be88aa100c8649$export$6039b89271c3de71).elementSpacingDesktop
                        }
                    },
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $939fbaf970c0d6e6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $7961aabc05d182ef$export$2e2bcd8739ae039), {
                    paddingTop: 3,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                    id: "page.webPayment.label.customerService.part1"
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039).Link, {
                                    href: intl.formatMessage({
                                        id: 'facility.customerService.url'
                                    }),
                                    "aria-label": intl.formatMessage({
                                        id: 'page.webPayment.label.customerService.urlTitle'
                                    }),
                                    bold: true,
                                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                        id: "page.webPayment.label.customerService.part2"
                                    })
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $e1vzu.jsx)((0, $311a456630f5f039$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039).Link, {
                                href: intl.formatMessage({
                                    id: 'facility.privacyPolicy.url'
                                }),
                                target: "_blank",
                                bold: true,
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                                    id: "facility.privacyPolicy.text"
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    const PaymentServiceProviderInformation = ()=>{
        const isVisible = [
            (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE,
            (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FILL_LICENSE_PLATE_ERROR,
            (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).INVOICE,
            (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).INVOICE_ERROR
        ].includes(currentPaymentStep);
        if (!isVisible) return null;
        return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $3d09673614435234$export$2e2bcd8739ae039), {});
    };
    const RenderStep = ()=>{
        if (!isPageReady) return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
            marginTop: 6,
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fccdfec3f47c0093$export$2e2bcd8739ae039), {})
        });
        switch(currentPaymentStep){
            case 'INVOICE':
            case 'INVOICE_ERROR':
                return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $de400b3a8e56e4f5$export$2e2bcd8739ae039), {
                    licensePlate: filledLicensePlate,
                    invoices: invoices
                });
            case 'FINISH':
            case 'FINISH_ERROR':
                return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $b9e346de39611d09$export$2e2bcd8739ae039), {});
            case 'FILL_LICENSE_PLATE':
            case 'FILL_LICENSE_PLATE_ERROR':
            default:
                return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1cbeb8d7e2751bc$export$2e2bcd8739ae039), {
                    formReference: FORM_REFERENCE,
                    licensePlate: filledLicensePlate,
                    isButtonDisabled: isButtonDisabled,
                    onSubmitLicensePlate: onSubmitLicensePlate
                });
        }
    };
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e1vzu.Fragment), {
        children: /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $ad8e3f93e981b797$export$2e2bcd8739ae039), {
            container: true,
            style: {
                flexGrow: 1,
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $e1vzu.jsx)(GridLanguage, {}),
                /*#__PURE__*/ (0, $e1vzu.jsx)(GridLogo, {}),
                /*#__PURE__*/ (0, $e1vzu.jsx)(RenderStep, {}),
                /*#__PURE__*/ (0, $e1vzu.jsx)(PaymentServiceProviderInformation, {}),
                /*#__PURE__*/ (0, $e1vzu.jsx)(GridCustomerService, {})
            ]
        })
    });
};
var $d72c9f17ad7fd436$export$2e2bcd8739ae039 = $d72c9f17ad7fd436$var$WebPayment;





var $e1vzu = parcelRequire("e1vzu");



var $3QbnI = parcelRequire("3QbnI");




const $42873dd50508edc7$var$PaymentRedirectReceiver = ({ type: type })=>{
    const [_currentPaymentStep, setCurrentPaymentStep] = (0, $19b60b7d89217ab4$export$2e2bcd8739ae039)();
    const navigate = (0, $720b4b44089c40ed$export$9770f232ac06a008)();
    (0, $3QbnI.useEffect)(()=>{
        setCurrentPaymentStep(type === 'success' ? (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FINISH : (0, $c8a51a1a3cac62e6$export$9e355b279c43f205).FINISH_ERROR);
        navigate('/');
    }, []);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $7961aabc05d182ef$export$2e2bcd8739ae039), {
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)("h1", {
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f34cae4af8bdbc33$export$2e2bcd8739ae039), {
                    id: "page.webPayment.paymentRedirectReceiver.heading"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $fccdfec3f47c0093$export$2e2bcd8739ae039), {})
        ]
    });
};
var $42873dd50508edc7$export$2e2bcd8739ae039 = $42873dd50508edc7$var$PaymentRedirectReceiver;




var $e1vzu = parcelRequire("e1vzu");

const $c753d58728ea6715$export$f023ae853add2e3e = (userPermissions, action, resource)=>{
    const userPermission = userPermissions.find((permission)=>permission.resource === resource);
    return userPermission?.action?.includes(action) || false;
};
const $c753d58728ea6715$var$getPermission = (actions, resource)=>{
    if (actions.includes('ALL')) return {
        action: [
            'READ',
            'CREATE',
            'EDIT',
            'DELETE'
        ],
        resource: resource
    };
    else return {
        action: actions,
        resource: resource
    };
};
const $c753d58728ea6715$export$b325ec6732b039cf = (isAdmin, action, resource)=>{
    const userPermissions = isAdmin ? [
        $c753d58728ea6715$var$getPermission([
            'READ',
            'EDIT'
        ], 'PARKING_EVENTS'),
        $c753d58728ea6715$var$getPermission([
            'ALL'
        ], 'WHITELIST'),
        $c753d58728ea6715$var$getPermission([
            'READ'
        ], 'USER_DETAILS')
    ] : [
        $c753d58728ea6715$var$getPermission([
            'READ',
            'EDIT'
        ], 'PARKING_EVENTS'),
        $c753d58728ea6715$var$getPermission([
            'READ'
        ], 'WHITELIST'),
        $c753d58728ea6715$var$getPermission([
            'READ'
        ], 'USER_DETAILS')
    ];
    return $c753d58728ea6715$export$f023ae853add2e3e(userPermissions, action, resource);
};
const $c753d58728ea6715$export$61147a57d3c24ac8 = {
    ROOT: '/',
    USER_DETAILS: '/user',
    PARKING_EVENTS: '/parking-events',
    WHITELIST: '/exempt-vehicles'
};


const $6b1d585dc0fb6610$var$MoovyRoute = ({ isProgress: isProgress = false, isAllowed: isAllowed = true, redirectPath: redirectPath = (0, $c753d58728ea6715$export$61147a57d3c24ac8).ROOT, children: children })=>{
    // TODO Antti
    /*const { isAuthenticated } = { isAuthenticated: true } // TODO Sampo

  if (isProgress) {
    return <MoovyProgress />
  }

  if (!isAuthenticated || !isAllowed) {
    return <Navigate to={redirectPath} replace />
  }*/ return children ? children : /*#__PURE__*/ (0, $e1vzu.jsx)((0, $720b4b44089c40ed$export$910ae8079b2c2852), {});
};
var $6b1d585dc0fb6610$export$2e2bcd8739ae039 = $6b1d585dc0fb6610$var$MoovyRoute;


const $f8688ebf24442bdd$var$Main = (0, $2TGnx.default)('main')({
    backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorMainBackground,
    minHeight: '100vh',
    maxHeight: '-webkit-fill-available'
});
const $f8688ebf24442bdd$var$MoovyRouters = ()=>{
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $720b4b44089c40ed$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $720b4b44089c40ed$export$e7b0ac011bb776c6), {
                index: true,
                element: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8b3278ab2e44253$export$2e2bcd8739ae039), {
                        sx: {
                            position: 'relative'
                        },
                        children: /*#__PURE__*/ (0, $e1vzu.jsx)($f8688ebf24442bdd$var$Main, {
                            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $36497735a3d4d2c6$export$2e2bcd8739ae039), {
                                style: {
                                    paddingTop: 10,
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    paddingBottom: 20,
                                    maxWidth: '800px'
                                },
                                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $d72c9f17ad7fd436$export$2e2bcd8739ae039), {})
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $720b4b44089c40ed$export$e7b0ac011bb776c6), {
                path: "/success",
                element: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $42873dd50508edc7$export$2e2bcd8739ae039), {
                    type: "success"
                })
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $720b4b44089c40ed$export$e7b0ac011bb776c6), {
                path: "/cancel",
                element: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $42873dd50508edc7$export$2e2bcd8739ae039), {
                    type: "cancel"
                })
            })
        ]
    });
};
var $f8688ebf24442bdd$export$2e2bcd8739ae039 = $f8688ebf24442bdd$var$MoovyRouters;


const $05214e8d6426daae$var$AppRoutes = ()=>{
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $cd8cc81cff53fd72$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f8688ebf24442bdd$export$2e2bcd8739ae039), {})
    });
};
var $05214e8d6426daae$export$2e2bcd8739ae039 = $05214e8d6426daae$var$AppRoutes;




var $5HuF3 = parcelRequire("5HuF3");
const $e8ed8958d84af172$var$smBreakpoint = 600;
var $e8ed8958d84af172$export$2e2bcd8739ae039 = (0, $5HuF3.default)({
    palette: {
        primary: {
            main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).primaryMain
        },
        secondary: {
            main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).secondaryMain
        },
        error: {
            main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).errorMain
        },
        warning: {
            main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).warningMain
        },
        info: {
            main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).infoMain
        },
        success: {
            main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).successMain
        },
        text: {
            primary: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlack
        },
        common: {
            black: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlack,
            white: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonWhite
        }
    },
    shape: {
        borderRadius: 10
    },
    typography: {
        fontFamily: (0, $53be88aa100c8649$export$6039b89271c3de71).fontFamily,
        htmlFontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).htmlFontSize,
        fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile,
        body1: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop
            }
        },
        body2: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 0.8,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 0.8
            }
        },
        h1: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 2.5,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 2.5
            },
            fontWeight: 'bold'
        },
        h2: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 2,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 2
            },
            fontWeight: 'bold'
        },
        h3: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 1.75,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 1.75
            },
            fontWeight: 'bold'
        },
        h4: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 1.5,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 1.5
            },
            fontWeight: 'bold'
        },
        h5: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 1.25,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 1.25
            },
            fontWeight: 'bold'
        },
        h6: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 1.1,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 1.1
            },
            fontWeight: 'bold'
        },
        subtitle1: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 1.1,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 1.1
            }
        },
        subtitle2: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 0.9,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 0.9
            }
        },
        button: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop
            },
            textTransform: 'none'
        },
        caption: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 0.75,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 0.75
            }
        },
        overline: {
            fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeMobile * 0.75,
            [`@media (min-width:${$e8ed8958d84af172$var$smBreakpoint}px)`]: {
                fontSize: (0, $53be88aa100c8649$export$6039b89271c3de71).fontSizeDesktop * 0.75
            },
            textTransform: 'uppercase'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                a: {
                    color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlue
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: (0, $53be88aa100c8649$export$6039b89271c3de71).buttonFontWeight
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorTableHeader,
                    '& .MuiTableCell-root': {
                        fontWeight: (0, $53be88aa100c8649$export$6039b89271c3de71).tableHeadFontWeight
                    }
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& input:-webkit-autofill': {
                        '-webkit-text-fill-color': (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlack
                    }
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    cursor: 'pointer'
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    alignItems: 'center',
                    paddingBottom: '0',
                    paddingTop: '2px',
                    paddingLeft: '2px',
                    paddingRight: '0',
                    margin: '0'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    paddingLeft: '10px'
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                standardInfo: {
                    backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorMainBackground,
                    color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).secondaryMain,
                    '& .MuiAlert-icon': {
                        color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).secondaryMain
                    }
                }
            }
        }
    }
});


const $cc9d09a6f2edbadb$var$App = ()=>{
    const intl = (0, $e0606c1bc07ea566$export$2e2bcd8739ae039)();
    (0, $3QbnI.useEffect)(()=>{
        const updateTitle = ()=>{
            document.title = intl.formatMessage({
                id: 'document.title'
            });
        };
        updateTitle();
        (0, $2e2f998e72251dab$export$2e2bcd8739ae039).on('languageChanged', updateTitle);
        return ()=>{
            (0, $2e2f998e72251dab$export$2e2bcd8739ae039).off('languageChanged', updateTitle);
        };
    }, [
        (0, $2e2f998e72251dab$export$2e2bcd8739ae039),
        intl
    ]);
    return /*#__PURE__*/ (0, $e1vzu.jsxs)((0, $54BtZ.b), {
        theme: (0, $e8ed8958d84af172$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $d7fe6407b009814b$export$f2815235e76a62b9), {
                position: "top-right"
            }),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $43320114867ac2e8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e1vzu.jsx)((0, $05214e8d6426daae$export$2e2bcd8739ae039), {})
        ]
    });
};
var $cc9d09a6f2edbadb$export$2e2bcd8739ae039 = $cc9d09a6f2edbadb$var$App;



var $e1vzu = parcelRequire("e1vzu");









var $5b53c5cbc1542e3e$var$_initialState, $5b53c5cbc1542e3e$var$_revertState, $5b53c5cbc1542e3e$var$_cache, $5b53c5cbc1542e3e$var$_retryer, $5b53c5cbc1542e3e$var$_defaultOptions, $5b53c5cbc1542e3e$var$_abortSignalConsumed, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn;
var $5b53c5cbc1542e3e$export$62297b13309008b2 = class extends (0, $5582451878673406$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5b53c5cbc1542e3e$var$_dispatch);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5b53c5cbc1542e3e$var$_initialState, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5b53c5cbc1542e3e$var$_revertState, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5b53c5cbc1542e3e$var$_cache, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5b53c5cbc1542e3e$var$_retryer, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5b53c5cbc1542e3e$var$_defaultOptions, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $5b53c5cbc1542e3e$var$_abortSignalConsumed, void 0);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_abortSignalConsumed, false);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_initialState, $5b53c5cbc1542e3e$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $83dd1d9d9eb46358$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $83dd1d9d9eb46358$export$8793edee2d425525)).catch((0, $83dd1d9d9eb46358$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $83dd1d9d9eb46358$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $83dd1d9d9eb46358$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $83dd1d9d9eb46358$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer)) {
                    if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_abortSignalConsumed)) (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer)) {
                (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer).continueRetry();
                return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $83dd1d9d9eb46358$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $5f29fcf8f44eb575$export$986cc6445c1d323)(error) && error.silent)) (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $5f29fcf8f44eb575$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            this.scheduleGc();
        };
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $5b53c5cbc1542e3e$var$_retryer, (0, $5f29fcf8f44eb575$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                (_b2 = (_a2 = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $338be774a3ed77e3$export$fa92d15b718fce20)(this, $5b53c5cbc1542e3e$var$_dispatch, $5b53c5cbc1542e3e$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_retryer).start();
    }
};
$5b53c5cbc1542e3e$var$_initialState = new WeakMap();
$5b53c5cbc1542e3e$var$_revertState = new WeakMap();
$5b53c5cbc1542e3e$var$_cache = new WeakMap();
$5b53c5cbc1542e3e$var$_retryer = new WeakMap();
$5b53c5cbc1542e3e$var$_defaultOptions = new WeakMap();
$5b53c5cbc1542e3e$var$_abortSignalConsumed = new WeakMap();
$5b53c5cbc1542e3e$var$_dispatch = new WeakSet();
$5b53c5cbc1542e3e$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$5b53c5cbc1542e3e$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $5f29fcf8f44eb575$export$986cc6445c1d323)(error) && error.revert && (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_revertState)) return {
                    ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $5b53c5cbc1542e3e$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $5b53c5cbc1542e3e$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $5f29fcf8f44eb575$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $5b53c5cbc1542e3e$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $588e3307ac914e4a$var$_queries;
var $588e3307ac914e4a$export$5dde0cd941da8468 = class extends (0, $bdb903fb62af5313$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $588e3307ac914e4a$var$_queries, void 0);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $588e3307ac914e4a$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $83dd1d9d9eb46358$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $5b53c5cbc1542e3e$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $588e3307ac914e4a$var$_queries).has(query.queryHash)) {
            (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $588e3307ac914e4a$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $588e3307ac914e4a$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $588e3307ac914e4a$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $588e3307ac914e4a$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $588e3307ac914e4a$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $83dd1d9d9eb46358$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $83dd1d9d9eb46358$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$588e3307ac914e4a$var$_queries = new WeakMap();







var $f29065836bb49aaa$var$_mutations, $f29065836bb49aaa$var$_mutationId;
var $f29065836bb49aaa$export$1fcfd9a244434844 = class extends (0, $bdb903fb62af5313$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $f29065836bb49aaa$var$_mutations, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $f29065836bb49aaa$var$_mutationId, void 0);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $f29065836bb49aaa$var$_mutations, /* @__PURE__ */ new Map());
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $f29065836bb49aaa$var$_mutationId, Date.now());
    }
    build(client, options, state) {
        const mutation = new (0, $ba51cfc10291f93f$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $338be774a3ed77e3$export$b1fe7cbb4502036b)(this, $f29065836bb49aaa$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $f29065836bb49aaa$var$scopeFor(mutation);
        const mutations = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).get(scope) ?? [];
        mutations.push(mutation);
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        var _a;
        const scope = $f29065836bb49aaa$var$scopeFor(mutation);
        if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).has(scope)) {
            const mutations = (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).get(scope)) == null ? void 0 : _a.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).delete(scope);
                else (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        var _a;
        const firstPendingMutation = (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).get($f29065836bb49aaa$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        var _a;
        const foundMutation = (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).get($f29065836bb49aaa$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
        return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
    }
    clear() {
        (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $f29065836bb49aaa$var$_mutations).values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $83dd1d9d9eb46358$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $83dd1d9d9eb46358$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $83dd1d9d9eb46358$export$8793edee2d425525)))));
    }
};
$f29065836bb49aaa$var$_mutations = new WeakMap();
$f29065836bb49aaa$var$_mutationId = new WeakMap();
function $f29065836bb49aaa$var$scopeFor(mutation) {
    var _a;
    return ((_a = mutation.options.scope) == null ? void 0 : _a.id) ?? String(mutation.mutationId);
}







function $bf25359934891353$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $83dd1d9d9eb46358$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $83dd1d9d9eb46358$export$8c6246b73dd61f4a) : (0, $83dd1d9d9eb46358$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $bf25359934891353$var$getPreviousPageParam : $bf25359934891353$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $bf25359934891353$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $bf25359934891353$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $bf25359934891353$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $bf25359934891353$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $bf25359934891353$var$getNextPageParam(options, data) != null;
}
function $bf25359934891353$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $bf25359934891353$var$getPreviousPageParam(options, data) != null;
}


var $b42cdd8e403361b3$var$_queryCache, $b42cdd8e403361b3$var$_mutationCache, $b42cdd8e403361b3$var$_defaultOptions, $b42cdd8e403361b3$var$_queryDefaults, $b42cdd8e403361b3$var$_mutationDefaults, $b42cdd8e403361b3$var$_mountCount, $b42cdd8e403361b3$var$_unsubscribeFocus, $b42cdd8e403361b3$var$_unsubscribeOnline;
var $b42cdd8e403361b3$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_queryCache, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_mutationCache, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_defaultOptions, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_queryDefaults, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_mutationDefaults, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_mountCount, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_unsubscribeFocus, void 0);
        (0, $338be774a3ed77e3$export$addf369becd23283)(this, $b42cdd8e403361b3$var$_unsubscribeOnline, void 0);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_queryCache, config.queryCache || new (0, $588e3307ac914e4a$export$5dde0cd941da8468)());
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_mutationCache, config.mutationCache || new (0, $f29065836bb49aaa$export$1fcfd9a244434844)());
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_defaultOptions, config.defaultOptions || {});
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_mountCount, 0);
    }
    mount() {
        (0, $338be774a3ed77e3$export$b1fe7cbb4502036b)(this, $b42cdd8e403361b3$var$_mountCount)._++;
        if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mountCount) !== 1) return;
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_unsubscribeFocus, (0, $07e860d07ad11d97$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).onFocus();
            }
        }));
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_unsubscribeOnline, (0, $74b8cab575ff81f7$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $338be774a3ed77e3$export$b1fe7cbb4502036b)(this, $b42cdd8e403361b3$var$_mountCount)._--;
        if ((0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mountCount) !== 0) return;
        (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_unsubscribeFocus, void 0);
        (_b = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $83dd1d9d9eb46358$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $83dd1d9d9eb46358$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache);
        (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $83dd1d9d9eb46358$export$8793edee2d425525)).catch((0, $83dd1d9d9eb46358$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>{
            (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $b80c5091a3f57d21$export$520687f44db6e1ab).batch(()=>(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $83dd1d9d9eb46358$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $83dd1d9d9eb46358$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $83dd1d9d9eb46358$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $83dd1d9d9eb46358$export$8793edee2d425525)).catch((0, $83dd1d9d9eb46358$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $bf25359934891353$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $83dd1d9d9eb46358$export$8793edee2d425525)).catch((0, $83dd1d9d9eb46358$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $bf25359934891353$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $74b8cab575ff81f7$export$b113e788b2dd3fdc).isOnline()) return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache);
    }
    getMutationCache() {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $338be774a3ed77e3$export$42432efe6614d3b4)(this, $b42cdd8e403361b3$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryDefaults).set((0, $83dd1d9d9eb46358$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $83dd1d9d9eb46358$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mutationDefaults).set((0, $83dd1d9d9eb46358$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $83dd1d9d9eb46358$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $83dd1d9d9eb46358$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $83dd1d9d9eb46358$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_queryCache).clear();
        (0, $338be774a3ed77e3$export$18a094aefa070634)(this, $b42cdd8e403361b3$var$_mutationCache).clear();
    }
};
$b42cdd8e403361b3$var$_queryCache = new WeakMap();
$b42cdd8e403361b3$var$_mutationCache = new WeakMap();
$b42cdd8e403361b3$var$_defaultOptions = new WeakMap();
$b42cdd8e403361b3$var$_queryDefaults = new WeakMap();
$b42cdd8e403361b3$var$_mutationDefaults = new WeakMap();
$b42cdd8e403361b3$var$_mountCount = new WeakMap();
$b42cdd8e403361b3$var$_unsubscribeFocus = new WeakMap();
$b42cdd8e403361b3$var$_unsubscribeOnline = new WeakMap();


parcelRequire("3QbnI");

var $e1vzu = parcelRequire("e1vzu");
parcelRequire("3QbnI");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 


var $3QbnI = parcelRequire("3QbnI");


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 





var $a6c3611fd1035310$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $a6c3611fd1035310$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $b1dd18b1cc667557$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $b1dd18b1cc667557$export$d697c39a2985a4c)(options, $a6c3611fd1035310$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $a6c3611fd1035310$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $a6c3611fd1035310$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $a6c3611fd1035310$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $a6c3611fd1035310$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return [];
}





var $1189437f1997725c$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $1189437f1997725c$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $b1dd18b1cc667557$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $b1dd18b1cc667557$export$d697c39a2985a4c)(options, $1189437f1997725c$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $1189437f1997725c$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $4155f8205c990ad5$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $4155f8205c990ad5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $1189437f1997725c$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}





var $112d43873b7d27fb$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $112d43873b7d27fb$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $b1dd18b1cc667557$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $b1dd18b1cc667557$export$d697c39a2985a4c)(options, $112d43873b7d27fb$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $112d43873b7d27fb$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $112d43873b7d27fb$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $112d43873b7d27fb$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $112d43873b7d27fb$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $112d43873b7d27fb$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $b1dd18b1cc667557$export$d697c39a2985a4c)(options, $112d43873b7d27fb$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $112d43873b7d27fb$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $112d43873b7d27fb$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $112d43873b7d27fb$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $112d43873b7d27fb$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return [];
}





var $265296a8957322f6$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $265296a8957322f6$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $4155f8205c990ad5$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $4155f8205c990ad5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $b1dd18b1cc667557$export$d697c39a2985a4c)(options, $265296a8957322f6$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}







function $078eba2008e5e1e7$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $803f8bad65bbae62$export$18ce0697a983be9b)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $078eba2008e5e1e7$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $078eba2008e5e1e7$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $f3c6aa574affa4d1$export$d342343268debc40).formats;
    return (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, mfFormats), f1), {
        date: $078eba2008e5e1e7$var$deepMergeOptions($078eba2008e5e1e7$var$setTimeZoneInOptions(mfFormats.date, timeZone), $078eba2008e5e1e7$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $078eba2008e5e1e7$var$deepMergeOptions($078eba2008e5e1e7$var$setTimeZoneInOptions(mfFormats.time, timeZone), $078eba2008e5e1e7$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $078eba2008e5e1e7$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $9652946c4050d8ce$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $bc39f8568750a8cb$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, defaultRichTextElements), values || {});
    formats = $078eba2008e5e1e7$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $078eba2008e5e1e7$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $77f3caa7b3f1f5a1$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $77f3caa7b3f1f5a1$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $803f8bad65bbae62$export$18ce0697a983be9b)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $77f3caa7b3f1f5a1$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $77f3caa7b3f1f5a1$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};






var $c0615f43f141a939$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $c0615f43f141a939$var$now = Date.now();
function $c0615f43f141a939$var$generateToken(i) {
    return "".concat($c0615f43f141a939$var$now, "_").concat(i, "_").concat($c0615f43f141a939$var$now);
}
function $c0615f43f141a939$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $c0615f43f141a939$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $c0615f43f141a939$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $4155f8205c990ad5$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $4155f8205c990ad5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $b1dd18b1cc667557$export$d697c39a2985a4c)(options, $c0615f43f141a939$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $c0615f43f141a939$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}





var $5e85cbf77fe5c41e$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $5e85cbf77fe5c41e$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $4155f8205c990ad5$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $4155f8205c990ad5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $b1dd18b1cc667557$export$d697c39a2985a4c)(options, $5e85cbf77fe5c41e$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $77f3caa7b3f1f5a1$export$e3b7eee1dbc44895)('Error formatting display name.', locale, e));
    }
}


function $9aaee70eb2428e61$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $9aaee70eb2428e61$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $9aaee70eb2428e61$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $9aaee70eb2428e61$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $b1dd18b1cc667557$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, (0, $b1dd18b1cc667557$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $77f3caa7b3f1f5a1$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $77f3caa7b3f1f5a1$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $77f3caa7b3f1f5a1$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $9aaee70eb2428e61$var$verifyConfigMessages(resolvedConfig);
    return (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $a6c3611fd1035310$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $a6c3611fd1035310$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $1189437f1997725c$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $112d43873b7d27fb$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $112d43873b7d27fb$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $112d43873b7d27fb$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $112d43873b7d27fb$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $112d43873b7d27fb$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $265296a8957322f6$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $078eba2008e5e1e7$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $078eba2008e5e1e7$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $c0615f43f141a939$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $c0615f43f141a939$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $5e85cbf77fe5c41e$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



var $3QbnI = parcelRequire("3QbnI");


function $e8f683ae6dbbb6b5$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $c1e6211c879bb1e5$export$df0c12a2d414a163)(v) ? (0, $df74ec6c7358c66e$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $e8f683ae6dbbb6b5$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $e8f683ae6dbbb6b5$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $078eba2008e5e1e7$export$25868d1e8e76735f).apply(void 0, (0, $803f8bad65bbae62$export$1216008129fb82ed)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $3QbnI.Children.toArray(chunks);
    return chunks;
};
var $e8f683ae6dbbb6b5$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $803f8bad65bbae62$export$3c9a16f847548506)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $e8f683ae6dbbb6b5$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $9aaee70eb2428e61$export$7e4cbedfdd7b4c0d)((0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, (0, $df74ec6c7358c66e$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $803f8bad65bbae62$export$18ce0697a983be9b)((0, $803f8bad65bbae62$export$18ce0697a983be9b)({}, coreIntl), {
        formatMessage: $e8f683ae6dbbb6b5$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $e8f683ae6dbbb6b5$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};


function $5e7f361bd9057075$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $5e7f361bd9057075$var$IntlProvider = /** @class */ function(_super) {
    (0, $803f8bad65bbae62$export$a8ba968b8961cb8a)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $b1dd18b1cc667557$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $e8f683ae6dbbb6b5$export$7e4cbedfdd7b4c0d)($5e7f361bd9057075$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $5e7f361bd9057075$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $5e7f361bd9057075$var$processIntlConfig(props);
        if (!(0, $df74ec6c7358c66e$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: (0, $e8f683ae6dbbb6b5$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $df74ec6c7358c66e$export$45c4bbf6e55bba1f)(this.state.intl);
        return $3QbnI.createElement((0, $d424b4c5f2093f25$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $df74ec6c7358c66e$export$b52f8d6fc0d47415);
    return IntlProvider;
}($3QbnI.PureComponent);
var $5e7f361bd9057075$export$2e2bcd8739ae039 = $5e7f361bd9057075$var$IntlProvider;




const $38511c7205865f42$var$IntlProviderWrapper = (props)=>{
    const { locale: locale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $5e7f361bd9057075$export$2e2bcd8739ae039), {
        locale: locale,
        messages: (0, $d30a5fdc49293dc0$export$bc99aaabaf7b70a7)[locale].translation,
        children: props.children
    });
};
var $38511c7205865f42$export$2e2bcd8739ae039 = $38511c7205865f42$var$IntlProviderWrapper;





const $403c1255315ab8b6$var$AppProviders = (props)=>{
    const queryClient = new (0, $b42cdd8e403361b3$export$405d0624ed55a03f)();
    return /*#__PURE__*/ (0, $e1vzu.jsx)((0, $6772a177ad7746fa$export$d07e18ad7fac0edc), {
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $38511c7205865f42$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $d9e1f0b1f58d3102$export$747289a838051b01), {
                children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $e8dd76247e9dc202$export$fdea2815ccb497e), {
                    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $f6e0a971d72905b7$export$45604f0cc8ae667b), {
                        client: queryClient,
                        children: props.children
                    })
                })
            })
        })
    });
};
var $403c1255315ab8b6$export$2e2bcd8739ae039 = $403c1255315ab8b6$var$AppProviders;



/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $bb276a8c51aa95a3$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $bb276a8c51aa95a3$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $bb276a8c51aa95a3$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $bb276a8c51aa95a3$var$isGlobalObj(window) || typeof self == 'object' && $bb276a8c51aa95a3$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $bb276a8c51aa95a3$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $bb276a8c51aa95a3$export$256479dc0cea61c4() {
    return $bb276a8c51aa95a3$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $bb276a8c51aa95a3$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $bb276a8c51aa95a3$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $8b55cac30e90f863$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$e6127cc7fe7395c3(wat) {
    switch($8b55cac30e90f863$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $8b55cac30e90f863$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$var$isBuiltin(wat, className) {
    return $8b55cac30e90f863$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$9f9636d330b71954(wat) {
    return $8b55cac30e90f863$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$ef9e2056653f0c8e(wat) {
    return $8b55cac30e90f863$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$12e869b2a583f783(wat) {
    return $8b55cac30e90f863$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$844ec244b1367d54(wat) {
    return $8b55cac30e90f863$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$c3825b437cbdea5c(wat) {
    return wat === null || $8b55cac30e90f863$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$53b83ca8eaab0383(wat) {
    return $8b55cac30e90f863$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $8b55cac30e90f863$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $8b55cac30e90f863$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$49841c62b9eff15(wat) {
    return $8b55cac30e90f863$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $8b55cac30e90f863$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$bc2894c7158efbac(wat) {
    return $8b55cac30e90f863$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8b55cac30e90f863$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3cc5e07e84dbdfba$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/** Prefix for logging strings */ const $bf3485ccdac24c3e$var$PREFIX = 'Sentry Logger ';
const $bf3485ccdac24c3e$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $bf3485ccdac24c3e$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $bf3485ccdac24c3e$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($bf3485ccdac24c3e$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $bf3485ccdac24c3e$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $bf3485ccdac24c3e$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $3cc5e07e84dbdfba$export$16a28057038b10ef) $bf3485ccdac24c3e$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $bf3485ccdac24c3e$export$cda52e2a8927a2ca(()=>{
                (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).console[name](`${$bf3485ccdac24c3e$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $bf3485ccdac24c3e$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $bf3485ccdac24c3e$export$af88d00dbe7f521 = $bf3485ccdac24c3e$var$makeLogger();


const $561ba8b5b77a0042$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $561ba8b5b77a0042$export$7740643b9eeaf0c4() {
    return Date.now() / $561ba8b5b77a0042$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $561ba8b5b77a0042$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $561ba8b5b77a0042$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $561ba8b5b77a0042$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $561ba8b5b77a0042$export$ee52dced521e3e18 = $561ba8b5b77a0042$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $561ba8b5b77a0042$export$c5907b5a8838db13 = $561ba8b5b77a0042$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $561ba8b5b77a0042$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $561ba8b5b77a0042$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $561ba8b5b77a0042$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $561ba8b5b77a0042$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $561ba8b5b77a0042$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $561ba8b5b77a0042$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();



// eslint-disable-next-line deprecation/deprecation
const $167dd1da81c36183$var$WINDOW = (0, $bb276a8c51aa95a3$export$256479dc0cea61c4)();
const $167dd1da81c36183$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $167dd1da81c36183$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $167dd1da81c36183$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $167dd1da81c36183$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $167dd1da81c36183$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($167dd1da81c36183$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $8b55cac30e90f863$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $167dd1da81c36183$export$1cfafeee2987818b() {
    try {
        return $167dd1da81c36183$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $167dd1da81c36183$export$c660c1f3ab49225c(selector) {
    if ($167dd1da81c36183$var$WINDOW.document && $167dd1da81c36183$var$WINDOW.document.querySelector) return $167dd1da81c36183$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $167dd1da81c36183$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$167dd1da81c36183$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $f54fd3bbbc09c038$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $f54fd3bbbc09c038$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f54fd3bbbc09c038$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $8b55cac30e90f863$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $f54fd3bbbc09c038$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $8b55cac30e90f863$export$844ec244b1367d54)(value)) return false;
    if ((0, $8b55cac30e90f863$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $8b55cac30e90f863$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $f54fd3bbbc09c038$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$f54fd3bbbc09c038$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $6a842238b70e8ef7$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $6a842238b70e8ef7$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $6a842238b70e8ef7$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $3cc5e07e84dbdfba$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $6a842238b70e8ef7$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $6a842238b70e8ef7$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $6a842238b70e8ef7$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $6a842238b70e8ef7$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $6a842238b70e8ef7$export$62ff257738bf57f5(value) {
    if ((0, $8b55cac30e90f863$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$6a842238b70e8ef7$var$getOwnProperties(value)
    };
    else if ((0, $8b55cac30e90f863$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $6a842238b70e8ef7$var$serializeEventTarget(value.target),
            currentTarget: $6a842238b70e8ef7$var$serializeEventTarget(value.currentTarget),
            ...$6a842238b70e8ef7$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $8b55cac30e90f863$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $6a842238b70e8ef7$var$serializeEventTarget(target) {
    try {
        return (0, $8b55cac30e90f863$export$45a5e7f76e0caa8d)(target) ? (0, $167dd1da81c36183$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $6a842238b70e8ef7$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $6a842238b70e8ef7$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($6a842238b70e8ef7$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $f54fd3bbbc09c038$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $f54fd3bbbc09c038$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $6a842238b70e8ef7$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $6a842238b70e8ef7$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $6a842238b70e8ef7$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($6a842238b70e8ef7$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $6a842238b70e8ef7$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($6a842238b70e8ef7$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $6a842238b70e8ef7$var$isPojo(input) {
    if (!(0, $8b55cac30e90f863$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $6a842238b70e8ef7$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $8b55cac30e90f863$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $c6eb3b4caecfb929$export$19f53698e68b2496() {
    const gbl = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $c6eb3b4caecfb929$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $c6eb3b4caecfb929$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c6eb3b4caecfb929$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $c6eb3b4caecfb929$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $c6eb3b4caecfb929$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c6eb3b4caecfb929$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $c6eb3b4caecfb929$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $c6eb3b4caecfb929$export$d364f2020ab30578(input) {
    const match = input.match($c6eb3b4caecfb929$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $c6eb3b4caecfb929$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $f54fd3bbbc09c038$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $f54fd3bbbc09c038$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $f54fd3bbbc09c038$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $c6eb3b4caecfb929$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $6a842238b70e8ef7$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $c6eb3b4caecfb929$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $3abd3930be9cb831$export$849dbeeeda01ae98 = 'production';


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4429ee8f266bc8f6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;







/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $e588f5833e027c10$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($e588f5833e027c10$var$States || ($e588f5833e027c10$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $e588f5833e027c10$export$1fda8aa4d135f8aa(value) {
    return new $e588f5833e027c10$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $e588f5833e027c10$export$78e43115b553f358(reason) {
    return new $e588f5833e027c10$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $e588f5833e027c10$export$6f292d4960313241 {
    constructor(executor){
        $e588f5833e027c10$export$6f292d4960313241.prototype.__init.call(this);
        $e588f5833e027c10$export$6f292d4960313241.prototype.__init2.call(this);
        $e588f5833e027c10$export$6f292d4960313241.prototype.__init3.call(this);
        $e588f5833e027c10$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $e588f5833e027c10$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $e588f5833e027c10$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $e588f5833e027c10$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($e588f5833e027c10$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($e588f5833e027c10$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $e588f5833e027c10$var$States.PENDING) return;
            if ((0, $8b55cac30e90f863$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $e588f5833e027c10$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $e588f5833e027c10$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $e588f5833e027c10$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $6aba8e18ce70b1d5$export$3c4238858b85e8ac() {
    return (0, $bb276a8c51aa95a3$export$7e223ec222791509)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $6aba8e18ce70b1d5$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $6aba8e18ce70b1d5$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $6aba8e18ce70b1d5$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $e588f5833e027c10$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && processor.id && result === null && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $8b55cac30e90f863$export$f5b060c2914b97c8)(result)) result.then((final)=>$6aba8e18ce70b1d5$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $6aba8e18ce70b1d5$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $c2c0d48545dc295f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $561ba8b5b77a0042$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$c2c0d48545dc295f$var$sessionToJSON(session)
    };
    if (context) $c2c0d48545dc295f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $c2c0d48545dc295f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $561ba8b5b77a0042$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $c2c0d48545dc295f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $c2c0d48545dc295f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $c2c0d48545dc295f$var$sessionToJSON(session) {
    return (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $ea45a8d144ab3501$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $dedd7293d096d014$export$9ca9946bd449ac06 = 'baggage';
const $dedd7293d096d014$export$6e69537d67fa20f = 'sentry-';
const $dedd7293d096d014$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $dedd7293d096d014$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $dedd7293d096d014$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $8b55cac30e90f863$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $dedd7293d096d014$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $dedd7293d096d014$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($dedd7293d096d014$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($dedd7293d096d014$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $dedd7293d096d014$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$dedd7293d096d014$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $dedd7293d096d014$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $dedd7293d096d014$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $dedd7293d096d014$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $dedd7293d096d014$export$bdd844ddb2def819) {
            (0, $3cc5e07e84dbdfba$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $67681cc921dcc55a$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $67681cc921dcc55a$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($67681cc921dcc55a$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $67681cc921dcc55a$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $67681cc921dcc55a$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dedd7293d096d014$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(),
            spanId: (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16),
            spanId: (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $67681cc921dcc55a$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $67681cc921dcc55a$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dedd7293d096d014$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(),
        spanId: (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16),
        spanId: (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $67681cc921dcc55a$export$f35d907436da45cf(traceId = (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(), spanId = (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $92410d3f4bb849a0$export$208d5b368507fb8b = 0x0;
const $92410d3f4bb849a0$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $92410d3f4bb849a0$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $92410d3f4bb849a0$export$92d8c23565496537(span);
    return (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $92410d3f4bb849a0$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $92410d3f4bb849a0$export$5caecac1caaf3a71(span);
    return (0, $67681cc921dcc55a$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $92410d3f4bb849a0$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $92410d3f4bb849a0$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $92410d3f4bb849a0$var$ensureTimestampInSeconds(input.getTime());
    return (0, $561ba8b5b77a0042$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $92410d3f4bb849a0$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $92410d3f4bb849a0$export$92d8c23565496537(span) {
    if ($92410d3f4bb849a0$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $92410d3f4bb849a0$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $92410d3f4bb849a0$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $92410d3f4bb849a0$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $59414fe30ad8ce39$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3abd3930be9cb831$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $59414fe30ad8ce39$export$a117f995597e25df(span) {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $59414fe30ad8ce39$export$366bad00d6815eed((0, $92410d3f4bb849a0$export$92d8c23565496537)(span).trace_id || '', client, (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $ea45a8d144ab3501$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $92410d3f4bb849a0$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $92410d3f4bb849a0$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $8f8d84bc9a6fbea7$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $8f8d84bc9a6fbea7$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $8f8d84bc9a6fbea7$var$applySpanToEvent(event, span);
    $8f8d84bc9a6fbea7$var$applyFingerprintToEvent(event, fingerprint);
    $8f8d84bc9a6fbea7$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $8f8d84bc9a6fbea7$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $8f8d84bc9a6fbea7$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $8f8d84bc9a6fbea7$export$b1a120a2871faa46(data, 'extra', extra);
    $8f8d84bc9a6fbea7$export$b1a120a2871faa46(data, 'tags', tags);
    $8f8d84bc9a6fbea7$export$b1a120a2871faa46(data, 'user', user);
    $8f8d84bc9a6fbea7$export$b1a120a2871faa46(data, 'contexts', contexts);
    $8f8d84bc9a6fbea7$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $8f8d84bc9a6fbea7$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $8f8d84bc9a6fbea7$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $6a842238b70e8ef7$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $6a842238b70e8ef7$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $6a842238b70e8ef7$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $6a842238b70e8ef7$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $8f8d84bc9a6fbea7$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $8f8d84bc9a6fbea7$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $8f8d84bc9a6fbea7$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $92410d3f4bb849a0$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $ea45a8d144ab3501$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $59414fe30ad8ce39$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $92410d3f4bb849a0$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $8f8d84bc9a6fbea7$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $c6eb3b4caecfb929$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $922144eb3383915f$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $922144eb3383915f$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $922144eb3383915f$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $922144eb3383915f$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $922144eb3383915f$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $922144eb3383915f$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $c2c0d48545dc295f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $922144eb3383915f$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $8b55cac30e90f863$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $922144eb3383915f$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $922144eb3383915f$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $561ba8b5b77a0042$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $8f8d84bc9a6fbea7$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $6aba8e18ce70b1d5$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $6aba8e18ce70b1d5$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $922144eb3383915f$export$aa55d5ab8e05984f() {
    if (!$922144eb3383915f$var$globalScope) $922144eb3383915f$var$globalScope = new $922144eb3383915f$export$775b6bb06e53a214();
    return $922144eb3383915f$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $922144eb3383915f$export$c83048efd17527d6(scope) {
    $922144eb3383915f$var$globalScope = scope;
}
function $922144eb3383915f$var$generatePropagationContext() {
    return {
        traceId: (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(),
        spanId: (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16)
    };
}



const $8f9d05859d58902f$export$31499a9cd224b78c = '7.120.2';


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $2d9e797091ea0ff6$export$24a86ef7798177e4 = parseFloat((0, $8f9d05859d58902f$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $2d9e797091ea0ff6$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $2d9e797091ea0ff6$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $2d9e797091ea0ff6$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $922144eb3383915f$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $922144eb3383915f$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $8b55cac30e90f863$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $2d9e797091ea0ff6$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $561ba8b5b77a0042$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $bf3485ccdac24c3e$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $2d9e797091ea0ff6$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $2d9e797091ea0ff6$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $4429ee8f266bc8f6$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $c2c0d48545dc295f$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $3abd3930be9cb831$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $c2c0d48545dc295f$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $c2c0d48545dc295f$export$531818e825e774db)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $2d9e797091ea0ff6$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $2d9e797091ea0ff6$export$19eade501500c6c1() {
    (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $2d9e797091ea0ff6$export$4188a14ad302d1bc(hub) {
    const registry = $2d9e797091ea0ff6$export$19eade501500c6c1();
    const oldHub = $2d9e797091ea0ff6$export$bfa8a924a84a76b7(registry);
    $2d9e797091ea0ff6$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $2d9e797091ea0ff6$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $2d9e797091ea0ff6$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $2d9e797091ea0ff6$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $2d9e797091ea0ff6$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $2d9e797091ea0ff6$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $2d9e797091ea0ff6$var$getGlobalHub(registry = $2d9e797091ea0ff6$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$2d9e797091ea0ff6$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $2d9e797091ea0ff6$export$bfa8a924a84a76b7(registry).isOlderThan($2d9e797091ea0ff6$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $2d9e797091ea0ff6$export$849f05434e95d2f2(registry, new $2d9e797091ea0ff6$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $2d9e797091ea0ff6$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $2d9e797091ea0ff6$export$236689a79f5aa020(carrier, parent = $2d9e797091ea0ff6$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$2d9e797091ea0ff6$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $2d9e797091ea0ff6$export$bfa8a924a84a76b7(carrier).isOlderThan($2d9e797091ea0ff6$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $2d9e797091ea0ff6$export$849f05434e95d2f2(carrier, new $2d9e797091ea0ff6$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $2d9e797091ea0ff6$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $2d9e797091ea0ff6$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $2d9e797091ea0ff6$export$70d775fb1f267027(callback, options = {}) {
    const registry = $2d9e797091ea0ff6$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $2d9e797091ea0ff6$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $2d9e797091ea0ff6$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $bb276a8c51aa95a3$export$7e223ec222791509)('hub', ()=>new $2d9e797091ea0ff6$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $2d9e797091ea0ff6$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $31e6677cc1bc6f1b$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $6325a4ad829c85f2$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $6325a4ad829c85f2$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $6325a4ad829c85f2$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $f7b10308552795e6$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $f7b10308552795e6$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $f7b10308552795e6$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $f7b10308552795e6$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $f7b10308552795e6$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($f7b10308552795e6$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $f7b10308552795e6$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $f7b10308552795e6$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $f7b10308552795e6$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $f7b10308552795e6$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $f7b10308552795e6$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($f7b10308552795e6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($f7b10308552795e6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $f7b10308552795e6$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $f7b10308552795e6$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $f7b10308552795e6$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $f7b10308552795e6$var$defaultFunctionName;
        return fn.name || $f7b10308552795e6$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $f7b10308552795e6$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $f7b10308552795e6$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $6325a4ad829c85f2$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1908c34a72f46e5e$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $1908c34a72f46e5e$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $1908c34a72f46e5e$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $1908c34a72f46e5e$export$a3295358bff77e(object, depth);
    if ($1908c34a72f46e5e$var$jsonSize(normalized) > maxSize) return $1908c34a72f46e5e$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $1908c34a72f46e5e$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $31e6677cc1bc6f1b$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $8b55cac30e90f863$export$c9f5652083b8129d)(value)) return value;
    const stringified = $1908c34a72f46e5e$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $1908c34a72f46e5e$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $6a842238b70e8ef7$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $1908c34a72f46e5e$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $1908c34a72f46e5e$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $8b55cac30e90f863$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $8b55cac30e90f863$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $f7b10308552795e6$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $1908c34a72f46e5e$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $1908c34a72f46e5e$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $1908c34a72f46e5e$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1908c34a72f46e5e$var$jsonSize(value) {
    return $1908c34a72f46e5e$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $1908c34a72f46e5e$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $dd0a854b4ac70026$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $561ba8b5b77a0042$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $dd0a854b4ac70026$var$applyClientOptions(prepared, options);
    $dd0a854b4ac70026$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $dd0a854b4ac70026$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $dd0a854b4ac70026$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $c6eb3b4caecfb929$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $922144eb3383915f$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $8f8d84bc9a6fbea7$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $8f8d84bc9a6fbea7$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8f8d84bc9a6fbea7$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $6aba8e18ce70b1d5$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $6aba8e18ce70b1d5$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $dd0a854b4ac70026$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $dd0a854b4ac70026$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $dd0a854b4ac70026$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $3abd3930be9cb831$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $f54fd3bbbc09c038$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $f54fd3bbbc09c038$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $f54fd3bbbc09c038$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $dd0a854b4ac70026$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $dd0a854b4ac70026$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $dd0a854b4ac70026$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $dd0a854b4ac70026$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $dd0a854b4ac70026$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $dd0a854b4ac70026$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $dd0a854b4ac70026$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $1908c34a72f46e5e$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $1908c34a72f46e5e$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $1908c34a72f46e5e$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $1908c34a72f46e5e$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $1908c34a72f46e5e$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $92410d3f4bb849a0$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $1908c34a72f46e5e$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $dd0a854b4ac70026$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $922144eb3383915f$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $dd0a854b4ac70026$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($dd0a854b4ac70026$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($dd0a854b4ac70026$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $dd0a854b4ac70026$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $922144eb3383915f$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $dd0a854b4ac70026$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $dd0a854b4ac70026$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$dd0a854b4ac70026$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $abd5e84d35afb05d$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().captureException(exception, (0, $dd0a854b4ac70026$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $abd5e84d35afb05d$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $abd5e84d35afb05d$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $abd5e84d35afb05d$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $abd5e84d35afb05d$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $abd5e84d35afb05d$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $abd5e84d35afb05d$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $abd5e84d35afb05d$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $abd5e84d35afb05d$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $abd5e84d35afb05d$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $abd5e84d35afb05d$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $abd5e84d35afb05d$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $abd5e84d35afb05d$export$9a4fed82c350c2bd(callback) {
    return (0, $2d9e797091ea0ff6$export$70d775fb1f267027)(()=>{
        return callback((0, $2d9e797091ea0ff6$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $abd5e84d35afb05d$export$e57ac09b143d92a2(span, callback) {
    return $abd5e84d35afb05d$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $abd5e84d35afb05d$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $abd5e84d35afb05d$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $abd5e84d35afb05d$export$c7be4b0125a10cba();
    const client = $abd5e84d35afb05d$export$6bb76d6eba7e258c();
    if (!client) (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $abd5e84d35afb05d$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $abd5e84d35afb05d$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $561ba8b5b77a0042$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $abd5e84d35afb05d$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $561ba8b5b77a0042$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $8b55cac30e90f863$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $abd5e84d35afb05d$export$4909b86c8034bf73(timeout) {
    const client = $abd5e84d35afb05d$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $abd5e84d35afb05d$export$8360e631d277ea4d(timeout) {
    const client = $abd5e84d35afb05d$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $abd5e84d35afb05d$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $abd5e84d35afb05d$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $abd5e84d35afb05d$export$3f95c6f800b78024() {
    return !!$abd5e84d35afb05d$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $abd5e84d35afb05d$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $abd5e84d35afb05d$export$c0d84948cecf78d8(context) {
    const client = $abd5e84d35afb05d$export$6bb76d6eba7e258c();
    const isolationScope = (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)();
    const currentScope = $abd5e84d35afb05d$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $3abd3930be9cb831$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $c2c0d48545dc295f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $c2c0d48545dc295f$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $abd5e84d35afb05d$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $abd5e84d35afb05d$export$17a5be43989a0bc1() {
    const isolationScope = (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)();
    const currentScope = $abd5e84d35afb05d$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $c2c0d48545dc295f$export$56521d9ba90f62ee)(session);
    $abd5e84d35afb05d$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $abd5e84d35afb05d$var$_sendSessionUpdate() {
    const isolationScope = (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)();
    const currentScope = $abd5e84d35afb05d$export$c7be4b0125a10cba();
    const client = $abd5e84d35afb05d$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $abd5e84d35afb05d$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $abd5e84d35afb05d$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $abd5e84d35afb05d$var$_sendSessionUpdate();
}








const $4a01cec229b54112$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $4a01cec229b54112$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $4a01cec229b54112$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $c6eb3b4caecfb929$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $4a01cec229b54112$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $4a01cec229b54112$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $4a01cec229b54112$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $4a01cec229b54112$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $4a01cec229b54112$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $4a01cec229b54112$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($4a01cec229b54112$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $6aba8e18ce70b1d5$export$8e4e25f54d456511), (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c));
        $4a01cec229b54112$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $4a01cec229b54112$export$2d8f5188773bcddd(integration) {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $4a01cec229b54112$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $4a01cec229b54112$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $4a01cec229b54112$export$2323046b9414659f(fn) {
    return fn;
}


let $ca088bc72b53c643$var$originalFunctionToString;
const $ca088bc72b53c643$var$INTEGRATION_NAME = 'FunctionToString';
const $ca088bc72b53c643$var$SETUP_CLIENTS = new WeakMap();
const $ca088bc72b53c643$var$_functionToStringIntegration = ()=>{
    return {
        name: $ca088bc72b53c643$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ca088bc72b53c643$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $6a842238b70e8ef7$export$e6cc1e135e2092e5)(this);
                    const context = $ca088bc72b53c643$var$SETUP_CLIENTS.has((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ca088bc72b53c643$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ca088bc72b53c643$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ca088bc72b53c643$export$7918117e9202e4fb = (0, $4a01cec229b54112$export$2323046b9414659f)($ca088bc72b53c643$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ca088bc72b53c643$export$da4704525c20ae79 = (0, $4a01cec229b54112$export$afa219bf23651160)($ca088bc72b53c643$var$INTEGRATION_NAME, $ca088bc72b53c643$export$7918117e9202e4fb);



/** Regular expression used to parse a Dsn. */ const $c7b6a1388971733a$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $c7b6a1388971733a$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $c7b6a1388971733a$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $c7b6a1388971733a$export$b892860177f70a30(str) {
    const match = $c7b6a1388971733a$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $bf3485ccdac24c3e$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $c7b6a1388971733a$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $c7b6a1388971733a$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $c7b6a1388971733a$var$validateDsn(dsn) {
    if (!(0, $3cc5e07e84dbdfba$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$c7b6a1388971733a$var$isValidProtocol(protocol)) {
        (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $c7b6a1388971733a$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $c7b6a1388971733a$export$b892860177f70a30(from) : $c7b6a1388971733a$var$dsnFromComponents(from);
    if (!components || !$c7b6a1388971733a$var$validateDsn(components)) return undefined;
    return components;
}


const $b7bc135f16935b4e$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b7bc135f16935b4e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $b7bc135f16935b4e$var$_getIngestEndpoint(dsn) {
    return `${$b7bc135f16935b4e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b7bc135f16935b4e$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $6a842238b70e8ef7$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $b7bc135f16935b4e$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $b7bc135f16935b4e$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$b7bc135f16935b4e$var$_getIngestEndpoint(dsn)}?${$b7bc135f16935b4e$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $b7bc135f16935b4e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $c7b6a1388971733a$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$b7bc135f16935b4e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $c7b6a1388971733a$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $19ec35e67a3940c6$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $19ec35e67a3940c6$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $19ec35e67a3940c6$var$INTEGRATION_NAME = 'InboundFilters';
const $19ec35e67a3940c6$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $19ec35e67a3940c6$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $19ec35e67a3940c6$var$_mergeOptions(options, clientOptions);
            return $19ec35e67a3940c6$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $19ec35e67a3940c6$export$cb3c5c2ceb9818ba = (0, $4a01cec229b54112$export$2323046b9414659f)($19ec35e67a3940c6$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $19ec35e67a3940c6$export$2ffbb5359dcc6be4 = (0, $4a01cec229b54112$export$afa219bf23651160)($19ec35e67a3940c6$var$INTEGRATION_NAME, $19ec35e67a3940c6$export$cb3c5c2ceb9818ba);
function $19ec35e67a3940c6$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $19ec35e67a3940c6$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $19ec35e67a3940c6$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $19ec35e67a3940c6$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $19ec35e67a3940c6$var$_isSentryError(event)) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($19ec35e67a3940c6$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($19ec35e67a3940c6$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($19ec35e67a3940c6$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)}.\nUrl: ${$19ec35e67a3940c6$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$19ec35e67a3940c6$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)}.\nUrl: ${$19ec35e67a3940c6$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $19ec35e67a3940c6$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $19ec35e67a3940c6$var$_getPossibleEventMessages(event).some((message)=>(0, $f54fd3bbbc09c038$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $19ec35e67a3940c6$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $f54fd3bbbc09c038$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $19ec35e67a3940c6$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $19ec35e67a3940c6$var$_getEventFilterUrl(event);
    return !url ? false : (0, $f54fd3bbbc09c038$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $19ec35e67a3940c6$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $19ec35e67a3940c6$var$_getEventFilterUrl(event);
    return !url ? true : (0, $f54fd3bbbc09c038$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $19ec35e67a3940c6$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $4429ee8f266bc8f6$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $19ec35e67a3940c6$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $19ec35e67a3940c6$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $19ec35e67a3940c6$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $19ec35e67a3940c6$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $1d21d82df9f39f81$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $4429ee8f266bc8f6$export$16a28057038b10ef) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $bf3485ccdac24c3e$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $1d21d82df9f39f81$export$ecb76f41d43c0e43(client);
    $1d21d82df9f39f81$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $1d21d82df9f39f81$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $1d21d82df9f39f81$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $41f0e719e5a32882$var$WINDOW = (0, $bb276a8c51aa95a3$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $41f0e719e5a32882$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $41f0e719e5a32882$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $41f0e719e5a32882$var$WINDOW && !!$41f0e719e5a32882$var$WINDOW.history.pushState && !!$41f0e719e5a32882$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}





// We keep the handlers globally
const $048e762f46e1343d$var$handlers = {};
const $048e762f46e1343d$var$instrumented = {};
/** Add a handler function. */ function $048e762f46e1343d$export$a4e09611e30da72e(type, handler) {
    $048e762f46e1343d$var$handlers[type] = $048e762f46e1343d$var$handlers[type] || [];
    $048e762f46e1343d$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $048e762f46e1343d$export$b17eab759a1cb5fe() {
    Object.keys($048e762f46e1343d$var$handlers).forEach((key)=>{
        $048e762f46e1343d$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $048e762f46e1343d$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$048e762f46e1343d$var$instrumented[type]) {
        instrumentFn();
        $048e762f46e1343d$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $048e762f46e1343d$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $048e762f46e1343d$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $3cc5e07e84dbdfba$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $f7b10308552795e6$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


const $64bd59e2066d26bd$var$WINDOW = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
let $64bd59e2066d26bd$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $64bd59e2066d26bd$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $048e762f46e1343d$export$a4e09611e30da72e)(type, handler);
    (0, $048e762f46e1343d$export$e18d6c5462c01368)(type, $64bd59e2066d26bd$var$instrumentHistory);
}
function $64bd59e2066d26bd$var$instrumentHistory() {
    if (!(0, $41f0e719e5a32882$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $64bd59e2066d26bd$var$WINDOW.onpopstate;
    $64bd59e2066d26bd$var$WINDOW.onpopstate = function(...args) {
        const to = $64bd59e2066d26bd$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $64bd59e2066d26bd$var$lastHref;
        $64bd59e2066d26bd$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $048e762f46e1343d$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $64bd59e2066d26bd$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $64bd59e2066d26bd$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $048e762f46e1343d$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)($64bd59e2066d26bd$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)($64bd59e2066d26bd$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}




// eslint-disable-next-line deprecation/deprecation
const $f3b31d8953feae60$var$WINDOW = (0, $bb276a8c51aa95a3$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $f3b31d8953feae60$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $f3b31d8953feae60$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $f3b31d8953feae60$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $f3b31d8953feae60$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $f3b31d8953feae60$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f3b31d8953feae60$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $f3b31d8953feae60$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$f3b31d8953feae60$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($f3b31d8953feae60$export$18cf36ed71d733e7($f3b31d8953feae60$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $f3b31d8953feae60$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $f3b31d8953feae60$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $3cc5e07e84dbdfba$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $f3b31d8953feae60$export$531055a6c684a70a() {
    return 'ReportingObserver' in $f3b31d8953feae60$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $f3b31d8953feae60$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$f3b31d8953feae60$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $79de85ad73085df5$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $8f9d05859d58902f$export$31499a9cd224b78c)
            })),
        version: (0, $8f9d05859d58902f$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b7a488e859caf65f$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b7a488e859caf65f$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $b7a488e859caf65f$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $b7a488e859caf65f$export$604a45d95a155e2b(envelope, types) {
    return $b7a488e859caf65f$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $b7a488e859caf65f$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $b7a488e859caf65f$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $b7a488e859caf65f$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $b7a488e859caf65f$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $1908c34a72f46e5e$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $b7a488e859caf65f$var$concatBuffers(parts);
}
function $b7a488e859caf65f$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $b7a488e859caf65f$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $b7a488e859caf65f$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $b7a488e859caf65f$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $b7a488e859caf65f$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $b7a488e859caf65f$export$b11169581eeaf237(type) {
    return $b7a488e859caf65f$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $b7a488e859caf65f$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $b7a488e859caf65f$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $c7b6a1388971733a$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $d33c42a198d04107$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $865d250a7e864acf$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $865d250a7e864acf$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b7a488e859caf65f$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $c7b6a1388971733a$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $b7a488e859caf65f$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $865d250a7e864acf$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b7a488e859caf65f$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $865d250a7e864acf$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $b7a488e859caf65f$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $b7a488e859caf65f$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $503fb71501c466e3$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $6a842238b70e8ef7$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $503fb71501c466e3$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $503fb71501c466e3$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $503fb71501c466e3$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $503fb71501c466e3$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $503fb71501c466e3$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $503fb71501c466e3$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        '\\u{7c}'
    ],
    [
        ',',
        '\\u{2c}'
    ]
];
function $503fb71501c466e3$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $503fb71501c466e3$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $503fb71501c466e3$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $503fb71501c466e3$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $503fb71501c466e3$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $503fb71501c466e3$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $503fb71501c466e3$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $0f2cdec0116f06b4$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $c7b6a1388971733a$export$44d472fbb931a776)(dsn);
    const item = $0f2cdec0116f06b4$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $b7a488e859caf65f$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $0f2cdec0116f06b4$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $503fb71501c466e3$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $39e6a3d3c61ae59d$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $39e6a3d3c61ae59d$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $c7b6a1388971733a$export$128827c3562ec0cb)(options.dsn);
        else (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $b7bc135f16935b4e$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $c6eb3b4caecfb929$export$6de4ffac6a2f1098)(exception)) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log($39e6a3d3c61ae59d$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $8b55cac30e90f863$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $8b55cac30e90f863$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $c6eb3b4caecfb929$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log($39e6a3d3c61ae59d$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $c2c0d48545dc295f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $e588f5833e027c10$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $4a01cec229b54112$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $4a01cec229b54112$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $865d250a7e864acf$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $b7a488e859caf65f$export$d650323442802f6f)(env, (0, $b7a488e859caf65f$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $865d250a7e864acf$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $0f2cdec0116f06b4$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $4a01cec229b54112$export$51abed9797baa598)(this, integrations);
        (0, $4a01cec229b54112$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $c2c0d48545dc295f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $e588f5833e027c10$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $dd0a854b4ac70026$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $59414fe30ad8ce39$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $4429ee8f266bc8f6$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $39e6a3d3c61ae59d$var$isTransactionEvent(event);
        const isError = $39e6a3d3c61ae59d$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $e588f5833e027c10$export$78e43115b553f358)(new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $39e6a3d3c61ae59d$var$processBeforeSend(options, prepared, hint);
            return $39e6a3d3c61ae59d$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $d33c42a198d04107$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('Error while sending event:', reason);
        });
        else (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $39e6a3d3c61ae59d$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $8b55cac30e90f863$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $8b55cac30e90f863$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $8b55cac30e90f863$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $39e6a3d3c61ae59d$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($39e6a3d3c61ae59d$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($39e6a3d3c61ae59d$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $39e6a3d3c61ae59d$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $39e6a3d3c61ae59d$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $39e6a3d3c61ae59d$export$9aac0b9f77928fbf(callback) {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $3b7bb305d94647f5$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $561ba8b5b77a0042$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $b7a488e859caf65f$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $lvfvG = parcelRequire("lvfvG");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b2eeeba0caf24d57$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $a84473c052e46d22$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $a84473c052e46d22$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $a84473c052e46d22$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $a84473c052e46d22$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $8b55cac30e90f863$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $a84473c052e46d22$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $1908c34a72f46e5e$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $a84473c052e46d22$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $a84473c052e46d22$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $a84473c052e46d22$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $a84473c052e46d22$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $a84473c052e46d22$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $a84473c052e46d22$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a84473c052e46d22$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($a84473c052e46d22$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a84473c052e46d22$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a84473c052e46d22$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a84473c052e46d22$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $c6eb3b4caecfb929$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $e588f5833e027c10$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a84473c052e46d22$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a84473c052e46d22$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $e588f5833e027c10$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $a84473c052e46d22$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $8b55cac30e90f863$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $a84473c052e46d22$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $8b55cac30e90f863$export$ef9e2056653f0c8e)(exception) || (0, $8b55cac30e90f863$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $a84473c052e46d22$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $8b55cac30e90f863$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $a84473c052e46d22$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $c6eb3b4caecfb929$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $8b55cac30e90f863$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $a84473c052e46d22$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $8b55cac30e90f863$export$53b83ca8eaab0383)(exception) || (0, $8b55cac30e90f863$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $a84473c052e46d22$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $c6eb3b4caecfb929$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a84473c052e46d22$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $c6eb3b4caecfb929$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $c6eb3b4caecfb929$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $a84473c052e46d22$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $a84473c052e46d22$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $8b55cac30e90f863$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $a84473c052e46d22$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $6a842238b70e8ef7$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $8b55cac30e90f863$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $8b55cac30e90f863$export$9671ea99bd126ace)(exception)) {
        const className = $a84473c052e46d22$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $a84473c052e46d22$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $99f5a5ddfc0686db$export$56d8a8a25bd48b81 = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
let $99f5a5ddfc0686db$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $99f5a5ddfc0686db$export$b79738ab10c590b2() {
    return $99f5a5ddfc0686db$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $99f5a5ddfc0686db$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $99f5a5ddfc0686db$var$ignoreOnError++;
    setTimeout(()=>{
        $99f5a5ddfc0686db$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $99f5a5ddfc0686db$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $6a842238b70e8ef7$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$99f5a5ddfc0686db$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $99f5a5ddfc0686db$export$1265a142ff5ba165();
            (0, $abd5e84d35afb05d$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $c6eb3b4caecfb929$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $c6eb3b4caecfb929$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $abd5e84d35afb05d$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $6a842238b70e8ef7$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $6a842238b70e8ef7$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $98194661ae3ca138$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $c7b6a1388971733a$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $98194661ae3ca138$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $b7a488e859caf65f$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $98194661ae3ca138$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $009e106d9e6068ab$export$1df9218a526d318d extends (0, $39e6a3d3c61ae59d$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $lvfvG.getSDKSource)();
        (0, $79de85ad73085df5$export$b9f95b027256052c)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document) (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $a84473c052e46d22$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $a84473c052e46d22$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $98194661ae3ca138$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $3b7bb305d94647f5$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $c7b6a1388971733a$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $536b5da25a720d6f$var$WINDOW = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
const $536b5da25a720d6f$var$DEBOUNCE_DURATION = 1000;
let $536b5da25a720d6f$var$debounceTimerID;
let $536b5da25a720d6f$var$lastCapturedEventType;
let $536b5da25a720d6f$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $536b5da25a720d6f$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $048e762f46e1343d$export$a4e09611e30da72e)(type, handler);
    (0, $048e762f46e1343d$export$e18d6c5462c01368)(type, $536b5da25a720d6f$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $536b5da25a720d6f$export$3014bbf0af0e1d4a() {
    if (!$536b5da25a720d6f$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $048e762f46e1343d$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $536b5da25a720d6f$var$makeDOMEventHandler(triggerDOMHandler, true);
    $536b5da25a720d6f$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $536b5da25a720d6f$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $536b5da25a720d6f$var$WINDOW[target] && $536b5da25a720d6f$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $536b5da25a720d6f$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $536b5da25a720d6f$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $536b5da25a720d6f$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $536b5da25a720d6f$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $536b5da25a720d6f$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $536b5da25a720d6f$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $536b5da25a720d6f$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($536b5da25a720d6f$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $6a842238b70e8ef7$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $6a842238b70e8ef7$export$e73679ffaf56810e)(target, '_sentryId', (0, $c6eb3b4caecfb929$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$536b5da25a720d6f$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $536b5da25a720d6f$var$lastCapturedEventType = event.type;
            $536b5da25a720d6f$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($536b5da25a720d6f$var$debounceTimerID);
        $536b5da25a720d6f$var$debounceTimerID = $536b5da25a720d6f$var$WINDOW.setTimeout(()=>{
            $536b5da25a720d6f$var$lastCapturedEventTargetId = undefined;
            $536b5da25a720d6f$var$lastCapturedEventType = undefined;
        }, $536b5da25a720d6f$var$DEBOUNCE_DURATION);
    };
}
function $536b5da25a720d6f$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $88f50094cddfae7e$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $048e762f46e1343d$export$a4e09611e30da72e)(type, handler);
    (0, $048e762f46e1343d$export$e18d6c5462c01368)(type, $88f50094cddfae7e$var$instrumentConsole);
}
function $88f50094cddfae7e$var$instrumentConsole() {
    if (!('console' in (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1))) return;
    (0, $bf3485ccdac24c3e$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).console)) return;
        (0, $6a842238b70e8ef7$export$9563e054e6f787fb)((0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $bf3485ccdac24c3e$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $048e762f46e1343d$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $bf3485ccdac24c3e$export$77c4ce905194557b)[level];
                log && log.apply((0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3ecb445c99cc1b01$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $048e762f46e1343d$export$a4e09611e30da72e)(type, handler);
    (0, $048e762f46e1343d$export$e18d6c5462c01368)(type, $3ecb445c99cc1b01$var$instrumentFetch);
}
function $3ecb445c99cc1b01$var$instrumentFetch() {
    if (!(0, $f3b31d8953feae60$export$c82d238e23c40b21)()) return;
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)((0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $3ecb445c99cc1b01$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $048e762f46e1343d$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $048e762f46e1343d$export$b18c893e424d3127)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $048e762f46e1343d$export$b18c893e424d3127)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $3ecb445c99cc1b01$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $3ecb445c99cc1b01$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($3ecb445c99cc1b01$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $3ecb445c99cc1b01$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $3ecb445c99cc1b01$var$getUrlFromResource(url),
            method: $3ecb445c99cc1b01$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $3ecb445c99cc1b01$var$getUrlFromResource(arg),
        method: $3ecb445c99cc1b01$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}





const $911e5e354121e865$var$WINDOW = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
const $911e5e354121e865$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $911e5e354121e865$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $048e762f46e1343d$export$a4e09611e30da72e)(type, handler);
    (0, $048e762f46e1343d$export$e18d6c5462c01368)(type, $911e5e354121e865$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $911e5e354121e865$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$911e5e354121e865$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $8b55cac30e90f863$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $911e5e354121e865$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$911e5e354121e865$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$911e5e354121e865$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $048e762f46e1343d$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$911e5e354121e865$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $8b55cac30e90f863$export$844ec244b1367d54)(header) && (0, $8b55cac30e90f863$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$911e5e354121e865$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $048e762f46e1343d$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $911e5e354121e865$var$parseUrl(url) {
    if ((0, $8b55cac30e90f863$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $8fa0e4f9edeffeaf$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $8fa0e4f9edeffeaf$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $8fa0e4f9edeffeaf$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $8fa0e4f9edeffeaf$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $aadd3e5096e903cd$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $aadd3e5096e903cd$export$e01cef29b4327697(level) {
    return $aadd3e5096e903cd$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $aadd3e5096e903cd$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $aadd3e5096e903cd$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $ea3c6017a25c58fd$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $ea3c6017a25c58fd$var$INTEGRATION_NAME = 'Breadcrumbs';
const $ea3c6017a25c58fd$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $ea3c6017a25c58fd$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $88f50094cddfae7e$export$1d6e0d073f9e6723)($ea3c6017a25c58fd$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $536b5da25a720d6f$export$5aeffd3db2cf9df7)($ea3c6017a25c58fd$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $911e5e354121e865$export$26ace48dd54c9aea)($ea3c6017a25c58fd$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $3ecb445c99cc1b01$export$f75d3c772c923df0)($ea3c6017a25c58fd$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $64bd59e2066d26bd$export$3f18c56c58114e75)($ea3c6017a25c58fd$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $ea3c6017a25c58fd$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $ea3c6017a25c58fd$export$c079d904b326663a = (0, $4a01cec229b54112$export$2323046b9414659f)($ea3c6017a25c58fd$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ea3c6017a25c58fd$export$2dc68d50d56fbbd = (0, $4a01cec229b54112$export$afa219bf23651160)($ea3c6017a25c58fd$var$INTEGRATION_NAME, $ea3c6017a25c58fd$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $ea3c6017a25c58fd$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client) return;
        (0, $abd5e84d35afb05d$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $c6eb3b4caecfb929$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $ea3c6017a25c58fd$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $ea3c6017a25c58fd$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$ea3c6017a25c58fd$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$ea3c6017a25c58fd$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $ea3c6017a25c58fd$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $ea3c6017a25c58fd$var$_isEvent(event) ? event.target : event;
            target = (0, $167dd1da81c36183$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $167dd1da81c36183$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $abd5e84d35afb05d$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $ea3c6017a25c58fd$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $aadd3e5096e903cd$export$d771ef054122c30a)(handlerData.level),
            message: (0, $f54fd3bbbc09c038$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $f54fd3bbbc09c038$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $abd5e84d35afb05d$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $ea3c6017a25c58fd$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $911e5e354121e865$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $abd5e84d35afb05d$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $ea3c6017a25c58fd$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $abd5e84d35afb05d$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $abd5e84d35afb05d$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $ea3c6017a25c58fd$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $8fa0e4f9edeffeaf$export$7a5253c0f62e0150)((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $8fa0e4f9edeffeaf$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $8fa0e4f9edeffeaf$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $abd5e84d35afb05d$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $ea3c6017a25c58fd$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $1d629906f94b0577$var$INTEGRATION_NAME = 'Dedupe';
const $1d629906f94b0577$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $1d629906f94b0577$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($1d629906f94b0577$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $1d629906f94b0577$export$6d39aa44cd0c7567 = (0, $4a01cec229b54112$export$2323046b9414659f)($1d629906f94b0577$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1d629906f94b0577$export$688d98c249d31ad3 = (0, $4a01cec229b54112$export$afa219bf23651160)($1d629906f94b0577$var$INTEGRATION_NAME, $1d629906f94b0577$export$6d39aa44cd0c7567);
function $1d629906f94b0577$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($1d629906f94b0577$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($1d629906f94b0577$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $1d629906f94b0577$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$1d629906f94b0577$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$1d629906f94b0577$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $1d629906f94b0577$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $1d629906f94b0577$var$_getExceptionFromEvent(previousEvent);
    const currentException = $1d629906f94b0577$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$1d629906f94b0577$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$1d629906f94b0577$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $1d629906f94b0577$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $1d629906f94b0577$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $1d629906f94b0577$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $1d629906f94b0577$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $1d629906f94b0577$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $1d629906f94b0577$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}





let $11244bd884ec8a28$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $11244bd884ec8a28$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $048e762f46e1343d$export$a4e09611e30da72e)(type, handler);
    (0, $048e762f46e1343d$export$e18d6c5462c01368)(type, $11244bd884ec8a28$var$instrumentError);
}
function $11244bd884ec8a28$var$instrumentError() {
    $11244bd884ec8a28$var$_oldOnErrorHandler = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).onerror;
    (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $048e762f46e1343d$export$b18c893e424d3127)('error', handlerData);
        if ($11244bd884ec8a28$var$_oldOnErrorHandler && !$11244bd884ec8a28$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $11244bd884ec8a28$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $5a54cba2c18a495d$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5a54cba2c18a495d$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $048e762f46e1343d$export$a4e09611e30da72e)(type, handler);
    (0, $048e762f46e1343d$export$e18d6c5462c01368)(type, $5a54cba2c18a495d$var$instrumentUnhandledRejection);
}
function $5a54cba2c18a495d$var$instrumentUnhandledRejection() {
    $5a54cba2c18a495d$var$_oldOnUnhandledRejectionHandler = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $048e762f46e1343d$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($5a54cba2c18a495d$var$_oldOnUnhandledRejectionHandler && !$5a54cba2c18a495d$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $5a54cba2c18a495d$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $172eb6fb11a8d37b$var$INTEGRATION_NAME = 'GlobalHandlers';
const $172eb6fb11a8d37b$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $172eb6fb11a8d37b$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $172eb6fb11a8d37b$var$_installGlobalOnErrorHandler(client);
                $172eb6fb11a8d37b$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $172eb6fb11a8d37b$var$_installGlobalOnUnhandledRejectionHandler(client);
                $172eb6fb11a8d37b$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $172eb6fb11a8d37b$export$66acc70e8cf2b71a = (0, $4a01cec229b54112$export$2323046b9414659f)($172eb6fb11a8d37b$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $172eb6fb11a8d37b$export$204155decbc90e5a = (0, $4a01cec229b54112$export$afa219bf23651160)($172eb6fb11a8d37b$var$INTEGRATION_NAME, $172eb6fb11a8d37b$export$66acc70e8cf2b71a);
function $172eb6fb11a8d37b$var$_installGlobalOnErrorHandler(client) {
    (0, $11244bd884ec8a28$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $172eb6fb11a8d37b$var$getOptions();
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client || (0, $99f5a5ddfc0686db$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $8b55cac30e90f863$export$844ec244b1367d54)(msg) ? $172eb6fb11a8d37b$var$_eventFromIncompleteOnError(msg, url, line, column) : $172eb6fb11a8d37b$var$_enhanceEventWithInitialFrame((0, $a84473c052e46d22$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $abd5e84d35afb05d$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $172eb6fb11a8d37b$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $5a54cba2c18a495d$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $172eb6fb11a8d37b$var$getOptions();
        if ((0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)() !== client || (0, $99f5a5ddfc0686db$export$b79738ab10c590b2)()) return;
        const error = $172eb6fb11a8d37b$var$_getUnhandledRejectionError(e);
        const event = (0, $8b55cac30e90f863$export$c3825b437cbdea5c)(error) ? $172eb6fb11a8d37b$var$_eventFromRejectionWithPrimitive(error) : (0, $a84473c052e46d22$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $abd5e84d35afb05d$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $172eb6fb11a8d37b$var$_getUnhandledRejectionError(error) {
    if ((0, $8b55cac30e90f863$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $172eb6fb11a8d37b$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $172eb6fb11a8d37b$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $8b55cac30e90f863$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $172eb6fb11a8d37b$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $172eb6fb11a8d37b$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $8b55cac30e90f863$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $167dd1da81c36183$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $172eb6fb11a8d37b$var$globalHandlerLog(type) {
    (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $172eb6fb11a8d37b$var$getOptions() {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $cf8ca1ca6fe8d77b$var$INTEGRATION_NAME = 'HttpContext';
const $cf8ca1ca6fe8d77b$var$_httpContextIntegration = ()=>{
    return {
        name: $cf8ca1ca6fe8d77b$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).navigator && !(0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location && !(0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $cf8ca1ca6fe8d77b$export$1378794447170364 = (0, $4a01cec229b54112$export$2323046b9414659f)($cf8ca1ca6fe8d77b$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $cf8ca1ca6fe8d77b$export$5d2ee9a544b09a94 = (0, $4a01cec229b54112$export$afa219bf23651160)($cf8ca1ca6fe8d77b$var$INTEGRATION_NAME, $cf8ca1ca6fe8d77b$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $5731cfbc8edbab31$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $8b55cac30e90f863$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $5731cfbc8edbab31$var$truncateAggregateExceptions($5731cfbc8edbab31$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $5731cfbc8edbab31$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $8b55cac30e90f863$export$49034edbe6b62415)(error[key], Error)) {
        $5731cfbc8edbab31$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $5731cfbc8edbab31$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $5731cfbc8edbab31$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $8b55cac30e90f863$export$49034edbe6b62415)(childError, Error)) {
            $5731cfbc8edbab31$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $5731cfbc8edbab31$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $5731cfbc8edbab31$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $5731cfbc8edbab31$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $5731cfbc8edbab31$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $5731cfbc8edbab31$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $f54fd3bbbc09c038$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $658ca9460e996f86$var$DEFAULT_KEY = 'cause';
const $658ca9460e996f86$var$DEFAULT_LIMIT = 5;
const $658ca9460e996f86$var$INTEGRATION_NAME = 'LinkedErrors';
const $658ca9460e996f86$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $658ca9460e996f86$var$DEFAULT_LIMIT;
    const key = options.key || $658ca9460e996f86$var$DEFAULT_KEY;
    return {
        name: $658ca9460e996f86$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $5731cfbc8edbab31$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $a84473c052e46d22$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $658ca9460e996f86$export$ebabb00eb7f3a395 = (0, $4a01cec229b54112$export$2323046b9414659f)($658ca9460e996f86$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $658ca9460e996f86$export$8d1e60aaf616fb4f = (0, $4a01cec229b54112$export$afa219bf23651160)($658ca9460e996f86$var$INTEGRATION_NAME, $658ca9460e996f86$export$ebabb00eb7f3a395);





const $6287429ba267fb1a$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $6287429ba267fb1a$var$INTEGRATION_NAME = 'TryCatch';
const $6287429ba267fb1a$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $6287429ba267fb1a$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $6a842238b70e8ef7$export$9563e054e6f787fb)((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81), 'setTimeout', $6287429ba267fb1a$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $6a842238b70e8ef7$export$9563e054e6f787fb)((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81), 'setInterval', $6287429ba267fb1a$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $6a842238b70e8ef7$export$9563e054e6f787fb)((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81), 'requestAnimationFrame', $6287429ba267fb1a$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81)) (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $6287429ba267fb1a$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $6287429ba267fb1a$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($6287429ba267fb1a$var$_wrapEventTarget);
            }
        }
    };
};
const $6287429ba267fb1a$export$59bfe9f1c76150e = (0, $4a01cec229b54112$export$2323046b9414659f)($6287429ba267fb1a$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6287429ba267fb1a$export$f1a018517668e6d3 = (0, $4a01cec229b54112$export$afa219bf23651160)($6287429ba267fb1a$var$INTEGRATION_NAME, $6287429ba267fb1a$export$59bfe9f1c76150e);
function $6287429ba267fb1a$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $99f5a5ddfc0686db$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $f7b10308552795e6$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6287429ba267fb1a$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $99f5a5ddfc0686db$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $f7b10308552795e6$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $6287429ba267fb1a$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $f7b10308552795e6$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $6a842238b70e8ef7$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $f7b10308552795e6$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $99f5a5ddfc0686db$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $6287429ba267fb1a$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $99f5a5ddfc0686db$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $f7b10308552795e6$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $99f5a5ddfc0686db$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $f7b10308552795e6$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $d99d0305fd30e3d7$var$UNKNOWN_FUNCTION = '?';
const $d99d0305fd30e3d7$var$OPERA10_PRIORITY = 10;
const $d99d0305fd30e3d7$var$OPERA11_PRIORITY = 20;
const $d99d0305fd30e3d7$var$CHROME_PRIORITY = 30;
const $d99d0305fd30e3d7$var$WINJS_PRIORITY = 40;
const $d99d0305fd30e3d7$var$GECKO_PRIORITY = 50;
function $d99d0305fd30e3d7$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $d99d0305fd30e3d7$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $d99d0305fd30e3d7$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $d99d0305fd30e3d7$var$chromeStackParserFn = (line)=>{
    const parts = $d99d0305fd30e3d7$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $d99d0305fd30e3d7$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $d99d0305fd30e3d7$var$extractSafariExtensionDetails(parts[1] || $d99d0305fd30e3d7$var$UNKNOWN_FUNCTION, parts[2]);
        return $d99d0305fd30e3d7$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $d99d0305fd30e3d7$export$263a749fff749872 = [
    $d99d0305fd30e3d7$var$CHROME_PRIORITY,
    $d99d0305fd30e3d7$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $d99d0305fd30e3d7$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $d99d0305fd30e3d7$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $d99d0305fd30e3d7$var$gecko = (line)=>{
    const parts = $d99d0305fd30e3d7$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $d99d0305fd30e3d7$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $d99d0305fd30e3d7$var$UNKNOWN_FUNCTION;
        [func, filename] = $d99d0305fd30e3d7$var$extractSafariExtensionDetails(func, filename);
        return $d99d0305fd30e3d7$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $d99d0305fd30e3d7$export$cdba47a5dd2804d = [
    $d99d0305fd30e3d7$var$GECKO_PRIORITY,
    $d99d0305fd30e3d7$var$gecko
];
const $d99d0305fd30e3d7$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $d99d0305fd30e3d7$var$winjs = (line)=>{
    const parts = $d99d0305fd30e3d7$var$winjsRegex.exec(line);
    return parts ? $d99d0305fd30e3d7$var$createFrame(parts[2], parts[1] || $d99d0305fd30e3d7$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $d99d0305fd30e3d7$export$179460296da408e8 = [
    $d99d0305fd30e3d7$var$WINJS_PRIORITY,
    $d99d0305fd30e3d7$var$winjs
];
const $d99d0305fd30e3d7$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $d99d0305fd30e3d7$var$opera10 = (line)=>{
    const parts = $d99d0305fd30e3d7$var$opera10Regex.exec(line);
    return parts ? $d99d0305fd30e3d7$var$createFrame(parts[2], parts[3] || $d99d0305fd30e3d7$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $d99d0305fd30e3d7$export$f892b52c880ffc7a = [
    $d99d0305fd30e3d7$var$OPERA10_PRIORITY,
    $d99d0305fd30e3d7$var$opera10
];
const $d99d0305fd30e3d7$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $d99d0305fd30e3d7$var$opera11 = (line)=>{
    const parts = $d99d0305fd30e3d7$var$opera11Regex.exec(line);
    return parts ? $d99d0305fd30e3d7$var$createFrame(parts[5], parts[3] || parts[4] || $d99d0305fd30e3d7$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $d99d0305fd30e3d7$export$af11af13f09fb0dc = [
    $d99d0305fd30e3d7$var$OPERA11_PRIORITY,
    $d99d0305fd30e3d7$var$opera11
];
const $d99d0305fd30e3d7$export$7197c0fe6554c079 = [
    $d99d0305fd30e3d7$export$263a749fff749872,
    $d99d0305fd30e3d7$export$cdba47a5dd2804d,
    $d99d0305fd30e3d7$export$179460296da408e8
];
const $d99d0305fd30e3d7$export$2b2b997d81bf3907 = (0, $f7b10308552795e6$export$a5739666fb2d03d4)(...$d99d0305fd30e3d7$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $d99d0305fd30e3d7$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $d99d0305fd30e3d7$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $81e6cd8bc80dbb83$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $81e6cd8bc80dbb83$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $81e6cd8bc80dbb83$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $81e6cd8bc80dbb83$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $81e6cd8bc80dbb83$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $81e6cd8bc80dbb83$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $81e6cd8bc80dbb83$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $81e6cd8bc80dbb83$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $51d7d2d72eefe176$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $e588f5833e027c10$export$78e43115b553f358)(new (0, $d33c42a198d04107$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $e588f5833e027c10$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $e588f5833e027c10$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $04a2b564b29e8002$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $04a2b564b29e8002$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $51d7d2d72eefe176$export$85a4f67f852183e6)(options.bufferSize || $04a2b564b29e8002$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $b7a488e859caf65f$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $b7a488e859caf65f$export$b11169581eeaf237)(type);
            if ((0, $81e6cd8bc80dbb83$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $04a2b564b29e8002$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $e588f5833e027c10$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $b7a488e859caf65f$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $b7a488e859caf65f$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $04a2b564b29e8002$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $b7a488e859caf65f$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $b7a488e859caf65f$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $81e6cd8bc80dbb83$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $d33c42a198d04107$export$5949942ba2a7c0e2)) {
                (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $e588f5833e027c10$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $04a2b564b29e8002$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $5b726f8ecdbca1a5$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $5b726f8ecdbca1a5$export$8be2119ce08e3379() {
    if ($5b726f8ecdbca1a5$var$cachedFetchImpl) return $5b726f8ecdbca1a5$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $f3b31d8953feae60$export$18cf36ed71d733e7)((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).fetch)) return $5b726f8ecdbca1a5$var$cachedFetchImpl = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).fetch.bind((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81));
    const document = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $5b726f8ecdbca1a5$var$cachedFetchImpl = fetchImpl.bind((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $5b726f8ecdbca1a5$export$d499686d2dd738c6() {
    $5b726f8ecdbca1a5$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $712213f14787c6d4$export$b2311068c46d7cc8(options, nativeFetch = (0, $5b726f8ecdbca1a5$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $5b726f8ecdbca1a5$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $e588f5833e027c10$export$78e43115b553f358)(e);
        }
    }
    return (0, $04a2b564b29e8002$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $8d8982c2675d6da4$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8d8982c2675d6da4$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $e588f5833e027c10$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8d8982c2675d6da4$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $04a2b564b29e8002$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $3a8c241c71bb62e6$export$5ef831fccfce35e5 = [
    (0, $19ec35e67a3940c6$export$cb3c5c2ceb9818ba)(),
    (0, $ca088bc72b53c643$export$7918117e9202e4fb)(),
    (0, $6287429ba267fb1a$export$59bfe9f1c76150e)(),
    (0, $ea3c6017a25c58fd$export$c079d904b326663a)(),
    (0, $172eb6fb11a8d37b$export$66acc70e8cf2b71a)(),
    (0, $658ca9460e996f86$export$ebabb00eb7f3a395)(),
    (0, $1d629906f94b0577$export$6d39aa44cd0c7567)(),
    (0, $cf8ca1ca6fe8d77b$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $3a8c241c71bb62e6$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$3a8c241c71bb62e6$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $3a8c241c71bb62e6$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $3a8c241c71bb62e6$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $f7b10308552795e6$export$1d5cf88b347146d4)(options.stackParser || (0, $d99d0305fd30e3d7$export$2b2b997d81bf3907)),
        integrations: (0, $4a01cec229b54112$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $f3b31d8953feae60$export$edf3cb81fd7d2a3e)() ? (0, $712213f14787c6d4$export$b2311068c46d7cc8) : (0, $8d8982c2675d6da4$export$5e1441cee30d5a39))
    };
    (0, $1d21d82df9f39f81$export$5333c3f1c58d9bc1)((0, $009e106d9e6068ab$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $3a8c241c71bb62e6$var$startSessionTracking();
}
const $3a8c241c71bb62e6$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document) {
        (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $b7bc135f16935b4e$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document.head || (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3a8c241c71bb62e6$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3a8c241c71bb62e6$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3a8c241c71bb62e6$export$4997ffc0176396a6(fn) {
    return (0, $99f5a5ddfc0686db$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $3a8c241c71bb62e6$var$startSessionTracking() {
    if (typeof (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $b2eeeba0caf24d57$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $abd5e84d35afb05d$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $abd5e84d35afb05d$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $64bd59e2066d26bd$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $abd5e84d35afb05d$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $abd5e84d35afb05d$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $3a8c241c71bb62e6$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $77125ddf85bcd489$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $79de85ad73085df5$export$b9f95b027256052c)(opts, 'react');
    (0, $3a8c241c71bb62e6$export$2cd8252107eb640b)(opts);
}









/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $4fb0e2bcdfaf27ed$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $4fb0e2bcdfaf27ed$export$8e9a29865c0a1226 = (0, $67681cc921dcc55a$export$8e9a29865c0a1226);


let $aa518312f31c3fa4$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $aa518312f31c3fa4$export$637857c1d87b640c() {
    if ($aa518312f31c3fa4$var$errorsInstrumented) return;
    $aa518312f31c3fa4$var$errorsInstrumented = true;
    (0, $11244bd884ec8a28$export$55b5c3ba2194f0c6)($aa518312f31c3fa4$var$errorCallback);
    (0, $5a54cba2c18a495d$export$8bf4fc6858821a4e)($aa518312f31c3fa4$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $aa518312f31c3fa4$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $4fb0e2bcdfaf27ed$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$aa518312f31c3fa4$var$errorCallback.tag = 'sentry_tracingErrorCallback';




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $5a0b96e8c20f2120$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $5a0b96e8c20f2120$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $5a0b96e8c20f2120$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $8b55cac30e90f863$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $9516542fb3c72171$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $735ba79a0f62e676$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
    const scope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $735ba79a0f62e676$var$normalizeContext(context);
    const activeSpan = $735ba79a0f62e676$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $5a0b96e8c20f2120$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $735ba79a0f62e676$export$a1bd95187356f372(context, callback) {
    const spanContext = $735ba79a0f62e676$var$normalizeContext(context);
    return (0, $2d9e797091ea0ff6$export$70d775fb1f267027)(()=>{
        return (0, $abd5e84d35afb05d$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $735ba79a0f62e676$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $5a0b96e8c20f2120$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $92410d3f4bb849a0$export$92d8c23565496537)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $735ba79a0f62e676$export$cb9e396e6b90b703 = $735ba79a0f62e676$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $735ba79a0f62e676$export$c10292ad04b92aea(context, callback) {
    const spanContext = $735ba79a0f62e676$var$normalizeContext(context);
    return (0, $2d9e797091ea0ff6$export$70d775fb1f267027)(()=>{
        return (0, $abd5e84d35afb05d$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $735ba79a0f62e676$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $5a0b96e8c20f2120$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $92410d3f4bb849a0$export$92d8c23565496537)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $735ba79a0f62e676$export$63dbba021a6b4047(context) {
    if (!(0, $9516542fb3c72171$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $735ba79a0f62e676$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $735ba79a0f62e676$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $735ba79a0f62e676$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $735ba79a0f62e676$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)().getSpan();
}
const $735ba79a0f62e676$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $67681cc921dcc55a$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $4429ee8f266bc8f6$export$16a28057038b10ef) && traceparentData) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $2d9e797091ea0ff6$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $735ba79a0f62e676$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $9516542fb3c72171$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $59414fe30ad8ce39$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $92410d3f4bb849a0$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $735ba79a0f62e676$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $735ba79a0f62e676$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $92410d3f4bb849a0$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $735ba79a0f62e676$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $735ba79a0f62e676$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $735ba79a0f62e676$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $6a842238b70e8ef7$export$e73679ffaf56810e)(span, $735ba79a0f62e676$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $6a842238b70e8ef7$export$e73679ffaf56810e)(span, $735ba79a0f62e676$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $735ba79a0f62e676$export$c08fbc656a245d03(span) {
    return {
        scope: span[$735ba79a0f62e676$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$735ba79a0f62e676$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $99dac51826b92dc3$var$SPAN_METRIC_SUMMARY;
function $99dac51826b92dc3$var$getMetricStorageForSpan(span) {
    return $99dac51826b92dc3$var$SPAN_METRIC_SUMMARY ? $99dac51826b92dc3$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $99dac51826b92dc3$export$2e7205e45c58797d(span) {
    const storage = $99dac51826b92dc3$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $6a842238b70e8ef7$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $99dac51826b92dc3$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $735ba79a0f62e676$export$1be426a8e585c83e)();
    if (span) {
        const storage = $99dac51826b92dc3$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$99dac51826b92dc3$var$SPAN_METRIC_SUMMARY) $99dac51826b92dc3$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $99dac51826b92dc3$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $fee337bd2c89db0b$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $fee337bd2c89db0b$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $fee337bd2c89db0b$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $fee337bd2c89db0b$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $fee337bd2c89db0b$export$1efec95406bbe327 = 'profile_id';




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $b6377485fae4d830$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($b6377485fae4d830$export$beb8e6a823e89c5d || ($b6377485fae4d830$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $b6377485fae4d830$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $b6377485fae4d830$export$ac65c70d78fcdb55 = $b6377485fae4d830$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $b6377485fae4d830$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $b6377485fae4d830$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $2b0775d2aa0f79a1$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $2b0775d2aa0f79a1$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $561ba8b5b77a0042$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $fee337bd2c89db0b$export$cca8dd30f57f805e)]: spanContext.origin || 'manual',
            [(0, $fee337bd2c89db0b$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $fee337bd2c89db0b$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $fee337bd2c89db0b$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $fee337bd2c89db0b$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $fee337bd2c89db0b$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $92410d3f4bb849a0$export$eb571cd9b5d98de8) : (0, $92410d3f4bb849a0$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $2b0775d2aa0f79a1$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $ea45a8d144ab3501$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $4429ee8f266bc8f6$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $92410d3f4bb849a0$export$92d8c23565496537)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $b6377485fae4d830$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $ea45a8d144ab3501$export$c4c6a79b1260ca1b)(this);
        if ((0, $4429ee8f266bc8f6$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $92410d3f4bb849a0$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $92410d3f4bb849a0$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $92410d3f4bb849a0$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $fee337bd2c89db0b$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $fee337bd2c89db0b$export$cca8dd30f57f805e],
            _metrics_summary: (0, $99dac51826b92dc3$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $fee337bd2c89db0b$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $d6471399972638de$export$febc5573c75cefb0 extends (0, $2b0775d2aa0f79a1$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $fee337bd2c89db0b$export$d7a7d984b0791405] && {
                source: this._attributes[0, $fee337bd2c89db0b$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $fee337bd2c89db0b$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $fee337bd2c89db0b$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $fee337bd2c89db0b$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $2b0775d2aa0f79a1$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $92410d3f4bb849a0$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $59414fe30ad8ce39$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $92410d3f4bb849a0$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $92410d3f4bb849a0$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $735ba79a0f62e676$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $92410d3f4bb849a0$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $59414fe30ad8ce39$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $99dac51826b92dc3$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $edf6573b7c1effc3$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $edf6573b7c1effc3$var$FINISH_REASON_TAG = 'finishReason';
const $edf6573b7c1effc3$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $edf6573b7c1effc3$export$370d6113c18ba86c extends (0, $2b0775d2aa0f79a1$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $92410d3f4bb849a0$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $edf6573b7c1effc3$export$b279e6bd7040371f extends (0, $d6471399972638de$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $edf6573b7c1effc3$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $edf6573b7c1effc3$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $edf6573b7c1effc3$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $edf6573b7c1effc3$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $edf6573b7c1effc3$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $92410d3f4bb849a0$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($edf6573b7c1effc3$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $92410d3f4bb849a0$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $92410d3f4bb849a0$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $4429ee8f266bc8f6$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] flushing IdleTransaction');
        } else (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $edf6573b7c1effc3$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $edf6573b7c1effc3$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $edf6573b7c1effc3$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $561ba8b5b77a0042$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $edf6573b7c1effc3$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $edf6573b7c1effc3$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $3d4de32c29caf7e1$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $9516542fb3c72171$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $fee337bd2c89db0b$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $fee337bd2c89db0b$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $fee337bd2c89db0b$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $fee337bd2c89db0b$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$3d4de32c29caf7e1$export$2603c8d332a51c42(sampleRate)) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $92410d3f4bb849a0$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $3d4de32c29caf7e1$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $8b55cac30e90f863$export$c9f5652083b8129d)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $b69b9fb1590d3703$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $92410d3f4bb849a0$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $b69b9fb1590d3703$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $4429ee8f266bc8f6$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $d6471399972638de$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $3d4de32c29caf7e1$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $b69b9fb1590d3703$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $edf6573b7c1effc3$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $3d4de32c29caf7e1$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $b69b9fb1590d3703$export$653d0ef2bad9cdf9() {
    const carrier = (0, $2d9e797091ea0ff6$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $b69b9fb1590d3703$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $b69b9fb1590d3703$var$traceHeaders;
    (0, $aa518312f31c3fa4$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2abc507e195761ce$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $975aaf7edad12874$export$56d8a8a25bd48b81 = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $f26da202598dfa3d$export$6f18f55521af71a1() {
    if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document) (0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $4fb0e2bcdfaf27ed$export$a7feb32fdd923295)();
        if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $92410d3f4bb849a0$export$92d8c23565496537)(activeTransaction);
            (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




const $6182943fb3a2b96b$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $691308e4462ecbac$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b2cf5db2787615c3$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $975aaf7edad12874$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $975aaf7edad12874$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $b2cf5db2787615c3$export$6431553786c94949 = ()=>{
    if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $975aaf7edad12874$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $b2cf5db2787615c3$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $975aaf7edad12874$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8a8a3f46711f93b2$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $b2cf5db2787615c3$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $62139dc1051d5891$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $b2cf5db2787615c3$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.prerendering || (0, $8a8a3f46711f93b2$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $691308e4462ecbac$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $4e9dd8e78aa892c1$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e432b83dcde5cf89$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $f2228469f570763d$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $62139dc1051d5891$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $4e9dd8e78aa892c1$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $6182943fb3a2b96b$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $e432b83dcde5cf89$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $4a419405a5114e27$var$firstHiddenTime = -1;
const $4a419405a5114e27$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.visibilityState) $4a419405a5114e27$var$firstHiddenTime = (0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $4a419405a5114e27$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $e432b83dcde5cf89$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $4a419405a5114e27$var$firstHiddenTime = timeStamp;
    }, true);
};
const $4a419405a5114e27$export$443f86b2c77012c4 = ()=>{
    if ($4a419405a5114e27$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $4a419405a5114e27$var$initHiddenTime();
        $4a419405a5114e27$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $4a419405a5114e27$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $8426feb9b0e95a3b$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $4a419405a5114e27$export$443f86b2c77012c4)();
    const metric = (0, $62139dc1051d5891$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $4e9dd8e78aa892c1$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $6182943fb3a2b96b$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $e432b83dcde5cf89$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $7862e17daea3ed23$var$interactionCountEstimate = 0;
let $7862e17daea3ed23$var$minKnownInteractionId = Infinity;
let $7862e17daea3ed23$var$maxKnownInteractionId = 0;
const $7862e17daea3ed23$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $7862e17daea3ed23$var$minKnownInteractionId = Math.min($7862e17daea3ed23$var$minKnownInteractionId, e.interactionId);
            $7862e17daea3ed23$var$maxKnownInteractionId = Math.max($7862e17daea3ed23$var$maxKnownInteractionId, e.interactionId);
            $7862e17daea3ed23$var$interactionCountEstimate = $7862e17daea3ed23$var$maxKnownInteractionId ? ($7862e17daea3ed23$var$maxKnownInteractionId - $7862e17daea3ed23$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $7862e17daea3ed23$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $7862e17daea3ed23$export$8a962f2683a476d1 = ()=>{
    return $7862e17daea3ed23$var$po ? $7862e17daea3ed23$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $7862e17daea3ed23$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $7862e17daea3ed23$var$po) return;
    $7862e17daea3ed23$var$po = (0, $4e9dd8e78aa892c1$export$d1203567a167490e)('event', $7862e17daea3ed23$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $c290ce4eb5712173$var$getInteractionCountForNavigation = ()=>{
    return (0, $7862e17daea3ed23$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $c290ce4eb5712173$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $c290ce4eb5712173$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $c290ce4eb5712173$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $c290ce4eb5712173$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $c290ce4eb5712173$var$longestInteractionList[$c290ce4eb5712173$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $c290ce4eb5712173$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $c290ce4eb5712173$var$longestInteractionList.length < $c290ce4eb5712173$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $c290ce4eb5712173$var$longestInteractionMap[interaction.id] = interaction;
            $c290ce4eb5712173$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $c290ce4eb5712173$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $c290ce4eb5712173$var$longestInteractionList.splice($c290ce4eb5712173$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $c290ce4eb5712173$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $c290ce4eb5712173$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($c290ce4eb5712173$var$longestInteractionList.length - 1, Math.floor($c290ce4eb5712173$var$getInteractionCountForNavigation() / 50));
    return $c290ce4eb5712173$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c290ce4eb5712173$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $7862e17daea3ed23$export$67d90cda6b78a2eb)();
    const metric = (0, $62139dc1051d5891$export$3c29b44508a0612b)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $c290ce4eb5712173$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$c290ce4eb5712173$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $c290ce4eb5712173$var$processEntry(entry);
            }
        });
        const inp = $c290ce4eb5712173$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $4e9dd8e78aa892c1$export$d1203567a167490e)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $6182943fb3a2b96b$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $e432b83dcde5cf89$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $c290ce4eb5712173$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9dd3faecf7d34b7a$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $9dd3faecf7d34b7a$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $4a419405a5114e27$export$443f86b2c77012c4)();
    const metric = (0, $62139dc1051d5891$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $8a8a3f46711f93b2$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $4e9dd8e78aa892c1$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $6182943fb3a2b96b$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$9dd3faecf7d34b7a$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $9dd3faecf7d34b7a$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $e432b83dcde5cf89$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $270fbc77963c86bd$var$whenReady = (callback)=>{
    if (!(0, $975aaf7edad12874$export$56d8a8a25bd48b81).document) return;
    if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>$270fbc77963c86bd$var$whenReady(callback), true);
    else if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$270fbc77963c86bd$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $270fbc77963c86bd$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $62139dc1051d5891$export$3c29b44508a0612b)('TTFB');
    const report = (0, $6182943fb3a2b96b$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $270fbc77963c86bd$var$whenReady(()=>{
        const navEntry = (0, $b2cf5db2787615c3$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $8a8a3f46711f93b2$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $2d276c9689c1344d$var$handlers = {};
const $2d276c9689c1344d$var$instrumented = {};
let $2d276c9689c1344d$var$_previousCls;
let $2d276c9689c1344d$var$_previousFid;
let $2d276c9689c1344d$var$_previousLcp;
let $2d276c9689c1344d$var$_previousTtfb;
let $2d276c9689c1344d$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $2d276c9689c1344d$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $2d276c9689c1344d$var$addMetricObserver('cls', callback, $2d276c9689c1344d$var$instrumentCls, $2d276c9689c1344d$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $2d276c9689c1344d$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $2d276c9689c1344d$var$addMetricObserver('lcp', callback, $2d276c9689c1344d$var$instrumentLcp, $2d276c9689c1344d$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $2d276c9689c1344d$export$699d9529c099a797(callback) {
    return $2d276c9689c1344d$var$addMetricObserver('ttfb', callback, $2d276c9689c1344d$var$instrumentTtfb, $2d276c9689c1344d$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $2d276c9689c1344d$export$2707d7471c0b918f(callback) {
    return $2d276c9689c1344d$var$addMetricObserver('fid', callback, $2d276c9689c1344d$var$instrumentFid, $2d276c9689c1344d$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $2d276c9689c1344d$export$da3b76aa2022cbd7(callback) {
    return $2d276c9689c1344d$var$addMetricObserver('inp', callback, $2d276c9689c1344d$var$instrumentInp, $2d276c9689c1344d$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $2d276c9689c1344d$export$69816c1a049f8db6(type, callback) {
    $2d276c9689c1344d$var$addHandler(type, callback);
    if (!$2d276c9689c1344d$var$instrumented[type]) {
        $2d276c9689c1344d$var$instrumentPerformanceObserver(type);
        $2d276c9689c1344d$var$instrumented[type] = true;
    }
    return $2d276c9689c1344d$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $2d276c9689c1344d$var$triggerHandlers(type, data) {
    const typeHandlers = $2d276c9689c1344d$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $f7b10308552795e6$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $2d276c9689c1344d$var$instrumentCls() {
    return (0, $f2228469f570763d$export$a7873055838e5ad8)((metric)=>{
        $2d276c9689c1344d$var$triggerHandlers('cls', {
            metric: metric
        });
        $2d276c9689c1344d$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $2d276c9689c1344d$var$instrumentFid() {
    return (0, $8426feb9b0e95a3b$export$39705a25c49af873)((metric)=>{
        $2d276c9689c1344d$var$triggerHandlers('fid', {
            metric: metric
        });
        $2d276c9689c1344d$var$_previousFid = metric;
    });
}
function $2d276c9689c1344d$var$instrumentLcp() {
    return (0, $9dd3faecf7d34b7a$export$947b1626ab8d5632)((metric)=>{
        $2d276c9689c1344d$var$triggerHandlers('lcp', {
            metric: metric
        });
        $2d276c9689c1344d$var$_previousLcp = metric;
    });
}
function $2d276c9689c1344d$var$instrumentTtfb() {
    return (0, $270fbc77963c86bd$export$33a01e6c5f2c7e33)((metric)=>{
        $2d276c9689c1344d$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $2d276c9689c1344d$var$_previousTtfb = metric;
    });
}
function $2d276c9689c1344d$var$instrumentInp() {
    return (0, $c290ce4eb5712173$export$7df4b36ecaed99e1)((metric)=>{
        $2d276c9689c1344d$var$triggerHandlers('inp', {
            metric: metric
        });
        $2d276c9689c1344d$var$_previousInp = metric;
    });
}
function $2d276c9689c1344d$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $2d276c9689c1344d$var$addHandler(type, callback);
    let stopListening;
    if (!$2d276c9689c1344d$var$instrumented[type]) {
        stopListening = instrumentFn();
        $2d276c9689c1344d$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $2d276c9689c1344d$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $2d276c9689c1344d$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $4e9dd8e78aa892c1$export$d1203567a167490e)(type, (entries)=>{
        $2d276c9689c1344d$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $2d276c9689c1344d$var$addHandler(type, handler) {
    $2d276c9689c1344d$var$handlers[type] = $2d276c9689c1344d$var$handlers[type] || [];
    $2d276c9689c1344d$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $2d276c9689c1344d$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $2d276c9689c1344d$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



/**
 * Create envelope from Span item.
 */ function $c9a6b0353049298f$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $c7b6a1388971733a$export$44d472fbb931a776)(dsn);
    const items = spans.map($c9a6b0353049298f$var$createSpanItem);
    return (0, $b7a488e859caf65f$export$f93f7f385160c44e)(headers, items);
}
function $c9a6b0353049298f$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $31482096a26a4379$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $4fb0e2bcdfaf27ed$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}







/**
 * Checks if a given value is a valid measurement value.
 */ function $d7a6a3bda06984c7$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $d7a6a3bda06984c7$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $9139ed090d7a9cd2$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $9139ed090d7a9cd2$var$msToSec(time) {
    return time / 1000;
}
function $9139ed090d7a9cd2$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $975aaf7edad12874$export$56d8a8a25bd48b81) && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).addEventListener && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).performance;
}
let $9139ed090d7a9cd2$var$_performanceCursor = 0;
let $9139ed090d7a9cd2$var$_measurements = {};
let $9139ed090d7a9cd2$var$_lcpEntry;
let $9139ed090d7a9cd2$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $9139ed090d7a9cd2$export$7c69f0412d101b88() {
    const performance = $9139ed090d7a9cd2$var$getBrowserPerformanceAPI();
    if (performance && (0, $561ba8b5b77a0042$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $975aaf7edad12874$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCallback = $9139ed090d7a9cd2$var$_trackFID();
        const clsCallback = $9139ed090d7a9cd2$var$_trackCLS();
        const lcpCallback = $9139ed090d7a9cd2$var$_trackLCP();
        const ttfbCallback = $9139ed090d7a9cd2$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $9139ed090d7a9cd2$export$f396d19077034ad2() {
    (0, $2d276c9689c1344d$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $4fb0e2bcdfaf27ed$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $9139ed090d7a9cd2$var$msToSec((0, $561ba8b5b77a0042$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $9139ed090d7a9cd2$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $9139ed090d7a9cd2$export$e27543e0976315e4() {
    (0, $2d276c9689c1344d$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $4fb0e2bcdfaf27ed$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $9139ed090d7a9cd2$var$msToSec((0, $561ba8b5b77a0042$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $9139ed090d7a9cd2$var$msToSec(entry.duration);
                const span = {
                    description: (0, $167dd1da81c36183$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $167dd1da81c36183$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $9139ed090d7a9cd2$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $9139ed090d7a9cd2$var$getBrowserPerformanceAPI();
    if (performance && (0, $561ba8b5b77a0042$export$baf075a948ffc0bf)) {
        const inpCallback = $9139ed090d7a9cd2$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $9139ed090d7a9cd2$var$_trackCLS() {
    return (0, $2d276c9689c1344d$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding CLS');
        $9139ed090d7a9cd2$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $9139ed090d7a9cd2$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $9139ed090d7a9cd2$var$_trackLCP() {
    return (0, $2d276c9689c1344d$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding LCP');
        $9139ed090d7a9cd2$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $9139ed090d7a9cd2$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $9139ed090d7a9cd2$var$_trackFID() {
    return (0, $2d276c9689c1344d$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $9139ed090d7a9cd2$var$msToSec((0, $561ba8b5b77a0042$export$baf075a948ffc0bf));
        const startTime = $9139ed090d7a9cd2$var$msToSec(entry.startTime);
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding FID');
        $9139ed090d7a9cd2$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $9139ed090d7a9cd2$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $9139ed090d7a9cd2$var$_trackTtfb() {
    return (0, $2d276c9689c1344d$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding TTFB');
        $9139ed090d7a9cd2$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $9139ed090d7a9cd2$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $9139ed090d7a9cd2$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $2d276c9689c1344d$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $9139ed090d7a9cd2$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $9139ed090d7a9cd2$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $9139ed090d7a9cd2$var$msToSec((0, $561ba8b5b77a0042$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $9139ed090d7a9cd2$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $2b0775d2aa0f79a1$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $167dd1da81c36183$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $9139ed090d7a9cd2$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $c9a6b0353049298f$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $9139ed090d7a9cd2$export$5f8fa6b3467a7443(transaction) {
    const performance = $9139ed090d7a9cd2$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $975aaf7edad12874$export$56d8a8a25bd48b81).performance.getEntries || !(0, $561ba8b5b77a0042$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $9139ed090d7a9cd2$var$msToSec((0, $561ba8b5b77a0042$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $92410d3f4bb849a0$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($9139ed090d7a9cd2$var$_performanceCursor).forEach((entry)=>{
        const startTime = $9139ed090d7a9cd2$var$msToSec(entry.startTime);
        const duration = $9139ed090d7a9cd2$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $9139ed090d7a9cd2$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $9139ed090d7a9cd2$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $4a419405a5114e27$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding FP');
                        $9139ed090d7a9cd2$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding FCP');
                        $9139ed090d7a9cd2$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $9139ed090d7a9cd2$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $9139ed090d7a9cd2$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $9139ed090d7a9cd2$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $9139ed090d7a9cd2$var$_addTtfbRequestTimeToMeasurements($9139ed090d7a9cd2$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$9139ed090d7a9cd2$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $9139ed090d7a9cd2$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $9139ed090d7a9cd2$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $9139ed090d7a9cd2$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $9139ed090d7a9cd2$var$_measurements['mark.fid'];
        if (fidMark && $9139ed090d7a9cd2$var$_measurements['fid']) {
            // create span for FID
            (0, $d7a6a3bda06984c7$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $9139ed090d7a9cd2$var$msToSec($9139ed090d7a9cd2$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $9139ed090d7a9cd2$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $9139ed090d7a9cd2$var$_measurements)) delete $9139ed090d7a9cd2$var$_measurements.cls;
        Object.keys($9139ed090d7a9cd2$var$_measurements).forEach((measurementName)=>{
            (0, $31482096a26a4379$export$7cc31b475d33a706)(measurementName, $9139ed090d7a9cd2$var$_measurements[measurementName].value, $9139ed090d7a9cd2$var$_measurements[measurementName].unit);
        });
        $9139ed090d7a9cd2$var$_tagMetricInfo(transaction);
    }
    $9139ed090d7a9cd2$var$_lcpEntry = undefined;
    $9139ed090d7a9cd2$var$_clsEntry = undefined;
    $9139ed090d7a9cd2$var$_measurements = {};
}
/** Create measure related spans */ function $9139ed090d7a9cd2$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $d7a6a3bda06984c7$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9139ed090d7a9cd2$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $9139ed090d7a9cd2$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $9139ed090d7a9cd2$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $9139ed090d7a9cd2$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $9139ed090d7a9cd2$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $9139ed090d7a9cd2$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $9139ed090d7a9cd2$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $d7a6a3bda06984c7$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $9139ed090d7a9cd2$var$msToSec(start),
        endTimestamp: timeOrigin + $9139ed090d7a9cd2$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9139ed090d7a9cd2$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $d7a6a3bda06984c7$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $9139ed090d7a9cd2$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $9139ed090d7a9cd2$var$msToSec(entry.responseEnd)
        });
        (0, $d7a6a3bda06984c7$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $9139ed090d7a9cd2$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $9139ed090d7a9cd2$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $9139ed090d7a9cd2$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $8fa0e4f9edeffeaf$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $9139ed090d7a9cd2$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $9139ed090d7a9cd2$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $9139ed090d7a9cd2$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $975aaf7edad12874$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $d7a6a3bda06984c7$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $975aaf7edad12874$export$56d8a8a25bd48b81).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $9139ed090d7a9cd2$var$_trackNavigator(transaction) {
    const navigator = (0, $975aaf7edad12874$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $d7a6a3bda06984c7$export$27169ccae1b439e3)(connection.rtt)) $9139ed090d7a9cd2$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $d7a6a3bda06984c7$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $d7a6a3bda06984c7$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $9139ed090d7a9cd2$var$_tagMetricInfo(transaction) {
    if ($9139ed090d7a9cd2$var$_lcpEntry) {
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($9139ed090d7a9cd2$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $167dd1da81c36183$export$5647df6b7814ac86)($9139ed090d7a9cd2$var$_lcpEntry.element));
        if ($9139ed090d7a9cd2$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $9139ed090d7a9cd2$var$_lcpEntry.id);
        if ($9139ed090d7a9cd2$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $9139ed090d7a9cd2$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $9139ed090d7a9cd2$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($9139ed090d7a9cd2$var$_clsEntry && $9139ed090d7a9cd2$var$_clsEntry.sources) {
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding CLS Data');
        $9139ed090d7a9cd2$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $167dd1da81c36183$export$5647df6b7814ac86)(source.node)));
    }
}
function $9139ed090d7a9cd2$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $9139ed090d7a9cd2$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $9139ed090d7a9cd2$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $b2cf5db2787615c3$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $9139ed090d7a9cd2$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $9516542fb3c72171$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $3d4de32c29caf7e1$export$2603c8d332a51c42)(sampleRate)) {
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}






/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $7ec87a76aa82a2f6$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $9516542fb3c72171$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $7ec87a76aa82a2f6$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $7ec87a76aa82a2f6$var$getFullURL(url);
    const host = fullUrl ? (0, $8fa0e4f9edeffeaf$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $735ba79a0f62e676$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $fee337bd2c89db0b$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $7ec87a76aa82a2f6$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $7ec87a76aa82a2f6$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $92410d3f4bb849a0$export$7e9f8ae9e4a328ab)(span) : (0, $67681cc921dcc55a$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $dedd7293d096d014$export$56766feef403f365)(dsc || (span ? (0, $59414fe30ad8ce39$export$a117f995597e25df)(span) : (0, $59414fe30ad8ce39$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $8b55cac30e90f863$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $8b55cac30e90f863$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $dedd7293d096d014$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $dedd7293d096d014$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $7ec87a76aa82a2f6$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $7ec87a76aa82a2f6$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $b6377485fae4d830$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}




/* eslint-disable max-lines */ const $3fc81ebc722b186b$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $3fc81ebc722b186b$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $3fc81ebc722b186b$export$15bd0305d05ad07b,
    tracePropagationTargets: $3fc81ebc722b186b$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $3fc81ebc722b186b$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $3fc81ebc722b186b$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $3fc81ebc722b186b$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$3fc81ebc722b186b$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $3ecb445c99cc1b01$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $7ec87a76aa82a2f6$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $3fc81ebc722b186b$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $8fa0e4f9edeffeaf$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $3fc81ebc722b186b$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $911e5e354121e865$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $3fc81ebc722b186b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $3fc81ebc722b186b$var$addHTTPTimings(createdSpan);
    });
}
function $3fc81ebc722b186b$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $3fc81ebc722b186b$var$addHTTPTimings(span) {
    const { url: url } = (0, $92410d3f4bb849a0$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $2d276c9689c1344d$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($3fc81ebc722b186b$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $3fc81ebc722b186b$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $3fc81ebc722b186b$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $3fc81ebc722b186b$var$getAbsoluteTime(time = 0) {
    return (((0, $561ba8b5b77a0042$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $3fc81ebc722b186b$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $3fc81ebc722b186b$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $561ba8b5b77a0042$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $3fc81ebc722b186b$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $3fc81ebc722b186b$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $f54fd3bbbc09c038$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $3fc81ebc722b186b$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $3fc81ebc722b186b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $911e5e354121e865$export$55b6bb1e45c6cf59];
    if (!(0, $9516542fb3c72171$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $b6377485fae4d830$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    const isolationScope = (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)();
    const fullUrl = $3fc81ebc722b186b$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $8fa0e4f9edeffeaf$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $735ba79a0f62e676$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $fee337bd2c89db0b$export$cca8dd30f57f805e)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $92410d3f4bb849a0$export$7e9f8ae9e4a328ab)(span) : (0, $67681cc921dcc55a$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $dedd7293d096d014$export$56766feef403f365)(dsc || (span ? (0, $59414fe30ad8ce39$export$a117f995597e25df)(span) : (0, $59414fe30ad8ce39$export$366bad00d6815eed)(traceId, client, scope)));
        $3fc81ebc722b186b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $3fc81ebc722b186b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $dedd7293d096d014$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $3fc81ebc722b186b$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



const $7e5446559061a90c$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $7e5446559061a90c$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $edf6573b7c1effc3$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $3fc81ebc722b186b$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $7e5446559061a90c$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $2abc507e195761ce$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $b69b9fb1590d3703$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$7e5446559061a90c$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $9139ed090d7a9cd2$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $9139ed090d7a9cd2$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $9139ed090d7a9cd2$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $9139ed090d7a9cd2$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $7e5446559061a90c$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $7e5446559061a90c$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $67681cc921dcc55a$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $975aaf7edad12874$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $b69b9fb1590d3703$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).document) {
            (0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                'interactive',
                'complete'
            ].includes((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $9139ed090d7a9cd2$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $7e5446559061a90c$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $2abc507e195761ce$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
            let activeSpan;
            let startingUrl = (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on('startNavigationSpan', (context)=>{
                    if (activeSpan) {
                        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $92410d3f4bb849a0$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'navigation',
                        ...context
                    });
                });
                client.on('startPageLoadSpan', (context)=>{
                    if (activeSpan) {
                        (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $92410d3f4bb849a0$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'pageload',
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $561ba8b5b77a0042$export$baf075a948ffc0bf) ? (0, $561ba8b5b77a0042$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: 'auto.pageload.browser',
                    attributes: {
                        [(0, $fee337bd2c89db0b$export$d7a7d984b0791405)]: 'url'
                    }
                };
                $7e5446559061a90c$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location) (0, $64bd59e2066d26bd$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $975aaf7edad12874$export$56d8a8a25bd48b81).location.pathname,
                        origin: 'auto.navigation.browser',
                        attributes: {
                            [(0, $fee337bd2c89db0b$export$d7a7d984b0791405)]: 'url'
                        }
                    };
                    $7e5446559061a90c$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $f26da202598dfa3d$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $7e5446559061a90c$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $7e5446559061a90c$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $3fc81ebc722b186b$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $7e5446559061a90c$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startPageLoadSpan', spanOptions);
    const span = (0, $735ba79a0f62e676$export$1be426a8e585c83e)();
    const op = span && (0, $92410d3f4bb849a0$export$92d8c23565496537)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $7e5446559061a90c$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startNavigationSpan', spanOptions);
    const span = (0, $735ba79a0f62e676$export$1be426a8e585c83e)();
    const op = span && (0, $92410d3f4bb849a0$export$92d8c23565496537)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $7e5446559061a90c$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $167dd1da81c36183$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $7e5446559061a90c$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = 'ui.action.click';
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $4fb0e2bcdfaf27ed$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            'navigation',
            'pageload'
        ].includes(currentTransaction.op)) {
            (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason('interactionInterrupted');
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $2abc507e195761ce$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $975aaf7edad12874$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $fee337bd2c89db0b$export$d7a7d984b0791405)]: latestRoute.context ? $7e5446559061a90c$var$getSource(latestRoute.context) : 'url'
            }
        };
        inflightInteractionTransaction = (0, $b69b9fb1590d3703$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $2d9e797091ea0ff6$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        'click'
    ].forEach((type)=>{
        if ((0, $975aaf7edad12874$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $7e5446559061a90c$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $7e5446559061a90c$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $7e5446559061a90c$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $4fb0e2bcdfaf27ed$export$a7feb32fdd923295)();
        const currentScope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($7e5446559061a90c$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === 'first-input') {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $7e5446559061a90c$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $7e5446559061a90c$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $2d276c9689c1344d$export$69816c1a049f8db6)('event', handleEntries);
    (0, $2d276c9689c1344d$export$69816c1a049f8db6)('first-input', handleEntries);
}
function $7e5446559061a90c$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $fee337bd2c89db0b$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $fee337bd2c89db0b$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

































/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $aa6295e4c669ad7c$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $aa6295e4c669ad7c$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $aa6295e4c669ad7c$var$checkDsn(url, dsn) || $aa6295e4c669ad7c$var$checkTunnel(url, tunnel);
}
function $aa6295e4c669ad7c$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $aa6295e4c669ad7c$var$removeTrailingSlash(url) === $aa6295e4c669ad7c$var$removeTrailingSlash(tunnel);
}
function $aa6295e4c669ad7c$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $aa6295e4c669ad7c$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $aa6295e4c669ad7c$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}













var $094a31d349a41a0c$exports = {};

$parcel$export($094a31d349a41a0c$exports, "FunctionToString", function () { return $ca088bc72b53c643$export$da4704525c20ae79; });
$parcel$export($094a31d349a41a0c$exports, "InboundFilters", function () { return $19ec35e67a3940c6$export$2ffbb5359dcc6be4; });
$parcel$export($094a31d349a41a0c$exports, "LinkedErrors", function () { return $ee914dbb63b0d6a4$export$8d1e60aaf616fb4f; });






/**
 * Extracts stack frames from the error.stack string
 */ function $b19ef82859b83848$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $b19ef82859b83848$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $b19ef82859b83848$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $b19ef82859b83848$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $6a842238b70e8ef7$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $b19ef82859b83848$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === 'function' ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    let extras;
    if (!(0, $8b55cac30e90f863$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $8b55cac30e90f863$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ['__serialized__']: (0, $1908c34a72f46e5e$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $b19ef82859b83848$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $b19ef82859b83848$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $c6eb3b4caecfb929$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $c6eb3b4caecfb929$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $b19ef82859b83848$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $b19ef82859b83848$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $8b55cac30e90f863$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $ee914dbb63b0d6a4$var$DEFAULT_KEY = 'cause';
const $ee914dbb63b0d6a4$var$DEFAULT_LIMIT = 5;
const $ee914dbb63b0d6a4$var$INTEGRATION_NAME = 'LinkedErrors';
const $ee914dbb63b0d6a4$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $ee914dbb63b0d6a4$var$DEFAULT_LIMIT;
    const key = options.key || $ee914dbb63b0d6a4$var$DEFAULT_KEY;
    return {
        name: $ee914dbb63b0d6a4$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $5731cfbc8edbab31$export$b91c38ed7d8ae9b2)((0, $b19ef82859b83848$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $ee914dbb63b0d6a4$export$ebabb00eb7f3a395 = (0, $4a01cec229b54112$export$2323046b9414659f)($ee914dbb63b0d6a4$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ee914dbb63b0d6a4$export$8d1e60aaf616fb4f = (0, $4a01cec229b54112$export$afa219bf23651160)($ee914dbb63b0d6a4$var$INTEGRATION_NAME, $ee914dbb63b0d6a4$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $69395913dde91a43$export$99d02219d259eb94 = $094a31d349a41a0c$exports;
















var $8ab6f26c6868a9b9$exports = {};

$parcel$export($8ab6f26c6868a9b9$exports, "GlobalHandlers", function () { return $172eb6fb11a8d37b$export$204155decbc90e5a; });
$parcel$export($8ab6f26c6868a9b9$exports, "TryCatch", function () { return $6287429ba267fb1a$export$f1a018517668e6d3; });
$parcel$export($8ab6f26c6868a9b9$exports, "Breadcrumbs", function () { return $ea3c6017a25c58fd$export$2dc68d50d56fbbd; });
$parcel$export($8ab6f26c6868a9b9$exports, "LinkedErrors", function () { return $658ca9460e996f86$export$8d1e60aaf616fb4f; });
$parcel$export($8ab6f26c6868a9b9$exports, "HttpContext", function () { return $cf8ca1ca6fe8d77b$export$5d2ee9a544b09a94; });
$parcel$export($8ab6f26c6868a9b9$exports, "Dedupe", function () { return $1d629906f94b0577$export$688d98c249d31ad3; });






 /* eslint-disable deprecation/deprecation */ 

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $53b18f23d475f76a$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $3e1d5193985023f5$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $191I6 = parcelRequire("191I6");

/**
 * Returns true if we are in the browser.
 */ function $beaad4d9fa74c27c$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $191I6.isNodeEnv)() || $beaad4d9fa74c27c$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $beaad4d9fa74c27c$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).process !== undefined && (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1).process.type === 'renderer');
}




// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $845a60d357898a03$var$WINDOW = (0, $bb276a8c51aa95a3$export$f1a6cdb1459e81d1);
const $845a60d357898a03$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $845a60d357898a03$var$REPLAY_EVENT_NAME = 'replay_event';
const $845a60d357898a03$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $845a60d357898a03$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $845a60d357898a03$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $845a60d357898a03$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $845a60d357898a03$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $845a60d357898a03$var$BUFFER_CHECKOUT_TIME = 60000;
const $845a60d357898a03$var$RETRY_BASE_INTERVAL = 5000;
const $845a60d357898a03$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $845a60d357898a03$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $845a60d357898a03$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $845a60d357898a03$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $845a60d357898a03$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $845a60d357898a03$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $845a60d357898a03$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $845a60d357898a03$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $845a60d357898a03$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $845a60d357898a03$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $845a60d357898a03$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $845a60d357898a03$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($845a60d357898a03$var$NodeType$1 || ($845a60d357898a03$var$NodeType$1 = {}));
function $845a60d357898a03$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $845a60d357898a03$var$isShadowRoot(n) {
    const host = $845a60d357898a03$var$_optionalChain$5([
        n,
        'optionalAccess',
        (_)=>_.host
    ]);
    return Boolean($845a60d357898a03$var$_optionalChain$5([
        host,
        'optionalAccess',
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $845a60d357898a03$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $845a60d357898a03$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $845a60d357898a03$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $845a60d357898a03$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $845a60d357898a03$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $845a60d357898a03$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $845a60d357898a03$var$stringifyRule(rule) {
    let importStringified;
    if ($845a60d357898a03$var$isCSSImportRule(rule)) try {
        importStringified = $845a60d357898a03$var$stringifyStylesheet(rule.styleSheet) || $845a60d357898a03$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($845a60d357898a03$var$isCSSStyleRule(rule) && rule.selectorText.includes(':')) return $845a60d357898a03$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $845a60d357898a03$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $845a60d357898a03$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $845a60d357898a03$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class $845a60d357898a03$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $845a60d357898a03$var$_optionalChain$5([
            this,
            'access',
            (_3)=>_3.getMeta,
            'call',
            (_4)=>_4(n),
            'optionalAccess',
            (_5)=>_5.id
        ]);
        return $845a60d357898a03$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $845a60d357898a03$var$createMirror() {
    return new $845a60d357898a03$var$Mirror();
}
function $845a60d357898a03$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === 'OPTION') tagName = 'SELECT';
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function $845a60d357898a03$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return '*'.repeat(text.length);
}
function $845a60d357898a03$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $845a60d357898a03$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $845a60d357898a03$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $845a60d357898a03$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $845a60d357898a03$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$845a60d357898a03$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $845a60d357898a03$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $845a60d357898a03$var$toLowerCase(type) : null;
}
function $845a60d357898a03$var$getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
let $845a60d357898a03$var$_id = 1;
const $845a60d357898a03$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $845a60d357898a03$var$IGNORED_NODE = -2;
function $845a60d357898a03$var$genId() {
    return $845a60d357898a03$var$_id++;
}
function $845a60d357898a03$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = $845a60d357898a03$var$toLowerCase(element.tagName);
    if ($845a60d357898a03$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $845a60d357898a03$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $845a60d357898a03$var$canvasService;
let $845a60d357898a03$var$canvasCtx;
const $845a60d357898a03$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $845a60d357898a03$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $845a60d357898a03$var$URL_WWW_MATCH = /^www\..*/i;
const $845a60d357898a03$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $845a60d357898a03$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($845a60d357898a03$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($845a60d357898a03$var$URL_PROTOCOL_MATCH.test(filePath) || $845a60d357898a03$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($845a60d357898a03$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$845a60d357898a03$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $845a60d357898a03$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $845a60d357898a03$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $845a60d357898a03$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while(true){
        collectCharacters($845a60d357898a03$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($845a60d357898a03$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $845a60d357898a03$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $845a60d357898a03$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $845a60d357898a03$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $845a60d357898a03$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $845a60d357898a03$var$getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $845a60d357898a03$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $845a60d357898a03$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $845a60d357898a03$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $845a60d357898a03$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $845a60d357898a03$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $845a60d357898a03$var$absoluteToStylesheet(value, $845a60d357898a03$var$getHref());
    else if (tagName === 'object' && name === 'data') return $845a60d357898a03$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === 'function') return maskAttributeFn(name, value, element);
    return value;
}
function $845a60d357898a03$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $845a60d357898a03$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $845a60d357898a03$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $845a60d357898a03$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $845a60d357898a03$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $845a60d357898a03$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($845a60d357898a03$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $845a60d357898a03$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === 'INPUT') {
            const autocomplete = el.getAttribute('autocomplete');
            const disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc'
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $845a60d357898a03$var$distanceToMatch(el, $845a60d357898a03$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $845a60d357898a03$var$distanceToMatch(el, $845a60d357898a03$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $845a60d357898a03$var$distanceToMatch(el, $845a60d357898a03$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $845a60d357898a03$var$distanceToMatch(el, $845a60d357898a03$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $845a60d357898a03$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $845a60d357898a03$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $845a60d357898a03$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $845a60d357898a03$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $845a60d357898a03$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $845a60d357898a03$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $845a60d357898a03$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $845a60d357898a03$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $845a60d357898a03$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $845a60d357898a03$var$NodeType$1.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $845a60d357898a03$var$NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $845a60d357898a03$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $845a60d357898a03$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($845a60d357898a03$var$_optionalChain$5([
                n,
                'access',
                (_6)=>_6.parentNode,
                'access',
                (_7)=>_7.sheet,
                'optionalAccess',
                (_8)=>_8.cssRules
            ])) textContent = $845a60d357898a03$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $845a60d357898a03$var$absoluteToStylesheet(textContent, $845a60d357898a03$var$getHref());
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    const forceMask = $845a60d357898a03$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
    if (parentTagName === 'OPTION' && textContent) {
        const isInputMasked = $845a60d357898a03$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $845a60d357898a03$var$maskInputValue({
            isMasked: $845a60d357898a03$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $845a60d357898a03$var$NodeType$1.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $845a60d357898a03$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $845a60d357898a03$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $845a60d357898a03$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$845a60d357898a03$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $845a60d357898a03$var$transformAttribute(doc, tagName, $845a60d357898a03$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $845a60d357898a03$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $845a60d357898a03$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        const cssText = $845a60d357898a03$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $845a60d357898a03$var$absoluteToStylesheet(cssText, $845a60d357898a03$var$getHref());
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
        const el = n;
        const type = $845a60d357898a03$var$getInputType(el);
        const value = $845a60d357898a03$var$getInputValue(el, $845a60d357898a03$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            const forceMask = $845a60d357898a03$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $845a60d357898a03$var$shouldMaskInput({
                type: type,
                tagName: $845a60d357898a03$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $845a60d357898a03$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$845a60d357898a03$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$845a60d357898a03$var$canvasService) {
            $845a60d357898a03$var$canvasService = doc.createElement('canvas');
            $845a60d357898a03$var$canvasCtx = $845a60d357898a03$var$canvasService.getContext('2d');
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        const recordInlineImage = ()=>{
            image.removeEventListener('load', recordInlineImage);
            try {
                $845a60d357898a03$var$canvasService.width = image.naturalWidth;
                $845a60d357898a03$var$canvasService.height = image.naturalHeight;
                $845a60d357898a03$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $845a60d357898a03$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused ? 'paused' : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $845a60d357898a03$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $845a60d357898a03$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $845a60d357898a03$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $845a60d357898a03$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $845a60d357898a03$var$NodeType$1.Comment) return true;
    else if (sn.type === $845a60d357898a03$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($845a60d357898a03$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'application-name' || $845a60d357898a03$var$lowerIfExists(sn.attributes.rel) === 'icon' || $845a60d357898a03$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $845a60d357898a03$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $845a60d357898a03$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($845a60d357898a03$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $845a60d357898a03$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'robots' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'author' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'generator' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'framework' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'publisher' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'progid' || $845a60d357898a03$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $845a60d357898a03$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'verification' || $845a60d357898a03$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $845a60d357898a03$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $845a60d357898a03$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($845a60d357898a03$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $845a60d357898a03$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $845a60d357898a03$var$IGNORED_NODE;
    else id = $845a60d357898a03$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $845a60d357898a03$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $845a60d357898a03$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $845a60d357898a03$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $845a60d357898a03$var$NodeType$1.Document || serializedNode.type === $845a60d357898a03$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $845a60d357898a03$var$NodeType$1.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $845a60d357898a03$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($845a60d357898a03$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $845a60d357898a03$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $845a60d357898a03$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $845a60d357898a03$var$isShadowRoot(n.parentNode) && $845a60d357898a03$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $845a60d357898a03$var$NodeType$1.Element && serializedNode.tagName === 'iframe') $845a60d357898a03$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $845a60d357898a03$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $845a60d357898a03$var$NodeType$1.Element && serializedNode.tagName === 'link' && serializedNode.attributes.rel === 'stylesheet') $845a60d357898a03$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $845a60d357898a03$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $845a60d357898a03$var$snapshot(n, options) {
    const { mirror: mirror = new $845a60d357898a03$var$Mirror(), blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $845a60d357898a03$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $845a60d357898a03$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $845a60d357898a03$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $845a60d357898a03$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $845a60d357898a03$var$_mirror = {
    map: {},
    getId () {
        console.error($845a60d357898a03$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($845a60d357898a03$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($845a60d357898a03$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($845a60d357898a03$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($845a60d357898a03$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $845a60d357898a03$var$_mirror = new Proxy($845a60d357898a03$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($845a60d357898a03$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $845a60d357898a03$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $845a60d357898a03$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $845a60d357898a03$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $845a60d357898a03$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $845a60d357898a03$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$845a60d357898a03$var$hookSetter(target, key, original || {}, true);
}
function $845a60d357898a03$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $845a60d357898a03$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $845a60d357898a03$var$nowTimestamp = ()=>new Date().getTime();
function $845a60d357898a03$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $845a60d357898a03$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_)=>_.documentElement,
            'access',
            (_2)=>_2.scrollLeft
        ]) || $845a60d357898a03$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_3)=>_3.body,
            'optionalAccess',
            (_4)=>_4.parentElement,
            'optionalAccess',
            (_5)=>_5.scrollLeft
        ]) || $845a60d357898a03$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_6)=>_6.body,
            'optionalAccess',
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $845a60d357898a03$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_8)=>_8.documentElement,
            'access',
            (_9)=>_9.scrollTop
        ]) || $845a60d357898a03$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_10)=>_10.body,
            'optionalAccess',
            (_11)=>_11.parentElement,
            'optionalAccess',
            (_12)=>_12.scrollTop
        ]) || $845a60d357898a03$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_13)=>_13.body,
            'optionalAccess',
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $845a60d357898a03$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $845a60d357898a03$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $845a60d357898a03$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $845a60d357898a03$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $845a60d357898a03$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $845a60d357898a03$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $845a60d357898a03$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $845a60d357898a03$var$distanceToMatch(el, $845a60d357898a03$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $845a60d357898a03$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $845a60d357898a03$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $845a60d357898a03$var$IGNORED_NODE;
}
function $845a60d357898a03$var$isAncestorRemoved(target, mirror) {
    if ($845a60d357898a03$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $845a60d357898a03$var$isAncestorRemoved(target.parentNode, mirror);
}
function $845a60d357898a03$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $845a60d357898a03$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $845a60d357898a03$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $845a60d357898a03$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $845a60d357898a03$var$hasShadowRoot(n) {
    return Boolean($845a60d357898a03$var$_optionalChain$4([
        n,
        'optionalAccess',
        (_18)=>_18.shadowRoot
    ]));
}
class $845a60d357898a03$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $53b18f23d475f76a$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $845a60d357898a03$var$getShadowHost(n) {
    let shadowHost = null;
    if ($845a60d357898a03$var$_optionalChain$4([
        n,
        'access',
        (_19)=>_19.getRootNode,
        'optionalCall',
        (_20)=>_20(),
        'optionalAccess',
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $845a60d357898a03$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $845a60d357898a03$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $845a60d357898a03$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $845a60d357898a03$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $845a60d357898a03$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $845a60d357898a03$var$shadowHostInDom(n);
}
const $845a60d357898a03$var$cachedImplementations = {};
function $845a60d357898a03$var$getImplementation(name) {
    const cached = $845a60d357898a03$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $845a60d357898a03$var$cachedImplementations[name] = impl.bind(window);
}
function $845a60d357898a03$var$onRequestAnimationFrame(...rest) {
    return $845a60d357898a03$var$getImplementation('requestAnimationFrame')(...rest);
}
function $845a60d357898a03$var$setTimeout$1(...rest) {
    return $845a60d357898a03$var$getImplementation('setTimeout')(...rest);
}
function $845a60d357898a03$var$clearTimeout$1(...rest) {
    return $845a60d357898a03$var$getImplementation('clearTimeout')(...rest);
}
var $845a60d357898a03$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($845a60d357898a03$var$EventType || {});
var $845a60d357898a03$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($845a60d357898a03$var$IncrementalSource || {});
var $845a60d357898a03$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($845a60d357898a03$var$MouseInteractions || {});
var $845a60d357898a03$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($845a60d357898a03$var$PointerTypes || {});
function $845a60d357898a03$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $845a60d357898a03$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $845a60d357898a03$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = $845a60d357898a03$var$_optionalChain$3([
            current,
            'optionalAccess',
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $845a60d357898a03$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $845a60d357898a03$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $845a60d357898a03$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $845a60d357898a03$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $845a60d357898a03$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $845a60d357898a03$var$IGNORED_NODE;
                while(nextId === $845a60d357898a03$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$845a60d357898a03$var$inDom(n)) return;
                const parentId = $845a60d357898a03$var$isShadowRoot(n.parentNode) ? this.mirror.getId($845a60d357898a03$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $845a60d357898a03$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($845a60d357898a03$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($845a60d357898a03$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($845a60d357898a03$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($845a60d357898a03$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$845a60d357898a03$var$isAncestorInSet(this.droppedSet, n) && !$845a60d357898a03$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($845a60d357898a03$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($845a60d357898a03$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$845a60d357898a03$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $845a60d357898a03$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $845a60d357898a03$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            const type = $845a60d357898a03$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $845a60d357898a03$var$getInputValue(target, tagName, type);
                            const isInputMasked = $845a60d357898a03$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $845a60d357898a03$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $845a60d357898a03$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($845a60d357898a03$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$845a60d357898a03$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $845a60d357898a03$var$transformAttribute(this.doc, $845a60d357898a03$var$toLowerCase(target.tagName), $845a60d357898a03$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === 'style') {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($845a60d357898a03$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $845a60d357898a03$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($845a60d357898a03$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $845a60d357898a03$var$isIgnored(n, this.mirror) || !$845a60d357898a03$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $845a60d357898a03$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($845a60d357898a03$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$845a60d357898a03$var$moveKey(nodeId, parentId)]) $845a60d357898a03$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $845a60d357898a03$var$isShadowRoot(m.target) && $845a60d357898a03$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($845a60d357898a03$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$845a60d357898a03$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$845a60d357898a03$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($845a60d357898a03$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskAllText',
            'maskTextClass',
            'unmaskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskAttributeFn',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $845a60d357898a03$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$845a60d357898a03$var$deepDelete(addsSet, childN));
}
function $845a60d357898a03$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $845a60d357898a03$var$_isParentRemoved(removes, n, mirror);
}
function $845a60d357898a03$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $845a60d357898a03$var$_isParentRemoved(removes, parentNode, mirror);
}
function $845a60d357898a03$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $845a60d357898a03$var$_isAncestorInSet(set, n);
}
function $845a60d357898a03$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $845a60d357898a03$var$_isAncestorInSet(set, parentNode);
}
let $845a60d357898a03$var$errorHandler;
function $845a60d357898a03$var$registerErrorHandler(handler) {
    $845a60d357898a03$var$errorHandler = handler;
}
function $845a60d357898a03$var$unregisterErrorHandler() {
    $845a60d357898a03$var$errorHandler = undefined;
}
const $845a60d357898a03$var$callbackWrapper = (cb)=>{
    if (!$845a60d357898a03$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($845a60d357898a03$var$errorHandler && $845a60d357898a03$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $845a60d357898a03$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $845a60d357898a03$var$mutationBuffers = [];
function $845a60d357898a03$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $845a60d357898a03$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $845a60d357898a03$var$MutationBuffer();
    $845a60d357898a03$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $845a60d357898a03$var$_optionalChain$2([
        window,
        'optionalAccess',
        (_)=>_.Zone,
        'optionalAccess',
        (_2)=>_2.__symbol__,
        'optionalCall',
        (_3)=>_3('MutationObserver')
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($845a60d357898a03$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $845a60d357898a03$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $845a60d357898a03$var$throttle$1($845a60d357898a03$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $845a60d357898a03$var$callbackWrapper($845a60d357898a03$var$throttle$1($845a60d357898a03$var$callbackWrapper((evt)=>{
        const target = $845a60d357898a03$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $845a60d357898a03$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $845a60d357898a03$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $845a60d357898a03$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $845a60d357898a03$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $845a60d357898a03$var$IncrementalSource.MouseMove : $845a60d357898a03$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $845a60d357898a03$var$on('mousemove', updatePosition, doc),
        $845a60d357898a03$var$on('touchmove', updatePosition, doc),
        $845a60d357898a03$var$on('drag', updatePosition, doc)
    ];
    return $845a60d357898a03$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $845a60d357898a03$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $845a60d357898a03$var$getEventTarget(event);
            if ($845a60d357898a03$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $845a60d357898a03$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $845a60d357898a03$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $845a60d357898a03$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $845a60d357898a03$var$PointerTypes.Touch) {
                    if ($845a60d357898a03$var$MouseInteractions[eventKey] === $845a60d357898a03$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($845a60d357898a03$var$MouseInteractions[eventKey] === $845a60d357898a03$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $845a60d357898a03$var$PointerTypes.Pen;
            } else if ($845a60d357898a03$var$legacy_isTouchEvent(event)) pointerType = $845a60d357898a03$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $845a60d357898a03$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $845a60d357898a03$var$PointerTypes.Mouse) pointerType = null;
            } else if ($845a60d357898a03$var$MouseInteractions[eventKey] === $845a60d357898a03$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $845a60d357898a03$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $845a60d357898a03$var$callbackWrapper(mouseInteractionCb)({
                type: $845a60d357898a03$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($845a60d357898a03$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $845a60d357898a03$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($845a60d357898a03$var$MouseInteractions[eventKey]){
            case $845a60d357898a03$var$MouseInteractions.MouseDown:
            case $845a60d357898a03$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $845a60d357898a03$var$MouseInteractions.TouchStart:
            case $845a60d357898a03$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($845a60d357898a03$var$on(eventName, handler, doc));
    });
    return $845a60d357898a03$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $845a60d357898a03$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $845a60d357898a03$var$callbackWrapper($845a60d357898a03$var$throttle$1($845a60d357898a03$var$callbackWrapper((evt)=>{
        const target = $845a60d357898a03$var$getEventTarget(evt);
        if (!target || $845a60d357898a03$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $845a60d357898a03$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $845a60d357898a03$var$on('scroll', updatePosition, doc);
}
function $845a60d357898a03$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $845a60d357898a03$var$callbackWrapper($845a60d357898a03$var$throttle$1($845a60d357898a03$var$callbackWrapper(()=>{
        const height = $845a60d357898a03$var$getWindowHeight();
        const width = $845a60d357898a03$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $845a60d357898a03$var$on('resize', updateDimension, win);
}
const $845a60d357898a03$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $845a60d357898a03$var$lastInputValueMap = new WeakMap();
function $845a60d357898a03$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $845a60d357898a03$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $845a60d357898a03$var$toUpperCase(target.tagName);
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $845a60d357898a03$var$INPUT_TAGS.indexOf(tagName) < 0 || $845a60d357898a03$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $845a60d357898a03$var$getInputType(target);
        let text = $845a60d357898a03$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $845a60d357898a03$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $845a60d357898a03$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        text = $845a60d357898a03$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $845a60d357898a03$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $845a60d357898a03$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $845a60d357898a03$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $845a60d357898a03$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $845a60d357898a03$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$845a60d357898a03$var$on(eventName, $845a60d357898a03$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$845a60d357898a03$var$hookSetter(p[0], p[1], {
            set () {
                $845a60d357898a03$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $845a60d357898a03$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $845a60d357898a03$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($845a60d357898a03$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $845a60d357898a03$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $845a60d357898a03$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $845a60d357898a03$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $845a60d357898a03$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $845a60d357898a03$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($845a60d357898a03$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($845a60d357898a03$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($845a60d357898a03$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($845a60d357898a03$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$845a60d357898a03$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$845a60d357898a03$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $845a60d357898a03$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $845a60d357898a03$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document' ? $845a60d357898a03$var$_optionalChain$2([
        host,
        'access',
        (_4)=>_4.defaultView,
        'optionalAccess',
        (_5)=>_5.Document
    ]) : $845a60d357898a03$var$_optionalChain$2([
        host,
        'access',
        (_6)=>_6.ownerDocument,
        'optionalAccess',
        (_7)=>_7.defaultView,
        'optionalAccess',
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $845a60d357898a03$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($845a60d357898a03$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_10)=>_10.prototype
    ]), 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $845a60d357898a03$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_11)=>_11.get,
                'optionalAccess',
                (_12)=>_12.call,
                'call',
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $845a60d357898a03$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_14)=>_14.set,
                'optionalAccess',
                (_15)=>_15.call,
                'call',
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $845a60d357898a03$var$callbackWrapper(()=>{
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $845a60d357898a03$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId($845a60d357898a03$var$_optionalChain$2([
                thisArg,
                'access',
                (_17)=>_17.parentRule,
                'optionalAccess',
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $845a60d357898a03$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $845a60d357898a03$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $845a60d357898a03$var$getIdAndStyleId($845a60d357898a03$var$_optionalChain$2([
                thisArg,
                'access',
                (_19)=>_19.parentRule,
                'optionalAccess',
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $845a60d357898a03$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $845a60d357898a03$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $845a60d357898a03$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $845a60d357898a03$var$callbackWrapper((type)=>$845a60d357898a03$var$throttle$1($845a60d357898a03$var$callbackWrapper((event)=>{
            const target = $845a60d357898a03$var$getEventTarget(event);
            if (!target || $845a60d357898a03$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $845a60d357898a03$var$on('play', handler(0), doc),
        $845a60d357898a03$var$on('pause', handler(1), doc),
        $845a60d357898a03$var$on('seeked', handler(2), doc),
        $845a60d357898a03$var$on('volumechange', handler(3), doc),
        $845a60d357898a03$var$on('ratechange', handler(4), doc)
    ];
    return $845a60d357898a03$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $845a60d357898a03$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $845a60d357898a03$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            $845a60d357898a03$var$setTimeout$1($845a60d357898a03$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $845a60d357898a03$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $845a60d357898a03$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $845a60d357898a03$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $845a60d357898a03$var$_optionalChain$2([
            selection,
            'optionalAccess',
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $845a60d357898a03$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $845a60d357898a03$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $845a60d357898a03$var$on('selectionchange', updateSelection);
}
function $845a60d357898a03$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $845a60d357898a03$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $845a60d357898a03$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $845a60d357898a03$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $845a60d357898a03$var$initMoveObserver(o);
    const mouseInteractionHandler = $845a60d357898a03$var$initMouseInteractionObserver(o);
    const scrollHandler = $845a60d357898a03$var$initScrollObserver(o);
    const viewportResizeHandler = $845a60d357898a03$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $845a60d357898a03$var$initInputObserver(o);
    const mediaInteractionHandler = $845a60d357898a03$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $845a60d357898a03$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $845a60d357898a03$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $845a60d357898a03$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $845a60d357898a03$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $845a60d357898a03$var$initSelectionObserver(o);
    const customElementObserver = $845a60d357898a03$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $845a60d357898a03$var$callbackWrapper(()=>{
        $845a60d357898a03$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $845a60d357898a03$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $845a60d357898a03$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $845a60d357898a03$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number') return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $845a60d357898a03$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $845a60d357898a03$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $845a60d357898a03$var$CrossOriginIframeMirror($845a60d357898a03$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $845a60d357898a03$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $845a60d357898a03$var$CrossOriginIframeMirror($845a60d357898a03$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $845a60d357898a03$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $845a60d357898a03$var$_optionalChain$1([
            this,
            'access',
            (_)=>_.loadListener,
            'optionalCall',
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $845a60d357898a03$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $845a60d357898a03$var$EventType.Meta:
            case $845a60d357898a03$var$EventType.Load:
            case $845a60d357898a03$var$EventType.DomContentLoaded:
                return false;
            case $845a60d357898a03$var$EventType.Plugin:
                return e;
            case $845a60d357898a03$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    'id',
                    'parentId',
                    'previousId',
                    'nextId'
                ]);
                return e;
            case $845a60d357898a03$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $845a60d357898a03$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId'
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'id'
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $845a60d357898a03$var$IncrementalSource.Drag:
                    case $845a60d357898a03$var$IncrementalSource.TouchMove:
                    case $845a60d357898a03$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $845a60d357898a03$var$IncrementalSource.ViewportResize:
                        return false;
                    case $845a60d357898a03$var$IncrementalSource.MediaInteraction:
                    case $845a60d357898a03$var$IncrementalSource.MouseInteraction:
                    case $845a60d357898a03$var$IncrementalSource.Scroll:
                    case $845a60d357898a03$var$IncrementalSource.CanvasMutation:
                    case $845a60d357898a03$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        return e;
                    case $845a60d357898a03$var$IncrementalSource.StyleSheetRule:
                    case $845a60d357898a03$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleId'
                        ]);
                        return e;
                    case $845a60d357898a03$var$IncrementalSource.Font:
                        return e;
                    case $845a60d357898a03$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                'start',
                                'end'
                            ]);
                        });
                        return e;
                    case $845a60d357898a03$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleIds'
                        ]);
                        $845a60d357898a03$var$_optionalChain$1([
                            e,
                            'access',
                            (_3)=>_3.data,
                            'access',
                            (_4)=>_4.styles,
                            'optionalAccess',
                            (_5)=>_5.forEach,
                            'call',
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        'styleId'
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            'id',
            'rootId'
        ]);
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $845a60d357898a03$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $845a60d357898a03$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $845a60d357898a03$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$845a60d357898a03$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $845a60d357898a03$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($845a60d357898a03$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $845a60d357898a03$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($845a60d357898a03$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($845a60d357898a03$var$patch(element.prototype, 'attachShadow', function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $845a60d357898a03$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $845a60d357898a03$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $845a60d357898a03$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $845a60d357898a03$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $845a60d357898a03$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $845a60d357898a03$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $845a60d357898a03$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $845a60d357898a03$var$wrappedEmit;
let $845a60d357898a03$var$_takeFullSnapshot;
const $845a60d357898a03$var$mirror = $845a60d357898a03$var$createMirror();
function $845a60d357898a03$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load', userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $845a60d357898a03$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $845a60d357898a03$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $845a60d357898a03$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $845a60d357898a03$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $845a60d357898a03$var$nowTimestamp();
        if ((0, $3e1d5193985023f5$export$3cc482e6b02f32f7)([
            $845a60d357898a03$var$mutationBuffers,
            'access',
            (_)=>_[0],
            'optionalAccess',
            (_2)=>_2.isFrozen,
            'call',
            (_3)=>_3()
        ]) && e.type !== $845a60d357898a03$var$EventType.FullSnapshot && !(e.type === $845a60d357898a03$var$EventType.IncrementalSnapshot && e.data.source === $845a60d357898a03$var$IncrementalSource.Mutation)) $845a60d357898a03$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $3e1d5193985023f5$export$3cc482e6b02f32f7)([
            emit,
            'optionalCall',
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $845a60d357898a03$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $845a60d357898a03$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $845a60d357898a03$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $845a60d357898a03$var$wrappedEmit({
            type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
            data: {
                source: $845a60d357898a03$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$845a60d357898a03$var$wrappedEmit({
            type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
            data: {
                source: $845a60d357898a03$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$845a60d357898a03$var$wrappedEmit({
            type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
            data: {
                source: $845a60d357898a03$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$845a60d357898a03$var$wrappedEmit({
            type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
            data: {
                source: $845a60d357898a03$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $845a60d357898a03$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new $845a60d357898a03$var$IframeManagerNoop() : new $845a60d357898a03$var$IframeManager({
        mirror: $845a60d357898a03$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $845a60d357898a03$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $845a60d357898a03$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $845a60d357898a03$var$ProcessedNodeManager();
    const canvasManager = $845a60d357898a03$var$_getCanvasManager(getCanvasManager, {
        mirror: $845a60d357898a03$var$mirror,
        win: window,
        mutationCb: (p)=>$845a60d357898a03$var$wrappedEmit({
                type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                data: {
                    source: $845a60d357898a03$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $845a60d357898a03$var$ShadowDomManagerNoop() : new $845a60d357898a03$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $845a60d357898a03$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $845a60d357898a03$var$wrappedEmit({
            type: $845a60d357898a03$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $845a60d357898a03$var$getWindowWidth(),
                height: $845a60d357898a03$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $845a60d357898a03$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $845a60d357898a03$var$snapshot(document, {
            mirror: $845a60d357898a03$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($845a60d357898a03$var$isSerializedIframe(n, $845a60d357898a03$var$mirror)) iframeManager.addIframe(n);
                if ($845a60d357898a03$var$isSerializedStylesheet(n, $845a60d357898a03$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($845a60d357898a03$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $845a60d357898a03$var$wrappedEmit({
            type: $845a60d357898a03$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $845a60d357898a03$var$getWindowScroll(window)
            }
        });
        $845a60d357898a03$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $845a60d357898a03$var$mirror.getId(document));
    };
    $845a60d357898a03$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $845a60d357898a03$var$callbackWrapper($845a60d357898a03$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $845a60d357898a03$var$wrappedEmit({
                        type: $845a60d357898a03$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $845a60d357898a03$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $845a60d357898a03$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $3e1d5193985023f5$export$3cc482e6b02f32f7)([
                    plugins,
                    'optionalAccess',
                    (_5)=>_5.filter,
                    'call',
                    (_6)=>_6((p)=>p.observer),
                    'optionalAccess',
                    (_7)=>_7.map,
                    'call',
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$845a60d357898a03$var$wrappedEmit({
                                        type: $845a60d357898a03$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($845a60d357898a03$var$on('DOMContentLoaded', ()=>{
                $845a60d357898a03$var$wrappedEmit({
                    type: $845a60d357898a03$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($845a60d357898a03$var$on('load', ()=>{
                $845a60d357898a03$var$wrappedEmit({
                    type: $845a60d357898a03$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === 'load') init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $845a60d357898a03$var$_takeFullSnapshot = undefined;
            $845a60d357898a03$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $845a60d357898a03$var$takeFullSnapshot(isCheckout) {
    if (!$845a60d357898a03$var$_takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $845a60d357898a03$var$_takeFullSnapshot(isCheckout);
}
$845a60d357898a03$var$record.mirror = $845a60d357898a03$var$mirror;
$845a60d357898a03$var$record.takeFullSnapshot = $845a60d357898a03$var$takeFullSnapshot;
function $845a60d357898a03$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $845a60d357898a03$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new $845a60d357898a03$var$CanvasManagerNoop();
    }
}
const $845a60d357898a03$var$ReplayEventTypeIncrementalSnapshot = 3;
const $845a60d357898a03$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $845a60d357898a03$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $845a60d357898a03$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $845a60d357898a03$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $845a60d357898a03$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $1908c34a72f46e5e$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $845a60d357898a03$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $845a60d357898a03$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($845a60d357898a03$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $845a60d357898a03$var$getClickTargetNode(event) {
    const target = $845a60d357898a03$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $845a60d357898a03$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $845a60d357898a03$var$getTargetNode(event) {
    if ($845a60d357898a03$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $845a60d357898a03$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $845a60d357898a03$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $845a60d357898a03$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$845a60d357898a03$var$handlers) {
        $845a60d357898a03$var$handlers = [];
        $845a60d357898a03$var$monkeyPatchWindowOpen();
    }
    $845a60d357898a03$var$handlers.push(cb);
    return ()=>{
        const pos = $845a60d357898a03$var$handlers ? $845a60d357898a03$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $845a60d357898a03$var$handlers.splice(pos, 1);
    };
}
function $845a60d357898a03$var$monkeyPatchWindowOpen() {
    (0, $6a842238b70e8ef7$export$9563e054e6f787fb)($845a60d357898a03$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($845a60d357898a03$var$handlers) try {
                $845a60d357898a03$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($845a60d357898a03$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $845a60d357898a03$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $845a60d357898a03$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $845a60d357898a03$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $845a60d357898a03$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $845a60d357898a03$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($845a60d357898a03$var$ignoreElement(node, this._ignoreSelector) || !$845a60d357898a03$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $845a60d357898a03$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $845a60d357898a03$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $845a60d357898a03$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $845a60d357898a03$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $845a60d357898a03$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $845a60d357898a03$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $845a60d357898a03$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $845a60d357898a03$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $845a60d357898a03$var$ignoreElement(node, ignoreSelector) {
    if (!$845a60d357898a03$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $845a60d357898a03$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $845a60d357898a03$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $845a60d357898a03$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$845a60d357898a03$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $845a60d357898a03$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $845a60d357898a03$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($845a60d357898a03$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $845a60d357898a03$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $845a60d357898a03$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $845a60d357898a03$var$isIncrementalEvent(event) {
    return event.type === $845a60d357898a03$var$ReplayEventTypeIncrementalSnapshot;
}
function $845a60d357898a03$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $845a60d357898a03$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $845a60d357898a03$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $845a60d357898a03$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($845a60d357898a03$var$NodeType || ($845a60d357898a03$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $845a60d357898a03$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $845a60d357898a03$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($845a60d357898a03$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $845a60d357898a03$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $845a60d357898a03$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $845a60d357898a03$var$handleClick(replay.clickDetector, result, $845a60d357898a03$var$getClickTargetNode(handlerData.event));
        $845a60d357898a03$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $845a60d357898a03$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $845a60d357898a03$var$record.mirror.getId(target);
    const node = nodeId && $845a60d357898a03$var$record.mirror.getNode(nodeId);
    const meta = node && $845a60d357898a03$var$record.mirror.getMeta(node);
    const element = meta && $845a60d357898a03$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $845a60d357898a03$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $845a60d357898a03$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $845a60d357898a03$var$handleDom(handlerData) {
    const { target: target, message: message } = $845a60d357898a03$var$getDomTarget(handlerData);
    return $845a60d357898a03$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$845a60d357898a03$var$getBaseDomBreadcrumb(target, message)
    });
}
function $845a60d357898a03$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $845a60d357898a03$var$getClickTargetNode(handlerData.event) : $845a60d357898a03$var$getTargetNode(handlerData.event);
        message = (0, $167dd1da81c36183$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $845a60d357898a03$var$isElement(node) {
    return node.type === $845a60d357898a03$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $845a60d357898a03$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $845a60d357898a03$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $845a60d357898a03$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $845a60d357898a03$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $845a60d357898a03$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $167dd1da81c36183$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $845a60d357898a03$var$getBaseDomBreadcrumb(target, message);
    return $845a60d357898a03$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $845a60d357898a03$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $845a60d357898a03$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $845a60d357898a03$var$createResourceEntry,
    paint: $845a60d357898a03$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $845a60d357898a03$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $845a60d357898a03$var$createPerformanceEntries(entries) {
    return entries.map($845a60d357898a03$var$createPerformanceEntry).filter(Boolean);
}
function $845a60d357898a03$var$createPerformanceEntry(entry) {
    if (!$845a60d357898a03$var$ENTRY_TYPES[entry.entryType]) return null;
    return $845a60d357898a03$var$ENTRY_TYPES[entry.entryType](entry);
}
function $845a60d357898a03$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $561ba8b5b77a0042$export$baf075a948ffc0bf) || $845a60d357898a03$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $845a60d357898a03$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $845a60d357898a03$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $845a60d357898a03$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $845a60d357898a03$var$getAbsoluteTime(startTime),
        end: $845a60d357898a03$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $845a60d357898a03$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $845a60d357898a03$var$getAbsoluteTime(startTime),
        end: $845a60d357898a03$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $845a60d357898a03$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $845a60d357898a03$var$getAbsoluteTime(value);
    const data = {
        type: 'largest-contentful-paint',
        name: 'largest-contentful-paint',
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $845a60d357898a03$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $845a60d357898a03$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $2d276c9689c1344d$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $2d276c9689c1344d$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($845a60d357898a03$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $845a60d357898a03$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $845a60d357898a03$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $845a60d357898a03$var$e() {
    const e = new Blob([
        $845a60d357898a03$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $845a60d357898a03$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$845a60d357898a03$var$DEBUG_BUILD) return;
    (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $845a60d357898a03$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $845a60d357898a03$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$845a60d357898a03$var$DEBUG_BUILD) return;
    (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $845a60d357898a03$var$addLogBreadcrumb(message);
    }, 0);
}
function $845a60d357898a03$var$addLogBreadcrumb(message) {
    (0, $abd5e84d35afb05d$export$efda9a273d7a036d)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: 'info',
        message: message
    }, {
        level: 'info'
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $845a60d357898a03$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$845a60d357898a03$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $845a60d357898a03$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $845a60d357898a03$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $845a60d357898a03$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $845a60d357898a03$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $845a60d357898a03$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $845a60d357898a03$var$logInfo('[Replay] Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('[Replay]', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $845a60d357898a03$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $845a60d357898a03$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $845a60d357898a03$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $845a60d357898a03$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $845a60d357898a03$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $845a60d357898a03$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $845a60d357898a03$var$EventBufferArray();
        this._compression = new $845a60d357898a03$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $845a60d357898a03$var$logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Failed to add events when switching buffers.', error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $845a60d357898a03$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $845a60d357898a03$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $845a60d357898a03$var$logInfo('[Replay] Using simple buffer');
    return new $845a60d357898a03$var$EventBufferArray();
}
function $845a60d357898a03$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $845a60d357898a03$var$_getWorkerUrl();
        if (!workerUrl) return;
        $845a60d357898a03$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $845a60d357898a03$var$EventBufferProxy(worker);
    } catch (error) {
        $845a60d357898a03$var$logInfo('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $845a60d357898a03$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $845a60d357898a03$var$e();
    return '';
}
/** If sessionStorage is available. */ function $845a60d357898a03$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $845a60d357898a03$var$WINDOW && !!$845a60d357898a03$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $845a60d357898a03$var$clearSession(replay) {
    $845a60d357898a03$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $845a60d357898a03$var$deleteSession() {
    if (!$845a60d357898a03$var$hasSessionStorage()) return;
    try {
        $845a60d357898a03$var$WINDOW.sessionStorage.removeItem($845a60d357898a03$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $845a60d357898a03$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $845a60d357898a03$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $c6eb3b4caecfb929$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $845a60d357898a03$var$saveSession(session) {
    if (!$845a60d357898a03$var$hasSessionStorage()) return;
    try {
        $845a60d357898a03$var$WINDOW.sessionStorage.setItem($845a60d357898a03$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $845a60d357898a03$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $845a60d357898a03$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $845a60d357898a03$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $845a60d357898a03$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $845a60d357898a03$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $845a60d357898a03$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $845a60d357898a03$var$fetchSession(traceInternals) {
    if (!$845a60d357898a03$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $845a60d357898a03$var$WINDOW.sessionStorage.getItem($845a60d357898a03$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $845a60d357898a03$var$logInfoNextTick('[Replay] Loading existing session', traceInternals);
        return $845a60d357898a03$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $845a60d357898a03$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $845a60d357898a03$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $845a60d357898a03$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $845a60d357898a03$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $845a60d357898a03$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$845a60d357898a03$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $845a60d357898a03$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $845a60d357898a03$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $845a60d357898a03$var$logInfoNextTick('[Replay] Creating new session', traceInternals);
        return $845a60d357898a03$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$845a60d357898a03$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $845a60d357898a03$var$logInfoNextTick('[Replay] Session in sessionStorage is expired, creating new one...');
    return $845a60d357898a03$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $845a60d357898a03$var$isCustomEvent(event) {
    return event.type === $845a60d357898a03$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $845a60d357898a03$var$addEventSync(replay, event, isCheckout) {
    if (!$845a60d357898a03$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $845a60d357898a03$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $845a60d357898a03$var$addEvent(replay, event, isCheckout) {
    if (!$845a60d357898a03$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $845a60d357898a03$var$_addEvent(replay, event, isCheckout);
}
async function $845a60d357898a03$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === 'buffer') replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $845a60d357898a03$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $845a60d357898a03$var$EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/** Exported only for tests. */ function $845a60d357898a03$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $845a60d357898a03$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $845a60d357898a03$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $845a60d357898a03$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $845a60d357898a03$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $845a60d357898a03$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $845a60d357898a03$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $845a60d357898a03$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $845a60d357898a03$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $845a60d357898a03$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $845a60d357898a03$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$845a60d357898a03$var$isErrorEvent(event) && !$845a60d357898a03$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($845a60d357898a03$var$isTransactionEvent(event)) {
            $845a60d357898a03$var$handleTransactionEvent(replay, event);
            return;
        }
        $845a60d357898a03$var$handleErrorEvent(replay, event);
    };
}
function $845a60d357898a03$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $845a60d357898a03$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $845a60d357898a03$var$isBaseTransportSend() {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $845a60d357898a03$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$845a60d357898a03$var$isErrorEvent(event)) return;
        $845a60d357898a03$var$handleHydrationError(replay, event);
    };
}
function $845a60d357898a03$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $845a60d357898a03$var$createBreadcrumb({
            category: 'replay.hydrate-error'
        });
        $845a60d357898a03$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $845a60d357898a03$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $845a60d357898a03$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $845a60d357898a03$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $845a60d357898a03$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $845a60d357898a03$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $845a60d357898a03$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $845a60d357898a03$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $845a60d357898a03$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($845a60d357898a03$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$845a60d357898a03$var$isErrorEvent(event) && !$845a60d357898a03$var$isTransactionEvent(event) && !$845a60d357898a03$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($845a60d357898a03$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $845a60d357898a03$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($845a60d357898a03$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).log('[Replay] Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $845a60d357898a03$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $845a60d357898a03$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $845a60d357898a03$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $845a60d357898a03$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $845a60d357898a03$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $845a60d357898a03$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $845a60d357898a03$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $845a60d357898a03$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($845a60d357898a03$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $aa6295e4c669ad7c$export$d92e61f5600202af)(url, (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $845a60d357898a03$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($845a60d357898a03$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $845a60d357898a03$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $845a60d357898a03$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: 'resource.fetch',
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $845a60d357898a03$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $845a60d357898a03$var$handleFetch(handlerData);
        $845a60d357898a03$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $845a60d357898a03$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $911e5e354121e865$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: 'resource.xhr',
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $845a60d357898a03$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $845a60d357898a03$var$handleXhr(handlerData);
        $845a60d357898a03$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $845a60d357898a03$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $845a60d357898a03$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $845a60d357898a03$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $845a60d357898a03$var$getBodyString(body) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $845a60d357898a03$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/** Merge a warning into an existing network request/response. */ function $845a60d357898a03$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $845a60d357898a03$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $6a842238b70e8ef7$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $845a60d357898a03$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $845a60d357898a03$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $845a60d357898a03$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $845a60d357898a03$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $845a60d357898a03$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $845a60d357898a03$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $845a60d357898a03$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $845a60d357898a03$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $845a60d357898a03$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $845a60d357898a03$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $845a60d357898a03$var$urlMatches(url, urls) {
    const fullUrl = $845a60d357898a03$var$getFullUrl(url);
    return (0, $f54fd3bbbc09c038$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $845a60d357898a03$var$getFullUrl(url, baseURI = $845a60d357898a03$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($845a60d357898a03$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $845a60d357898a03$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $845a60d357898a03$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $845a60d357898a03$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $845a60d357898a03$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $845a60d357898a03$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $845a60d357898a03$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $845a60d357898a03$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $845a60d357898a03$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $845a60d357898a03$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $845a60d357898a03$var$urlMatches(url, options.networkDetailAllowUrls) && !$845a60d357898a03$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $845a60d357898a03$var$_getRequestInfo(options, hint.input, requestBodySize) : $845a60d357898a03$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $845a60d357898a03$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $845a60d357898a03$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $845a60d357898a03$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $845a60d357898a03$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $845a60d357898a03$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $845a60d357898a03$var$getBodyString(requestBody);
    const data = $845a60d357898a03$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $845a60d357898a03$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $845a60d357898a03$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $845a60d357898a03$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $845a60d357898a03$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $845a60d357898a03$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $845a60d357898a03$var$_parseFetchResponseBody(response);
    const result = $845a60d357898a03$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $845a60d357898a03$var$mergeWarning(result, warning);
    return result;
}
function $845a60d357898a03$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $845a60d357898a03$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $845a60d357898a03$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $845a60d357898a03$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $845a60d357898a03$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Failed to serialize response body', error);
        // fallback
        return $845a60d357898a03$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $845a60d357898a03$var$_parseFetchResponseBody(response) {
    const res = $845a60d357898a03$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $845a60d357898a03$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Failed to get text body from response', error);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $845a60d357898a03$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $845a60d357898a03$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $845a60d357898a03$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $845a60d357898a03$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $845a60d357898a03$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $845a60d357898a03$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $845a60d357898a03$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $845a60d357898a03$var$getAllowedHeaders(headers, allowedHeaders);
}
function $845a60d357898a03$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Failed to clone response body', error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $845a60d357898a03$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $845a60d357898a03$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $845a60d357898a03$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $845a60d357898a03$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $845a60d357898a03$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $845a60d357898a03$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $845a60d357898a03$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('[Replay] Failed to capture xhr breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $845a60d357898a03$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $845a60d357898a03$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader('content-length') ? $845a60d357898a03$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $845a60d357898a03$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $845a60d357898a03$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$845a60d357898a03$var$urlMatches(url, options.networkDetailAllowUrls) || $845a60d357898a03$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $845a60d357898a03$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $845a60d357898a03$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $911e5e354121e865$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $845a60d357898a03$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $845a60d357898a03$var$getAllowedHeaders($845a60d357898a03$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $845a60d357898a03$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $845a60d357898a03$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $845a60d357898a03$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $845a60d357898a03$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $845a60d357898a03$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $845a60d357898a03$var$mergeWarning(response, responseWarning) : response
    };
}
function $845a60d357898a03$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $845a60d357898a03$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $845a60d357898a03$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $845a60d357898a03$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $845a60d357898a03$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $845a60d357898a03$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $845a60d357898a03$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$845a60d357898a03$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $3ecb445c99cc1b01$export$f75d3c772c923df0)($845a60d357898a03$var$handleFetchSpanListener(replay));
            (0, $911e5e354121e865$export$26ace48dd54c9aea)($845a60d357898a03$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $845a60d357898a03$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($845a60d357898a03$var$_isXhrBreadcrumb(breadcrumb) && $845a60d357898a03$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $845a60d357898a03$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $845a60d357898a03$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($845a60d357898a03$var$_isFetchBreadcrumb(breadcrumb) && $845a60d357898a03$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $845a60d357898a03$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $845a60d357898a03$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('Error when enriching network breadcrumb');
    }
}
function $845a60d357898a03$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $845a60d357898a03$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $845a60d357898a03$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $845a60d357898a03$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $845a60d357898a03$var$_LAST_BREADCRUMB = null;
function $845a60d357898a03$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $845a60d357898a03$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $845a60d357898a03$var$handleScope(scope);
        if (!result) return;
        $845a60d357898a03$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $845a60d357898a03$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($845a60d357898a03$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $845a60d357898a03$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$845a60d357898a03$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        'fetch',
        'xhr',
        'sentry.event',
        'sentry.transaction'
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith('ui.')) return null;
    if (newBreadcrumb.category === 'console') return $845a60d357898a03$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $845a60d357898a03$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $845a60d357898a03$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $845a60d357898a03$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $845a60d357898a03$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $845a60d357898a03$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $1908c34a72f46e5e$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $845a60d357898a03$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $845a60d357898a03$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $845a60d357898a03$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $845a60d357898a03$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    scope.addScopeListener($845a60d357898a03$var$handleScopeListener(replay));
    (0, $536b5da25a720d6f$export$5aeffd3db2cf9df7)($845a60d357898a03$var$handleDomListener(replay));
    (0, $64bd59e2066d26bd$export$3f18c56c58114e75)($845a60d357898a03$var$handleHistorySpanListener(replay));
    $845a60d357898a03$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $845a60d357898a03$var$handleGlobalEventListener(replay, !$845a60d357898a03$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $39e6a3d3c61ae59d$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($845a60d357898a03$var$hasHooks(client)) {
        client.on('beforeSendEvent', $845a60d357898a03$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $845a60d357898a03$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('startTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on('finishTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on('beforeSendFeedback', (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $845a60d357898a03$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $845a60d357898a03$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($845a60d357898a03$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $845a60d357898a03$var$createMemoryEntry($845a60d357898a03$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $845a60d357898a03$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $845a60d357898a03$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $845a60d357898a03$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('[Replay] Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $845a60d357898a03$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$845a60d357898a03$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $845a60d357898a03$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $845a60d357898a03$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $845a60d357898a03$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $845a60d357898a03$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $845a60d357898a03$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $845a60d357898a03$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $845a60d357898a03$var$addEventSync(replay, $845a60d357898a03$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $845a60d357898a03$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $b7a488e859caf65f$export$f93f7f385160c44e)((0, $b7a488e859caf65f$export$92b6093782fe661b)(replayEvent, (0, $b7a488e859caf65f$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $845a60d357898a03$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $845a60d357898a03$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $dd0a854b4ac70026$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $2d9e797091ea0ff6$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $845a60d357898a03$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $845a60d357898a03$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    const scope = (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $845a60d357898a03$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $845a60d357898a03$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        $845a60d357898a03$var$logInfo('An event processor returned `null`, will not send event.');
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $845a60d357898a03$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($845a60d357898a03$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $845a60d357898a03$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $81e6cd8bc80dbb83$export$699aff705e0d49d4)({}, response);
    if ((0, $81e6cd8bc80dbb83$export$6c91fec22056810a)(rateLimits, 'replay')) throw new $845a60d357898a03$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $845a60d357898a03$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $845a60d357898a03$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $845a60d357898a03$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $845a60d357898a03$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $845a60d357898a03$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $845a60d357898a03$var$TransportStatusCodeError || err instanceof $845a60d357898a03$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $abd5e84d35afb05d$export$2f04de43fe27971a)('Replays', {
            _retryCount: retryConfig.count
        });
        if ($845a60d357898a03$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $abd5e84d35afb05d$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $845a60d357898a03$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$845a60d357898a03$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $845a60d357898a03$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $845a60d357898a03$var$THROTTLED = '__THROTTLED';
const $845a60d357898a03$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $845a60d357898a03$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $845a60d357898a03$var$SKIPPED : $845a60d357898a03$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $845a60d357898a03$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $845a60d357898a03$var$ReplayContainer.prototype.__init.call(this);
        $845a60d357898a03$var$ReplayContainer.prototype.__init2.call(this);
        $845a60d357898a03$var$ReplayContainer.prototype.__init3.call(this);
        $845a60d357898a03$var$ReplayContainer.prototype.__init4.call(this);
        $845a60d357898a03$var$ReplayContainer.prototype.__init5.call(this);
        $845a60d357898a03$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $845a60d357898a03$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $845a60d357898a03$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $845a60d357898a03$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $845a60d357898a03$var$throttle((event, isCheckout)=>$845a60d357898a03$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($845a60d357898a03$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $845a60d357898a03$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $845a60d357898a03$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $845a60d357898a03$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') throw new Error('Replay recording is already in progress');
        if (this._isEnabled && this.recordingMode === 'buffer') throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
        $845a60d357898a03$var$logInfoNextTick('[Replay] Starting replay in session mode', this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $845a60d357898a03$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error('Replay recording is already in progress');
        $845a60d357898a03$var$logInfoNextTick('[Replay] Starting replay in buffer mode', this._options._experiments.traceInternals);
        const session = $845a60d357898a03$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $845a60d357898a03$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' && {
                    checkoutEveryNms: $845a60d357898a03$var$BUFFER_CHECKOUT_TIME
                },
                emit: $845a60d357898a03$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $845a60d357898a03$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $845a60d357898a03$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $845a60d357898a03$var$logInfo('[Replay] Pausing replay', this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $845a60d357898a03$var$logInfo('[Replay] Resuming replay', this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $845a60d357898a03$var$logInfo('[Replay] Converting buffer to session', this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $845a60d357898a03$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$845a60d357898a03$var$WINDOW.location.pathname}${$845a60d357898a03$var$WINDOW.location.hash}${$845a60d357898a03$var$WINDOW.location.search}`;
        const url = `${$845a60d357898a03$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $845a60d357898a03$var$THROTTLED) {
            const breadcrumb = $845a60d357898a03$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$845a60d357898a03$var$addEventSync(this, {
                    type: $845a60d357898a03$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $abd5e84d35afb05d$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $92410d3f4bb849a0$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $fee337bd2c89db0b$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $92410d3f4bb849a0$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $845a60d357898a03$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('[Replay]', error);
        if ($845a60d357898a03$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $abd5e84d35afb05d$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $845a60d357898a03$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($845a60d357898a03$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $845a60d357898a03$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $845a60d357898a03$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $845a60d357898a03$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $845a60d357898a03$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $845a60d357898a03$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $845a60d357898a03$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $845a60d357898a03$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $845a60d357898a03$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $845a60d357898a03$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $845a60d357898a03$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($845a60d357898a03$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $845a60d357898a03$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $845a60d357898a03$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $845a60d357898a03$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $845a60d357898a03$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $845a60d357898a03$var$logInfo('[Replay] Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $845a60d357898a03$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $845a60d357898a03$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($845a60d357898a03$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('[Replay] No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $845a60d357898a03$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $845a60d357898a03$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent('send_error', 'replay');
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error('[Replay] Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $845a60d357898a03$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $845a60d357898a03$var$logInfo('[Replay] Flushing initial segment without checkout.', this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $845a60d357898a03$var$DEBUG_BUILD && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $845a60d357898a03$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $845a60d357898a03$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: 'mutationLimit',
                    forceFlush: this.recordingMode === 'session'
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $845a60d357898a03$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== 'undefined') {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === 'string') allSelectors.push(`.${deprecatedClassOption}`);
        (0, $bf3485ccdac24c3e$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.');
        });
    }
    return allSelectors.join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $845a60d357898a03$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $845a60d357898a03$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $845a60d357898a03$var$getOption(unmask, [
        '.sentry-unmask',
        '[data-sentry-unmask]'
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $845a60d357898a03$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $845a60d357898a03$var$getOption(unblock, [
            '.sentry-unblock',
            '[data-sentry-unblock]'
        ]),
        ignoreSelector: $845a60d357898a03$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $845a60d357898a03$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $845a60d357898a03$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $845a60d357898a03$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $845a60d357898a03$var$_initialized = false;
const $845a60d357898a03$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $845a60d357898a03$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $845a60d357898a03$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $845a60d357898a03$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $845a60d357898a03$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $845a60d357898a03$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $845a60d357898a03$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $845a60d357898a03$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $845a60d357898a03$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$845a60d357898a03$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $845a60d357898a03$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $845a60d357898a03$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $845a60d357898a03$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $845a60d357898a03$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $845a60d357898a03$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$845a60d357898a03$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $beaad4d9fa74c27c$export$4e09c449d6c407f7)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $845a60d357898a03$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $845a60d357898a03$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $beaad4d9fa74c27c$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $845a60d357898a03$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $845a60d357898a03$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$845a60d357898a03$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $845a60d357898a03$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $6a842238b70e8ef7$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $bf3485ccdac24c3e$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('SDK client is not available.');
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $bf3485ccdac24c3e$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (typeof opt.replaysSessionSampleRate === 'number') finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === 'number') finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $845a60d357898a03$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$845a60d357898a03$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $845a60d357898a03$export$81cc0d0f72285d1() {
    const client = (0, $abd5e84d35afb05d$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName('Replay');
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $845a60d357898a03$export$b28310b2f161456b = $845a60d357898a03$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $845a60d357898a03$export$d7706faf7ab354bf = $845a60d357898a03$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $845a60d357898a03$export$a35c789ed37ee0f7 extends $845a60d357898a03$export$6b59b88de1ff9cb7 {
}









let $72906f95e7a15795$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).Sentry && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).Sentry.Integrations) $72906f95e7a15795$var$windowIntegrations = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $72906f95e7a15795$export$99d02219d259eb94 = {
    ...$72906f95e7a15795$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $69395913dde91a43$export$99d02219d259eb94),
    ...$8ab6f26c6868a9b9$exports
};





var $8FL51 = parcelRequire("8FL51");

var $3QbnI = parcelRequire("3QbnI");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $693449810130c458$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $2c90c1fbe728dd1c$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $2c90c1fbe728dd1c$var$activeTransaction;
let $2c90c1fbe728dd1c$var$_useEffect;
let $2c90c1fbe728dd1c$var$_useLocation;
let $2c90c1fbe728dd1c$var$_useNavigationType;
let $2c90c1fbe728dd1c$var$_createRoutesFromChildren;
let $2c90c1fbe728dd1c$var$_matchRoutes;
let $2c90c1fbe728dd1c$var$_customStartTransaction;
let $2c90c1fbe728dd1c$var$_startTransactionOnLocationChange;
let $2c90c1fbe728dd1c$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $2c90c1fbe728dd1c$export$47113a480541ff59(options) {
    const integration = (0, $7e5446559061a90c$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $7e5446559061a90c$export$7d159749bd9969ad)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81) && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $7e5446559061a90c$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $fee337bd2c89db0b$export$d7a7d984b0791405)]: 'url',
                    [(0, $fee337bd2c89db0b$export$1a413bd9a88fdb09)]: 'pageload',
                    [(0, $fee337bd2c89db0b$export$cca8dd30f57f805e)]: 'auto.pageload.react.reactrouter_v6'
                }
            });
            $2c90c1fbe728dd1c$var$_useEffect = useEffect;
            $2c90c1fbe728dd1c$var$_useLocation = useLocation;
            $2c90c1fbe728dd1c$var$_useNavigationType = useNavigationType;
            $2c90c1fbe728dd1c$var$_matchRoutes = matchRoutes;
            $2c90c1fbe728dd1c$var$_createRoutesFromChildren = createRoutesFromChildren;
            $2c90c1fbe728dd1c$var$_stripBasename = stripBasename || false;
            $2c90c1fbe728dd1c$var$_customStartTransaction = startNavigationCallback;
            $2c90c1fbe728dd1c$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $2c90c1fbe728dd1c$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81) && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location && (0, $99f5a5ddfc0686db$export$56d8a8a25bd48b81).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $2c90c1fbe728dd1c$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $fee337bd2c89db0b$export$d7a7d984b0791405)]: 'url',
                [(0, $fee337bd2c89db0b$export$1a413bd9a88fdb09)]: 'pageload',
                [(0, $fee337bd2c89db0b$export$cca8dd30f57f805e)]: 'auto.pageload.react.reactrouter_v6'
            }
        });
        $2c90c1fbe728dd1c$var$_useEffect = useEffect;
        $2c90c1fbe728dd1c$var$_useLocation = useLocation;
        $2c90c1fbe728dd1c$var$_useNavigationType = useNavigationType;
        $2c90c1fbe728dd1c$var$_matchRoutes = matchRoutes;
        $2c90c1fbe728dd1c$var$_createRoutesFromChildren = createRoutesFromChildren;
        $2c90c1fbe728dd1c$var$_stripBasename = stripBasename || false;
        $2c90c1fbe728dd1c$var$_customStartTransaction = customStartTransaction;
        $2c90c1fbe728dd1c$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $2c90c1fbe728dd1c$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === '/') return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith('/') ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== '/') // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || '/';
}
function $2c90c1fbe728dd1c$var$getNormalizedName(routes, location, branches, basename = '') {
    if (!routes || routes.length === 0) return [
        $2c90c1fbe728dd1c$var$_stripBasename ? $2c90c1fbe728dd1c$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        'url'
    ];
    let pathBuilder = '';
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $2c90c1fbe728dd1c$var$_stripBasename ? $2c90c1fbe728dd1c$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                'route'
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $8fa0e4f9edeffeaf$export$69dd85280a8d374c)(pathBuilder) !== (0, $8fa0e4f9edeffeaf$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== '/*') return [
                        ($2c90c1fbe728dd1c$var$_stripBasename ? '' : basename) + newPath,
                        'route'
                    ];
                    return [
                        ($2c90c1fbe728dd1c$var$_stripBasename ? '' : basename) + pathBuilder,
                        'route'
                    ];
                }
            }
        }
    }
    return [
        $2c90c1fbe728dd1c$var$_stripBasename ? $2c90c1fbe728dd1c$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        'url'
    ];
}
function $2c90c1fbe728dd1c$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $2c90c1fbe728dd1c$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $2c90c1fbe728dd1c$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $fee337bd2c89db0b$export$d7a7d984b0791405), source);
    }
}
function $2c90c1fbe728dd1c$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $2c90c1fbe728dd1c$var$_matchRoutes(routes, location, basename);
    if ($2c90c1fbe728dd1c$var$_startTransactionOnLocationChange && (navigationType === 'PUSH' || navigationType === 'POP') && branches) {
        if ($2c90c1fbe728dd1c$var$activeTransaction) $2c90c1fbe728dd1c$var$activeTransaction.end();
        const [name, source] = $2c90c1fbe728dd1c$var$getNormalizedName(routes, location, branches, basename);
        $2c90c1fbe728dd1c$var$activeTransaction = $2c90c1fbe728dd1c$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $fee337bd2c89db0b$export$d7a7d984b0791405)]: source,
                [(0, $fee337bd2c89db0b$export$1a413bd9a88fdb09)]: 'navigation',
                [(0, $fee337bd2c89db0b$export$cca8dd30f57f805e)]: 'auto.navigation.react.reactrouter_v6'
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2c90c1fbe728dd1c$export$c6111e8561a02a8b(Routes) {
    if (!$2c90c1fbe728dd1c$var$_useEffect || !$2c90c1fbe728dd1c$var$_useLocation || !$2c90c1fbe728dd1c$var$_useNavigationType || !$2c90c1fbe728dd1c$var$_createRoutesFromChildren || !$2c90c1fbe728dd1c$var$_matchRoutes || !$2c90c1fbe728dd1c$var$_customStartTransaction) {
        (0, $693449810130c458$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$2c90c1fbe728dd1c$var$_useEffect}. useLocation: ${$2c90c1fbe728dd1c$var$_useLocation}. useNavigationType: ${$2c90c1fbe728dd1c$var$_useNavigationType}.
      createRoutesFromChildren: ${$2c90c1fbe728dd1c$var$_createRoutesFromChildren}. matchRoutes: ${$2c90c1fbe728dd1c$var$_matchRoutes}. customStartTransaction: ${$2c90c1fbe728dd1c$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $2c90c1fbe728dd1c$var$_useLocation();
        const navigationType = $2c90c1fbe728dd1c$var$_useNavigationType();
        $2c90c1fbe728dd1c$var$_useEffect(()=>{
            const routes = $2c90c1fbe728dd1c$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $2c90c1fbe728dd1c$var$updatePageloadTransaction($2c90c1fbe728dd1c$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $2c90c1fbe728dd1c$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $3QbnI.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $2c90c1fbe728dd1c$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $2c90c1fbe728dd1c$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$2c90c1fbe728dd1c$var$_useEffect || !$2c90c1fbe728dd1c$var$_useLocation || !$2c90c1fbe728dd1c$var$_useNavigationType || !$2c90c1fbe728dd1c$var$_matchRoutes || !$2c90c1fbe728dd1c$var$_customStartTransaction) {
        (0, $693449810130c458$export$16a28057038b10ef) && (0, $bf3485ccdac24c3e$export$af88d00dbe7f521).warn('reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.');
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $2c90c1fbe728dd1c$var$_useLocation();
        const navigationType = $2c90c1fbe728dd1c$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === 'string' || locationArg && locationArg.pathname ? locationArg : location;
        $2c90c1fbe728dd1c$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === 'string' ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $2c90c1fbe728dd1c$var$updatePageloadTransaction($2c90c1fbe728dd1c$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $2c90c1fbe728dd1c$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $3QbnI.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $2c90c1fbe728dd1c$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $2c90c1fbe728dd1c$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $2c90c1fbe728dd1c$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === 'POP' && activeRootSpan) $2c90c1fbe728dd1c$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($2c90c1fbe728dd1c$var$_startTransactionOnLocationChange && (state.historyAction === 'PUSH' || state.historyAction === 'POP')) $2c90c1fbe728dd1c$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $2c90c1fbe728dd1c$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($2c90c1fbe728dd1c$var$activeTransaction) return $2c90c1fbe728dd1c$var$activeTransaction;
    const span = (0, $735ba79a0f62e676$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $ea45a8d144ab3501$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $92410d3f4bb849a0$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}



var $3QbnI = parcelRequire("3QbnI");


var $d8c7a2882f726c0c$export$2e2bcd8739ae039 = ()=>{
    $77125ddf85bcd489$export$2cd8252107eb640b({
        dsn: (0, $87c980b245bbb7d9$export$6faa4a850bc4d0ce),
        environment: (0, $87c980b245bbb7d9$export$be46596bc6608f3b),
        debug: (0, $87c980b245bbb7d9$export$e987ec915f285263),
        release: (0, $87c980b245bbb7d9$export$d2c893bfac1da9a1),
        integrations: [
            // See docs for support of different versions of variation of react router
            // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
            $2c90c1fbe728dd1c$export$47113a480541ff59({
                useEffect: (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useEffect,
                useLocation: $720b4b44089c40ed$export$45d76561a5302f2b,
                useNavigationType: $720b4b44089c40ed$export$1b3f31771c5d07c,
                createRoutesFromChildren: $720b4b44089c40ed$export$16da398f5434bdec,
                matchRoutes: $98b25df047b2379b$export$2708184779ceb39d
            }),
            $845a60d357898a03$export$2832a2ae028f5e28({
                // Default values, but makes it explicit for privacy reasons
                maskAllText: true,
                maskAllInputs: true,
                blockAllMedia: true
            })
        ],
        tracesSampleRate: (0, $87c980b245bbb7d9$export$934e799b0e87def5),
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: (0, $87c980b245bbb7d9$export$6229fa3b56a23727),
        // Setting these will enable the replay feature.
        // By default, all user input and text is masked with * and all media is blocked for privacy reasons
        replaysSessionSampleRate: (0, $87c980b245bbb7d9$export$d991ba28bdd15482),
        replaysOnErrorSampleRate: (0, $87c980b245bbb7d9$export$6d698ff2c1f4a0ca)
    });
};


if (0, $87c980b245bbb7d9$export$6faa4a850bc4d0ce) (0, $d8c7a2882f726c0c$export$2e2bcd8739ae039)();
(0, $b44a20a3fc7684be$export$882461b6382ed46c)(document.getElementById('root')).render(/*#__PURE__*/ (0, $e1vzu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).StrictMode, {
    children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $403c1255315ab8b6$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $e1vzu.jsx)((0, $cc9d09a6f2edbadb$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.e553582d.js.map
